/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _reactDom = __webpack_require__(159);var _reactDom2 = _interopRequireDefault(_reactDom);var _redux = __webpack_require__(160);var _reactRedux = __webpack_require__(169);var _Reducers = __webpack_require__(178);var _Reducers2 = _interopRequireDefault(_Reducers);var _LocalStore = __webpack_require__(185);var _LocalStore2 = _interopRequireDefault(_LocalStore);var _LocalStoreReduxInterface = __webpack_require__(186);var _LocalStoreReduxInterface2 = _interopRequireDefault(_LocalStoreReduxInterface);var _App = __webpack_require__(188);var _App2 = _interopRequireDefault(_App);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}__webpack_require__(265);
	
	
	
	
	
	
	
	
	
	window.LocalStore = _LocalStore2.default;
	
	
	
	var store = (0, _redux.createStore)(_Reducers2.default);
	(0, _LocalStoreReduxInterface2.default)(store);
	
	
	var component = _react2.default.createElement(_reactRedux.Provider, { store: store }, 
	_react2.default.createElement(_App2.default, null));
	
	
	_reactDom2.default.render(component, document.getElementById('app'));

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(3);


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(4);
	var ReactDOMServer = __webpack_require__(149);
	var ReactIsomorphic = __webpack_require__(153);
	
	var assign = __webpack_require__(40);
	var deprecated = __webpack_require__(158);
	
	// `version` will be added here by ReactIsomorphic.
	var React = {};
	
	assign(React, ReactIsomorphic);
	
	assign(React, {
	  // ReactDOM
	  findDOMNode: deprecated('findDOMNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.findDOMNode),
	  render: deprecated('render', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.render),
	  unmountComponentAtNode: deprecated('unmountComponentAtNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.unmountComponentAtNode),
	
	  // ReactDOMServer
	  renderToString: deprecated('renderToString', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToString),
	  renderToStaticMarkup: deprecated('renderToStaticMarkup', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToStaticMarkup)
	});
	
	React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOM;
	React.__SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOMServer;
	
	module.exports = React;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(6);
	var ReactDOMTextComponent = __webpack_require__(7);
	var ReactDefaultInjection = __webpack_require__(72);
	var ReactInstanceHandles = __webpack_require__(46);
	var ReactMount = __webpack_require__(29);
	var ReactPerf = __webpack_require__(19);
	var ReactReconciler = __webpack_require__(51);
	var ReactUpdates = __webpack_require__(55);
	var ReactVersion = __webpack_require__(147);
	
	var findDOMNode = __webpack_require__(92);
	var renderSubtreeIntoContainer = __webpack_require__(148);
	var warning = __webpack_require__(26);
	
	ReactDefaultInjection.inject();
	
	var render = ReactPerf.measure('React', 'render', ReactMount.render);
	
	var React = {
	  findDOMNode: findDOMNode,
	  render: render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    CurrentOwner: ReactCurrentOwner,
	    InstanceHandles: ReactInstanceHandles,
	    Mount: ReactMount,
	    Reconciler: ReactReconciler,
	    TextComponent: ReactDOMTextComponent
	  });
	}
	
	if (process.env.NODE_ENV !== 'production') {
	  var ExecutionEnvironment = __webpack_require__(10);
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        console.debug('Download the React DevTools for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : undefined;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim,
	
	    // shams
	    Object.create, Object.freeze];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        console.error('One or more ES5 shim/shams expected by React are not available: ' + 'https://fb.me/react-warning-polyfills');
	        break;
	      }
	    }
	  }
	}
	
	module.exports = React;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 5 */
/***/ function(module, exports) {

	// shim for using process in browser
	
	var process = module.exports = {};
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = setTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    clearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        setTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 6 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(8);
	var DOMPropertyOperations = __webpack_require__(23);
	var ReactComponentBrowserEnvironment = __webpack_require__(27);
	var ReactMount = __webpack_require__(29);
	
	var assign = __webpack_require__(40);
	var escapeTextContentForBrowser = __webpack_require__(22);
	var setTextContent = __webpack_require__(21);
	var validateDOMNesting = __webpack_require__(71);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings in elements so that they can undergo
	 * the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (props) {
	  // This constructor and its argument is currently used by mocks.
	};
	
	assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * @param {ReactText} text
	   * @internal
	   */
	  construct: function (text) {
	    // TODO: This is really a ReactText (ReactNode), not a ReactElement
	    this._currentElement = text;
	    this._stringText = '' + text;
	
	    // Properties
	    this._rootNodeID = null;
	    this._mountIndex = 0;
	  },
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    if (process.env.NODE_ENV !== 'production') {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting('span', null, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    this._rootNodeID = rootID;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement('span');
	      DOMPropertyOperations.setAttributeForID(el, rootID);
	      // Populate node cache
	      ReactMount.getID(el);
	      setTextContent(el, this._stringText);
	      return el;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this in a `span` for the reasons stated above, but
	        // since this is a situation where React won't take over (static pages),
	        // we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' + escapedText + '</span>';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var node = ReactMount.getNode(this._rootNodeID);
	        DOMChildrenOperations.updateTextContent(node, nextStringText);
	      }
	    }
	  },
	
	  unmountComponent: function () {
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var Danger = __webpack_require__(9);
	var ReactMultiChildUpdateTypes = __webpack_require__(17);
	var ReactPerf = __webpack_require__(19);
	
	var setInnerHTML = __webpack_require__(20);
	var setTextContent = __webpack_require__(21);
	var invariant = __webpack_require__(14);
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	function insertChildAt(parentNode, childNode, index) {
	  // By exploiting arrays returning `undefined` for an undefined index, we can
	  // rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. However, using `undefined` is not allowed by all
	  // browsers so we must replace it with `null`.
	
	  // fix render order error in safari
	  // IE8 will throw error when index out of list size.
	  var beforeChild = index >= parentNode.childNodes.length ? null : parentNode.childNodes.item(index);
	
	  parentNode.insertBefore(childNode, beforeChild);
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,
	
	  updateTextContent: setTextContent,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markupList List of markup strings.
	   * @internal
	   */
	  processUpdates: function (updates, markupList) {
	    var update;
	    // Mapping from parent IDs to initial child orderings.
	    var initialChildren = null;
	    // List of children that will be moved or removed.
	    var updatedChildren = null;
	
	    for (var i = 0; i < updates.length; i++) {
	      update = updates[i];
	      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING || update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
	        var updatedIndex = update.fromIndex;
	        var updatedChild = update.parentNode.childNodes[updatedIndex];
	        var parentID = update.parentID;
	
	        !updatedChild ? process.env.NODE_ENV !== 'production' ? invariant(false, 'processUpdates(): Unable to find child %s of element. This ' + 'probably means the DOM was unexpectedly mutated (e.g., by the ' + 'browser), usually due to forgetting a <tbody> when using tables, ' + 'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' + 'in an <svg> parent. Try inspecting the child nodes of the element ' + 'with React ID `%s`.', updatedIndex, parentID) : invariant(false) : undefined;
	
	        initialChildren = initialChildren || {};
	        initialChildren[parentID] = initialChildren[parentID] || [];
	        initialChildren[parentID][updatedIndex] = updatedChild;
	
	        updatedChildren = updatedChildren || [];
	        updatedChildren.push(updatedChild);
	      }
	    }
	
	    var renderedMarkup;
	    // markupList is either a list of markup or just a list of elements
	    if (markupList.length && typeof markupList[0] === 'string') {
	      renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);
	    } else {
	      renderedMarkup = markupList;
	    }
	
	    // Remove updated children first so that `toIndex` is consistent.
	    if (updatedChildren) {
	      for (var j = 0; j < updatedChildren.length; j++) {
	        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
	      }
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertChildAt(update.parentNode, renderedMarkup[update.markupIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          insertChildAt(update.parentNode, initialChildren[update.parentID][update.fromIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          // Already removed by the for-loop above.
	          break;
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMChildrenOperations, 'DOMChildrenOperations', {
	  updateTextContent: 'updateTextContent'
	});
	
	module.exports = DOMChildrenOperations;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	var createNodesFromMarkup = __webpack_require__(11);
	var emptyFunction = __webpack_require__(16);
	var getMarkupWrap = __webpack_require__(15);
	var invariant = __webpack_require__(14);
	
	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';
	
	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}
	
	var Danger = {
	
	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function (markupList) {
	    !ExecutionEnvironment.canUseDOM ? process.env.NODE_ENV !== 'production' ? invariant(false, 'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' + 'thread. Make sure `window` and `document` are available globally ' + 'before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString for server rendering.') : invariant(false) : undefined;
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      !markupList[i] ? process.env.NODE_ENV !== 'production' ? invariant(false, 'dangerouslyRenderMarkup(...): Missing markup.') : invariant(false) : undefined;
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];
	
	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];
	
	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(OPEN_TAG_NAME_EXP,
	          // This index will be parsed back out below.
	          '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" ');
	        }
	      }
	
	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(markupListByNodeName.join(''), emptyFunction // Do nothing special with <script> tags.
	      );
	
	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute && renderNode.hasAttribute(RESULT_INDEX_ATTR)) {
	
	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);
	
	          !!resultList.hasOwnProperty(resultIndex) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Danger: Assigning to an already-occupied result index.') : invariant(false) : undefined;
	
	          resultList[resultIndex] = renderNode;
	
	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;
	        } else if (process.env.NODE_ENV !== 'production') {
	          console.error('Danger: Discarding unexpected node:', renderNode);
	        }
	      }
	    }
	
	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    !(resultListAssignmentCount === resultList.length) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Danger: Did not assign to every index of resultList.') : invariant(false) : undefined;
	
	    !(resultList.length === markupList.length) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Danger: Expected markup to render %s nodes, but rendered %s.', markupList.length, resultList.length) : invariant(false) : undefined;
	
	    return resultList;
	  },
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ? process.env.NODE_ENV !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' + 'worker thread. Make sure `window` and `document` are available ' + 'globally before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	    !markup ? process.env.NODE_ENV !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(false) : undefined;
	    !(oldChild.tagName.toLowerCase() !== 'html') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' + '<html> node. This is because browser quirks make this unreliable ' + 'and/or slow. If you want to render to the root you must use ' + 'server rendering. See ReactDOMServer.renderToString().') : invariant(false) : undefined;
	
	    var newChild;
	    if (typeof markup === 'string') {
	      newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	    } else {
	      newChild = markup;
	    }
	    oldChild.parentNode.replaceChild(newChild, oldChild);
	  }
	
	};
	
	module.exports = Danger;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 10 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createNodesFromMarkup
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	var createArrayFromMixed = __webpack_require__(12);
	var getMarkupWrap = __webpack_require__(15);
	var invariant = __webpack_require__(14);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ? process.env.NODE_ENV !== 'production' ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : undefined;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ? process.env.NODE_ENV !== 'production' ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : undefined;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = createArrayFromMixed(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createArrayFromMixed
	 * @typechecks
	 */
	
	'use strict';
	
	var toArray = __webpack_require__(13);
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return(
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule toArray
	 * @typechecks
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
	  // old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : undefined;
	
	  !(typeof length === 'number') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : undefined;
	
	  !(length === 0 || length - 1 in obj) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : undefined;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	module.exports = toArray;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function (condition, format, a, b, c, d, e, f) {
	  if (process.env.NODE_ENV !== 'production') {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getMarkupWrap
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : undefined;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 16 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyFunction
	 */
	
	"use strict";
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	function emptyFunction() {}
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(18);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyMirror
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function (obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : undefined;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,
	
	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,
	
	  /**
	   * @param {object} object
	   * @param {string} objectName
	   * @param {object<string>} methodNames
	   */
	  measureMethods: function (object, objectName, methodNames) {
	    if (process.env.NODE_ENV !== 'production') {
	      for (var key in methodNames) {
	        if (!methodNames.hasOwnProperty(key)) {
	          continue;
	        }
	        object[key] = ReactPerf.measure(objectName, methodNames[key], object[key]);
	      }
	    }
	  },
	
	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function (objName, fnName, func) {
	    if (process.env.NODE_ENV !== 'production') {
	      var measuredFunc = null;
	      var wrapper = function () {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	      wrapper.displayName = objName + '_' + fnName;
	      return wrapper;
	    }
	    return func;
	  },
	
	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function (measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};
	
	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}
	
	module.exports = ReactPerf;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = function (node, html) {
	  node.innerHTML = html;
	};
	
	// Win8 apps: Allow all html to be inserted
	if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	  setInnerHTML = function (node, html) {
	    MSApp.execUnsafeLocalFunction(function () {
	      node.innerHTML = html;
	    });
	  };
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	var escapeTextContentForBrowser = __webpack_require__(22);
	var setInnerHTML = __webpack_require__(20);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 22 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(24);
	var ReactPerf = __webpack_require__(19);
	
	var quoteAttributeValueForBrowser = __webpack_require__(25);
	var warning = __webpack_require__(26);
	
	// Simplified subset
	var VALID_ATTRIBUTE_NAME_REGEX = /^[a-zA-Z_][\w\.\-]*$/;
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	  process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid attribute name: `%s`', attributeName) : undefined;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	if (process.env.NODE_ENV !== 'production') {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};
	
	  var warnUnknownProperty = function (name) {
	    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }
	
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    process.env.NODE_ENV !== 'production' ? warning(standardName == null, 'Unknown DOM property %s. Did you mean %s?', name, standardName) : undefined;
	  };
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    } else if (process.env.NODE_ENV !== 'production') {
	      warnUnknownProperty(name);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (propertyInfo.mustUseAttribute) {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      } else {
	        var propName = propertyInfo.propertyName;
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== '' + value) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	    } else if (process.env.NODE_ENV !== 'production') {
	      warnUnknownProperty(name);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseAttribute) {
	        node.removeAttribute(propertyInfo.attributeName);
	      } else {
	        var propName = propertyInfo.propertyName;
	        var defaultValue = DOMProperty.getDefaultValueForProperty(node.nodeName, propName);
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== defaultValue) {
	          node[propName] = defaultValue;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    } else if (process.env.NODE_ENV !== 'production') {
	      warnUnknownProperty(name);
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMPropertyOperations, 'DOMPropertyOperations', {
	  setValueForProperty: 'setValueForProperty',
	  setValueForAttribute: 'setValueForAttribute',
	  deleteValueForProperty: 'deleteValueForProperty'
	});
	
	module.exports = DOMPropertyOperations;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_ATTRIBUTE: 0x1,
	  MUST_USE_PROPERTY: 0x2,
	  HAS_SIDE_EFFECTS: 0x4,
	  HAS_BOOLEAN_VALUE: 0x8,
	  HAS_NUMERIC_VALUE: 0x10,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' + '\'%s\' which has already been injected. You may be accidentally ' + 'injecting the same DOM property config twice, or you may be ' + 'injecting two configs that have conflicting property names.', propName) : invariant(false) : undefined;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseAttribute: checkMask(propConfig, Injection.MUST_USE_ATTRIBUTE),
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasSideEffects: checkMask(propConfig, Injection.HAS_SIDE_EFFECTS),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	
	      !(!propertyInfo.mustUseAttribute || !propertyInfo.mustUseProperty) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'DOMProperty: Cannot require using both attribute and property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.mustUseProperty || !propertyInfo.hasSideEffects) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'DOMProperty: Properties that have side effects must use property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or ' + 'numeric value, but not a combination: %s', propName) : invariant(false) : undefined;
	
	      if (process.env.NODE_ENV !== 'production') {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (process.env.NODE_ENV !== 'production') {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	var defaultValueCache = {};
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseAttribute:
	   *   Whether the property must be accessed and mutated using `*Attribute()`.
	   *   (This includes anything that fails `<propName> in <element>`.)
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasSideEffects:
	   *   Whether or not setting a value causes side effects such as triggering
	   *   resources to be loaded or text selection changes. If true, we read from
	   *   the DOM before updating to ensure that the value is only set if it has
	   *   changed.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName: process.env.NODE_ENV !== 'production' ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  /**
	   * Returns the default property value for a DOM property (i.e., not an
	   * attribute). Most default values are '' or false, but not all. Worse yet,
	   * some (in particular, `type`) vary depending on the type of element.
	   *
	   * TODO: Is it better to grab all the possible properties when creating an
	   * element to avoid having to create the same element twice?
	   */
	  getDefaultValueForProperty: function (nodeName, prop) {
	    var nodeDefaults = defaultValueCache[nodeName];
	    var testElement;
	    if (!nodeDefaults) {
	      defaultValueCache[nodeName] = nodeDefaults = {};
	    }
	    if (!(prop in nodeDefaults)) {
	      testElement = document.createElement(nodeName);
	      nodeDefaults[prop] = testElement[prop];
	    }
	    return nodeDefaults[prop];
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(22);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(16);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (process.env.NODE_ENV !== 'production') {
	  warning = function (condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(28);
	var ReactMount = __webpack_require__(29);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkupByID: ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {
	    ReactMount.purgeID(rootNodeID);
	  }
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(8);
	var DOMPropertyOperations = __webpack_require__(23);
	var ReactMount = __webpack_require__(29);
	var ReactPerf = __webpack_require__(19);
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Errors for properties that should not be updated with `updatePropertyByID()`.
	 *
	 * @type {object}
	 * @private
	 */
	var INVALID_PROPERTY_ERRORS = {
	  dangerouslySetInnerHTML: '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
	  style: '`style` must be set using `updateStylesByID()`.'
	};
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a DOM node with new property values. This should only be used to
	   * update DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A valid property name, see `DOMProperty`.
	   * @param {*} value New value of the property.
	   * @internal
	   */
	  updatePropertyByID: function (id, name, value) {
	    var node = ReactMount.getNode(id);
	    !!INVALID_PROPERTY_ERRORS.hasOwnProperty(name) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'updatePropertyByID(...): %s', INVALID_PROPERTY_ERRORS[name]) : invariant(false) : undefined;
	
	    // If we're updating to null or undefined, we should remove the property
	    // from the DOM node instead of inadvertantly setting to a string. This
	    // brings us in line with the same behavior we have on initial render.
	    if (value != null) {
	      DOMPropertyOperations.setValueForProperty(node, name, value);
	    } else {
	      DOMPropertyOperations.deleteValueForProperty(node, name);
	    }
	  },
	
	  /**
	   * Replaces a DOM node that exists in the document with markup.
	   *
	   * @param {string} id ID of child to be replaced.
	   * @param {string} markup Dangerous markup to inject in place of child.
	   * @internal
	   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
	   */
	  dangerouslyReplaceNodeWithMarkupByID: function (id, markup) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
	  },
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markup List of markup strings.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (updates, markup) {
	    for (var i = 0; i < updates.length; i++) {
	      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
	    }
	    DOMChildrenOperations.processUpdates(updates, markup);
	  }
	};
	
	ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
	  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
	  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
	});
	
	module.exports = ReactDOMIDOperations;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(24);
	var ReactBrowserEventEmitter = __webpack_require__(30);
	var ReactCurrentOwner = __webpack_require__(6);
	var ReactDOMFeatureFlags = __webpack_require__(42);
	var ReactElement = __webpack_require__(43);
	var ReactEmptyComponentRegistry = __webpack_require__(45);
	var ReactInstanceHandles = __webpack_require__(46);
	var ReactInstanceMap = __webpack_require__(48);
	var ReactMarkupChecksum = __webpack_require__(49);
	var ReactPerf = __webpack_require__(19);
	var ReactReconciler = __webpack_require__(51);
	var ReactUpdateQueue = __webpack_require__(54);
	var ReactUpdates = __webpack_require__(55);
	
	var assign = __webpack_require__(40);
	var emptyObject = __webpack_require__(59);
	var containsNode = __webpack_require__(60);
	var instantiateReactComponent = __webpack_require__(63);
	var invariant = __webpack_require__(14);
	var setInnerHTML = __webpack_require__(20);
	var shouldUpdateReactComponent = __webpack_require__(68);
	var validateDOMNesting = __webpack_require__(71);
	var warning = __webpack_require__(26);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var nodeCache = {};
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var ownerDocumentContextKey = '__ReactMount_ownerDocument$' + Math.random().toString(36).slice(2);
	
	/** Mapping from reactRootID to React component instance. */
	var instancesByReactRootID = {};
	
	/** Mapping from reactRootID to `container` nodes. */
	var containersByReactRootID = {};
	
	if (process.env.NODE_ENV !== 'production') {
	  /** __DEV__-only mapping from reactRootID to root elements. */
	  var rootElementsByReactRootID = {};
	}
	
	// Used to store breadth-first search state in findComponentRoot.
	var findComponentRootReusableArray = [];
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	/**
	 * @param {DOMElement} container DOM element that may contain a React component.
	 * @return {?string} A "reactRoot" ID, if a React component is rendered.
	 */
	function getReactRootID(container) {
	  var rootElement = getReactRootElementInContainer(container);
	  return rootElement && ReactMount.getID(rootElement);
	}
	
	/**
	 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
	 * element can return its control whose name or ID equals ATTR_NAME. All
	 * DOM nodes support `getAttributeNode` but this can also get called on
	 * other objects so just return '' if we're given something other than a
	 * DOM node (such as window).
	 *
	 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
	 * @return {string} ID of the supplied `domNode`.
	 */
	function getID(node) {
	  var id = internalGetID(node);
	  if (id) {
	    if (nodeCache.hasOwnProperty(id)) {
	      var cached = nodeCache[id];
	      if (cached !== node) {
	        !!isValid(cached, id) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactMount: Two valid but unequal nodes with the same `%s`: %s', ATTR_NAME, id) : invariant(false) : undefined;
	
	        nodeCache[id] = node;
	      }
	    } else {
	      nodeCache[id] = node;
	    }
	  }
	
	  return id;
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Sets the React-specific ID of the given node.
	 *
	 * @param {DOMElement} node The DOM node whose ID will be set.
	 * @param {string} id The value of the ID attribute.
	 */
	function setID(node, id) {
	  var oldID = internalGetID(node);
	  if (oldID !== id) {
	    delete nodeCache[oldID];
	  }
	  node.setAttribute(ATTR_NAME, id);
	  nodeCache[id] = node;
	}
	
	/**
	 * Finds the node with the supplied React-generated DOM ID.
	 *
	 * @param {string} id A React-generated DOM ID.
	 * @return {DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNode(id) {
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * Finds the node with the supplied public React instance.
	 *
	 * @param {*} instance A public React instance.
	 * @return {?DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNodeFromInstance(instance) {
	  var id = ReactInstanceMap.get(instance)._rootNodeID;
	  if (ReactEmptyComponentRegistry.isNullComponentID(id)) {
	    return null;
	  }
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * A node is "valid" if it is contained by a currently mounted container.
	 *
	 * This means that the node does not have to be contained by a document in
	 * order to be considered valid.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @param {string} id The expected ID of the node.
	 * @return {boolean} Whether the node is contained by a mounted container.
	 */
	function isValid(node, id) {
	  if (node) {
	    !(internalGetID(node) === id) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactMount: Unexpected modification of `%s`', ATTR_NAME) : invariant(false) : undefined;
	
	    var container = ReactMount.findReactContainerForID(id);
	    if (container && containsNode(container, node)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Causes the cache to forget about one React-specific ID.
	 *
	 * @param {string} id The ID to forget.
	 */
	function purgeID(id) {
	  delete nodeCache[id];
	}
	
	var deepestNodeSoFar = null;
	function findDeepestCachedAncestorImpl(ancestorID) {
	  var ancestor = nodeCache[ancestorID];
	  if (ancestor && isValid(ancestor, ancestorID)) {
	    deepestNodeSoFar = ancestor;
	  } else {
	    // This node isn't populated in the cache, so presumably none of its
	    // descendants are. Break out of the loop.
	    return false;
	  }
	}
	
	/**
	 * Return the deepest cached node whose ID is a prefix of `targetID`.
	 */
	function findDeepestCachedAncestor(targetID) {
	  deepestNodeSoFar = null;
	  ReactInstanceHandles.traverseAncestors(targetID, findDeepestCachedAncestorImpl);
	
	  var foundNode = deepestNodeSoFar;
	  deepestNodeSoFar = null;
	  return foundNode;
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(componentInstance, rootID, container, transaction, shouldReuseMarkup, context) {
	  if (ReactDOMFeatureFlags.useCreateElement) {
	    context = assign({}, context);
	    if (container.nodeType === DOC_NODE_TYPE) {
	      context[ownerDocumentContextKey] = container;
	    } else {
	      context[ownerDocumentContextKey] = container.ownerDocument;
	    }
	  }
	  if (process.env.NODE_ENV !== 'production') {
	    if (context === emptyObject) {
	      context = {};
	    }
	    var tag = container.nodeName.toLowerCase();
	    context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(null, tag, null);
	  }
	  var markup = ReactReconciler.mountComponent(componentInstance, rootID, transaction, context);
	  componentInstance._renderedComponent._topLevelWrapper = componentInstance;
	  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, rootID, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* forceHTML */shouldReuseMarkup);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, rootID, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container) {
	  ReactReconciler.unmountComponent(instance);
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(node) {
	  var reactRootID = getReactRootID(node);
	  return reactRootID ? reactRootID !== ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID) : false;
	}
	
	/**
	 * Returns the first (deepest) ancestor of a node which is rendered by this copy
	 * of React.
	 */
	function findFirstReactDOMImpl(node) {
	  // This node might be from another React instance, so we make sure not to
	  // examine the node cache here
	  for (; node && node.parentNode !== node; node = node.parentNode) {
	    if (node.nodeType !== 1) {
	      // Not a DOMElement, therefore not a React component
	      continue;
	    }
	    var nodeID = internalGetID(node);
	    if (!nodeID) {
	      continue;
	    }
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	
	    // If containersByReactRootID contains the container we find by crawling up
	    // the tree, we know that this instance of React rendered the node.
	    // nb. isValid's strategy (with containsNode) does not work because render
	    // trees may be nested and we don't want a false positive in that case.
	    var current = node;
	    var lastID;
	    do {
	      lastID = internalGetID(current);
	      current = current.parentNode;
	      if (current == null) {
	        // The passed-in node has been detached from the container it was
	        // originally rendered into.
	        return null;
	      }
	    } while (lastID !== reactRootID);
	
	    if (current === containersByReactRootID[reactRootID]) {
	      return node;
	    }
	  }
	  return null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var TopLevelWrapper = function () {};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (process.env.NODE_ENV !== 'production') {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /** Exposed for debugging purposes **/
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    if (process.env.NODE_ENV !== 'production') {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[getReactRootID(container)] = getReactRootElementInContainer(container);
	    }
	
	    return prevComponent;
	  },
	
	  /**
	   * Register a component into the instance map and starts scroll value
	   * monitoring
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @return {string} reactRoot ID prefix
	   */
	  _registerComponent: function (nextComponent, container) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	
	    var reactRootID = ReactMount.registerContainer(container);
	    instancesByReactRootID[reactRootID] = nextComponent;
	    return reactRootID;
	  },
	
	  /**
	   * Render a new component into the DOM.
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    var componentInstance = instantiateReactComponent(nextElement, null);
	    var reactRootID = ReactMount._registerComponent(componentInstance, container);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, reactRootID, container, shouldReuseMarkup, context);
	
	    if (process.env.NODE_ENV !== 'production') {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[reactRootID] = getReactRootElementInContainer(container);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && parentComponent._reactInternalInstance != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'parentComponent must be a valid React Component') : invariant(false) : undefined;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !ReactElement.isValidElement(nextElement) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing an element string, make sure to instantiate ' + 'it by passing it to React.createElement.' : typeof nextElement === 'function' ? ' Instead of passing a component class, make sure to instantiate ' + 'it by passing it to React.createElement.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : invariant(false) : undefined;
	
	    process.env.NODE_ENV !== 'production' ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : undefined;
	
	    var nextWrappedElement = new ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var prevComponent = instancesByReactRootID[getReactRootID(container)];
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (process.env.NODE_ENV !== 'production') {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : undefined;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : undefined;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, parentComponent != null ? parentComponent._reactInternalInstance._processChildContext(parentComponent._reactInternalInstance._context) : emptyObject)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Registers a container node into which React components will be rendered.
	   * This also creates the "reactRoot" ID that will be assigned to the element
	   * rendered within.
	   *
	   * @param {DOMElement} container DOM element to register as a container.
	   * @return {string} The "reactRoot" ID of elements rendered within.
	   */
	  registerContainer: function (container) {
	    var reactRootID = getReactRootID(container);
	    if (reactRootID) {
	      // If one exists, make sure it is a valid "reactRoot" ID.
	      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
	    }
	    if (!reactRootID) {
	      // No valid "reactRoot" ID found, create one.
	      reactRootID = ReactInstanceHandles.createReactRootID();
	    }
	    containersByReactRootID[reactRootID] = container;
	    return reactRootID;
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    var reactRootID = getReactRootID(container);
	    var component = instancesByReactRootID[reactRootID];
	    if (!component) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var containerID = internalGetID(container);
	      var isContainerReactRoot = containerID && containerID === ReactInstanceHandles.getReactRootIDFromNodeID(containerID);
	
	      if (process.env.NODE_ENV !== 'production') {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : undefined;
	      }
	
	      return false;
	    }
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, component, container);
	    delete instancesByReactRootID[reactRootID];
	    delete containersByReactRootID[reactRootID];
	    if (process.env.NODE_ENV !== 'production') {
	      delete rootElementsByReactRootID[reactRootID];
	    }
	    return true;
	  },
	
	  /**
	   * Finds the container DOM element that contains React component to which the
	   * supplied DOM `id` belongs.
	   *
	   * @param {string} id The ID of an element rendered by a React component.
	   * @return {?DOMElement} DOM element that contains the `id`.
	   */
	  findReactContainerForID: function (id) {
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
	    var container = containersByReactRootID[reactRootID];
	
	    if (process.env.NODE_ENV !== 'production') {
	      var rootElement = rootElementsByReactRootID[reactRootID];
	      if (rootElement && rootElement.parentNode !== container) {
	        process.env.NODE_ENV !== 'production' ? warning(
	        // Call internalGetID here because getID calls isValid which calls
	        // findReactContainerForID (this function).
	        internalGetID(rootElement) === reactRootID, 'ReactMount: Root element ID differed from reactRootID.') : undefined;
	        var containerChild = container.firstChild;
	        if (containerChild && reactRootID === internalGetID(containerChild)) {
	          // If the container has a new child with the same ID as the old
	          // root element, then rootElementsByReactRootID[reactRootID] is
	          // just stale and needs to be updated. The case that deserves a
	          // warning is when the container is empty.
	          rootElementsByReactRootID[reactRootID] = containerChild;
	        } else {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'ReactMount: Root element has been removed from its original ' + 'container. New container: %s', rootElement.parentNode) : undefined;
	        }
	      }
	    }
	
	    return container;
	  },
	
	  /**
	   * Finds an element rendered by React with the supplied ID.
	   *
	   * @param {string} id ID of a DOM node in the React component.
	   * @return {DOMElement} Root DOM node of the React component.
	   */
	  findReactNodeByID: function (id) {
	    var reactRoot = ReactMount.findReactContainerForID(id);
	    return ReactMount.findComponentRoot(reactRoot, id);
	  },
	
	  /**
	   * Traverses up the ancestors of the supplied node to find a node that is a
	   * DOM representation of a React component rendered by this copy of React.
	   *
	   * @param {*} node
	   * @return {?DOMEventTarget}
	   * @internal
	   */
	  getFirstReactDOM: function (node) {
	    return findFirstReactDOMImpl(node);
	  },
	
	  /**
	   * Finds a node with the supplied `targetID` inside of the supplied
	   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
	   * quickly.
	   *
	   * @param {DOMEventTarget} ancestorNode Search from this root.
	   * @pararm {string} targetID ID of the DOM representation of the component.
	   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
	   * @internal
	   */
	  findComponentRoot: function (ancestorNode, targetID) {
	    var firstChildren = findComponentRootReusableArray;
	    var childIndex = 0;
	
	    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;
	
	    if (process.env.NODE_ENV !== 'production') {
	      // This will throw on the next line; give an early warning
	      process.env.NODE_ENV !== 'production' ? warning(deepestAncestor != null, 'React can\'t find the root component node for data-reactid value ' + '`%s`. If you\'re seeing this message, it probably means that ' + 'you\'ve loaded two copies of React on the page. At this time, only ' + 'a single copy of React can be loaded at a time.', targetID) : undefined;
	    }
	
	    firstChildren[0] = deepestAncestor.firstChild;
	    firstChildren.length = 1;
	
	    while (childIndex < firstChildren.length) {
	      var child = firstChildren[childIndex++];
	      var targetChild;
	
	      while (child) {
	        var childID = ReactMount.getID(child);
	        if (childID) {
	          // Even if we find the node we're looking for, we finish looping
	          // through its siblings to ensure they're cached so that we don't have
	          // to revisit this node again. Otherwise, we make n^2 calls to getID
	          // when visiting the many children of a single node in order.
	
	          if (targetID === childID) {
	            targetChild = child;
	          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
	            // If we find a child whose ID is an ancestor of the given ID,
	            // then we can be sure that we only want to search the subtree
	            // rooted at this child, so we can throw out the rest of the
	            // search state.
	            firstChildren.length = childIndex = 0;
	            firstChildren.push(child.firstChild);
	          }
	        } else {
	          // If this child had no ID, then there's a chance that it was
	          // injected automatically by the browser, as when a `<table>`
	          // element sprouts an extra `<tbody>` child as a side effect of
	          // `.innerHTML` parsing. Optimistically continue down this
	          // branch, but not before examining the other siblings.
	          firstChildren.push(child.firstChild);
	        }
	
	        child = child.nextSibling;
	      }
	
	      if (targetChild) {
	        // Emptying firstChildren/findComponentRootReusableArray is
	        // not necessary for correctness, but it helps the GC reclaim
	        // any nodes that were left at the end of the search.
	        firstChildren.length = 0;
	
	        return targetChild;
	      }
	    }
	
	    firstChildren.length = 0;
	
	     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'findComponentRoot(..., %s): Unable to find element. This probably ' + 'means the DOM was unexpectedly mutated (e.g., by the browser), ' + 'usually due to forgetting a <tbody> when using tables, nesting tags ' + 'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' + 'parent. ' + 'Try inspecting the child nodes of the element with React ID `%s`.', targetID, ReactMount.getID(ancestorNode)) : invariant(false) : undefined;
	  },
	
	  _mountImageIntoNode: function (markup, container, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : invariant(false) : undefined;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (process.env.NODE_ENV !== 'production') {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'You\'re trying to render a component to the document using ' + 'server rendering but the checksum was invalid. This usually ' + 'means you rendered a different component type or props on ' + 'the client from the one on the server, or your render() ' + 'methods are impure. React cannot handle this case due to ' + 'cross-browser quirks by rendering at the document root. You ' + 'should look for environment dependent code in your components ' + 'and ensure the props are the same client and server side:\n%s', difference) : invariant(false) : undefined;
	
	        if (process.env.NODE_ENV !== 'production') {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : undefined;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'You\'re trying to render a component to the document but ' + 'you didn\'t use server rendering. We can\'t do this ' + 'without using server rendering due to cross-browser quirks. ' + 'See ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      container.appendChild(markup);
	    } else {
	      setInnerHTML(container, markup);
	    }
	  },
	
	  ownerDocumentContextKey: ownerDocumentContextKey,
	
	  /**
	   * React ID utilities.
	   */
	
	  getReactRootID: getReactRootID,
	
	  getID: getID,
	
	  setID: setID,
	
	  getNode: getNode,
	
	  getNodeFromInstance: getNodeFromInstance,
	
	  isValid: isValid,
	
	  purgeID: purgeID
	};
	
	ReactPerf.measureMethods(ReactMount, 'ReactMount', {
	  _renderNewRootComponent: '_renderNewRootComponent',
	  _mountImageIntoNode: '_mountImageIntoNode'
	});
	
	module.exports = ReactMount;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(31);
	var EventPluginHub = __webpack_require__(32);
	var EventPluginRegistry = __webpack_require__(33);
	var ReactEventEmitterMixin = __webpack_require__(38);
	var ReactPerf = __webpack_require__(19);
	var ViewportMetrics = __webpack_require__(39);
	
	var assign = __webpack_require__(40);
	var isEventSupported = __webpack_require__(41);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (!isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  },
	
	  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginHub.registrationNameModules,
	
	  putListener: EventPluginHub.putListener,
	
	  getListener: EventPluginHub.getListener,
	
	  deleteListener: EventPluginHub.deleteListener,
	
	  deleteAllListeners: EventPluginHub.deleteAllListeners
	
	});
	
	ReactPerf.measureMethods(ReactBrowserEventEmitter, 'ReactBrowserEventEmitter', {
	  putListener: 'putListener',
	  deleteListener: 'deleteListener'
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(18);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var EventPluginRegistry = __webpack_require__(33);
	var EventPluginUtils = __webpack_require__(34);
	var ReactErrorUtils = __webpack_require__(35);
	
	var accumulateInto = __webpack_require__(36);
	var forEachAccumulated = __webpack_require__(37);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(26);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	/**
	 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
	 *   hierarchy given ids of the logical DOM elements involved.
	 */
	var InstanceHandle = null;
	
	function validateInstanceHandle() {
	  var valid = InstanceHandle && InstanceHandle.traverseTwoPhase && InstanceHandle.traverseEnterLeave;
	  process.env.NODE_ENV !== 'production' ? warning(valid, 'InstanceHandle not injected before use!') : undefined;
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {object} InjectedMount
	     * @public
	     */
	    injectMount: EventPluginUtils.injection.injectMount,
	
	    /**
	     * @param {object} InjectedInstanceHandle
	     * @public
	     */
	    injectInstanceHandle: function (InjectedInstanceHandle) {
	      InstanceHandle = InjectedInstanceHandle;
	      if (process.env.NODE_ENV !== 'production') {
	        validateInstanceHandle();
	      }
	    },
	
	    getInstanceHandle: function () {
	      if (process.env.NODE_ENV !== 'production') {
	        validateInstanceHandle();
	      }
	      return InstanceHandle;
	    },
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginRegistry.registrationNameModules,
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {?function} listener The callback to store.
	   */
	  putListener: function (id, registrationName, listener) {
	    !(typeof listener === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : invariant(false) : undefined;
	
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[id] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(id, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[id];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (id, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(id, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[id];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {string} id ID of the DOM element.
	   */
	  deleteAllListeners: function (id) {
	    for (var registrationName in listenerBank) {
	      if (!listenerBank[registrationName][id]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(id, registrationName);
	      }
	
	      delete listenerBank[registrationName][id];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ? process.env.NODE_ENV !== 'production' ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing ' + 'an event queue. Support for this has not yet been implemented.') : invariant(false) : undefined;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in ' + 'the plugin ordering, `%s`.', pluginName) : invariant(false) : undefined;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` ' + 'method, but `%s` does not.', pluginName) : invariant(false) : undefined;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : invariant(false) : undefined;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'event name, `%s`.', eventName) : invariant(false) : undefined;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName) : invariant(false) : undefined;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than ' + 'once. You are likely trying to load more than one copy of React.') : invariant(false) : undefined;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ? process.env.NODE_ENV !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins ' + 'using the same name, `%s`.', pluginName) : invariant(false) : undefined;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(31);
	var ReactErrorUtils = __webpack_require__(35);
	
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(26);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `Mount`: [required] Module that can convert between React dom IDs and
	 *   actual node references.
	 */
	var injection = {
	  Mount: null,
	  injectMount: function (InjectedMount) {
	    injection.Mount = InjectedMount;
	    if (process.env.NODE_ENV !== 'production') {
	      process.env.NODE_ENV !== 'production' ? warning(InjectedMount && InjectedMount.getNode && InjectedMount.getID, 'EventPluginUtils.injection.injectMount(...): Injected Mount ' + 'module is missing getNode or getID.') : undefined;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (process.env.NODE_ENV !== 'production') {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchIDs = event._dispatchIDs;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var idsIsArr = Array.isArray(dispatchIDs);
	    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(idsIsArr === listenersIsArr && IDsLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : undefined;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {string} domID DOM id to pass to the callback.
	 */
	function executeDispatch(event, simulated, listener, domID) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = injection.Mount.getNode(domID);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event, domID);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event, domID);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (process.env.NODE_ENV !== 'production') {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchIDs[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchIDs);
	  }
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (process.env.NODE_ENV !== 'production') {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchIDs[i])) {
	        return dispatchIDs[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchIDs)) {
	      return dispatchIDs;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchIDs = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (process.env.NODE_ENV !== 'production') {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchID = event._dispatchIDs;
	  !!Array.isArray(dispatchListener) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : invariant(false) : undefined;
	  var res = dispatchListener ? dispatchListener(event, dispatchID) : null;
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getNode: function (id) {
	    return injection.Mount.getNode(id);
	  },
	  getID: function (node) {
	    return injection.Mount.getID(node);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 * @typechecks
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (process.env.NODE_ENV !== 'production') {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : invariant(false) : undefined;
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);
	
	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }
	
	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }
	
	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 37 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	var forEachAccumulated = function (arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};
	
	module.exports = forEachAccumulated;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(32);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {object} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native environment event.
	   */
	  handleTopLevel: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 39 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 40 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Object.assign
	 */
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign
	
	'use strict';
	
	function assign(target, sources) {
	  if (target == null) {
	    throw new TypeError('Object.assign target cannot be null or undefined');
	  }
	
	  var to = Object(target);
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
	    var nextSource = arguments[nextIndex];
	    if (nextSource == null) {
	      continue;
	    }
	
	    var from = Object(nextSource);
	
	    // We don't currently support accessors nor proxies. Therefore this
	    // copy cannot throw. If we ever supported this then we must handle
	    // exceptions and side-effects. We don't support symbols so they won't
	    // be transferred.
	
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	  }
	
	  return to;
	}
	
	module.exports = assign;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = (eventName in document);
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 42 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(6);
	
	var assign = __webpack_require__(40);
	var canDefineProperty = __webpack_require__(44);
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	/**
	 * Base constructor for all React elements. This is only used to make this
	 * work with a dynamic instanceof check. Nothing should live on this prototype.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (process.env.NODE_ENV !== 'production') {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    Object.freeze(element.props);
	    Object.freeze(element);
	  }
	
	  return element;
	};
	
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    ref = config.ref === undefined ? null : config.ref;
	    key = config.key === undefined ? null : '' + config.key;
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (typeof props[propName] === 'undefined') {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	ReactElement.cloneAndReplaceProps = function (oldElement, newProps) {
	  var newElement = ReactElement(oldElement.type, oldElement.key, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, newProps);
	
	  if (process.env.NODE_ENV !== 'production') {
	    // If the key on the original is valid, then the clone is valid
	    newElement._store.validated = oldElement._store.validated;
	  }
	
	  return newElement;
	};
	
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (process.env.NODE_ENV !== 'production') {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 45 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponentRegistry
	 */
	
	'use strict';
	
	// This registry keeps track of the React IDs of the components that rendered to
	// `null` (in reality a placeholder such as `noscript`)
	var nullComponentIDsRegistry = {};
	
	/**
	 * @param {string} id Component's `_rootNodeID`.
	 * @return {boolean} True if the component is rendered to null.
	 */
	function isNullComponentID(id) {
	  return !!nullComponentIDsRegistry[id];
	}
	
	/**
	 * Mark the component as having rendered to null.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function registerNullComponentID(id) {
	  nullComponentIDsRegistry[id] = true;
	}
	
	/**
	 * Unmark the component as having rendered to null: it renders to something now.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function deregisterNullComponentID(id) {
	  delete nullComponentIDsRegistry[id];
	}
	
	var ReactEmptyComponentRegistry = {
	  isNullComponentID: isNullComponentID,
	  registerNullComponentID: registerNullComponentID,
	  deregisterNullComponentID: deregisterNullComponentID
	};
	
	module.exports = ReactEmptyComponentRegistry;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceHandles
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactRootIndex = __webpack_require__(47);
	
	var invariant = __webpack_require__(14);
	
	var SEPARATOR = '.';
	var SEPARATOR_LENGTH = SEPARATOR.length;
	
	/**
	 * Maximum depth of traversals before we consider the possibility of a bad ID.
	 */
	var MAX_TREE_DEPTH = 10000;
	
	/**
	 * Creates a DOM ID prefix to use when mounting React components.
	 *
	 * @param {number} index A unique integer
	 * @return {string} React root ID.
	 * @internal
	 */
	function getReactRootIDString(index) {
	  return SEPARATOR + index.toString(36);
	}
	
	/**
	 * Checks if a character in the supplied ID is a separator or the end.
	 *
	 * @param {string} id A React DOM ID.
	 * @param {number} index Index of the character to check.
	 * @return {boolean} True if the character is a separator or end of the ID.
	 * @private
	 */
	function isBoundary(id, index) {
	  return id.charAt(index) === SEPARATOR || index === id.length;
	}
	
	/**
	 * Checks if the supplied string is a valid React DOM ID.
	 *
	 * @param {string} id A React DOM ID, maybe.
	 * @return {boolean} True if the string is a valid React DOM ID.
	 * @private
	 */
	function isValidID(id) {
	  return id === '' || id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR;
	}
	
	/**
	 * Checks if the first ID is an ancestor of or equal to the second ID.
	 *
	 * @param {string} ancestorID
	 * @param {string} descendantID
	 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
	 * @internal
	 */
	function isAncestorIDOf(ancestorID, descendantID) {
	  return descendantID.indexOf(ancestorID) === 0 && isBoundary(descendantID, ancestorID.length);
	}
	
	/**
	 * Gets the parent ID of the supplied React DOM ID, `id`.
	 *
	 * @param {string} id ID of a component.
	 * @return {string} ID of the parent, or an empty string.
	 * @private
	 */
	function getParentID(id) {
	  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
	}
	
	/**
	 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
	 * supplied `destinationID`. If they are equal, the ID is returned.
	 *
	 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
	 * @param {string} destinationID ID of the destination node.
	 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
	 * @private
	 */
	function getNextDescendantID(ancestorID, destinationID) {
	  !(isValidID(ancestorID) && isValidID(destinationID)) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getNextDescendantID(%s, %s): Received an invalid React DOM ID.', ancestorID, destinationID) : invariant(false) : undefined;
	  !isAncestorIDOf(ancestorID, destinationID) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getNextDescendantID(...): React has made an invalid assumption about ' + 'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.', ancestorID, destinationID) : invariant(false) : undefined;
	  if (ancestorID === destinationID) {
	    return ancestorID;
	  }
	  // Skip over the ancestor and the immediate separator. Traverse until we hit
	  // another separator or we reach the end of `destinationID`.
	  var start = ancestorID.length + SEPARATOR_LENGTH;
	  var i;
	  for (i = start; i < destinationID.length; i++) {
	    if (isBoundary(destinationID, i)) {
	      break;
	    }
	  }
	  return destinationID.substr(0, i);
	}
	
	/**
	 * Gets the nearest common ancestor ID of two IDs.
	 *
	 * Using this ID scheme, the nearest common ancestor ID is the longest common
	 * prefix of the two IDs that immediately preceded a "marker" in both strings.
	 *
	 * @param {string} oneID
	 * @param {string} twoID
	 * @return {string} Nearest common ancestor ID, or the empty string if none.
	 * @private
	 */
	function getFirstCommonAncestorID(oneID, twoID) {
	  var minLength = Math.min(oneID.length, twoID.length);
	  if (minLength === 0) {
	    return '';
	  }
	  var lastCommonMarkerIndex = 0;
	  // Use `<=` to traverse until the "EOL" of the shorter string.
	  for (var i = 0; i <= minLength; i++) {
	    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
	      lastCommonMarkerIndex = i;
	    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
	      break;
	    }
	  }
	  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
	  !isValidID(longestCommonID) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s', oneID, twoID, longestCommonID) : invariant(false) : undefined;
	  return longestCommonID;
	}
	
	/**
	 * Traverses the parent path between two IDs (either up or down). The IDs must
	 * not be the same, and there must exist a parent path between them. If the
	 * callback returns `false`, traversal is stopped.
	 *
	 * @param {?string} start ID at which to start traversal.
	 * @param {?string} stop ID at which to end traversal.
	 * @param {function} cb Callback to invoke each ID with.
	 * @param {*} arg Argument to invoke the callback with.
	 * @param {?boolean} skipFirst Whether or not to skip the first node.
	 * @param {?boolean} skipLast Whether or not to skip the last node.
	 * @private
	 */
	function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
	  start = start || '';
	  stop = stop || '';
	  !(start !== stop) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.', start) : invariant(false) : undefined;
	  var traverseUp = isAncestorIDOf(stop, start);
	  !(traverseUp || isAncestorIDOf(start, stop)) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' + 'not have a parent path.', start, stop) : invariant(false) : undefined;
	  // Traverse from `start` to `stop` one depth at a time.
	  var depth = 0;
	  var traverse = traverseUp ? getParentID : getNextDescendantID;
	  for (var id = start;; /* until break */id = traverse(id, stop)) {
	    var ret;
	    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
	      ret = cb(id, traverseUp, arg);
	    }
	    if (ret === false || id === stop) {
	      // Only break //after// visiting `stop`.
	      break;
	    }
	    !(depth++ < MAX_TREE_DEPTH) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' + 'traversing the React DOM ID tree. This may be due to malformed IDs: %s', start, stop, id) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Manages the IDs assigned to DOM representations of React components. This
	 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
	 * order to simulate events).
	 *
	 * @internal
	 */
	var ReactInstanceHandles = {
	
	  /**
	   * Constructs a React root ID
	   * @return {string} A React root ID.
	   */
	  createReactRootID: function () {
	    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
	  },
	
	  /**
	   * Constructs a React ID by joining a root ID with a name.
	   *
	   * @param {string} rootID Root ID of a parent component.
	   * @param {string} name A component's name (as flattened children).
	   * @return {string} A React ID.
	   * @internal
	   */
	  createReactID: function (rootID, name) {
	    return rootID + name;
	  },
	
	  /**
	   * Gets the DOM ID of the React component that is the root of the tree that
	   * contains the React component with the supplied DOM ID.
	   *
	   * @param {string} id DOM ID of a React component.
	   * @return {?string} DOM ID of the React component that is the root.
	   * @internal
	   */
	  getReactRootIDFromNodeID: function (id) {
	    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
	      var index = id.indexOf(SEPARATOR, 1);
	      return index > -1 ? id.substr(0, index) : id;
	    }
	    return null;
	  },
	
	  /**
	   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	   * should would receive a `mouseEnter` or `mouseLeave` event.
	   *
	   * NOTE: Does not invoke the callback on the nearest common ancestor because
	   * nothing "entered" or "left" that element.
	   *
	   * @param {string} leaveID ID being left.
	   * @param {string} enterID ID being entered.
	   * @param {function} cb Callback to invoke on each entered/left ID.
	   * @param {*} upArg Argument to invoke the callback with on left IDs.
	   * @param {*} downArg Argument to invoke the callback with on entered IDs.
	   * @internal
	   */
	  traverseEnterLeave: function (leaveID, enterID, cb, upArg, downArg) {
	    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
	    if (ancestorID !== leaveID) {
	      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
	    }
	    if (ancestorID !== enterID) {
	      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
	    }
	  },
	
	  /**
	   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseTwoPhase: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, false);
	      traverseParentPath(targetID, '', cb, arg, false, true);
	    }
	  },
	
	  /**
	   * Same as `traverseTwoPhase` but skips the `targetID`.
	   */
	  traverseTwoPhaseSkipTarget: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, true);
	      traverseParentPath(targetID, '', cb, arg, true, true);
	    }
	  },
	
	  /**
	   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
	   * example, passing `.0.$row-0.1` would result in `cb` getting called
	   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseAncestors: function (targetID, cb, arg) {
	    traverseParentPath('', targetID, cb, arg, true, false);
	  },
	
	  getFirstCommonAncestorID: getFirstCommonAncestorID,
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getNextDescendantID: getNextDescendantID,
	
	  isAncestorIDOf: isAncestorIDOf,
	
	  SEPARATOR: SEPARATOR
	
	};
	
	module.exports = ReactInstanceHandles;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 47 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactRootIndexInjection = {
	  /**
	   * @param {function} _createReactRootIndex
	   */
	  injectCreateReactRootIndex: function (_createReactRootIndex) {
	    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
	  }
	};
	
	var ReactRootIndex = {
	  createReactRootIndex: null,
	  injection: ReactRootIndexInjection
	};
	
	module.exports = ReactRootIndex;

/***/ },
/* 48 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(50);
	
	var TAG_END = /\/?>/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags and self-closing tags)
	    return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 50 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    for (; i < Math.min(i + 4096, m); i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(52);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, rootID, transaction, context) {
	    var markup = internalInstance.mountComponent(rootID, transaction, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance) {
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent();
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction) {
	    internalInstance.performUpdateIfNecessary(transaction);
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(53);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might ' + 'be adding a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might ' + 'be removing a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    // Check that `component` is still the current ref because we do not want to
	    // detach the ref if another component stole it.
	    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(6);
	var ReactElement = __webpack_require__(43);
	var ReactInstanceMap = __webpack_require__(48);
	var ReactUpdates = __webpack_require__(55);
	
	var assign = __webpack_require__(40);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(26);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (process.env.NODE_ENV !== 'production') {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : undefined;
	    }
	    return null;
	  }
	
	  if (process.env.NODE_ENV !== 'production') {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition ' + '(such as within `render`). Render methods should be a pure function ' + 'of props and state.', callerName) : undefined;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (process.env.NODE_ENV !== 'production') {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {
	    !(typeof callback === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    !(typeof callback === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueSetPropsInternal(internalInstance, partialProps);
	  },
	
	  enqueueSetPropsInternal: function (internalInstance, partialProps) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ? process.env.NODE_ENV !== 'production' ? invariant(false, 'setProps(...): You called `setProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    var props = assign({}, element.props, partialProps);
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueReplacePropsInternal(internalInstance, props);
	  },
	
	  enqueueReplacePropsInternal: function (internalInstance, props) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ? process.env.NODE_ENV !== 'production' ? invariant(false, 'replaceProps(...): You called `replaceProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  enqueueElementInternal: function (internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  }
	
	};
	
	module.exports = ReactUpdateQueue;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(56);
	var PooledClass = __webpack_require__(57);
	var ReactPerf = __webpack_require__(19);
	var ReactReconciler = __webpack_require__(51);
	var Transaction = __webpack_require__(58);
	
	var assign = __webpack_require__(40);
	var invariant = __webpack_require__(14);
	
	var dirtyComponents = [];
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching ' + 'strategy') : invariant(false) : undefined;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled( /* forceHTML */false);
	}
	
	assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to ' + 'match dirty-components array length (%s).', len, dirtyComponents.length) : invariant(false) : undefined;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction);
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	flushBatchedUpdates = ReactPerf.measure('ReactUpdates', 'flushBatchedUpdates', flushBatchedUpdates);
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' + 'updates are not being batched.') : invariant(false) : undefined;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : invariant(false) : undefined;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide a batching strategy') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : invariant(false) : undefined;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(57);
	
	var assign = __webpack_require__(40);
	var invariant = __webpack_require__(14);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Mismatched list of contexts in callback queue') : invariant(false) : undefined;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Trying to release an instance into a pool of a different type.') : invariant(false) : undefined;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there ' + 'is already an outstanding transaction.') : invariant(false) : undefined;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : invariant(false) : undefined;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyObject
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (process.env.NODE_ENV !== 'production') {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule containsNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isTextNode = __webpack_require__(61);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 *
	 * @param {?DOMNode} outerNode Outer DOM node.
	 * @param {?DOMNode} innerNode Inner DOM node.
	 * @return {boolean} True if `outerNode` contains or is `innerNode`.
	 */
	function containsNode(_x, _x2) {
	  var _again = true;
	
	  _function: while (_again) {
	    var outerNode = _x,
	        innerNode = _x2;
	    _again = false;
	
	    if (!outerNode || !innerNode) {
	      return false;
	    } else if (outerNode === innerNode) {
	      return true;
	    } else if (isTextNode(outerNode)) {
	      return false;
	    } else if (isTextNode(innerNode)) {
	      _x = outerNode;
	      _x2 = innerNode.parentNode;
	      _again = true;
	      continue _function;
	    } else if (outerNode.contains) {
	      return outerNode.contains(innerNode);
	    } else if (outerNode.compareDocumentPosition) {
	      return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	    } else {
	      return false;
	    }
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isNode = __webpack_require__(62);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 62 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isNode
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	'use strict';
	
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCompositeComponent = __webpack_require__(64);
	var ReactEmptyComponent = __webpack_require__(69);
	var ReactNativeComponent = __webpack_require__(70);
	
	var assign = __webpack_require__(40);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(26);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function () {};
	assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = new ReactEmptyComponent(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : invariant(false) : undefined;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactNativeComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper();
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	     true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : invariant(false) : undefined;
	  }
	
	  if (process.env.NODE_ENV !== 'production') {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.construct === 'function' && typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : undefined;
	  }
	
	  // Sets up the instance. This can probably just move into the constructor now.
	  instance.construct(node);
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (process.env.NODE_ENV !== 'production') {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (process.env.NODE_ENV !== 'production') {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(65);
	var ReactCurrentOwner = __webpack_require__(6);
	var ReactElement = __webpack_require__(43);
	var ReactInstanceMap = __webpack_require__(48);
	var ReactPerf = __webpack_require__(19);
	var ReactPropTypeLocations = __webpack_require__(66);
	var ReactPropTypeLocationNames = __webpack_require__(67);
	var ReactReconciler = __webpack_require__(51);
	var ReactUpdateQueue = __webpack_require__(54);
	
	var assign = __webpack_require__(40);
	var emptyObject = __webpack_require__(59);
	var invariant = __webpack_require__(14);
	var shouldUpdateReactComponent = __webpack_require__(68);
	var warning = __webpack_require__(26);
	
	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  return Component(this.props, this.context, this.updater);
	};
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	
	    // See ReactUpdateQueue
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedComponent = null;
	
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._rootNodeID = rootID;
	
	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    // Initialize the public class
	    var inst;
	    var renderedElement;
	
	    // This is a way to detect if Component is a stateless arrow function
	    // component, which is not newable. It might not be 100% reliable but is
	    // something we can do until we start detecting that Component extends
	    // React.Component. We already assume that typeof Component === 'function'.
	    var canInstantiate = ('prototype' in Component);
	
	    if (canInstantiate) {
	      if (process.env.NODE_ENV !== 'production') {
	        ReactCurrentOwner.current = this;
	        try {
	          inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	        } finally {
	          ReactCurrentOwner.current = null;
	        }
	      } else {
	        inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	      }
	    }
	
	    if (!canInstantiate || inst === null || inst === false || ReactElement.isValidElement(inst)) {
	      renderedElement = inst;
	      inst = new StatelessComponent(Component);
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`, returned ' + 'null/false from a stateless component, or tried to render an ' + 'element whose type is a function that isn\'t a React component.', Component.displayName || Component.name || 'Component') : undefined;
	      } else {
	        // We support ES6 inheriting from React.Component, the module pattern,
	        // and stateless components, but not ES6 classes that don't extend
	        process.env.NODE_ENV !== 'production' ? warning(Component.prototype && Component.prototype.isReactComponent || !canInstantiate || !(inst instanceof Component), '%s(...): React component classes must extend React.Component.', Component.displayName || Component.name || 'Component') : undefined;
	      }
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = ReactUpdateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (process.env.NODE_ENV !== 'production') {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : undefined;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    if (inst.componentWillMount) {
	      inst.componentWillMount();
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    this._renderedComponent = this._instantiateReactComponent(renderedElement);
	
	    var markup = ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, this._processChildContext(context));
	    if (inst.componentDidMount) {
	      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	    }
	
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function () {
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount) {
	      inst.componentWillUnmount();
	    }
	
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    this._renderedComponent = null;
	    this._instance = null;
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var maskedContext = null;
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (process.env.NODE_ENV !== 'production') {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkPropTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	      if (process.env.NODE_ENV !== 'production') {
	        this._checkPropTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : invariant(false) : undefined;
	      }
	      return assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function (newProps) {
	    if (process.env.NODE_ENV !== 'production') {
	      var Component = this._currentElement.type;
	      if (Component.propTypes) {
	        this._checkPropTypes(Component.propTypes, newProps, ReactPropTypeLocations.prop);
	      }
	    }
	    return newProps;
	  },
	
	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function (propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          !(typeof propTypes[propName] === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually ' + 'from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	          error = propTypes[propName](props, propName, componentName, location);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // top-level render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	
	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	            process.env.NODE_ENV !== 'production' ? warning(false, 'Failed Composite propType: %s%s', error.message, addendum) : undefined;
	          } else {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'Failed Context Types: %s%s', error.message, addendum) : undefined;
	          }
	        }
	      }
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement || this._currentElement, transaction, this._context);
	    }
	
	    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	
	    var nextContext = this._context === nextUnmaskedContext ? inst.context : this._processContext(nextUnmaskedContext);
	    var nextProps;
	
	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement === nextParentElement) {
	      // Skip checking prop types again -- we don't read inst.props to avoid
	      // warning for DOM component props in this upgrade
	      nextProps = nextParentElement.props;
	    } else {
	      nextProps = this._processProps(nextParentElement.props);
	      // An update here will schedule an update but immediately set
	      // _pendingStateQueue which will ensure that any state updates gets
	      // immediately reconciled instead of waiting for the next batch.
	
	      if (inst.componentWillReceiveProps) {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	
	    var shouldUpdate = this._pendingForceUpdate || !inst.shouldComponentUpdate || inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	
	    if (process.env.NODE_ENV !== 'production') {
	      process.env.NODE_ENV !== 'production' ? warning(typeof shouldUpdate !== 'undefined', '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : undefined;
	    }
	
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      // These two IDs are actually the same! But nothing should rely on that.
	      var thisID = this._rootNodeID;
	      var prevComponentID = prevComponentInstance._rootNodeID;
	      ReactReconciler.unmountComponent(prevComponentInstance);
	
	      this._renderedComponent = this._instantiateReactComponent(nextRenderedElement);
	      var nextMarkup = ReactReconciler.mountComponent(this._renderedComponent, thisID, transaction, this._processChildContext(context));
	      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  _replaceNodeWithMarkupByID: function (prevComponentID, nextMarkup) {
	    ReactComponentEnvironment.replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedComponent = inst.render();
	    if (process.env.NODE_ENV !== 'production') {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (typeof renderedComponent === 'undefined' && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactCurrentOwner.current = null;
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.render(): A valid ReactComponent must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Stateless function components cannot have refs.') : invariant(false) : undefined;
	    var publicComponentInstance = component.getPublicInstance();
	    if (process.env.NODE_ENV !== 'production') {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : undefined;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (inst instanceof StatelessComponent) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	ReactPerf.measureMethods(ReactCompositeComponentMixin, 'ReactCompositeComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent',
	  _renderValidatedComponent: '_renderValidatedComponent'
	});
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(14);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkupByID: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : invariant(false) : undefined;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkupByID = environment.replaceNodeWithMarkupByID;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(18);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (process.env.NODE_ENV !== 'production') {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 68 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	  return false;
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(43);
	var ReactEmptyComponentRegistry = __webpack_require__(45);
	var ReactReconciler = __webpack_require__(51);
	
	var assign = __webpack_require__(40);
	
	var placeholderElement;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponent: function (component) {
	    placeholderElement = ReactElement.createElement(component);
	  }
	};
	
	var ReactEmptyComponent = function (instantiate) {
	  this._currentElement = null;
	  this._rootNodeID = null;
	  this._renderedComponent = instantiate(placeholderElement);
	};
	assign(ReactEmptyComponent.prototype, {
	  construct: function (element) {},
	  mountComponent: function (rootID, transaction, context) {
	    ReactEmptyComponentRegistry.registerNullComponentID(rootID);
	    this._rootNodeID = rootID;
	    return ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, context);
	  },
	  receiveComponent: function () {},
	  unmountComponent: function (rootID, transaction, context) {
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    ReactEmptyComponentRegistry.deregisterNullComponentID(this._rootNodeID);
	    this._rootNodeID = null;
	    this._renderedComponent = null;
	  }
	});
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */
	
	'use strict';
	
	var assign = __webpack_require__(40);
	var invariant = __webpack_require__(14);
	
	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}
	
	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ? process.env.NODE_ENV !== 'production' ? invariant(false, 'There is no registered component for the tag %s', element.type) : invariant(false) : undefined;
	  return new genericComponentClass(element.type, element.props);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};
	
	module.exports = ReactNativeComponent;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var assign = __webpack_require__(40);
	var emptyFunction = __webpack_require__(16);
	var warning = __webpack_require__(26);
	
	var validateDOMNesting = emptyFunction;
	
	if (process.env.NODE_ENV !== 'production') {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    parentTag: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.parentTag = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    /*eslint-disable space-after-keywords */
	    do {
	      /*eslint-enable space-after-keywords */
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a child of <%s>. ' + 'See %s.%s', childTag, ancestorTag, ownerInfo, info) : undefined;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a descendant of ' + '<%s>. See %s.', childTag, ancestorTag, ownerInfo) : undefined;
	      }
	    }
	  };
	
	  validateDOMNesting.ancestorInfoContextKey = '__validateDOMNesting_ancestorInfo$' + Math.random().toString(36).slice(2);
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(73);
	var ChangeEventPlugin = __webpack_require__(81);
	var ClientReactRootIndex = __webpack_require__(84);
	var DefaultEventPluginOrder = __webpack_require__(85);
	var EnterLeaveEventPlugin = __webpack_require__(86);
	var ExecutionEnvironment = __webpack_require__(10);
	var HTMLDOMPropertyConfig = __webpack_require__(90);
	var ReactBrowserComponentMixin = __webpack_require__(91);
	var ReactComponentBrowserEnvironment = __webpack_require__(27);
	var ReactDefaultBatchingStrategy = __webpack_require__(93);
	var ReactDOMComponent = __webpack_require__(94);
	var ReactDOMTextComponent = __webpack_require__(7);
	var ReactEventListener = __webpack_require__(119);
	var ReactInjection = __webpack_require__(122);
	var ReactInstanceHandles = __webpack_require__(46);
	var ReactMount = __webpack_require__(29);
	var ReactReconcileTransaction = __webpack_require__(126);
	var SelectEventPlugin = __webpack_require__(131);
	var ServerReactRootIndex = __webpack_require__(132);
	var SimpleEventPlugin = __webpack_require__(133);
	var SVGDOMPropertyConfig = __webpack_require__(142);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
	  ReactInjection.EventPluginHub.injectMount(ReactMount);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.NativeComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.NativeComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.RootIndex.injectCreateReactRootIndex(ExecutionEnvironment.canUseDOM ? ClientReactRootIndex.createReactRootIndex : ServerReactRootIndex.createReactRootIndex);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	
	  if (process.env.NODE_ENV !== 'production') {
	    var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
	    if (/[?&]react_perf\b/.test(url)) {
	      var ReactDefaultPerf = __webpack_require__(143);
	      ReactDefaultPerf.start();
	    }
	  }
	}
	
	module.exports = {
	  inject: inject
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015 Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(31);
	var EventPropagators = __webpack_require__(74);
	var ExecutionEnvironment = __webpack_require__(10);
	var FallbackCompositionState = __webpack_require__(75);
	var SyntheticCompositionEvent = __webpack_require__(77);
	var SyntheticInputEvent = __webpack_require__(79);
	
	var keyOf = __webpack_require__(80);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(31);
	var EventPluginHub = __webpack_require__(32);
	
	var warning = __webpack_require__(26);
	
	var accumulateInto = __webpack_require__(36);
	var forEachAccumulated = __webpack_require__(37);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(id, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(id, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(domID, upwards, event) {
	  if (process.env.NODE_ENV !== 'production') {
	    process.env.NODE_ENV !== 'production' ? warning(domID, 'Dispatching id must not be null') : undefined;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(domID, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhaseSkipTarget(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(id, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(id, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event.dispatchMarker, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
	  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(fromID, toID, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(57);
	
	var assign = __webpack_require__(40);
	var getTextContentAccessor = __webpack_require__(76);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(78);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(57);
	
	var assign = __webpack_require__(40);
	var emptyFunction = __webpack_require__(16);
	var warning = __webpack_require__(26);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 */
	function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  this.dispatchConfig = dispatchConfig;
	  this.dispatchMarker = dispatchMarker;
	  this.nativeEvent = nativeEvent;
	  this.target = nativeEventTarget;
	  this.currentTarget = nativeEventTarget;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      this[propName] = nativeEvent[propName];
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	}
	
	assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (process.env.NODE_ENV !== 'production') {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `preventDefault` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (process.env.NODE_ENV !== 'production') {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `stopPropagation` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      this[propName] = null;
	    }
	    this.dispatchConfig = null;
	    this.dispatchMarker = null;
	    this.nativeEvent = null;
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var prototype = Object.create(Super.prototype);
	  assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(78);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 80 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	"use strict";
	
	var keyOf = function (oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(31);
	var EventPluginHub = __webpack_require__(32);
	var EventPropagators = __webpack_require__(74);
	var ExecutionEnvironment = __webpack_require__(10);
	var ReactUpdates = __webpack_require__(55);
	var SyntheticEvent = __webpack_require__(78);
	
	var getEventTarget = __webpack_require__(82);
	var isEventSupported = __webpack_require__(41);
	var isTextInputElement = __webpack_require__(83);
	var keyOf = __webpack_require__(80);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementID = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementID, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementID = null;
	}
	
	function getTargetIDForChangeEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return topLevelTargetID;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For old IE.) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For old IE.) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For old IE.) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementID = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For old IE.) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetIDForInputEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return topLevelTargetID;
	  }
	}
	
	// For IE8 and IE9.
	function handleEventsForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetIDForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementID;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetIDForClickEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return topLevelTargetID;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	
	    var getTargetIDFunc, handleEventFunc;
	    if (shouldUseChangeEvent(topLevelTarget)) {
	      if (doesChangeEventBubble) {
	        getTargetIDFunc = getTargetIDForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(topLevelTarget)) {
	      if (isInputEventSupported) {
	        getTargetIDFunc = getTargetIDForInputEvent;
	      } else {
	        getTargetIDFunc = getTargetIDForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(topLevelTarget)) {
	      getTargetIDFunc = getTargetIDForClickEvent;
	    }
	
	    if (getTargetIDFunc) {
	      var targetID = getTargetIDFunc(topLevelType, topLevelTarget, topLevelTargetID);
	      if (targetID) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, targetID, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, topLevelTarget, topLevelTargetID);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 82 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 83 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName && (nodeName === 'input' && supportedInputTypes[elem.type] || nodeName === 'textarea');
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 84 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ClientReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var nextReactRootIndex = 0;
	
	var ClientReactRootIndex = {
	  createReactRootIndex: function () {
	    return nextReactRootIndex++;
	  }
	};
	
	module.exports = ClientReactRootIndex;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(80);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(31);
	var EventPropagators = __webpack_require__(74);
	var SyntheticMouseEvent = __webpack_require__(87);
	
	var ReactMount = __webpack_require__(29);
	var keyOf = __webpack_require__(80);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	var getFirstReactDOM = ReactMount.getFirstReactDOM;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var extractedEvents = [null, null];
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (topLevelTarget.window === topLevelTarget) {
	      // `topLevelTarget` is probably a window object.
	      win = topLevelTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = topLevelTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    var fromID = '';
	    var toID = '';
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = topLevelTarget;
	      fromID = topLevelTargetID;
	      to = getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement);
	      if (to) {
	        toID = ReactMount.getID(to);
	      } else {
	        to = win;
	      }
	      to = to || win;
	    } else {
	      from = win;
	      to = topLevelTarget;
	      toID = topLevelTargetID;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, fromID, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = from;
	    leave.relatedTarget = to;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, toID, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = to;
	    enter.relatedTarget = from;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);
	
	    extractedEvents[0] = leave;
	    extractedEvents[1] = enter;
	
	    return extractedEvents;
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(88);
	var ViewportMetrics = __webpack_require__(39);
	
	var getEventModifierState = __webpack_require__(89);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(78);
	
	var getEventTarget = __webpack_require__(82);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 89 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(24);
	var ExecutionEnvironment = __webpack_require__(10);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var hasSVG;
	if (ExecutionEnvironment.canUseDOM) {
	  var implementation = document.implementation;
	  hasSVG = implementation && implementation.hasFeature && implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
	}
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(/^(data|aria)-[a-z_][a-z\d_.\-]*$/),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: null,
	    acceptCharset: null,
	    accessKey: null,
	    action: null,
	    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    allowTransparency: MUST_USE_ATTRIBUTE,
	    alt: null,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: null,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    cellPadding: null,
	    cellSpacing: null,
	    charSet: MUST_USE_ATTRIBUTE,
	    challenge: MUST_USE_ATTRIBUTE,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    classID: MUST_USE_ATTRIBUTE,
	    // To set className on SVG elements, it's necessary to use .setAttribute;
	    // this works on HTML elements too in all browsers except IE8. Conveniently,
	    // IE8 doesn't support SVG and so we can simply use the attribute in
	    // browsers that support SVG and the property in browsers that don't,
	    // regardless of whether the element is HTML or SVG.
	    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
	    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: null,
	    content: null,
	    contentEditable: null,
	    contextMenu: MUST_USE_ATTRIBUTE,
	    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    coords: null,
	    crossOrigin: null,
	    data: null, // For `<object />` acts as `src`.
	    dateTime: MUST_USE_ATTRIBUTE,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: null,
	    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: null,
	    encType: null,
	    form: MUST_USE_ATTRIBUTE,
	    formAction: MUST_USE_ATTRIBUTE,
	    formEncType: MUST_USE_ATTRIBUTE,
	    formMethod: MUST_USE_ATTRIBUTE,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: MUST_USE_ATTRIBUTE,
	    frameBorder: MUST_USE_ATTRIBUTE,
	    headers: null,
	    height: MUST_USE_ATTRIBUTE,
	    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    high: null,
	    href: null,
	    hrefLang: null,
	    htmlFor: null,
	    httpEquiv: null,
	    icon: null,
	    id: MUST_USE_PROPERTY,
	    inputMode: MUST_USE_ATTRIBUTE,
	    integrity: null,
	    is: MUST_USE_ATTRIBUTE,
	    keyParams: MUST_USE_ATTRIBUTE,
	    keyType: MUST_USE_ATTRIBUTE,
	    kind: null,
	    label: null,
	    lang: null,
	    list: MUST_USE_ATTRIBUTE,
	    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    low: null,
	    manifest: MUST_USE_ATTRIBUTE,
	    marginHeight: null,
	    marginWidth: null,
	    max: null,
	    maxLength: MUST_USE_ATTRIBUTE,
	    media: MUST_USE_ATTRIBUTE,
	    mediaGroup: null,
	    method: null,
	    min: null,
	    minLength: MUST_USE_ATTRIBUTE,
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: null,
	    nonce: MUST_USE_ATTRIBUTE,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: null,
	    pattern: null,
	    placeholder: null,
	    poster: null,
	    preload: null,
	    radioGroup: null,
	    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    rel: null,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: MUST_USE_ATTRIBUTE,
	    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: null,
	    sandbox: null,
	    scope: null,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: null,
	    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: null,
	    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: MUST_USE_ATTRIBUTE,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: null,
	    src: null,
	    srcDoc: MUST_USE_PROPERTY,
	    srcLang: null,
	    srcSet: MUST_USE_ATTRIBUTE,
	    start: HAS_NUMERIC_VALUE,
	    step: null,
	    style: null,
	    summary: null,
	    tabIndex: null,
	    target: null,
	    title: null,
	    type: null,
	    useMap: null,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: MUST_USE_ATTRIBUTE,
	    wmode: MUST_USE_ATTRIBUTE,
	    wrap: null,
	
	    /**
	     * RDFa Properties
	     */
	    about: MUST_USE_ATTRIBUTE,
	    datatype: MUST_USE_ATTRIBUTE,
	    inlist: MUST_USE_ATTRIBUTE,
	    prefix: MUST_USE_ATTRIBUTE,
	    // property is also supported for OpenGraph in meta tags.
	    property: MUST_USE_ATTRIBUTE,
	    resource: MUST_USE_ATTRIBUTE,
	    'typeof': MUST_USE_ATTRIBUTE,
	    vocab: MUST_USE_ATTRIBUTE,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: MUST_USE_ATTRIBUTE,
	    autoCorrect: MUST_USE_ATTRIBUTE,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: null,
	    // color is for Safari mask-icon link
	    color: null,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: MUST_USE_ATTRIBUTE,
	    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    itemType: MUST_USE_ATTRIBUTE,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: MUST_USE_ATTRIBUTE,
	    itemRef: MUST_USE_ATTRIBUTE,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: null,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: MUST_USE_ATTRIBUTE,
	    // IE-only attribute that controls focus behavior
	    unselectable: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {
	    autoComplete: 'autocomplete',
	    autoFocus: 'autofocus',
	    autoPlay: 'autoplay',
	    autoSave: 'autosave',
	    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
	    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
	    encType: 'encoding',
	    hrefLang: 'hreflang',
	    radioGroup: 'radiogroup',
	    spellCheck: 'spellcheck',
	    srcDoc: 'srcdoc',
	    srcSet: 'srcset'
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserComponentMixin
	 */
	
	'use strict';
	
	var ReactInstanceMap = __webpack_require__(48);
	
	var findDOMNode = __webpack_require__(92);
	var warning = __webpack_require__(26);
	
	var didWarnKey = '_getDOMNodeDidWarn';
	
	var ReactBrowserComponentMixin = {
	  /**
	   * Returns the DOM node rendered by this component.
	   *
	   * @return {DOMElement} The root node of this component.
	   * @final
	   * @protected
	   */
	  getDOMNode: function () {
	    process.env.NODE_ENV !== 'production' ? warning(this.constructor[didWarnKey], '%s.getDOMNode(...) is deprecated. Please use ' + 'ReactDOM.findDOMNode(instance) instead.', ReactInstanceMap.get(this).getName() || this.tagName || 'Unknown') : undefined;
	    this.constructor[didWarnKey] = true;
	    return findDOMNode(this);
	  }
	};
	
	module.exports = ReactBrowserComponentMixin;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(6);
	var ReactInstanceMap = __webpack_require__(48);
	var ReactMount = __webpack_require__(29);
	
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(26);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (process.env.NODE_ENV !== 'production') {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing getDOMNode or findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	  if (ReactInstanceMap.has(componentOrElement)) {
	    return ReactMount.getNodeFromInstance(componentOrElement);
	  }
	  !(componentOrElement.render == null || typeof componentOrElement.render !== 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'findDOMNode was called on an unmounted component.') : invariant(false) : undefined;
	   true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : invariant(false) : undefined;
	}
	
	module.exports = findDOMNode;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var ReactUpdates = __webpack_require__(55);
	var Transaction = __webpack_require__(58);
	
	var assign = __webpack_require__(40);
	var emptyFunction = __webpack_require__(16);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 * @typechecks static-only
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var AutoFocusUtils = __webpack_require__(95);
	var CSSPropertyOperations = __webpack_require__(97);
	var DOMProperty = __webpack_require__(24);
	var DOMPropertyOperations = __webpack_require__(23);
	var EventConstants = __webpack_require__(31);
	var ReactBrowserEventEmitter = __webpack_require__(30);
	var ReactComponentBrowserEnvironment = __webpack_require__(27);
	var ReactDOMButton = __webpack_require__(105);
	var ReactDOMInput = __webpack_require__(106);
	var ReactDOMOption = __webpack_require__(110);
	var ReactDOMSelect = __webpack_require__(113);
	var ReactDOMTextarea = __webpack_require__(114);
	var ReactMount = __webpack_require__(29);
	var ReactMultiChild = __webpack_require__(115);
	var ReactPerf = __webpack_require__(19);
	var ReactUpdateQueue = __webpack_require__(54);
	
	var assign = __webpack_require__(40);
	var canDefineProperty = __webpack_require__(44);
	var escapeTextContentForBrowser = __webpack_require__(22);
	var invariant = __webpack_require__(14);
	var isEventSupported = __webpack_require__(41);
	var keyOf = __webpack_require__(80);
	var setInnerHTML = __webpack_require__(20);
	var setTextContent = __webpack_require__(21);
	var shallowEqual = __webpack_require__(118);
	var validateDOMNesting = __webpack_require__(71);
	var warning = __webpack_require__(26);
	
	var deleteListener = ReactBrowserEventEmitter.deleteListener;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var CHILDREN = keyOf({ children: null });
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	
	var ELEMENT_NODE_TYPE = 1;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	var legacyPropsDescriptor;
	if (process.env.NODE_ENV !== 'production') {
	  legacyPropsDescriptor = {
	    props: {
	      enumerable: false,
	      get: function () {
	        var component = this._reactInternalComponent;
	        process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .props of a DOM node; instead, ' + 'recreate the props as `render` did originally or read the DOM ' + 'properties/attributes directly from this node (e.g., ' + 'this.refs.box.className).%s', getDeclarationErrorAddendum(component)) : undefined;
	        return component._currentElement.props;
	      }
	    }
	  };
	}
	
	function legacyGetDOMNode() {
	  if (process.env.NODE_ENV !== 'production') {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .getDOMNode() of a DOM node; ' + 'instead, use the node directly.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return this;
	}
	
	function legacyIsMounted() {
	  var component = this._reactInternalComponent;
	  if (process.env.NODE_ENV !== 'production') {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .isMounted() of a DOM node.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return !!component;
	}
	
	function legacySetStateEtc() {
	  if (process.env.NODE_ENV !== 'production') {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setState(), .replaceState(), or ' + '.forceUpdate() of a DOM node. This is a no-op.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	}
	
	function legacySetProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (process.env.NODE_ENV !== 'production') {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueSetPropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function legacyReplaceProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (process.env.NODE_ENV !== 'production') {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .replaceProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueReplacePropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined becauses undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	  process.env.NODE_ENV !== 'production' ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : undefined;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (process.env.NODE_ENV !== 'production') {
	    if (voidElementTags[component._tag]) {
	      process.env.NODE_ENV !== 'production' ? warning(props.children == null && props.dangerouslySetInnerHTML == null, '%s is a void element tag and must not have `children` or ' + 'use `props.dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : undefined;
	    }
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : invariant(false) : undefined;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ? process.env.NODE_ENV !== 'production' ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' + 'for more information.') : invariant(false) : undefined;
	  }
	  if (process.env.NODE_ENV !== 'production') {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : undefined;
	    process.env.NODE_ENV !== 'production' ? warning(!props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : undefined;
	  }
	  !(props.style == null || typeof props.style === 'object') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'The `style` prop expects a mapping from style properties to values, ' + 'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' + 'using JSX.%s', getDeclarationErrorAddendum(component)) : invariant(false) : undefined;
	}
	
	function enqueuePutListener(id, registrationName, listener, transaction) {
	  if (process.env.NODE_ENV !== 'production') {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : undefined;
	  }
	  var container = ReactMount.findReactContainerForID(id);
	  if (container) {
	    var doc = container.nodeType === ELEMENT_NODE_TYPE ? container.ownerDocument : container;
	    listenTo(registrationName, doc);
	  }
	  transaction.getReactMountReady().enqueue(putListener, {
	    id: id,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  ReactBrowserEventEmitter.putListener(listenerToPut.id, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Must be mounted to trap events') : invariant(false) : undefined;
	  var node = ReactMount.getNode(inst._rootNodeID);
	  !node ? process.env.NODE_ENV !== 'production' ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : invariant(false) : undefined;
	
	  switch (inst._tag) {
	    case 'iframe':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	  }
	}
	
	function mountReadyInputWrapper() {
	  ReactDOMInput.mountReadyWrapper(this);
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special cased tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = ({}).hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Invalid tag: %s', tag) : invariant(false) : undefined;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function processChildContextDev(context, inst) {
	  // Pass down our tag name to child components for validation purposes
	  context = assign({}, context);
	  var info = context[validateDOMNesting.ancestorInfoContextKey];
	  context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(info, inst._tag, inst);
	  return context;
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(tag) {
	  validateDangerousTag(tag);
	  this._tag = tag.toLowerCase();
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._rootNodeID = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._nodeWithLegacyProperties = null;
	  if (process.env.NODE_ENV !== 'production') {
	    this._unprocessedContextDev = null;
	    this._processedContextDev = null;
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  construct: function (element) {
	    this._currentElement = element;
	  },
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {string} rootID The root DOM ID for this node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._rootNodeID = rootID;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getNativeProps(this, props, context);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, context);
	        props = ReactDOMInput.getNativeProps(this, props, context);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, context);
	        props = ReactDOMOption.getNativeProps(this, props, context);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, context);
	        props = ReactDOMSelect.getNativeProps(this, props, context);
	        context = ReactDOMSelect.processChildContext(this, props, context);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, context);
	        props = ReactDOMTextarea.getNativeProps(this, props, context);
	        break;
	    }
	
	    assertValidProps(this, props);
	    if (process.env.NODE_ENV !== 'production') {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting(this._tag, this, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      this._unprocessedContextDev = context;
	      this._processedContextDev = processChildContextDev(context, this);
	      context = this._processedContextDev;
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement(this._currentElement.type);
	      DOMPropertyOperations.setAttributeForID(el, this._rootNodeID);
	      // Populate node cache
	      ReactMount.getID(el);
	      this._updateDOMProperties({}, props, transaction, el);
	      this._createInitialChildren(transaction, props, context, el);
	      mountImage = el;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(mountReadyInputWrapper, this);
	      // falls through
	      case 'button':
	      case 'select':
	      case 'textarea':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this._rootNodeID, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (process.env.NODE_ENV !== 'production') {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (propKey !== CHILDREN) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
	    return ret + ' ' + markupForID;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, el) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        setInnerHTML(el, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        setTextContent(el, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          el.appendChild(mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getNativeProps(this, lastProps);
	        nextProps = ReactDOMButton.getNativeProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getNativeProps(this, lastProps);
	        nextProps = ReactDOMInput.getNativeProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getNativeProps(this, lastProps);
	        nextProps = ReactDOMOption.getNativeProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getNativeProps(this, lastProps);
	        nextProps = ReactDOMSelect.getNativeProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getNativeProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getNativeProps(this, nextProps);
	        break;
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      // If the context is reference-equal to the old one, pass down the same
	      // processed object so the update bailout in ReactReconciler behaves
	      // correctly (and identically in dev and prod). See #5005.
	      if (this._unprocessedContextDev !== context) {
	        this._unprocessedContextDev = context;
	        this._processedContextDev = processChildContextDev(context, this);
	      }
	      context = this._processedContextDev;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction, null);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (!canDefineProperty && this._nodeWithLegacyProperties) {
	      this._nodeWithLegacyProperties.props = nextProps;
	    }
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction, node) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey)) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        DOMPropertyOperations.deleteValueForProperty(node, propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps[propKey];
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (process.env.NODE_ENV !== 'production') {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this._rootNodeID, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        if (propKey === CHILDREN) {
	          nextProp = null;
	        }
	        DOMPropertyOperations.setValueForAttribute(node, propKey, nextProp);
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertantly setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      if (!node) {
	        node = ReactMount.getNode(this._rootNodeID);
	      }
	      CSSPropertyOperations.setValueForStyles(node, styleUpdates);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function () {
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	        ReactDOMInput.unmountWrapper(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ? process.env.NODE_ENV !== 'production' ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is ' + 'impossible to unmount some top-level components (eg <html>, ' + '<head>, and <body>) reliably and efficiently. To fix this, have a ' + 'single top-level component that never unmounts render these ' + 'elements.', this._tag) : invariant(false) : undefined;
	        break;
	    }
	
	    this.unmountChildren();
	    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._wrapperState = null;
	    if (this._nodeWithLegacyProperties) {
	      var node = this._nodeWithLegacyProperties;
	      node._reactInternalComponent = null;
	      this._nodeWithLegacyProperties = null;
	    }
	  },
	
	  getPublicInstance: function () {
	    if (!this._nodeWithLegacyProperties) {
	      var node = ReactMount.getNode(this._rootNodeID);
	
	      node._reactInternalComponent = this;
	      node.getDOMNode = legacyGetDOMNode;
	      node.isMounted = legacyIsMounted;
	      node.setState = legacySetStateEtc;
	      node.replaceState = legacySetStateEtc;
	      node.forceUpdate = legacySetStateEtc;
	      node.setProps = legacySetProps;
	      node.replaceProps = legacyReplaceProps;
	
	      if (process.env.NODE_ENV !== 'production') {
	        if (canDefineProperty) {
	          Object.defineProperties(node, legacyPropsDescriptor);
	        } else {
	          // updateComponent will update this property on subsequent renders
	          node.props = this._currentElement.props;
	        }
	      } else {
	        // updateComponent will update this property on subsequent renders
	        node.props = this._currentElement.props;
	      }
	
	      this._nodeWithLegacyProperties = node;
	    }
	    return this._nodeWithLegacyProperties;
	  }
	
	};
	
	ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent'
	});
	
	assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(29);
	
	var findDOMNode = __webpack_require__(92);
	var focusNode = __webpack_require__(96);
	
	var Mixin = {
	  componentDidMount: function () {
	    if (this.props.autoFocus) {
	      focusNode(findDOMNode(this));
	    }
	  }
	};
	
	var AutoFocusUtils = {
	  Mixin: Mixin,
	
	  focusDOMComponent: function () {
	    focusNode(ReactMount.getNode(this._rootNodeID));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 96 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule focusNode
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(98);
	var ExecutionEnvironment = __webpack_require__(10);
	var ReactPerf = __webpack_require__(19);
	
	var camelizeStyleName = __webpack_require__(99);
	var dangerousStyleValue = __webpack_require__(101);
	var hyphenateStyleName = __webpack_require__(102);
	var memoizeStringOnly = __webpack_require__(104);
	var warning = __webpack_require__(26);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (process.env.NODE_ENV !== 'production') {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	
	  var warnHyphenatedStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?', name, camelizeStyleName(name)) : undefined;
	  };
	
	  var warnBadVendoredStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1)) : undefined;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon. ' + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, '')) : undefined;
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   */
	  var warnValidStyle = function (name, value) {
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (process.env.NODE_ENV !== 'production') {
	        warnValidStyle(styleName, styleValue);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   */
	  setValueForStyles: function (node, styles) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (process.env.NODE_ENV !== 'production') {
	        warnValidStyle(styleName, styles[styleName]);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
	      if (styleName === 'float') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(CSSPropertyOperations, 'CSSPropertyOperations', {
	  setValueForStyles: 'setValueForStyles'
	});
	
	module.exports = CSSPropertyOperations;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 98 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelizeStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(100);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 100 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelize
	 * @typechecks
	 */
	
	"use strict";
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(98);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenateStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(103);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 103 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenate
	 * @typechecks
	 */
	
	'use strict';
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 104 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule memoizeStringOnly
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 *
	 * @param {function} callback
	 * @return {function}
	 */
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 105 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var mouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getNativeProps: function (inst, props, context) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var nativeProps = {};
	    for (var key in props) {
	      if (props.hasOwnProperty(key) && !mouseListenerNames[key]) {
	        nativeProps[key] = props[key];
	      }
	    }
	
	    return nativeProps;
	  }
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(28);
	var LinkedValueUtils = __webpack_require__(107);
	var ReactMount = __webpack_require__(29);
	var ReactUpdates = __webpack_require__(55);
	
	var assign = __webpack_require__(40);
	var invariant = __webpack_require__(14);
	
	var instancesByReactID = {};
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getNativeProps: function (inst, props, context) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var nativeProps = assign({}, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (process.env.NODE_ENV !== 'production') {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  mountReadyWrapper: function (inst) {
	    // Can't be in mountWrapper or else server rendering leaks.
	    instancesByReactID[inst._rootNodeID] = inst;
	  },
	
	  unmountWrapper: function (inst) {
	    delete instancesByReactID[inst._rootNodeID];
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'checked', checked || false);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactMount.getNode(this._rootNodeID);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React with non-React.
	      var otherID = ReactMount.getID(otherNode);
	      !otherID ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.') : invariant(false) : undefined;
	      var otherInstance = instancesByReactID[otherID];
	      !otherInstance ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactDOMInput: Unknown radio button ID %s.', otherID) : invariant(false) : undefined;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactPropTypes = __webpack_require__(108);
	var ReactPropTypeLocations = __webpack_require__(66);
	
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(26);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use ' + 'checkedLink, you probably don\'t want to use valueLink and vice versa.') : invariant(false) : undefined;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want ' + 'to use value or onChange, you probably don\'t want to use valueLink.') : invariant(false) : undefined;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. ' + 'If you want to use checked or onChange, you probably don\'t want to ' + 'use checkedLink') : invariant(false) : undefined;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(43);
	var ReactPropTypeLocationNames = __webpack_require__(67);
	
	var emptyFunction = __webpack_require__(16);
	var getIteratorFn = __webpack_require__(109);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']');
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (propValue === expectedValues[i]) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return '<<anonymous>>';
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 109 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/* global Symbol */
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(111);
	var ReactDOMSelect = __webpack_require__(113);
	
	var assign = __webpack_require__(40);
	var warning = __webpack_require__(26);
	
	var valueContextKey = ReactDOMSelect.valueContextKey;
	
	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, context) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (process.env.NODE_ENV !== 'production') {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : undefined;
	    }
	
	    // Look up whether this option is 'selected' via context
	    var selectValue = context[valueContextKey];
	
	    // If context key is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === '' + props.value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === '' + props.value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  getNativeProps: function (inst, props, context) {
	    var nativeProps = assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      nativeProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = '';
	
	    // Flatten children and warn if they aren't strings or numbers;
	    // invalid types are ignored.
	    ReactChildren.forEach(props.children, function (child) {
	      if (child == null) {
	        return;
	      }
	      if (typeof child === 'string' || typeof child === 'number') {
	        content += child;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Only strings and numbers are supported as <option> children.') : undefined;
	      }
	    });
	
	    nativeProps.children = content;
	    return nativeProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(57);
	var ReactElement = __webpack_require__(43);
	
	var emptyFunction = __webpack_require__(16);
	var traverseAllChildren = __webpack_require__(112);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/(?!\/)/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '//');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild !== child ? escapeUserProvidedKey(mappedChild.key || '') + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(6);
	var ReactElement = __webpack_require__(43);
	var ReactInstanceHandles = __webpack_require__(46);
	
	var getIteratorFn = __webpack_require__(109);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(26);
	
	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var userProvidedKeyEscaperLookup = {
	  '=': '=0',
	  '.': '=1',
	  ':': '=2'
	};
	
	var userProvidedKeyEscapeRegex = /[=.:]/g;
	
	var didWarnAboutMaps = false;
	
	function userProvidedKeyEscaper(match) {
	  return userProvidedKeyEscaperLookup[match];
	}
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  if (component && component.key != null) {
	    // Explicit key
	    return wrapUserProvidedKey(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * Escape a component key so that it is safe to use in a reactid.
	 *
	 * @param {*} text Component key to be escaped.
	 * @return {string} An escaped string.
	 */
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, userProvidedKeyEscaper);
	}
	
	/**
	 * Wrap a `key` value explicitly provided by the user to distinguish it from
	 * implicitly-generated keys generated by a component's index in its parent.
	 *
	 * @param {string} key Value of a user-provided `key` attribute
	 * @return {string}
	 */
	function wrapUserProvidedKey(key) {
	  return '$' + escapeUserProvidedKey(key);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (process.env.NODE_ENV !== 'production') {
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : undefined;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + wrapUserProvidedKey(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (process.env.NODE_ENV !== 'production') {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : invariant(false) : undefined;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(107);
	var ReactMount = __webpack_require__(29);
	var ReactUpdates = __webpack_require__(55);
	
	var assign = __webpack_require__(40);
	var warning = __webpack_require__(26);
	
	var valueContextKey = '__ReactDOMSelect_value$' + Math.random().toString(36).slice(2);
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	      process.env.NODE_ENV !== 'production' ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    } else {
	      process.env.NODE_ENV !== 'production' ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactMount.getNode(inst._rootNodeID).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  valueContextKey: valueContextKey,
	
	  getNativeProps: function (inst, props, context) {
	    return assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (process.env.NODE_ENV !== 'production') {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	  },
	
	  processChildContext: function (inst, props, context) {
	    // Pass down initial value so initial generated markup has correct
	    // `selected` attributes
	    var childContext = assign({}, context);
	    childContext[valueContextKey] = inst._wrapperState.initialValue;
	    return childContext;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // the context value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  this._wrapperState.pendingUpdate = true;
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(107);
	var ReactDOMIDOperations = __webpack_require__(28);
	var ReactUpdates = __webpack_require__(55);
	
	var assign = __webpack_require__(40);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(26);
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getNativeProps: function (inst, props, context) {
	    !(props.dangerouslySetInnerHTML == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : invariant(false) : undefined;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    var nativeProps = assign({}, props, {
	      defaultValue: undefined,
	      value: undefined,
	      children: inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (process.env.NODE_ENV !== 'production') {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = props.children;
	    if (children != null) {
	      if (process.env.NODE_ENV !== 'production') {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : undefined;
	      }
	      !(defaultValue == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : invariant(false) : undefined;
	      if (Array.isArray(children)) {
	        !(children.length <= 1) ? process.env.NODE_ENV !== 'production' ? invariant(false, '<textarea> can only have at most one child.') : invariant(false) : undefined;
	        children = children[0];
	      }
	
	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(props);
	
	    inst._wrapperState = {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue),
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(65);
	var ReactMultiChildUpdateTypes = __webpack_require__(17);
	
	var ReactCurrentOwner = __webpack_require__(6);
	var ReactReconciler = __webpack_require__(51);
	var ReactChildReconciler = __webpack_require__(116);
	
	var flattenChildren = __webpack_require__(117);
	
	/**
	 * Updating children of a component may trigger recursive updates. The depth is
	 * used to batch recursive updates to render markup more efficiently.
	 *
	 * @type {number}
	 * @private
	 */
	var updateDepth = 0;
	
	/**
	 * Queue of update configuration objects.
	 *
	 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
	 *
	 * @type {array<object>}
	 * @private
	 */
	var updateQueue = [];
	
	/**
	 * Queue of markup to be rendered.
	 *
	 * @type {array<string>}
	 * @private
	 */
	var markupQueue = [];
	
	/**
	 * Enqueues markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function enqueueInsertMarkup(parentID, markup, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    markupIndex: markupQueue.push(markup) - 1,
	    content: null,
	    fromIndex: null,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues moving an existing element to another index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function enqueueMove(parentID, fromIndex, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues removing an element at an index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function enqueueRemove(parentID, fromIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the markup of a node.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function enqueueSetMarkup(parentID, markup) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    markupIndex: null,
	    content: markup,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the text content.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function enqueueTextContent(parentID, textContent) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    markupIndex: null,
	    content: textContent,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue() {
	  if (updateQueue.length) {
	    ReactComponentEnvironment.processChildrenUpdates(updateQueue, markupQueue);
	    clearQueue();
	  }
	}
	
	/**
	 * Clears any enqueued updates.
	 *
	 * @private
	 */
	function clearQueue() {
	  updateQueue.length = 0;
	  markupQueue.length = 0;
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, transaction, context) {
	      var nextChildren;
	      if (process.env.NODE_ENV !== 'production') {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	          var rootID = this._rootNodeID + name;
	          var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        // TODO: The setTextContent operation should be enough
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChild(prevChildren[name]);
	          }
	        }
	        // Set new text content.
	        this.setTextContent(nextContent);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChildByName(prevChildren[name], name);
	          }
	        }
	        this.setMarkup(nextMarkup);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        this._updateChildren(nextNestedChildrenElements, transaction, context);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Improve performance by isolating this hot code path from the try/catch
	     * block in `updateChildren`.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, transaction, context);
	      this._renderedChildren = nextChildren;
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          this.moveChild(prevChild, nextIndex, lastIndex);
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            this._unmountChild(prevChild);
	          }
	          // The child must be instantiated before it's mounted.
	          this._mountChildByNameAtIndex(nextChild, name, nextIndex, transaction, context);
	        }
	        nextIndex++;
	      }
	      // Remove children that are no longer present.
	      for (name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	          this._unmountChild(prevChildren[name]);
	        }
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted.
	     *
	     * @internal
	     */
	    unmountChildren: function () {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, mountImage) {
	      enqueueInsertMarkup(this._rootNodeID, mountImage, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child) {
	      enqueueRemove(this._rootNodeID, child._mountIndex);
	    },
	
	    /**
	     * Sets this text content string.
	     *
	     * @param {string} textContent Text content to set.
	     * @protected
	     */
	    setTextContent: function (textContent) {
	      enqueueTextContent(this._rootNodeID, textContent);
	    },
	
	    /**
	     * Sets this markup string.
	     *
	     * @param {string} markup Markup to set.
	     * @protected
	     */
	    setMarkup: function (markup) {
	      enqueueSetMarkup(this._rootNodeID, markup);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildByNameAtIndex: function (child, name, index, transaction, context) {
	      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	      var rootID = this._rootNodeID + name;
	      var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	      child._mountIndex = index;
	      this.createChild(child, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child) {
	      this.removeChild(child);
	      child._mountIndex = null;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(51);
	
	var instantiateReactComponent = __webpack_require__(63);
	var shouldUpdateReactComponent = __webpack_require__(68);
	var traverseAllChildren = __webpack_require__(112);
	var warning = __webpack_require__(26);
	
	function instantiateChild(childInstances, child, name) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (process.env.NODE_ENV !== 'production') {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, null);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	    traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, transaction, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return null;
	    }
	    var name;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      var prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          ReactReconciler.unmountComponent(prevChild, name);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, null);
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        ReactReconciler.unmountComponent(prevChildren[name]);
	      }
	    }
	    return nextChildren;
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */
	
	'use strict';
	
	var traverseAllChildren = __webpack_require__(112);
	var warning = __webpack_require__(26);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = result[name] === undefined;
	  if (process.env.NODE_ENV !== 'production') {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 118 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventListener = __webpack_require__(120);
	var ExecutionEnvironment = __webpack_require__(10);
	var PooledClass = __webpack_require__(57);
	var ReactInstanceHandles = __webpack_require__(46);
	var ReactMount = __webpack_require__(29);
	var ReactUpdates = __webpack_require__(55);
	
	var assign = __webpack_require__(40);
	var getEventTarget = __webpack_require__(82);
	var getUnboundedScrollPosition = __webpack_require__(121);
	
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * Finds the parent React component of `node`.
	 *
	 * @param {*} node
	 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
	 *                           is not nested.
	 */
	function findParent(node) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  var nodeID = ReactMount.getID(node);
	  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	  var container = ReactMount.findReactContainerForID(rootID);
	  var parent = ReactMount.getFirstReactDOM(container);
	  return parent;
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  // TODO: Re-enable event.path handling
	  //
	  // if (bookKeeping.nativeEvent.path && bookKeeping.nativeEvent.path.length > 1) {
	  //   // New browsers have a path attribute on native events
	  //   handleTopLevelWithPath(bookKeeping);
	  // } else {
	  //   // Legacy browsers don't have a path attribute on native events
	  //   handleTopLevelWithoutPath(bookKeeping);
	  // }
	
	  void handleTopLevelWithPath; // temporarily unused
	  handleTopLevelWithoutPath(bookKeeping);
	}
	
	// Legacy browsers don't have a path attribute on native events
	function handleTopLevelWithoutPath(bookKeeping) {
	  var topLevelTarget = ReactMount.getFirstReactDOM(getEventTarget(bookKeeping.nativeEvent)) || window;
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = topLevelTarget;
	  while (ancestor) {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = findParent(ancestor);
	  }
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    topLevelTarget = bookKeeping.ancestors[i];
	    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, topLevelTarget, topLevelTargetID, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	// New browsers have a path attribute on native events
	function handleTopLevelWithPath(bookKeeping) {
	  var path = bookKeeping.nativeEvent.path;
	  var currentNativeTarget = path[0];
	  var eventsFired = 0;
	  for (var i = 0; i < path.length; i++) {
	    var currentPathElement = path[i];
	    if (currentPathElement.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE) {
	      currentNativeTarget = path[i + 1];
	    }
	    // TODO: slow
	    var reactParent = ReactMount.getFirstReactDOM(currentPathElement);
	    if (reactParent === currentPathElement) {
	      var currentPathElementID = ReactMount.getID(currentPathElement);
	      var newRootID = ReactInstanceHandles.getReactRootIDFromNodeID(currentPathElementID);
	      bookKeeping.ancestors.push(currentPathElement);
	
	      var topLevelTargetID = ReactMount.getID(currentPathElement) || '';
	      eventsFired++;
	      ReactEventListener._handleTopLevel(bookKeeping.topLevelType, currentPathElement, topLevelTargetID, bookKeeping.nativeEvent, currentNativeTarget);
	
	      // Jump to the root of this React render tree
	      while (currentPathElementID !== newRootID) {
	        i++;
	        currentPathElement = path[i];
	        currentPathElementID = ReactMount.getID(currentPathElement);
	      }
	    }
	  }
	  if (eventsFired === 0) {
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, window, '', bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventListener
	 * @typechecks
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(16);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function () {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (process.env.NODE_ENV !== 'production') {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function () {}
	};
	
	module.exports = EventListener;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 121 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUnboundedScrollPosition
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(24);
	var EventPluginHub = __webpack_require__(32);
	var ReactComponentEnvironment = __webpack_require__(65);
	var ReactClass = __webpack_require__(123);
	var ReactEmptyComponent = __webpack_require__(69);
	var ReactBrowserEventEmitter = __webpack_require__(30);
	var ReactNativeComponent = __webpack_require__(70);
	var ReactPerf = __webpack_require__(19);
	var ReactRootIndex = __webpack_require__(47);
	var ReactUpdates = __webpack_require__(55);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Perf: ReactPerf.injection,
	  RootIndex: ReactRootIndex.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var ReactComponent = __webpack_require__(124);
	var ReactElement = __webpack_require__(43);
	var ReactPropTypeLocations = __webpack_require__(66);
	var ReactPropTypeLocationNames = __webpack_require__(67);
	var ReactNoopUpdateQueue = __webpack_require__(125);
	
	var assign = __webpack_require__(40);
	var emptyObject = __webpack_require__(59);
	var invariant = __webpack_require__(14);
	var keyMirror = __webpack_require__(18);
	var keyOf = __webpack_require__(80);
	var warning = __webpack_require__(26);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	var warnedSetProps = false;
	function warnSetProps() {
	  if (!warnedSetProps) {
	    warnedSetProps = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'setProps(...) and replaceProps(...) are deprecated. ' + 'Instead, call render again at the top level.') : undefined;
	  }
	}
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (process.env.NODE_ENV !== 'production') {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (process.env.NODE_ENV !== 'production') {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (process.env.NODE_ENV !== 'production') {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but not in __DEV__
	      process.env.NODE_ENV !== 'production' ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : undefined;
	    }
	  }
	}
	
	function validateMethodOverride(proto, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name) : invariant(false) : undefined;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (proto.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classses.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  !(typeof spec !== 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component class as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	  !!ReactElement.isValidElement(spec) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	
	  var proto = Constructor.prototype;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    validateMethodOverride(proto, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        if (!proto.__reactAutoBindMap) {
	          proto.__reactAutoBindMap = {};
	        }
	        proto.__reactAutoBindMap[name] = property;
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name) : invariant(false) : undefined;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (process.env.NODE_ENV !== 'production') {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = (name in RESERVED_SPEC_KEYS);
	    !!isReserved ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name) : invariant(false) : undefined;
	
	    var isInherited = (name in Constructor);
	    !!isInherited ? process.env.NODE_ENV !== 'production' ? invariant(false, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name) : invariant(false) : undefined;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ? process.env.NODE_ENV !== 'production' ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : invariant(false) : undefined;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key) : invariant(false) : undefined;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (process.env.NODE_ENV !== 'production') {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    /* eslint-disable block-scoped-var, no-undef */
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : undefined;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : undefined;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	      /* eslint-enable */
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  for (var autoBindKey in component.__reactAutoBindMap) {
	    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	      var method = component.__reactAutoBindMap[autoBindKey];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  setProps: function (partialProps, callback) {
	    if (process.env.NODE_ENV !== 'production') {
	      warnSetProps();
	    }
	    this.updater.enqueueSetProps(this, partialProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Replace all the props.
	   *
	   * @param {object} newProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  replaceProps: function (newProps, callback) {
	    if (process.env.NODE_ENV !== 'production') {
	      warnSetProps();
	    }
	    this.updater.enqueueReplaceProps(this, newProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  }
	};
	
	var ReactClassComponent = function () {};
	assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor is overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (process.env.NODE_ENV !== 'production') {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : undefined;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindMap) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (process.env.NODE_ENV !== 'production') {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (typeof initialState === 'undefined' && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ? process.env.NODE_ENV !== 'production' ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : invariant(false) : undefined;
	
	    if (process.env.NODE_ENV !== 'production') {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : undefined;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var ReactNoopUpdateQueue = __webpack_require__(125);
	
	var canDefineProperty = __webpack_require__(44);
	var emptyObject = __webpack_require__(59);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(26);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.') : invariant(false) : undefined;
	  if (process.env.NODE_ENV !== 'production') {
	    process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : undefined;
	  }
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (process.env.NODE_ENV !== 'production') {
	  var deprecatedAPIs = {
	    getDOMNode: ['getDOMNode', 'Use ReactDOM.findDOMNode(component) instead.'],
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceProps: ['replaceProps', 'Instead, call render again at the top level.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).'],
	    setProps: ['setProps', 'Instead, call render again at the top level.']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : undefined;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(26);
	
	function warnTDZ(publicInstance, callerName) {
	  if (process.env.NODE_ENV !== 'production') {
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor && publicInstance.constructor.displayName || '') : undefined;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnTDZ(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnTDZ(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnTDZ(publicInstance, 'setState');
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    warnTDZ(publicInstance, 'setProps');
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    warnTDZ(publicInstance, 'replaceProps');
	  }
	
	};
	
	module.exports = ReactNoopUpdateQueue;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(56);
	var PooledClass = __webpack_require__(57);
	var ReactBrowserEventEmitter = __webpack_require__(30);
	var ReactDOMFeatureFlags = __webpack_require__(42);
	var ReactInputSelection = __webpack_require__(127);
	var Transaction = __webpack_require__(58);
	
	var assign = __webpack_require__(40);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(forceHTML) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = !forceHTML && ReactDOMFeatureFlags.useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(128);
	
	var containsNode = __webpack_require__(60);
	var focusNode = __webpack_require__(96);
	var getActiveElement = __webpack_require__(130);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (typeof end === 'undefined') {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	var getNodeForCharacterOffset = __webpack_require__(129);
	var getTextContentAccessor = __webpack_require__(76);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (typeof offsets.end === 'undefined') {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = typeof offsets.end === 'undefined' ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 129 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 130 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getActiveElement
	 * @typechecks
	 */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not yet defined.
	 */
	'use strict';
	
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(31);
	var EventPropagators = __webpack_require__(74);
	var ExecutionEnvironment = __webpack_require__(10);
	var ReactInputSelection = __webpack_require__(127);
	var SyntheticEvent = __webpack_require__(78);
	
	var getActiveElement = __webpack_require__(130);
	var isTextInputElement = __webpack_require__(83);
	var keyOf = __webpack_require__(80);
	var shallowEqual = __webpack_require__(118);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementID = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementID, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(topLevelTarget) || topLevelTarget.contentEditable === 'true') {
	          activeElement = topLevelTarget;
	          activeElementID = topLevelTargetID;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementID = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 132 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ServerReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Size of the reactRoot ID space. We generate random numbers for React root
	 * IDs and if there's a collision the events and DOM update system will
	 * get confused. In the future we need a way to generate GUIDs but for
	 * now this will work on a smaller scale.
	 */
	var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);
	
	var ServerReactRootIndex = {
	  createReactRootIndex: function () {
	    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
	  }
	};
	
	module.exports = ServerReactRootIndex;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(31);
	var EventListener = __webpack_require__(120);
	var EventPropagators = __webpack_require__(74);
	var ReactMount = __webpack_require__(29);
	var SyntheticClipboardEvent = __webpack_require__(134);
	var SyntheticEvent = __webpack_require__(78);
	var SyntheticFocusEvent = __webpack_require__(135);
	var SyntheticKeyboardEvent = __webpack_require__(136);
	var SyntheticMouseEvent = __webpack_require__(87);
	var SyntheticDragEvent = __webpack_require__(139);
	var SyntheticTouchEvent = __webpack_require__(140);
	var SyntheticUIEvent = __webpack_require__(88);
	var SyntheticWheelEvent = __webpack_require__(141);
	
	var emptyFunction = __webpack_require__(16);
	var getEventCharCode = __webpack_require__(137);
	var invariant = __webpack_require__(14);
	var keyOf = __webpack_require__(80);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // FireFox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ? process.env.NODE_ENV !== 'production' ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : invariant(false) : undefined;
	    var event = EventConstructor.getPooled(dispatchConfig, topLevelTargetID, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var node = ReactMount.getNode(id);
	      if (!onClickListeners[id]) {
	        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (id, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      onClickListeners[id].remove();
	      delete onClickListeners[id];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(78);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(88);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(88);
	
	var getEventCharCode = __webpack_require__(137);
	var getEventKey = __webpack_require__(138);
	var getEventModifierState = __webpack_require__(89);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 137 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(137);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(87);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(88);
	
	var getEventModifierState = __webpack_require__(89);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(87);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(24);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {
	    clipPath: MUST_USE_ATTRIBUTE,
	    cx: MUST_USE_ATTRIBUTE,
	    cy: MUST_USE_ATTRIBUTE,
	    d: MUST_USE_ATTRIBUTE,
	    dx: MUST_USE_ATTRIBUTE,
	    dy: MUST_USE_ATTRIBUTE,
	    fill: MUST_USE_ATTRIBUTE,
	    fillOpacity: MUST_USE_ATTRIBUTE,
	    fontFamily: MUST_USE_ATTRIBUTE,
	    fontSize: MUST_USE_ATTRIBUTE,
	    fx: MUST_USE_ATTRIBUTE,
	    fy: MUST_USE_ATTRIBUTE,
	    gradientTransform: MUST_USE_ATTRIBUTE,
	    gradientUnits: MUST_USE_ATTRIBUTE,
	    markerEnd: MUST_USE_ATTRIBUTE,
	    markerMid: MUST_USE_ATTRIBUTE,
	    markerStart: MUST_USE_ATTRIBUTE,
	    offset: MUST_USE_ATTRIBUTE,
	    opacity: MUST_USE_ATTRIBUTE,
	    patternContentUnits: MUST_USE_ATTRIBUTE,
	    patternUnits: MUST_USE_ATTRIBUTE,
	    points: MUST_USE_ATTRIBUTE,
	    preserveAspectRatio: MUST_USE_ATTRIBUTE,
	    r: MUST_USE_ATTRIBUTE,
	    rx: MUST_USE_ATTRIBUTE,
	    ry: MUST_USE_ATTRIBUTE,
	    spreadMethod: MUST_USE_ATTRIBUTE,
	    stopColor: MUST_USE_ATTRIBUTE,
	    stopOpacity: MUST_USE_ATTRIBUTE,
	    stroke: MUST_USE_ATTRIBUTE,
	    strokeDasharray: MUST_USE_ATTRIBUTE,
	    strokeLinecap: MUST_USE_ATTRIBUTE,
	    strokeOpacity: MUST_USE_ATTRIBUTE,
	    strokeWidth: MUST_USE_ATTRIBUTE,
	    textAnchor: MUST_USE_ATTRIBUTE,
	    transform: MUST_USE_ATTRIBUTE,
	    version: MUST_USE_ATTRIBUTE,
	    viewBox: MUST_USE_ATTRIBUTE,
	    x1: MUST_USE_ATTRIBUTE,
	    x2: MUST_USE_ATTRIBUTE,
	    x: MUST_USE_ATTRIBUTE,
	    xlinkActuate: MUST_USE_ATTRIBUTE,
	    xlinkArcrole: MUST_USE_ATTRIBUTE,
	    xlinkHref: MUST_USE_ATTRIBUTE,
	    xlinkRole: MUST_USE_ATTRIBUTE,
	    xlinkShow: MUST_USE_ATTRIBUTE,
	    xlinkTitle: MUST_USE_ATTRIBUTE,
	    xlinkType: MUST_USE_ATTRIBUTE,
	    xmlBase: MUST_USE_ATTRIBUTE,
	    xmlLang: MUST_USE_ATTRIBUTE,
	    xmlSpace: MUST_USE_ATTRIBUTE,
	    y1: MUST_USE_ATTRIBUTE,
	    y2: MUST_USE_ATTRIBUTE,
	    y: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {
	    clipPath: 'clip-path',
	    fillOpacity: 'fill-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    gradientTransform: 'gradientTransform',
	    gradientUnits: 'gradientUnits',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    patternContentUnits: 'patternContentUnits',
	    patternUnits: 'patternUnits',
	    preserveAspectRatio: 'preserveAspectRatio',
	    spreadMethod: 'spreadMethod',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strokeDasharray: 'stroke-dasharray',
	    strokeLinecap: 'stroke-linecap',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    viewBox: 'viewBox',
	    xlinkActuate: 'xlink:actuate',
	    xlinkArcrole: 'xlink:arcrole',
	    xlinkHref: 'xlink:href',
	    xlinkRole: 'xlink:role',
	    xlinkShow: 'xlink:show',
	    xlinkTitle: 'xlink:title',
	    xlinkType: 'xlink:type',
	    xmlBase: 'xml:base',
	    xmlLang: 'xml:lang',
	    xmlSpace: 'xml:space'
	  }
	};
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultPerf
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(24);
	var ReactDefaultPerfAnalysis = __webpack_require__(144);
	var ReactMount = __webpack_require__(29);
	var ReactPerf = __webpack_require__(19);
	
	var performanceNow = __webpack_require__(145);
	
	function roundFloat(val) {
	  return Math.floor(val * 100) / 100;
	}
	
	function addValue(obj, key, val) {
	  obj[key] = (obj[key] || 0) + val;
	}
	
	var ReactDefaultPerf = {
	  _allMeasurements: [], // last item in the list is the current one
	  _mountStack: [0],
	  _injected: false,
	
	  start: function () {
	    if (!ReactDefaultPerf._injected) {
	      ReactPerf.injection.injectMeasure(ReactDefaultPerf.measure);
	    }
	
	    ReactDefaultPerf._allMeasurements.length = 0;
	    ReactPerf.enableMeasure = true;
	  },
	
	  stop: function () {
	    ReactPerf.enableMeasure = false;
	  },
	
	  getLastMeasurements: function () {
	    return ReactDefaultPerf._allMeasurements;
	  },
	
	  printExclusive: function (measurements) {
	    measurements = measurements || ReactDefaultPerf._allMeasurements;
	    var summary = ReactDefaultPerfAnalysis.getExclusiveSummary(measurements);
	    console.table(summary.map(function (item) {
	      return {
	        'Component class name': item.componentName,
	        'Total inclusive time (ms)': roundFloat(item.inclusive),
	        'Exclusive mount time (ms)': roundFloat(item.exclusive),
	        'Exclusive render time (ms)': roundFloat(item.render),
	        'Mount time per instance (ms)': roundFloat(item.exclusive / item.count),
	        'Render time per instance (ms)': roundFloat(item.render / item.count),
	        'Instances': item.count
	      };
	    }));
	    // TODO: ReactDefaultPerfAnalysis.getTotalTime() does not return the correct
	    // number.
	  },
	
	  printInclusive: function (measurements) {
	    measurements = measurements || ReactDefaultPerf._allMeasurements;
	    var summary = ReactDefaultPerfAnalysis.getInclusiveSummary(measurements);
	    console.table(summary.map(function (item) {
	      return {
	        'Owner > component': item.componentName,
	        'Inclusive time (ms)': roundFloat(item.time),
	        'Instances': item.count
	      };
	    }));
	    console.log('Total time:', ReactDefaultPerfAnalysis.getTotalTime(measurements).toFixed(2) + ' ms');
	  },
	
	  getMeasurementsSummaryMap: function (measurements) {
	    var summary = ReactDefaultPerfAnalysis.getInclusiveSummary(measurements, true);
	    return summary.map(function (item) {
	      return {
	        'Owner > component': item.componentName,
	        'Wasted time (ms)': item.time,
	        'Instances': item.count
	      };
	    });
	  },
	
	  printWasted: function (measurements) {
	    measurements = measurements || ReactDefaultPerf._allMeasurements;
	    console.table(ReactDefaultPerf.getMeasurementsSummaryMap(measurements));
	    console.log('Total time:', ReactDefaultPerfAnalysis.getTotalTime(measurements).toFixed(2) + ' ms');
	  },
	
	  printDOM: function (measurements) {
	    measurements = measurements || ReactDefaultPerf._allMeasurements;
	    var summary = ReactDefaultPerfAnalysis.getDOMSummary(measurements);
	    console.table(summary.map(function (item) {
	      var result = {};
	      result[DOMProperty.ID_ATTRIBUTE_NAME] = item.id;
	      result.type = item.type;
	      result.args = JSON.stringify(item.args);
	      return result;
	    }));
	    console.log('Total time:', ReactDefaultPerfAnalysis.getTotalTime(measurements).toFixed(2) + ' ms');
	  },
	
	  _recordWrite: function (id, fnName, totalTime, args) {
	    // TODO: totalTime isn't that useful since it doesn't count paints/reflows
	    var writes = ReactDefaultPerf._allMeasurements[ReactDefaultPerf._allMeasurements.length - 1].writes;
	    writes[id] = writes[id] || [];
	    writes[id].push({
	      type: fnName,
	      time: totalTime,
	      args: args
	    });
	  },
	
	  measure: function (moduleName, fnName, func) {
	    return function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var totalTime;
	      var rv;
	      var start;
	
	      if (fnName === '_renderNewRootComponent' || fnName === 'flushBatchedUpdates') {
	        // A "measurement" is a set of metrics recorded for each flush. We want
	        // to group the metrics for a given flush together so we can look at the
	        // components that rendered and the DOM operations that actually
	        // happened to determine the amount of "wasted work" performed.
	        ReactDefaultPerf._allMeasurements.push({
	          exclusive: {},
	          inclusive: {},
	          render: {},
	          counts: {},
	          writes: {},
	          displayNames: {},
	          totalTime: 0,
	          created: {}
	        });
	        start = performanceNow();
	        rv = func.apply(this, args);
	        ReactDefaultPerf._allMeasurements[ReactDefaultPerf._allMeasurements.length - 1].totalTime = performanceNow() - start;
	        return rv;
	      } else if (fnName === '_mountImageIntoNode' || moduleName === 'ReactBrowserEventEmitter' || moduleName === 'ReactDOMIDOperations' || moduleName === 'CSSPropertyOperations' || moduleName === 'DOMChildrenOperations' || moduleName === 'DOMPropertyOperations') {
	        start = performanceNow();
	        rv = func.apply(this, args);
	        totalTime = performanceNow() - start;
	
	        if (fnName === '_mountImageIntoNode') {
	          var mountID = ReactMount.getID(args[1]);
	          ReactDefaultPerf._recordWrite(mountID, fnName, totalTime, args[0]);
	        } else if (fnName === 'dangerouslyProcessChildrenUpdates') {
	          // special format
	          args[0].forEach(function (update) {
	            var writeArgs = {};
	            if (update.fromIndex !== null) {
	              writeArgs.fromIndex = update.fromIndex;
	            }
	            if (update.toIndex !== null) {
	              writeArgs.toIndex = update.toIndex;
	            }
	            if (update.textContent !== null) {
	              writeArgs.textContent = update.textContent;
	            }
	            if (update.markupIndex !== null) {
	              writeArgs.markup = args[1][update.markupIndex];
	            }
	            ReactDefaultPerf._recordWrite(update.parentID, update.type, totalTime, writeArgs);
	          });
	        } else {
	          // basic format
	          var id = args[0];
	          if (typeof id === 'object') {
	            id = ReactMount.getID(args[0]);
	          }
	          ReactDefaultPerf._recordWrite(id, fnName, totalTime, Array.prototype.slice.call(args, 1));
	        }
	        return rv;
	      } else if (moduleName === 'ReactCompositeComponent' && (fnName === 'mountComponent' || fnName === 'updateComponent' || // TODO: receiveComponent()?
	      fnName === '_renderValidatedComponent')) {
	
	        if (this._currentElement.type === ReactMount.TopLevelWrapper) {
	          return func.apply(this, args);
	        }
	
	        var rootNodeID = fnName === 'mountComponent' ? args[0] : this._rootNodeID;
	        var isRender = fnName === '_renderValidatedComponent';
	        var isMount = fnName === 'mountComponent';
	
	        var mountStack = ReactDefaultPerf._mountStack;
	        var entry = ReactDefaultPerf._allMeasurements[ReactDefaultPerf._allMeasurements.length - 1];
	
	        if (isRender) {
	          addValue(entry.counts, rootNodeID, 1);
	        } else if (isMount) {
	          entry.created[rootNodeID] = true;
	          mountStack.push(0);
	        }
	
	        start = performanceNow();
	        rv = func.apply(this, args);
	        totalTime = performanceNow() - start;
	
	        if (isRender) {
	          addValue(entry.render, rootNodeID, totalTime);
	        } else if (isMount) {
	          var subMountTime = mountStack.pop();
	          mountStack[mountStack.length - 1] += totalTime;
	          addValue(entry.exclusive, rootNodeID, totalTime - subMountTime);
	          addValue(entry.inclusive, rootNodeID, totalTime);
	        } else {
	          addValue(entry.inclusive, rootNodeID, totalTime);
	        }
	
	        entry.displayNames[rootNodeID] = {
	          current: this.getName(),
	          owner: this._currentElement._owner ? this._currentElement._owner.getName() : '<root>'
	        };
	
	        return rv;
	      } else {
	        return func.apply(this, args);
	      }
	    };
	  }
	};
	
	module.exports = ReactDefaultPerf;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultPerfAnalysis
	 */
	
	'use strict';
	
	var assign = __webpack_require__(40);
	
	// Don't try to save users less than 1.2ms (a number I made up)
	var DONT_CARE_THRESHOLD = 1.2;
	var DOM_OPERATION_TYPES = {
	  '_mountImageIntoNode': 'set innerHTML',
	  INSERT_MARKUP: 'set innerHTML',
	  MOVE_EXISTING: 'move',
	  REMOVE_NODE: 'remove',
	  SET_MARKUP: 'set innerHTML',
	  TEXT_CONTENT: 'set textContent',
	  'setValueForProperty': 'update attribute',
	  'setValueForAttribute': 'update attribute',
	  'deleteValueForProperty': 'remove attribute',
	  'setValueForStyles': 'update styles',
	  'replaceNodeWithMarkup': 'replace',
	  'updateTextContent': 'set textContent'
	};
	
	function getTotalTime(measurements) {
	  // TODO: return number of DOM ops? could be misleading.
	  // TODO: measure dropped frames after reconcile?
	  // TODO: log total time of each reconcile and the top-level component
	  // class that triggered it.
	  var totalTime = 0;
	  for (var i = 0; i < measurements.length; i++) {
	    var measurement = measurements[i];
	    totalTime += measurement.totalTime;
	  }
	  return totalTime;
	}
	
	function getDOMSummary(measurements) {
	  var items = [];
	  measurements.forEach(function (measurement) {
	    Object.keys(measurement.writes).forEach(function (id) {
	      measurement.writes[id].forEach(function (write) {
	        items.push({
	          id: id,
	          type: DOM_OPERATION_TYPES[write.type] || write.type,
	          args: write.args
	        });
	      });
	    });
	  });
	  return items;
	}
	
	function getExclusiveSummary(measurements) {
	  var candidates = {};
	  var displayName;
	
	  for (var i = 0; i < measurements.length; i++) {
	    var measurement = measurements[i];
	    var allIDs = assign({}, measurement.exclusive, measurement.inclusive);
	
	    for (var id in allIDs) {
	      displayName = measurement.displayNames[id].current;
	
	      candidates[displayName] = candidates[displayName] || {
	        componentName: displayName,
	        inclusive: 0,
	        exclusive: 0,
	        render: 0,
	        count: 0
	      };
	      if (measurement.render[id]) {
	        candidates[displayName].render += measurement.render[id];
	      }
	      if (measurement.exclusive[id]) {
	        candidates[displayName].exclusive += measurement.exclusive[id];
	      }
	      if (measurement.inclusive[id]) {
	        candidates[displayName].inclusive += measurement.inclusive[id];
	      }
	      if (measurement.counts[id]) {
	        candidates[displayName].count += measurement.counts[id];
	      }
	    }
	  }
	
	  // Now make a sorted array with the results.
	  var arr = [];
	  for (displayName in candidates) {
	    if (candidates[displayName].exclusive >= DONT_CARE_THRESHOLD) {
	      arr.push(candidates[displayName]);
	    }
	  }
	
	  arr.sort(function (a, b) {
	    return b.exclusive - a.exclusive;
	  });
	
	  return arr;
	}
	
	function getInclusiveSummary(measurements, onlyClean) {
	  var candidates = {};
	  var inclusiveKey;
	
	  for (var i = 0; i < measurements.length; i++) {
	    var measurement = measurements[i];
	    var allIDs = assign({}, measurement.exclusive, measurement.inclusive);
	    var cleanComponents;
	
	    if (onlyClean) {
	      cleanComponents = getUnchangedComponents(measurement);
	    }
	
	    for (var id in allIDs) {
	      if (onlyClean && !cleanComponents[id]) {
	        continue;
	      }
	
	      var displayName = measurement.displayNames[id];
	
	      // Inclusive time is not useful for many components without knowing where
	      // they are instantiated. So we aggregate inclusive time with both the
	      // owner and current displayName as the key.
	      inclusiveKey = displayName.owner + ' > ' + displayName.current;
	
	      candidates[inclusiveKey] = candidates[inclusiveKey] || {
	        componentName: inclusiveKey,
	        time: 0,
	        count: 0
	      };
	
	      if (measurement.inclusive[id]) {
	        candidates[inclusiveKey].time += measurement.inclusive[id];
	      }
	      if (measurement.counts[id]) {
	        candidates[inclusiveKey].count += measurement.counts[id];
	      }
	    }
	  }
	
	  // Now make a sorted array with the results.
	  var arr = [];
	  for (inclusiveKey in candidates) {
	    if (candidates[inclusiveKey].time >= DONT_CARE_THRESHOLD) {
	      arr.push(candidates[inclusiveKey]);
	    }
	  }
	
	  arr.sort(function (a, b) {
	    return b.time - a.time;
	  });
	
	  return arr;
	}
	
	function getUnchangedComponents(measurement) {
	  // For a given reconcile, look at which components did not actually
	  // render anything to the DOM and return a mapping of their ID to
	  // the amount of time it took to render the entire subtree.
	  var cleanComponents = {};
	  var dirtyLeafIDs = Object.keys(measurement.writes);
	  var allIDs = assign({}, measurement.exclusive, measurement.inclusive);
	
	  for (var id in allIDs) {
	    var isDirty = false;
	    // For each component that rendered, see if a component that triggered
	    // a DOM op is in its subtree.
	    for (var i = 0; i < dirtyLeafIDs.length; i++) {
	      if (dirtyLeafIDs[i].indexOf(id) === 0) {
	        isDirty = true;
	        break;
	      }
	    }
	    // check if component newly created
	    if (measurement.created[id]) {
	      isDirty = true;
	    }
	    if (!isDirty && measurement.counts[id] > 0) {
	      cleanComponents[id] = true;
	    }
	  }
	  return cleanComponents;
	}
	
	var ReactDefaultPerfAnalysis = {
	  getExclusiveSummary: getExclusiveSummary,
	  getInclusiveSummary: getInclusiveSummary,
	  getDOMSummary: getDOMSummary,
	  getTotalTime: getTotalTime
	};
	
	module.exports = ReactDefaultPerfAnalysis;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule performanceNow
	 * @typechecks
	 */
	
	'use strict';
	
	var performance = __webpack_require__(146);
	var curPerformance = performance;
	
	/**
	 * Detect if we can use `window.performance.now()` and gracefully fallback to
	 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
	 * because of Facebook's testing infrastructure.
	 */
	if (!curPerformance || !curPerformance.now) {
	  curPerformance = Date;
	}
	
	var performanceNow = curPerformance.now.bind(curPerformance);
	
	module.exports = performanceNow;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule performance
	 * @typechecks
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	var performance;
	
	if (ExecutionEnvironment.canUseDOM) {
	  performance = window.performance || window.msPerformance || window.webkitPerformance;
	}
	
	module.exports = performance || {};

/***/ },
/* 147 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '0.14.4';

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(29);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMServer
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(72);
	var ReactServerRendering = __webpack_require__(150);
	var ReactVersion = __webpack_require__(147);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactServerRendering
	 */
	'use strict';
	
	var ReactDefaultBatchingStrategy = __webpack_require__(93);
	var ReactElement = __webpack_require__(43);
	var ReactInstanceHandles = __webpack_require__(46);
	var ReactMarkupChecksum = __webpack_require__(49);
	var ReactServerBatchingStrategy = __webpack_require__(151);
	var ReactServerRenderingTransaction = __webpack_require__(152);
	var ReactUpdates = __webpack_require__(55);
	
	var emptyObject = __webpack_require__(59);
	var instantiateReactComponent = __webpack_require__(63);
	var invariant = __webpack_require__(14);
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToString(element) {
	  !ReactElement.isValidElement(element) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(false);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      var markup = componentInstance.mountComponent(id, transaction, emptyObject);
	      return ReactMarkupChecksum.addChecksumToMarkup(markup);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup, without the extra React ID and checksum
	 * (for generating static pages)
	 */
	function renderToStaticMarkup(element) {
	  !ReactElement.isValidElement(element) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(true);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      return componentInstance.mountComponent(id, transaction, emptyObject);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 151 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerBatchingStrategy
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 * @typechecks
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(57);
	var CallbackQueue = __webpack_require__(56);
	var Transaction = __webpack_require__(58);
	
	var assign = __webpack_require__(40);
	var emptyFunction = __webpack_require__(16);
	
	/**
	 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
	 * during the performing of the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  close: emptyFunction
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [ON_DOM_READY_QUEUEING];
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = false;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactIsomorphic
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(111);
	var ReactComponent = __webpack_require__(124);
	var ReactClass = __webpack_require__(123);
	var ReactDOMFactories = __webpack_require__(154);
	var ReactElement = __webpack_require__(43);
	var ReactElementValidator = __webpack_require__(155);
	var ReactPropTypes = __webpack_require__(108);
	var ReactVersion = __webpack_require__(147);
	
	var assign = __webpack_require__(40);
	var onlyChild = __webpack_require__(157);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (process.env.NODE_ENV !== 'production') {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Hook for JSX spread, don't use this for anything else.
	  __spread: assign
	};
	
	module.exports = React;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(43);
	var ReactElementValidator = __webpack_require__(155);
	
	var mapObject = __webpack_require__(156);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (process.env.NODE_ENV !== 'production') {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(43);
	var ReactPropTypeLocations = __webpack_require__(66);
	var ReactPropTypeLocationNames = __webpack_require__(67);
	var ReactCurrentOwner = __webpack_require__(6);
	
	var canDefineProperty = __webpack_require__(44);
	var getIteratorFn = __webpack_require__(109);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(26);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	var loggedTypeFailures = {};
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var addenda = getAddendaForKeyUse('uniqueKey', element, parentType);
	  if (addenda === null) {
	    // we already showed the warning
	    return;
	  }
	  process.env.NODE_ENV !== 'production' ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s%s', addenda.parentOrOwner || '', addenda.childOwner || '', addenda.url || '') : undefined;
	}
	
	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} messageType A key used for de-duping warnings.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 * @returns {?object} A set of addenda to use in the warning message, or null
	 * if the warning has already been shown before (and shouldn't be shown again).
	 */
	function getAddendaForKeyUse(messageType, element, parentType) {
	  var addendum = getDeclarationErrorAddendum();
	  if (!addendum) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      addendum = ' Check the top-level render call using <' + parentName + '>.';
	    }
	  }
	
	  var memoizer = ownerHasKeyUseWarning[messageType] || (ownerHasKeyUseWarning[messageType] = {});
	  if (memoizer[addendum]) {
	    return null;
	  }
	  memoizer[addendum] = true;
	
	  var addenda = {
	    parentOrOwner: addendum,
	    url: ' See https://fb.me/react-warning-keys for more information.',
	    childOwner: null
	  };
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    addenda.childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
	  }
	
	  return addenda;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof propTypes[propName] === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	        error = propTypes[propName](props, propName, componentName, location);
	      } catch (ex) {
	        error = ex;
	      }
	      process.env.NODE_ENV !== 'production' ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], propName, typeof error) : undefined;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum();
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Failed propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(name, componentClass.propTypes, element.props, ReactPropTypeLocations.prop);
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	    process.env.NODE_ENV !== 'production' ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : undefined;
	  }
	}
	
	var ReactElementValidator = {
	
	  createElement: function (type, props, children) {
	    var validType = typeof type === 'string' || typeof type === 'function';
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	    process.env.NODE_ENV !== 'production' ? warning(validType, 'React.createElement: type should not be null, undefined, boolean, or ' + 'number. It should be a string (for DOM elements) or a ReactClass ' + '(for composite components).%s', getDeclarationErrorAddendum()) : undefined;
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)
	    if (validType) {
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], type);
	      }
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function (type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (process.env.NODE_ENV !== 'production') {
	      if (canDefineProperty) {
	        Object.defineProperty(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : undefined;
	            Object.defineProperty(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	    }
	
	    return validatedFactory;
	  },
	
	  cloneElement: function (element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	
	};
	
	module.exports = ReactElementValidator;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 156 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule mapObject
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(43);
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactComponent} The first and only `ReactComponent` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : invariant(false) : undefined;
	  return children;
	}
	
	module.exports = onlyChild;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule deprecated
	 */
	
	'use strict';
	
	var assign = __webpack_require__(40);
	var warning = __webpack_require__(26);
	
	/**
	 * This will log a single deprecation notice per function and forward the call
	 * on to the new API.
	 *
	 * @param {string} fnName The name of the function
	 * @param {string} newModule The module that fn will exist in
	 * @param {string} newPackage The module that fn will exist in
	 * @param {*} ctx The context this forwarded call should run in
	 * @param {function} fn The function to forward on to
	 * @return {function} The function that will warn once and then call fn
	 */
	function deprecated(fnName, newModule, newPackage, ctx, fn) {
	  var warned = false;
	  if (process.env.NODE_ENV !== 'production') {
	    var newFn = function () {
	      process.env.NODE_ENV !== 'production' ? warning(warned,
	      // Require examples in this string must be split to prevent React's
	      // build tools from mistaking them for real requires.
	      // Otherwise the build tools will attempt to build a '%s' module.
	      'React.%s is deprecated. Please use %s.%s from require' + '(\'%s\') ' + 'instead.', fnName, newModule, fnName, newPackage) : undefined;
	      warned = true;
	      return fn.apply(ctx, arguments);
	    };
	    // We need to make sure all properties of the original fn are copied over.
	    // In particular, this is needed to support PropTypes
	    return assign(newFn, fn);
	  }
	
	  return fn;
	}
	
	module.exports = deprecated;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(4);


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _createStore = __webpack_require__(161);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _utilsCombineReducers = __webpack_require__(163);
	
	var _utilsCombineReducers2 = _interopRequireDefault(_utilsCombineReducers);
	
	var _utilsBindActionCreators = __webpack_require__(166);
	
	var _utilsBindActionCreators2 = _interopRequireDefault(_utilsBindActionCreators);
	
	var _utilsApplyMiddleware = __webpack_require__(167);
	
	var _utilsApplyMiddleware2 = _interopRequireDefault(_utilsApplyMiddleware);
	
	var _utilsCompose = __webpack_require__(168);
	
	var _utilsCompose2 = _interopRequireDefault(_utilsCompose);
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _utilsCombineReducers2['default'];
	exports.bindActionCreators = _utilsBindActionCreators2['default'];
	exports.applyMiddleware = _utilsApplyMiddleware2['default'];
	exports.compose = _utilsCompose2['default'];

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createStore;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utilsIsPlainObject = __webpack_require__(162);
	
	var _utilsIsPlainObject2 = _interopRequireDefault(_utilsIsPlainObject);
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	exports.ActionTypes = ActionTypes;
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [initialState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	
	function createStore(reducer, initialState) {
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = initialState;
	  var listeners = [];
	  var isDispatching = false;
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    listeners.push(listener);
	    var isSubscribed = true;
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	      var index = listeners.indexOf(listener);
	      listeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!_utilsIsPlainObject2['default'](action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    listeners.slice().forEach(function (listener) {
	      return listener();
	    });
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  };
	}

/***/ },
/* 162 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = isPlainObject;
	var fnToString = function fnToString(fn) {
	  return Function.prototype.toString.call(fn);
	};
	var objStringValue = fnToString(Object);
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	
	function isPlainObject(obj) {
	  if (!obj || typeof obj !== 'object') {
	    return false;
	  }
	
	  var proto = typeof obj.constructor === 'function' ? Object.getPrototypeOf(obj) : Object.prototype;
	
	  if (proto === null) {
	    return true;
	  }
	
	  var constructor = proto.constructor;
	
	  return typeof constructor === 'function' && constructor instanceof constructor && fnToString(constructor) === objStringValue;
	}
	
	module.exports = exports['default'];

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _createStore = __webpack_require__(161);
	
	var _isPlainObject = __webpack_require__(162);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _mapValues = __webpack_require__(164);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _pick = __webpack_require__(165);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	/* eslint-disable no-console */
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Reducer "' + key + '" returned undefined handling ' + actionName + '. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateKeyWarningMessage(inputState, outputState, action) {
	  var reducerKeys = Object.keys(outputState);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!_isPlainObject2['default'](inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return reducerKeys.indexOf(key) < 0;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	
	function combineReducers(reducers) {
	  var finalReducers = _pick2['default'](reducers, function (val) {
	    return typeof val === 'function';
	  });
	  var sanityError;
	
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  var defaultState = _mapValues2['default'](finalReducers, function () {
	    return undefined;
	  });
	
	  return function combination(state, action) {
	    if (state === undefined) state = defaultState;
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    var hasChanged = false;
	    var finalState = _mapValues2['default'](finalReducers, function (reducer, key) {
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	      return nextStateForKey;
	    });
	
	    if (process.env.NODE_ENV !== 'production') {
	      var warningMessage = getUnexpectedStateKeyWarningMessage(state, finalState, action);
	      if (warningMessage) {
	        console.error(warningMessage);
	      }
	    }
	
	    return hasChanged ? finalState : state;
	  };
	}
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 164 */
/***/ function(module, exports) {

	/**
	 * Applies a function to every key-value pair inside an object.
	 *
	 * @param {Object} obj The source object.
	 * @param {Function} fn The mapper function that receives the value and the key.
	 * @returns {Object} A new object that contains the mapped values for the keys.
	 */
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = mapValues;
	
	function mapValues(obj, fn) {
	  return Object.keys(obj).reduce(function (result, key) {
	    result[key] = fn(obj[key], key);
	    return result;
	  }, {});
	}
	
	module.exports = exports["default"];

/***/ },
/* 165 */
/***/ function(module, exports) {

	/**
	 * Picks key-value pairs from an object where values satisfy a predicate.
	 *
	 * @param {Object} obj The object to pick from.
	 * @param {Function} fn The predicate the values must satisfy to be copied.
	 * @returns {Object} The object with the values that satisfied the predicate.
	 */
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = pick;
	
	function pick(obj, fn) {
	  return Object.keys(obj).reduce(function (result, key) {
	    if (fn(obj[key])) {
	      result[key] = obj[key];
	    }
	    return result;
	  }, {});
	}
	
	module.exports = exports["default"];

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapValues = __webpack_require__(164);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null || actionCreators === undefined) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  return _mapValues2['default'](actionCreators, function (actionCreator) {
	    return bindActionCreator(actionCreator, dispatch);
	  });
	}
	
	module.exports = exports['default'];

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _compose = __webpack_require__(168);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (next) {
	    return function (reducer, initialState) {
	      var store = next(reducer, initialState);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 168 */
/***/ function(module, exports) {

	/**
	 * Composes single-argument functions from right to left.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing functions from right to
	 * left. For example, compose(f, g, h) is identical to arg => f(g(h(arg))).
	 */
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return function (arg) {
	    return funcs.reduceRight(function (composed, f) {
	      return f(composed);
	    }, arg);
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Provider = __webpack_require__(170);
	var connect = __webpack_require__(172);
	
	module.exports = { Provider: Provider, connect: connect };

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(2);
	
	var Component = _require.Component;
	var PropTypes = _require.PropTypes;
	var Children = _require.Children;
	
	var storeShape = __webpack_require__(171);
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	
	  didWarnAboutReceivingStore = true;
	  console.error( // eslint-disable-line no-console
	  '<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/rackt/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = (function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	
	  Provider.prototype.render = function render() {
	    var children = this.props.children;
	
	    return Children.only(children);
	  };
	
	  return Provider;
	})(Component);
	
	Provider.propTypes = {
	  store: storeShape.isRequired,
	  children: PropTypes.element.isRequired
	};
	Provider.childContextTypes = {
	  store: storeShape.isRequired
	};
	
	module.exports = Provider;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(2);
	
	var PropTypes = _require.PropTypes;
	
	var storeShape = PropTypes.shape({
	  subscribe: PropTypes.func.isRequired,
	  dispatch: PropTypes.func.isRequired,
	  getState: PropTypes.func.isRequired
	});
	
	module.exports = storeShape;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(2);
	
	var Component = _require.Component;
	var createElement = _require.createElement;
	
	var storeShape = __webpack_require__(171);
	var shallowEqual = __webpack_require__(173);
	var isPlainObject = __webpack_require__(174);
	var wrapActionCreators = __webpack_require__(175);
	var hoistStatics = __webpack_require__(176);
	var invariant = __webpack_require__(177);
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var finalMapStateToProps = mapStateToProps || defaultMapStateToProps;
	  var finalMapDispatchToProps = isPlainObject(mapDispatchToProps) ? wrapActionCreators(mapDispatchToProps) : mapDispatchToProps || defaultMapDispatchToProps;
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var doStatePropsDependOnOwnProps = finalMapStateToProps.length !== 1;
	  var doDispatchPropsDependOnOwnProps = finalMapDispatchToProps.length !== 1;
	  var _options$pure = options.pure;
	  var pure = _options$pure === undefined ? true : _options$pure;
	  var _options$withRef = options.withRef;
	  var withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  // Helps track hot reloading.
	
	  var version = nextVersion++;
	
	  function computeStateProps(store, props) {
	    var state = store.getState();
	    var stateProps = doStatePropsDependOnOwnProps ? finalMapStateToProps(state, props) : finalMapStateToProps(state);
	
	    invariant(isPlainObject(stateProps), '`mapStateToProps` must return an object. Instead received %s.', stateProps);
	    return stateProps;
	  }
	
	  function computeDispatchProps(store, props) {
	    var dispatch = store.dispatch;
	
	    var dispatchProps = doDispatchPropsDependOnOwnProps ? finalMapDispatchToProps(dispatch, props) : finalMapDispatchToProps(dispatch);
	
	    invariant(isPlainObject(dispatchProps), '`mapDispatchToProps` must return an object. Instead received %s.', dispatchProps);
	    return dispatchProps;
	  }
	
	  function computeMergedProps(stateProps, dispatchProps, parentProps) {
	    var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	    invariant(isPlainObject(mergedProps), '`mergeProps` must return an object. Instead received %s.', mergedProps);
	    return mergedProps;
	  }
	
	  return function wrapWithConnect(WrappedComponent) {
	    var Connect = (function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        invariant(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + _this.constructor.displayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + _this.constructor.displayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = computeStateProps(this.store, this.props);
	        if (this.stateProps && shallowEqual(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && shallowEqual(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedProps = function updateMergedProps() {
	        this.mergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !shallowEqual(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.renderedElement = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var prevStoreState = this.state.storeState;
	        var storeState = this.store.getState();
	
	        if (!pure || prevStoreState !== storeState) {
	          this.hasStoreStateChanged = true;
	          this.setState({ storeState: storeState });
	        }
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        invariant(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged;
	        var hasStoreStateChanged = this.hasStoreStateChanged;
	        var renderedElement = this.renderedElement;
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          this.updateMergedProps();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = createElement(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = createElement(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    })(Component);
	
	    Connect.displayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: storeShape
	    };
	    Connect.propTypes = {
	      store: storeShape
	    };
	
	    if (process.env.NODE_ENV !== 'production') {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return hoistStatics(Connect, WrappedComponent);
	  };
	}
	
	module.exports = connect;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 173 */
/***/ function(module, exports) {

	"use strict";
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 174 */
/***/ function(module, exports) {

	'use strict';
	
	function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }
	
	var fnToString = function fnToString(fn) {
	  return Function.prototype.toString.call(fn);
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
	    return false;
	  }
	
	  var proto = typeof obj.constructor === 'function' ? Object.getPrototypeOf(obj) : Object.prototype;
	
	  if (proto === null) {
	    return true;
	  }
	
	  var constructor = proto.constructor;
	
	  return typeof constructor === 'function' && constructor instanceof constructor && fnToString(constructor) === fnToString(Object);
	}
	
	module.exports = isPlainObject;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _redux = __webpack_require__(160);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}
	
	module.exports = wrapActionCreators;

/***/ },
/* 176 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent) {
	    var keys = Object.getOwnPropertyNames(sourceComponent);
	    for (var i=0; i<keys.length; ++i) {
	        if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]]) {
	            targetComponent[keys[i]] = sourceComponent[keys[i]];
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (process.env.NODE_ENV !== 'production') {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};Object.defineProperty(exports, "__esModule", { value: true });exports.default = 
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	reducer;var _Rational = __webpack_require__(179);var _Rational2 = _interopRequireDefault(_Rational);var _merge = __webpack_require__(181);var _merge2 = _interopRequireDefault(_merge);var _HarmonicData = __webpack_require__(183);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toConsumableArray(arr) {if (Array.isArray(arr)) {for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {arr2[i] = arr[i];}return arr2;} else {return Array.from(arr);}}var initialState = { acousticRatios: _HarmonicData.canonicalValues, treeViewOptions: { // There are two different 'levels' properties:
	        // one for the finite tree, and one for the infinite tree.
	        // All the other properties are shared, unless otherwise noted.
	        levels: 4, // for the finite tree; must be discrete
	        infiniteLevels: 3, // for the infinite tree; can be real
	        infiniteHeight: 600, // pixel height of the infinite tree
	        //
	        showRoots: true, showOctaves: true, wide: false, limits: { // TODO(william): refactor this to be more structured:
	            // e.g., { combined: { min: { value: 4, enabled: false } } }
	            minCombined: 4, maxCombined: 24, minIndividual: 2, maxIndividual: 12, minCombinedEnabled: false, maxCombinedEnabled: false, minIndividualEnabled: false, maxIndividualEnabled: false }, //
	        // These fields are for the infinite tree only.
	        treeNumber: 1, // the 'n' in "the root has semitones '[n][n]'"
	        rootBass: 0, // semitones above middle C of the bass note
	        highQuality: false, // smoother, slower rendering
	        rainbowFactor: 0, // how colorful should the nodes be?
	        alwaysEngrave: false } }; // sohw engravings always, not just on hover
	function setAcousticRatio(state, index, ratio) {var acousticRatios = state.acousticRatios;if (index < 0 || index >= acousticRatios.length) {throw new Error('acoustic ratio index is out of bounds: ' + ('got ' + index + ', but array length is ' + acousticRatios.length));}if (!(ratio instanceof _Rational2.default)) {throw new Error('expected Rational, but got: ' + ratio);}return _extends({}, state, { acousticRatios: [].concat(_toConsumableArray(acousticRatios.slice(0, index)), [ratio], _toConsumableArray(acousticRatios.slice(index + 1))) });}function setTreeViewOption(state, name, value) {return _extends({}, state, { treeViewOptions: _extends({}, state.treeViewOptions, _defineProperty({}, name, value)) });}function setTreeLimitField(state, name, value) {if (Object.keys(state.treeViewOptions.limits).indexOf(name) === -1) {throw new Error('unknown limit field: ' + name);}return _extends({}, state, { treeViewOptions: _extends({}, state.treeViewOptions, { limits: _extends({}, state.treeViewOptions.limits, _defineProperty({}, name, value)) }) });}function setTreeLimitValue(state, name, value) {return setTreeLimitField(state, name, value);}function setTreeLimitEnabled(state, name, value) {return setTreeLimitField(state, name + 'Enabled', value);}function rehydrate(state, dehydrated) {var merged = _merge2.default.recursive(true /* clone */, state, dehydrated);var acousticRatios = merged.acousticRatios;if (!Array.isArray(acousticRatios)) {throw new Error('expected to find an array of acousticRatios, ' + ('but found: ' + acousticRatios));}var rehydratedRatios = acousticRatios.map(function (x) {return new _Rational2.default(x.a, x.b);});return _extends({}, merged, { acousticRatios: rehydratedRatios });}function reducer() {var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];var action = arguments[1];switch (action.type) {case "NOOP":return state;case "SET_ACOUSTIC_RATIO":return setAcousticRatio(state, action.index, action.ratio);case "SET_TREE_VIEW_OPTION":return setTreeViewOption(state, action.field, action.value);case "SET_TREE_LIMIT_VALUE":return setTreeLimitValue(state, action.limit, action.value);case "SET_TREE_LIMIT_ENABLED":return setTreeLimitEnabled(state, action.limit, action.enabled);case "REHYDRATE":return rehydrate(state, action.newState);default:return state;}}

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _Utils = __webpack_require__(180);function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var 
	
	Rational = (function () {
	
	    function Rational(a, b) {_classCallCheck(this, Rational);
	        if (b === 0) {
	            throw new Error("denominator must not be zero");}
	
	        if (!isFinite(a)) {
	            throw new Error("numerator must be finite");}
	
	        if (!isFinite(b)) {
	            throw new Error("denominator must be finite");}
	
	        if (!isFinite(a / b)) {
	            // can arise when dividing by subnormals, etc.
	            throw new Error("rational must represent a finite quotient");}
	
	
	        var divisor = (0, _Utils.gcd)(a, b);
	        var maybeNegate = b < 0 ? -1 : 1;
	        var fac = maybeNegate / divisor;
	
	        this.a = a * fac;
	        this.b = b * fac;}_createClass(Rational, [{ key: "equals", value: function equals(
	
	
	        other) {
	            return this.a === other.a && this.b === other.b;} }, { key: "multiply", value: function multiply(
	
	
	        other) {
	            return new Rational(this.a * other.a, this.b * other.b);} }, { key: "exponentiateScalar", value: function exponentiateScalar(
	
	
	        k) {
	            if (k === 0) {
	                return new Rational(1, 1);} else 
	            {var 
	                a = this.a;var b = this.b;
	                var absK = Math.abs(k);
	                return new Rational(
	                Math.pow(k > 0 ? a : b, absK), 
	                Math.pow(k > 0 ? b : a, absK));}} }, { key: "toNumber", value: function toNumber() 
	
	
	
	        {
	            return this.a / this.b;} }]);return Rational;})();exports.default = Rational;

/***/ },
/* 180 */
/***/ function(module, exports) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.gcd = gcd;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	buildArray = buildArray;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	range = range;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	arraysEqual = arraysEqual;exports.
	
	
	
	
	
	
	
	
	
	
	
	flatten = flatten;function gcd(a, b) {if (b === 0) {return Math.abs(a);} else {return gcd(b, a % b);}} /*
	                                                                                                        * You'd like something like 'Array(length).map(callback)' to work,
	                                                                                                        * but it doesn't because this is JavaScript
	                                                                                                        * and "uninitialized array position" and "undefined value at position"
	                                                                                                        * are different things, so 'map' and friends don't work on such arrays.
	                                                                                                        * Instead, this does what you want.
	                                                                                                        *
	                                                                                                        * More precisely, 'length' is the length of an array to create,
	                                                                                                        * and 'callback' is a callback that takes
	                                                                                                        * an index into the array
	                                                                                                        * and (optionally) the previous state of the array
	                                                                                                        * and returns the element at the given index.
	                                                                                                        *
	                                                                                                        * For example: 'buildArray(5, x => x * x)' returns [0, 1, 4, 9, 16],
	                                                                                                        * and 'buildArray(5, (i, r) => (r[i - 1] || 0) + i)' returns [0, 1, 3, 6, 10].
	                                                                                                        */function buildArray(length, callback) {var result = Array(length);for (var i = 0; i < length; i++) {result[i] = callback(i, result);}return result;} /*
	                                                                                                                                                                                                                                                                * Takes either one, two, or three arguments:
	                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                *   - range(b)       = [0, 1, ..., b - 1];
	                                                                                                                                                                                                                                                                *   - range(a, b)    = [a, a + 1, ..., b - 1]; or
	                                                                                                                                                                                                                                                                *   - range(a, b, s) = [a, a + s, ..., a + ks]
	                                                                                                                                                                                                                                                                *                      where 'k' is the largest integer such that a + ks < b.
	                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                * All arguments, when present, must be finite numbers,
	                                                                                                                                                                                                                                                                * but need not be integers (though beware of floating-point voodoo).
	                                                                                                                                                                                                                                                                * Descending ranges are fine.
	                                                                                                                                                                                                                                                                * The step size may not be zero.
	                                                                                                                                                                                                                                                                */function range() {// Extract the arguments.
	    var min = undefined, max = undefined, step = undefined;for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}switch (args.length) {case 1:min = 0;max = args[0];step = 1;break;case 2:min = args[0];max = args[1];step = 1;break;case 3:min = args[0];max = args[1];step = args[2];break;default:throw new Error("Invalid arity " + args.length + "; must be 0, 1, or 2");} // Make sure all arguments are finite numbers.
	    var checks = { min: min, max: max, step: step };Object.keys(checks).forEach(function (key) {var value = checks[key];if (isNaN(value)) {throw new Error("expected '" + value + "' to be numeric, but got: " + value);}if (!isFinite(value)) {throw new Error("expected '" + value + "' to be finite, but got: " + value);}}); // Make sure the step size is non-zero.
	    if (step === 0) {throw new Error("expected non-zero step size");} // Finally, create an populate an array.
	    return buildArray(Math.max(0, Math.ceil((max - min) / step)), function (i, r) {return i === 0 ? min : r[i - 1] + step;});}function arraysEqual(arr1, arr2) {var comparator = arguments.length <= 2 || arguments[2] === undefined ? function (a, b) {return a === b;} : arguments[2];if (arr1.length !== arr2.length) {return false;}for (var i = 0; i < arr1.length; i++) {if (!comparator(arr1[i], arr2[i])) {return false;}}return true;}function flatten(arrays) {return Array.prototype.concat.apply([], arrays);}

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*!
	 * @name JavaScript/NodeJS Merge v1.2.0
	 * @author yeikos
	 * @repository https://github.com/yeikos/js.merge
	
	 * Copyright 2014 yeikos - MIT license
	 * https://raw.github.com/yeikos/js.merge/master/LICENSE
	 */
	
	;(function(isNode) {
	
		/**
		 * Merge one or more objects 
		 * @param bool? clone
		 * @param mixed,... arguments
		 * @return object
		 */
	
		var Public = function(clone) {
	
			return merge(clone === true, false, arguments);
	
		}, publicName = 'merge';
	
		/**
		 * Merge two or more objects recursively 
		 * @param bool? clone
		 * @param mixed,... arguments
		 * @return object
		 */
	
		Public.recursive = function(clone) {
	
			return merge(clone === true, true, arguments);
	
		};
	
		/**
		 * Clone the input removing any reference
		 * @param mixed input
		 * @return mixed
		 */
	
		Public.clone = function(input) {
	
			var output = input,
				type = typeOf(input),
				index, size;
	
			if (type === 'array') {
	
				output = [];
				size = input.length;
	
				for (index=0;index<size;++index)
	
					output[index] = Public.clone(input[index]);
	
			} else if (type === 'object') {
	
				output = {};
	
				for (index in input)
	
					output[index] = Public.clone(input[index]);
	
			}
	
			return output;
	
		};
	
		/**
		 * Merge two objects recursively
		 * @param mixed input
		 * @param mixed extend
		 * @return mixed
		 */
	
		function merge_recursive(base, extend) {
	
			if (typeOf(base) !== 'object')
	
				return extend;
	
			for (var key in extend) {
	
				if (typeOf(base[key]) === 'object' && typeOf(extend[key]) === 'object') {
	
					base[key] = merge_recursive(base[key], extend[key]);
	
				} else {
	
					base[key] = extend[key];
	
				}
	
			}
	
			return base;
	
		}
	
		/**
		 * Merge two or more objects
		 * @param bool clone
		 * @param bool recursive
		 * @param array argv
		 * @return object
		 */
	
		function merge(clone, recursive, argv) {
	
			var result = argv[0],
				size = argv.length;
	
			if (clone || typeOf(result) !== 'object')
	
				result = {};
	
			for (var index=0;index<size;++index) {
	
				var item = argv[index],
	
					type = typeOf(item);
	
				if (type !== 'object') continue;
	
				for (var key in item) {
	
					var sitem = clone ? Public.clone(item[key]) : item[key];
	
					if (recursive) {
	
						result[key] = merge_recursive(result[key], sitem);
	
					} else {
	
						result[key] = sitem;
	
					}
	
				}
	
			}
	
			return result;
	
		}
	
		/**
		 * Get type of variable
		 * @param mixed input
		 * @return string
		 *
		 * @see http://jsperf.com/typeofvar
		 */
	
		function typeOf(input) {
	
			return ({}).toString.call(input).slice(8, -1).toLowerCase();
	
		}
	
		if (isNode) {
	
			module.exports = Public;
	
		} else {
	
			window[publicName] = Public;
	
		}
	
	})(typeof module === 'object' && module && typeof module.exports === 'object' && module.exports);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)(module)))

/***/ },
/* 182 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });exports.intervalNames = exports.canonicalRationalizer = exports.canonicalValues = exports.restrictedRationalizerDomain = undefined;var _Rational = __webpack_require__(179);var _Rational2 = _interopRequireDefault(_Rational);var _HarmonicSeries = __webpack_require__(184);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	
	var restrictedRationalizerDomain = exports.restrictedRationalizerDomain = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
	var canonicalValues = exports.canonicalValues = [
	new _Rational2.default(15, 16), 
	new _Rational2.default(8, 9), 
	new _Rational2.default(5, 6), 
	new _Rational2.default(4, 5), 
	new _Rational2.default(3, 4), 
	new _Rational2.default(12, 17), 
	new _Rational2.default(2, 3), 
	new _Rational2.default(5, 8), 
	new _Rational2.default(3, 5), 
	new _Rational2.default(5, 9), 
	new _Rational2.default(8, 15)];
	
	var canonicalRationalizer = exports.canonicalRationalizer = (0, _HarmonicSeries.extendRationalizer)(canonicalValues);
	
	var intervalNames = exports.intervalNames = [
	"m2", "M2", "m3", "M3", 
	"P4", "A4/d5", "P5", 
	"m6", "M6", "m7", "M7"];

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};Object.defineProperty(exports, "__esModule", { value: true });exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	extendRationalizer = extendRationalizer;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	temperExact = temperExact;exports.
	
	
	
	
	
	
	temper = temper;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	findRootOffsetExact = findRootOffsetExact;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	findRootOffset = findRootOffset;exports.
	
	
	
	
	
	
	
	
	
	
	
	findChordRootOffset = findChordRootOffset;var _Rational = __webpack_require__(179);var _Rational2 = _interopRequireDefault(_Rational);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _toConsumableArray(arr) {if (Array.isArray(arr)) {for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {arr2[i] = arr[i];}return arr2;} else {return Array.from(arr);}} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                            * Given mappings for the eleven non-unitary simple intervals
	                                                                                                                                                                                                                                                                                                                                                                                                                            * from equal temperament to just intonation---
	                                                                                                                                                                                                                                                                                                                                                                                                                            * that is, given the acoustic ratios
	                                                                                                                                                                                                                                                                                                                                                                                                                            * for all intervals from a minor second to a major seventh, inclusive---
	                                                                                                                                                                                                                                                                                                                                                                                                                            * create a function that will map any semitone difference (as an integer)
	                                                                                                                                                                                                                                                                                                                                                                                                                            * to the corresponding acoustic ratio
	                                                                                                                                                                                                                                                                                                                                                                                                                            * determined by extrapolating octave-wise from the provided ratios.
	                                                                                                                                                                                                                                                                                                                                                                                                                            *
	                                                                                                                                                                                                                                                                                                                                                                                                                            * The input must be a length-11 array of Rationals, where
	                                                                                                                                                                                                                                                                                                                                                                                                                            * the first element is the acoustic ratio for a minor second (1 semitone),
	                                                                                                                                                                                                                                                                                                                                                                                                                            * and the last is the acoustic ratio for a major seventh (11 semitones).
	                                                                                                                                                                                                                                                                                                                                                                                                                            * These should all be ratios between 1 and 1/2 (exclusive),
	                                                                                                                                                                                                                                                                                                                                                                                                                            * and the array should be in strictly decreasing order,
	                                                                                                                                                                                                                                                                                                                                                                                                                            * although these constraints are not verified.
	                                                                                                                                                                                                                                                                                                                                                                                                                            *
	                                                                                                                                                                                                                                                                                                                                                                                                                            * For example, a perfect fifth should be (2 / 3), not (3 / 2).
	                                                                                                                                                                                                                                                                                                                                                                                                                            *
	                                                                                                                                                                                                                                                                                                                                                                                                                            * The type of this function is ({1, ..., 11} -> Q) -> (Z -> Q),
	                                                                                                                                                                                                                                                                                                                                                                                                                            * or, equivalently and a bit more accurately, (Q^11) -> (Z -> Q),
	                                                                                                                                                                                                                                                                                                                                                                                                                            * where Z and Q are the sets of integers and Rationals, respectively.
	                                                                                                                                                                                                                                                                                                                                                                                                                            */function extendRationalizer(table) {if (!Array.isArray(table)) {throw new Error("expected input to be an array, but found:" + table);}if (table.length !== 11) {throw new Error("expected input length to be exactly 11, " + "but found: " + table.length);}table.forEach(function (element, index) {if (!(element instanceof _Rational2.default)) {throw new Error("expected all elements to be Rationals, " + ("but the element at index " + index + " is: " + element));}});var realTable = [new _Rational2.default(1, 1)].concat(_toConsumableArray(table));return function rationalizer(n) {if (isNaN(n)) {throw new Error("expected input to be an number, but got: " + n);}if (!isFinite(n)) {throw new Error("expected input to be finite, but got: " + n);}if (n !== Math.round(n)) {throw new Error("expected input to be an integer, but got: " + n);}var octaves = Math.floor(n / 12);var fac = new _Rational2.default(1, 2).exponentiateScalar(octaves);var mod = n % 12;var idx = mod < 0 ? mod + 12 : mod;return realTable[idx].multiply(fac);};} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Convert a multiple of the fundamental frequency
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * to a equal-temperament semitone difference.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * For example, 4 maps to 24,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * because the fourth overtone is two octaves above the fundamental,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * and two octaves comprise 24 semitones.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Similarly, 3 maps to about 19.01955,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * because the third overtone is an octave and a perfect fifth above,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * and this corresponds to about that many semitones.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Note that the returned value need not be an integer.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */function temperExact(fundamentalMultiple) {return 12 * Math.log2(fundamentalMultiple);} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * Like 'temperExact', but rounds the result to the nearest integer.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */function temper(fundamentalMultiple) {return Math.round(temperExact(fundamentalMultiple));} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Suppose we have some arbitrary origin point---say, middle C is at 0.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Then an interval can be represented by a pair (a, b)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * of integers 'a' and 'b', where a < b,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * the lower note is 'a' semitones above the origin,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * and the higher note is 'b' semitones above the origin.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * This function finds the root of that chord in pitch space.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * For example, consider the minor third from E up to G.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * If our origin is middle C, then we would have a = 4 and b = 7.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * If you work out the fundamentals, you can find that
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * the root is the middle C two octaves below the origin.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * So, if CR is some canonical rationalizer,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * this implies that findRootOffsetExact(CR, 4, 7) should be about -24.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Returns either { status: "success", result: <number> }
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * or { status: "error", error: "<error code>" }.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */function findRootOffsetExact(rationalizer, basePitch, highPitch) {var semitoneDifference = highPitch - basePitch;try {var ratio = rationalizer(semitoneDifference);if (ratio.toNumber() === 0) {return { status: "error", error: "zero_ratio" };}var result = basePitch - temperExact(ratio.a);return { status: "success", result: result };} catch (e) {if (e.message.match(/(numerator|denominator) must be finite/)) {return { status: "error", error: "infinite" };} else {throw e;}}} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        * Like 'findRootOffsetExact', but rounds the result to the nearest integer.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        */function findRootOffset(rationalizer, basePitch, highPitch) {var exact = findRootOffsetExact(rationalizer, basePitch, highPitch);if (exact.status === "success") {return _extends({}, exact, { result: Math.round(exact.result) });} else {return exact;}}function findChordRootOffset(rationalizer, notes) {if (notes.length === 1) {return { status: "success", result: notes[0] };} // Zip with the binary operator on consecutive pairs.
	    // (That is, convert [a, b, c, d] to [f(a, b), f(b, c), f(c, d)].)
	    var results = new Array(notes.length - 1);for (var i = 0; i < results.length; i++) {var result = findRootOffset(rationalizer, notes[i], notes[i + 1]);if (result.status === "success") {results[i] = result.result;} else {return result;}}return findChordRootOffset(rationalizer, results);}exports.default = { extendRationalizer: extendRationalizer, temperExact: temperExact, temper: temper, findRootOffsetExact: findRootOffsetExact, findRootOffset: findRootOffset, findChordRootOffset: findChordRootOffset };

/***/ },
/* 185 */
/***/ function(module, exports) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true }); /*
	                                                                             * A simple abstraction over 'localStorage'
	                                                                             * to provide transparent JSON serialization and deserialization.
	                                                                             *
	                                                                             * The implementation is borrowed heavily from
	                                                                             * Khan Academy's LocalStore module,
	                                                                             * and also KaVideoPlayer's SafeLocalStore module.
	                                                                             */exports.default = 
	{ 
	    // Bump this to expire all old values.
	    version: 1, 
	    keyPrefix: "varese", 
	
	    cacheKey: function cacheKey(key) {
	        if (!key) {
	            throw new Error("Falsy key provided to cacheKey: " + key);}
	
	        return [this.keyPrefix, this.version, key].join(":");}, 
	
	
	    get: function get(key, whenUnavailable) {
	        if (!this.isEnabled()) {
	            return whenUnavailable;}
	
	        try {
	            var data = window.localStorage[this.cacheKey(key)];
	            if (data) {
	                return JSON.parse(data);} else 
	            {
	                return whenUnavailable;}} 
	
	        catch (e) {
	            // If we had trouble retrieving, like FF's NS_FILE_CORRUPTED:
	            // http://stackoverflow.com/q/18877643/
	            return whenUnavailable;}}, 
	
	
	
	    set: function set(key, data) {
	        if (!this.isEnabled()) {
	            return;}
	
	        var stringified = JSON.stringify(data);
	
	        try {
	            window.localStorage[this.cacheKey(key)] = stringified;} 
	        catch (e) {
	            // Probably went over the storage limit...that's not good.
	            throw e;}}, 
	
	
	
	    /*
	     * Delete whatever data was associated with the given key.
	     */
	    del: function del(key) {
	        if (!this.isEnabled()) {
	            return;}
	
	        var cacheKey = this.cacheKey(key);
	        if (cacheKey in window.localStorage) {
	            // (IE throws when deleting a non-existent entry.)
	            delete window.localStorage[cacheKey];}}, 
	
	
	
	    /*
	     * Local storage might be disabled in old browsers
	     * or in Safari's private browsing mode.
	     * Don't die.
	     */
	    isEnabled: function isEnabled() {
	        var uid = String(+new Date());
	        try {
	            window.sessionStorage[uid] = uid;
	            var enabled = window.sessionStorage[uid] === uid;
	            window.sessionStorage.removeItem(uid);
	            return enabled;} 
	        catch (e) {
	            return false;}} };

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	createListener = createListener;exports.
	
	
	
	
	
	createRehydrationAction = createRehydrationAction;exports.default = 
	
	
	
	
	
	
	
	
	setUp;var _LocalStore = __webpack_require__(185);var _LocalStore2 = _interopRequireDefault(_LocalStore);var _Actions = __webpack_require__(187);var Actions = _interopRequireWildcard(_Actions);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Connect a Redux store to the LocalStore localStorage layer,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * such that the Redux store is serialized (as JSON) to localStorage
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * immediately after every change to the store,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * and can be rehydrated when the application first launches.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This exposes two functions: 'createListener' and 'createRehydrationAction'.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You should first call 'createRehydrationAction' (with no arguments)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * and dispatch the resulting action to the store.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Then, you should call 'createListener' (passing in the store)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * and add the resulting listener as a subscriber to the store.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Or, you can just call the default export 'setUp',
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * which does all that for you; just pass in your store as an argument.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */var LOCAL_STORE_KEY = 'redux_state';function createListener(store) {return function listener() {_LocalStore2.default.set(LOCAL_STORE_KEY, store.getState());};}function createRehydrationAction() {var storedState = _LocalStore2.default.get(LOCAL_STORE_KEY, undefined);if (storedState === undefined) {return Actions.noop();} else {return Actions.rehydrate(storedState);}}function setUp(store) {store.dispatch(createRehydrationAction());store.subscribe(createListener(store));}

/***/ },
/* 187 */
/***/ function(module, exports) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.noop = noop;exports.
	
	
	
	
	
	setAcousticRatio = setAcousticRatio;exports.
	
	
	
	
	
	
	
	setTreeLevels = setTreeLevels;exports.
	
	
	
	
	
	
	
	setInfiniteTreeLevels = setInfiniteTreeLevels;exports.
	
	
	
	
	
	
	
	setInfiniteTreeHeight = setInfiniteTreeHeight;exports.
	
	
	
	
	
	
	
	setTreeShowRoots = setTreeShowRoots;exports.
	
	
	
	
	
	
	
	setTreeShowOctaves = setTreeShowOctaves;exports.
	
	
	
	
	
	
	
	setTreeWide = setTreeWide;exports.
	
	
	
	
	
	
	
	setTreeTreeNumber = setTreeTreeNumber;exports.
	
	
	
	
	
	
	
	setTreeRootBass = setTreeRootBass;exports.
	
	
	
	
	
	
	
	setTreeHighQuality = setTreeHighQuality;exports.
	
	
	
	
	
	
	
	setTreeRainbowFactor = setTreeRainbowFactor;exports.
	
	
	
	
	
	
	
	setTreeAlwaysEngrave = setTreeAlwaysEngrave;exports.
	
	
	
	
	
	
	
	setTreeLimitValue = setTreeLimitValue;exports.
	
	
	
	
	
	
	
	setTreeLimitEnabled = setTreeLimitEnabled;exports.
	
	
	
	
	
	
	
	rehydrate = rehydrate;function noop() {return { type: "NOOP" };}function setAcousticRatio(index, ratio) {return { type: "SET_ACOUSTIC_RATIO", index: index, ratio: ratio };}function setTreeLevels(levels) {return { type: "SET_TREE_VIEW_OPTION", field: "levels", value: levels };}function setInfiniteTreeLevels(levels) {return { type: "SET_TREE_VIEW_OPTION", field: "infiniteLevels", value: levels };}function setInfiniteTreeHeight(height) {return { type: "SET_TREE_VIEW_OPTION", field: "infiniteHeight", value: height };}function setTreeShowRoots(showRoots) {return { type: "SET_TREE_VIEW_OPTION", field: "showRoots", value: showRoots };}function setTreeShowOctaves(showOctaves) {return { type: "SET_TREE_VIEW_OPTION", field: "showOctaves", value: showOctaves };}function setTreeWide(wide) {return { type: "SET_TREE_VIEW_OPTION", field: "wide", value: wide };}function setTreeTreeNumber(treeNumber) {return { type: "SET_TREE_VIEW_OPTION", field: "treeNumber", value: treeNumber };}function setTreeRootBass(rootBass) {return { type: "SET_TREE_VIEW_OPTION", field: "rootBass", value: rootBass };}function setTreeHighQuality(highQuality) {return { type: "SET_TREE_VIEW_OPTION", field: "highQuality", value: highQuality };}function setTreeRainbowFactor(rainbowFactor) {return { type: "SET_TREE_VIEW_OPTION", field: "rainbowFactor", value: rainbowFactor };}function setTreeAlwaysEngrave(alwaysEngrave) {return { type: "SET_TREE_VIEW_OPTION", field: "alwaysEngrave", value: alwaysEngrave };}function setTreeLimitValue(limit, value) {return { type: "SET_TREE_LIMIT_VALUE", limit: limit, value: value };}function setTreeLimitEnabled(limit, enabled) {return { type: "SET_TREE_LIMIT_ENABLED", limit: limit, enabled: enabled };}function rehydrate(newState) {
	    return { 
	        type: "REHYDRATE", 
	        newState: newState };}

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _reactRouter = __webpack_require__(189);var _PitchCalculator = __webpack_require__(235);var _PitchCalculator2 = _interopRequireDefault(_PitchCalculator);var _TreeExplorer = __webpack_require__(246);var _TreeExplorer2 = _interopRequireDefault(_TreeExplorer);var _InfiniteTreeExplorer = __webpack_require__(259);var _InfiniteTreeExplorer2 = _interopRequireDefault(_InfiniteTreeExplorer);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var 
	
	
	
	
	
	
	App = (function (_Component) {_inherits(App, _Component);function App() {_classCallCheck(this, App);return _possibleConstructorReturn(this, Object.getPrototypeOf(App).apply(this, arguments));}_createClass(App, [{ key: 'render', value: function render() 
	        {
	            return _react2.default.createElement('div', null, 
	            _react2.default.createElement(_reactRouter.Router, null, 
	            _react2.default.createElement(_reactRouter.Redirect, { from: '/', to: 'calculator' }), 
	            _react2.default.createElement(_reactRouter.Route, { path: 'calculator', component: _PitchCalculator2.default }), 
	            _react2.default.createElement(_reactRouter.Route, { path: 'tree', component: _TreeExplorer2.default }), 
	            _react2.default.createElement(_reactRouter.Route, { path: 'infinite-tree', component: _InfiniteTreeExplorer2.default })));} }]);return App;})(_react.Component);exports.default = App;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/* components */
	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Router2 = __webpack_require__(190);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	exports.Router = _Router3['default'];
	
	var _Link2 = __webpack_require__(223);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	exports.Link = _Link3['default'];
	
	var _IndexLink2 = __webpack_require__(224);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	exports.IndexLink = _IndexLink3['default'];
	
	/* components (configuration) */
	
	var _IndexRedirect2 = __webpack_require__(225);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	exports.IndexRedirect = _IndexRedirect3['default'];
	
	var _IndexRoute2 = __webpack_require__(227);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	exports.IndexRoute = _IndexRoute3['default'];
	
	var _Redirect2 = __webpack_require__(226);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	exports.Redirect = _Redirect3['default'];
	
	var _Route2 = __webpack_require__(228);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	exports.Route = _Route3['default'];
	
	/* mixins */
	
	var _History2 = __webpack_require__(229);
	
	var _History3 = _interopRequireDefault(_History2);
	
	exports.History = _History3['default'];
	
	var _Lifecycle2 = __webpack_require__(230);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	exports.Lifecycle = _Lifecycle3['default'];
	
	var _RouteContext2 = __webpack_require__(231);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	exports.RouteContext = _RouteContext3['default'];
	
	/* utils */
	
	var _useRoutes2 = __webpack_require__(212);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	exports.useRoutes = _useRoutes3['default'];
	
	var _RouteUtils = __webpack_require__(208);
	
	exports.createRoutes = _RouteUtils.createRoutes;
	
	var _RoutingContext2 = __webpack_require__(209);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	exports.RoutingContext = _RoutingContext3['default'];
	
	var _PropTypes2 = __webpack_require__(222);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	exports.PropTypes = _PropTypes3['default'];
	
	var _match2 = __webpack_require__(232);
	
	var _match3 = _interopRequireDefault(_match2);
	
	exports.match = _match3['default'];
	
	var _Router4 = _interopRequireDefault(_Router2);
	
	exports['default'] = _Router4['default'];

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _historyLibCreateHashHistory = __webpack_require__(192);
	
	var _historyLibCreateHashHistory2 = _interopRequireDefault(_historyLibCreateHashHistory);
	
	var _RouteUtils = __webpack_require__(208);
	
	var _RoutingContext = __webpack_require__(209);
	
	var _RoutingContext2 = _interopRequireDefault(_RoutingContext);
	
	var _useRoutes = __webpack_require__(212);
	
	var _useRoutes2 = _interopRequireDefault(_useRoutes);
	
	var _PropTypes = __webpack_require__(222);
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RoutingContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = (function (_Component) {
	  _inherits(Router, _Component);
	
	  function Router(props, context) {
	    _classCallCheck(this, Router);
	
	    _Component.call(this, props, context);
	
	    this.state = {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  }
	
	  Router.prototype.handleError = function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var history = _props.history;
	    var children = _props.children;
	    var routes = _props.routes;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	    var createHistory = history ? function () {
	      return history;
	    } : _historyLibCreateHashHistory2['default'];
	
	    this.history = _useRoutes2['default'](createHistory)({
	      routes: _RouteUtils.createRoutes(routes || children),
	      parseQueryString: parseQueryString,
	      stringifyQuery: stringifyQuery
	    });
	
	    this._unlisten = this.history.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  };
	
	  /* istanbul ignore next: sanity check */
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    process.env.NODE_ENV !== 'production' ? _warning2['default'](nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : undefined;
	
	    process.env.NODE_ENV !== 'production' ? _warning2['default']((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : undefined;
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props2 = this.props;
	    var RoutingContext = _props2.RoutingContext;
	    var createElement = _props2.createElement;
	
	    var props = _objectWithoutProperties(_props2, ['RoutingContext', 'createElement']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return _react2['default'].createElement(RoutingContext, _extends({}, props, {
	      history: this.history,
	      createElement: createElement,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components
	    }));
	  };
	
	  return Router;
	})(_react.Component);
	
	Router.propTypes = {
	  history: object,
	  children: _PropTypes.routes,
	  routes: _PropTypes.routes, // alias for children
	  RoutingContext: func.isRequired,
	  createElement: func,
	  onError: func,
	  onUpdate: func,
	  parseQueryString: func,
	  stringifyQuery: func
	};
	
	Router.defaultProps = {
	  RoutingContext: _RoutingContext2['default']
	};
	
	exports['default'] = Router;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (process.env.NODE_ENV !== 'production') {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(177);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(193);
	
	var _ExecutionEnvironment = __webpack_require__(194);
	
	var _DOMUtils = __webpack_require__(195);
	
	var _DOMStateStorage = __webpack_require__(196);
	
	var _createDOMHistory = __webpack_require__(197);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	var _parsePath = __webpack_require__(204);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ? process.env.NODE_ENV !== 'production' ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _parsePath2['default'](path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	        process.env.NODE_ENV !== 'production' ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	    process.env.NODE_ENV !== 'production' ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	    process.env.NODE_ENV !== 'production' ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	    process.env.NODE_ENV !== 'production' ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    process.env.NODE_ENV !== 'production' ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    process.env.NODE_ENV !== 'production' ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 193 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 194 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 195 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  // FIXME: Work around our browser history not working correctly on Chrome
	  // iOS: https://github.com/rackt/react-router/issues/2565
	  if (ua.indexOf('CriOS') !== -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededError = 'QuotaExceededError';
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	      process.env.NODE_ENV !== 'production' ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (error.name === QuotaExceededError && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	      process.env.NODE_ENV !== 'production' ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	      process.env.NODE_ENV !== 'production' ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(177);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(194);
	
	var _DOMUtils = __webpack_require__(195);
	
	var _createHistory = __webpack_require__(198);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ? process.env.NODE_ENV !== 'production' ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	//import warning from 'warning'
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deepEqual = __webpack_require__(199);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _AsyncUtils = __webpack_require__(202);
	
	var _Actions = __webpack_require__(193);
	
	var _createLocation2 = __webpack_require__(203);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(206);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _parsePath = __webpack_require__(204);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	var _deprecate = __webpack_require__(207);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var keyLength = options.keyLength;
	  var getUserConfirmation = options.getUserConfirmation;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	      //warning(
	      //  false,
	      //  'The state (2nd) argument to history.createLocation is deprecated; use a ' +
	      //  'location descriptor instead'
	      //)
	
	      if (typeof location === 'string') location = _parsePath2['default'](location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _parsePath2['default'](path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _parsePath2['default'](path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(200);
	var isArguments = __webpack_require__(201);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 200 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 201 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 202 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0;
	  var isDone = false;
	
	  function done() {
	    isDone = true;
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) return;
	
	    if (currentTurn < turns) {
	      work.call(this, currentTurn++, next, done);
	    } else {
	      done.apply(this, arguments);
	    }
	  }
	
	  next();
	}

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	//import warning from 'warning'
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Actions = __webpack_require__(193);
	
	var _parsePath = __webpack_require__(204);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _parsePath2['default'](location);
	
	  if (typeof action === 'object') {
	    //warning(
	    //  false,
	    //  'The state (2nd) argument to createLocation is deprecated; use a ' +
	    //  'location descriptor instead'
	    //)
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _extractPath = __webpack_require__(205);
	
	var _extractPath2 = _interopRequireDefault(_extractPath);
	
	function parsePath(path) {
	  var pathname = _extractPath2['default'](path);
	  var search = '';
	  var hash = '';
	
	  process.env.NODE_ENV !== 'production' ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}
	
	exports['default'] = parsePath;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 205 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	exports["default"] = extractPath;
	module.exports = exports["default"];

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	    process.env.NODE_ENV !== 'production' ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 207 */
/***/ function(module, exports) {

	//import warning from 'warning'
	
	"use strict";
	
	exports.__esModule = true;
	function deprecate(fn) {
	  return fn;
	  //return function () {
	  //  warning(false, '[history] ' + message)
	  //  return fn.apply(this, arguments)
	  //}
	}
	
	exports["default"] = deprecate;
	module.exports = exports["default"];

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function isValidChild(object) {
	  return object == null || _react2['default'].isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function checkPropTypes(componentName, propTypes, props) {
	  componentName = componentName || 'UnknownComponent';
	
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error = propTypes[propName](props, propName, componentName);
	
	      /* istanbul ignore if: error logging */
	      if (error instanceof Error) process.env.NODE_ENV !== 'production' ? _warning2['default'](false, error.message) : undefined;
	    }
	  }
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (type.propTypes) checkPropTypes(type.displayName || type.name, type.propTypes, route);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *   
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2['default'].Children.forEach(children, function (element) {
	    if (_react2['default'].isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _invariant = __webpack_require__(177);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouteUtils = __webpack_require__(208);
	
	var _getRouteParams = __webpack_require__(210);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RoutingContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RoutingContext = (function (_Component) {
	  _inherits(RoutingContext, _Component);
	
	  function RoutingContext() {
	    _classCallCheck(this, RoutingContext);
	
	    _Component.apply(this, arguments);
	  }
	
	  RoutingContext.prototype.getChildContext = function getChildContext() {
	    var _props = this.props;
	    var history = _props.history;
	    var location = _props.location;
	
	    return { history: history, location: location };
	  };
	
	  RoutingContext.prototype.createElement = function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  };
	
	  RoutingContext.prototype.render = function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = _getRouteParams2['default'](route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if (_RouteUtils.isReactChildren(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (element.hasOwnProperty(prop)) props[prop] = element[prop];
	          }
	        }
	
	        if (typeof components === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (components.hasOwnProperty(key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2['default'].isValidElement(element)) ? process.env.NODE_ENV !== 'production' ? _invariant2['default'](false, 'The root route must render a single element') : _invariant2['default'](false) : undefined;
	
	    return element;
	  };
	
	  return RoutingContext;
	})(_react.Component);
	
	RoutingContext.propTypes = {
	  history: object.isRequired,
	  createElement: func.isRequired,
	  location: object.isRequired,
	  routes: array.isRequired,
	  params: object.isRequired,
	  components: array.isRequired
	};
	
	RoutingContext.defaultProps = {
	  createElement: _react2['default'].createElement
	};
	
	RoutingContext.childContextTypes = {
	  history: object.isRequired,
	  location: object.isRequired
	};
	
	exports['default'] = RoutingContext;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(211);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  var paramNames = _PatternUtils.getParamNames(route.path);
	
	  for (var p in params) {
	    if (params.hasOwnProperty(p) && paramNames.indexOf(p) !== -1) routeParams[p] = params[p];
	  }return routeParams;
	}
	
	exports['default'] = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(177);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function escapeSource(string) {
	  return escapeRegExp(string).replace(/\/+/g, '/+');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = undefined,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeSource(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/?#]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '([\\s\\S]*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '([\\s\\S]*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeSource(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = {};
	
	function compilePattern(pattern) {
	  if (!(pattern in CompiledPatternsCache)) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	
	function matchPattern(pattern, pathname) {
	  // Make leading slashes consistent between pattern and pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	  regexpSource += '/*'; // Capture path separators
	
	  // Special-case patterns like '*' for catch-all routes.
	  var captureRemaining = tokens[tokens.length - 1] !== '*';
	
	  if (captureRemaining) {
	    // This will match newlines in the remaining path.
	    regexpSource += '([\\s\\S]*?)';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource + '$', 'i'));
	
	  var remainingPathname = undefined,
	      paramValues = undefined;
	  if (match != null) {
	    if (captureRemaining) {
	      remainingPathname = match.pop();
	      var matchedPath = match[0].substr(0, match[0].length - remainingPathname.length);
	
	      // If we didn't match the entire pathname, then make sure that the match
	      // we did get ends at a path separator (potentially the one we added
	      // above at the beginning of the path, if the actual match was empty).
	      if (remainingPathname && matchedPath.charAt(matchedPath.length - 1) !== '/') {
	        return {
	          remainingPathname: null,
	          paramNames: paramNames,
	          paramValues: null
	        };
	      }
	    } else {
	      // If this matched at all, then the match was the entire pathname.
	      remainingPathname = '';
	    }
	
	    paramValues = match.slice(1).map(function (v) {
	      return v != null ? decodeURIComponent(v) : v;
	    });
	  } else {
	    remainingPathname = paramValues = null;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: paramValues
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var _matchPattern = matchPattern(pattern, pathname);
	
	  var paramNames = _matchPattern.paramNames;
	  var paramValues = _matchPattern.paramValues;
	
	  if (paramValues != null) {
	    return paramNames.reduce(function (memo, paramName, index) {
	      memo[paramName] = paramValues[index];
	      return memo;
	    }, {});
	  }
	
	  return null;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = undefined,
	      paramName = undefined,
	      paramValue = undefined;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ? process.env.NODE_ENV !== 'production' ? _invariant2['default'](false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : _invariant2['default'](false) : undefined;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ? process.env.NODE_ENV !== 'production' ? _invariant2['default'](false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : _invariant2['default'](false) : undefined;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _historyLibActions = __webpack_require__(193);
	
	var _historyLibUseQueries = __webpack_require__(213);
	
	var _historyLibUseQueries2 = _interopRequireDefault(_historyLibUseQueries);
	
	var _computeChangedRoutes2 = __webpack_require__(216);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(217);
	
	var _isActive2 = __webpack_require__(219);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(220);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(221);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (object.hasOwnProperty(p)) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var routes = options.routes;
	
	    var historyOptions = _objectWithoutProperties(options, ['routes']);
	
	    var history = _historyLibUseQueries2['default'](createHistory)(historyOptions);
	    var state = {};
	
	    function isActive(pathname, query) {
	      var indexOnly = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	      return _isActive3['default'](pathname, query, indexOnly, state.location, state.routes, state.params);
	    }
	
	    function createLocationFromRedirectInfo(_ref) {
	      var pathname = _ref.pathname;
	      var query = _ref.query;
	      var state = _ref.state;
	
	      return history.createLocation(history.createPath(pathname, query), state, _historyLibActions.REPLACE);
	    }
	
	    var partialNextState = undefined;
	
	    function match(location, callback) {
	      if (partialNextState && partialNextState.location === location) {
	        // Continue from where we left off.
	        finishMatch(partialNextState, callback);
	      } else {
	        _matchRoutes2['default'](routes, location, function (error, nextState) {
	          if (error) {
	            callback(error);
	          } else if (nextState) {
	            finishMatch(_extends({}, nextState, { location: location }), callback);
	          } else {
	            callback();
	          }
	        });
	      }
	    }
	
	    function finishMatch(nextState, callback) {
	      var _computeChangedRoutes = _computeChangedRoutes3['default'](state, nextState);
	
	      var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	      var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	      _TransitionUtils.runLeaveHooks(leaveRoutes);
	
	      _TransitionUtils.runEnterHooks(enterRoutes, nextState, function (error, redirectInfo) {
	        if (error) {
	          callback(error);
	        } else if (redirectInfo) {
	          callback(null, createLocationFromRedirectInfo(redirectInfo));
	        } else {
	          // TODO: Fetch components after state is updated.
	          _getComponents2['default'](nextState, function (error, components) {
	            if (error) {
	              callback(error);
	            } else {
	              // TODO: Make match a pure function and have some other API
	              // for "match and update state".
	              callback(null, null, state = _extends({}, nextState, { components: components }));
	            }
	          });
	        }
	      });
	    }
	
	    var RouteGuid = 1;
	
	    function getRouteID(route) {
	      return route.__id__ || (route.__id__ = RouteGuid++);
	    }
	
	    var RouteHooks = {};
	
	    function getRouteHooksForRoutes(routes) {
	      return routes.reduce(function (hooks, route) {
	        hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	        return hooks;
	      }, []);
	    }
	
	    function transitionHook(location, callback) {
	      _matchRoutes2['default'](routes, location, function (error, nextState) {
	        if (nextState == null) {
	          // TODO: We didn't actually match anything, but hang
	          // onto error/nextState so we don't have to matchRoutes
	          // again in the listen callback.
	          callback();
	          return;
	        }
	
	        // Cache some state here so we don't have to
	        // matchRoutes() again in the listen callback.
	        partialNextState = _extends({}, nextState, { location: location });
	
	        var hooks = getRouteHooksForRoutes(_computeChangedRoutes3['default'](state, partialNextState).leaveRoutes);
	
	        var result = undefined;
	        for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	          // Passing the location arg here indicates to
	          // the user that this is a transition hook.
	          result = hooks[i](location);
	        }
	
	        callback(result);
	      });
	    }
	
	    function beforeUnloadHook() {
	      // Synchronously check to see if any route hooks want
	      // to prevent the current window/tab from closing.
	      if (state.routes) {
	        var hooks = getRouteHooksForRoutes(state.routes);
	
	        var message = undefined;
	        for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	          // Passing no args indicates to the user that this is a
	          // beforeunload hook. We don't know the next location.
	          message = hooks[i]();
	        }
	
	        return message;
	      }
	    }
	
	    var unlistenBefore = undefined,
	        unlistenBeforeUnload = undefined;
	
	    /**
	     * Registers the given hook function to run before leaving the given route.
	     *
	     * During a normal transition, the hook function receives the next location
	     * as its only argument and must return either a) a prompt message to show
	     * the user, to make sure they want to leave the page or b) false, to prevent
	     * the transition.
	     *
	     * During the beforeunload event (in browsers) the hook receives no arguments.
	     * In this case it must return a prompt message to prevent the transition.
	     *
	     * Returns a function that may be used to unbind the listener.
	     */
	    function listenBeforeLeavingRoute(route, hook) {
	      // TODO: Warn if they register for a route that isn't currently
	      // active. They're probably doing something wrong, like re-creating
	      // route objects on every location change.
	      var routeID = getRouteID(route);
	      var hooks = RouteHooks[routeID];
	
	      if (hooks == null) {
	        var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	        hooks = RouteHooks[routeID] = [hook];
	
	        if (thereWereNoRouteHooks) {
	          // setup transition & beforeunload hooks
	          unlistenBefore = history.listenBefore(transitionHook);
	
	          if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	        }
	      } else if (hooks.indexOf(hook) === -1) {
	        hooks.push(hook);
	      }
	
	      return function () {
	        var hooks = RouteHooks[routeID];
	
	        if (hooks != null) {
	          var newHooks = hooks.filter(function (item) {
	            return item !== hook;
	          });
	
	          if (newHooks.length === 0) {
	            delete RouteHooks[routeID];
	
	            if (!hasAnyProperties(RouteHooks)) {
	              // teardown transition & beforeunload hooks
	              if (unlistenBefore) {
	                unlistenBefore();
	                unlistenBefore = null;
	              }
	
	              if (unlistenBeforeUnload) {
	                unlistenBeforeUnload();
	                unlistenBeforeUnload = null;
	              }
	            }
	          } else {
	            RouteHooks[routeID] = newHooks;
	          }
	        }
	      };
	    }
	
	    /**
	     * This is the API for stateful environments. As the location
	     * changes, we update state and call the listener. We can also
	     * gracefully handle errors and redirects.
	     */
	    function listen(listener) {
	      // TODO: Only use a single history listener. Otherwise we'll
	      // end up with multiple concurrent calls to match.
	      return history.listen(function (location) {
	        if (state.location === location) {
	          listener(null, state);
	        } else {
	          match(location, function (error, redirectLocation, nextState) {
	            if (error) {
	              listener(error);
	            } else if (redirectLocation) {
	              history.transitionTo(redirectLocation);
	            } else if (nextState) {
	              listener(null, nextState);
	            } else {
	              process.env.NODE_ENV !== 'production' ? _warning2['default'](false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : undefined;
	            }
	          });
	        }
	      });
	    }
	
	    return _extends({}, history, {
	      isActive: isActive,
	      match: match,
	      listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	      listen: listen
	    });
	  };
	}
	
	exports['default'] = useRoutes;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(214);
	
	var _runTransitionHook = __webpack_require__(206);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _parsePath = __webpack_require__(204);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	var _deprecate = __webpack_require__(207);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (object.hasOwnProperty(p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    var historyOptions = _objectWithoutProperties(options, ['stringifyQuery', 'parseQueryString']);
	
	    var history = createHistory(historyOptions);
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var queryString = undefined;
	      if (!query || (queryString = stringifyQuery(query)) === '') return location;
	
	      process.env.NODE_ENV !== 'production' ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _parsePath2['default'](location);
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase + (searchBase ? '&' : '?') + queryString;
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	      //warning(
	      //  !query,
	      //  'the query argument to createPath is deprecated; use a location descriptor instead'
	      //)
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	      //warning(
	      //  !query,
	      //  'the query argument to createHref is deprecated; use a location descriptor instead'
	      //)
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation() {
	      return addQuery(history.createLocation.apply(history, arguments));
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _parsePath2['default'](path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _parsePath2['default'](path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(215);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 215 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16);
		});
	};


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(211);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = _PatternUtils.getParamNames(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = undefined,
	      enterRoutes = undefined;
	  if (prevRoutes) {
	    leaveRoutes = prevRoutes.filter(function (route) {
	      return nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = nextRoutes.filter(function (route) {
	      return prevRoutes.indexOf(route) === -1 || leaveRoutes.indexOf(route) !== -1;
	    });
	  } else {
	    leaveRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports['default'] = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(218);
	
	function createEnterHook(hook, route) {
	  return function (a, b, callback) {
	    hook.apply(route, arguments);
	
	    if (hook.length < 3) {
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createEnterHook(route.onEnter, route));
	
	    return hooks;
	  }, []);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replaceState, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replaceState short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	
	  if (!hooks.length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = undefined;
	  function replaceState(state, pathname, query) {
	    redirectInfo = { pathname: pathname, query: query, state: state };
	  }
	
	  _AsyncUtils.loopAsync(hooks.length, function (index, next, done) {
	    hooks[index](nextState, replaceState, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	          next();
	        }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	
	function runLeaveHooks(routes) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i]);
	  }
	}

/***/ },
/* 218 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	
	  function done() {
	    isDone = true;
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) return;
	
	    if (currentTurn < turns) {
	      work.call(this, currentTurn++, next, done);
	    } else {
	      done.apply(this, arguments);
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(211);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if (typeof a === 'object') {
	    for (var p in a) {
	      if (!a.hasOwnProperty(p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!b.hasOwnProperty(p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	function paramsAreActive(paramNames, paramValues, activeParams) {
	  // FIXME: This doesn't work on repeated params in activeParams.
	  return paramNames.every(function (paramName, index) {
	    return String(paramValues[index]) === String(activeParams[paramName]);
	  });
	}
	
	function getMatchingRouteIndex(pathname, activeRoutes, activeParams) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  for (var i = 0, len = activeRoutes.length; i < len; ++i) {
	    var route = activeRoutes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null) {
	      var matched = _PatternUtils.matchPattern(pattern, remainingPathname);
	      remainingPathname = matched.remainingPathname;
	      paramNames = [].concat(paramNames, matched.paramNames);
	      paramValues = [].concat(paramValues, matched.paramValues);
	    }
	
	    if (remainingPathname === '' && route.path && paramsAreActive(paramNames, paramValues, activeParams)) return i;
	  }
	
	  return null;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes
	 * and params.
	 */
	function routeIsActive(pathname, routes, params, indexOnly) {
	  var i = getMatchingRouteIndex(pathname, routes, params);
	
	  if (i === null) {
	    // No match.
	    return false;
	  } else if (!indexOnly) {
	    // Any match is good enough.
	    return true;
	  }
	
	  // If any remaining routes past the match index have paths, then we can't
	  // be on the index route.
	  return routes.slice(i + 1).every(function (route) {
	    return !route.path;
	  });
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(pathname, query, indexOnly, location, routes, params) {
	  if (location == null) return false;
	
	  if (!routeIsActive(pathname, routes, params, indexOnly)) return false;
	
	  return queryIsActive(query, location.query);
	}
	
	exports['default'] = isActive;
	module.exports = exports['default'];

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(218);
	
	function getComponentsForRoute(location, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	  } else if (route.getComponent) {
	    route.getComponent(location, callback);
	  } else if (route.getComponents) {
	    route.getComponents(location, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  _AsyncUtils.mapAsync(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState.location, route, callback);
	  }, callback);
	}
	
	exports['default'] = getComponents;
	module.exports = exports['default'];

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _AsyncUtils = __webpack_require__(218);
	
	var _PatternUtils = __webpack_require__(211);
	
	var _RouteUtils = __webpack_require__(208);
	
	function getChildRoutes(route, location, callback) {
	  if (route.childRoutes) {
	    callback(null, route.childRoutes);
	  } else if (route.getChildRoutes) {
	    route.getChildRoutes(location, function (error, childRoutes) {
	      callback(error, !error && _RouteUtils.createRoutes(childRoutes));
	    });
	  } else {
	    callback();
	  }
	}
	
	function getIndexRoute(route, location, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    route.getIndexRoute(location, function (error, indexRoute) {
	      callback(error, !error && _RouteUtils.createRoutes(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (obj) {
	        return !obj.hasOwnProperty('path');
	      });
	
	      _AsyncUtils.loopAsync(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  if (remainingPathname !== null) {
	    var matched = _PatternUtils.matchPattern(pattern, remainingPathname);
	    remainingPathname = matched.remainingPathname;
	    paramNames = [].concat(paramNames, matched.paramNames);
	    paramValues = [].concat(paramValues, matched.paramValues);
	
	    if (remainingPathname === '' && route.path) {
	      var _ret2 = (function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	              process.env.NODE_ENV !== 'production' ? _warning2['default'](indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : undefined;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	              process.env.NODE_ENV !== 'production' ? _warning2['default'](!indexRoute.path, 'Index routes should not have paths') : undefined;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	        return {
	          v: undefined
	        };
	      })();
	
	      if (typeof _ret2 === 'object') return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    getChildRoutes(route, location, function (error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    });
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback) {
	  var remainingPathname = arguments.length <= 3 || arguments[3] === undefined ? location.pathname : arguments[3];
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	  return (function () {
	    _AsyncUtils.loopAsync(routes.length, function (index, next, done) {
	      matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	        if (error || match) {
	          done(error, match);
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  })();
	}
	
	exports['default'] = matchRoutes;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(2);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = shape({
	  listen: func.isRequired,
	  pushState: func.isRequired,
	  replaceState: func.isRequired,
	  go: func.isRequired
	});
	
	exports.history = history;
	var location = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	exports.location = location;
	var component = oneOfType([func, string]);
	exports.component = component;
	var components = oneOfType([component, object]);
	exports.components = components;
	var route = oneOfType([object, element]);
	exports.route = route;
	var routes = oneOfType([route, arrayOf(route)]);
	
	exports.routes = routes;
	exports['default'] = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route
	};

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (object.hasOwnProperty(p)) return false;
	  }return true;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * `activeClassName` prop
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	
	var Link = (function (_Component) {
	  _inherits(Link, _Component);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    _Component.apply(this, arguments);
	  }
	
	  Link.prototype.handleClick = function handleClick(event) {
	    var allowTransition = true;
	
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    if (event.defaultPrevented === true) allowTransition = false;
	
	    // If target prop is set (e.g. to "_blank") let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) {
	      if (!allowTransition) event.preventDefault();
	
	      return;
	    }
	
	    event.preventDefault();
	
	    if (allowTransition) {
	      var _props = this.props;
	      var state = _props.state;
	      var to = _props.to;
	      var query = _props.query;
	      var hash = _props.hash;
	
	      if (hash) to += hash;
	
	      this.context.history.pushState(state, to, query);
	    }
	  };
	
	  Link.prototype.render = function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Manually override onClick.
	    props.onClick = function (e) {
	      return _this.handleClick(e);
	    };
	
	    // Ignore if rendered outside the context of history, simplifies unit testing.
	    var history = this.context.history;
	
	    if (history) {
	      props.href = history.createHref(to, query);
	
	      if (hash) props.href += hash;
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (history.isActive(to, query, onlyActiveOnIndex)) {
	          if (activeClassName) props.className += props.className === '' ? activeClassName : ' ' + activeClassName;
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2['default'].createElement('a', props);
	  };
	
	  return Link;
	})(_react.Component);
	
	Link.contextTypes = {
	  history: object
	};
	
	Link.propTypes = {
	  to: string.isRequired,
	  query: object,
	  hash: string,
	  state: object,
	  activeStyle: object,
	  activeClassName: string,
	  onlyActiveOnIndex: bool.isRequired,
	  onClick: func
	};
	
	Link.defaultProps = {
	  onlyActiveOnIndex: false,
	  className: '',
	  style: {}
	};
	
	exports['default'] = Link;
	module.exports = exports['default'];

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(223);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	
	var IndexLink = (function (_Component) {
	  _inherits(IndexLink, _Component);
	
	  function IndexLink() {
	    _classCallCheck(this, IndexLink);
	
	    _Component.apply(this, arguments);
	  }
	
	  IndexLink.prototype.render = function render() {
	    return _react2['default'].createElement(_Link2['default'], _extends({}, this.props, { onlyActiveOnIndex: true }));
	  };
	
	  return IndexLink;
	})(_react.Component);
	
	exports['default'] = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(177);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Redirect = __webpack_require__(226);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _PropTypes = __webpack_require__(222);
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = (function (_Component) {
	  _inherits(IndexRedirect, _Component);
	
	  function IndexRedirect() {
	    _classCallCheck(this, IndexRedirect);
	
	    _Component.apply(this, arguments);
	  }
	
	  /* istanbul ignore next: sanity check */
	
	  IndexRedirect.prototype.render = function render() {
	     true ? process.env.NODE_ENV !== 'production' ? _invariant2['default'](false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : _invariant2['default'](false) : undefined;
	  };
	
	  return IndexRedirect;
	})(_react.Component);
	
	IndexRedirect.propTypes = {
	  to: string.isRequired,
	  query: object,
	  state: object,
	  onEnter: _PropTypes.falsy,
	  children: _PropTypes.falsy
	};
	
	IndexRedirect.createRouteFromReactElement = function (element, parentRoute) {
	  /* istanbul ignore else: sanity check */
	  if (parentRoute) {
	    parentRoute.indexRoute = _Redirect2['default'].createRouteFromReactElement(element);
	  } else {
	    process.env.NODE_ENV !== 'production' ? _warning2['default'](false, 'An <IndexRedirect> does not make sense at the root of your route config') : undefined;
	  }
	};
	
	exports['default'] = IndexRedirect;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _invariant = __webpack_require__(177);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouteUtils = __webpack_require__(208);
	
	var _PatternUtils = __webpack_require__(211);
	
	var _PropTypes = __webpack_require__(222);
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = (function (_Component) {
	  _inherits(Redirect, _Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    _Component.apply(this, arguments);
	  }
	
	  /* istanbul ignore next: sanity check */
	
	  Redirect.prototype.render = function render() {
	     true ? process.env.NODE_ENV !== 'production' ? _invariant2['default'](false, '<Redirect> elements are for router configuration only and should not be rendered') : _invariant2['default'](false) : undefined;
	  };
	
	  return Redirect;
	})(_react.Component);
	
	Redirect.createRouteFromReactElement = function (element) {
	  var route = _RouteUtils.createRouteFromReactElement(element);
	
	  if (route.from) route.path = route.from;
	
	  route.onEnter = function (nextState, replaceState) {
	    var location = nextState.location;
	    var params = nextState.params;
	
	    var pathname = undefined;
	    if (route.to.charAt(0) === '/') {
	      pathname = _PatternUtils.formatPattern(route.to, params);
	    } else if (!route.to) {
	      pathname = location.pathname;
	    } else {
	      var routeIndex = nextState.routes.indexOf(route);
	      var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	      var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	      pathname = _PatternUtils.formatPattern(pattern, params);
	    }
	
	    replaceState(route.state || location.state, pathname, route.query || location.query);
	  };
	
	  return route;
	};
	
	Redirect.getRoutePattern = function (routes, routeIndex) {
	  var parentPattern = '';
	
	  for (var i = routeIndex; i >= 0; i--) {
	    var route = routes[i];
	    var pattern = route.path || '';
	    parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	    if (pattern.indexOf('/') === 0) break;
	  }
	
	  return '/' + parentPattern;
	};
	
	Redirect.propTypes = {
	  path: string,
	  from: string, // Alias for path
	  to: string.isRequired,
	  query: object,
	  state: object,
	  onEnter: _PropTypes.falsy,
	  children: _PropTypes.falsy
	};
	
	exports['default'] = Redirect;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(177);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouteUtils = __webpack_require__(208);
	
	var _PropTypes = __webpack_require__(222);
	
	var func = _react2['default'].PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = (function (_Component) {
	  _inherits(IndexRoute, _Component);
	
	  function IndexRoute() {
	    _classCallCheck(this, IndexRoute);
	
	    _Component.apply(this, arguments);
	  }
	
	  /* istanbul ignore next: sanity check */
	
	  IndexRoute.prototype.render = function render() {
	     true ? process.env.NODE_ENV !== 'production' ? _invariant2['default'](false, '<IndexRoute> elements are for router configuration only and should not be rendered') : _invariant2['default'](false) : undefined;
	  };
	
	  return IndexRoute;
	})(_react.Component);
	
	IndexRoute.propTypes = {
	  path: _PropTypes.falsy,
	  component: _PropTypes.component,
	  components: _PropTypes.components,
	  getComponent: func,
	  getComponents: func
	};
	
	IndexRoute.createRouteFromReactElement = function (element, parentRoute) {
	  /* istanbul ignore else: sanity check */
	  if (parentRoute) {
	    parentRoute.indexRoute = _RouteUtils.createRouteFromReactElement(element);
	  } else {
	    process.env.NODE_ENV !== 'production' ? _warning2['default'](false, 'An <IndexRoute> does not make sense at the root of your route config') : undefined;
	  }
	};
	
	exports['default'] = IndexRoute;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _invariant = __webpack_require__(177);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouteUtils = __webpack_require__(208);
	
	var _PropTypes = __webpack_require__(222);
	
	var _React$PropTypes = _react2['default'].PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = (function (_Component) {
	  _inherits(Route, _Component);
	
	  function Route() {
	    _classCallCheck(this, Route);
	
	    _Component.apply(this, arguments);
	  }
	
	  /* istanbul ignore next: sanity check */
	
	  Route.prototype.render = function render() {
	     true ? process.env.NODE_ENV !== 'production' ? _invariant2['default'](false, '<Route> elements are for router configuration only and should not be rendered') : _invariant2['default'](false) : undefined;
	  };
	
	  return Route;
	})(_react.Component);
	
	Route.createRouteFromReactElement = _RouteUtils.createRouteFromReactElement;
	
	Route.propTypes = {
	  path: string,
	  component: _PropTypes.component,
	  components: _PropTypes.components,
	  getComponent: func,
	  getComponents: func
	};
	
	exports['default'] = Route;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PropTypes = __webpack_require__(222);
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _PropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.history = this.context.history;
	  }
	
	};
	
	exports['default'] = History;
	module.exports = exports['default'];

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(177);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var object = _react2['default'].PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	    !this.routerWillLeave ? process.env.NODE_ENV !== 'production' ? _invariant2['default'](false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : _invariant2['default'](false) : undefined;
	
	    var route = this.props.route || this.context.route;
	
	    !route ? process.env.NODE_ENV !== 'production' ? _invariant2['default'](false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : _invariant2['default'](false) : undefined;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	
	};
	
	exports['default'] = Lifecycle;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var object = _react2['default'].PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  }
	
	};
	
	exports['default'] = RouteContext;
	module.exports = exports['default'];

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(177);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _historyLibCreateMemoryHistory = __webpack_require__(233);
	
	var _historyLibCreateMemoryHistory2 = _interopRequireDefault(_historyLibCreateMemoryHistory);
	
	var _historyLibUseBasename = __webpack_require__(234);
	
	var _historyLibUseBasename2 = _interopRequireDefault(_historyLibUseBasename);
	
	var _RouteUtils = __webpack_require__(208);
	
	var _useRoutes = __webpack_require__(212);
	
	var _useRoutes2 = _interopRequireDefault(_useRoutes);
	
	var createHistory = _useRoutes2['default'](_historyLibUseBasename2['default'](_historyLibCreateMemoryHistory2['default']));
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser. Use
	 * the history.listen API instead.
	 */
	function match(_ref, callback) {
	  var routes = _ref.routes;
	  var location = _ref.location;
	  var parseQueryString = _ref.parseQueryString;
	  var stringifyQuery = _ref.stringifyQuery;
	  var basename = _ref.basename;
	
	  !location ? process.env.NODE_ENV !== 'production' ? _invariant2['default'](false, 'match needs a location') : _invariant2['default'](false) : undefined;
	
	  var history = createHistory({
	    routes: _RouteUtils.createRoutes(routes),
	    parseQueryString: parseQueryString,
	    stringifyQuery: stringifyQuery,
	    basename: basename
	  });
	
	  // Allow match({ location: '/the/path', ... })
	  if (typeof location === 'string') location = history.createLocation(location);
	
	  history.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation, nextState && _extends({}, nextState, { history: history }));
	  });
	}
	
	exports['default'] = match;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(191);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(177);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(193);
	
	var _createHistory = __webpack_require__(198);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _parsePath = __webpack_require__(204);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ? process.env.NODE_ENV !== 'production' ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ? process.env.NODE_ENV !== 'production' ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var key = entry.key;
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var state = undefined;
	    if (key) {
	      state = readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	      entry.key = key;
	    }
	
	    var location = _parsePath2['default'](path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	        process.env.NODE_ENV !== 'production' ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _ExecutionEnvironment = __webpack_require__(194);
	
	var _runTransitionHook = __webpack_require__(206);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _extractPath = __webpack_require__(205);
	
	var _extractPath2 = _interopRequireDefault(_extractPath);
	
	var _parsePath = __webpack_require__(204);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	var _deprecate = __webpack_require__(207);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var basename = options.basename;
	
	    var historyOptions = _objectWithoutProperties(options, ['basename']);
	
	    var history = createHistory(historyOptions);
	
	    // Automatically use the value of <base href> in HTML
	    // documents as basename if it's not explicitly given.
	    if (basename == null && _ExecutionEnvironment.canUseDOM) {
	      var base = document.getElementsByTagName('base')[0];
	
	      if (base) basename = _extractPath2['default'](base.href);
	    }
	
	    function addBasename(location) {
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _parsePath2['default'](location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation() {
	      return addBasename(history.createLocation.apply(history, arguments));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _parsePath2['default'](path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _parsePath2['default'](path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _reactRedux = __webpack_require__(169);var _Actions = __webpack_require__(187);var 
	
	
	Actions = _interopRequireWildcard(_Actions);var _HarmonicSeries = __webpack_require__(184);var _Page = __webpack_require__(236);var _Page2 = _interopRequireDefault(_Page);var _ChordComputer = __webpack_require__(237);var _ChordComputer2 = _interopRequireDefault(_ChordComputer);var _RationalizerSettings = __webpack_require__(245);var _RationalizerSettings2 = _interopRequireDefault(_RationalizerSettings);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var 
	
	
	
	
	
	
	
	PitchCalculator = (function (_Component) {_inherits(PitchCalculator, _Component);function PitchCalculator() {_classCallCheck(this, PitchCalculator);return _possibleConstructorReturn(this, Object.getPrototypeOf(PitchCalculator).apply(this, arguments));}_createClass(PitchCalculator, [{ key: 'render', 
	
	        /* eslint-disable react/prop-types */value: function render() 
	        {
	            return _react2.default.createElement(_Page2.default, { path: 'calculator' }, 
	            _react2.default.createElement('h1', null, 'Pitch space root calculator'), 
	            _react2.default.createElement(_ChordComputer2.default, { 
	                rationalizer: (0, _HarmonicSeries.extendRationalizer)(this.props.acousticRatios) }), 
	
	            _react2.default.createElement(_RationalizerSettings2.default, { 
	                values: this.props.acousticRatios, 
	                onChangeValue: this.props.onSetAcousticRatio }));}
	
	
	
	        /* eslint-enable */ }]);return PitchCalculator;})(_react.Component);
	
	
	function mapStateToProps(state) {
	    return { 
	        acousticRatios: state.acousticRatios };}
	
	
	
	function mapDispatchToProps(dispatch) {
	    return { 
	        onSetAcousticRatio: function onSetAcousticRatio(index, ratio) {return dispatch(
	            Actions.setAcousticRatio(index, ratio));} };}exports.default = 
	
	
	
	(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PitchCalculator);

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _reactRouter = __webpack_require__(189);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var 
	
	
	Page = (function (_Component) {_inherits(Page, _Component);function Page() {_classCallCheck(this, Page);return _possibleConstructorReturn(this, Object.getPrototypeOf(Page).apply(this, arguments));}_createClass(Page, [{ key: 'render', value: function render() 
	        {var _this2 = this;
	            var NavEntry = function NavEntry(_ref) {var path = _ref.path;var name = _ref.name;var flag = _ref.flag;return (
	                    _react2.default.createElement('li', { className: path === _this2.props.path ? "active" : undefined }, 
	                    _react2.default.createElement(_reactRouter.Link, { to: '/' + path }, 
	                    name, 
	                    flag && _react2.default.createElement('span', { style: { 
	                            color: "red", 
	                            fontSize: "75%" } }, 
	
	                    ' ', 
	                    flag.toString().toUpperCase()))));};
	
	
	
	            NavEntry.propTypes = { 
	                path: _react.PropTypes.string.isRequired, 
	                name: _react.PropTypes.node.isRequired, 
	                flag: _react.PropTypes.string };
	
	            return _react2.default.createElement('div', null, 
	            _react2.default.createElement('nav', { className: 'navbar navbar-inverse navbar-static-top' }, 
	            _react2.default.createElement('div', { className: 'container' }, 
	            _react2.default.createElement('span', { className: 'navbar-brand' }, 'Varèse tools'), 
	            _react2.default.createElement('div', { className: 'collapse navbar-collapse' }, 
	            _react2.default.createElement('ul', { className: 'nav navbar-nav' }, 
	            this.props.links.map(function (props, idx) {return (
	                    _react2.default.createElement(NavEntry, _extends({}, props, { key: idx })));}))))), 
	
	
	
	
	            _react2.default.createElement('div', { className: 'container' }, this.props.children));} }]);return Page;})(_react.Component);exports.default = Page;
	
	
	
	Page.propTypes = { 
	    path: _react.PropTypes.string.isRequired, 
	    children: _react.PropTypes.node.isRequired, 
	    //
	    links: _react.PropTypes.arrayOf(_react.PropTypes.shape({ 
	        path: _react.PropTypes.string.isRequired, 
	        name: _react.PropTypes.node.isRequired, 
	        flag: _react.PropTypes.string }).
	    isRequired) };
	
	Page.defaultProps = { 
	    links: [
	    { path: "calculator", name: "Root calculator" }, 
	    { path: "tree", name: "Tree explorer" }, 
	    { path: "infinite-tree", name: "Infinite tree" }] };

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _PitchNames = __webpack_require__(238);var _PitchNames2 = _interopRequireDefault(_PitchNames);var _HarmonicSeries = __webpack_require__(184);var _DisplayUtils = __webpack_require__(239);var _ChordEngraving = __webpack_require__(240);var _ChordEngraving2 = _interopRequireDefault(_ChordEngraving);var _ChordInput = __webpack_require__(243);var _ChordInput2 = _interopRequireDefault(_ChordInput);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}
	
	
	
	
	
	
	
	
	var DEFAULT_CHORD = [3, 7, 10];var 
	
	ChordComputer = (function (_Component) {_inherits(ChordComputer, _Component);
	
	    function ChordComputer() {_classCallCheck(this, ChordComputer);var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChordComputer).call(this));
	
	        _this.state = { 
	            chord: DEFAULT_CHORD };return _this;}_createClass(ChordComputer, [{ key: 'render', value: function render() 
	
	
	
	        {var _this2 = this;
	            var example = function example(text) {var quote = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];return (
	                    _react2.default.createElement('span', null, 
	                    quote && '“' /* &ldquo; */, 
	                    _react2.default.createElement('code', { style: { 
	                            color: "black", 
	                            fontFamily: "monospace" } }, 
	                    text), 
	                    quote && '”' /* &rdquo; */));};
	
	
	            return _react2.default.createElement('div', null, 
	            _react2.default.createElement('p', null, 'Enter a chord like'), 
	
	
	            _react2.default.createElement('ul', null, 
	            _react2.default.createElement('li', null, 
	            example("C4 E4 G4"), 
	            " ", '(using scientific pitch notation);'), 
	
	
	            _react2.default.createElement('li', null, 
	            example("B#3 Fb4 G4"), 
	            " ", '(using ', 
	            example("#", false), ' for sharps and ', 
	            example("b", false), ' and flats);'), 
	
	            _react2.default.createElement('li', null, 
	            example("G, C E''"), 
	            " ", '(using relative pitch notation, where ', 
	
	            example(",", false), ' lowers a pitch by an octave and ', 
	            example("'", false), ' raises a pitch by an octave); or'), 
	
	            _react2.default.createElement('li', null, 
	            example("0 4 7"), " ", '(indicating semitones above middle C).')), 
	
	
	
	            _react2.default.createElement(_ChordInput2.default, { 
	                value: this.state.chord, 
	                message: 'Enter a chord: ', 
	                onChange: function onChange(chord) {return _this2.setState({ chord: chord });} }), 
	
	            _react2.default.createElement(ChordOutput, { 
	                chord: this.state.chord, 
	                rationalizer: this.props.rationalizer }));} }]);return ChordComputer;})(_react.Component);exports.default = ChordComputer;
	
	
	
	
	
	ChordComputer.propTypes = { 
	    rationalizer: _react.PropTypes.func.isRequired };var 
	
	
	ChordOutput = (function (_Component2) {_inherits(ChordOutput, _Component2);function ChordOutput() {_classCallCheck(this, ChordOutput);return _possibleConstructorReturn(this, Object.getPrototypeOf(ChordOutput).apply(this, arguments));}_createClass(ChordOutput, [{ key: 'render', value: function render() 
	        {var _props = 
	            this.props;var rationalizer = _props.rationalizer;var chord = _props.chord;
	            if (chord.length < 1) {
	                return _react2.default.createElement('div', { className: 'alert alert-info' }, 'There’s no chord there to analyze.');} else 
	
	
	            {
	                var maybeOffset = (0, _HarmonicSeries.findChordRootOffset)(rationalizer, chord);
	                if (maybeOffset.status === "success") {
	                    var offset = maybeOffset.result;
	                    var noun = offset === 1 ? "semitone" : "semitones";
	                    var str = offset.toString().replace(/-/g, '−');
	                    var note = _PitchNames2.default.pitchToName(offset, true);
	
	                    if (!(0, _DisplayUtils.withinEngravingRange)(chord)) {
	                        return _react2.default.createElement('div', { className: 'alert alert-info' }, 'The root of that chord is ', 
	                        _react2.default.createElement('strong', null, note), ', at ', 
	                        str, ' ', noun, '.');} else 
	
	                    {
	                        var chordWidth = 100;
	                        var margin = 15;
	                        return _react2.default.createElement('div', null, 
	                        _react2.default.createElement('div', { style: { 
	                                width: 'calc(100% - ' + (chordWidth + margin) + 'px)', 
	                                marginRight: margin, 
	                                display: "inline-block", 
	                                verticalAlign: "top" } }, 
	
	                        _react2.default.createElement('div', { className: 'alert alert-info' }, 'The root of that chord (shown at right) is ', 
	
	                        _react2.default.createElement('strong', null, note), ', at ', str, ' ', noun, '.')), 
	
	
	                        _react2.default.createElement(_ChordEngraving2.default, { notes: chord, width: chordWidth }));}} else 
	
	
	                {
	                    var e = maybeOffset.error;
	                    if (e === "infinite") {
	                        return _react2.default.createElement('div', { className: 'alert alert-danger' }, 
	                        _react2.default.createElement('strong', null, 'Whoops!'), 
	                        " ", 'That chord\'s too complicated for me to analyze. In particular, the acoustic ratios are such complicated fractions that your browser gives up on the math. Try another one?');} else 
	
	
	
	
	
	
	                    if (e === "zero_ratio") {
	                        return _react2.default.createElement('div', { className: 'alert alert-danger' }, 
	                        _react2.default.createElement('strong', null, 'Whoops!'), 
	                        " ", 'It looks like one of the acoustic ratios involved in this chord turns out to be zero. That can\'t be! Check your rationalization configuration and try again.');} else 
	
	
	
	
	
	
	                    {
	                        throw e;}}}} }]);return ChordOutput;})(_react.Component);
	
	
	
	
	
	ChordOutput.propTypes = { 
	    rationalizer: _react.PropTypes.func.isRequired, 
	    chord: _react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired };

/***/ },
/* 238 */
/***/ function(module, exports) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	pitchToName = pitchToName;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	nameToPitch = nameToPitch;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	relativeToPitch = relativeToPitch;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	parseNameOrPitch = parseNameOrPitch;var flat = "♭";var sharp = "♯";var minus = "−";var baseTable = ["C", "C#", "D", "Eb", "E", "F", "F#", "G", "Ab", "A", "Bb", "B"];var prettify = function prettify(x) {return x.replace("#", sharp).replace("b", flat).replace("-", "−");}; /*
	                                                                                                                                                                                                                                                                                * Input: number of semitones above middle C.
	                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                * Output: note name in scientific pitch notation.
	                                                                                                                                                                                                                                                                                * If pretty = true, use proper sharp and flat symbols.
	                                                                                                                                                                                                                                                                                */function pitchToName(semitones) {var pretty = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];var showOctaves = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];var octaveOffset = Math.floor(semitones / 12);var octaveName = octaveOffset + 4;var phase1 = semitones % 12;var phase = phase1 < 0 ? phase1 + 12 : phase1;var phaseName = baseTable[phase];var plain = showOctaves ? phaseName + octaveName : phaseName;return pretty ? prettify(plain) : plain;} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Input: a string like "C4" or "Ab6" or "F\u266F-1";
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * that is, a string in scientific pitch notation
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * where negative octaves are allowed
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * and accidentals can be either plain or pretty.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Output: the number of semitones above middle C,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * or null if it is not a valid note.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */function nameToPitch(name) {var pat = /^([A-Ga-g])([#\u266F]*|[b\u266D]*)((?:-|\u2212)?\d+)$/;var match = name.match(pat);if (!match) {return null;}var letter = match[1].toUpperCase();var accidentals = prettify(match[2]);var number = parseInt(match[3].replace(minus, "-"), 10);var accidental = accidentals.charAt(0);var accidentalShift = accidental === sharp ? accidentals.length : accidental === flat ? -accidentals.length : /* undefined; no text given */0;var octaveShift = (number - 4) * 12;var base = ({ "C": 0, "D": 2, "E": 4, "F": 5, "G": 7, "A": 9, "B": 11 })[letter];return base + octaveShift + accidentalShift;} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Input: a pitch class name followed by ('*|,*),
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * where a quote indicates raising the octave by one
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * and a comma indicates lowering the octave by one.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * (Everything starts in octave 4.)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Output: the number of semitones above middle C,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * or null if it is not a valid note.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Example: C is C4; C' is C5; Db,, is Db2.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */function relativeToPitch(relativeString) {var pat = /^([A-Ga-g](?:[#\u266F]*|[b\u266D]*))('*|,*)$/;var match = relativeString.match(pat);if (!match) {return null;}var letter = match[1];var modifiers = match[2];var modifier = modifiers.charAt(0);var octaveShift = modifier === "'" ? +modifiers.length : modifier === "," ? -modifiers.length : /* undefined; no text given */0;var octave = 4 + octaveShift;return nameToPitch("" + letter + octave);} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Input: a string that's
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *   - a scientific pitch notation name, like "C4" or "Ab6" or "F\u266F-1";
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *   - a relative pitch name, like "C" or "Db'" or "E,,"; or
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *   - a number of semitones above middle C, like "12" or "-23" or "\u221234".
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Output: the number of semitones above middle C,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * or null if the string is not valid in any of the accepted formats.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */function parseNameOrPitch(input) {var asName = nameToPitch(input);if (asName !== null) {return asName;}var asRelative = relativeToPitch(input);if (asRelative !== null) {return asRelative;}if (input.match(/^(-|\u2212)?\d+$/)) {var plain = input.replace(minus, "-");return parseInt(plain, 10);}return null;}exports.default = { pitchToName: pitchToName, nameToPitch: nameToPitch, relativeToPitch: relativeToPitch, parseNameOrPitch: parseNameOrPitch };

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.
	
	
	
	
	
	
	
	
	
	withinLimits = withinLimits;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	withinEngravingRange = withinEngravingRange;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	formatMaybeRoot = formatMaybeRoot;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	formatPitchesAndSemitones = formatPitchesAndSemitones;var _PitchNames = __webpack_require__(238); /*
	                                                                                                        * Determine whether the given chord passes the given limit filters.
	                                                                                                        * Return true if the chord should be displayed, or false otherwise.
	                                                                                                        */function withinLimits(notes, limits) {if (!limits) {return true;}var span = notes[notes.length - 1] - notes[0];if (limits.minCombinedEnabled && span < limits.minCombined) {return false;}if (limits.maxCombinedEnabled && span > limits.maxCombined) {return false;}var deltas = notes.slice(1).map(function (snd, idx) {return snd - notes[idx];});if (limits.minIndividualEnabled && deltas.some(function (x) {return x < limits.minIndividual;})) {return false;}if (limits.maxIndividualEnabled && deltas.some(function (x) {return x > limits.maxIndividual;})) {return false;}return true;} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              * Utilities for formatting and displaying
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              * primarily trichords and related results.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              */function withinEngravingRange(notes) {var pianoMin = -40;var pianoMax = 48;var leeway = 24;var min = pianoMin - leeway;var max = pianoMax + leeway;return notes.every(function (x) {return min < x && x < max;});} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    * Given a result of HarmonicSeries.findChordRootOffset,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    *   - format the root pitch, respecting the given view options,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    *     when the result indicates success;
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    *   - return a single question mark "?"
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    *     when the result is failure due to
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    *     an infinite term or zero acoustic ratio; or
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    *   - throw an exception if the result indicates
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    *     failure for some other (unexpected) reason.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    */function formatMaybeRoot(maybeRootPitch, viewOptions) {if (maybeRootPitch.status === "success") {var rootPitch = maybeRootPitch.result;return (0, _PitchNames.pitchToName)(rootPitch, true, viewOptions.showOctaves);} else {var e = maybeRootPitch.error;if (e.match(/finite/) || e.match(/zero_ratio/)) {return "?";} else {throw e;}}} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * Given an ascending sequence of pitches
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * (as numbers, representing semitones above middle C),
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * format each of the pitches and also the differences between them
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * according to the given view options.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * If the sequence is not ascending,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * some of the semitone differences will be negative;
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * the proper MINUS SIGN (U+2212) will be used in the representation.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * The return value has shape { noteNames: [string], semitoneNames: [string] },
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * where the values are in the same order as the input.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * For example, [0, 4, 7] might map to {
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 *     noteNames: ["C4", "E4", "G4"],
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 *     semitoneNames: ["[4]", "[3]"],
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 * }, but the octaves are hidden if so specified by the view options.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 */function formatPitchesAndSemitones(notes, viewOptions) {var noteNames = notes.map(function (x) {return (0, _PitchNames.pitchToName)(x, true, viewOptions.showOctaves);});var semitoneNames = notes.slice(1).map(function (snd, idx) {return ("[" + (snd - notes[idx]) + "]").replace(/-/, "−");});return { noteNames: noteNames, semitoneNames: semitoneNames };}

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _vexflow = __webpack_require__(241);var _vexflow2 = _interopRequireDefault(_vexflow);var _DisplayUtils = __webpack_require__(239);var _VexFlowUtils = __webpack_require__(242);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}
	
	
	
	
	
	/*
	 * Engrave a chord and display it!
	 *
	 * This involves a bit of hackery and goes outside the React lifecycle;
	 * in particular, VexFlow expects to render into an existing DOM node
	 * so we have to create one as a 'ref' during 'render'
	 * and then actually render into it in 'componentDidMount'.
	 * Not a big deal, though;
	 * one intended use of the lifecycle methods
	 * is dealing with legacy or external code, which this is.
	 */var 
	ChordEngraving = (function (_Component) {_inherits(ChordEngraving, _Component);function ChordEngraving() {_classCallCheck(this, ChordEngraving);return _possibleConstructorReturn(this, Object.getPrototypeOf(ChordEngraving).apply(this, arguments));}_createClass(ChordEngraving, [{ key: 'render', value: function render() 
	
	        {
	            if (this._shouldRenderNote()) {
	                return _react2.default.createElement('div', { ref: 'outer', style: { display: "inline-block" } });} else 
	            {
	                return _react2.default.createElement('div', { style: { width: this.props.width } }, 'The notes in this chord are way off the piano!');}} }, { key: '_shouldRenderNote', value: function _shouldRenderNote() 
	
	
	
	
	
	        {
	            return (0, _DisplayUtils.withinEngravingRange)(this.props.notes);} }, { key: 'componentDidMount', value: function componentDidMount() 
	
	
	        {
	            if (this._shouldRenderNote()) {
	                this._renderNote();}} }, { key: 'componentDidUpdate', value: function componentDidUpdate() 
	
	
	
	        {
	            if (this._shouldRenderNote()) {
	                this._renderNote();}} }, { key: '_renderNote', value: function _renderNote() 
	
	
	
	        {var _props = 
	            this.props;var notes = _props.notes;var width = _props.width;
	            var chord = (0, _VexFlowUtils.pitchesToStaveNote)(notes);
	
	            // VexFlow supports, you know, actual music,
	            // which generally comprises multiple notes in sequence.
	            // So we need to wrap this in a singleton array.
	            var chords = [chord];
	
	            var svgContainer = document.createElement('div');
	            var renderer = new _vexflow2.default.Flow.Renderer(svgContainer, 
	            _vexflow2.default.Flow.Renderer.Backends.SVG);
	            var ctx = renderer.getContext();
	            var stave = new _vexflow2.default.Flow.Stave(0, 0, width);
	            stave.addClef("treble").setContext(ctx).draw();
	            _vexflow2.default.Flow.Formatter.FormatAndDraw(ctx, stave, chords);
	
	            // Clear container before adding anything.
	            var container = this.refs.outer;
	            while (container.childNodes.length > 0) {
	                container.removeChild(container.childNodes[0]);}
	
	            container.appendChild(svgContainer);
	
	            var svg = svgContainer.childNodes[0];
	
	            // We can only get the bounding box once the SVG is fully in the DOM;
	            // that is, 'svg' is in 'svgContainer',
	            // and 'svgContainer' is in the mounted ref.
	            var boundingBox = svg.getBBox();
	
	            svg.style.top = -boundingBox.y + "px";
	            svg.style.height = boundingBox.height;
	            svg.style.left = "0px";
	            svg.style.width = width + "px";
	            svg.style.position = "absolute";
	            svg.style.overflow = "visible";
	
	            // The margin/padding/positioning stuff we're doing here
	            // works optically, and the SVG looks correct,
	            // but apparently it's still pushed pretty far down in the DOM.
	            // This can interfere with pointer events
	            // because the SVG can block the mouse cursor.
	            // We can fix that by just not capturing such events.
	            svg.style.pointerEvents = "none";
	
	            svgContainer.style.height = boundingBox.height + "px";
	            svgContainer.style.width = width + "px";
	            svgContainer.style.position = "relative";
	            svgContainer.style.display = "inlineBlock";} }]);return ChordEngraving;})(_react.Component);exports.default = ChordEngraving;
	
	
	
	ChordEngraving.propTypes = { 
	    // Semitones above middle C.
	    notes: _react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired, 
	
	    // Width of the staff output, in pixels.
	    width: _react.PropTypes.number };
	
	ChordEngraving.defaultProps = { 
	    width: 100 };

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * VexFlow 1.2.36 built on 2015-10-15.
	 * Copyright (c) 2010 Mohit Muthanna Cheppudira <mohit@muthanna.com>
	 *
	 * http://www.vexflow.com  http://github.com/0xfe/vexflow
	 */
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements utility methods used by the rest of the VexFlow
	// codebase.
	//
	// ## JSHint Settings
	//
	/* global window: false */
	/* global document: false */
	
	if (typeof Vex === 'undefined') {
	  /* global Vex: true */
	  Vex = function() {};
	}
	
	// Default log function sends all arguments to console.
	Vex.L = function(block, args) {
	  if (!args) return;
	  var line = Array.prototype.slice.call(args).join(" ");
	  window.console.log(block + ": " + line);
	};
	
	// Default runtime exception.
	Vex.RuntimeError = function(code, message) {
	  this.code = code;
	  this.message = message;
	};
	
	Vex.RuntimeError.prototype.toString = function() {
	  return "RuntimeError: " + this.message;
	};
	
	// Shortcut method for `RuntimeError`.
	Vex.RERR = Vex.RuntimeError;
	
	// Merge `destination` hash with `source` hash, overwriting like keys
	// in `source` if necessary.
	Vex.Merge = function(destination, source) {
	  for (var property in source)
	    destination[property] = source[property];
	  return destination;
	};
	
	// DEPRECATED. Use `Math.*`.
	Vex.Min = Math.min;
	Vex.Max = Math.max;
	Vex.forEach = function(a, fn) {
	  for (var i=0; i<a.length; i++) {
	    fn(a[i],i);
	  }
	};
	
	// Round number to nearest fractional value (`.5`, `.25`, etc.)
	Vex.RoundN = function(x, n) {
	  return (x % n) >= (n/2) ?
	    parseInt(x / n, 10) * n + n : parseInt(x / n, 10) * n;
	};
	
	// Locate the mid point between stave lines. Returns a fractional line if a space.
	Vex.MidLine = function(a, b) {
	  var mid_line = b + (a - b) / 2;
	  if (mid_line % 2 > 0) {
	    mid_line = Vex.RoundN(mid_line * 10, 5) / 10;
	  }
	  return mid_line;
	};
	
	// Take `arr` and return a new list consisting of the sorted, unique,
	// contents of arr. Does not modify `arr`.
	Vex.SortAndUnique = function(arr, cmp, eq) {
	  if (arr.length > 1) {
	    var newArr = [];
	    var last;
	    arr.sort(cmp);
	
	    for (var i = 0; i < arr.length; ++i) {
	      if (i === 0 || !eq(arr[i], last)) {
	        newArr.push(arr[i]);
	      }
	      last = arr[i];
	    }
	
	    return newArr;
	  } else {
	    return arr;
	  }
	};
	
	// Check if array `a` contains `obj`.
	Vex.Contains = function(a, obj) {
	  var i = a.length;
	  while (i--) {
	    if (a[i] === obj) {
	      return true;
	    }
	  }
	  return false;
	};
	
	// Get the 2D Canvas context from DOM element `canvas_sel`.
	Vex.getCanvasContext = function(canvas_sel) {
	  if (!canvas_sel)
	    throw new Vex.RERR("BadArgument", "Invalid canvas selector: " + canvas_sel);
	
	  var canvas = document.getElementById(canvas_sel);
	  if (!(canvas && canvas.getContext)) {
	    throw new Vex.RERR("UnsupportedBrowserError",
	        "This browser does not support HTML5 Canvas");
	  }
	
	  return canvas.getContext('2d');
	};
	
	// Draw a tiny dot marker on the specified canvas. A great debugging aid.
	//
	// `ctx`: Canvas context.
	// `x`, `y`: Dot coordinates.
	Vex.drawDot = function(ctx, x, y, color) {
	  var c = color || "#f55";
	  ctx.save();
	  ctx.setFillStyle(c);
	
	  //draw a circle
	  ctx.beginPath();
	  ctx.arc(x, y, 3, 0, Math.PI*2, true);
	  ctx.closePath();
	  ctx.fill();
	  ctx.restore();
	};
	
	// Benchmark. Run function `f` once and report time elapsed shifted by `s` milliseconds.
	Vex.BM = function(s, f) {
	  var start_time = new Date().getTime();
	  f();
	  var elapsed = new Date().getTime() - start_time;
	  Vex.L(s + elapsed + "ms");
	};
	
	// Basic classical inheritance helper. Usage:
	// ```
	// // Vex.Inherit(Child, Parent, {
	// //   getName: function() {return this.name;},
	// //   setName: function(name) {this.name = name}
	// // });
	// //
	// // Returns 'Child'.
	// ```
	Vex.Inherit = (function () {
	  var F = function () {};
	  // `C` is Child. `P` is parent. `O` is an object to
	  // to extend `C` with.
	  return function (C, P, O) {
	    F.prototype = P.prototype;
	    C.prototype = new F();
	    C.superclass = P.prototype;
	    C.prototype.constructor = C;
	    Vex.Merge(C.prototype, O);
	    return C;
	  };
	}());
	
	// Get stack trace.
	Vex.StackTrace = function() {
	  var err = new Error();
	  return err.stack;
	};
	
	// Dump warning to console.
	Vex.W = function() {
	  var line = Array.prototype.slice.call(arguments).join(" ");
	  window.console.log("Warning: ", line, Vex.StackTrace());
	};
	
	// Used by various classes (e.g., SVGContext) to provide a
	// unique prefix to element names (or other keys in shared namespaces).
	Vex.Prefix = function(text) {
	  return Vex.Prefix.prefix + text;
	};
	Vex.Prefix.prefix = "vf-";
	
	// UMD to export Vex.
	//
	/* global require: false */
	/* global define: false */
	/* global module: false */
	if (true) {
	  try {
	    module.exports = Vex;
	  } catch (e) {}
	} else if (typeof define == "function" && define.amd) {
	  define("Vex", [], function(){ return Vex; });
	} else {
	  (this || window)["Vex"] = Vex;
	}
	
	/**
	 * Vex Flow - Mohit Muthanna <mohit@muthanna.com>
	 */
	
	/**
	 * New namespace.
	 */
	
	if (typeof Vex.Flow === 'undefined') {
	  Vex.Flow = {
	    /**
	     * The resolution used for all the rhythm timing in this
	     * library.
	     *
	     * @const
	     * @type {number}
	     */
	    RESOLUTION: 16384,
	
	    /* Kerning (DEPRECATED) */
	    IsKerned: true
	  };
	}
	
	// Fraction class that represents a rational number
	// @author zz85
	// @author incompleteopus (modifications)
	
	Vex.Flow.Fraction = (function() {
	  function Fraction(numerator, denominator) {
	    this.set(numerator, denominator);
	  }
	
	  /**
	   * GCD: Find greatest common divisor using Euclidean algorithm
	   */
	  Fraction.GCD = function(a, b) {
	    if (typeof a !== "number" || typeof b !== "number") {
	      throw new Vex.RERR("BadArgument", "Invalid numbers: " + a + ", " + b);
	    }
	
	    var t;
	
	    while (b !== 0) {
	      t = b;
	      b = a % b;
	      a = t;
	    }
	
	    return a;
	  };
	
	  /**
	   * LCM: Lowest common multiple
	   */
	  Fraction.LCM = function(a, b) {
	    return ((a * b) / Fraction.GCD(a, b));
	  };
	
	  /**
	   * LCMM: Lowest common multiple for more than two numbers
	   */
	  Fraction.LCMM = function(args) {
	    if (args.length === 0) {
	      return 0;
	    } else if (args.length == 1) {
	      return args[0];
	    } else if (args.length == 2) {
	      return Vex.Flow.Fraction.LCM(args[0], args[1]);
	    } else {
	      var arg0 = args[0];
	      args.shift();
	      return Fraction.LCM(arg0, Vex.Flow.Fraction.LCMM(args));
	    }
	  };
	
	  Fraction.prototype = {
	    set: function(numerator, denominator) {
	      this.numerator = numerator === undefined ? 1 : numerator;
	      this.denominator = denominator === undefined ? 1 : denominator;
	      return this;
	    },
	
	    value: function() {
	      return this.numerator / this.denominator;
	    },
	
	    simplify: function() {
	      var u = this.numerator;
	      var d = this.denominator;
	
	      var gcd = Vex.Flow.Fraction.GCD(u, d);
	      u /= gcd;
	      d /= gcd;
	
	      if (d < 0) {
	        d = -d;
	        u = -u;
	      }
	      return this.set(u, d);
	    },
	
	    add: function(param1, param2) {
	      var otherNumerator;
	      var otherDenominator;
	
	      if (param1 instanceof Vex.Flow.Fraction) {
	        otherNumerator = param1.numerator;
	        otherDenominator = param1.denominator;
	      } else {
	        if (param1 !== undefined) {
	          otherNumerator = param1;
	        } else {
	          otherNumerator = 0;
	        }
	
	        if (param2 !== undefined) {
	          otherDenominator = param2;
	        } else {
	          otherDenominator = 1;
	        }
	      }
	
	      var lcm = Vex.Flow.Fraction.LCM(this.denominator, otherDenominator);
	      var a = lcm / this.denominator;
	      var b = lcm / otherDenominator;
	
	      var u = this.numerator * a + otherNumerator * b;
	      return this.set(u, lcm);
	    },
	
	    subtract: function(param1, param2) {
	      var otherNumerator;
	      var otherDenominator;
	
	      if (param1 instanceof Vex.Flow.Fraction) {
	        otherNumerator = param1.numerator;
	        otherDenominator = param1.denominator;
	      } else {
	        if (param1 !== undefined) {
	          otherNumerator = param1;
	        } else {
	          otherNumerator = 0;
	        }
	
	        if (param2 !== undefined) {
	          otherDenominator = param2;
	        } else {
	          otherDenominator = 1;
	        }
	      }
	
	      var lcm = Vex.Flow.Fraction.LCM(this.denominator, otherDenominator);
	      var a = lcm / this.denominator;
	      var b = lcm / otherDenominator;
	
	      var u = this.numerator * a - otherNumerator * b;
	      return this.set(u, lcm);
	    },
	
	    multiply: function(param1, param2) {
	      var otherNumerator;
	      var otherDenominator;
	
	      if (param1 instanceof Vex.Flow.Fraction) {
	        otherNumerator = param1.numerator;
	        otherDenominator = param1.denominator;
	      } else {
	        if (param1 !== undefined) {
	          otherNumerator = param1;
	        } else {
	          otherNumerator = 1;
	        }
	
	        if (param2 !== undefined) {
	          otherDenominator = param2;
	        } else {
	          otherDenominator = 1;
	        }
	      }
	
	      return this.set(this.numerator * otherNumerator, this.denominator * otherDenominator);
	    },
	
	    divide: function(param1, param2) {
	      var otherNumerator;
	      var otherDenominator;
	
	      if (param1 instanceof Vex.Flow.Fraction) {
	        otherNumerator = param1.numerator;
	        otherDenominator = param1.denominator;
	      } else {
	        if (param1 !== undefined) {
	          otherNumerator = param1;
	        } else {
	          otherNumerator = 1;
	        }
	
	        if (param2 !== undefined) {
	          otherDenominator = param2;
	        } else {
	          otherDenominator = 1;
	        }
	      }
	
	      return this.set(this.numerator * otherDenominator, this.denominator * otherNumerator);
	    },
	
	
	    // Simplifies both sides and checks if they are equal.
	    equals: function(compare) {
	      var a = Vex.Flow.Fraction.__compareA.copy(compare).simplify();
	      var b = Vex.Flow.Fraction.__compareB.copy(this).simplify();
	
	      return (a.numerator === b.numerator) && (a.denominator === b.denominator);
	    },
	    
	    // Greater than operator.
	    greaterThan: function(compare) {
	      var a = Vex.Flow.Fraction.__compareB.copy(this);
	      a.subtract(compare);
	      return (a.numerator > 0);
	    },
	    
	    // Greater than or equals operator.
	    greaterThanEquals: function(compare) {
	      var a = Vex.Flow.Fraction.__compareB.copy(this);
	      a.subtract(compare);
	      return (a.numerator >= 0);
	    },
	
	    // Less than operator.
	    lessThan: function(compare) {
	      return !(this.greaterThanEquals(compare));  
	    },
	
	    // Less than or equals operator.
	    lessThanEquals: function(compare) {
	      return !(this.greaterThan(compare));  
	    },
	
	    // Creates a new copy with this current values.
	    clone: function() {
	      return new Vex.Flow.Fraction(this.numerator, this.denominator);
	    },
	
	    // Copies value of another Fraction into itself.
	    copy: function(copy) {
	      return this.set(copy.numerator, copy.denominator);
	    },
	
	    // Returns the integer component eg. (4/2) == 2
	    quotient: function() {
	      return Math.floor(this.numerator / this.denominator);
	    },
	
	    // Returns the fraction component when reduced to a mixed number
	    fraction: function() {
	      return this.numerator % this.denominator;
	    },
	
	    // Returns the absolute value
	    abs: function() {
	      this.denominator = Math.abs(this.denominator);
	      this.numerator = Math.abs(this.numerator);
	      return this;
	    },
	
	    // Returns a raw string representation
	    toString: function() {
	      return this.numerator + '/' + this.denominator;
	    },
	
	    // Returns a simplified string respresentation
	    toSimplifiedString: function() {
	      return Vex.Flow.Fraction.__tmp.copy(this).simplify().toString();
	    },
	
	    // Returns string representation in mixed form
	    toMixedString: function() {
	      var s = '';
	      var q = this.quotient();
	      var f = Vex.Flow.Fraction.__tmp.copy(this);
	
	      if (q < 0) {
	        f.abs().fraction();
	      } else {
	        f.fraction();
	      }
	
	      if (q !== 0) {
	        s += q;
	
	        if (f.numerator !== 0) {
	          s += ' ' + f.toSimplifiedString();
	        }
	      } else {
	        if (f.numerator === 0) {
	          s = '0';
	        } else {
	          s = f.toSimplifiedString();
	        }
	      }
	
	      return s;
	    },
	
	    // Parses a fraction string
	    parse: function(str) {
	      var i = str.split('/');
	      var n = parseInt(i[0], 10);
	      var d = (i[1]) ? parseInt(i[1], 10) : 1;
	
	      return this.set(n, d);
	    }
	  };
	
	  // Temporary cached objects
	  Fraction.__compareA = new Fraction();
	  Fraction.__compareB = new Fraction();
	  Fraction.__tmp = new Fraction();
	
	  return Fraction;
	}());
	
	
	// Vex Flow Notation
	// Mohit Muthanna <mohit@muthanna.com>
	//
	// Copyright Mohit Muthanna 2010
	//
	// Requires vex.js.
	
	Vex.Flow.STEM_WIDTH = 1.5;
	Vex.Flow.STEM_HEIGHT = 32;
	Vex.Flow.STAVE_LINE_THICKNESS = 2;
	
	Vex.Flow.clefProperties = function(clef) {
	  if (!clef) throw new Vex.RERR("BadArgument", "Invalid clef: " + clef);
	
	  var props = Vex.Flow.clefProperties.values[clef];
	  if (!props) throw new Vex.RERR("BadArgument", "Invalid clef: " + clef);
	
	  return props;
	};
	
	Vex.Flow.clefProperties.values = {
	  'treble':  { line_shift: 0 },
	  'bass':    { line_shift: 6 },
	  'tenor':   { line_shift: 4 },
	  'alto':    { line_shift: 3 },
	  'soprano': { line_shift: 1 },
	  'percussion': { line_shift: 0 },
	  'mezzo-soprano': { line_shift: 2 },
	  'baritone-c': { line_shift: 5 },
	  'baritone-f': { line_shift: 5 },
	  'subbass': { line_shift: 7 },
	  'french': { line_shift: -1 }
	};
	
	/*
	  Take a note in the format "Key/Octave" (e.g., "C/5") and return properties.
	
	  The last argument, params, is a struct the currently can contain one option,
	  octave_shift for clef ottavation (0 = default; 1 = 8va; -1 = 8vb, etc.).
	*/
	Vex.Flow.keyProperties = function(key, clef, params) {
	  if (clef === undefined) {
	    clef = 'treble';
	  }
	  var options = {
	    octave_shift: 0
	  };
	  if (typeof params == "object") {
	    Vex.Merge(options, params);
	  }
	
	  var pieces = key.split("/");
	
	  if (pieces.length < 2) {
	    throw new Vex.RERR("BadArguments",
	        "Key must have note + octave and an optional glyph: " + key);
	  }
	
	  var k = pieces[0].toUpperCase();
	  var value = Vex.Flow.keyProperties.note_values[k];
	  if (!value) throw new Vex.RERR("BadArguments", "Invalid key name: " + k);
	  if (value.octave) pieces[1] = value.octave;
	
	  var o = parseInt(pieces[1]);
	
	  // Octave_shift is the shift to compensate for clef 8va/8vb.
	  o += -1 * options.octave_shift;
	
	  var base_index = (o * 7) - (4 * 7);
	  var line = (base_index + value.index) / 2;
	  line += Vex.Flow.clefProperties(clef).line_shift;
	
	  var stroke = 0;
	
	  if (line <= 0 && (((line * 2) % 2) === 0)) stroke = 1;  // stroke up
	  if (line >= 6 && (((line * 2) % 2) === 0)) stroke = -1; // stroke down
	
	  // Integer value for note arithmetic.
	  var int_value = (typeof(value.int_val)!='undefined') ? (o * 12) +
	    value.int_val : null;
	
	  /* Check if the user specified a glyph. */
	  var code = value.code;
	  var shift_right = value.shift_right;
	  if ((pieces.length > 2) && (pieces[2])) {
	    var glyph_name = pieces[2].toUpperCase();
	    var note_glyph = Vex.Flow.keyProperties.note_glyph[glyph_name];
	    if (note_glyph) {
	      code = note_glyph.code;
	      shift_right = note_glyph.shift_right;
	    }
	  }
	
	  return {
	    key: k,
	    octave: o,
	    line: line,
	    int_value: int_value,
	    accidental: value.accidental,
	    code: code,
	    stroke: stroke,
	    shift_right: shift_right,
	    displaced: false
	  };
	};
	
	Vex.Flow.keyProperties.note_values = {
	  'C':  { index: 0, int_val: 0, accidental: null },
	  'CN': { index: 0, int_val: 0, accidental: "n" },
	  'C#': { index: 0, int_val: 1, accidental: "#" },
	  'C##': { index: 0, int_val: 2, accidental: "##" },
	  'CB': { index: 0, int_val: -1, accidental: "b" },
	  'CBB': { index: 0, int_val: -2, accidental: "bb" },
	  'D':  { index: 1, int_val: 2, accidental: null },
	  'DN': { index: 1, int_val: 2, accidental: "n" },
	  'D#': { index: 1, int_val: 3, accidental: "#" },
	  'D##': { index: 1, int_val: 4, accidental: "##" },
	  'DB': { index: 1, int_val: 1, accidental: "b" },
	  'DBB': { index: 1, int_val: 0, accidental: "bb" },
	  'E':  { index: 2, int_val: 4, accidental: null },
	  'EN': { index: 2, int_val: 4, accidental: "n" },
	  'E#': { index: 2, int_val: 5, accidental: "#" },
	  'E##': { index: 2, int_val: 6, accidental: "##" },
	  'EB': { index: 2, int_val: 3, accidental: "b" },
	  'EBB': { index: 2, int_val: 2, accidental: "bb" },
	  'F':  { index: 3, int_val: 5, accidental: null },
	  'FN': { index: 3, int_val: 5, accidental: "n" },
	  'F#': { index: 3, int_val: 6, accidental: "#" },
	  'F##': { index: 3, int_val: 7, accidental: "##" },
	  'FB': { index: 3, int_val: 4, accidental: "b" },
	  'FBB': { index: 3, int_val: 3, accidental: "bb" },
	  'G':  { index: 4, int_val: 7, accidental: null },
	  'GN': { index: 4, int_val: 7, accidental: "n" },
	  'G#': { index: 4, int_val: 8, accidental: "#" },
	  'G##': { index: 4, int_val: 9, accidental: "##" },
	  'GB': { index: 4, int_val: 6, accidental: "b" },
	  'GBB': { index: 4, int_val: 5, accidental: "bb" },
	  'A':  { index: 5, int_val: 9, accidental: null },
	  'AN': { index: 5, int_val: 9, accidental: "n" },
	  'A#': { index: 5, int_val: 10, accidental: "#" },
	  'A##': { index: 5, int_val: 11, accidental: "##" },
	  'AB': { index: 5, int_val: 8, accidental: "b" },
	  'ABB': { index: 5, int_val: 7, accidental: "bb" },
	  'B':  { index: 6, int_val: 11, accidental: null },
	  'BN': { index: 6, int_val: 11, accidental: "n" },
	  'B#': { index: 6, int_val: 12, accidental: "#" },
	  'B##': { index: 6, int_val: 13, accidental: "##" },
	  'BB': { index: 6, int_val: 10, accidental: "b" },
	  'BBB': { index: 6, int_val: 9, accidental: "bb" },
	  'R': { index: 6, int_val: 9, rest: true }, // Rest
	  'X':  {
	    index: 6,
	    accidental: "",
	    octave: 4,
	    code: "v3e",
	    shift_right: 5.5
	  }
	};
	
	Vex.Flow.keyProperties.note_glyph = {
	  /* Diamond */
	  'D0':  { code: "v27", shift_right: -0.5 },
	  'D1':  { code: "v2d", shift_right: -0.5 },
	  'D2':  { code: "v22", shift_right: -0.5 },
	  'D3':  { code: "v70", shift_right: -0.5 },
	
	  /* Triangle */
	  'T0':  { code: "v49", shift_right: -2 },
	  'T1':  { code: "v93", shift_right: 0.5 },
	  'T2':  { code: "v40", shift_right: 0.5 },
	  'T3':  { code: "v7d", shift_right: 0.5 },
	
	  /* Cross */
	  'X0':  { code: "v92", shift_right: -2 },
	  'X1':  { code: "v95", shift_right: -0.5 },
	  'X2':  { code: "v7f", shift_right: 0.5 },
	  'X3':  { code: "v3b", shift_right: -2 }
	};
	
	Vex.Flow.integerToNote = function(integer) {
	  if (typeof(integer) == "undefined")
	    throw new Vex.RERR("BadArguments", "Undefined integer for integerToNote");
	
	  if (integer < -2)
	    throw new Vex.RERR("BadArguments",
	        "integerToNote requires integer > -2: " + integer);
	
	  var noteValue = Vex.Flow.integerToNote.table[integer];
	  if (!noteValue)
	    throw new Vex.RERR("BadArguments", "Unknown note value for integer: " +
	        integer);
	
	  return noteValue;
	};
	
	Vex.Flow.integerToNote.table = {
	  0: "C",
	  1: "C#",
	  2: "D",
	  3: "D#",
	  4: "E",
	  5: "F",
	  6: "F#",
	  7: "G",
	  8: "G#",
	  9: "A",
	  10: "A#",
	  11: "B"
	};
	
	
	Vex.Flow.tabToGlyph = function(fret) {
	  var glyph = null;
	  var width = 0;
	  var shift_y = 0;
	
	  if (fret.toString().toUpperCase() == "X") {
	    glyph = "v7f";
	    width = 7;
	    shift_y = -4.5;
	  } else {
	    width = Vex.Flow.textWidth(fret.toString());
	  }
	
	  return {
	    text: fret,
	    code: glyph,
	    width: width,
	    shift_y: shift_y
	  };
	};
	
	Vex.Flow.textWidth = function(text) {
	  return 6 * text.toString().length;
	};
	
	Vex.Flow.articulationCodes = function(artic) {
	  return Vex.Flow.articulationCodes.articulations[artic];
	};
	
	Vex.Flow.articulationCodes.articulations = {
	  "a.": {   // Staccato
	    code: "v23",
	    width: 4,
	    shift_right: -2,
	    shift_up: 8,
	    shift_down: 0,
	    between_lines: true
	  },
	  "av": {   // Staccatissimo
	    code: "v28",
	    width: 4,
	    shift_right: 0,
	    shift_up: 11,
	    shift_down: 5,
	    between_lines: true
	  },
	  "a>": {   // Accent
	    code: "v42",
	    width: 10,
	    shift_right: 5,
	    shift_up: 8,
	    shift_down: 1,
	    between_lines: true
	  },
	  "a-": {   // Tenuto
	    code: "v25",
	    width: 9,
	    shift_right: -4,
	    shift_up: 17,
	    shift_down: 10,
	    between_lines: true
	  },
	  "a^": {   // Marcato
	    code: "va",
	    width: 8,
	    shift_right: 0,
	    shift_up: -4,
	    shift_down: -2,
	    between_lines: false
	  },
	  "a+": {   // Left hand pizzicato
	    code: "v8b",
	    width: 9,
	    shift_right: -4,
	    shift_up: 12,
	    shift_down: 12,
	    between_lines: false
	  },
	  "ao": {   // Snap pizzicato
	    code: "v94",
	    width: 8,
	    shift_right: 0,
	    shift_up: -4,
	    shift_down: 6,
	    between_lines: false
	  },
	  "ah": {   // Natural harmonic or open note
	    code: "vb9",
	    width: 7,
	    shift_right: 0,
	    shift_up: -4,
	    shift_down: 4,
	    between_lines: false
	  },
	  "a@a": {   // Fermata above staff
	    code: "v43",
	    width: 25,
	    shift_right: 0,
	    shift_up: 8,
	    shift_down: 10,
	    between_lines: false
	  },
	  "a@u": {   // Fermata below staff
	    code: "v5b",
	    width: 25,
	    shift_right: 0,
	    shift_up: 0,
	    shift_down: -4,
	    between_lines: false
	  },
	  "a|": {   // Bow up - up stroke
	    code: "v75",
	    width: 8,
	    shift_right: 0,
	    shift_up: 8,
	    shift_down: 10,
	    between_lines: false
	  },
	  "am": {   // Bow down - down stroke
	    code: "v97",
	    width: 13,
	    shift_right: 0,
	    shift_up: 10,
	    shift_down: 12,
	    between_lines: false
	  },
	  "a,": {   // Choked
	    code: "vb3",
	    width: 6,
	    shift_right: 8,
	    shift_up: -4,
	    shift_down: 4,
	    between_lines: false
	  }
	};
	
	Vex.Flow.accidentalCodes = function(acc) {
	  return Vex.Flow.accidentalCodes.accidentals[acc];
	};
	
	Vex.Flow.accidentalCodes.accidentals = {
	  "#": {
	    code: "v18",
	    width: 10,
	    gracenote_width: 4.5,
	    shift_right: 0,
	    shift_down: 0
	  },
	  "##": {
	    code: "v7f",
	    width: 13,
	    gracenote_width: 6,
	    shift_right: -1,
	    shift_down: 0
	  },
	  "b": {
	    code: "v44",
	    width: 8,
	    gracenote_width: 4.5,
	    shift_right: 0,
	    shift_down: 0
	  },
	  "bb": {
	    code: "v26",
	    width: 14,
	    gracenote_width: 8,
	    shift_right: -3,
	    shift_down: 0
	  },
	  "n": {
	    code: "v4e",
	    width: 8,
	    gracenote_width: 4.5,
	    shift_right: 0,
	    shift_down: 0
	  },
	  "{": {   // Left paren for cautionary accidentals
	    code: "v9c",
	    width: 5,
	    shift_right: 2,
	    shift_down: 0
	  },
	  "}": {   // Right paren for cautionary accidentals
	    code: "v84",
	    width: 5,
	    shift_right: 0,
	    shift_down: 0
	  },
	  "db": {
	    code: "v9e",
	    width: 16,
	    shift_right: 0,
	    shift_down: 0
	  },
	  "d": {
	    code: "vab",
	    width: 10,
	    shift_right: 0,
	    shift_down: 0
	  },
	  "bbs": {
	    code: "v90",
	    width: 13,
	    shift_right: 0,
	    shift_down: 0
	  },
	  "++": {
	    code: "v51",
	    width: 13,
	    shift_right: 0,
	    shift_down: 0
	  },
	  "+": {
	    code: "v78",
	    width: 8,
	    shift_right: 0,
	    shift_down: 0
	  }
	};
	
	Vex.Flow.accidentalColumnsTable = {
	  1 : { a : [1], b : [1]},
	  2 : { a : [1, 2] },
	  3 : { a : [1, 3, 2], b : [1, 2, 1], second_on_bottom : [1, 2, 3] },
	  4 : { a : [1, 3, 4, 2], b : [1, 2, 3, 1], spaced_out_tetrachord : [1, 2, 1, 2] },
	  5 : { a : [1, 3, 5, 4, 2], b : [1, 2, 4, 3, 1],
	        spaced_out_pentachord : [1, 2, 3, 2, 1],
	        very_spaced_out_pentachord : [1, 2, 1, 2, 1] },
	  6 : { a : [1, 3, 5, 6, 4, 2], b : [1, 2, 4, 5, 3, 1],
	        spaced_out_hexachord : [1, 3, 2, 1, 3, 2],
	        very_spaced_out_hexachord : [1, 2, 1, 2, 1, 2] }
	};
	
	Vex.Flow.ornamentCodes = function(acc) {
	  return Vex.Flow.ornamentCodes.ornaments[acc];
	};
	
	Vex.Flow.ornamentCodes.ornaments = {
	  "mordent": {
	    code: "v1e",
	    shift_right: 1,
	    shift_up: 0,
	    shift_down: 5,
	    width: 14,
	  },
	  "mordent_inverted": {
	    code: "v45",
	    shift_right: 1,
	    shift_up: 0,
	    shift_down: 5,
	    width: 14,
	  },
	  "turn": {
	    code: "v72",
	    shift_right: 1,
	    shift_up: 0,
	    shift_down: 5,
	    width: 20,
	  },
	  "turn_inverted": {
	    code: "v33",
	    shift_right: 1,
	    shift_up: 0,
	    shift_down: 6,
	    width: 20,
	  },
	  "tr": {
	    code: "v1f",
	    shift_right: 0,
	    shift_up: 5,
	    shift_down: 15,
	    width: 10,
	  },
	  "upprall": {
	    code: "v60",
	    shift_right: 1,
	    shift_up: -3,
	    shift_down: 6,
	    width: 20,
	  },
	  "downprall": {
	    code: "vb4",
	    shift_right: 1,
	    shift_up: -3,
	    shift_down: 6,
	    width: 20,
	  },
	  "prallup": {
	    code: "v6d",
	    shift_right: 1,
	    shift_up: -3,
	    shift_down: 6,
	    width: 20,
	  },
	  "pralldown": {
	    code: "v2c",
	    shift_right: 1,
	    shift_up: -3,
	    shift_down: 6,
	    width: 20,
	  },
	  "upmordent": {
	    code: "v29",
	    shift_right: 1,
	    shift_up: -3,
	    shift_down: 6,
	    width: 20,
	  },
	  "downmordent": {
	    code: "v68",
	    shift_right: 1,
	    shift_up: -3,
	    shift_down: 6,
	    width: 20,
	  },
	  "lineprall": {
	    code: "v20",
	    shift_right: 1,
	    shift_up: -3,
	    shift_down: 6,
	    width: 20,
	  },
	  "prallprall": {
	    code: "v86",
	    shift_right: 1,
	    shift_up: -3,
	    shift_down: 6,
	    width: 20,
	  }
	};
	
	Vex.Flow.keySignature = function(spec) {
	  var keySpec = Vex.Flow.keySignature.keySpecs[spec];
	
	  if (!keySpec) {
	    throw new Vex.RERR("BadKeySignature",
	        "Bad key signature spec: '" + spec + "'");
	  }
	
	  if (!keySpec.acc) {
	    return [];
	  }
	
	  var notes = Vex.Flow.keySignature.accidentalList(keySpec.acc);
	
	  var acc_list = [];
	  for (var i = 0; i < keySpec.num; ++i) {
	    var line = notes[i];
	    acc_list.push({type: keySpec.acc, line: line});
	  }
	
	  return acc_list;
	};
	
	Vex.Flow.keySignature.keySpecs = {
	  "C": {acc: null, num: 0},
	  "Am": {acc: null, num: 0},
	  "F": {acc: "b", num: 1},
	  "Dm": {acc: "b", num: 1},
	  "Bb": {acc: "b", num: 2},
	  "Gm": {acc: "b", num: 2},
	  "Eb": {acc: "b", num: 3},
	  "Cm": {acc: "b", num: 3},
	  "Ab": {acc: "b", num: 4},
	  "Fm": {acc: "b", num: 4},
	  "Db": {acc: "b", num: 5},
	  "Bbm": {acc: "b", num: 5},
	  "Gb": {acc: "b", num: 6},
	  "Ebm": {acc: "b", num: 6},
	  "Cb": {acc: "b", num: 7},
	  "Abm": {acc: "b", num: 7},
	  "G": {acc: "#", num: 1},
	  "Em": {acc: "#", num: 1},
	  "D": {acc: "#", num: 2},
	  "Bm": {acc: "#", num: 2},
	  "A": {acc: "#", num: 3},
	  "F#m": {acc: "#", num: 3},
	  "E": {acc: "#", num: 4},
	  "C#m": {acc: "#", num: 4},
	  "B": {acc: "#", num: 5},
	  "G#m": {acc: "#", num: 5},
	  "F#": {acc: "#", num: 6},
	  "D#m": {acc: "#", num: 6},
	  "C#": {acc: "#", num: 7},
	  "A#m": {acc: "#", num: 7}
	};
	
	Vex.Flow.unicode = {
	  // Unicode accidentals
	  "sharp": String.fromCharCode(parseInt('266F', 16)),
	  "flat" : String.fromCharCode(parseInt('266D', 16)),
	  "natural": String.fromCharCode(parseInt('266E', 16)),
	  // Major Chord
	  "triangle": String.fromCharCode(parseInt('25B3', 16)),
	  // half-diminished
	  "o-with-slash": String.fromCharCode(parseInt('00F8', 16)),
	   // Diminished
	  "degrees": String.fromCharCode(parseInt('00B0', 16)),
	  "circle": String.fromCharCode(parseInt('25CB', 16))
	};
	
	Vex.Flow.keySignature.accidentalList = function(acc) {
	  if (acc == "b") {
	    return [2, 0.5, 2.5, 1, 3, 1.5, 3.5];
	  }
	  else if (acc == "#") {
	    return [0, 1.5, -0.5, 1, 2.5, 0.5, 2]; }
	};
	
	Vex.Flow.parseNoteDurationString = function(durationString) {
	  if (typeof(durationString) !== "string") {
	    return null;
	  }
	
	  var regexp = /(\d*\/?\d+|[a-z])(d*)([nrhms]|$)/;
	
	  var result = regexp.exec(durationString);
	  if (!result) {
	    return null;
	  }
	
	  var duration = result[1];
	  var dots = result[2].length;
	  var type = result[3];
	
	  if (type.length === 0) {
	    type = "n";
	  }
	
	  return {
	    duration: duration,
	    dots: dots,
	    type: type
	  };
	};
	
	Vex.Flow.parseNoteData = function(noteData) {
	  var duration = noteData.duration;
	
	  // Preserve backwards-compatibility
	  var durationStringData = Vex.Flow.parseNoteDurationString(duration);
	  if (!durationStringData) {
	    return null;
	  }
	
	  var ticks = Vex.Flow.durationToTicks(durationStringData.duration);
	  if (ticks == null) {
	    return null;
	  }
	
	  var type = noteData.type;
	
	  if (type) {
	    if (!(type === "n" || type === "r" || type === "h" ||
	          type === "m" || type === "s")) {
	      return null;
	    }
	  } else {
	    type = durationStringData.type;
	    if (!type) {
	      type = "n";
	    }
	  }
	
	  var dots = 0;
	  if (noteData.dots) {
	    dots = noteData.dots;
	  } else {
	    dots = durationStringData.dots;
	  }
	
	  if (typeof(dots) !== "number") {
	    return null;
	  }
	
	  var currentTicks = ticks;
	
	  for (var i = 0; i < dots; i++) {
	    if (currentTicks <= 1) {
	      return null;
	    }
	
	    currentTicks = currentTicks / 2;
	    ticks += currentTicks;
	  }
	
	  return {
	    duration: durationStringData.duration,
	    type: type,
	    dots: dots,
	    ticks: ticks
	  };
	};
	
	// Used to convert duration aliases to the number based duration.
	// If the input isn't an alias, simply return the input.
	//
	// example: 'q' -> '4', '8' -> '8'
	Vex.Flow.sanitizeDuration = function(duration) {
	  var alias = Vex.Flow.durationAliases[duration];
	  if (alias !== undefined) {
	    duration = alias;
	  }
	
	  if (Vex.Flow.durationToTicks.durations[duration] === undefined) {
	    throw new Vex.RERR('BadArguments',
	      'The provided duration is not valid');
	  }
	
	  return duration;
	};
	
	// Convert the `duration` to an fraction
	Vex.Flow.durationToFraction = function(duration) {
	  return new Vex.Flow.Fraction().parse(Vex.Flow.sanitizeDuration(duration));
	};
	
	// Convert the `duration` to an number
	Vex.Flow.durationToNumber = function(duration) {
	  return Vex.Flow.durationToFraction(duration).value();
	};
	
	// Convert the `duration` to total ticks
	Vex.Flow.durationToTicks = function(duration) {
	  duration = Vex.Flow.sanitizeDuration(duration);
	
	  var ticks = Vex.Flow.durationToTicks.durations[duration];
	  if (ticks === undefined) {
	    return null;
	  }
	
	  return ticks;
	};
	
	Vex.Flow.durationToTicks.durations = {
	  "1/2":  Vex.Flow.RESOLUTION * 2,
	  "1":    Vex.Flow.RESOLUTION / 1,
	  "2":    Vex.Flow.RESOLUTION / 2,
	  "4":    Vex.Flow.RESOLUTION / 4,
	  "8":    Vex.Flow.RESOLUTION / 8,
	  "16":   Vex.Flow.RESOLUTION / 16,
	  "32":   Vex.Flow.RESOLUTION / 32,
	  "64":   Vex.Flow.RESOLUTION / 64,
	  "128":  Vex.Flow.RESOLUTION / 128,
	  "256":  Vex.Flow.RESOLUTION / 256
	};
	
	Vex.Flow.durationAliases = {
	  "w": "1",
	  "h": "2",
	  "q": "4",
	
	  // This is the default duration used to render bars (BarNote). Bars no longer
	  // consume ticks, so this should be a no-op.
	  //
	  // TODO(0xfe): This needs to be cleaned up.
	  "b": "256"
	};
	
	Vex.Flow.durationToGlyph = function(duration, type) {
	  duration = Vex.Flow.sanitizeDuration(duration);
	
	  var code = Vex.Flow.durationToGlyph.duration_codes[duration];
	  if (code === undefined) {
	    return null;
	  }
	
	  if (!type) {
	    type = "n";
	  }
	
	  var glyphTypeProperties = code.type[type];
	  if (glyphTypeProperties === undefined) {
	    return null;
	  }
	
	  return Vex.Merge(Vex.Merge({}, code.common), glyphTypeProperties);
	};
	
	Vex.Flow.durationToGlyph.duration_codes = {
	  "1/2": {
	    common: {
	      head_width: 22,
	      stem: false,
	      stem_offset: 0,
	      flag: false,
	      stem_up_extension: -Vex.Flow.STEM_HEIGHT,
	      stem_down_extension: -Vex.Flow.STEM_HEIGHT,
	      gracenote_stem_up_extension: -Vex.Flow.STEM_HEIGHT,
	      gracenote_stem_down_extension: -Vex.Flow.STEM_HEIGHT,
	      tabnote_stem_up_extension: -Vex.Flow.STEM_HEIGHT,
	      tabnote_stem_down_extension: -Vex.Flow.STEM_HEIGHT,
	      dot_shiftY: 0,
	      line_above: 0,
	      line_below: 0
	    },
	    type: {
	      "n": { // Breve note
	        code_head: "v53"
	      },
	      "h": { // Breve note harmonic
	        code_head: "v59"
	      },
	      "m": { // Breve note muted -
	        code_head: "vf",
	        stem_offset: 0
	      },
	      "r": { // Breve rest
	        code_head: "v31",
	        head_width: 24,
	        rest: true,
	        position: "B/5",
	        dot_shiftY: 0.5
	      },
	      "s": { // Breve note slash -
	        // Drawn with canvas primitives
	        head_width: 15,
	        position: "B/4"
	      }
	    }
	  },
	  "1": {
	    common: {
	      head_width: 16,
	      stem: false,
	      stem_offset: 0,
	      flag: false,
	      stem_up_extension: -Vex.Flow.STEM_HEIGHT,
	      stem_down_extension: -Vex.Flow.STEM_HEIGHT,
	      gracenote_stem_up_extension: -Vex.Flow.STEM_HEIGHT,
	      gracenote_stem_down_extension: -Vex.Flow.STEM_HEIGHT,
	      tabnote_stem_up_extension: -Vex.Flow.STEM_HEIGHT,
	      tabnote_stem_down_extension: -Vex.Flow.STEM_HEIGHT,
	      dot_shiftY: 0,
	      line_above: 0,
	      line_below: 0
	    },
	    type: {
	      "n": { // Whole note
	        code_head: "v1d"
	      },
	      "h": { // Whole note harmonic
	        code_head: "v46"
	      },
	      "m": { // Whole note muted
	        code_head: "v92",
	        stem_offset: -3
	      },
	      "r": { // Whole rest
	        code_head: "v5c",
	        head_width: 12,
	        rest: true,
	        position: "D/5",
	        dot_shiftY: 0.5
	      },
	      "s": { // Whole note slash
	        // Drawn with canvas primitives
	        head_width: 15,
	        position: "B/4"
	      }
	    }
	  },
	  "2": {
	    common: {
	      head_width: 10,
	      stem: true,
	      stem_offset: 0,
	      flag: false,
	      stem_up_extension: 0,
	      stem_down_extension: 0,
	      gracenote_stem_up_extension: -14,
	      gracenote_stem_down_extension: -14,
	      tabnote_stem_up_extension: 0,
	      tabnote_stem_down_extension: 0,
	      dot_shiftY: 0,
	      line_above: 0,
	      line_below: 0
	    },
	    type: {
	      "n": { // Half note
	        code_head: "v81"
	      },
	      "h": { // Half note harmonic
	        code_head: "v2d"
	      },
	      "m": { // Half note muted
	        code_head: "v95",
	        stem_offset: -3
	      },
	      "r": { // Half rest
	        code_head: "vc",
	        head_width: 12,
	        stem: false,
	        rest: true,
	        position: "B/4",
	        dot_shiftY: -0.5
	      },
	      "s": { // Half note slash
	        // Drawn with canvas primitives
	        head_width: 15,
	        position: "B/4"
	      }
	    }
	  },
	  "4": {
	    common: {
	      head_width: 10,
	      stem: true,
	      stem_offset: 0,
	      flag: false,
	      stem_up_extension: 0,
	      stem_down_extension: 0,
	      gracenote_stem_up_extension: -14,
	      gracenote_stem_down_extension: -14,
	      tabnote_stem_up_extension: 0,
	      tabnote_stem_down_extension: 0,
	      dot_shiftY: 0,
	      line_above: 0,
	      line_below: 0
	    },
	    type: {
	      "n": { // Quarter note
	        code_head: "vb"
	      },
	      "h": { // Quarter harmonic
	        code_head: "v22"
	      },
	      "m": { // Quarter muted
	        code_head: "v3e",
	        stem_offset: -3
	      },
	      "r": { // Quarter rest
	        code_head: "v7c",
	        head_width: 8,
	        stem: false,
	        rest: true,
	        position: "B/4",
	        dot_shiftY: -0.5,
	        line_above: 1.5,
	        line_below: 1.5
	      },
	      "s": { // Quarter slash
	         // Drawn with canvas primitives
	         head_width: 15,
	         position: "B/4"
	      }
	    }
	  },
	  "8": {
	    common: {
	      head_width: 10,
	      stem: true,
	      stem_offset: 0,
	      flag: true,
	      beam_count: 1,
	      code_flag_upstem: "v54",
	      code_flag_downstem: "v9a",
	      stem_up_extension: 0,
	      stem_down_extension: 0,
	      gracenote_stem_up_extension: -14,
	      gracenote_stem_down_extension: -14,
	      tabnote_stem_up_extension: 0,
	      tabnote_stem_down_extension: 0,
	      dot_shiftY: 0,
	      line_above: 0,
	      line_below: 0
	    },
	    type: {
	      "n": { // Eighth note
	        code_head: "vb"
	      },
	      "h": { // Eighth note harmonic
	        code_head: "v22"
	      },
	      "m": { // Eighth note muted
	        code_head: "v3e"
	      },
	      "r": { // Eighth rest
	        code_head: "va5",
	        stem: false,
	        flag: false,
	        rest: true,
	        position: "B/4",
	        dot_shiftY: -0.5,
	        line_above: 1.0,
	        line_below: 1.0
	      },
	      "s": { // Eight slash
	        // Drawn with canvas primitives
	        head_width: 15,
	        position: "B/4"
	      }
	    }
	  },
	  "16": {
	    common: {
	      beam_count: 2,
	      head_width: 10,
	      stem: true,
	      stem_offset: 0,
	      flag: true,
	      code_flag_upstem: "v3f",
	      code_flag_downstem: "v8f",
	      stem_up_extension: 4,
	      stem_down_extension: 0,
	      gracenote_stem_up_extension: -14,
	      gracenote_stem_down_extension: -14,
	      tabnote_stem_up_extension: 0,
	      tabnote_stem_down_extension: 0,
	      dot_shiftY: 0,
	      line_above: 0,
	      line_below: 0
	    },
	    type: {
	      "n": { // Sixteenth note
	        code_head: "vb"
	      },
	      "h": { // Sixteenth note harmonic
	        code_head: "v22"
	      },
	      "m": { // Sixteenth note muted
	        code_head: "v3e"
	      },
	      "r": { // Sixteenth rest
	        code_head: "v3c",
	        head_width: 13,
	        stem: false,
	        flag: false,
	        rest: true,
	        position: "B/4",
	        dot_shiftY: -0.5,
	        line_above: 1.0,
	        line_below: 2.0
	      },
	      "s": { // Sixteenth slash
	        // Drawn with canvas primitives
	        head_width: 15,
	        position: "B/4"
	      }
	    }
	  },
	  "32": {
	    common: {
	      beam_count: 3,
	      head_width: 10,
	      stem: true,
	      stem_offset: 0,
	      flag: true,
	      code_flag_upstem: "v47",
	      code_flag_downstem: "v2a",
	      stem_up_extension: 13,
	      stem_down_extension: 9,
	      gracenote_stem_up_extension: -12,
	      gracenote_stem_down_extension: -12,
	      tabnote_stem_up_extension: 9,
	      tabnote_stem_down_extension: 5,
	      dot_shiftY: 0,
	      line_above: 0,
	      line_below: 0
	    },
	    type: {
	      "n": { // Thirty-second note
	        code_head: "vb"
	      },
	      "h": { // Thirty-second harmonic
	        code_head: "v22"
	      },
	      "m": { // Thirty-second muted
	        code_head: "v3e"
	      },
	      "r": { // Thirty-second rest
	        code_head: "v55",
	        head_width: 16,
	        stem: false,
	        flag: false,
	        rest: true,
	        position: "B/4",
	        dot_shiftY: -1.5,
	        line_above: 2.0,
	        line_below: 2.0
	      },
	      "s": { // Thirty-second slash
	        // Drawn with canvas primitives
	        head_width: 15,
	        position: "B/4"
	      }
	    }
	  },
	  "64": {
	    common: {
	      beam_count: 4,
	      head_width: 10,
	      stem: true,
	      stem_offset: 0,
	      flag: true,
	      code_flag_upstem: "va9",
	      code_flag_downstem: "v58",
	      stem_up_extension: 17,
	      stem_down_extension: 13,
	      gracenote_stem_up_extension: -10,
	      gracenote_stem_down_extension: -10,
	      tabnote_stem_up_extension: 13,
	      tabnote_stem_down_extension: 9,
	      dot_shiftY: 0,
	      line_above: 0,
	      line_below: 0
	    },
	    type: {
	      "n": { // Sixty-fourth note
	        code_head: "vb"
	      },
	      "h": { // Sixty-fourth harmonic
	        code_head: "v22"
	      },
	      "m": { // Sixty-fourth muted
	        code_head: "v3e"
	      },
	      "r": { // Sixty-fourth rest
	        code_head: "v38",
	        head_width: 18,
	        stem: false,
	        flag: false,
	        rest: true,
	        position: "B/4",
	        dot_shiftY: -1.5,
	        line_above: 2.0,
	        line_below: 3.0
	      },
	      "s": { // Sixty-fourth slash
	        // Drawn with canvas primitives
	        head_width: 15,
	        position: "B/4"
	      }
	    }
	  },
	  "128": {
	      common: {
	          beam_count: 5,
	          head_width: 10,
	          stem: true,
	          stem_offset:0,
	          flag: true,
	          code_flag_upstem: "v9b",
	          code_flag_downstem: "v30",
	          stem_up_extension: 26,
	          stem_down_extension: 22,
	          gracenote_stem_up_extension: -8,
	          gracenote_stem_down_extension: -8,
	          tabnote_stem_up_extension: 22,
	          tabnote_stem_down_extension: 18,
	          dot_shiftY: 0,
	          line_above: 0,
	          line_below: 0
	      },
	      type: {
	          "n": {  // Hundred-twenty-eight note
	              code_head: "vb"
	          },
	          "h": { // Hundred-twenty-eight harmonic
	              code_head: "v22"
	          },
	          "m": { // Hundred-twenty-eight muted
	              code_head: "v3e"
	          },
	          "r": {  // Hundred-twenty-eight rest
	              code_head: "vaa",
	              head_width: 20,
	              stem: false,
	              flag: false,
	              rest: true,
	              position: "B/4",
	              dot_shiftY: 1.5,
	              line_above: 3.0,
	              line_below: 3.0
	          },
	          "s": { // Hundred-twenty-eight rest
	              // Drawn with canvas primitives
	              head_width: 15,
	              position: "B/4"
	          }
	      }
	  }
	};
	
	// Some defaults
	Vex.Flow.TIME4_4 = {
	  num_beats: 4,
	  beat_value: 4,
	  resolution: Vex.Flow.RESOLUTION
	};
	
	Vex.Flow.Font = {"glyphs":{"v0":{"x_min":0,"x_max":514.5,"ha":525,"o":"m 236 648 b 246 648 238 648 242 648 b 288 646 261 648 283 648 b 472 513 364 634 428 587 b 514 347 502 464 514 413 b 462 163 514 272 499 217 b 257 44 409 83 333 44 b 50 163 181 44 103 83 b 0 347 14 217 0 272 b 40 513 0 413 12 464 b 236 648 87 591 155 638 m 277 614 b 253 616 273 616 261 616 b 242 616 247 616 243 616 b 170 499 193 609 181 589 b 159 348 163 446 159 398 b 166 222 159 308 161 266 b 201 91 174 138 183 106 b 257 76 215 81 235 76 b 311 91 277 76 299 81 b 347 222 330 106 338 138 b 353 348 352 266 353 308 b 344 499 353 398 351 446 b 277 614 333 587 322 606 m 257 -1 l 258 -1 l 255 -1 l 257 -1 m 257 673 l 258 673 l 255 673 l 257 673 "},"v1":{"x_min":-1.359375,"x_max":344.359375,"ha":351,"o":"m 126 637 l 129 638 l 198 638 l 266 638 l 269 635 b 274 631 272 634 273 632 l 277 627 l 277 395 b 279 156 277 230 277 161 b 329 88 281 123 295 106 b 344 69 341 81 344 79 b 337 55 344 62 343 59 l 333 54 l 197 54 l 61 54 l 58 55 b 50 69 53 59 50 62 b 65 88 50 79 53 81 b 80 97 72 91 74 93 b 117 156 103 113 112 129 b 117 345 117 161 117 222 l 117 528 l 100 503 l 38 406 b 14 383 24 384 23 383 b -1 398 5 383 -1 390 b 4 415 -1 403 1 409 b 16 437 5 416 10 426 l 72 539 l 100 596 b 121 632 119 631 119 631 b 126 637 122 634 125 635 m 171 -1 l 172 -1 l 170 -1 l 171 -1 m 171 673 l 172 673 l 170 673 l 171 673 "},"v2":{"x_min":-1.359375,"x_max":458.6875,"ha":468,"o":"m 197 648 b 216 648 201 648 208 648 b 258 646 232 648 253 648 b 419 546 333 637 393 599 b 432 489 428 528 432 509 b 356 342 432 440 405 384 b 235 278 322 313 288 295 b 69 170 166 256 107 217 b 69 169 69 170 69 169 b 69 169 69 169 69 169 b 74 173 69 169 72 170 b 209 222 112 204 163 222 b 310 195 247 222 274 215 b 371 179 332 184 352 179 b 396 181 379 179 387 179 b 428 202 409 184 423 194 b 442 212 431 209 436 212 b 458 197 450 212 458 206 b 441 148 458 190 449 165 b 299 44 409 84 353 44 b 288 45 295 44 292 44 b 250 61 274 45 268 49 b 122 99 212 86 164 99 b 73 91 104 99 88 97 b 28 63 53 84 34 72 b 14 54 25 56 20 54 b 1 62 9 54 4 56 l -1 65 l -1 79 b 0 99 -1 91 0 95 b 2 113 1 102 2 108 b 164 309 20 197 81 272 b 285 470 232 341 277 398 b 287 487 287 476 287 481 b 171 595 287 551 239 595 b 155 595 166 595 160 595 b 142 592 145 594 142 594 b 145 589 142 592 142 591 b 179 527 168 576 179 551 b 132 455 179 496 163 467 b 104 451 122 452 112 451 b 27 530 62 451 27 487 b 29 555 27 538 27 546 b 197 648 44 601 115 639 m 228 -1 l 230 -1 l 227 -1 l 228 -1 m 228 673 l 230 673 l 227 673 l 228 673 "},"v3":{"x_min":-1.359375,"x_max":409.6875,"ha":418,"o":"m 174 648 b 191 648 176 648 183 648 b 225 648 204 648 220 648 b 402 523 317 638 389 588 b 404 503 404 517 404 510 b 402 484 404 495 404 488 b 264 373 389 437 334 394 b 257 370 259 371 257 371 b 257 370 257 370 257 370 b 264 369 258 370 261 369 b 409 202 359 334 409 267 b 318 72 409 152 381 104 b 200 43 281 52 240 43 b 23 113 134 43 69 68 b 0 169 6 129 0 149 b 77 249 0 210 29 249 l 77 249 b 152 174 125 249 152 212 b 103 102 152 145 137 116 b 103 102 103 102 103 102 b 147 94 103 101 132 95 b 153 94 149 94 151 94 b 265 206 219 94 265 141 b 264 226 265 213 265 219 b 147 355 253 299 204 353 b 126 371 133 356 126 362 b 147 388 126 383 132 388 b 254 474 196 391 238 424 b 259 502 258 484 259 494 b 182 592 259 544 228 582 b 156 595 175 595 166 595 b 115 592 142 595 129 594 l 111 591 l 115 588 b 152 524 141 574 152 549 b 92 449 152 491 130 458 b 76 448 87 448 81 448 b -1 530 32 448 -1 488 b 20 581 -1 548 5 566 b 174 648 55 619 108 641 m 204 -1 l 205 -1 l 202 -1 l 204 -1 m 204 673 l 205 673 l 202 673 l 204 673 "},"v4":{"x_min":0,"x_max":468.21875,"ha":478,"o":"m 174 637 b 232 638 175 638 189 638 b 277 638 245 638 259 638 l 378 638 l 381 635 b 389 623 386 632 389 627 b 382 609 389 617 386 613 b 366 589 381 606 372 598 l 313 528 l 245 451 l 209 410 l 155 348 l 84 267 b 59 240 72 252 59 240 b 59 240 59 240 59 240 b 151 238 59 238 68 238 l 242 238 l 242 303 b 243 371 242 369 242 370 b 289 426 245 374 254 385 l 303 441 l 317 456 l 338 483 l 360 506 l 371 520 b 386 527 375 526 381 527 b 400 519 392 527 397 524 b 401 440 401 516 401 514 b 401 377 401 423 401 402 l 401 238 l 426 238 b 453 237 449 238 450 238 b 465 217 461 234 465 226 b 460 202 465 212 464 206 b 426 197 454 197 453 197 l 401 197 l 401 180 b 451 88 402 129 412 109 b 468 69 465 81 468 79 b 461 55 468 62 466 59 l 458 54 l 321 54 l 185 54 l 182 55 b 175 69 176 59 175 62 b 191 88 175 79 176 81 b 240 180 230 109 240 129 l 240 197 l 125 197 b 73 195 104 195 87 195 b 8 197 10 195 9 197 b 0 212 2 199 0 205 b 0 212 0 212 0 212 b 20 242 0 219 0 219 b 163 610 104 344 163 492 b 174 637 163 628 166 634 m 234 -1 l 235 -1 l 232 -1 l 234 -1 m 234 673 l 235 673 l 232 673 l 234 673 "},"v5":{"x_min":0,"x_max":409.6875,"ha":418,"o":"m 47 637 b 53 638 49 638 50 638 b 69 634 55 638 61 637 b 210 610 114 619 161 610 b 363 634 259 610 311 619 b 382 638 372 637 378 638 b 392 634 386 638 389 637 b 397 623 396 630 397 627 b 393 610 397 620 396 616 b 298 505 368 552 338 520 b 212 494 277 498 246 494 b 65 517 163 494 106 502 b 61 517 62 517 61 517 b 61 517 61 517 61 517 b 51 408 61 517 51 412 b 51 408 51 408 51 408 b 51 408 51 408 51 408 b 61 412 53 408 55 409 b 125 434 80 421 103 430 b 185 441 145 440 166 441 b 409 244 310 441 409 353 b 401 191 409 227 406 209 b 197 43 375 105 287 43 b 159 47 183 43 171 44 b 23 123 112 56 61 86 b 0 180 6 140 0 159 b 76 260 0 220 31 260 b 92 259 81 260 87 259 b 152 183 132 251 152 216 b 100 112 152 152 134 122 b 95 111 98 112 95 111 b 95 111 95 111 95 111 b 129 98 95 109 119 101 b 148 97 136 97 141 97 b 264 235 206 97 261 158 b 265 248 265 240 265 244 b 210 398 265 312 243 373 b 179 408 201 406 194 408 b 174 408 178 408 176 408 b 53 369 130 408 88 394 b 34 359 39 359 38 359 b 17 374 24 359 17 365 b 39 628 17 384 38 625 b 47 637 40 631 43 635 m 204 -1 l 205 -1 l 202 -1 l 204 -1 m 204 673 l 205 673 l 202 673 l 204 673 "},"v6":{"x_min":0,"x_max":475.03125,"ha":485,"o":"m 255 648 b 274 648 259 648 266 648 b 314 646 288 648 307 648 b 450 555 374 637 438 594 b 454 530 453 546 454 538 b 375 451 454 485 416 451 b 328 467 359 451 343 455 b 300 526 310 483 300 503 b 352 598 300 557 319 589 b 356 599 355 598 356 599 b 352 602 356 599 355 601 b 288 616 330 612 308 616 b 210 584 257 616 230 605 b 164 433 189 559 174 508 b 160 374 163 415 160 381 b 160 374 160 374 160 374 b 160 374 160 374 160 374 b 168 377 160 374 164 376 b 258 395 200 390 228 395 b 366 367 294 395 328 387 b 475 223 436 333 475 283 b 472 197 475 215 473 206 b 349 65 462 141 419 95 b 259 43 317 51 288 43 b 167 69 230 43 200 52 b 4 290 80 113 20 195 b 0 349 1 309 0 328 b 20 467 0 391 6 433 b 255 648 58 563 155 637 m 269 363 b 257 363 265 363 261 363 b 210 345 236 363 220 356 b 186 226 196 324 186 272 b 187 198 186 216 186 206 b 213 95 191 151 202 112 b 257 76 221 83 238 76 b 270 77 261 76 266 76 b 321 156 299 81 310 99 b 329 229 326 183 329 206 b 321 301 329 252 326 274 b 269 363 311 342 298 359 m 236 -1 l 238 -1 l 235 -1 l 236 -1 m 236 673 l 238 673 l 235 673 l 236 673 "},"v7":{"x_min":0,"x_max":442.359375,"ha":451,"o":"m 147 648 b 166 649 153 649 160 649 b 313 598 217 649 273 630 b 340 587 323 588 328 587 l 341 587 b 412 628 367 587 390 601 b 427 638 416 635 421 638 b 439 632 431 638 435 637 b 442 623 441 630 442 628 b 430 569 442 616 439 603 b 352 369 408 492 377 410 b 300 259 325 324 313 298 b 273 84 283 205 273 140 b 265 55 273 65 272 59 l 261 54 l 181 54 l 99 54 l 96 55 b 91 61 95 56 92 59 l 89 63 l 89 77 b 147 263 89 133 111 202 b 261 401 176 313 212 355 b 378 541 315 449 349 489 l 382 548 l 375 544 b 240 495 333 512 285 495 b 129 535 198 495 160 509 b 84 560 108 552 95 560 b 76 559 81 560 78 560 b 31 487 59 555 43 530 b 14 470 27 473 24 470 b 1 477 8 470 4 471 l 0 480 l 0 553 l 0 627 l 1 630 b 16 638 4 635 9 638 b 23 635 17 638 20 637 b 49 626 36 626 39 626 b 96 638 59 626 80 630 b 104 639 99 638 102 639 b 117 644 107 641 112 642 b 147 648 125 645 137 648 m 220 -1 l 221 -1 l 219 -1 l 220 -1 m 220 673 l 221 673 l 219 673 l 220 673 "},"v8":{"x_min":0,"x_max":488.640625,"ha":499,"o":"m 217 648 b 245 649 225 648 235 649 b 453 516 343 649 430 595 b 458 478 455 503 458 491 b 412 370 458 440 441 398 b 411 369 412 369 411 369 b 415 365 411 367 412 367 b 488 231 462 331 488 281 b 472 165 488 208 483 186 b 243 43 434 86 338 43 b 63 104 178 43 112 62 b 0 233 20 140 0 186 b 73 365 0 283 24 331 l 77 369 l 72 374 b 29 476 42 406 29 441 b 217 648 29 557 103 635 m 258 605 b 242 606 253 605 247 606 b 157 552 198 606 157 580 b 160 541 157 548 159 544 b 319 413 176 503 242 452 l 337 403 l 338 406 b 359 476 352 428 359 452 b 258 605 359 537 318 595 m 138 326 b 130 330 134 328 130 330 b 130 330 130 330 130 330 b 107 305 127 330 112 313 b 84 231 91 281 84 256 b 243 86 84 156 151 86 b 249 87 245 86 246 87 b 347 156 303 88 347 120 b 344 172 347 162 345 167 b 156 319 325 227 257 281 b 138 326 151 322 144 324 m 243 -1 l 245 -1 l 242 -1 l 243 -1 m 243 673 l 245 673 l 242 673 l 243 673 "},"v9":{"x_min":0,"x_max":475.03125,"ha":485,"o":"m 191 646 b 212 649 198 648 205 649 b 255 644 227 649 243 646 b 458 448 348 616 428 539 b 475 342 469 415 475 378 b 460 244 475 308 469 274 b 193 44 421 124 303 44 b 91 69 157 44 122 51 b 19 161 43 97 19 126 b 21 181 19 167 20 174 b 98 241 32 220 65 241 b 170 186 129 241 160 223 b 172 166 171 179 172 173 b 121 94 172 134 152 102 b 117 93 118 94 117 93 b 121 90 117 93 118 91 b 185 76 142 80 164 76 b 270 119 220 76 251 91 b 308 259 287 145 300 194 b 313 317 310 277 313 310 b 313 317 313 317 313 317 b 313 317 313 317 313 317 b 304 315 313 317 308 316 b 216 295 273 302 245 295 b 145 308 193 295 170 299 b 19 398 88 327 42 360 b 0 469 5 420 0 444 b 24 551 0 496 8 526 b 191 646 54 596 125 637 m 227 614 b 215 616 224 616 220 616 b 202 614 210 616 206 616 b 152 535 174 610 163 592 b 144 463 147 509 144 485 b 152 391 144 440 147 417 b 216 328 163 344 179 328 b 280 391 253 328 269 344 b 288 463 285 417 288 440 b 280 535 288 485 285 509 b 227 614 269 594 258 610 m 236 -1 l 238 -1 l 235 -1 l 236 -1 m 236 673 l 238 673 l 235 673 l 236 673 "},"va":{"x_min":-149.71875,"x_max":148.359375,"ha":151,"o":"m -8 -1 b -1 0 -5 -1 -4 0 b 16 -11 5 0 13 -4 b 83 -186 17 -12 47 -90 l 148 -358 l 148 -363 b 127 -385 148 -376 138 -385 b 112 -378 122 -385 118 -383 b 54 -226 110 -374 114 -385 b 0 -81 24 -147 0 -81 b -55 -226 -1 -81 -25 -147 b -114 -378 -115 -385 -111 -374 b -129 -385 -119 -383 -123 -385 b -149 -363 -140 -385 -149 -376 l -149 -358 l -84 -186 b -19 -11 -49 -90 -19 -12 b -8 -1 -17 -8 -12 -4 "},"vb":{"x_min":0,"x_max":428.75,"ha":438,"o":"m 262 186 b 273 186 266 186 272 186 b 274 186 273 186 274 186 b 285 186 274 186 280 186 b 428 48 375 181 428 122 b 386 -68 428 12 416 -29 b 155 -187 329 -145 236 -187 b 12 -111 92 -187 38 -162 b 0 -51 4 -91 0 -72 b 262 186 0 58 122 179 "},"vc":{"x_min":0,"x_max":447.8125,"ha":457,"o":"m 0 86 l 0 173 l 223 173 l 447 173 l 447 86 l 447 0 l 223 0 l 0 0 l 0 86 "},"vf":{"x_min":0,"x_max":370.21875,"ha":378,"o":"m 0 0 l 0 277 l 61 277 l 122 277 l 122 0 l 122 -278 l 61 -278 l 0 -278 l 0 0 m 246 -1 l 246 277 l 308 277 l 370 277 l 370 -1 l 370 -278 l 308 -278 l 246 -278 l 246 -1 "},"v10":{"x_min":0,"x_max":559.421875,"ha":571,"o":"m 5 127 b 14 127 6 127 9 127 b 51 126 25 127 43 127 b 175 98 93 122 138 112 l 186 94 b 279 51 210 86 255 65 b 285 47 280 51 283 48 b 319 27 291 44 311 31 l 326 22 b 359 0 332 19 352 4 l 367 -6 b 371 -9 368 -6 370 -8 l 379 -15 b 387 -22 383 -18 386 -20 l 398 -30 l 411 -40 l 417 -47 l 427 -55 l 434 -61 b 441 -66 436 -62 439 -65 l 446 -72 l 453 -77 l 462 -87 b 558 -188 490 -113 549 -176 b 559 -195 559 -191 559 -194 b 548 -205 559 -201 555 -205 b 541 -204 547 -205 544 -205 b 534 -198 539 -201 536 -199 l 525 -191 b 481 -162 518 -187 490 -167 b 472 -155 477 -159 472 -156 b 468 -152 470 -155 469 -154 b 461 -149 466 -152 464 -151 b 428 -130 454 -145 441 -137 b 371 -99 413 -122 372 -99 b 363 -95 371 -99 367 -98 b 353 -91 357 -94 353 -91 b 348 -90 353 -91 352 -91 b 332 -81 343 -87 341 -86 b 27 -12 230 -37 127 -13 b 0 -5 4 -11 2 -11 b 0 58 0 -2 0 27 b 0 122 0 88 0 120 b 5 127 1 124 4 126 "},"v11":{"x_min":-155.171875,"x_max":153.8125,"ha":157,"o":"m -137 353 b -130 353 -136 353 -133 353 b -112 349 -125 353 -119 352 b -100 342 -110 347 -104 344 b 0 317 -69 326 -35 317 b 111 349 38 317 76 328 b 129 353 117 352 123 353 b 153 327 142 353 153 344 b 144 302 153 320 153 317 b 27 6 93 226 50 113 b 21 -13 24 -11 24 -11 b 0 -26 17 -22 8 -26 b -24 -12 -9 -26 -19 -22 b -28 5 -24 -9 -27 -2 b -145 302 -53 117 -95 224 b -155 327 -155 317 -155 320 b -137 353 -155 340 -148 349 "},"v18":{"x_min":0,"x_max":323.9375,"ha":331,"o":"m 217 535 b 225 537 220 537 221 537 b 245 524 235 537 242 533 l 246 521 l 247 390 l 247 258 l 273 265 b 306 270 288 269 299 270 b 322 259 315 270 319 267 b 323 208 323 256 323 233 b 322 158 323 184 323 159 b 288 140 318 148 315 147 b 247 130 254 131 247 130 b 247 65 247 130 247 104 b 247 20 247 51 247 36 l 247 -88 l 273 -81 b 306 -76 289 -77 299 -76 b 318 -81 311 -76 315 -77 b 323 -123 323 -87 323 -86 l 323 -138 l 323 -154 b 318 -195 323 -191 323 -190 b 269 -210 314 -199 315 -199 b 249 -216 259 -213 250 -216 l 247 -216 l 247 -349 l 246 -483 l 245 -487 b 225 -499 242 -495 234 -499 b 206 -487 219 -499 210 -495 l 205 -483 l 205 -355 l 205 -227 l 204 -227 l 181 -233 l 138 -244 b 117 -249 127 -247 117 -249 b 115 -385 115 -249 115 -256 l 115 -523 l 114 -526 b 95 -538 110 -534 102 -538 b 74 -526 87 -538 78 -534 l 73 -523 l 73 -391 b 72 -260 73 -269 73 -260 b 72 -260 72 -260 72 -260 b 19 -273 61 -263 23 -273 b 0 -260 10 -273 4 -267 b 0 -209 0 -256 0 -256 l 0 -162 l 1 -158 b 61 -134 5 -148 5 -148 l 73 -131 l 73 -22 b 72 86 73 79 73 86 b 72 86 72 86 72 86 b 19 74 61 83 23 74 b 0 86 10 74 4 79 b 0 137 0 90 0 90 l 0 184 l 1 188 b 61 212 5 198 5 198 l 73 215 l 73 348 l 73 481 l 74 485 b 95 498 78 492 87 498 b 103 495 98 498 100 496 b 114 485 107 494 111 489 l 115 481 l 115 353 l 115 226 l 121 226 b 159 235 123 227 141 231 l 198 247 l 205 248 l 205 384 l 205 521 l 206 524 b 217 535 209 528 212 533 m 205 9 b 205 119 205 70 205 119 l 205 119 b 182 113 204 119 194 116 l 138 102 b 117 97 127 99 117 97 b 115 -12 115 97 115 91 l 115 -122 l 121 -120 b 159 -111 123 -119 141 -115 l 198 -101 l 205 -98 l 205 9 "},"v1b":{"x_min":0,"x_max":559.421875,"ha":571,"o":"m 544 204 b 548 204 545 204 547 204 b 559 194 555 204 559 199 b 559 190 559 192 559 191 b 530 156 559 188 556 184 b 462 86 510 134 481 104 b 453 76 458 81 454 77 l 446 70 l 441 65 b 434 59 439 63 436 61 l 427 54 b 409 37 426 51 416 44 b 392 23 398 29 394 26 b 387 19 389 22 387 20 b 379 13 386 19 383 16 l 371 8 l 367 5 l 359 -1 l 337 -16 b 285 -48 319 -29 298 -41 l 279 -52 b 186 -95 255 -66 210 -87 l 175 -99 b 23 -129 127 -117 68 -129 b 17 -129 20 -129 19 -129 b 1 -123 2 -129 2 -129 b 0 -49 0 -122 0 -83 b 0 4 0 -22 0 1 b 27 11 2 9 4 9 b 185 31 78 12 145 20 b 198 34 186 31 193 33 b 314 73 234 44 277 58 b 349 88 328 79 340 84 b 353 90 352 90 353 90 b 363 94 353 90 357 93 b 371 98 367 97 371 98 b 428 129 372 98 413 120 b 461 148 441 136 454 144 b 468 151 464 149 466 151 b 472 154 469 152 470 154 b 481 161 473 155 477 158 b 525 190 490 166 518 186 l 534 197 b 540 201 536 198 539 199 b 544 204 541 202 544 204 "},"v1d":{"x_min":0,"x_max":619.3125,"ha":632,"o":"m 274 184 b 307 186 285 186 296 186 b 616 22 465 186 597 116 b 619 -1 617 13 619 5 b 308 -187 619 -104 483 -187 b 0 -1 133 -187 0 -102 b 5 36 0 11 1 23 b 274 184 29 115 141 176 m 289 161 b 272 162 284 162 277 162 b 171 41 209 162 171 108 b 205 -73 171 5 182 -34 b 345 -163 243 -133 298 -163 b 436 -98 385 -163 420 -142 b 446 -43 443 -80 446 -62 b 289 161 446 47 377 147 "},"v1e":{"x_min":-402.890625,"x_max":401.53125,"ha":410,"o":"m -219 173 b -213 174 -217 174 -215 174 b -202 173 -209 174 -205 173 b -114 86 -200 172 -179 151 b -28 0 -66 37 -28 0 b 40 84 -28 0 2 37 b 117 174 111 173 110 172 b 122 174 118 174 119 174 b 132 173 125 174 129 173 b 295 11 134 172 171 134 l 307 -1 l 336 34 b 374 76 366 72 368 74 b 381 77 375 77 378 77 b 401 56 392 77 401 68 b 400 48 401 54 401 51 b 223 -172 397 41 230 -166 b 210 -176 220 -174 215 -176 b 201 -174 206 -176 204 -176 b 112 -87 198 -173 178 -152 b 27 0 65 -38 27 0 b -42 -86 27 0 -4 -38 b -118 -174 -112 -174 -111 -173 b -123 -176 -119 -176 -121 -176 b -133 -174 -126 -176 -130 -174 b -296 -12 -136 -173 -172 -137 l -308 0 l -337 -34 b -375 -77 -367 -73 -370 -76 b -382 -79 -377 -79 -379 -79 b -402 -58 -393 -79 -402 -69 b -401 -49 -402 -55 -402 -52 b -224 172 -398 -43 -228 167 b -219 173 -223 172 -220 173 "},"v1f":{"x_min":-340.28125,"x_max":338.921875,"ha":346,"o":"m -32 520 b -29 521 -31 520 -31 521 b -23 519 -27 521 -24 520 b -20 513 -21 517 -20 516 b -21 506 -20 512 -20 509 b -31 474 -23 502 -27 488 l -53 402 l -66 352 l -68 349 l -57 349 b -32 351 -51 349 -40 351 b 123 370 19 352 74 359 b 137 371 127 370 133 371 b 170 356 152 371 164 366 b 171 355 170 355 170 355 b 216 366 174 355 183 358 b 280 378 268 377 266 377 b 287 378 283 378 284 378 b 332 349 307 378 322 369 b 338 319 336 341 338 330 b 332 301 338 310 336 302 b 242 280 329 299 246 280 b 242 280 242 280 242 280 b 235 288 236 280 235 283 b 235 292 235 290 235 291 b 236 302 236 297 236 299 b 220 337 236 316 230 330 l 216 340 l 210 335 b 159 276 189 322 172 301 b 118 149 152 265 156 274 b 81 34 84 36 85 36 b -8 13 78 33 -4 13 b -8 13 -8 13 -8 13 b -14 20 -12 15 -14 15 b -8 44 -14 24 -12 31 b -2 66 -5 55 -2 65 b -2 66 -2 66 -2 66 l -2 66 b -43 41 -2 66 -21 55 b -114 4 -98 8 -98 8 b -144 0 -123 0 -134 0 b -242 99 -197 0 -242 43 b -242 109 -242 102 -242 105 b -212 219 -240 122 -242 116 b -185 312 -197 270 -185 312 l -185 312 b -189 312 -185 312 -186 312 b -259 312 -200 312 -227 312 b -321 310 -291 312 -310 310 b -334 312 -330 310 -334 312 b -340 319 -338 313 -340 316 b -336 326 -340 322 -338 324 b -291 337 -334 326 -314 331 l -247 347 l -210 348 b -172 348 -190 348 -172 348 b -168 363 -172 348 -171 355 b -145 442 -151 424 -145 441 b -133 452 -144 444 -140 446 l -77 489 b -32 520 -53 506 -32 520 m 57 334 b 53 335 55 335 54 335 b 44 334 50 335 49 335 b -70 316 8 326 -28 320 b -78 309 -78 316 -78 316 b -108 202 -80 305 -88 274 b -141 81 -136 112 -141 93 b -140 74 -141 79 -141 77 b -117 49 -137 59 -127 49 b -107 52 -114 49 -110 51 b 16 127 -106 54 14 126 b 42 217 16 127 42 215 b 49 241 42 222 44 229 b 73 320 53 251 73 317 b 57 334 73 327 65 333 "},"v20":{"x_min":-571.671875,"x_max":570.3125,"ha":582,"o":"m -559 351 b -551 352 -556 352 -553 352 b -530 338 -543 352 -533 348 b -529 169 -530 337 -529 291 l -529 1 l -507 27 l -441 112 b -382 174 -394 169 -390 174 b -378 174 -381 174 -379 174 b -281 86 -370 174 -375 179 b -196 0 -234 37 -196 0 b -126 84 -196 0 -164 37 b -50 174 -55 173 -57 172 b -44 174 -49 174 -47 174 b -35 173 -42 174 -38 173 b 53 86 -32 172 -12 151 b 138 0 100 37 138 0 b 208 84 140 0 170 37 b 284 174 279 173 279 172 b 289 174 285 174 288 174 b 300 173 294 174 298 173 b 462 11 303 172 340 134 l 475 -1 l 503 34 b 541 76 534 72 536 74 b 548 77 544 77 545 77 b 570 56 560 77 570 68 b 567 48 570 54 568 51 b 392 -172 564 41 397 -166 b 378 -176 387 -174 382 -176 b 368 -174 375 -176 371 -176 b 280 -87 367 -173 347 -152 b 194 0 234 -38 194 0 b 126 -86 194 0 163 -38 b 49 -174 54 -174 55 -173 b 44 -176 47 -176 46 -176 b 34 -174 40 -176 36 -174 b -54 -87 31 -173 10 -152 b -140 0 -102 -38 -140 0 b -209 -86 -140 0 -171 -38 b -285 -174 -280 -174 -279 -173 b -291 -176 -287 -176 -288 -176 b -300 -174 -294 -176 -298 -174 b -464 -11 -303 -173 -374 -102 l -476 0 l -506 -37 b -539 -76 -528 -65 -537 -74 b -551 -80 -543 -79 -547 -80 b -570 -68 -558 -80 -566 -76 l -571 -65 l -571 136 b -570 340 -571 331 -571 337 b -559 351 -568 344 -564 348 "},"v22":{"x_min":0,"x_max":432.828125,"ha":442,"o":"m 209 186 b 213 187 210 187 212 187 b 216 187 215 187 216 187 b 224 174 216 186 220 180 b 420 -1 269 105 338 43 b 432 -12 431 -8 432 -9 b 421 -23 432 -15 432 -16 b 228 -180 345 -70 264 -137 b 219 -188 221 -188 221 -188 l 219 -188 b 208 -177 215 -188 215 -188 b 10 1 163 -106 93 -44 b 0 11 0 6 0 8 b 10 22 0 13 0 15 b 202 179 87 69 167 136 b 209 186 206 183 209 186 "},"v23":{"x_min":0,"x_max":133.390625,"ha":136,"o":"m 54 66 b 65 68 58 68 61 68 b 122 37 88 68 110 56 b 133 -1 130 26 133 12 b 104 -58 133 -23 123 -44 b 66 -69 92 -65 78 -69 b 10 -38 44 -69 23 -58 b 0 -1 2 -27 0 -13 b 54 66 0 30 20 61 "},"v25":{"x_min":0,"x_max":318.5,"ha":325,"o":"m 20 376 b 167 377 23 377 96 377 b 296 376 231 377 294 377 b 318 347 311 371 318 359 b 296 316 318 333 311 320 b 159 315 294 315 227 315 b 21 316 91 315 24 315 b 0 345 6 320 0 333 b 20 376 0 359 6 371 "},"v26":{"x_min":-21.78125,"x_max":483.1875,"ha":493,"o":"m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 383 20 616 20 616 l 20 148 l 21 151 b 140 199 59 183 102 199 b 206 179 164 199 187 192 l 210 176 l 210 396 l 210 617 l 212 621 b 231 632 216 628 223 632 b 250 620 239 632 247 628 b 251 383 251 616 251 616 l 251 148 l 254 151 b 370 199 291 183 332 199 b 415 191 385 199 400 197 b 483 84 458 176 483 134 b 461 0 483 58 476 29 b 332 -142 439 -40 411 -72 l 255 -215 b 231 -229 240 -229 239 -229 b 216 -223 224 -229 220 -227 b 210 -158 210 -217 210 -223 b 210 -120 210 -148 210 -136 l 210 -29 l 205 -34 b 100 -142 182 -65 159 -88 l 23 -215 b -1 -229 9 -229 6 -229 b -20 -216 -9 -229 -17 -224 l -21 -212 l -21 201 l -21 616 l -20 620 b -8 631 -17 624 -13 630 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 m 341 131 b 328 133 337 133 332 133 b 322 133 326 133 323 133 b 257 87 296 129 273 113 l 251 80 l 251 -37 l 251 -156 l 255 -152 b 375 81 328 -72 375 20 l 375 83 b 341 131 375 113 367 126 "},"v27":{"x_min":0,"x_max":432.828125,"ha":442,"o":"m 208 184 b 213 187 209 186 212 187 b 224 176 217 187 221 183 b 245 147 225 172 235 159 b 419 -1 288 90 347 38 b 431 -8 424 -4 431 -8 b 432 -12 432 -9 432 -11 b 430 -18 432 -13 432 -16 b 364 -61 424 -20 383 -47 b 225 -183 307 -102 250 -152 b 223 -187 224 -184 223 -187 b 220 -188 221 -188 220 -188 b 208 -176 216 -188 210 -184 b 187 -148 205 -173 197 -159 b 12 0 144 -90 84 -38 b 0 11 4 5 0 8 b 16 24 0 13 4 18 b 183 158 83 69 141 115 b 208 184 194 169 198 173 m 183 105 b 176 113 181 109 176 113 b 172 109 176 113 175 112 b 92 45 149 90 117 62 l 88 41 l 102 31 b 247 -105 160 -6 210 -55 l 254 -115 l 257 -112 l 269 -102 b 340 -45 287 -87 319 -61 l 344 -43 l 330 -33 b 183 105 272 6 221 54 "},"v28":{"x_min":-73.5,"x_max":72.140625,"ha":74,"o":"m -72 252 l -73 254 l 0 254 l 72 254 l 70 252 b 0 -1 70 248 0 -1 b -72 252 -1 -1 -72 248 "},"v29":{"x_min":-590.71875,"x_max":589.359375,"ha":601,"o":"m 175 273 b 182 274 178 273 181 274 b 202 262 190 274 198 269 b 204 158 204 259 204 259 l 204 56 l 250 112 b 303 174 296 172 298 172 b 308 174 304 174 307 174 b 318 173 313 174 317 173 b 481 11 322 172 357 134 l 494 -1 l 522 34 b 560 76 553 72 555 74 b 567 77 563 77 564 77 b 589 56 579 77 589 68 b 586 48 589 54 588 51 b 411 -172 583 41 416 -166 b 397 -176 406 -174 401 -176 b 387 -174 393 -176 390 -176 b 299 -87 386 -173 366 -152 b 213 0 253 -38 213 0 b 208 -6 213 0 210 -2 l 204 -12 l 204 -147 b 204 -210 204 -173 204 -194 b 198 -292 204 -297 204 -287 b 183 -299 194 -297 189 -299 b 164 -287 175 -299 167 -295 b 163 -174 163 -284 163 -284 l 161 -63 l 119 -117 b 65 -176 76 -170 73 -176 b 61 -176 63 -176 62 -176 b -35 -87 51 -174 57 -180 b -121 0 -83 -38 -121 0 b -190 -86 -122 0 -152 -38 b -266 -174 -261 -174 -259 -173 b -272 -176 -268 -176 -270 -176 b -281 -174 -276 -176 -280 -174 b -371 -86 -284 -173 -304 -152 b -457 0 -417 -38 -457 0 l -457 0 b -477 -26 -457 0 -470 -16 b -548 -227 -524 -88 -548 -161 b -536 -303 -548 -254 -544 -280 b -533 -317 -534 -309 -533 -313 b -553 -338 -533 -330 -541 -338 b -577 -315 -566 -338 -571 -333 b -590 -227 -586 -287 -590 -258 b -518 -9 -590 -154 -564 -77 b -465 56 -509 2 -504 8 l -402 134 b -363 174 -374 170 -371 174 b -359 174 -362 174 -360 174 b -262 86 -351 174 -356 179 b -176 0 -216 37 -176 0 b -107 84 -176 0 -145 37 b -31 174 -36 173 -38 172 b -25 174 -29 174 -28 174 b -16 173 -23 174 -19 173 b 147 11 -13 172 35 123 l 157 -1 l 160 1 l 163 4 l 163 130 b 164 260 163 256 163 258 b 175 273 166 266 170 270 "},"v2a":{"x_min":-21.78125,"x_max":366.140625,"ha":374,"o":"m 276 1378 b 284 1379 279 1379 281 1379 b 306 1360 292 1379 298 1374 b 352 1247 326 1326 343 1286 b 366 1139 362 1213 366 1175 b 347 1009 366 1093 359 1049 l 344 1002 l 347 992 b 352 971 348 986 351 977 b 366 863 362 936 366 899 b 347 732 366 818 359 773 l 344 725 l 347 716 b 352 695 348 710 351 700 b 366 588 362 659 366 623 b 223 262 366 464 314 345 b 189 233 212 252 212 252 b 35 76 126 183 73 129 b -1 16 20 56 2 27 b -19 4 -4 9 -12 4 l -21 4 l -21 137 l -21 270 l -17 270 b 186 344 59 281 134 308 b 319 606 270 399 319 499 b 317 650 319 620 319 635 l 315 659 l 314 655 b 223 537 288 607 258 570 b 189 509 212 528 212 528 b 35 352 126 459 73 405 b -1 292 20 333 2 303 b -19 280 -4 285 -12 280 l -21 280 l -21 413 l -21 546 l -17 546 b 186 620 59 557 134 584 b 319 882 270 675 319 775 b 317 925 319 896 319 911 l 315 935 l 314 931 b 223 813 288 884 258 846 b 189 785 212 805 212 805 b 35 628 126 735 73 681 b -1 569 20 609 2 580 b -19 556 -4 562 -12 556 l -21 556 l -21 689 l -21 823 l -17 823 b 202 907 68 835 152 867 b 319 1157 280 968 319 1061 b 270 1338 319 1218 303 1281 b 262 1358 264 1349 262 1353 b 262 1364 262 1360 262 1363 b 276 1378 265 1371 269 1376 "},"v2c":{"x_min":-597.53125,"x_max":596.171875,"ha":608,"o":"m -413 173 b -408 174 -412 174 -409 174 b -397 173 -404 174 -400 173 b -308 86 -394 172 -374 151 b -223 0 -261 37 -223 0 b -153 84 -223 0 -191 37 b -77 174 -83 173 -84 172 b -72 174 -76 174 -74 174 b -62 173 -68 174 -63 173 b 25 86 -59 172 -39 151 b 112 0 73 37 111 0 b 181 84 112 0 144 37 b 257 174 251 173 251 172 b 262 174 258 174 261 174 b 273 173 266 174 270 173 b 436 9 276 172 347 101 l 447 -1 l 477 36 b 522 79 511 79 513 79 l 522 79 b 552 51 533 79 539 73 b 596 -112 582 6 596 -51 b 567 -262 596 -161 586 -213 b 539 -322 558 -287 544 -316 b 524 -327 534 -326 529 -327 b 504 -315 515 -327 507 -323 b 503 -308 503 -312 503 -309 b 511 -285 503 -302 504 -297 b 555 -113 540 -227 555 -169 b 544 -34 555 -86 551 -59 b 522 19 540 -16 530 8 l 521 22 l 481 -26 l 405 -122 b 353 -176 366 -172 362 -176 b 349 -176 352 -176 351 -176 b 253 -87 341 -176 347 -180 b 167 0 206 -38 167 0 b 99 -86 167 0 136 -38 b 21 -174 27 -174 28 -173 b 17 -176 20 -176 19 -176 b 6 -174 13 -176 9 -174 b -81 -87 4 -173 -14 -152 b -167 0 -129 -38 -167 0 b -236 -86 -167 0 -198 -38 b -313 -174 -307 -174 -306 -173 b -318 -176 -314 -176 -315 -176 b -328 -174 -321 -176 -325 -174 b -491 -12 -330 -173 -367 -137 l -503 0 l -530 -34 b -570 -77 -562 -73 -564 -76 b -577 -79 -571 -79 -574 -79 b -597 -58 -588 -79 -597 -69 b -596 -49 -597 -55 -597 -52 b -417 172 -593 -43 -423 167 b -413 173 -417 172 -415 173 "},"v2d":{"x_min":0,"x_max":438.28125,"ha":447,"o":"m 212 190 b 219 191 213 191 216 191 b 236 176 225 191 228 190 b 419 18 277 105 341 49 b 436 5 431 13 434 11 b 438 -1 438 4 438 1 b 424 -16 438 -8 432 -13 b 356 -49 409 -20 379 -36 b 234 -180 306 -83 258 -133 b 219 -192 230 -188 224 -192 b 200 -176 213 -192 206 -187 b 9 -15 157 -102 89 -45 b 0 0 2 -12 0 -6 b 16 18 0 9 2 12 b 200 176 93 48 159 104 b 212 190 205 186 208 188 m 239 113 b 236 117 238 116 238 117 b 230 108 235 117 234 115 b 92 -15 196 58 140 8 b 88 -18 91 -16 88 -18 b 92 -20 88 -18 91 -19 b 198 -116 130 -43 166 -74 b 200 -117 200 -117 200 -117 b 201 -117 200 -117 201 -117 b 264 -43 212 -98 242 -62 b 345 15 288 -19 321 4 b 348 18 347 16 348 16 b 344 20 348 18 347 19 b 239 113 307 41 266 79 "},"v2f":{"x_min":-1.359375,"x_max":680.5625,"ha":694,"o":"m 597 1042 b 604 1042 600 1042 602 1042 b 642 1002 627 1042 642 1022 b 619 966 642 988 635 974 b 439 927 574 942 503 927 l 426 927 l 426 921 b 430 838 428 893 430 866 b 345 480 430 696 398 560 b 179 391 307 423 249 391 b 156 392 171 391 164 392 b 138 394 149 394 142 394 b 103 434 115 396 103 416 b 129 471 103 451 111 466 b 141 474 133 473 137 474 b 172 459 153 474 164 469 b 181 455 175 456 176 455 b 187 456 182 455 185 455 b 253 520 212 460 234 483 b 315 836 294 605 315 714 b 311 928 315 867 314 898 b 302 945 310 943 311 942 b 245 953 283 950 262 953 b 130 891 193 953 149 931 b 84 860 119 870 102 860 b 36 905 61 860 39 877 b 36 910 36 907 36 909 b 80 970 36 931 50 949 b 249 1017 125 1000 187 1017 b 322 1009 273 1017 299 1014 l 341 1003 b 436 991 372 995 406 991 b 577 1031 495 991 545 1004 b 597 1042 583 1038 590 1041 m 416 360 b 424 360 419 360 421 360 b 481 309 454 360 479 338 b 503 145 484 280 495 199 b 585 -185 525 16 555 -106 b 630 -245 596 -213 613 -237 l 634 -247 l 638 -245 b 647 -244 641 -245 645 -244 b 680 -278 666 -244 680 -262 b 664 -308 680 -290 675 -301 b 638 -312 658 -310 650 -312 b 613 -309 631 -312 623 -310 b 477 -201 555 -303 502 -260 b 417 -2 460 -159 434 -72 b 416 5 417 1 416 5 b 416 5 416 5 416 5 b 411 -5 415 5 413 0 b 359 -97 397 -33 377 -70 b 353 -106 355 -102 353 -105 b 359 -112 353 -108 355 -109 b 409 -130 375 -123 390 -129 b 426 -134 420 -130 421 -131 b 431 -147 428 -137 431 -141 b 420 -162 431 -152 427 -159 b 382 -169 409 -166 396 -169 b 323 -155 363 -169 341 -165 l 317 -152 l 314 -155 b 62 -303 240 -240 148 -295 b 36 -305 55 -305 44 -305 b 23 -303 29 -305 24 -305 b -1 -273 6 -299 -1 -287 b 31 -240 -1 -256 10 -240 b 36 -240 32 -240 34 -240 b 42 -241 38 -241 39 -241 b 134 -204 63 -241 99 -226 b 367 288 265 -115 357 81 b 375 330 368 313 370 320 b 416 360 383 347 400 358 m 360 -359 b 379 -359 363 -359 371 -359 b 424 -360 396 -359 416 -359 b 646 -502 536 -373 624 -430 b 649 -527 649 -510 649 -519 b 530 -673 649 -578 604 -635 l 521 -677 l 529 -681 b 653 -811 592 -714 637 -762 b 660 -853 658 -827 660 -839 b 645 -911 660 -873 656 -892 b 426 -1021 608 -981 519 -1021 b 283 -989 377 -1021 328 -1011 b 235 -949 249 -972 239 -964 b 234 -936 234 -946 234 -941 b 234 -928 234 -934 234 -931 l 235 -925 l 234 -927 l 225 -934 b 87 -982 186 -966 138 -982 b 80 -982 85 -982 83 -982 b 55 -981 70 -981 58 -981 b 17 -943 32 -981 17 -964 b 54 -904 17 -921 35 -904 b 78 -914 62 -904 72 -909 l 83 -918 l 88 -918 b 190 -831 122 -918 166 -881 b 269 -506 242 -727 269 -612 b 268 -462 269 -492 269 -477 b 266 -449 266 -458 266 -452 b 265 -444 266 -445 266 -444 b 257 -446 264 -444 261 -445 b 132 -545 196 -470 152 -505 b 88 -573 122 -563 104 -573 b 39 -523 63 -573 39 -553 b 63 -476 39 -505 44 -494 b 360 -359 136 -408 235 -369 m 419 -424 b 393 -423 411 -423 406 -423 l 375 -423 l 377 -426 b 379 -439 377 -427 378 -434 b 383 -510 382 -463 383 -487 b 314 -811 383 -609 360 -710 b 266 -893 296 -850 285 -870 b 264 -898 265 -896 264 -898 l 264 -898 b 264 -898 264 -898 264 -898 b 268 -898 264 -898 266 -898 b 273 -898 270 -898 272 -898 b 300 -909 283 -898 291 -900 b 426 -957 340 -941 385 -957 b 476 -949 443 -957 460 -954 b 547 -853 522 -931 547 -893 b 485 -745 547 -816 526 -775 b 397 -707 460 -727 432 -714 b 366 -675 375 -703 366 -692 b 396 -642 366 -657 377 -645 b 530 -557 455 -637 511 -601 b 536 -527 534 -548 536 -537 b 419 -424 536 -480 490 -437 "},"v30":{"x_min":-21.78125,"x_max":367.5,"ha":375,"o":"m 276 1900 b 284 1901 279 1900 281 1901 b 306 1883 291 1901 298 1896 b 367 1686 347 1825 367 1757 b 343 1558 367 1643 359 1600 l 338 1549 l 343 1537 b 367 1411 359 1497 367 1454 b 343 1282 367 1367 359 1324 l 338 1272 l 343 1261 b 367 1135 359 1221 367 1178 b 343 1007 367 1090 359 1047 l 338 996 l 343 985 b 367 859 359 945 367 902 b 343 731 367 814 359 771 l 338 720 l 343 709 b 367 582 359 667 367 626 b 289 362 367 503 340 426 b 239 312 276 345 259 330 b 29 77 152 237 76 152 b -1 18 14 54 2 30 b -19 4 -4 11 -12 4 l -21 4 l -21 133 l -20 260 l -13 262 b 98 299 17 269 62 284 b 111 305 103 302 110 305 b 167 334 123 310 156 327 b 319 595 264 391 319 491 b 313 659 319 616 318 638 b 310 667 311 664 311 667 b 307 663 310 667 308 666 b 240 588 289 637 269 614 b 16 331 141 505 62 413 b -1 294 8 316 1 302 b -19 280 -4 287 -12 280 l -21 280 l -21 408 l -20 537 l -13 538 b 98 576 17 545 62 560 b 111 581 103 578 110 581 b 167 610 123 587 156 603 b 319 871 264 667 319 767 b 313 935 319 892 318 913 b 310 942 311 941 311 942 b 307 939 310 942 308 941 b 240 864 289 913 269 889 b 16 607 141 781 62 689 b -1 570 8 592 1 578 b -19 556 -4 563 -12 556 l -21 556 l -21 684 l -20 813 l -13 814 b 98 852 17 821 62 836 b 111 857 103 855 110 857 b 167 886 123 863 156 880 b 319 1147 264 943 319 1043 b 313 1211 319 1168 318 1189 b 310 1218 311 1217 311 1218 b 307 1215 310 1218 308 1217 b 240 1140 289 1188 269 1165 b 16 884 141 1057 62 966 b -1 846 8 868 1 855 b -19 832 -4 839 -12 832 l -21 832 l -21 960 l -20 1089 l -13 1090 b 98 1128 17 1097 62 1111 b 111 1134 103 1131 110 1134 b 167 1163 123 1139 156 1156 b 319 1424 264 1220 319 1320 b 313 1486 319 1444 318 1465 b 310 1494 311 1493 311 1494 b 307 1492 310 1494 308 1493 b 240 1417 289 1464 269 1442 b 16 1160 141 1333 62 1242 b -1 1121 8 1145 1 1131 b -19 1109 -4 1115 -12 1109 l -21 1109 l -21 1236 l -20 1365 l -13 1367 b 98 1404 17 1374 62 1388 b 111 1410 103 1407 110 1410 b 250 1508 172 1437 215 1467 b 319 1701 296 1564 319 1633 b 270 1859 319 1757 303 1814 b 262 1882 265 1868 262 1875 b 276 1900 262 1890 266 1896 "},"v31":{"x_min":0,"x_max":386.5625,"ha":394,"o":"m 0 173 l 0 347 l 193 347 l 386 347 l 386 173 l 386 0 l 193 0 l 0 0 l 0 173 "},"v33":{"x_min":-423.3125,"x_max":421.9375,"ha":431,"o":"m -10 276 b -2 277 -8 277 -5 277 b 17 265 5 277 13 273 b 19 163 19 260 19 260 l 19 68 l 39 45 b 277 -95 122 -34 200 -81 b 289 -97 281 -97 285 -97 b 378 0 332 -97 371 -54 b 378 11 378 4 378 6 b 302 83 378 55 345 83 b 242 66 283 83 262 77 b 208 56 231 59 219 56 b 148 120 175 56 148 81 b 200 186 148 151 164 172 b 261 198 220 194 240 198 b 420 45 341 198 411 137 b 421 22 421 37 421 29 b 257 -198 421 -86 347 -188 b 242 -198 251 -198 247 -198 b 20 -105 181 -198 95 -163 l 19 -104 l 19 -183 b 19 -216 19 -195 19 -206 b 12 -273 19 -272 17 -267 b -2 -278 8 -277 2 -278 b -21 -266 -10 -278 -19 -274 b -23 -165 -23 -263 -23 -262 l -23 -69 l -44 -47 b -250 86 -117 23 -183 66 b -295 94 -270 93 -284 94 b -315 91 -302 94 -308 94 b -381 5 -356 81 -381 43 b -355 -56 -381 -16 -372 -40 b -299 -81 -338 -73 -319 -81 b -246 -68 -283 -81 -265 -77 b -212 -58 -234 -61 -223 -58 b -168 -77 -196 -58 -179 -65 b -151 -122 -156 -90 -151 -105 b -179 -174 -151 -141 -160 -162 b -239 -195 -194 -184 -217 -192 b -257 -197 -245 -195 -250 -197 b -423 -5 -349 -197 -423 -113 b -423 0 -423 -4 -423 -1 b -277 194 -420 97 -362 173 b -247 197 -268 197 -258 197 b -24 104 -185 197 -100 162 l -23 102 l -23 181 b -21 265 -23 260 -23 260 b -10 276 -20 269 -14 274 "},"v34":{"x_min":0,"x_max":622.03125,"ha":635,"o":"m 398 417 b 406 419 401 419 404 419 b 427 398 417 419 427 409 b 427 391 427 395 427 392 b 34 -274 424 385 38 -272 b 20 -280 29 -278 25 -280 b 0 -259 9 -280 0 -270 b 0 -252 0 -256 0 -254 b 393 413 2 -247 389 410 b 398 417 394 415 397 416 m 592 417 b 600 419 594 419 597 419 b 622 398 611 419 622 409 b 620 391 622 395 620 392 b 227 -274 617 385 231 -272 b 213 -280 223 -278 219 -280 b 193 -259 202 -280 193 -270 b 194 -252 193 -256 193 -254 b 586 413 196 -247 582 410 b 592 417 588 415 590 416 "},"v36":{"x_min":-1.359375,"x_max":1064.390625,"ha":1086,"o":"m 296 692 b 314 694 302 694 307 694 b 386 685 337 694 366 689 b 548 498 480 660 548 580 b 548 481 548 492 548 487 b 455 395 541 426 499 395 b 370 462 420 395 383 417 b 362 496 364 477 362 488 b 377 514 362 509 367 514 b 393 501 386 514 390 510 b 432 474 397 484 413 474 b 470 487 445 474 458 478 b 491 530 484 496 491 510 b 490 544 491 534 491 539 b 333 660 479 606 411 657 l 323 662 l 315 646 b 269 524 285 591 269 556 b 321 431 269 492 287 466 b 349 395 338 413 343 408 b 363 342 359 378 363 362 b 359 312 363 333 362 322 b 285 158 348 266 318 206 b 281 152 283 155 281 152 b 281 152 281 152 281 152 b 287 154 283 152 284 152 b 318 155 298 154 308 155 b 461 98 371 155 419 136 l 464 97 l 483 112 b 503 129 494 120 503 127 b 504 130 503 129 504 129 b 503 138 504 131 503 134 b 500 180 500 152 500 166 b 553 326 500 238 518 288 b 604 366 560 331 592 358 b 649 381 617 376 632 381 b 696 362 665 381 681 374 b 724 302 714 347 724 324 b 695 238 724 278 714 255 b 660 210 691 234 662 212 b 579 148 658 209 582 151 b 579 148 579 148 579 148 b 596 106 579 144 589 119 b 622 77 604 88 609 83 b 657 69 632 72 645 69 b 748 112 688 69 721 84 b 755 123 754 117 755 120 b 755 127 755 124 755 126 b 751 165 752 137 751 151 b 758 219 751 183 754 202 b 894 387 774 290 820 347 b 896 390 896 388 896 388 b 891 398 896 391 895 392 b 622 560 827 477 730 535 b 600 580 605 564 600 569 b 617 596 600 591 607 596 b 628 595 622 596 624 596 b 1057 248 846 552 1020 412 b 1064 191 1061 229 1064 209 b 922 0 1064 94 1005 9 b 902 -1 916 -1 909 -1 b 774 76 847 -1 800 26 b 769 83 770 81 770 83 b 769 81 769 83 769 83 b 627 -1 733 29 677 -1 b 548 27 597 -1 570 8 b 515 88 537 37 525 61 l 513 95 l 510 93 l 453 45 b 390 0 396 0 396 0 b 390 0 390 0 390 0 b 374 15 381 0 377 4 b 268 105 359 69 314 105 b 250 104 262 105 257 105 l 243 102 l 234 90 b 155 1 201 49 159 2 b 147 -1 152 0 149 -1 b 130 15 138 -1 130 6 b 132 20 130 18 132 19 b 136 31 133 22 134 27 b 220 131 149 74 178 109 b 231 137 225 134 230 136 b 302 278 280 202 302 244 b 265 335 302 299 295 309 b 209 442 234 363 213 402 b 209 455 209 446 209 451 b 279 648 209 502 232 564 l 285 659 l 283 659 b 176 627 238 653 210 645 b 57 477 111 594 66 538 b 55 459 55 471 55 464 b 72 409 55 437 61 415 b 93 403 78 405 87 403 b 152 467 123 403 151 431 b 168 488 153 483 157 488 b 185 462 181 488 185 483 l 185 460 b 137 344 183 409 168 369 b 78 322 119 328 98 322 b 13 360 50 322 25 335 b -1 426 4 380 -1 402 b 89 610 -1 488 32 559 b 296 692 147 659 210 685 m 926 348 b 921 353 924 351 922 353 b 914 348 920 353 918 351 b 823 167 857 306 823 237 b 828 124 823 154 826 138 b 890 31 837 79 862 40 b 896 31 892 31 894 31 b 956 104 916 31 940 59 b 970 191 965 129 970 159 b 966 241 970 208 969 224 b 926 348 959 277 945 313 m 627 326 b 619 326 624 326 622 326 b 598 316 611 326 604 323 b 568 215 579 288 568 255 b 568 208 568 213 568 210 b 571 183 570 195 570 184 l 571 183 b 594 201 571 183 582 191 l 634 231 b 660 259 653 247 656 248 b 664 278 662 266 664 272 b 627 326 664 299 649 320 "},"v38":{"x_min":-1.359375,"x_max":651.96875,"ha":665,"o":"m 389 644 b 405 645 394 645 400 645 b 504 566 450 645 492 613 b 507 541 506 557 507 549 b 480 471 507 514 498 489 l 477 467 l 483 470 b 609 591 539 485 586 531 b 613 601 611 595 613 599 b 631 609 619 607 624 609 b 651 588 641 609 651 602 b 200 -946 651 584 204 -941 b 182 -957 197 -953 190 -957 b 163 -945 174 -957 166 -953 b 161 -939 161 -942 161 -942 b 217 -743 161 -931 170 -904 b 272 -555 247 -639 272 -555 b 272 -555 272 -555 272 -555 b 264 -560 272 -555 268 -557 b 140 -603 227 -589 182 -603 b 36 -567 102 -603 65 -592 b -1 -487 12 -548 -1 -517 b 17 -427 -1 -466 5 -445 b 103 -380 38 -395 70 -380 b 191 -433 137 -380 172 -398 b 205 -484 201 -448 205 -466 b 178 -553 205 -509 196 -535 l 175 -557 l 182 -555 b 307 -435 236 -539 284 -494 b 372 -213 308 -430 372 -215 b 372 -213 372 -213 372 -213 b 364 -219 372 -213 368 -216 b 240 -262 328 -247 283 -262 b 137 -226 202 -262 166 -249 b 99 -145 112 -206 99 -176 b 118 -84 99 -124 106 -104 b 204 -38 138 -54 171 -38 b 292 -91 238 -38 273 -56 b 306 -141 302 -106 306 -124 b 279 -212 306 -167 296 -194 l 276 -215 l 281 -213 b 408 -93 336 -198 385 -151 b 473 129 409 -88 473 127 b 473 129 473 129 473 129 b 465 122 473 129 469 126 b 341 80 428 94 383 80 b 236 115 303 80 266 91 b 200 195 213 136 200 165 b 217 256 200 217 206 238 b 304 303 239 287 272 303 b 393 249 338 303 374 285 b 406 199 402 234 406 217 b 379 129 406 173 397 148 l 377 126 l 382 127 b 509 248 436 142 485 190 b 574 470 510 254 574 469 b 574 470 574 470 574 470 b 566 464 574 470 570 467 b 442 421 529 435 484 421 b 337 458 404 421 367 433 b 300 537 313 478 300 508 b 389 644 300 585 334 635 "},"v3b":{"x_min":0,"x_max":484.5625,"ha":494,"o":"m 228 245 b 239 247 234 247 239 247 b 243 247 240 247 242 247 b 303 238 257 247 287 242 b 484 -2 417 208 484 104 b 412 -177 484 -65 461 -127 b 243 -248 363 -226 303 -248 b 6 -63 138 -248 36 -180 b 0 -1 1 -41 0 -20 b 228 245 0 127 98 240 m 255 181 b 240 183 247 183 245 183 b 232 181 238 183 235 183 b 142 152 200 180 168 170 l 138 149 l 190 97 l 242 44 l 294 97 l 345 149 l 340 152 b 255 181 315 169 284 180 m 147 -54 l 197 -1 l 147 51 l 95 104 l 91 99 b 62 -1 72 70 62 34 b 66 -43 62 -15 63 -29 b 91 -101 72 -63 80 -84 l 95 -106 l 147 -54 m 393 99 b 389 104 390 102 389 104 b 337 51 389 104 366 80 l 285 -1 l 337 -54 l 389 -106 l 393 -101 b 421 -1 412 -72 421 -36 b 393 99 421 34 412 69 m 294 -98 b 242 -45 265 -69 242 -45 b 190 -98 242 -45 219 -69 l 138 -151 l 142 -154 b 242 -184 172 -174 206 -184 b 340 -154 276 -184 311 -174 l 345 -151 l 294 -98 "},"v3c":{"x_min":0,"x_max":450.53125,"ha":460,"o":"m 189 302 b 204 303 193 302 198 303 b 303 224 250 303 292 270 b 306 199 304 216 306 208 b 279 129 306 173 296 147 l 276 126 l 281 127 b 408 249 337 142 385 190 b 412 259 409 254 412 258 b 430 267 417 265 423 267 b 450 247 441 267 450 259 b 200 -605 450 242 204 -599 b 182 -616 197 -612 190 -616 b 163 -602 174 -616 166 -610 b 161 -598 161 -601 161 -601 b 217 -402 161 -589 170 -562 b 272 -213 247 -298 272 -213 b 272 -213 272 -213 272 -213 b 264 -219 272 -213 268 -216 b 140 -262 227 -247 182 -262 b 36 -226 102 -262 65 -249 b 0 -145 12 -206 0 -176 b 17 -84 0 -124 5 -104 b 103 -38 38 -54 70 -38 b 191 -91 137 -38 172 -56 b 205 -141 201 -106 205 -124 b 178 -212 205 -167 196 -194 l 175 -215 l 182 -213 b 307 -93 236 -198 284 -151 b 372 129 308 -88 372 127 b 372 129 372 129 372 129 b 364 122 372 129 368 126 b 240 80 328 94 283 80 b 137 115 202 80 166 91 b 99 194 111 136 99 165 b 189 302 99 244 133 292 "},"v3e":{"x_min":0,"x_max":406.96875,"ha":415,"o":"m 21 183 b 28 183 24 183 25 183 b 42 181 34 183 39 183 b 127 108 47 179 47 179 b 202 41 168 72 202 41 b 279 108 204 41 238 72 b 357 177 321 145 356 176 b 375 183 363 181 370 183 b 406 151 392 183 406 169 b 404 137 406 147 405 141 b 322 62 401 131 398 129 b 251 0 284 27 251 0 b 322 -63 251 -1 284 -29 b 404 -138 398 -130 401 -133 b 406 -152 405 -142 406 -148 b 375 -184 406 -170 392 -184 b 357 -179 370 -184 363 -183 b 279 -109 356 -177 321 -147 b 202 -43 238 -73 204 -43 b 127 -109 202 -43 168 -73 b 49 -179 85 -147 50 -177 b 31 -184 43 -183 36 -184 b 0 -152 13 -184 0 -170 b 2 -138 0 -148 0 -142 b 83 -63 5 -133 8 -130 b 155 0 122 -29 155 -1 b 83 62 155 0 122 27 b 8 129 43 97 10 127 b 0 151 2 136 0 144 b 21 183 0 165 8 177 "},"v3f":{"x_min":-24.5,"x_max":317.140625,"ha":324,"o":"m -24 -147 l -24 -5 l -20 -5 b -1 -19 -12 -5 -4 -11 b 58 -123 6 -43 31 -86 b 196 -278 93 -173 134 -219 b 317 -570 274 -356 317 -460 b 294 -713 317 -617 308 -666 l 289 -724 l 294 -735 b 317 -873 308 -780 317 -827 b 235 -1132 317 -963 288 -1054 b 209 -1165 228 -1140 224 -1146 b 189 -1177 204 -1172 196 -1177 b 171 -1164 182 -1177 175 -1172 b 168 -1154 170 -1161 168 -1159 b 181 -1132 168 -1149 172 -1142 b 269 -891 238 -1064 269 -975 b 269 -881 269 -886 269 -884 b 262 -814 269 -857 265 -827 b 258 -800 261 -811 259 -806 b 142 -628 240 -731 198 -667 b -8 -589 112 -606 47 -589 b -20 -589 -13 -589 -19 -589 l -24 -589 l -24 -449 l -24 -308 l -20 -308 b -1 -322 -12 -308 -4 -313 b 58 -424 6 -345 31 -388 b 194 -580 93 -476 136 -523 b 259 -660 221 -606 245 -635 b 261 -663 259 -662 261 -663 b 264 -656 262 -663 262 -660 b 269 -587 268 -632 269 -610 b 264 -521 269 -566 268 -544 b 262 -512 264 -517 262 -513 b 258 -498 261 -509 259 -503 b 142 -326 240 -428 198 -365 b -8 -287 112 -303 47 -288 b -20 -287 -13 -287 -19 -287 l -24 -287 l -24 -147 "},"v40":{"x_min":-1.359375,"x_max":436.921875,"ha":446,"o":"m 213 205 b 217 205 215 205 216 205 b 234 194 224 205 234 199 b 236 187 234 194 235 190 l 245 167 l 261 129 l 270 106 b 355 -61 294 54 329 -13 b 420 -163 381 -105 402 -138 b 436 -188 435 -184 436 -184 b 436 -191 436 -190 436 -190 b 421 -206 436 -201 431 -206 l 421 -206 l 416 -206 l 405 -201 b 217 -158 347 -172 283 -158 b 31 -201 153 -158 88 -172 l 20 -206 l 14 -206 l 14 -206 b 0 -191 5 -206 0 -201 b -1 -188 0 -190 -1 -190 b 14 -163 -1 -186 0 -184 b 95 -34 36 -136 72 -77 b 166 106 119 8 148 68 l 175 129 l 183 148 l 200 188 b 213 205 205 199 208 202 "},"v41":{"x_min":-1.359375,"x_max":556.6875,"ha":568,"o":"m 294 322 b 318 323 299 322 308 323 b 360 320 334 323 352 322 b 526 217 430 310 490 273 b 543 166 537 202 543 184 b 447 70 543 117 503 70 b 445 70 447 70 446 70 b 359 159 394 72 359 113 b 368 201 359 173 362 187 b 442 245 382 229 412 245 b 455 244 446 245 451 245 b 460 244 458 244 460 244 b 460 244 460 244 460 244 b 454 248 460 244 458 245 b 325 291 417 276 372 291 b 285 287 313 291 299 290 b 144 -2 183 269 144 190 b 281 -290 144 -208 179 -280 b 304 -291 289 -291 298 -291 b 524 -105 412 -291 506 -212 b 541 -84 526 -88 530 -84 b 556 -101 551 -84 556 -90 b 549 -138 556 -111 553 -122 b 334 -322 521 -237 435 -310 b 302 -324 323 -323 313 -324 b 13 -101 172 -324 54 -234 b -1 -1 4 -68 -1 -34 b 294 322 -1 161 121 303 "},"v42":{"x_min":-348.4375,"x_max":24.5,"ha":25,"o":"m -330 155 b -322 156 -329 156 -326 156 b -315 156 -319 156 -317 156 b -298 147 -311 155 -308 154 b -19 30 -224 98 -122 55 l 2 26 b 24 -1 17 22 24 13 b 2 -27 24 -15 17 -23 l -19 -31 b -298 -148 -122 -56 -224 -99 b -322 -158 -313 -158 -315 -158 b -348 -131 -338 -158 -348 -145 b -344 -117 -348 -127 -347 -122 b -328 -104 -341 -112 -338 -111 b -127 -8 -269 -65 -202 -33 b -106 0 -115 -4 -106 -1 b -127 6 -106 0 -115 2 b -328 102 -202 31 -269 63 b -344 116 -338 109 -341 111 b -348 130 -347 120 -348 124 b -330 155 -348 141 -341 152 "},"v43":{"x_min":-442.359375,"x_max":441,"ha":450,"o":"m -31 487 b -1 488 -21 488 -10 488 b 434 104 216 488 397 330 b 441 27 438 79 441 47 b 439 12 441 20 439 15 b 419 0 435 4 427 0 b 404 5 413 0 408 1 b 398 30 400 11 398 13 b 0 351 390 213 213 351 b -59 348 -20 351 -39 349 b -400 30 -251 324 -393 191 b -405 5 -400 13 -401 11 b -420 0 -409 1 -415 0 b -441 12 -428 0 -436 4 b -442 27 -441 15 -442 20 b -435 104 -442 47 -439 79 b -31 487 -401 316 -235 474 m -13 131 b -1 133 -9 133 -5 133 b 51 105 19 133 39 123 b 61 70 58 95 61 83 b 51 34 61 58 58 45 b -1 6 39 16 19 6 b -46 27 -17 6 -34 13 b -62 69 -57 38 -62 54 b -13 131 -62 98 -44 124 "},"v44":{"x_min":-21.78125,"x_max":251.8125,"ha":257,"o":"m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 383 20 616 20 616 l 20 148 l 21 151 b 137 199 59 183 99 199 b 182 191 152 199 167 197 b 251 84 227 176 251 134 b 228 0 251 58 243 29 b 100 -142 206 -40 178 -72 l 23 -215 b 0 -229 9 -229 6 -229 b -20 -216 -9 -229 -17 -224 l -21 -212 l -21 201 l -21 616 l -20 620 b -8 631 -17 624 -13 630 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 "},"v45":{"x_min":-402.890625,"x_max":401.53125,"ha":410,"o":"m -10 273 b -4 274 -9 273 -6 274 b 16 262 4 274 12 269 b 17 158 17 259 17 259 l 17 56 l 62 112 b 117 174 110 172 110 172 b 122 174 118 174 119 174 b 132 173 125 174 129 173 b 295 11 134 172 171 134 l 307 -1 l 336 34 b 374 76 366 72 368 74 b 381 77 375 77 378 77 b 401 56 392 77 401 68 b 400 48 401 54 401 51 b 223 -172 397 41 230 -166 b 210 -176 220 -174 215 -176 b 201 -174 206 -176 204 -176 b 112 -87 198 -173 178 -152 b 27 0 65 -38 27 0 b 21 -6 27 0 24 -2 l 17 -12 l 17 -147 b 17 -210 17 -173 17 -194 b 10 -292 17 -297 16 -287 b -2 -299 6 -297 2 -299 b -21 -287 -10 -299 -19 -295 b -24 -174 -23 -284 -23 -284 l -24 -63 l -66 -117 b -121 -176 -110 -170 -114 -176 b -125 -176 -122 -176 -123 -176 b -296 -12 -134 -174 -125 -184 l -308 0 l -337 -34 b -375 -77 -367 -73 -370 -76 b -382 -79 -377 -79 -379 -79 b -402 -58 -393 -79 -402 -69 b -401 -49 -402 -55 -402 -52 b -224 170 -398 -43 -231 165 b -212 174 -221 173 -216 174 b -202 173 -208 174 -205 174 b -39 11 -200 172 -151 122 l -28 -1 l -25 1 l -24 4 l -24 130 b -23 260 -24 256 -24 258 b -10 273 -20 266 -16 270 "},"v46":{"x_min":0,"x_max":627.46875,"ha":640,"o":"m 306 190 b 314 191 308 191 311 191 b 326 184 318 191 322 190 l 336 173 b 510 52 377 127 442 80 b 515 49 513 51 515 49 b 611 16 537 40 579 24 b 627 0 624 13 627 9 b 607 -18 627 -11 624 -13 b 330 -181 490 -49 389 -109 b 314 -192 323 -190 319 -192 b 306 -191 311 -192 308 -192 b 294 -177 302 -188 302 -188 b 257 -140 287 -170 265 -148 b 19 -18 193 -84 114 -44 b 0 0 2 -13 0 -11 b 16 16 0 9 2 13 b 110 49 47 24 89 40 b 117 52 111 49 114 51 b 145 65 126 56 130 58 b 281 163 200 93 245 124 b 300 186 288 170 291 174 b 306 190 300 187 303 188 m 317 137 b 313 142 315 141 314 142 b 308 137 313 142 311 141 b 161 4 276 84 220 33 b 155 0 159 1 155 0 b 163 -4 155 0 159 -2 b 308 -138 220 -34 276 -84 b 313 -142 311 -141 313 -142 b 317 -138 314 -142 315 -141 b 464 -4 351 -84 406 -34 b 470 0 468 -2 470 0 b 464 4 470 0 468 1 b 317 137 406 33 351 84 "},"v47":{"x_min":-24.5,"x_max":315.78125,"ha":322,"o":"m -24 -145 l -24 -5 l -20 -5 b 1 -26 -10 -5 -6 -9 b 175 -241 31 -86 96 -166 b 314 -548 259 -323 304 -420 b 315 -589 315 -555 315 -571 b 314 -630 315 -606 315 -623 b 298 -730 311 -664 306 -699 l 295 -742 l 296 -748 b 314 -850 304 -778 311 -813 b 315 -892 315 -857 315 -874 b 314 -932 315 -909 315 -925 b 298 -1032 311 -967 306 -1002 l 295 -1045 l 296 -1050 b 314 -1153 304 -1081 311 -1115 b 315 -1193 315 -1160 315 -1177 b 314 -1235 315 -1211 315 -1228 b 217 -1526 306 -1338 270 -1444 b 201 -1533 213 -1532 208 -1533 b 182 -1522 193 -1533 185 -1529 b 179 -1514 181 -1518 179 -1517 b 189 -1489 179 -1508 182 -1501 b 266 -1217 240 -1403 266 -1308 b 262 -1156 266 -1196 265 -1177 b 110 -907 247 -1043 190 -950 b 0 -889 87 -895 50 -889 l -1 -889 l -24 -889 l -24 -749 l -24 -610 l -20 -610 b 1 -631 -10 -610 -6 -614 b 175 -846 31 -691 96 -771 b 259 -956 213 -884 236 -914 b 265 -966 262 -961 264 -966 b 265 -966 265 -966 265 -966 b 265 -953 265 -964 265 -959 b 266 -920 266 -943 266 -932 b 262 -853 266 -898 265 -873 b 110 -605 247 -741 190 -648 b 0 -587 87 -592 50 -587 l -1 -587 l -24 -587 l -24 -448 l -24 -308 l -20 -308 b 1 -328 -10 -308 -6 -312 b 175 -544 31 -388 96 -469 b 259 -655 213 -581 236 -612 b 265 -663 262 -659 264 -663 b 265 -663 265 -663 265 -663 b 265 -650 265 -663 265 -657 b 266 -617 266 -641 266 -630 b 262 -551 266 -595 265 -570 b 110 -303 247 -438 190 -345 b 0 -284 87 -290 50 -284 l -1 -284 l -24 -284 l -24 -145 "},"v49":{"x_min":0,"x_max":630.203125,"ha":643,"o":"m 308 204 b 314 205 310 205 313 205 b 326 201 319 205 323 204 b 355 154 328 199 338 180 b 401 83 362 142 392 95 l 409 72 b 431 41 412 66 424 49 b 619 -174 498 -51 570 -134 b 630 -192 626 -180 630 -186 b 626 -202 630 -195 628 -199 b 616 -206 623 -205 620 -206 b 552 -188 608 -206 592 -202 b 310 -155 488 -169 392 -155 b 268 -156 295 -155 281 -155 b 77 -188 197 -161 126 -173 b 13 -206 35 -202 20 -206 b 9 -206 12 -206 10 -206 b 0 -191 2 -202 0 -197 b 8 -176 0 -186 2 -180 b 204 49 58 -136 138 -43 l 220 72 l 227 83 b 295 188 245 108 281 166 b 308 204 299 197 304 202 m 315 147 b 314 147 315 147 314 147 b 314 147 314 147 314 147 b 306 129 314 145 310 138 l 296 105 b 281 72 292 97 284 77 l 274 56 b 181 -123 247 -4 212 -72 l 174 -134 l 176 -133 b 314 -123 215 -127 272 -123 b 451 -133 356 -123 413 -127 l 454 -134 l 449 -123 b 353 56 417 -72 381 -4 l 347 72 b 332 105 344 77 336 97 l 322 129 b 315 147 318 138 315 145 "},"v4a":{"x_min":70.78125,"x_max":378.390625,"ha":315,"o":"m 246 373 b 254 373 249 373 251 373 b 372 324 303 373 360 351 b 378 302 377 317 378 309 b 338 251 378 278 362 255 b 328 249 334 249 332 249 b 283 294 303 249 283 270 b 288 315 283 301 284 308 b 289 319 289 317 289 319 b 289 319 289 319 289 319 b 283 320 289 320 287 320 b 270 322 279 322 274 322 b 206 288 242 322 215 308 b 206 283 206 287 206 285 b 257 223 206 267 230 238 b 284 206 272 213 277 210 b 351 90 328 173 351 130 b 340 47 351 74 348 59 b 205 -30 314 -2 264 -30 b 182 -29 198 -30 190 -30 b 84 15 147 -24 103 -5 b 70 48 74 24 70 36 b 108 99 70 70 85 94 b 121 102 112 101 117 102 b 167 56 147 102 167 80 b 159 31 167 48 164 40 l 156 26 l 157 26 b 190 20 167 22 178 20 b 220 26 201 20 212 22 b 258 65 243 34 258 51 b 257 70 258 66 258 69 b 204 126 249 94 234 109 b 114 258 148 158 114 209 b 125 302 114 273 118 288 b 246 373 147 342 193 370 "},"v4b":{"x_min":0,"x_max":503.609375,"ha":514,"o":"m 274 430 b 277 430 276 430 277 430 b 310 394 296 430 310 415 b 308 383 310 391 308 387 b 306 367 307 381 307 374 b 236 120 298 305 272 210 b 40 -273 189 -5 125 -134 b 20 -287 35 -283 27 -287 b 5 -281 14 -287 9 -285 b 0 -267 1 -277 0 -273 b 9 -242 0 -262 2 -255 b 246 395 137 -12 232 242 b 274 430 249 416 257 427 m 468 430 b 472 430 469 430 470 430 b 503 394 490 430 503 415 b 502 383 503 391 503 387 b 499 367 502 381 500 374 b 431 120 491 305 465 210 b 234 -273 382 -5 318 -134 b 213 -287 228 -283 220 -287 b 198 -281 208 -287 202 -285 b 193 -267 194 -277 193 -273 b 202 -242 193 -262 196 -255 b 439 395 330 -12 426 242 b 468 430 442 416 451 427 "},"v4d":{"x_min":-311.6875,"x_max":310.328125,"ha":317,"o":"m -9 388 b -2 390 -8 390 -5 390 b 5 388 1 390 4 390 b 19 378 10 387 16 383 b 23 333 23 371 23 371 b 24 298 23 299 24 298 b 81 276 34 298 65 285 b 213 91 145 240 190 177 b 224 24 217 76 224 36 b 257 24 224 24 235 24 b 299 19 292 24 292 24 b 310 -1 306 15 310 6 b 299 -23 310 -11 306 -19 b 257 -27 292 -27 292 -27 b 224 -29 235 -27 224 -29 b 213 -95 224 -40 217 -80 b 81 -280 190 -181 145 -244 b 24 -301 65 -290 34 -301 b 23 -335 24 -301 23 -303 l 23 -340 b 17 -381 23 -374 23 -374 b -1 -391 13 -388 5 -391 b -21 -381 -9 -391 -17 -388 b -27 -340 -27 -374 -27 -374 l -27 -335 b -28 -301 -27 -303 -27 -301 b -85 -280 -38 -301 -69 -290 b -217 -95 -149 -244 -194 -181 b -228 -29 -221 -80 -228 -40 b -259 -27 -228 -29 -238 -27 b -300 -23 -294 -27 -294 -27 b -311 -2 -307 -19 -311 -11 b -294 23 -311 8 -304 19 b -259 24 -291 23 -284 24 b -228 24 -239 24 -228 24 b -217 91 -228 36 -221 76 b -85 276 -194 177 -149 240 b -28 298 -69 285 -38 298 b -27 333 -27 298 -27 299 b -27 371 -27 362 -27 369 b -9 388 -24 378 -17 385 m -27 136 b -28 247 -27 197 -28 247 b -61 216 -31 247 -53 226 b -123 33 -95 172 -121 98 l -125 24 l -76 24 l -27 24 l -27 136 m 29 242 b 24 247 27 245 24 247 b 23 136 24 247 23 197 l 23 24 l 72 24 l 121 24 l 119 33 b 29 242 115 116 77 206 m -27 -140 l -27 -27 l -76 -27 l -125 -27 l -123 -36 b -61 -220 -121 -102 -95 -176 b -28 -251 -53 -230 -31 -251 b -27 -140 -28 -251 -27 -201 m 119 -36 l 121 -27 l 72 -27 l 23 -27 l 23 -140 b 24 -251 23 -201 24 -251 b 57 -220 27 -251 49 -230 b 119 -36 91 -176 117 -102 "},"v4e":{"x_min":0,"x_max":239.5625,"ha":244,"o":"m 10 460 b 20 462 13 462 14 462 b 39 449 28 462 35 458 l 40 446 l 40 326 b 40 205 40 259 40 205 b 127 227 40 205 80 215 b 220 249 196 244 213 249 b 227 247 224 249 225 248 b 238 237 231 245 235 241 l 239 233 l 239 -106 l 239 -448 l 238 -451 b 219 -463 234 -459 225 -463 b 198 -451 210 -463 202 -459 l 197 -448 l 197 -324 b 197 -201 197 -248 197 -201 b 110 -223 196 -201 157 -210 b 17 -245 42 -240 24 -245 b 10 -242 13 -245 13 -244 b 0 -233 6 -241 2 -237 l 0 -230 l 0 108 l 0 446 l 0 449 b 10 460 2 453 6 458 m 197 22 b 197 70 197 41 197 58 b 196 116 197 113 197 116 l 196 116 b 118 97 196 116 160 106 l 40 77 l 40 -18 b 40 -112 40 -69 40 -112 l 119 -93 l 197 -73 l 197 22 "},"v51":{"x_min":-1.359375,"x_max":455.96875,"ha":465,"o":"m 352 541 b 357 542 353 542 355 542 b 377 530 364 542 372 537 l 378 526 l 378 394 l 379 262 l 404 266 b 436 270 420 269 430 270 b 450 265 443 270 446 269 b 455 220 455 259 455 260 l 455 208 l 455 161 l 454 156 b 411 140 449 147 447 147 b 378 133 393 137 379 134 b 378 68 378 133 378 106 b 378 22 378 54 378 38 l 379 -87 l 404 -83 b 436 -79 420 -80 430 -79 b 450 -84 443 -79 446 -80 b 455 -129 455 -90 455 -88 l 455 -141 l 455 -188 l 454 -192 b 413 -209 449 -202 447 -202 b 382 -215 398 -212 383 -215 l 378 -215 l 378 -345 l 378 -380 b 375 -485 378 -484 378 -480 b 357 -494 371 -491 364 -494 b 340 -485 351 -494 344 -491 b 336 -383 337 -480 336 -484 l 336 -349 l 336 -223 l 334 -223 b 291 -231 334 -223 314 -227 l 247 -240 l 247 -371 l 246 -503 l 245 -506 b 225 -519 242 -514 234 -519 b 206 -506 219 -519 210 -514 l 205 -503 l 205 -376 l 205 -248 l 160 -256 l 115 -265 l 115 -396 l 115 -527 l 114 -531 b 95 -544 110 -539 102 -544 b 76 -531 87 -544 78 -539 l 73 -527 l 73 -399 b 73 -273 73 -330 73 -273 b 49 -277 73 -273 61 -274 b 17 -281 32 -280 24 -281 b 4 -276 10 -281 8 -280 b -1 -234 0 -269 -1 -272 b 0 -219 -1 -229 0 -224 l 0 -170 l 1 -167 b 10 -158 2 -163 6 -159 b 49 -149 13 -156 16 -155 l 73 -145 l 73 -34 b 73 76 73 26 73 76 b 49 72 73 76 61 74 b 17 68 32 69 24 68 b 4 73 10 68 8 69 b -1 115 0 80 -1 77 b 0 130 -1 120 0 124 l 0 179 l 1 181 b 10 191 2 186 6 190 b 49 199 13 192 16 194 l 73 204 l 73 338 b 73 374 73 352 73 365 b 77 483 73 484 73 477 b 95 492 81 489 88 492 b 111 483 100 492 107 489 b 115 378 115 477 115 483 l 115 342 b 117 212 115 223 115 212 b 204 229 117 212 200 227 l 205 229 l 205 365 l 205 502 l 206 505 b 225 517 210 513 219 517 b 245 505 234 517 242 513 l 246 502 l 247 369 l 247 237 l 249 237 b 336 254 253 238 336 254 b 337 390 336 254 337 302 l 337 526 l 338 530 b 352 541 341 535 347 539 m 336 15 b 336 126 336 102 336 126 l 336 126 b 291 117 336 126 315 122 l 247 109 l 247 -1 l 247 -112 l 249 -112 b 336 -95 253 -111 336 -95 b 336 15 336 -95 336 -56 m 205 -120 b 205 -55 205 -120 205 -93 b 205 -9 205 -41 205 -24 l 205 101 l 160 93 l 115 84 l 115 -26 b 115 -83 115 -49 115 -69 b 117 -137 115 -133 115 -137 b 205 -120 118 -137 204 -120 "},"v52":{"x_min":-10.890625,"x_max":298.078125,"ha":294,"o":"m 138 473 b 142 474 140 473 141 474 b 164 459 148 474 153 470 b 191 402 183 442 191 423 b 181 353 191 388 187 371 b 178 349 179 352 178 349 b 179 348 178 348 179 348 b 185 349 181 348 182 348 b 255 376 210 355 234 363 b 272 381 264 381 266 381 b 298 355 287 381 298 370 b 288 330 298 348 298 345 b 171 34 238 254 194 141 b 166 13 168 16 168 16 b 144 1 161 5 152 1 b 121 15 134 1 125 5 b 115 33 119 18 117 24 b 0 330 91 145 49 252 b -10 355 -9 345 -10 348 b 13 381 -10 371 0 381 b 31 376 19 381 25 380 b 132 345 61 358 103 345 l 136 345 l 137 355 b 145 378 138 359 142 370 b 152 415 149 394 152 405 b 137 452 152 427 148 438 b 133 464 134 458 133 460 b 138 473 133 467 134 470 "},"v53":{"x_min":0,"x_max":902.421875,"ha":921,"o":"m 17 240 b 24 241 19 241 21 241 b 32 240 28 241 31 241 b 46 229 38 238 43 234 b 50 88 50 223 50 237 b 50 -1 50 63 50 34 b 50 -90 50 -36 50 -65 b 46 -231 50 -238 50 -224 b 25 -242 42 -238 34 -242 b 0 -224 14 -242 4 -235 b 0 2 0 -222 0 -108 b 0 223 0 112 0 220 b 17 240 2 230 9 237 m 110 240 b 118 241 111 241 114 241 b 126 240 121 241 123 241 b 142 223 133 237 140 230 b 144 123 144 220 144 205 b 144 29 144 45 144 29 b 144 29 144 29 144 29 b 393 183 166 106 264 167 b 450 186 412 184 431 186 b 756 29 600 186 732 120 b 756 29 756 29 756 29 b 758 123 758 29 758 45 b 760 227 758 226 758 223 b 784 241 766 237 774 241 b 804 229 792 241 800 237 b 809 88 808 223 809 237 l 809 -1 l 809 -90 b 804 -231 809 -238 808 -224 b 784 -242 800 -238 792 -242 b 762 -231 775 -242 766 -238 b 758 -124 756 -224 758 -231 b 756 -30 758 -47 758 -30 b 756 -30 756 -30 756 -30 b 509 -184 736 -108 637 -169 b 450 -187 488 -187 469 -187 b 144 -30 300 -187 168 -122 b 144 -30 144 -30 144 -30 b 144 -124 144 -30 144 -47 b 140 -231 144 -231 144 -224 b 118 -242 134 -238 126 -242 b 92 -224 107 -242 96 -235 b 92 2 92 -222 92 -108 b 92 223 92 112 92 220 b 110 240 95 230 102 237 m 432 161 b 413 162 426 162 420 162 b 313 41 351 162 313 109 b 347 -73 313 5 323 -34 b 487 -163 385 -133 439 -163 b 578 -97 526 -163 562 -142 b 588 -43 585 -80 588 -62 b 432 161 588 47 518 147 m 868 240 b 876 241 869 241 872 241 b 884 240 879 241 882 241 b 898 229 890 238 894 234 b 902 88 902 223 902 237 l 902 -1 l 902 -90 b 898 -231 902 -238 902 -224 b 876 -242 892 -238 884 -242 b 852 -224 865 -242 854 -235 b 850 2 850 -222 850 -108 b 852 223 850 112 850 220 b 868 240 853 230 860 237 "},"v54":{"x_min":-24.5,"x_max":317.140625,"ha":324,"o":"m -24 -161 l -24 -5 l -20 -5 b 0 -24 -9 -5 -2 -12 b 171 -315 21 -124 84 -233 b 317 -660 268 -406 317 -531 b 187 -1014 317 -782 274 -909 b 161 -1034 172 -1034 171 -1034 b 141 -1013 149 -1034 141 -1025 b 152 -991 141 -1004 142 -1002 b 266 -682 228 -899 266 -788 b 174 -430 266 -588 236 -498 b -23 -317 136 -388 66 -348 b -24 -161 -23 -316 -24 -285 "},"v55":{"x_min":0,"x_max":551.25,"ha":563,"o":"m 289 644 b 304 645 294 645 299 645 b 404 566 349 645 392 613 b 406 541 405 557 406 549 b 379 471 406 514 397 489 l 377 467 l 382 470 b 509 591 438 485 485 531 b 513 601 510 595 513 599 b 530 609 518 607 524 609 b 551 588 540 609 551 602 b 200 -605 551 584 204 -599 b 182 -616 197 -612 190 -616 b 163 -602 174 -616 166 -610 b 161 -598 161 -601 161 -601 b 217 -402 161 -589 170 -562 b 272 -213 247 -298 272 -213 b 272 -213 272 -213 272 -213 b 264 -219 272 -213 268 -216 b 140 -262 227 -247 182 -262 b 36 -226 102 -262 65 -249 b 0 -145 12 -206 0 -176 b 17 -84 0 -124 5 -104 b 103 -38 38 -54 70 -38 b 191 -91 137 -38 172 -56 b 205 -141 201 -106 205 -124 b 178 -212 205 -167 196 -194 l 175 -215 l 182 -213 b 307 -93 236 -198 284 -151 b 372 129 308 -88 372 127 b 372 129 372 129 372 129 b 364 122 372 129 368 126 b 240 80 328 94 283 80 b 137 115 202 80 166 91 b 99 195 112 136 99 165 b 118 256 99 217 106 238 b 204 303 138 287 171 303 b 292 249 238 303 273 285 b 306 199 302 234 306 217 b 279 129 306 173 296 148 l 276 126 l 281 127 b 408 248 336 142 385 190 b 473 470 409 254 473 469 b 473 470 473 470 473 470 b 465 464 473 470 469 467 b 341 421 428 435 383 421 b 236 458 303 421 266 433 b 200 537 212 478 200 508 b 289 644 200 585 234 635 "},"v58":{"x_min":-21.78125,"x_max":367.5,"ha":375,"o":"m 259 1553 b 265 1553 261 1553 264 1553 b 288 1540 272 1553 277 1550 b 367 1351 340 1493 367 1424 b 336 1221 367 1308 357 1263 l 332 1211 l 333 1208 b 367 1077 356 1170 367 1124 b 336 945 367 1032 357 986 l 332 935 l 333 932 b 367 800 356 893 367 848 b 336 669 367 756 357 710 l 332 659 l 333 656 b 367 523 356 617 367 571 b 345 412 367 485 360 446 b 231 273 322 356 284 310 b -1 19 121 195 27 93 b -17 4 -4 11 -10 5 l -21 4 l -21 134 l -21 265 l -17 265 b 133 291 20 265 96 278 b 318 537 245 328 318 433 b 307 603 318 559 315 582 b 303 614 304 612 304 614 b 298 609 302 614 300 613 b 231 549 281 589 258 567 b -1 295 121 471 27 369 b -17 280 -4 287 -10 281 l -21 280 l -21 410 l -21 541 l -17 541 b 133 567 20 541 96 555 b 318 813 245 605 318 709 b 307 880 318 835 315 859 b 303 891 304 888 304 891 b 298 885 302 891 300 888 b 231 825 281 866 258 843 b -1 571 121 748 27 645 b -17 556 -4 563 -10 557 l -21 556 l -21 687 l -21 817 l -17 817 b 133 843 20 817 96 830 b 318 1089 245 881 318 985 b 307 1156 318 1111 315 1134 b 303 1167 304 1164 304 1167 b 298 1161 302 1167 300 1164 b 231 1102 281 1140 258 1120 b -1 848 121 1024 27 921 b -17 832 -4 839 -10 834 l -21 832 l -21 963 l -21 1093 l -17 1093 b 114 1113 12 1093 78 1103 b 313 1314 215 1142 289 1218 b 318 1364 317 1331 318 1347 b 255 1511 318 1422 295 1478 b 243 1532 247 1519 243 1525 b 259 1553 243 1540 250 1550 "},"v59":{"x_min":0,"x_max":464.140625,"ha":474,"o":"m 0 0 l 0 347 l 76 347 l 153 347 l 153 0 l 153 -348 l 76 -348 l 0 -348 l 0 0 m 308 -1 l 308 347 l 386 347 l 464 347 l 464 -1 l 464 -348 l 386 -348 l 308 -348 l 308 -1 "},"v5a":{"x_min":-171.5,"x_max":170.140625,"ha":174,"o":"m -6 566 b 0 567 -5 567 -2 567 b 14 556 6 567 12 563 b 92 285 14 555 50 433 b 170 13 166 33 170 19 b 168 13 170 13 170 13 b 161 1 168 8 167 4 l 159 0 l 122 0 l 84 0 l 81 1 b 21 195 76 5 78 -5 b -32 381 -8 297 -32 381 b -87 197 -32 381 -57 298 b -141 8 -115 94 -140 9 b -155 0 -142 2 -149 0 b -171 15 -163 0 -171 5 b -14 556 -171 18 -24 528 b -6 566 -14 560 -10 564 "},"v5b":{"x_min":-441,"x_max":439.640625,"ha":449,"o":"m -428 -2 b -421 0 -427 -1 -424 0 b -406 -6 -416 0 -409 -2 b -400 -31 -401 -12 -400 -15 b -1 -352 -392 -215 -215 -352 b 58 -349 19 -352 38 -351 b 398 -31 250 -326 392 -192 b 404 -6 398 -15 400 -12 b 419 -1 408 -2 413 -1 b 439 -13 427 -1 435 -5 b 439 -29 439 -16 439 -22 b 434 -105 439 -48 438 -80 b 0 -489 397 -333 213 -489 b -68 -484 -23 -489 -44 -488 b -441 -36 -280 -452 -436 -263 b -441 -30 -441 -34 -441 -31 b -428 -2 -441 -11 -439 -5 m -13 -9 b -1 -8 -9 -8 -5 -8 b 50 -36 19 -8 39 -19 b 61 -72 57 -47 61 -59 b 50 -106 61 -84 57 -97 b -1 -134 39 -124 19 -134 b -46 -115 -17 -134 -34 -129 b -62 -72 -57 -102 -62 -87 b -13 -9 -62 -44 -44 -16 "},"v5c":{"x_min":0,"x_max":447.8125,"ha":457,"o":"m 0 -87 l 0 0 l 223 0 l 447 0 l 447 -87 l 447 -174 l 223 -174 l 0 -174 l 0 -87 "},"v5d":{"x_min":-1.359375,"x_max":592.078125,"ha":604,"o":"m 280 692 b 295 694 283 692 289 694 b 310 692 300 694 307 692 b 357 630 340 684 357 657 b 336 580 357 612 351 594 b 311 538 321 566 311 549 b 352 492 311 512 330 492 b 366 495 357 492 362 492 b 397 553 390 503 397 517 b 415 603 397 576 402 591 b 460 623 427 617 443 623 b 509 599 479 623 498 614 b 522 559 518 587 522 573 b 494 506 522 538 513 519 b 451 495 481 498 473 496 b 415 488 432 495 426 494 b 394 449 404 483 394 464 b 394 448 394 448 394 448 l 394 440 l 397 433 b 428 409 404 420 413 413 b 438 408 431 408 435 408 b 479 431 450 408 462 415 b 528 455 495 448 510 455 b 548 452 534 455 541 453 b 592 391 577 442 592 416 b 549 331 592 365 577 340 b 528 327 541 328 534 327 b 479 351 510 327 495 335 b 438 374 464 367 450 374 b 417 369 431 374 424 373 b 394 333 402 360 394 348 b 400 312 394 326 396 319 b 451 287 408 294 420 288 b 513 258 484 285 499 278 b 522 223 519 247 522 234 b 461 159 522 190 496 159 b 449 161 457 159 453 159 b 397 229 416 167 397 191 b 366 288 397 265 390 278 b 352 290 362 290 357 290 b 315 262 336 290 321 280 b 311 245 313 256 311 251 b 334 204 311 233 318 220 b 355 170 348 190 351 184 b 357 152 356 166 357 159 b 355 136 357 147 356 140 b 295 88 345 104 321 88 b 232 152 264 88 232 112 b 255 204 232 174 238 186 b 279 244 273 222 279 231 l 279 245 b 238 290 279 270 259 290 b 224 288 234 290 228 290 b 193 229 200 278 193 265 b 141 161 193 191 174 167 b 129 159 137 159 133 159 b 68 223 93 159 68 190 b 77 258 68 234 70 247 b 138 287 91 278 106 285 b 185 302 166 287 175 291 b 196 333 193 312 196 323 b 174 369 196 347 187 360 b 152 374 166 373 159 374 b 111 351 140 374 126 367 b 62 327 95 335 80 327 b 51 328 58 327 54 327 b -1 391 16 334 -1 363 b 53 455 -1 420 17 449 b 62 455 57 455 59 455 b 111 431 80 455 95 448 b 152 408 127 415 140 408 b 161 409 155 408 159 408 b 193 433 176 413 186 420 l 196 440 l 196 448 b 196 451 196 449 196 449 b 190 471 196 459 194 463 b 137 495 182 489 167 495 l 134 495 l 134 495 b 68 560 95 495 68 521 b 129 623 68 596 95 623 b 144 621 134 623 138 623 b 193 553 175 614 193 589 b 224 495 193 517 200 503 b 238 492 228 492 234 492 b 279 538 259 492 279 512 b 254 580 279 549 269 566 b 232 630 239 594 232 612 b 280 692 232 657 250 684 m 307 456 b 295 458 303 458 299 458 b 230 391 258 458 230 426 b 236 360 230 381 231 371 b 295 324 249 337 272 324 b 353 360 318 324 341 337 b 360 391 357 370 360 381 b 307 456 360 421 340 451 "},"v60":{"x_min":-590.71875,"x_max":589.359375,"ha":601,"o":"m -367 173 b -362 174 -366 174 -364 174 b -351 173 -357 174 -353 173 b -262 86 -348 172 -328 151 b -176 0 -216 37 -176 0 b -107 84 -176 0 -145 37 b -31 174 -36 173 -38 172 b -25 174 -29 174 -28 174 b -16 173 -23 174 -19 173 b 72 86 -13 172 6 151 b 157 0 119 37 157 0 b 227 84 159 0 189 37 b 303 174 298 173 296 172 b 308 174 304 174 307 174 b 318 173 313 174 317 173 b 481 11 322 172 357 134 l 494 -1 l 522 34 b 560 76 553 72 555 74 b 567 77 563 77 564 77 b 589 56 579 77 589 68 b 586 48 589 54 588 51 b 411 -172 583 41 416 -166 b 397 -176 406 -174 401 -176 b 387 -174 393 -176 390 -176 b 299 -87 386 -173 366 -152 b 213 0 253 -38 213 0 b 144 -86 213 0 182 -38 b 68 -174 73 -174 74 -173 b 62 -176 66 -176 65 -176 b 53 -174 59 -176 55 -174 b -35 -87 50 -173 29 -152 b -121 0 -83 -38 -121 0 b -190 -86 -122 0 -152 -38 b -266 -174 -261 -174 -259 -173 b -272 -176 -268 -176 -270 -176 b -281 -174 -276 -176 -280 -174 b -371 -86 -284 -173 -304 -152 b -457 0 -417 -38 -457 0 l -457 0 b -477 -26 -457 0 -470 -16 b -548 -227 -524 -88 -548 -161 b -536 -303 -548 -254 -544 -280 b -533 -317 -534 -309 -533 -313 b -553 -338 -533 -330 -541 -338 b -577 -315 -566 -338 -571 -333 b -590 -227 -586 -287 -590 -258 b -518 -9 -590 -154 -564 -77 b -465 56 -509 2 -504 8 l -402 134 b -367 173 -375 169 -372 172 "},"v62":{"x_min":46.28125,"x_max":669.671875,"ha":563,"o":"m 183 376 b 189 376 185 376 187 376 b 212 374 197 376 208 376 b 265 337 234 369 253 355 b 274 317 268 331 273 320 b 274 316 274 317 274 316 b 280 323 276 316 276 319 b 311 358 288 337 299 348 b 319 366 315 360 318 365 b 356 376 326 373 340 376 b 382 371 364 376 374 374 b 428 337 400 366 417 352 b 436 317 431 331 436 320 b 438 316 436 317 436 316 b 442 323 438 316 439 319 b 475 358 451 337 462 348 b 483 366 477 360 481 365 b 518 376 488 373 503 376 b 544 373 528 376 536 376 b 604 285 579 360 604 326 b 597 249 604 273 601 258 b 543 63 596 247 544 70 b 541 54 543 61 541 55 b 540 44 540 51 540 47 b 552 23 540 33 545 23 b 552 23 552 23 552 23 b 647 126 586 29 627 72 b 658 138 651 136 653 138 b 660 138 660 138 660 138 b 669 129 666 137 669 136 b 654 88 669 122 665 109 b 562 -12 631 43 602 9 l 549 -19 b 521 -27 540 -24 530 -27 b 447 30 490 -27 458 -4 b 443 58 445 38 443 48 b 450 93 443 72 446 84 b 504 278 453 97 504 272 b 507 288 506 283 506 287 b 509 298 507 292 509 295 b 491 326 509 310 502 320 b 487 327 490 327 488 327 b 479 324 484 327 483 326 b 441 270 462 316 443 288 b 435 249 441 265 436 254 b 398 127 434 248 419 195 b 362 4 379 61 362 5 b 328 -1 359 -1 362 -1 b 314 -1 323 -1 319 -1 b 302 -1 310 -1 306 -1 b 266 4 266 -1 269 -1 b 265 6 265 5 265 5 b 303 144 265 13 272 34 b 343 278 325 216 343 276 b 344 288 343 281 344 285 b 345 298 345 291 345 295 b 330 326 345 310 340 320 b 323 327 328 327 325 327 b 317 324 322 327 321 326 b 279 270 300 316 281 288 b 273 249 279 265 274 254 b 236 127 272 248 255 195 b 200 4 216 61 200 5 b 164 -1 197 -1 198 -1 b 151 -1 161 -1 156 -1 b 140 -1 147 -1 142 -1 b 103 4 104 -1 106 -1 b 103 6 103 5 103 5 b 141 144 103 13 108 34 b 181 278 161 216 179 276 b 182 288 181 281 181 285 b 183 298 182 291 183 295 b 168 324 183 310 178 320 b 160 327 166 326 163 327 b 141 320 156 327 151 324 b 69 230 112 305 85 272 b 57 215 65 217 62 215 b 55 215 57 215 55 215 b 46 224 49 215 46 217 b 59 260 46 231 50 242 b 151 363 81 306 112 341 b 161 369 155 365 160 367 b 183 376 166 371 174 374 "},"v68":{"x_min":-597.53125,"x_max":596.171875,"ha":608,"o":"m -533 324 b -525 327 -530 326 -528 327 b -504 305 -514 327 -504 317 b -504 305 -504 305 -504 305 b -513 284 -504 299 -504 299 b -556 112 -541 226 -556 167 b -545 33 -556 84 -552 58 b -524 -20 -541 15 -532 -9 l -522 -23 l -491 15 l -413 111 b -355 174 -367 169 -363 174 b -351 174 -353 174 -352 174 b -254 86 -343 174 -348 179 b -168 -1 -208 37 -168 -1 b -100 84 -168 -1 -137 37 b -23 173 -28 173 -29 172 b -19 174 -21 174 -20 174 b -8 173 -14 174 -10 173 b 155 11 -5 172 43 123 l 166 -1 l 168 1 l 170 4 l 170 130 b 171 260 170 256 170 258 b 191 274 175 269 183 274 b 205 267 196 274 201 272 b 212 158 212 262 210 273 l 212 56 l 257 112 b 311 173 304 172 304 172 b 317 174 313 174 314 174 b 326 173 319 174 323 173 b 490 11 329 172 366 134 l 502 -1 l 530 34 b 568 76 560 72 563 74 b 575 77 570 77 573 77 b 596 56 586 77 596 68 b 594 48 596 54 596 51 b 417 -172 592 41 424 -166 b 405 -176 415 -174 409 -176 b 396 -174 401 -176 398 -176 b 307 -87 393 -173 372 -152 b 221 -1 259 -38 221 -1 b 216 -6 221 -1 219 -2 l 212 -12 l 212 -147 b 212 -210 212 -173 212 -194 b 205 -292 212 -297 210 -287 b 191 -299 201 -297 196 -299 b 172 -287 183 -299 175 -295 b 170 -174 171 -284 171 -284 l 170 -63 l 127 -117 b 73 -176 84 -170 80 -176 b 68 -176 72 -176 70 -176 b -27 -87 59 -174 65 -180 b -114 0 -74 -38 -112 0 b -182 -86 -114 0 -145 -38 b -258 -174 -253 -174 -253 -173 b -264 -176 -259 -176 -262 -176 b -274 -174 -268 -176 -272 -174 b -438 -11 -277 -173 -348 -102 l -449 0 l -479 -37 b -524 -80 -513 -80 -514 -80 l -524 -80 b -553 -52 -534 -80 -540 -74 b -597 109 -583 -8 -597 48 b -560 280 -597 165 -585 224 b -533 324 -548 310 -540 322 "},"v6c":{"x_min":-1.359375,"x_max":193.28125,"ha":197,"o":"m 78 233 b 87 233 81 233 84 233 b 187 140 132 233 174 195 b 193 102 190 127 193 115 b 43 -113 193 22 136 -62 b 27 -119 36 -116 31 -119 b 19 -108 21 -119 19 -115 b 29 -97 19 -102 20 -101 b 102 13 73 -72 102 -27 b 92 51 102 26 98 40 l 91 54 l 84 54 b 8 104 53 54 21 74 b -1 142 1 116 -1 130 b 78 233 -1 187 31 227 "},"v6d":{"x_min":-590.71875,"x_max":589.359375,"ha":601,"o":"m 544 335 b 553 337 548 337 551 337 b 575 313 563 337 570 330 b 589 226 583 285 589 256 b 517 8 589 152 563 76 b 464 -58 507 -4 503 -9 l 401 -136 b 362 -176 372 -172 370 -176 b 357 -176 360 -176 359 -176 b 261 -87 349 -174 355 -180 b 175 0 215 -38 175 0 b 106 -86 175 0 144 -38 b 29 -174 35 -174 36 -173 b 24 -176 28 -176 27 -176 b 14 -174 21 -176 17 -174 b -73 -87 12 -173 -8 -152 b -159 0 -121 -38 -159 0 b -228 -86 -160 0 -190 -38 b -304 -174 -299 -174 -298 -173 b -310 -176 -306 -176 -308 -176 b -319 -174 -314 -176 -318 -174 b -483 -12 -323 -173 -359 -137 l -495 0 l -524 -34 b -562 -77 -553 -73 -556 -76 b -568 -79 -564 -79 -566 -79 b -590 -58 -581 -79 -590 -69 b -588 -49 -590 -55 -589 -52 b -412 170 -585 -43 -417 165 b -398 174 -408 173 -402 174 b -389 173 -394 174 -392 174 b -300 86 -387 172 -366 151 b -215 -1 -254 37 -215 -1 b -145 84 -215 -1 -183 37 b -69 173 -74 173 -76 172 b -63 174 -68 174 -66 174 b -54 173 -61 174 -57 173 b 34 86 -51 172 -31 151 b 119 -1 81 37 119 -1 b 189 84 121 -1 151 37 b 265 173 259 173 258 172 b 270 174 266 174 269 174 b 280 173 274 174 279 173 b 370 84 283 172 303 151 b 455 -1 416 37 455 -1 l 455 -1 b 476 24 455 -1 469 15 b 547 226 522 87 547 159 b 534 302 547 252 543 278 b 532 317 533 308 532 313 b 544 335 532 326 536 333 "},"v6f":{"x_min":-80.3125,"x_max":78.9375,"ha":81,"o":"m 63 191 b 69 192 65 192 66 192 b 77 188 72 192 76 191 b 78 183 78 187 78 186 b 74 158 78 179 77 172 l 66 115 b 9 -161 49 30 10 -158 b -10 -187 6 -172 -1 -181 b -34 -194 -17 -191 -25 -194 b -80 -147 -58 -194 -80 -174 b -80 -141 -80 -144 -80 -142 b 9 70 -80 -134 -73 -117 l 49 163 b 63 191 59 188 61 190 "},"v70":{"x_min":0,"x_max":436.921875,"ha":446,"o":"m 213 190 b 217 191 215 191 216 191 b 231 184 223 191 228 188 b 249 154 240 167 246 159 b 419 18 292 91 348 45 b 436 -1 435 11 436 8 b 424 -16 436 -9 434 -13 b 308 -87 394 -26 340 -59 b 231 -186 276 -117 257 -142 b 219 -192 228 -191 225 -192 b 198 -174 209 -192 208 -191 b 47 -33 161 -113 110 -63 b 10 -16 34 -26 17 -19 b 0 -1 2 -13 0 -9 b 17 18 0 8 1 11 b 198 173 95 48 156 101 b 213 190 206 187 208 188 "},"v72":{"x_min":-423.3125,"x_max":421.9375,"ha":431,"o":"m -262 197 b -247 197 -257 197 -253 197 b -118 162 -210 197 -163 184 b 40 45 -61 134 -13 98 b 277 -95 119 -33 200 -81 b 289 -97 281 -97 285 -97 b 378 0 332 -97 371 -55 b 378 11 378 4 378 6 b 302 83 378 55 345 83 b 242 66 283 83 262 77 b 208 56 231 59 219 56 b 148 120 175 56 148 81 b 201 186 148 151 164 172 b 261 198 220 194 240 198 b 420 45 341 198 411 136 b 421 22 421 37 421 29 b 245 -199 421 -93 338 -199 b 238 -198 243 -199 240 -199 b -44 -47 148 -194 50 -141 b -250 86 -114 22 -183 66 b -295 94 -270 91 -283 94 b -315 91 -302 94 -307 94 b -381 4 -356 81 -381 43 b -355 -56 -381 -18 -372 -40 b -298 -81 -338 -73 -319 -81 b -246 -68 -283 -81 -265 -77 b -212 -58 -234 -61 -223 -58 b -178 -69 -200 -58 -189 -62 b -151 -122 -160 -81 -151 -101 b -171 -167 -151 -138 -157 -155 b -239 -195 -185 -181 -213 -192 b -257 -197 -245 -197 -250 -197 b -423 -5 -352 -197 -423 -109 b -412 65 -423 16 -419 40 b -262 197 -389 137 -329 188 "},"v74":{"x_min":-206.890625,"x_max":428.75,"ha":438,"o":"m 389 -351 b 394 -351 390 -351 393 -351 b 428 -385 413 -351 428 -367 b 428 -394 428 -388 428 -391 b 394 -428 426 -406 421 -410 l 332 -473 l 269 -516 l 205 -560 l 141 -603 l 77 -648 l 13 -692 l -50 -737 l -114 -780 l -145 -802 b -171 -813 -157 -810 -163 -813 b -175 -813 -172 -813 -174 -813 b -206 -777 -194 -811 -206 -795 b -202 -760 -206 -771 -205 -766 b -87 -675 -197 -752 -206 -757 l -34 -639 l 83 -557 l 145 -514 l 209 -470 l 272 -427 b 389 -351 375 -356 381 -352 "},"v75":{"x_min":-149.71875,"x_max":148.359375,"ha":151,"o":"m -137 381 b -130 383 -134 383 -133 383 b -111 371 -122 383 -114 378 b -55 224 -110 370 -85 305 b 0 80 -25 145 -1 80 b 54 224 0 80 24 145 b 112 377 114 384 110 373 b 127 384 118 381 122 384 b 148 362 138 384 148 374 l 148 356 l 83 183 b 16 9 47 88 17 11 b -1 0 12 2 5 0 b -14 5 -5 0 -10 1 b -84 183 -19 9 -13 -6 l -149 356 l -149 362 b -137 381 -149 371 -145 378 "},"v78":{"x_min":0,"x_max":193.28125,"ha":197,"o":"m 85 514 b 95 517 88 517 89 517 b 114 505 103 517 110 513 l 115 502 l 115 376 b 115 249 115 306 115 249 b 141 258 117 249 127 252 l 167 266 l 172 266 b 190 254 181 265 187 262 l 193 251 l 193 202 l 193 188 b 187 147 193 149 191 152 b 147 130 183 142 182 141 l 115 119 l 115 9 b 115 -99 115 -51 115 -99 b 141 -91 115 -99 127 -95 b 171 -81 166 -81 167 -81 l 171 -81 b 191 -94 181 -81 189 -87 b 193 -142 191 -97 193 -120 b 191 -195 193 -167 191 -194 b 125 -227 187 -205 187 -204 l 115 -230 l 115 -366 l 115 -503 l 114 -506 b 95 -519 110 -514 102 -519 b 74 -506 87 -519 78 -514 l 73 -503 l 73 -374 b 73 -245 73 -260 73 -245 b 73 -245 73 -245 73 -245 b 55 -252 72 -245 63 -249 l 32 -260 b 19 -263 27 -262 23 -263 b 4 -256 13 -263 8 -260 b 0 -215 0 -251 0 -254 b 0 -199 0 -210 0 -206 l 0 -152 l 1 -149 b 8 -140 2 -145 5 -141 b 42 -127 9 -140 24 -133 l 73 -116 l 73 -5 b 73 23 73 4 73 15 b 73 105 73 70 73 105 b 49 97 73 105 61 101 b 17 88 32 91 23 88 b 4 95 10 88 8 91 b 0 137 0 101 0 98 b 0 151 0 141 0 145 l 0 199 l 1 202 b 43 224 5 212 5 212 l 73 234 l 73 367 l 73 502 l 74 505 b 85 514 77 509 81 513 "},"v79":{"x_min":-1.359375,"x_max":899.703125,"ha":918,"o":"m 307 349 b 332 351 315 351 323 351 b 443 340 367 351 408 347 b 741 47 607 306 720 195 b 744 0 743 31 744 16 b 660 -303 744 -90 713 -206 b 28 -755 534 -531 304 -695 b 14 -756 23 -755 19 -756 b -1 -741 4 -756 -1 -750 b 21 -720 -1 -731 1 -728 b 567 -56 337 -601 548 -344 b 568 -11 568 -41 568 -24 b 442 285 568 129 525 233 b 325 319 406 308 367 319 b 93 177 232 319 137 266 b 84 154 91 170 84 155 b 84 154 84 154 84 154 b 88 156 84 154 85 155 b 159 177 110 170 134 177 b 257 134 194 177 231 162 b 294 41 281 108 294 73 b 171 -97 294 -24 246 -90 b 156 -98 166 -97 161 -98 b 6 74 73 -98 6 -22 b 6 80 6 76 6 79 b 307 349 10 223 141 340 m 839 215 b 845 216 841 216 842 216 b 862 213 852 216 860 215 b 899 163 887 206 899 184 b 872 117 899 145 890 127 b 847 111 865 112 856 111 b 808 130 833 111 818 117 b 796 162 800 140 796 151 b 839 215 796 187 812 212 m 839 -112 b 845 -112 841 -112 842 -112 b 862 -115 852 -112 860 -113 b 899 -165 887 -122 899 -144 b 872 -210 899 -183 890 -201 b 847 -217 865 -215 856 -217 b 808 -198 833 -217 818 -210 b 796 -165 800 -188 796 -177 b 839 -112 796 -140 812 -116 "},"v7c":{"x_min":0,"x_max":300.8125,"ha":307,"o":"m 49 505 b 53 506 50 505 51 506 b 70 496 58 506 62 503 b 81 485 73 492 78 488 l 96 473 l 111 459 l 122 449 l 134 438 l 182 396 l 255 330 b 292 291 292 298 292 298 l 292 290 l 292 284 l 283 270 b 209 36 234 197 209 113 b 288 -170 209 -44 235 -119 b 299 -184 295 -179 299 -181 b 300 -191 300 -187 300 -188 b 285 -206 300 -199 294 -206 b 280 -206 283 -206 281 -206 b 247 -201 270 -202 259 -201 b 176 -222 223 -201 197 -208 b 114 -340 136 -249 114 -292 b 172 -471 114 -384 134 -433 b 185 -492 182 -481 185 -487 b 181 -502 185 -496 183 -499 b 171 -508 176 -505 174 -508 b 152 -498 166 -508 160 -503 b 0 -284 65 -428 12 -352 b 0 -260 0 -278 0 -270 b 1 -238 0 -252 0 -242 b 148 -140 16 -177 73 -140 b 209 -148 167 -140 189 -142 b 215 -149 212 -148 215 -149 b 215 -149 215 -149 215 -149 l 215 -149 b 201 -136 215 -148 209 -142 l 157 -97 l 96 -41 b 17 34 21 24 17 29 b 17 37 17 36 17 36 b 17 38 17 37 17 38 b 25 56 17 44 17 44 b 110 298 81 131 110 219 b 46 474 110 367 88 431 b 38 491 40 480 38 487 b 49 505 38 498 42 502 "},"v7d":{"x_min":-1.359375,"x_max":436.921875,"ha":446,"o":"m 213 205 b 217 205 215 205 216 205 b 234 194 224 205 234 199 b 236 187 234 194 235 190 l 245 167 l 261 129 l 270 106 b 355 -61 294 54 329 -13 b 420 -163 381 -105 402 -138 b 436 -188 435 -184 436 -184 b 436 -191 436 -190 436 -190 b 421 -206 436 -201 431 -206 l 421 -206 l 416 -206 l 405 -201 b 217 -158 347 -172 283 -158 b 31 -201 153 -158 88 -172 l 20 -206 l 14 -206 l 14 -206 b 0 -191 5 -206 0 -201 b -1 -188 0 -190 -1 -190 b 14 -163 -1 -186 0 -184 b 95 -34 36 -136 72 -77 b 166 106 119 8 148 68 l 175 129 l 183 148 l 200 188 b 213 205 205 199 208 202 "},"v7f":{"x_min":0,"x_max":367.5,"ha":375,"o":"m 0 124 l 0 187 l 61 187 l 122 187 l 122 138 l 122 91 l 153 61 l 183 30 l 213 61 l 243 91 l 243 138 l 243 187 l 306 187 l 367 187 l 367 124 l 367 61 l 321 61 l 274 61 l 243 30 l 213 0 l 243 -31 l 274 -62 l 321 -62 l 367 -62 l 367 -124 l 367 -188 l 306 -188 l 243 -188 l 243 -140 l 243 -93 l 213 -62 l 183 -31 l 153 -62 l 122 -93 l 122 -140 l 122 -188 l 61 -188 l 0 -188 l 0 -124 l 0 -62 l 46 -62 l 92 -62 l 123 -31 l 153 0 l 123 30 l 92 61 l 46 61 l 0 61 l 0 124 "},"v80":{"x_min":29.9375,"x_max":420.578125,"ha":371,"o":"m 115 345 b 221 347 117 345 166 347 b 411 345 306 347 409 345 b 420 330 416 342 420 335 b 415 319 420 326 419 321 b 178 118 397 303 179 118 b 178 117 178 118 178 117 b 181 117 178 117 178 117 b 189 117 182 117 185 117 b 193 117 190 117 191 117 b 247 98 215 117 232 111 b 296 75 266 83 280 76 b 302 75 299 75 300 75 b 322 91 311 75 315 79 b 322 91 322 91 322 91 b 322 91 322 91 322 91 b 319 91 322 91 321 91 b 313 90 318 90 315 90 b 283 107 300 90 288 97 b 277 126 279 114 277 121 b 319 167 277 149 295 167 b 319 167 319 167 319 167 b 362 118 347 167 362 147 b 355 82 362 108 359 96 b 311 33 349 65 340 55 b 224 1 284 12 253 1 b 194 5 213 1 204 2 b 168 18 183 8 178 11 b 110 36 151 30 130 36 b 57 15 88 36 68 29 b 47 11 54 12 51 11 b 31 20 40 11 34 13 b 29 26 31 22 29 25 b 68 66 29 36 39 45 b 285 250 73 71 281 248 b 285 250 285 250 285 250 b 231 252 285 252 261 252 b 137 250 190 252 141 250 b 93 227 122 248 110 241 b 78 220 88 222 83 220 b 66 227 74 220 70 222 b 63 234 65 229 63 231 b 85 291 63 241 69 252 b 115 345 108 342 108 344 "},"v81":{"x_min":0,"x_max":428.75,"ha":438,"o":"m 262 186 b 273 186 266 186 272 186 b 274 186 273 186 274 186 b 285 186 274 186 280 186 b 428 48 375 181 428 122 b 386 -68 428 12 416 -29 b 155 -187 329 -145 236 -187 b 12 -111 92 -187 38 -162 b 0 -51 4 -91 0 -72 b 262 186 0 58 122 179 m 366 131 b 352 134 362 133 357 134 b 219 81 321 134 269 115 b 47 -111 126 23 50 -62 b 47 -112 47 -111 47 -112 b 77 -136 47 -129 58 -136 b 264 -45 118 -136 194 -101 b 382 109 336 12 382 76 b 366 131 382 120 377 129 "},"v83":{"x_min":-1.359375,"x_max":847.96875,"ha":865,"o":"m 488 1499 b 495 1500 490 1500 492 1500 b 541 1465 507 1500 521 1490 b 679 1078 622 1372 679 1210 b 677 1050 679 1068 677 1060 b 477 642 668 893 604 764 l 443 609 l 431 596 l 431 592 l 438 562 l 449 508 l 460 458 b 481 355 475 390 481 355 b 481 355 481 355 481 355 b 490 356 481 355 485 355 b 528 358 495 356 511 358 b 558 356 540 358 552 356 b 839 95 699 338 808 237 b 847 22 845 72 847 47 b 631 -303 847 -113 766 -242 b 620 -309 623 -308 620 -309 l 620 -310 b 631 -359 620 -310 626 -333 l 646 -435 l 660 -496 b 672 -588 668 -535 672 -563 b 664 -653 672 -610 669 -630 b 383 -875 630 -792 509 -875 b 201 -810 321 -875 257 -855 b 129 -680 151 -768 129 -730 b 274 -530 129 -592 200 -530 b 351 -553 300 -530 326 -538 b 412 -669 393 -582 412 -626 b 287 -805 412 -735 366 -800 l 279 -805 l 285 -809 b 383 -830 318 -823 351 -830 b 586 -718 464 -830 540 -789 b 626 -584 612 -678 626 -631 b 619 -528 626 -566 623 -548 b 612 -495 619 -526 616 -510 b 577 -324 590 -387 577 -324 b 577 -324 577 -324 577 -324 b 568 -326 575 -324 571 -324 b 528 -334 558 -328 537 -333 b 465 -338 506 -337 485 -338 b 24 -11 269 -338 87 -206 b -1 145 8 41 -1 93 b 96 442 -1 249 32 351 b 322 714 166 541 236 626 l 352 745 l 345 782 l 332 843 l 315 921 b 303 984 310 950 304 978 b 295 1082 298 1017 295 1049 b 413 1426 295 1208 336 1329 b 488 1499 436 1456 477 1496 m 549 1301 b 541 1301 547 1301 544 1301 b 411 1207 500 1301 447 1263 b 355 1004 374 1152 355 1079 b 359 942 355 984 356 963 b 371 881 362 927 363 917 l 385 818 b 392 782 389 799 392 784 l 392 782 b 434 828 393 782 424 816 b 607 1165 534 941 594 1060 b 608 1193 608 1175 608 1183 b 597 1270 608 1224 604 1254 b 549 1301 589 1286 571 1299 m 398 528 b 393 555 396 542 393 553 b 392 555 393 555 393 555 b 317 470 390 555 347 505 b 190 298 266 408 212 334 b 127 70 148 227 127 148 b 155 -77 127 19 137 -30 b 468 -303 209 -216 333 -303 b 519 -299 484 -303 502 -302 b 568 -284 541 -295 568 -287 l 568 -284 b 563 -263 568 -284 566 -274 l 534 -120 l 511 -13 l 496 61 l 480 133 b 469 187 472 176 469 187 b 468 188 469 187 469 188 b 416 162 462 188 430 172 b 337 13 364 126 337 69 b 413 -124 337 -40 363 -93 b 428 -144 424 -131 428 -137 b 428 -149 428 -145 428 -148 b 409 -166 426 -161 419 -166 b 394 -162 405 -166 400 -165 b 240 77 302 -122 240 -27 l 240 77 b 430 342 240 197 315 301 l 436 344 l 426 394 l 398 528 m 548 194 b 526 195 540 195 532 195 b 519 195 524 195 521 195 l 514 195 l 518 177 l 539 79 l 552 15 l 566 -48 l 594 -187 l 605 -240 b 612 -266 609 -254 611 -266 b 612 -266 612 -266 612 -266 b 641 -248 613 -266 630 -256 b 744 -98 692 -212 730 -156 b 751 -40 749 -79 751 -59 b 548 194 751 76 665 181 "},"v84":{"x_min":25.859375,"x_max":164.6875,"ha":168,"o":"m 34 369 b 40 370 35 370 38 370 b 59 353 49 370 50 367 b 164 40 122 254 155 158 b 164 0 164 33 164 16 b 164 -40 164 -16 164 -34 b 59 -353 155 -158 122 -254 b 40 -371 53 -366 47 -371 b 34 -370 38 -371 36 -370 b 25 -358 28 -367 25 -363 b 31 -337 25 -352 27 -347 b 92 0 72 -234 92 -117 b 31 335 92 116 72 233 b 25 356 27 345 25 352 b 34 369 25 363 28 366 "},"v86":{"x_min":-571.671875,"x_max":570.3125,"ha":582,"o":"m -386 173 b -381 174 -385 174 -383 174 b -370 173 -377 174 -372 173 b -281 86 -367 172 -347 151 b -196 0 -235 37 -196 0 b -126 84 -196 0 -164 37 b -50 174 -55 173 -57 172 b -44 174 -49 174 -47 174 b -35 173 -42 174 -38 173 b 53 86 -32 172 -12 151 b 138 0 100 37 138 0 b 208 84 140 0 170 37 b 284 174 279 173 277 172 b 289 174 285 174 288 174 b 299 173 294 174 298 173 b 462 11 303 172 338 134 l 475 -1 l 503 34 b 541 76 534 72 536 74 b 548 77 544 77 545 77 b 570 56 560 77 570 68 b 567 48 570 54 568 51 b 392 -172 564 41 397 -166 b 378 -176 387 -174 382 -176 b 368 -174 374 -176 371 -176 b 280 -87 367 -173 345 -152 b 194 0 234 -38 194 0 b 125 -86 194 0 163 -38 b 49 -174 54 -174 55 -173 b 43 -176 47 -176 46 -176 b 34 -174 40 -176 36 -174 b -54 -87 31 -173 10 -152 b -140 0 -102 -38 -140 0 b -209 -86 -141 0 -171 -38 b -285 -174 -280 -174 -279 -173 b -291 -176 -287 -176 -289 -176 b -300 -174 -295 -176 -299 -174 b -464 -12 -304 -173 -340 -137 l -476 0 l -504 -34 b -543 -77 -534 -73 -537 -76 b -549 -79 -545 -79 -547 -79 b -571 -58 -562 -79 -571 -69 b -568 -49 -571 -55 -570 -52 b -392 172 -566 -43 -396 167 b -386 173 -390 172 -387 173 "},"v8a":{"x_min":-170.140625,"x_max":168.78125,"ha":172,"o":"m -160 567 b -122 567 -159 567 -149 567 l -87 567 l -84 566 b -74 553 -78 563 -77 560 b -20 366 -73 551 -49 466 b 31 186 8 267 31 186 b 85 371 31 186 55 269 b 140 559 114 473 138 557 b 153 567 141 564 148 567 b 168 559 159 567 166 564 b 168 555 168 557 168 557 b 92 281 168 548 159 513 b 14 13 50 134 14 13 b 0 0 14 6 6 0 b -17 15 -8 0 -17 8 b -93 283 -17 15 -51 136 b -170 552 -166 533 -170 548 b -170 553 -170 552 -170 552 b -160 567 -170 560 -167 564 "},"v8b":{"x_min":0,"x_max":319.859375,"ha":326,"o":"m 149 508 b 159 509 152 509 155 509 b 186 494 170 509 181 503 b 190 440 190 487 190 488 l 190 430 l 190 377 l 242 377 l 251 377 b 303 373 298 377 296 377 b 319 345 314 367 319 356 b 304 319 319 335 314 324 b 250 315 296 315 299 315 l 242 315 l 190 315 l 190 262 l 190 252 b 186 198 190 204 190 205 b 159 183 179 188 170 183 b 132 198 148 183 138 188 b 127 252 127 205 127 204 l 127 262 l 127 315 l 76 315 l 68 315 b 14 319 20 315 21 315 b 0 347 4 324 0 335 b 14 373 0 356 4 367 b 68 377 21 377 20 377 l 76 377 l 127 377 l 127 430 l 127 440 b 132 494 127 488 127 487 b 149 508 136 501 142 505 "},"v8c":{"x_min":-330.75,"x_max":329.390625,"ha":336,"o":"m -133 483 b -117 484 -127 484 -122 484 b 31 373 -51 484 9 440 b 35 348 34 365 35 356 b -25 285 35 313 10 285 b -87 331 -55 285 -76 302 b -167 402 -100 376 -133 402 b -191 398 -175 402 -183 401 b -227 341 -215 388 -227 369 b -225 320 -227 334 -227 327 b -13 74 -209 230 -125 133 b 6 65 -4 70 5 66 l 9 63 l 10 65 b 117 231 12 68 40 112 l 189 341 l 242 424 b 268 460 262 456 264 458 b 283 464 273 463 277 464 b 308 438 296 464 308 453 l 308 437 b 287 396 308 430 308 428 l 95 98 l 59 43 l 58 41 l 65 37 b 253 -156 151 -8 217 -77 b 281 -285 272 -199 281 -244 b 148 -481 281 -381 231 -463 b 115 -485 137 -484 126 -485 b -32 -376 51 -485 -9 -442 b -36 -349 -35 -366 -36 -358 b 25 -287 -36 -315 -12 -287 b 85 -333 54 -287 74 -302 b 166 -403 99 -377 133 -403 b 190 -399 174 -403 182 -402 b 225 -342 215 -390 225 -370 b 224 -322 225 -335 225 -328 b 12 -76 208 -231 125 -134 b -8 -66 2 -72 -6 -68 l -10 -65 l -12 -66 b -118 -231 -13 -68 -42 -113 l -190 -342 l -243 -426 b -269 -462 -264 -458 -265 -458 b -284 -466 -274 -464 -279 -466 b -310 -440 -298 -466 -310 -455 l -310 -438 b -288 -398 -310 -430 -308 -430 l -96 -99 l -59 -44 l -59 -43 l -66 -38 b -281 284 -198 33 -281 158 l -281 284 b -133 483 -281 392 -220 474 m 254 177 b 266 179 258 177 262 179 b 319 149 287 179 307 167 b 329 115 326 140 329 127 b 319 79 329 102 326 90 b 268 51 307 61 287 51 b 221 72 250 51 234 58 b 205 115 210 84 205 99 b 254 177 205 142 223 170 m -281 -54 b -269 -52 -277 -52 -273 -52 b -223 -73 -253 -52 -235 -59 b -206 -116 -212 -84 -206 -101 b -216 -151 -206 -129 -209 -141 b -269 -179 -228 -170 -249 -179 b -314 -159 -285 -179 -302 -173 b -330 -116 -325 -147 -330 -131 b -281 -54 -330 -88 -313 -61 "},"v8f":{"x_min":-21.78125,"x_max":362.0625,"ha":369,"o":"m 302 1031 b 308 1032 304 1032 307 1032 b 330 1016 318 1032 325 1027 b 362 867 351 970 362 920 b 340 738 362 824 353 780 l 336 727 l 340 717 b 362 591 355 677 362 634 b 257 323 362 496 325 401 b 204 272 243 306 227 290 b 20 56 129 206 66 133 b -1 18 12 44 0 22 b -19 4 -4 9 -12 4 l -21 4 l -21 140 l -21 276 l -12 277 b 167 333 61 288 127 309 b 319 598 262 388 319 491 b 311 664 319 620 317 642 l 310 673 l 304 664 b 204 548 279 620 250 587 b 20 333 129 483 66 409 b -1 292 12 320 0 298 b -19 280 -4 285 -12 280 l -21 280 l -21 416 l -21 552 l -12 553 b 167 609 61 564 127 585 b 319 874 264 666 319 770 b 294 992 319 914 311 954 b 288 1011 288 1004 288 1007 b 302 1031 288 1021 294 1028 "},"v90":{"x_min":-171.5,"x_max":483.1875,"ha":493,"o":"m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 495 20 616 20 616 b 20 373 20 427 20 373 b 115 410 20 373 63 390 l 210 448 l 210 531 b 212 620 210 614 210 616 b 231 632 215 628 223 632 b 246 627 236 632 242 631 b 251 541 251 620 251 628 l 251 463 l 315 489 b 387 514 368 509 381 514 b 393 513 390 514 392 514 b 406 494 402 510 406 502 b 397 476 406 487 404 480 b 323 446 396 474 363 462 l 251 417 l 251 283 l 251 148 l 254 151 b 370 199 291 183 332 199 b 415 191 385 199 400 197 b 483 84 458 176 483 134 b 461 0 483 58 476 29 b 332 -142 439 -40 411 -72 l 255 -215 b 231 -229 240 -229 239 -229 b 216 -223 224 -229 220 -227 b 210 -158 210 -217 210 -223 b 210 -120 210 -148 210 -136 l 210 -29 l 205 -34 b 100 -142 182 -65 159 -88 l 23 -215 b -1 -229 9 -229 6 -229 b -19 -217 -9 -229 -16 -224 l -20 -215 l -21 48 l -21 310 l -83 287 b -152 262 -133 266 -145 262 b -157 263 -153 262 -155 262 b -171 283 -166 266 -171 274 b -161 301 -171 290 -167 297 b -91 328 -160 302 -129 315 l -21 356 l -21 487 l -20 617 l -19 621 b -8 631 -17 626 -12 630 m 210 288 b 210 401 210 351 210 401 b 114 365 209 401 167 384 l 20 327 l 20 238 l 20 148 l 21 151 b 140 199 59 183 102 199 b 206 180 164 199 187 192 l 209 177 b 209 177 209 177 209 177 b 210 288 210 177 210 199 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 m 341 131 b 328 133 337 133 332 133 b 322 133 326 133 323 133 b 257 87 296 129 273 113 l 251 80 l 251 -37 l 251 -156 l 255 -152 b 375 81 328 -72 375 20 l 375 83 b 341 131 375 113 367 126 "},"v92":{"x_min":0,"x_max":598.890625,"ha":611,"o":"m 62 181 b 77 183 66 183 72 183 b 91 181 83 183 88 183 b 202 131 100 180 106 177 l 299 87 l 394 131 b 517 183 499 181 502 183 b 519 183 517 183 518 183 b 598 104 567 183 598 144 b 577 49 598 84 592 65 b 518 15 567 38 563 37 b 484 0 499 6 484 0 b 518 -16 484 -1 499 -8 b 577 -51 563 -38 567 -40 b 598 -105 592 -66 598 -86 b 519 -184 598 -145 567 -184 b 517 -184 518 -184 517 -184 b 394 -133 502 -184 499 -183 l 299 -88 l 202 -133 b 81 -184 99 -183 95 -184 b 77 -184 80 -184 78 -184 b 0 -105 29 -184 0 -145 b 20 -51 0 -86 5 -66 b 80 -16 29 -40 34 -38 b 114 -1 98 -8 114 -1 b 80 15 114 0 98 6 b 20 49 34 37 29 38 b 0 104 6 65 0 84 b 62 181 0 140 23 174 m 88 134 b 74 136 85 134 80 136 b 68 134 72 136 69 136 b 46 104 54 130 46 117 b 55 81 46 95 49 88 b 149 34 59 76 53 80 b 224 -1 190 15 224 0 b 144 -38 224 -1 187 -18 b 54 -84 59 -79 58 -79 b 46 -105 49 -90 46 -98 b 76 -137 46 -122 58 -137 b 78 -137 77 -137 77 -137 b 194 -86 87 -137 76 -141 b 298 -36 250 -58 298 -36 b 298 -36 298 -36 298 -36 b 402 -84 299 -36 345 -58 b 518 -137 522 -141 510 -137 b 521 -137 519 -137 519 -137 b 551 -105 539 -137 551 -122 b 541 -83 551 -98 548 -90 b 447 -36 537 -77 544 -81 b 374 -1 406 -16 374 -1 b 447 34 374 0 406 15 b 541 81 544 80 537 76 b 551 104 548 88 551 97 b 521 136 551 120 539 136 b 518 136 519 136 519 136 b 517 136 518 136 517 136 l 517 136 b 402 83 511 136 511 136 b 298 34 345 56 299 34 b 298 34 298 34 298 34 b 194 84 298 34 250 56 b 88 134 137 111 89 133 "},"v93":{"x_min":0,"x_max":438.28125,"ha":447,"o":"m 212 205 b 219 205 213 205 216 205 b 239 183 228 205 231 204 b 421 -163 298 40 363 -83 b 438 -191 434 -180 438 -186 b 436 -197 438 -192 438 -195 b 424 -206 434 -204 431 -206 b 406 -201 420 -206 415 -205 b 216 -156 347 -172 281 -156 b 23 -205 148 -156 80 -173 b 14 -206 20 -206 17 -206 b 0 -191 6 -206 0 -201 b 6 -176 0 -187 1 -183 b 202 192 63 -104 142 45 b 212 205 205 199 208 202 m 264 48 l 249 81 l 243 94 l 242 91 b 89 -126 208 36 137 -66 b 81 -138 85 -133 81 -138 b 81 -138 81 -138 81 -138 b 81 -138 81 -138 81 -138 b 95 -133 81 -138 87 -136 b 280 -94 156 -108 221 -94 b 334 -98 299 -94 317 -95 b 343 -99 338 -99 343 -99 b 343 -99 343 -99 343 -99 b 338 -94 343 -99 341 -97 b 264 48 318 -58 287 1 "},"v94":{"x_min":-149.71875,"x_max":148.359375,"ha":151,"o":"m -9 215 b 0 217 -6 217 -4 217 b 19 205 8 217 14 213 b 20 142 20 202 20 201 l 20 84 l 23 84 b 144 -27 81 74 129 30 b 148 -66 147 -40 148 -54 b 36 -213 148 -134 103 -197 b 0 -219 24 -217 12 -219 b -145 -104 -68 -219 -129 -173 b -149 -68 -148 -91 -149 -79 b -24 84 -149 6 -98 74 l -21 84 l -21 142 b -19 205 -20 201 -20 202 b -9 215 -17 209 -13 213 m -21 -15 b -23 41 -21 37 -21 41 b -23 41 -23 41 -23 41 b -76 11 -35 40 -62 26 b -108 -65 -98 -11 -108 -38 b -1 -176 -108 -122 -65 -176 b 107 -65 63 -176 107 -122 b 74 11 107 -38 96 -11 b 20 41 61 26 32 41 b 20 -15 20 41 20 15 b 19 -74 20 -72 20 -72 b 0 -87 14 -83 6 -87 b -19 -74 -8 -87 -16 -83 b -21 -15 -20 -72 -20 -72 "},"v95":{"x_min":0,"x_max":406.96875,"ha":415,"o":"m 55 181 b 70 183 61 183 66 183 b 111 170 85 183 99 179 b 160 130 115 167 137 149 l 202 95 l 245 130 b 319 181 299 176 302 179 b 334 183 325 183 330 183 b 406 109 375 183 406 148 b 401 81 406 99 405 91 b 348 24 394 65 390 59 b 318 -1 332 11 318 0 b 348 -26 318 -1 332 -12 b 401 -83 390 -61 394 -66 b 406 -111 405 -93 406 -101 b 334 -184 406 -149 375 -184 b 319 -183 330 -184 325 -184 b 245 -131 302 -180 299 -177 l 202 -97 l 160 -131 b 85 -183 107 -177 103 -180 b 70 -184 80 -184 76 -184 b 0 -111 31 -184 0 -149 b 4 -83 0 -101 1 -93 b 58 -26 10 -66 16 -61 b 88 -1 74 -12 88 -1 b 58 24 88 0 74 11 b 10 69 23 54 17 59 b 0 109 2 81 0 95 b 55 181 0 142 21 173 m 83 133 b 72 136 78 136 76 136 b 57 131 66 136 61 134 b 46 109 49 126 46 117 b 50 93 46 104 47 98 b 107 45 51 91 77 70 b 160 0 137 20 160 0 b 107 -47 160 -1 137 -22 b 50 -94 77 -72 51 -93 b 46 -111 47 -99 46 -105 b 59 -134 46 -120 50 -130 b 72 -137 62 -136 68 -137 b 83 -136 76 -137 80 -136 b 144 -84 84 -134 107 -116 b 202 -36 176 -58 202 -36 b 261 -84 202 -36 230 -58 b 323 -136 299 -116 321 -134 b 334 -137 326 -136 330 -137 b 345 -134 338 -137 343 -136 b 360 -111 355 -130 360 -120 b 355 -94 360 -105 359 -99 b 299 -47 353 -93 329 -72 b 245 0 269 -22 245 -1 b 299 45 245 0 269 20 b 355 93 329 70 353 91 b 360 109 359 98 360 104 b 345 133 360 119 355 129 b 334 136 343 134 338 136 b 323 134 330 136 326 134 b 261 83 321 133 299 115 b 202 34 230 56 202 34 b 144 83 202 34 176 56 b 83 133 106 115 84 133 "},"v97":{"x_min":-228.671875,"x_max":227.3125,"ha":232,"o":"m -217 487 l -213 488 l 0 488 l 212 488 l 216 487 b 225 476 220 484 224 480 l 227 473 l 227 244 l 227 15 l 225 12 b 206 0 223 4 215 0 b 197 1 204 0 200 0 b 187 12 193 4 189 6 l 186 15 l 186 138 l 186 262 l -1 262 l -187 262 l -187 138 l -187 15 l -189 12 b -208 0 -193 4 -200 0 b -227 12 -216 0 -223 4 l -228 15 l -228 244 l -228 473 l -227 476 b -217 487 -225 480 -221 484 "},"v9a":{"x_min":-21.78125,"x_max":367.5,"ha":375,"o":"m 230 1031 b 238 1032 232 1032 235 1032 b 259 1014 245 1032 251 1027 b 367 662 330 906 367 782 b 364 602 367 641 367 621 b 232 317 352 488 304 384 b 57 120 155 245 103 187 b -1 18 31 84 6 40 b -19 4 -4 11 -12 4 l -21 4 l -21 159 l -21 315 l -16 315 b 96 335 10 315 62 324 b 315 695 227 380 315 527 b 313 738 315 709 314 724 b 224 991 304 825 273 916 b 216 1013 219 999 216 1007 b 230 1031 216 1021 220 1028 "},"v9b":{"x_min":-24.5,"x_max":313.0625,"ha":319,"o":"m -24 -133 l -24 -5 l -20 -5 b -1 -19 -12 -5 -4 -11 b 142 -213 13 -61 74 -144 b 258 -376 196 -269 230 -315 b 313 -605 295 -449 313 -528 b 292 -742 313 -652 306 -699 b 288 -752 289 -748 288 -752 b 288 -752 288 -752 288 -752 b 292 -764 289 -753 291 -757 b 313 -907 306 -811 313 -860 b 292 -1045 313 -954 306 -1002 b 288 -1054 289 -1050 288 -1054 b 288 -1054 288 -1054 288 -1054 b 292 -1067 289 -1054 291 -1060 b 313 -1210 306 -1113 313 -1161 b 292 -1346 313 -1257 306 -1304 b 288 -1357 289 -1353 288 -1357 b 288 -1357 288 -1357 288 -1357 b 292 -1368 289 -1357 291 -1363 b 313 -1512 306 -1415 313 -1464 b 292 -1648 313 -1560 306 -1605 b 288 -1660 289 -1654 288 -1660 b 288 -1660 288 -1660 288 -1660 b 292 -1671 289 -1660 291 -1665 b 313 -1814 306 -1719 313 -1766 b 250 -2040 313 -1897 291 -1977 b 232 -2062 238 -2057 236 -2059 b 221 -2065 230 -2063 225 -2065 b 200 -2045 210 -2065 201 -2057 b 200 -2043 200 -2044 200 -2044 b 208 -2026 200 -2037 202 -2034 b 269 -1826 249 -1966 269 -1897 b 153 -1544 269 -1726 230 -1625 b -9 -1472 115 -1506 58 -1481 b -21 -1471 -14 -1471 -19 -1471 l -24 -1471 l -24 -1343 l -24 -1215 l -20 -1215 b -1 -1229 -12 -1215 -4 -1221 b 142 -1424 13 -1270 74 -1353 b 257 -1582 196 -1478 228 -1524 b 264 -1594 261 -1589 264 -1594 l 264 -1594 b 265 -1582 264 -1594 264 -1589 b 270 -1525 268 -1562 270 -1544 b 153 -1243 270 -1424 228 -1321 b -9 -1170 115 -1203 58 -1178 b -21 -1168 -14 -1170 -19 -1168 l -24 -1168 l -24 -1041 l -24 -913 l -20 -913 b -1 -927 -12 -913 -4 -918 b 142 -1121 13 -967 74 -1050 b 257 -1281 196 -1175 228 -1221 b 264 -1292 261 -1286 264 -1292 l 264 -1292 b 265 -1279 264 -1292 264 -1286 b 270 -1222 268 -1261 270 -1242 b 153 -941 270 -1121 228 -1018 b -9 -867 115 -900 58 -875 b -21 -866 -14 -867 -19 -866 l -24 -866 l -24 -738 l -24 -610 l -20 -610 b -1 -624 -12 -610 -4 -616 b 142 -818 13 -664 74 -749 b 257 -978 196 -873 228 -918 b 264 -989 261 -984 264 -989 l 264 -989 b 265 -977 264 -989 264 -984 b 270 -920 268 -959 270 -939 b 153 -638 270 -818 228 -716 b -9 -564 115 -598 58 -573 b -21 -563 -14 -564 -19 -563 l -24 -563 l -24 -435 l -24 -308 l -20 -308 b -1 -322 -12 -308 -4 -313 b 142 -516 13 -363 74 -446 b 257 -675 196 -571 228 -616 b 264 -687 261 -681 264 -687 l 264 -687 b 265 -674 264 -687 264 -681 b 270 -617 268 -656 270 -637 b 153 -335 270 -516 228 -413 b -9 -262 115 -295 58 -270 b -21 -260 -14 -262 -19 -260 l -24 -260 l -24 -133 "},"v9c":{"x_min":-166.0625,"x_max":-25.859375,"ha":0,"o":"m -49 369 b -42 370 -46 369 -44 370 b -27 360 -36 370 -29 366 b -25 355 -27 359 -25 358 b -32 335 -25 351 -28 347 b -92 52 -66 248 -87 159 b -93 -1 -93 43 -93 20 b -92 -54 -93 -23 -93 -45 b -32 -337 -85 -162 -66 -251 b -25 -355 -27 -349 -25 -352 b -42 -371 -25 -365 -32 -371 b -61 -353 -50 -371 -51 -369 b -163 -63 -119 -262 -153 -165 b -166 -1 -166 -37 -166 -31 b -163 62 -166 30 -166 36 b -61 352 -153 163 -119 260 b -49 369 -54 365 -51 366 "},"v9e":{"x_min":0,"x_max":607.0625,"ha":619,"o":"m 243 631 b 250 632 246 632 249 632 b 270 620 259 632 268 628 l 272 616 l 272 201 l 272 -212 l 270 -216 b 251 -229 268 -224 259 -229 b 227 -215 243 -229 240 -229 l 151 -142 b 32 -16 81 -80 53 -49 b 0 84 9 18 0 52 b 111 199 0 149 42 199 b 137 197 119 199 127 198 b 228 151 168 191 197 177 l 231 148 l 231 383 b 232 620 231 616 231 616 b 243 631 234 624 238 630 m 168 131 b 152 133 163 133 157 133 b 107 102 130 133 111 120 b 106 86 107 97 106 91 b 111 41 106 73 108 56 b 227 -152 125 -13 171 -90 l 231 -156 l 231 -37 l 231 80 l 225 87 b 168 131 210 111 190 126 m 347 631 b 353 632 348 632 351 632 b 374 620 363 632 371 628 b 375 383 375 616 375 616 l 375 148 l 377 151 b 492 199 415 183 454 199 b 537 191 507 199 522 197 b 607 84 582 176 607 134 b 583 0 607 58 598 29 b 455 -142 562 -40 533 -72 l 378 -215 b 355 -229 364 -229 362 -229 b 334 -216 345 -229 337 -224 l 333 -212 l 333 201 l 333 616 l 334 620 b 347 631 337 624 341 630 m 465 131 b 451 133 461 133 455 133 b 445 133 449 133 446 133 b 379 87 419 129 396 113 l 375 80 l 375 -37 l 375 -156 l 378 -152 b 499 81 451 -72 499 20 l 499 83 b 465 131 499 113 490 126 "},"va3":{"x_min":58.53125,"x_max":228.671875,"ha":294,"o":"m 138 371 b 142 373 140 371 141 373 b 178 342 149 373 156 366 b 228 251 217 297 228 278 b 228 244 228 248 228 247 b 176 147 227 212 212 184 b 123 73 152 122 132 93 b 121 62 122 70 121 66 b 145 13 121 48 129 31 b 153 -2 151 6 153 1 b 149 -9 153 -5 152 -6 b 144 -11 148 -11 145 -11 b 129 -1 140 -11 136 -8 b 61 87 89 37 68 68 b 58 113 59 95 58 105 b 110 215 58 144 74 177 b 163 287 134 240 155 269 b 166 299 166 291 166 295 b 141 348 166 313 157 330 b 133 360 134 356 133 358 b 133 363 133 362 133 362 b 138 371 133 367 136 370 "},"va5":{"x_min":0,"x_max":349.8125,"ha":357,"o":"m 88 302 b 103 303 93 302 98 303 b 202 224 149 303 191 270 b 205 199 204 216 205 208 b 178 129 205 173 196 147 l 175 126 l 182 127 b 307 249 236 142 284 190 b 313 259 308 254 311 258 b 329 267 317 265 323 267 b 349 247 340 267 349 259 b 201 -263 349 242 204 -258 b 182 -273 197 -270 190 -273 b 163 -260 174 -273 166 -269 b 161 -256 161 -259 161 -258 b 217 -59 161 -248 170 -220 b 272 129 247 43 272 127 b 272 129 272 129 272 129 b 264 122 272 129 268 126 b 140 80 227 94 183 80 b 36 115 102 80 65 91 b 0 194 10 136 0 165 b 88 302 0 244 32 292 "},"va9":{"x_min":-24.5,"x_max":314.421875,"ha":321,"o":"m -24 -145 l -24 -5 l -20 -5 b 0 -23 -9 -5 -2 -12 b 27 -87 4 -38 14 -66 b 138 -220 53 -136 88 -177 b 235 -328 179 -255 208 -288 b 314 -592 287 -409 314 -501 b 292 -732 314 -639 307 -687 l 289 -742 l 294 -756 b 314 -896 307 -802 314 -849 b 292 -1035 314 -943 307 -991 l 289 -1045 l 294 -1057 b 314 -1197 307 -1104 314 -1152 b 292 -1338 314 -1246 307 -1292 l 289 -1347 l 294 -1360 b 314 -1500 307 -1407 314 -1454 b 273 -1689 314 -1565 300 -1628 b 250 -1712 265 -1710 261 -1712 b 228 -1691 236 -1712 228 -1704 l 228 -1685 l 234 -1675 b 270 -1507 258 -1621 270 -1564 b 98 -1193 270 -1381 209 -1261 b 40 -1174 76 -1179 58 -1174 b -10 -1189 24 -1174 8 -1178 b -20 -1192 -14 -1192 -16 -1192 l -24 -1192 l -24 -1052 l -24 -913 l -20 -913 b 0 -931 -9 -913 -2 -920 b 27 -995 4 -946 14 -974 b 138 -1128 53 -1043 88 -1085 b 257 -1275 190 -1172 228 -1220 b 262 -1283 259 -1279 262 -1283 l 262 -1283 b 269 -1249 264 -1282 268 -1260 b 270 -1206 270 -1233 270 -1220 b 98 -891 270 -1075 206 -957 b 40 -871 76 -877 58 -871 b -10 -886 24 -871 8 -875 b -20 -889 -14 -889 -16 -889 l -24 -889 l -24 -749 l -24 -610 l -20 -610 b 0 -628 -9 -610 -2 -617 b 27 -692 4 -644 14 -671 b 138 -825 53 -741 88 -782 b 257 -973 190 -870 228 -917 b 262 -981 259 -977 262 -981 l 262 -981 b 269 -946 264 -979 268 -957 b 270 -903 270 -931 270 -917 b 98 -588 270 -774 206 -655 b 40 -569 76 -574 58 -569 b -10 -584 24 -569 8 -574 b -20 -587 -14 -587 -16 -587 l -24 -587 l -24 -448 l -24 -308 l -20 -308 b 0 -326 -9 -308 -2 -315 b 27 -390 4 -341 14 -369 b 138 -523 53 -438 88 -480 b 257 -670 190 -567 228 -614 b 262 -678 259 -674 262 -678 b 262 -678 262 -678 262 -678 b 269 -644 264 -677 268 -656 b 270 -601 270 -628 270 -614 b 98 -285 270 -471 206 -352 b 40 -266 76 -273 58 -266 b -10 -281 24 -266 8 -272 b -20 -284 -14 -284 -16 -284 l -24 -284 l -24 -145 "},"vaa":{"x_min":-1.359375,"x_max":752.703125,"ha":768,"o":"m 490 985 b 504 986 495 986 500 986 b 604 907 551 986 593 954 b 607 884 607 900 607 892 b 581 813 607 857 597 831 l 578 810 l 583 811 b 710 932 638 827 687 873 b 714 943 711 936 713 942 b 730 952 720 949 725 952 b 752 931 741 952 752 943 b 200 -946 752 927 204 -941 b 182 -957 197 -953 190 -957 b 163 -945 174 -957 166 -953 b 161 -939 161 -942 161 -942 b 217 -743 161 -931 170 -904 b 272 -555 247 -639 272 -555 b 272 -555 272 -555 272 -555 b 264 -560 272 -555 268 -557 b 140 -603 227 -589 182 -603 b 36 -567 102 -603 65 -592 b -1 -487 12 -548 -1 -517 b 17 -427 -1 -466 5 -445 b 103 -380 38 -395 70 -380 b 191 -433 137 -380 172 -398 b 205 -484 201 -448 205 -466 b 178 -553 205 -509 196 -535 l 175 -557 l 182 -555 b 307 -435 236 -539 284 -494 b 372 -213 308 -430 372 -215 b 372 -213 372 -213 372 -213 b 364 -219 372 -213 368 -216 b 240 -262 328 -247 283 -262 b 137 -226 202 -262 166 -249 b 99 -145 112 -206 99 -176 b 118 -84 99 -124 106 -104 b 204 -38 138 -54 171 -38 b 292 -91 238 -38 273 -56 b 306 -141 302 -106 306 -124 b 279 -212 306 -167 296 -194 l 276 -215 l 281 -213 b 408 -93 336 -198 385 -151 b 473 129 409 -88 473 127 b 473 129 473 129 473 129 b 465 122 473 129 469 126 b 341 80 428 94 383 80 b 236 115 303 80 266 91 b 200 195 213 136 200 165 b 217 256 200 217 206 238 b 304 303 239 287 272 303 b 393 249 338 303 374 285 b 406 199 402 234 406 217 b 379 129 406 173 397 148 l 377 126 l 382 127 b 509 248 436 142 485 190 b 574 470 510 254 574 469 b 574 470 574 470 574 470 b 566 464 574 470 570 467 b 442 421 529 435 484 421 b 337 458 404 421 367 433 b 300 538 314 477 300 508 b 318 598 300 559 306 580 b 404 645 340 630 372 645 b 494 592 439 645 475 627 b 507 541 502 577 507 559 b 480 471 507 516 498 489 l 477 467 l 483 470 b 608 589 537 485 586 531 b 675 811 611 595 675 810 b 675 811 675 811 675 811 b 666 806 675 811 671 809 b 543 763 628 777 585 763 b 438 799 504 763 468 775 b 401 878 412 820 401 849 b 490 985 401 928 434 977 "},"vab":{"x_min":0,"x_max":272.21875,"ha":278,"o":"m 243 631 b 250 632 246 632 249 632 b 270 620 259 632 268 628 l 272 616 l 272 201 l 272 -212 l 270 -216 b 251 -229 268 -224 259 -229 b 227 -215 243 -229 240 -229 l 151 -142 b 32 -16 81 -80 53 -49 b 0 84 9 18 0 52 b 111 199 0 149 42 199 b 137 197 119 199 127 198 b 228 151 168 191 197 177 l 231 148 l 231 383 b 232 620 231 616 231 616 b 243 631 234 624 238 630 m 168 131 b 152 133 163 133 157 133 b 107 102 130 133 111 120 b 106 86 107 97 106 91 b 111 41 106 73 108 56 b 227 -152 125 -13 171 -90 l 231 -156 l 231 -37 l 231 80 l 225 87 b 168 131 210 111 190 126 "},"vad":{"x_min":0,"x_max":873.828125,"ha":892,"o":"m 0 0 l 0 703 l 81 703 l 164 703 l 164 0 l 164 -705 l 81 -705 l 0 -705 l 0 0 m 225 0 l 225 703 l 246 703 l 268 703 l 268 366 l 268 30 l 274 36 b 314 79 284 44 302 63 b 413 302 357 137 392 213 b 432 327 419 324 421 327 b 449 306 443 327 447 322 b 611 115 457 195 529 115 b 651 122 624 115 638 117 b 728 316 705 140 724 188 b 729 388 728 342 729 366 b 671 635 729 533 711 602 b 581 662 649 652 616 662 b 477 637 545 662 510 653 l 475 635 l 477 634 b 503 627 488 632 495 631 b 545 556 532 612 545 584 b 491 480 545 524 526 491 b 465 474 481 476 473 474 b 379 563 417 474 379 516 b 389 602 379 576 382 588 b 541 691 409 641 479 681 b 582 694 555 692 568 694 b 865 462 714 694 834 598 b 873 392 871 440 873 416 b 865 317 873 367 871 341 b 639 84 839 194 748 101 b 612 83 630 83 620 83 b 511 116 577 83 543 94 b 504 120 509 119 506 120 b 504 120 504 120 504 120 b 469 59 504 120 488 93 l 432 -1 l 469 -61 b 504 -122 488 -94 504 -122 b 504 -122 504 -122 504 -122 b 511 -117 506 -122 509 -120 b 612 -84 543 -95 577 -84 b 665 -91 630 -84 647 -87 b 869 -338 771 -122 850 -216 b 873 -392 872 -356 873 -374 b 798 -595 873 -469 847 -539 b 581 -695 741 -662 660 -695 b 406 -626 517 -695 454 -671 b 381 -563 389 -607 381 -585 b 465 -477 381 -519 413 -477 b 545 -559 514 -477 545 -519 b 503 -628 545 -587 532 -613 b 477 -635 495 -632 488 -634 l 475 -637 l 477 -638 b 581 -663 510 -655 545 -663 b 671 -637 616 -663 649 -653 b 729 -391 711 -603 729 -534 b 728 -317 729 -367 728 -344 b 623 -117 722 -173 698 -124 b 611 -116 619 -116 615 -116 b 449 -308 528 -116 457 -198 b 432 -328 447 -323 443 -328 b 413 -303 421 -328 419 -326 b 314 -80 392 -215 357 -138 b 274 -37 302 -65 284 -45 l 268 -31 l 268 -367 l 268 -705 l 246 -705 l 225 -705 l 225 0 "},"vb1":{"x_min":78.9375,"x_max":485.921875,"ha":417,"o":"m 362 378 b 378 380 367 380 372 380 b 472 348 415 380 453 367 b 485 315 481 338 485 327 b 462 273 485 298 477 281 b 439 267 454 269 446 267 b 398 290 424 267 409 274 b 344 319 385 309 364 319 b 281 269 315 319 289 301 b 279 262 280 266 279 262 b 276 256 279 260 277 258 b 274 249 276 254 274 251 b 238 127 273 248 257 192 b 201 4 217 61 201 5 b 166 -1 198 -1 200 -1 b 153 -1 163 -1 157 -1 b 141 -1 148 -1 144 -1 b 104 4 106 -1 107 -1 b 104 6 104 5 104 5 b 142 144 104 13 110 34 b 182 278 164 219 181 276 b 183 288 182 281 182 285 b 185 302 185 292 185 298 b 164 330 185 317 176 328 b 159 330 163 330 161 330 b 102 302 140 330 119 320 b 91 294 95 295 93 294 b 88 294 91 294 89 294 b 78 303 83 294 78 298 b 81 312 78 306 78 309 b 200 373 106 347 160 373 b 215 371 205 373 209 371 b 266 335 235 367 254 353 b 269 331 268 333 269 331 b 269 331 269 331 269 331 b 273 335 269 331 270 334 b 362 378 298 359 330 376 "},"vb3":{"x_min":0,"x_max":227.3125,"ha":232,"o":"m 91 213 b 100 215 93 215 96 215 b 227 58 167 215 224 144 b 227 52 227 56 227 54 b 61 -201 227 -43 164 -138 b 29 -216 44 -212 36 -216 b 23 -210 27 -216 24 -213 b 21 -205 21 -208 21 -206 b 34 -192 21 -201 25 -197 b 122 -55 89 -161 122 -106 b 104 6 122 -33 117 -12 l 103 9 l 96 9 b 4 79 57 9 17 38 b 0 112 1 90 0 101 b 91 213 0 163 36 209 "},"vb4":{"x_min":-597.53125,"x_max":596.171875,"ha":608,"o":"m -533 324 b -525 327 -530 326 -528 327 b -504 305 -514 327 -504 317 b -504 305 -504 305 -504 305 b -513 284 -504 299 -504 299 b -556 112 -541 226 -556 167 b -545 33 -556 84 -552 58 b -524 -20 -541 15 -532 -9 l -522 -23 l -491 15 l -413 111 b -355 174 -367 169 -363 174 b -351 174 -353 174 -352 174 b -254 86 -343 174 -348 179 b -168 -1 -208 37 -168 -1 b -100 84 -168 -1 -137 37 b -23 173 -28 173 -29 172 b -19 174 -21 174 -20 174 b -8 173 -14 174 -10 173 b 80 86 -5 172 13 151 b 166 -1 127 37 166 -1 b 235 84 166 -1 197 37 b 311 173 306 173 304 172 b 317 174 313 174 314 174 b 326 173 319 174 323 173 b 490 11 329 172 366 134 l 502 -1 l 530 34 b 568 76 560 72 563 74 b 575 77 570 77 573 77 b 596 56 586 77 596 68 b 594 48 596 54 596 51 b 417 -172 592 41 424 -166 b 405 -176 415 -174 409 -176 b 396 -174 401 -176 398 -176 b 307 -87 393 -173 372 -152 b 221 -1 259 -38 221 -1 b 152 -86 221 -1 190 -38 b 76 -176 81 -174 83 -173 b 70 -176 74 -176 73 -176 b 61 -174 66 -176 62 -174 b -27 -87 58 -173 38 -152 b -114 -1 -74 -38 -112 -1 b -182 -86 -114 -1 -145 -38 b -258 -176 -253 -174 -253 -173 b -264 -176 -259 -176 -262 -176 b -274 -174 -268 -176 -272 -174 b -438 -11 -277 -173 -348 -102 l -449 0 l -479 -37 b -524 -80 -513 -80 -514 -80 l -524 -80 b -553 -52 -534 -80 -540 -74 b -597 109 -583 -8 -597 48 b -560 280 -597 165 -585 224 b -533 324 -548 310 -540 322 "},"vb6":{"x_min":0,"x_max":556.6875,"ha":568,"o":"m 289 545 b 298 546 292 545 295 546 b 318 533 306 546 315 541 b 319 428 319 530 319 528 l 319 327 l 334 327 b 526 223 412 326 485 285 b 543 172 537 206 543 190 b 447 76 543 122 503 76 b 445 76 446 76 446 76 b 359 165 394 77 359 119 b 368 205 359 179 362 192 b 441 251 382 233 412 251 b 455 249 446 251 451 251 b 460 248 458 249 460 248 b 460 248 460 248 460 248 b 454 254 460 249 458 251 b 334 295 419 280 378 294 l 319 295 l 319 4 l 319 -287 l 321 -285 b 328 -285 322 -285 325 -285 b 524 -99 424 -277 507 -198 b 541 -79 526 -84 530 -79 b 556 -97 551 -79 556 -84 b 548 -133 556 -105 553 -117 b 334 -317 521 -233 434 -306 b 322 -319 329 -317 323 -317 l 319 -319 l 319 -424 b 319 -471 319 -444 319 -459 b 313 -541 319 -544 318 -535 b 298 -548 308 -545 303 -548 b 279 -534 289 -548 281 -542 b 277 -424 277 -531 277 -530 l 277 -317 l 273 -317 b 13 -95 153 -305 51 -217 b 0 2 4 -62 0 -29 b 182 295 0 126 66 238 b 274 324 210 309 249 320 l 277 324 l 277 427 b 279 533 277 528 277 530 b 289 545 281 538 285 542 m 277 2 b 277 291 277 161 277 291 b 268 288 277 291 273 290 b 144 1 179 265 144 184 b 276 -284 144 -199 175 -267 l 277 -285 l 277 2 "},"vb9":{"x_min":-122.5,"x_max":121.140625,"ha":124,"o":"m -16 145 b 0 147 -10 147 -5 147 b 121 -1 66 147 121 77 b 114 -49 121 -16 118 -33 b -1 -148 95 -112 47 -148 b -85 -106 -31 -148 -61 -134 b -122 -1 -110 -76 -122 -38 b -16 145 -122 68 -81 134 m 12 111 b 0 113 8 113 4 113 b -68 22 -29 113 -61 73 b -70 0 -69 15 -70 6 b -13 -113 -70 -49 -47 -98 b -1 -115 -9 -115 -5 -115 b 63 -40 24 -115 53 -83 b 68 -1 66 -27 68 -15 b 12 111 68 48 46 97 "},"vba":{"x_min":-118.421875,"x_max":597.53125,"ha":381,"o":"m 460 574 b 464 574 461 574 462 574 b 488 574 470 574 481 574 b 500 573 491 574 498 574 b 594 503 543 570 588 538 b 597 488 596 498 597 494 b 528 417 597 449 564 417 b 502 423 519 417 510 419 b 465 481 477 434 465 458 b 488 528 465 499 472 516 b 490 530 490 530 490 530 b 490 530 490 530 490 530 b 468 517 488 530 475 523 b 349 340 419 485 377 420 b 347 330 348 334 347 330 b 383 328 347 328 363 328 b 428 326 423 328 424 328 b 442 302 438 320 442 312 b 430 281 442 294 438 285 b 385 276 424 277 426 276 l 377 276 l 332 276 l 330 269 b 178 -117 303 126 250 -9 b 1 -249 129 -194 69 -237 b -20 -251 -6 -251 -13 -251 b -114 -187 -65 -251 -100 -227 b -118 -156 -117 -177 -118 -166 b -51 -84 -118 -116 -91 -84 b -31 -87 -46 -84 -39 -86 b 16 -152 0 -95 16 -124 b -12 -205 16 -173 8 -194 b -16 -208 -14 -206 -16 -208 b -14 -208 -16 -208 -14 -208 b -9 -206 -14 -208 -12 -208 b 74 -124 23 -197 54 -166 b 172 224 98 -79 125 22 b 185 276 178 252 183 274 b 185 276 185 276 185 276 b 141 276 185 276 181 276 b 91 280 96 276 96 276 b 77 302 83 285 77 294 b 91 326 77 312 83 320 b 148 328 95 328 96 328 l 198 330 l 202 341 b 460 574 249 473 351 566 "},"vbf":{"x_min":-53.078125,"x_max":513.140625,"ha":485,"o":"m 185 383 b 196 384 187 383 191 384 b 277 334 230 384 259 365 b 288 301 281 324 288 306 b 288 297 288 298 288 297 b 294 302 289 297 291 299 b 394 370 323 338 367 367 b 404 371 398 370 401 371 b 510 272 453 371 498 328 b 513 237 513 262 513 251 b 507 172 513 217 511 192 b 326 -34 487 59 412 -26 b 314 -36 322 -36 318 -36 b 274 -24 298 -36 283 -31 l 265 -16 b 224 44 246 -1 232 20 b 223 49 224 47 223 49 b 223 49 223 49 223 49 b 149 -197 221 48 149 -194 b 149 -198 149 -197 149 -198 b 170 -210 149 -202 155 -205 b 187 -215 174 -210 175 -212 b 204 -231 201 -219 204 -222 b 197 -245 204 -240 202 -242 l 194 -248 l 76 -248 l -42 -248 l -46 -245 b -53 -231 -51 -242 -53 -240 b -35 -215 -53 -222 -49 -217 b -13 -210 -21 -212 -20 -212 b -6 -208 -10 -209 -8 -208 b 0 -206 -6 -208 -2 -206 b 25 -188 13 -201 21 -195 b 163 280 28 -183 163 276 b 166 291 163 283 164 287 b 167 302 167 295 167 299 b 155 324 167 315 161 324 b 155 324 155 324 155 324 b 65 230 125 322 85 280 b 53 215 61 217 58 215 b 51 215 53 215 51 215 b 42 224 46 215 42 217 b 57 263 42 231 47 244 b 140 360 77 305 104 337 b 152 370 144 365 149 369 b 185 383 157 376 172 381 m 374 306 b 366 308 371 308 368 308 b 300 273 348 308 321 294 b 284 254 288 262 287 259 b 280 242 283 249 281 245 b 257 169 279 240 270 213 l 236 98 l 236 93 b 251 48 238 77 243 61 b 279 27 258 37 272 27 b 281 27 279 27 280 27 b 291 31 281 27 287 30 b 396 170 334 52 378 109 b 406 247 402 197 406 224 b 401 277 406 259 405 270 b 374 306 397 290 383 303 "},"vc3":{"x_min":-10.890625,"x_max":299.4375,"ha":294,"o":"m 136 460 b 142 462 137 462 140 462 b 166 449 152 462 161 456 b 171 428 168 446 168 445 b 288 131 194 322 238 209 b 298 115 295 120 296 117 b 299 106 298 112 299 109 b 273 81 299 91 287 81 b 255 86 268 81 261 83 b 155 116 225 104 183 116 l 152 116 l 149 108 b 141 83 148 102 144 91 b 134 48 137 69 134 58 b 149 9 134 34 140 24 b 153 -1 152 5 153 1 b 149 -9 153 -5 152 -6 b 144 -11 148 -11 147 -11 b 122 2 138 -11 133 -6 b 95 61 104 20 95 38 b 107 108 95 74 99 90 b 108 113 107 111 108 112 b 107 113 108 113 108 113 b 102 113 106 113 104 113 b 31 86 76 108 53 98 b 14 80 24 81 20 80 b -10 106 0 80 -10 91 b 0 131 -10 115 -9 116 b 115 430 49 209 91 317 b 136 460 119 451 123 456 "}},"cssFontWeight":"normal","ascender":1903,"underlinePosition":-125,"cssFontStyle":"normal","boundingBox":{"yMin":-2065.375,"xMin":-695.53125,"yMax":1901.578125,"xMax":1159.671875},"resolution":1000,"descender":-2066,"familyName":"VexFlow-18","lineHeight":4093,"underlineThickness":50};
	// Vex Flow
	// Mohit Muthanna <mohit@muthanna.com>
	//
	// Copyright Mohit Muthanna 2010
	//
	// Requires a glyph font to be loaded and Vex.Flow.Font to be set.
	
	/**
	 * A quick and dirty static glyph renderer. Renders glyphs from the default
	 * font defined in Vex.Flow.Font.
	 *
	 * @param {!Object} ctx The canvas context.
	 * @param {number} x_pos X coordinate.
	 * @param {number} y_pos Y coordinate.
	 * @param {number} point The point size to use.
	 * @param {string} val The glyph code in Vex.Flow.Font.
	 * @param {boolean} nocache If set, disables caching of font outline.
	 */
	Vex.Flow.renderGlyph = function(ctx, x_pos, y_pos, point, val, nocache) {
	  var scale = point * 72.0 / (Vex.Flow.Font.resolution * 100.0);
	  var metrics = Vex.Flow.Glyph.loadMetrics(Vex.Flow.Font, val, !nocache);
	  Vex.Flow.Glyph.renderOutline(ctx, metrics.outline, scale, x_pos, y_pos);
	};
	
	/**
	 * @constructor
	 */
	Vex.Flow.Glyph = (function() {
	  function Glyph(code, point, options) {
	    this.code = code;
	    this.point = point;
	    this.context = null;
	    this.options = {
	      cache: true,
	      font: Vex.Flow.Font
	    };
	
	    this.width = null;
	    this.metrics = null;
	    this.x_shift = 0;
	    this.y_shift = 0;
	
	    if (options) this.setOptions(options); else this.reset();
	  }
	
	  Glyph.prototype = {
	    setOptions: function(options) {
	      Vex.Merge(this.options, options);
	      this.reset();
	    },
	
	    setStave: function(stave) { this.stave = stave; return this; },
	    setXShift: function(x_shift) { this.x_shift = x_shift; return this; },
	    setYShift: function(y_shift) { this.y_shift = y_shift; return this; },
	    setContext: function(context) { this.context = context; return this; },
	    getContext: function() { return this.context; },
	
	    reset: function() {
	      this.metrics = Vex.Flow.Glyph.loadMetrics(this.options.font, this.code,
	          this.options.cache);
	      this.scale = this.point * 72 / (this.options.font.resolution * 100);
	    },
	
	    setWidth: function(width) {
	      this.width =  width;
	      return this;
	    },
	
	    getMetrics: function() {
	      if (!this.metrics) throw new Vex.RuntimeError("BadGlyph", "Glyph " +
	          this.code + " is not initialized.");
	      return {
	        x_min: this.metrics.x_min * this.scale,
	        x_max: this.metrics.x_max * this.scale,
	        width: this.width || (this.metrics.x_max - this.metrics.x_min) * this.scale,
	        height: this.metrics.ha * this.scale
	      };
	    },
	
	    render: function(ctx, x_pos, y_pos) {
	      if (!this.metrics) throw new Vex.RuntimeError("BadGlyph", "Glyph " +
	          this.code + " is not initialized.");
	
	      var outline = this.metrics.outline;
	      var scale = this.scale;
	
	      Glyph.renderOutline(ctx, outline, scale, x_pos, y_pos);
	    },
	
	    renderToStave: function(x) {
	      if (!this.metrics) throw new Vex.RuntimeError("BadGlyph", "Glyph " +
	          this.code + " is not initialized.");
	      if (!this.stave) throw new Vex.RuntimeError("GlyphError", "No valid stave");
	      if (!this.context) throw new Vex.RERR("GlyphError", "No valid context");
	
	      var outline = this.metrics.outline;
	      var scale = this.scale;
	
	      Glyph.renderOutline(this.context, outline, scale,
	          x + this.x_shift, this.stave.getYForGlyphs() + this.y_shift);
	    }
	  };
	
	  /* Static methods used to implement loading / unloading of glyphs */
	  Glyph.loadMetrics = function(font, code, cache) {
	    var glyph = font.glyphs[code];
	    if (!glyph) throw new Vex.RuntimeError("BadGlyph", "Glyph " + code +
	        " does not exist in font.");
	
	    var x_min = glyph.x_min;
	    var x_max = glyph.x_max;
	    var ha = glyph.ha;
	
	    var outline;
	
	    if (glyph.o) {
	      if (cache) {
	        if (glyph.cached_outline) {
	          outline = glyph.cached_outline;
	        } else {
	          outline = glyph.o.split(' ');
	          glyph.cached_outline = outline;
	        }
	      } else {
	        if (glyph.cached_outline) delete glyph.cached_outline;
	        outline = glyph.o.split(' ');
	      }
	
	      return {
	        x_min: x_min,
	        x_max: x_max,
	        ha: ha,
	        outline: outline
	      };
	    } else {
	      throw new Vex.RuntimeError("BadGlyph", "Glyph " + this.code +
	          " has no outline defined.");
	    }
	  };
	
	  Glyph.renderOutline = function(ctx, outline, scale, x_pos, y_pos) {
	    var outlineLength = outline.length;
	
	    ctx.beginPath();
	
	    ctx.moveTo(x_pos, y_pos);
	
	    for (var i = 0; i < outlineLength; ) {
	      var action = outline[i++];
	
	      switch(action) {
	        case 'm':
	          ctx.moveTo(x_pos + outline[i++] * scale,
	                     y_pos + outline[i++] * -scale);
	          break;
	        case 'l':
	          ctx.lineTo(x_pos + outline[i++] * scale,
	                     y_pos + outline[i++] * -scale);
	          break;
	
	        case 'q':
	          var cpx = x_pos + outline[i++] * scale;
	          var cpy = y_pos + outline[i++] * -scale;
	
	          ctx.quadraticCurveTo(
	              x_pos + outline[i++] * scale,
	              y_pos + outline[i++] * -scale, cpx, cpy);
	          break;
	
	        case 'b':
	          var x = x_pos + outline[i++] * scale;
	          var y = y_pos + outline[i++] * -scale;
	
	          ctx.bezierCurveTo(
	              x_pos + outline[i++] * scale, y_pos + outline[i++] * -scale,
	              x_pos + outline[i++] * scale, y_pos + outline[i++] * -scale,
	              x, y);
	          break;
	      }
	    }
	    ctx.fill();
	  };
	
	  return Glyph;
	}());
	
	// Vex Flow
	// Mohit Muthanna <mohit@muthanna.com>
	//
	// Copyright Mohit Cheppudira 2010
	
	/** @constructor */
	Vex.Flow.Stave = (function() {
	  function Stave(x, y, width, options) {
	    if (arguments.length > 0) this.init(x, y, width, options);
	  }
	
	  var THICKNESS = (Vex.Flow.STAVE_LINE_THICKNESS > 1 ?
	        Vex.Flow.STAVE_LINE_THICKNESS : 0);
	  Stave.prototype = {
	    init: function(x, y, width, options) {
	      this.x = x;
	      this.y = y;
	      this.width = width;
	      this.glyph_start_x = x + 5;
	      this.glyph_end_x = x + width;
	      this.start_x = this.glyph_start_x;
	      this.end_x = this.glyph_end_x;
	      this.context = null;
	      this.glyphs = [];
	      this.end_glyphs = [];
	      this.modifiers = [];  // non-glyph stave items (barlines, coda, segno, etc.)
	      this.measure = 0;
	      this.clef = "treble";
	      this.font = {
	        family: "sans-serif",
	        size: 8,
	        weight: ""
	      };
	      this.options = {
	        vertical_bar_width: 10,       // Width around vertical bar end-marker
	        glyph_spacing_px: 10,
	        num_lines: 5,
	        fill_style: "#999999",
	        spacing_between_lines_px: 10, // in pixels
	        space_above_staff_ln: 4,      // in staff lines
	        space_below_staff_ln: 4,      // in staff lines
	        top_text_position: 1          // in staff lines
	      };
	      this.bounds = {x: this.x, y: this.y, w: this.width, h: 0};
	      Vex.Merge(this.options, options);
	
	      this.resetLines();
	
	      this.modifiers.push(
	          new Vex.Flow.Barline(Vex.Flow.Barline.type.SINGLE, this.x)); // beg bar
	      this.modifiers.push(
	          new Vex.Flow.Barline(Vex.Flow.Barline.type.SINGLE,
	          this.x + this.width)); // end bar
	    },
	
	    resetLines: function() {
	      this.options.line_config = [];
	      for (var i = 0; i < this.options.num_lines; i++) {
	        this.options.line_config.push({visible: true});
	      }
	      this.height = (this.options.num_lines + this.options.space_above_staff_ln) *
	         this.options.spacing_between_lines_px;
	      this.options.bottom_text_position = this.options.num_lines + 1;
	    },
	
	    setNoteStartX: function(x) { this.start_x = x; return this; },
	    getNoteStartX: function() {
	      var start_x = this.start_x;
	
	      // Add additional space if left barline is REPEAT_BEGIN and there are other
	      // start modifiers than barlines
	      if (this.modifiers[0].barline == Vex.Flow.Barline.type.REPEAT_BEGIN &&
	          this.modifiers.length > 2) {
	        start_x += 20;
	      }
	
	      return start_x;
	    },
	
	    getNoteEndX: function() { return this.end_x; },
	    getTieStartX: function() { return this.start_x; },
	    getTieEndX: function() { return this.x + this.width; },
	    setContext: function(context) {
	      this.context = context;
		for(var i=0; i<this.glyphs.length; i++){
	          if(typeof(this.glyphs[i].setContext) === "function"){
		    this.glyphs[i].setContext(context);
	          }
		}
	      return this;
	    },
	    getContext: function() { return this.context; },
	    getX: function() { return this.x; },
	    getNumLines: function() { return this.options.num_lines; },
	    setNumLines: function(lines) {
	      this.options.num_lines = parseInt(lines, 10);
	      this.resetLines();
	      return this;
	    },
	    setY: function(y) { this.y = y; return this; },
	
	    setX: function(x){
	      var shift = x - this.x;
	      this.x = x;
	      this.glyph_start_x += shift;
	      this.glyph_end_x += shift;
	      this.start_x += shift;
	      this.end_x += shift;
	      for(var i=0; i<this.modifiers.length; i++) {
	      	var mod = this.modifiers[i];
	        if (mod.x !== undefined) {
	          mod.x += shift;
	      	}
	      }
	      return this;
	    },
	
	    setWidth: function(width) {
	      this.width = width;
	      this.glyph_end_x = this.x + width;
	      this.end_x = this.glyph_end_x;
	
	      // reset the x position of the end barline (TODO(0xfe): This makes no sense)
	      // this.modifiers[1].setX(this.end_x);
	      return this;
	    },
	
	    getWidth: function() {
	      return this.width;
	    },
	
	    setMeasure: function(measure) { this.measure = measure; return this; },
	
	      // Bar Line functions
	    setBegBarType: function(type) {
	      // Only valid bar types at beginning of stave is none, single or begin repeat
	      if (type == Vex.Flow.Barline.type.SINGLE ||
	          type == Vex.Flow.Barline.type.REPEAT_BEGIN ||
	          type == Vex.Flow.Barline.type.NONE) {
	          this.modifiers[0] = new Vex.Flow.Barline(type, this.x);
	      }
	      return this;
	    },
	
	    setEndBarType: function(type) {
	      // Repeat end not valid at end of stave
	      if (type != Vex.Flow.Barline.type.REPEAT_BEGIN)
	        this.modifiers[1] = new Vex.Flow.Barline(type, this.x + this.width);
	      return this;
	    },
	
	    /**
	     * Gets the pixels to shift from the beginning of the stave
	     * following the modifier at the provided index
	     * @param  {Number} index The index from which to determine the shift
	     * @return {Number}       The amount of pixels shifted
	     */
	    getModifierXShift: function(index) {
	      if (typeof index === 'undefined') index = this.glyphs.length -1;
	      if (typeof index !== 'number') new Vex.RERR("InvalidIndex",
	        "Must be of number type");
	
	      var x = this.glyph_start_x;
	      var bar_x_shift = 0;
	
	      for (var i = 0; i < index + 1; ++i) {
	        var glyph = this.glyphs[i];
	        x += glyph.getMetrics().width;
	        bar_x_shift += glyph.getMetrics().width;
	      }
	
	      // Add padding after clef, time sig, key sig
	      if (bar_x_shift > 0) bar_x_shift += this.options.vertical_bar_width + 10;
	
	      return bar_x_shift;
	    },
	
	    // Coda & Segno Symbol functions
	    setRepetitionTypeLeft: function(type, y) {
	      this.modifiers.push(new Vex.Flow.Repetition(type, this.x, y));
	      return this;
	    },
	
	    setRepetitionTypeRight: function(type, y) {
	      this.modifiers.push(new Vex.Flow.Repetition(type, this.x, y) );
	      return this;
	    },
	
	    // Volta functions
	    setVoltaType: function(type, number_t, y) {
	      this.modifiers.push(new Vex.Flow.Volta(type, number_t, this.x, y));
	      return this;
	    },
	
	    // Section functions
	    setSection: function(section, y) {
	      this.modifiers.push(new Vex.Flow.StaveSection(section, this.x, y));
	      return this;
	    },
	
	    // Tempo functions
	    setTempo: function(tempo, y) {
	      this.modifiers.push(new Vex.Flow.StaveTempo(tempo, this.x, y));
	      return this;
	    },
	
	    // Text functions
	    setText: function(text, position, options) {
	      this.modifiers.push(new Vex.Flow.StaveText(text, position, options));
	      return this;
	    },
	
	    getHeight: function() {
	      return this.height;
	    },
	
	    getSpacingBetweenLines: function() {
	      return this.options.spacing_between_lines_px;
	    },
	
	    getBoundingBox: function() {
	      return new Vex.Flow.BoundingBox(this.x, this.y, this.width, this.getBottomY() - this.y);
	      // body...
	    },
	
	    getBottomY: function() {
	      var options = this.options;
	      var spacing = options.spacing_between_lines_px;
	      var score_bottom = this.getYForLine(options.num_lines) +
	         (options.space_below_staff_ln * spacing);
	
	      return score_bottom;
	    },
	
	    getBottomLineY: function() {
	      return this.getYForLine(this.options.num_lines);
	    },
	
	    getYForLine: function(line) {
	      var options = this.options;
	      var spacing = options.spacing_between_lines_px;
	      var headroom = options.space_above_staff_ln;
	
	      var y = this.y + ((line * spacing) + (headroom * spacing)) -
	        (THICKNESS / 2);
	
	      return y;
	    },
	
	    getYForTopText: function(line) {
	      var l = line || 0;
	      return this.getYForLine(-l - this.options.top_text_position);
	    },
	
	    getYForBottomText: function(line) {
	      var l = line || 0;
	      return this.getYForLine(this.options.bottom_text_position + l);
	    },
	
	    getYForNote: function(line) {
	      var options = this.options;
	      var spacing = options.spacing_between_lines_px;
	      var headroom = options.space_above_staff_ln;
	      var y = this.y + (headroom * spacing) + (5 * spacing) - (line * spacing);
	
	      return y;
	    },
	
	    getYForGlyphs: function() {
	      return this.getYForLine(3);
	    },
	
	    addGlyph: function(glyph) {
	      glyph.setStave(this);
	      this.glyphs.push(glyph);
	      this.start_x += glyph.getMetrics().width;
	      return this;
	    },
	
	    addEndGlyph: function(glyph) {
	      glyph.setStave(this);
	      this.end_glyphs.push(glyph);
	      this.end_x -= glyph.getMetrics().width;
	      return this;
	    },
	
	    addModifier: function(modifier) {
	      this.modifiers.push(modifier);
	      modifier.addToStave(this, (this.glyphs.length === 0));
	      return this;
	    },
	
	    addEndModifier: function(modifier) {
	      this.modifiers.push(modifier);
	      modifier.addToStaveEnd(this, (this.end_glyphs.length === 0));
	      return this;
	    },
	
	    addKeySignature: function(keySpec) {
	      this.addModifier(new Vex.Flow.KeySignature(keySpec));
	      return this;
	    },
	
	    addClef: function(clef, size, annotation) {
	      this.clef = clef;
	      this.addModifier(new Vex.Flow.Clef(clef, size, annotation));
	      return this;
	    },
	
	    addEndClef: function(clef, size, annotation) {
	      this.addEndModifier(new Vex.Flow.Clef(clef, size, annotation));
	      return this;
	    },
	
	    addTimeSignature: function(timeSpec, customPadding) {
	      this.addModifier(new Vex.Flow.TimeSignature(timeSpec, customPadding));
	      return this;
	    },
	
	    addEndTimeSignature: function(timeSpec, customPadding) {
	      this.addEndModifier(new Vex.Flow.TimeSignature(timeSpec, customPadding));
	    },
	
	    addTrebleGlyph: function() {
	      this.clef = "treble";
	      this.addGlyph(new Vex.Flow.Glyph("v83", 40));
	      return this;
	    },
	
	    /**
	     * All drawing functions below need the context to be set.
	     */
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw stave without canvas context.");
	
	      var num_lines = this.options.num_lines;
	      var width = this.width;
	      var x = this.x;
	      var y;
	      var glyph;
	
	      // Render lines
	      for (var line=0; line < num_lines; line++) {
	        y = this.getYForLine(line);
	
	        this.context.save();
	        this.context.setFillStyle(this.options.fill_style);
	        this.context.setStrokeStyle(this.options.fill_style);
	        if (this.options.line_config[line].visible) {
	          this.context.fillRect(x, y, width, Vex.Flow.STAVE_LINE_THICKNESS);
	        }
	        this.context.restore();
	      }
	
	      // Render glyphs
	      x = this.glyph_start_x;
	      for (var i = 0; i < this.glyphs.length; ++i) {
	        glyph = this.glyphs[i];
	        if (!glyph.getContext()) {
	          glyph.setContext(this.context);
	        }
	        glyph.renderToStave(x);
	        x += glyph.getMetrics().width;
	      }
	
	      // Render end glyphs
	      x = this.glyph_end_x;
	      for (i = 0; i < this.end_glyphs.length; ++i) {
	        glyph = this.end_glyphs[i];
	        if (!glyph.getContext()) {
	          glyph.setContext(this.context);
	        }
	        x -= glyph.getMetrics().width;
	        glyph.renderToStave(x);
	      }
	
	      // Draw the modifiers (bar lines, coda, segno, repeat brackets, etc.)
	      for (i = 0; i < this.modifiers.length; i++) {
	        // Only draw modifier if it has a draw function
	        if (typeof this.modifiers[i].draw == "function")
	          this.modifiers[i].draw(this, this.getModifierXShift());
	      }
	
	      // Render measure numbers
	      if (this.measure > 0) {
	        this.context.save();
	        this.context.setFont(this.font.family, this.font.size, this.font.weight);
	        var text_width = this.context.measureText("" + this.measure).width;
	        y = this.getYForTopText(0) + 3;
	        this.context.fillText("" + this.measure, this.x - text_width / 2, y);
	        this.context.restore();
	      }
	
	      return this;
	    },
	
	    // Draw Simple barlines for backward compatability
	    // Do not delete - draws the beginning bar of the stave
	    drawVertical: function(x, isDouble) {
	      this.drawVerticalFixed(this.x + x, isDouble);
	    },
	
	    drawVerticalFixed: function(x, isDouble) {
	      if (!this.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw stave without canvas context.");
	
	      var top_line = this.getYForLine(0);
	      var bottom_line = this.getYForLine(this.options.num_lines - 1);
	      if (isDouble)
	        this.context.fillRect(x - 3, top_line, 1, bottom_line - top_line + 1);
	      this.context.fillRect(x, top_line, 1, bottom_line - top_line + 1);
	    },
	
	    drawVerticalBar: function(x) {
	      this.drawVerticalBarFixed(this.x + x, false);
	    },
	
	    drawVerticalBarFixed: function(x) {
	      if (!this.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw stave without canvas context.");
	
	      var top_line = this.getYForLine(0);
	      var bottom_line = this.getYForLine(this.options.num_lines - 1);
	      this.context.fillRect(x, top_line, 1, bottom_line - top_line + 1);
	    },
	
	    /**
	     * Get the current configuration for the Stave.
	     * @return {Array} An array of configuration objects.
	     */
	    getConfigForLines: function() {
	      return this.options.line_config;
	    },
	
	    /**
	     * Configure properties of the lines in the Stave
	     * @param line_number The index of the line to configure.
	     * @param line_config An configuration object for the specified line.
	     * @throws Vex.RERR "StaveConfigError" When the specified line number is out of
	     *   range of the number of lines specified in the constructor.
	     */
	    setConfigForLine: function(line_number, line_config) {
	      if (line_number >= this.options.num_lines || line_number < 0) {
	        throw new Vex.RERR("StaveConfigError",
	          "The line number must be within the range of the number of lines in the Stave.");
	      }
	      if (!line_config.hasOwnProperty('visible')) {
	        throw new Vex.RERR("StaveConfigError",
	          "The line configuration object is missing the 'visible' property.");
	      }
	      if (typeof(line_config.visible) !== 'boolean') {
	        throw new Vex.RERR("StaveConfigError",
	          "The line configuration objects 'visible' property must be true or false.");
	      }
	
	      this.options.line_config[line_number] = line_config;
	
	      return this;
	    },
	
	    /**
	     * Set the staff line configuration array for all of the lines at once.
	     * @param lines_configuration An array of line configuration objects.  These objects
	     *   are of the same format as the single one passed in to setLineConfiguration().
	     *   The caller can set null for any line config entry if it is desired that the default be used
	     * @throws Vex.RERR "StaveConfigError" When the lines_configuration array does not have
	     *   exactly the same number of elements as the num_lines configuration object set in
	     *   the constructor.
	     */
	    setConfigForLines: function(lines_configuration) {
	      if (lines_configuration.length !== this.options.num_lines) {
	        throw new Vex.RERR("StaveConfigError",
	          "The length of the lines configuration array must match the number of lines in the Stave");
	      }
	
	      // Make sure the defaults are present in case an incomplete set of
	      //  configuration options were supplied.
	      for (var line_config in lines_configuration) {
	        // Allow 'null' to be used if the caller just wants the default for a particular node.
	        if (!lines_configuration[line_config]) {
	          lines_configuration[line_config] = this.options.line_config[line_config];
	        }
	        Vex.Merge(this.options.line_config[line_config], lines_configuration[line_config]);
	      }
	
	      this.options.line_config = lines_configuration;
	
	      return this;
	    }
	  };
	
	  return Stave;
	}());
	
	// Vex Flow Notation
	// Mohit Muthanna <mohit@muthanna.com>
	//
	// Copyright Mohit Muthanna 2010
	//
	// Requires vex.js.
	
	/** @constructor */
	Vex.Flow.StaveConnector = (function() {
	  function StaveConnector(top_stave, bottom_stave) {
	    this.init(top_stave, bottom_stave);
	  }
	
	  // SINGLE_LEFT and SINGLE are the same value for compatibility
	  // with older versions of vexflow which didn't have right sided
	  // stave connectors
	  StaveConnector.type = {
	    SINGLE_RIGHT : 0,
	    SINGLE_LEFT : 1,
	    SINGLE: 1,
	    DOUBLE: 2,
	    BRACE: 3,
	    BRACKET: 4,
	    BOLD_DOUBLE_LEFT: 5,
	    BOLD_DOUBLE_RIGHT: 6,
	    THIN_DOUBLE: 7
	  };
	
	  StaveConnector.prototype = {
	    init: function(top_stave, bottom_stave) {
	      this.thickness = Vex.Flow.STAVE_LINE_THICKNESS;
	      this.width = 3;
	      this.top_stave = top_stave;
	      this.bottom_stave = bottom_stave;
	      this.type = StaveConnector.type.DOUBLE;
	      this.x_shift = 0; // Mainly used to offset Bold Double Left to align with offset Repeat Begin bars
	    },
	
	    setContext: function(ctx) {
	      this.ctx = ctx;
	      return this;
	    },
	
	    setType: function(type) {
	      if (type >= StaveConnector.type.SINGLE_RIGHT &&
	          type <= StaveConnector.type.THIN_DOUBLE)
	        this.type = type;
	      return this;
	    },
	
	    setText: function(text, text_options) {
	      this.text = text;
	      this.text_options = {
	        shift_x: 0,
	        shift_y: 0
	      };
	      Vex.Merge(this.text_options, text_options);
	
	      this.font = {
	        family: "times",
	        size: 16,
	        weight: "normal"
	      };
	      return this;
	    },
	
	    setFont: function(font) {
	      Vex.Merge(this.font, font);
	    },
	
	    setXShift: function(x_shift){
	      if (typeof x_shift !== 'number') {
	        throw Vex.RERR("InvalidType", "x_shift must be a Number");
	      }
	
	      this.x_shift = x_shift;
	      return this;
	    },
	
	    draw: function() {
	      if (!this.ctx) throw new Vex.RERR(
	          "NoContext", "Can't draw without a context.");
	      var topY = this.top_stave.getYForLine(0);
	      var botY = this.bottom_stave.getYForLine(this.bottom_stave.getNumLines() - 1) +
	        this.thickness;
	      var width = this.width;
	      var topX = this.top_stave.getX();
	
	      var isRightSidedConnector = (
	        this.type === StaveConnector.type.SINGLE_RIGHT ||
	        this.type === StaveConnector.type.BOLD_DOUBLE_RIGHT ||
	        this.type === StaveConnector.type.THIN_DOUBLE
	      );
	
	      if (isRightSidedConnector){
	        topX = this.top_stave.getX() + this.top_stave.width;
	      }
	
	      var attachment_height = botY - topY;
	      switch (this.type) {
	        case StaveConnector.type.SINGLE:
	          width = 1;
	          break;
	        case StaveConnector.type.SINGLE_LEFT:
	          width = 1;
	          break;
	        case StaveConnector.type.SINGLE_RIGHT:
	          width = 1;
	          break;
	        case StaveConnector.type.DOUBLE:
	          topX -= (this.width + 2);
	          break;
	        case StaveConnector.type.BRACE:
	          width = 12;
	          // May need additional code to draw brace
	          var x1 = this.top_stave.getX() - 2;
	          var y1 = topY;
	          var x3 = x1;
	          var y3 = botY;
	          var x2 = x1 - width;
	          var y2 = y1 + attachment_height/2.0;
	          var cpx1 = x2 - (0.90 * width);
	          var cpy1 = y1 + (0.2 * attachment_height);
	          var cpx2 = x1 + (1.10 * width);
	          var cpy2 = y2 - (0.135 * attachment_height);
	          var cpx3 = cpx2;
	          var cpy3 = y2 + (0.135 * attachment_height);
	          var cpx4 = cpx1;
	          var cpy4 = y3 - (0.2 * attachment_height);
	          var cpx5 = x2 - width;
	          var cpy5 = cpy4;
	          var cpx6 = x1 + (0.40 * width);
	          var cpy6 = y2 + (0.135 * attachment_height);
	          var cpx7 = cpx6;
	          var cpy7 = y2 - (0.135 * attachment_height);
	          var cpx8 = cpx5;
	          var cpy8 = cpy1;
	          this.ctx.beginPath();
	          this.ctx.moveTo(x1, y1);
	          this.ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
	          this.ctx.bezierCurveTo(cpx3, cpy3, cpx4, cpy4, x3, y3);
	          this.ctx.bezierCurveTo(cpx5, cpy5, cpx6, cpy6, x2, y2);
	          this.ctx.bezierCurveTo(cpx7, cpy7, cpx8, cpy8, x1, y1);
	          this.ctx.fill();
	          this.ctx.stroke();
	          break;
	        case StaveConnector.type.BRACKET:
	          topY -= 4;
	          botY += 4;
	          attachment_height = botY - topY;
	          Vex.Flow.renderGlyph(this.ctx, topX - 5, topY - 3, 40, "v1b", true);
	          Vex.Flow.renderGlyph(this.ctx, topX - 5, botY + 3, 40, "v10", true);
	          topX -= (this.width + 2);
	          break;
	        case StaveConnector.type.BOLD_DOUBLE_LEFT:
	          drawBoldDoubleLine(this.ctx, this.type, topX + this.x_shift, topY, botY);
	          break;
	        case StaveConnector.type.BOLD_DOUBLE_RIGHT:
	          drawBoldDoubleLine(this.ctx, this.type, topX, topY, botY);
	          break;
	        case StaveConnector.type.THIN_DOUBLE:
	          width = 1;
	          break;
	      }
	
	      if (this.type !== StaveConnector.type.BRACE &&
	        this.type !== StaveConnector.type.BOLD_DOUBLE_LEFT &&
	        this.type !== StaveConnector.type.BOLD_DOUBLE_RIGHT) {
	        this.ctx.fillRect(topX , topY, width, attachment_height);
	      }
	
	      // If the connector is a thin double barline, draw the paralell line
	      if (this.type === StaveConnector.type.THIN_DOUBLE) {
	        this.ctx.fillRect(topX - 3, topY, width, attachment_height);
	      }
	
	      // Add stave connector text
	      if (this.text !== undefined) {
	        this.ctx.save();
	        this.ctx.lineWidth = 2;
	        this.ctx.setFont(this.font.family, this.font.size, this.font.weight);
	        var text_width = this.ctx.measureText("" + this.text).width;
	
	        var x = this.top_stave.getX() - text_width - 24 + this.text_options.shift_x;
	        var y = (this.top_stave.getYForLine(0) + this.bottom_stave.getBottomLineY()) / 2 +
	          this.text_options.shift_y;
	
	        this.ctx.fillText("" + this.text, x, y + 4);
	        this.ctx.restore();
	      }
	    }
	  };
	
	  function drawBoldDoubleLine(ctx, type, topX, topY, botY){
	    if (type !== StaveConnector.type.BOLD_DOUBLE_LEFT &&
	        type !== StaveConnector.type.BOLD_DOUBLE_RIGHT) {
	      throw Vex.RERR("InvalidConnector",
	        "A REPEAT_BEGIN or REPEAT_END type must be provided.");
	    }
	
	    var x_shift = 3;
	    var variableWidth = 3.5; // Width for avoiding anti-aliasing width issues
	    var thickLineOffset = 2; // For aesthetics
	
	    if (type === StaveConnector.type.BOLD_DOUBLE_RIGHT) {
	      x_shift = -5; // Flips the side of the thin line
	      variableWidth = 3;
	    }
	
	    // Thin line
	    ctx.fillRect(topX + x_shift, topY, 1, botY - topY);
	    // Thick line
	    ctx.fillRect(topX - thickLineOffset, topY, variableWidth, botY - topY);
	  }
	
	  return StaveConnector;
	}());
	// Vex Flow
	// Mohit Muthanna <mohit@muthanna.com>
	//
	// Copyright Mohit Cheppudira 2010
	
	/** @constructor */
	Vex.Flow.TabStave = (function() {
	  function TabStave(x, y, width, options) {
	    if (arguments.length > 0) this.init(x, y, width, options);
	  }
	
	  Vex.Inherit(TabStave, Vex.Flow.Stave, {
	    init: function(x, y, width, options) {
	      var tab_options = {
	        spacing_between_lines_px: 13,
	        num_lines: 6,
	        top_text_position: 1
	      };
	
	      Vex.Merge(tab_options, options);
	      TabStave.superclass.init.call(this, x, y, width, tab_options);
	    },
	
	    getYForGlyphs: function() {
	      return this.getYForLine(2.5);
	    },
	
	    addTabGlyph: function() {
	      var glyphScale;
	      var glyphOffset;
	
	      switch(this.options.num_lines) {
	        case 8:
	          glyphScale = 55;
	          glyphOffset = 14;
	          break;
	        case 7:
	          glyphScale = 47;
	          glyphOffset = 8;
	          break;
	        case 6:
	          glyphScale = 40;
	          glyphOffset = 1;
	          break;
	        case 5:
	          glyphScale = 30;
	          glyphOffset = -6;
	          break;
	        case 4:
	          glyphScale = 23;
	          glyphOffset = -12;
	          break;
	      }
	
	      var tabGlyph = new Vex.Flow.Glyph("v2f", glyphScale);
	      tabGlyph.y_shift = glyphOffset;
	      this.addGlyph(tabGlyph);
	      return this;
	    }
	  });
	
	  return TabStave;
	}());
	// Vex Flow
	// Copyright Mohit Cheppudira <mohit@muthanna.com>
	//
	// A formatter for abstract tickable objects, such as notes, chords,
	// tabs, etc.
	
	/** @constructor */
	Vex.Flow.TickContext = (function() {
	  function TickContext() {
	    this.init();
	  }
	
	  TickContext.prototype = {
	    init: function() {
	      this.currentTick = new Vex.Flow.Fraction(0, 1);
	      this.maxTicks = new Vex.Flow.Fraction(0, 1);
	      this.minTicks = null;
	      this.width = 0;
	      this.padding = 3;     // padding on each side (width += padding * 2)
	      this.pixelsUsed = 0;
	      this.x = 0;
	      this.tickables = [];   // Notes, tabs, chords, lyrics.
	      this.notePx = 0;       // width of widest note in this context
	      this.extraLeftPx = 0;  // Extra left pixels for modifers & displace notes
	      this.extraRightPx = 0; // Extra right pixels for modifers & displace notes
	      this.align_center = false;
	
	      this.tContexts = [];   // Parent array of tick contexts
	
	      // Ignore this tick context for formatting and justification
	      this.ignore_ticks = true;
	      this.preFormatted = false;
	      this.postFormatted = false;
	      this.context = null; // Rendering context
	    },
	
	    setContext: function(context) { this.context = context; return this; },
	    getContext: function() { return this.context; },
	    shouldIgnoreTicks: function() { return this.ignore_ticks; },
	    getWidth: function() { return this.width + (this.padding * 2); },
	    getX: function() { return this.x; },
	    setX: function(x) { this.x = x; return this; },
	    getPixelsUsed: function() { return this.pixelsUsed; },
	    setPixelsUsed: function(pixelsUsed) { this.pixelsUsed = pixelsUsed; return this; },
	    setPadding: function(padding) { this.padding = padding; return this; },
	    getMaxTicks: function() { return this.maxTicks; },
	    getMinTicks: function() { return this.minTicks; },
	    getTickables: function() { return this.tickables; },
	
	    getCenterAlignedTickables: function() {
	      return this.tickables.filter(function(tickable) {
	        return tickable.isCenterAligned();
	      });
	    },
	
	    // Get widths context, note and left/right modifiers for formatting
	    getMetrics: function() {
	      return { width: this.width, notePx: this.notePx,
	               extraLeftPx: this.extraLeftPx, extraRightPx: this.extraRightPx };
	    },
	
	    getCurrentTick: function() { return this.currentTick; },
	    setCurrentTick: function(tick) {
	      this.currentTick = tick;
	      this.preFormatted = false;
	    },
	
	    // Get left & right pixels used for modifiers
	    getExtraPx: function() {
	      var left_shift = 0;
	      var right_shift = 0;
	      var extraLeftPx = 0;
	      var extraRightPx = 0;
	      for (var i = 0; i < this.tickables.length; i++) {
	        extraLeftPx = Math.max(this.tickables[i].extraLeftPx, extraLeftPx);
	        extraRightPx = Math.max(this.tickables[i].extraRightPx, extraRightPx);
	        var mContext = this.tickables[i].modifierContext;
	        if (mContext && mContext != null) {
	          left_shift = Math.max( left_shift, mContext.state.left_shift);
	          right_shift = Math.max( right_shift, mContext.state.right_shift);
	        }
	      }
	      return { left: left_shift, right: right_shift,
	               extraLeft: extraLeftPx, extraRight: extraRightPx };
	    },
	
	    addTickable: function(tickable) {
	      if (!tickable) {
	        throw new Vex.RERR("BadArgument", "Invalid tickable added.");
	      }
	
	      if (!tickable.shouldIgnoreTicks()) {
	        this.ignore_ticks = false;
	
	        var ticks = tickable.getTicks();
	
	        if (ticks.greaterThan(this.maxTicks)) {
	          this.maxTicks = ticks.clone();
	        }
	
	        if (this.minTicks == null) {
	          this.minTicks = ticks.clone();
	        } else if (ticks.lessThan(this.minTicks)) {
	          this.minTicks = ticks.clone();
	        }
	      }
	
	      tickable.setTickContext(this);
	      this.tickables.push(tickable);
	      this.preFormatted = false;
	      return this;
	    },
	
	    preFormat: function() {
	      if (this.preFormatted) return;
	
	      for (var i = 0; i < this.tickables.length; ++i) {
	        var tickable = this.tickables[i];
	        tickable.preFormat();
	        var metrics = tickable.getMetrics();
	
	        // Maintain max extra pixels from all tickables in the context
	        this.extraLeftPx = Math.max(this.extraLeftPx,
	                                    metrics.extraLeftPx + metrics.modLeftPx);
	        this.extraRightPx = Math.max(this.extraRightPx,
	                                     metrics.extraRightPx + metrics.modRightPx);
	
	        // Maintain the widest note for all tickables in the context
	        this.notePx = Math.max(this.notePx, metrics.noteWidth);
	
	        // Recalculate the tick context total width
	        this.width = this.notePx +
	                     this.extraLeftPx +
	                     this.extraRightPx;
	      }
	
	      return this;
	    },
	
	    postFormat: function() {
	      if (this.postFormatted) return this;
	      this.postFormatted = true;
	      return this;
	    }
	  };
	
	  TickContext.getNextContext = function(tContext) {
	    var contexts = tContext.tContexts;
	    var index = contexts.indexOf(tContext);
	
	    return contexts[index+1];
	  };
	
	  return TickContext;
	}());
	
	// Vex Flow
	// Copyright Mohit Cheppudira <mohit@muthanna.com>
	//
	// The tickable interface. Tickables are things that sit on a score and
	// have a duration, i.e., they occupy space in the musical rendering dimension.
	
	/** @constructor */
	Vex.Flow.Tickable = (function() {
	  function Tickable() {
	    this.init();
	  }
	
	  Tickable.prototype = {
	    init: function() {
	      this.intrinsicTicks = 0;
	      this.tickMultiplier = new Vex.Flow.Fraction(1, 1);
	      this.ticks = new Vex.Flow.Fraction(0, 1);
	      this.width = 0;
	      this.x_shift = 0; // Shift from tick context
	      this.voice = null;
	      this.tickContext = null;
	      this.modifierContext = null;
	      this.modifiers = [];
	      this.preFormatted = false;
	      this.postFormatted = false;
	      this.tuplet = null;
	
	      // For interactivity
	      this.id = null;
	      this.elem = null;
	
	      this.align_center = false;
	      this.center_x_shift = 0; // Shift from tick context if center aligned
	
	      // This flag tells the formatter to ignore this tickable during
	      // formatting and justification. It is set by tickables such as BarNote.
	      this.ignore_ticks = false;
	      this.context = null;
	    },
	
	    setContext: function(context) { this.context = context; },
	
	    // Set the DOM ID of the element. Must be called before draw(). TODO: Update
	    // ID of element if has already been rendered.
	    setId: function(id) { this.id = id; },
	    getId: function() { return this.id; },
	    getElem: function() { return this.elem; },
	    getBoundingBox: function() { return null; },
	    getTicks: function() { return this.ticks; },
	    shouldIgnoreTicks: function() { return this.ignore_ticks; },
	    getWidth: function() { return this.width; },
	    setXShift: function(x) { this.x_shift = x; },
	    getCenterXShift: function() {
	      if (this.isCenterAligned()) {
	        return this.center_x_shift;
	      }
	
	      return 0;
	    },
	
	    isCenterAligned: function() { return this.align_center; },
	    setCenterAlignment: function(align_center) {
	      this.align_center = align_center;
	      return this;
	    },
	
	    // Every tickable must be associated with a voice. This allows formatters
	    // and preFormatter to associate them with the right modifierContexts.
	    getVoice: function() {
	      if (!this.voice) throw new Vex.RERR("NoVoice", "Tickable has no voice.");
	      return this.voice;
	    },
	    setVoice: function(voice) { this.voice = voice; },
	
	    getTuplet: function() { return this.tuplet; },
	    setTuplet: function(tuplet) {
	      // Detach from previous tuplet
	      var noteCount, beatsOccupied;
	
	      if (this.tuplet) {
	        noteCount = this.tuplet.getNoteCount();
	        beatsOccupied = this.tuplet.getBeatsOccupied();
	
	        // Revert old multiplier
	        this.applyTickMultiplier(noteCount, beatsOccupied);
	      }
	
	      // Attach to new tuplet
	      if (tuplet) {
	        noteCount = tuplet.getNoteCount();
	        beatsOccupied = tuplet.getBeatsOccupied();
	
	        this.applyTickMultiplier(beatsOccupied, noteCount);
	      }
	
	      this.tuplet = tuplet;
	
	      return this;
	    },
	
	    /** optional, if tickable has modifiers **/
	    addToModifierContext: function(mc) {
	      this.modifierContext = mc;
	      // Add modifiers to modifier context (if any)
	      this.preFormatted = false;
	    },
	
	    /** optional, if tickable has modifiers **/
	    addModifier: function(mod) {
	      this.modifiers.push(mod);
	      this.preFormatted = false;
	      return this;
	    },
	
	    setTickContext: function(tc) {
	      this.tickContext = tc;
	      this.preFormatted = false;
	    },
	
	    preFormat: function() {
	      if (this.preFormatted) return;
	
	      this.width = 0;
	      if (this.modifierContext) {
	        this.modifierContext.preFormat();
	        this.width += this.modifierContext.getWidth();
	      }
	    },
	    postFormat: function() {
	      if (this.postFormatted) return;
	      this.postFormatted = true;
	      return this;
	    },
	    getIntrinsicTicks: function() {
	      return this.intrinsicTicks;
	    },
	    setIntrinsicTicks: function(intrinsicTicks) {
	      this.intrinsicTicks = intrinsicTicks;
	      this.ticks = this.tickMultiplier.clone().multiply(this.intrinsicTicks);
	    },
	    getTickMultiplier: function() {
	      return this.tickMultiplier;
	    },
	    applyTickMultiplier: function(numerator, denominator) {
	      this.tickMultiplier.multiply(numerator, denominator);
	      this.ticks = this.tickMultiplier.clone().multiply(this.intrinsicTicks);
	    },
	    setDuration: function(duration) {
	      var ticks = duration.numerator * (Vex.Flow.RESOLUTION / duration.denominator);
	      this.ticks = this.tickMultiplier.clone().multiply(ticks);
	      this.intrinsicTicks = this.ticks.value();
	    }
	  };
	
	  return Tickable;
	}());
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements an abstract interface for notes and chords that
	// are rendered on a stave. Notes have some common properties: All of them
	// have a value (e.g., pitch, fret, etc.) and a duration (quarter, half, etc.)
	//
	// Some notes have stems, heads, dots, etc. Most notational elements that
	// surround a note are called *modifiers*, and every note has an associated
	// array of them. All notes also have a rendering context and belong to a stave.
	
	Vex.Flow.Note = (function() {
	  // To create a new note you need to provide a `note_struct`, which consists
	  // of the following fields:
	  //
	  // `type`: The note type (e.g., `r` for rest, `s` for slash notes, etc.)
	  // `dots`: The number of dots, which affects the duration.
	  // `duration`: The time length (e.g., `q` for quarter, `h` for half, `8` for eighth etc.)
	  //
	  // The range of values for these parameters are available in `src/tables.js`.
	  function Note(note_struct) {
	    if (arguments.length > 0) this.init(note_struct);
	  }
	  Note.CATEGORY = "note";
	
	  // Debug helper. Displays various note metrics for the given
	  // note.
	  Note.plotMetrics = function(ctx, note, yPos) {
	    var metrics = note.getMetrics();
	    var w = metrics.width;
	    var xStart = note.getAbsoluteX() - metrics.modLeftPx - metrics.extraLeftPx;
	    var xPre1 = note.getAbsoluteX() - metrics.extraLeftPx;
	    var xAbs = note.getAbsoluteX();
	    var xPost1 = note.getAbsoluteX() + metrics.noteWidth;
	    var xPost2 = note.getAbsoluteX() + metrics.noteWidth + metrics.extraRightPx;
	    var xEnd = note.getAbsoluteX() + metrics.noteWidth + metrics.extraRightPx + metrics.modRightPx;
	
	    var xWidth = xEnd - xStart;
	    ctx.save();
	    ctx.setFont("Arial", 8, "");
	    ctx.fillText(Math.round(xWidth) + "px", xStart + note.getXShift(), yPos);
	
	    var y = (yPos + 7);
	    function stroke(x1, x2, color) {
	      ctx.beginPath();
	      ctx.setStrokeStyle(color);
	      ctx.setFillStyle(color);
	      ctx.setLineWidth(3);
	      ctx.moveTo(x1 + note.getXShift(), y);
	      ctx.lineTo(x2 + note.getXShift(), y);
	      ctx.stroke();
	    }
	
	    stroke(xStart, xPre1, "red");
	    stroke(xPre1, xAbs, "#999");
	    stroke(xAbs, xPost1, "green");
	    stroke(xPost1, xPost2, "#999");
	    stroke(xPost2, xEnd, "red");
	    stroke(xStart - note.getXShift(), xStart, "#DDD"); // Shift
	    Vex.drawDot(ctx, xAbs + note.getXShift(), y, "blue");
	    ctx.restore();
	  };
	
	  // ## Prototype Methods
	  //
	  // Every note is a tickable, i.e., it can be mutated by the `Formatter` class for
	  // positioning and layout.
	  Vex.Inherit(Note, Vex.Flow.Tickable, {
	    // See constructor above for how to create a note.
	    init: function(note_struct) {
	      Note.superclass.init.call(this);
	
	      if (!note_struct) {
	        throw new Vex.RuntimeError("BadArguments",
	            "Note must have valid initialization data to identify " +
	            "duration and type.");
	      }
	
	      // Parse `note_struct` and get note properties.
	      var initData = Vex.Flow.parseNoteData(note_struct);
	      if (!initData) {
	        throw new Vex.RuntimeError("BadArguments",
	            "Invalid note initialization object: " + JSON.stringify(note_struct));
	      }
	
	      // Set note properties from parameters.
	      this.duration = initData.duration;
	      this.dots = initData.dots;
	      this.noteType = initData.type;
	
	      if (note_struct.duration_override) {
	        // Custom duration
	        this.setDuration(note_struct.duration_override);
	      } else {
	        // Default duration
	        this.setIntrinsicTicks(initData.ticks);
	      }
	
	      this.modifiers = [];
	
	      // Get the glyph code for this note from the font.
	      this.glyph = Vex.Flow.durationToGlyph(this.duration, this.noteType);
	
	      if (this.positions &&
	          (typeof(this.positions) != "object" || !this.positions.length)) {
	        throw new Vex.RuntimeError(
	          "BadArguments", "Note keys must be array type.");
	      }
	
	      // Note to play for audio players.
	      this.playNote = null;
	
	      // Positioning contexts used by the Formatter.
	      this.tickContext = null;    // The current tick context.
	      this.modifierContext = null;
	      this.ignore_ticks = false;
	
	      // Positioning variables
	      this.width = 0;             // Width in pixels calculated after preFormat
	      this.extraLeftPx = 0;       // Extra room on left for offset note head
	      this.extraRightPx = 0;      // Extra room on right for offset note head
	      this.x_shift = 0;           // X shift from tick context X
	      this.left_modPx = 0;        // Max width of left modifiers
	      this.right_modPx = 0;       // Max width of right modifiers
	      this.voice = null;          // The voice that this note is in
	      this.preFormatted = false;  // Is this note preFormatted?
	      this.ys = [];               // list of y coordinates for each note
	                                  // we need to hold on to these for ties and beams.
	
	      if (note_struct.align_center) {
	        this.setCenterAlignment(note_struct.align_center);
	      }
	
	      // The render surface.
	      this.context = null;
	      this.stave = null;
	      this.render_options = {
	        annotation_spacing: 5,
	        stave_padding: 12
	      };
	    },
	
	    // Get and set the play note, which is arbitrary data that can be used by an
	    // audio player.
	    getPlayNote: function() { return this.playNote; },
	    setPlayNote: function(note) { this.playNote = note; return this; },
	
	    // Don't play notes by default, call them rests. This is also used by things like
	    // beams and dots for positioning.
	    isRest: function() { return false; },
	
	    // TODO(0xfe): Why is this method here?
	    addStroke: function(index, stroke) {
	      stroke.setNote(this);
	      stroke.setIndex(index);
	      this.modifiers.push(stroke);
	      this.setPreFormatted(false);
	      return this;
	    },
	
	    // Get and set the target stave.
	    getStave: function() { return this.stave; },
	    setStave: function(stave) {
	      this.stave = stave;
	      this.setYs([stave.getYForLine(0)]); // Update Y values if the stave is changed.
	      this.context = this.stave.context;
	      return this;
	    },
	
	
	    // `Note` is not really a modifier, but is used in
	    // a `ModifierContext`.
	    getCategory: function() { return this.constructor.CATEGORY; },
	
	    // Set the rendering context for the note.
	    setContext: function(context) { this.context = context; return this; },
	
	    // Get and set spacing to the left and right of the notes.
	    getExtraLeftPx: function() { return this.extraLeftPx; },
	    getExtraRightPx: function() { return this.extraRightPx; },
	    setExtraLeftPx: function(x) { this.extraLeftPx = x; return this; },
	    setExtraRightPx: function(x) { this.extraRightPx = x; return this; },
	
	    // Returns true if this note has no duration (e.g., bar notes, spacers, etc.)
	    shouldIgnoreTicks: function() { return this.ignore_ticks; },
	
	    // Get the stave line number for the note.
	    getLineNumber: function() { return 0; },
	
	    // Get the stave line number for rest.
	    getLineForRest: function() { return 0; },
	
	    // Get the glyph associated with this note.
	    getGlyph: function() { return this.glyph; },
	
	    // Set and get Y positions for this note. Each Y value is associated with
	    // an individual pitch/key within the note/chord.
	    setYs: function(ys) { this.ys = ys; return this; },
	    getYs: function() {
	      if (this.ys.length === 0) throw new Vex.RERR("NoYValues",
	          "No Y-values calculated for this note.");
	      return this.ys;
	    },
	
	    // Get the Y position of the space above the stave onto which text can
	    // be rendered.
	    getYForTopText: function(text_line) {
	      if (!this.stave) throw new Vex.RERR("NoStave",
	          "No stave attached to this note.");
	      return this.stave.getYForTopText(text_line);
	    },
	
	    // Get a `BoundingBox` for this note.
	    getBoundingBox: function() { return null; },
	
	    // Returns the voice that this note belongs in.
	    getVoice: function() {
	      if (!this.voice) throw new Vex.RERR("NoVoice", "Note has no voice.");
	      return this.voice;
	    },
	
	    // Attach this note to `voice`.
	    setVoice: function(voice) {
	      this.voice = voice;
	      this.preFormatted = false;
	      return this;
	    },
	
	    // Get and set the `TickContext` for this note.
	    getTickContext: function() { return this.tickContext; },
	    setTickContext: function(tc) {
	      this.tickContext = tc;
	      this.preFormatted = false;
	      return this;
	    },
	
	    // Accessors for the note type.
	    getDuration: function() { return this.duration; },
	    isDotted: function() { return (this.dots > 0); },
	    hasStem: function() { return false; },
	    getDots: function() { return this.dots; },
	    getNoteType: function() { return this.noteType; },
	    setBeam: function() { return this; }, // ignore parameters
	
	    // Attach this note to a modifier context.
	    setModifierContext: function(mc) { this.modifierContext = mc; return this; },
	
	    // Attach a modifier to this note.
	    addModifier: function(modifier, index) {
	      modifier.setNote(this);
	      modifier.setIndex(index || 0);
	      this.modifiers.push(modifier);
	      this.setPreFormatted(false);
	      return this;
	    },
	
	    // Get the coordinates for where modifiers begin.
	    getModifierStartXY: function() {
	      if (!this.preFormatted) throw new Vex.RERR("UnformattedNote",
	          "Can't call GetModifierStartXY on an unformatted note");
	      return {x: this.getAbsoluteX(), y: this.ys[0]};
	    },
	
	    // Get bounds and metrics for this note.
	    //
	    // Returns a struct with fields:
	    // `width`: The total width of the note (including modifiers.)
	    // `noteWidth`: The width of the note head only.
	    // `left_shift`: The horizontal displacement of the note.
	    // `modLeftPx`: Start `X` for left modifiers.
	    // `modRightPx`: Start `X` for right modifiers.
	    // `extraLeftPx`: Extra space on left of note.
	    // `extraRightPx`: Extra space on right of note.
	    getMetrics: function() {
	      if (!this.preFormatted) throw new Vex.RERR("UnformattedNote",
	          "Can't call getMetrics on an unformatted note.");
	      var modLeftPx = 0;
	      var modRightPx = 0;
	      if (this.modifierContext != null) {
	        modLeftPx = this.modifierContext.state.left_shift;
	        modRightPx = this.modifierContext.state.right_shift;
	      }
	
	      var width = this.getWidth();
	      return { width: width,
	               noteWidth: width -
	                          modLeftPx - modRightPx -
	                          this.extraLeftPx - this.extraRightPx,
	               left_shift: this.x_shift, // TODO(0xfe): Make style consistent
	
	
	               // Modifiers, accidentals etc.
	               modLeftPx: modLeftPx,
	               modRightPx: modRightPx,
	
	               // Displaced note head on left or right.
	               extraLeftPx: this.extraLeftPx,
	               extraRightPx: this.extraRightPx };
	    },
	
	    // Get and set width of note. Used by the formatter for positioning.
	    setWidth: function(width) { this.width = width; },
	    getWidth: function() {
	      if (!this.preFormatted) throw new Vex.RERR("UnformattedNote",
	          "Can't call GetWidth on an unformatted note.");
	      return this.width +
	        (this.modifierContext ?  this.modifierContext.getWidth() : 0);
	    },
	
	    // Displace note by `x` pixels. Used by the formatter.
	    setXShift: function(x) { this.x_shift = x; return this; },
	    getXShift: function() { return this.x_shift; },
	
	    // Get `X` position of this tick context.
	    getX: function() {
	      if (!this.tickContext) throw new Vex.RERR("NoTickContext",
	          "Note needs a TickContext assigned for an X-Value");
	      return this.tickContext.getX() + this.x_shift;
	    },
	
	    // Get the absolute `X` position of this note's tick context. This
	    // excludes x_shift, so you'll need to factor it in if you're
	    // looking for the post-formatted x-position.
	    getAbsoluteX: function() {
	      if (!this.tickContext) throw new Vex.RERR("NoTickContext",
	          "Note needs a TickContext assigned for an X-Value");
	
	      // Position note to left edge of tick context.
	      var x = this.tickContext.getX();
	      if (this.stave) {
	        x += this.stave.getNoteStartX() + this.render_options.stave_padding;
	      }
	
	      if (this.isCenterAligned()){
	        x += this.getCenterXShift();
	      }
	
	      return x;
	    },
	
	    setPreFormatted: function(value) {
	      this.preFormatted = value;
	
	      // Maintain the width of left and right modifiers in pixels.
	      if (this.preFormatted) {
	        var extra = this.tickContext.getExtraPx();
	        this.left_modPx = Math.max(this.left_modPx, extra.left);
	        this.right_modPx = Math.max(this.right_modPx, extra.right);
	      }
	    }
	  });
	
	  return Note;
	}());
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements `NoteHeads`. `NoteHeads` are typically not manipulated
	// directly, but used internally in `StaveNote`.
	//
	// See `tests/notehead_tests.js` for usage examples.
	Vex.Flow.NoteHead = (function() {
	  var NoteHead = function(head_options) {
	    if (arguments.length > 0) this.init(head_options);
	  };
	
	  // To enable logging for this class. Set `Vex.Flow.NoteHead.DEBUG` to `true`.
	  function L() { if (NoteHead.DEBUG) Vex.L("Vex.Flow.NoteHead", arguments); }
	
	
	  // Draw slashnote head manually. No glyph exists for this.
	  //
	  // Parameters:
	  // * `ctx`: the Canvas context
	  // * `duration`: the duration of the note. ex: "4"
	  // * `x`: the x coordinate to draw at
	  // * `y`: the y coordinate to draw at
	  // * `stem_direction`: the direction of the stem
	  function drawSlashNoteHead(ctx, duration, x, y, stem_direction) {
	    var width = 15 + (Vex.Flow.STEM_WIDTH / 2);
	    ctx.save();
	    ctx.setLineWidth(Vex.Flow.STEM_WIDTH);
	
	    var fill = false;
	
	    if (Vex.Flow.durationToNumber(duration) > 2) {
	      fill = true;
	    }
	
	    if (!fill) x -= (Vex.Flow.STEM_WIDTH / 2) * stem_direction;
	
	    ctx.beginPath();
	    ctx.moveTo(x, y + 11);
	    ctx.lineTo(x, y + 1);
	    ctx.lineTo(x + width, y - 10);
	    ctx.lineTo(x + width, y);
	    ctx.lineTo(x, y + 11);
	    ctx.closePath();
	
	    if (fill) {
	       ctx.fill();
	    } else {
	       ctx.stroke();
	    }
	
	    if (Vex.Flow.durationToFraction(duration).equals(0.5)) {
	      var breve_lines = [-3, -1, width + 1, width + 3];
	      for(var i=0; i<breve_lines.length; i++){
	          ctx.beginPath();
	          ctx.moveTo(x + breve_lines[i], y - 10);
	          ctx.lineTo(x + breve_lines[i], y + 11);
	          ctx.stroke();
	      }
	    }
	
	    ctx.restore();
	  }
	
	  // ## Prototype Methods
	  Vex.Inherit(NoteHead, Vex.Flow.Note, {
	    init: function(head_options) {
	      NoteHead.superclass.init.call(this, head_options);
	      this.index = head_options.index;
	      this.x = head_options.x || 0;
	      this.y = head_options.y || 0;
	      this.note_type = head_options.note_type;
	      this.duration = head_options.duration;
	      this.displaced = head_options.displaced || false;
	      this.stem_direction = head_options.stem_direction || Vex.Flow.StaveNote.STEM_UP;
	      this.line = head_options.line;
	
	      // Get glyph code based on duration and note type. This could be
	      // regular notes, rests, or other custom codes.
	      this.glyph = Vex.Flow.durationToGlyph(this.duration, this.note_type);
	      if (!this.glyph) {
	        throw new Vex.RuntimeError("BadArguments",
	            "No glyph found for duration '" + this.duration +
	            "' and type '" + this.note_type + "'");
	      }
	
	      this.glyph_code = this.glyph.code_head;
	      this.x_shift = head_options.x_shift;
	      if (head_options.custom_glyph_code) {
	        this.custom_glyph = true;
	        this.glyph_code = head_options.custom_glyph_code;
	      }
	
	      this.context = null;
	      this.style = head_options.style;
	      this.slashed = head_options.slashed;
	
	      Vex.Merge(this.render_options, {
	        glyph_font_scale: 35, // font size for note heads
	        stroke_px: 3         // number of stroke px to the left and right of head
	      });
	
	      if (head_options.glyph_font_scale) {
	        this.render_options.glyph_font_scale = head_options.glyph_font_scale;
	      }
	
	      this.setWidth(this.glyph.head_width);
	    },
	
	    // Get the `ModifierContext` category
	    getCategory: function() { return "notehead"; },
	
	    // Set the Cavnas context for drawing
	    setContext: function(context) { this.context = context; return this;},
	
	    // Get the width of the notehead
	    getWidth: function() { return this.width; },
	
	    // Determine if the notehead is displaced
	    isDisplaced: function() { return this.displaced === true; },
	
	    // Get/set the notehead's style
	    //
	    // `style` is an `object` with the following properties: `shadowColor`,
	    // `shadowBlur`, `fillStyle`, `strokeStyle`
	    getStyle: function() { return this.style; },
	    setStyle: function(style) { this.style = style; return this; },
	
	    // Get the glyph data
	    getGlyph: function(){ return this.glyph; },
	
	    // Set the X coordinate
	    setX: function(x){ this.x = x; return this; },
	
	    // get/set the Y coordinate
	    getY: function() { return this.y; },
	    setY: function(y) { this.y = y;  return this; },
	
	    // Get/set the stave line the notehead is placed on
	    getLine: function() { return this.line; },
	    setLine: function(line) { this.line = line; return this; },
	
	    // Get the canvas `x` coordinate position of the notehead.
	    getAbsoluteX: function() {
	      var getAbsoluteX = NoteHead.superclass.getAbsoluteX;
	
	      // If the note has not been preformatted, then get the static x value
	      // Otherwise, it's been formatted and we should use it's x value relative
	      // to its tick context
	      var x = !this.preFormatted ? this.x : getAbsoluteX.call(this);
	
	      return x + (this.displaced ? this.width * this.stem_direction : 0);
	    },
	
	    // Get the `BoundingBox` for the `NoteHead`
	    getBoundingBox: function() {
	      if (!this.preFormatted) throw new Vex.RERR("UnformattedNote",
	          "Can't call getBoundingBox on an unformatted note.");
	
	      var spacing = this.stave.getSpacingBetweenLines();
	      var half_spacing = spacing/2;
	      var min_y = this.y - half_spacing;
	
	      return new Vex.Flow.BoundingBox(this.getAbsoluteX(), min_y, this.width, spacing);
	    },
	
	    // Apply current style to Canvas `context`
	    applyStyle: function(context) {
	      var style = this.getStyle();
	      if (style.shadowColor) context.setShadowColor(style.shadowColor);
	      if (style.shadowBlur) context.setShadowBlur(style.shadowBlur);
	      if (style.fillStyle) context.setFillStyle(style.fillStyle);
	      if (style.strokeStyle) context.setStrokeStyle(style.strokeStyle);
	      return this;
	    },
	
	    // Set notehead to a provided `stave`
	    setStave: function(stave){
	      var line = this.getLine();
	
	      this.stave = stave;
	      this.setY(stave.getYForNote(line));
	      this.context = this.stave.context;
	      return this;
	    },
	
	    // Pre-render formatting
	    preFormat: function() {
	      if (this.preFormatted) return this;
	
	      var glyph = this.getGlyph();
	      var width = glyph.head_width + this.extraLeftPx + this.extraRightPx;
	
	      this.setWidth(width);
	      this.setPreFormatted(true);
	      return this;
	    },
	
	    // Draw the notehead
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw without a canvas context.");
	
	      var ctx = this.context;
	      var head_x = this.getAbsoluteX();
	      var y = this.y;
	
	      L("Drawing note head '", this.note_type, this.duration, "' at", head_x, y);
	
	      // Begin and end positions for head.
	      var stem_direction = this.stem_direction;
	      var glyph_font_scale = this.render_options.glyph_font_scale;
	
	      var line = this.line;
	
	      // If note above/below the staff, draw the small staff
	      if (line <= 0 || line >= 6) {
	        var line_y = y;
	        var floor = Math.floor(line);
	        if (line < 0 && floor - line == -0.5)
	          line_y -= 5;
	        else if (line > 6 &&  floor - line == -0.5)
	          line_y += 5;
	        if (this.note_type != 'r') {
	          ctx.fillRect(
	            head_x - this.render_options.stroke_px, line_y,
	            (this.getGlyph().head_width) +
	            (this.render_options.stroke_px * 2), 1);
	        }
	      }
	
	      if (this.note_type == "s") {
	        drawSlashNoteHead(ctx, this.duration,
	          head_x, y, stem_direction);
	      } else {
	        if (this.style) {
	          ctx.save();
	          this.applyStyle(ctx);
	          Vex.Flow.renderGlyph(ctx, head_x, y, glyph_font_scale, this.glyph_code);
	          ctx.restore();
	        } else {
	          Vex.Flow.renderGlyph(ctx, head_x, y, glyph_font_scale, this.glyph_code);
	        }
	      }
	    }
	  });
	
	  return NoteHead;
	}());
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements the `Stem` object. Generally this object is handled
	// by its parent `StemmableNote`.
	//
	Vex.Flow.Stem = (function() {
	  var Stem = function(options) {
	    if (arguments.length > 0) this.init(options);
	  };
	
	  // To enable logging for this class. Set `Vex.Flow.Stem.DEBUG` to `true`.
	  function L() { if (Stem.DEBUG) Vex.L("Vex.Flow.Stem", arguments); }
	
	  // Stem directions
	  Stem.UP = 1;
	  Stem.DOWN = -1;
	
	  // Theme
	  Stem.WIDTH = Vex.Flow.STEM_WIDTH;
	  Stem.HEIGHT = Vex.Flow.STEM_HEIGHT;
	
	  // ## Prototype Methods
	  Stem.prototype = {
	    init: function(options) {
	      // Default notehead x bounds
	      this.x_begin = options.x_begin || 0;
	      this.x_end = options.x_end || 0;
	
	      // Y bounds for top/bottom most notehead
	      this.y_top = options.y_top || 0;
	      this.y_bottom = options.y_bottom || 0;
	
	      // Stem base extension
	      this.y_extend = options.y_extend || 0;
	      // Stem top extension
	      this.stem_extension = options.stem_extension || 0;
	
	      // Direction of the stem
	      this.stem_direction = options.stem_direction || 0;
	
	      // Flag to override all draw calls
	      this.hide = false;
	    },
	
	    // Set the x bounds for the default notehead
	    setNoteHeadXBounds: function(x_begin, x_end) {
	      this.x_begin = x_begin;
	      this.x_end = x_end;
	      return this;
	    },
	
	    // Set the direction of the stem in relation to the noteheads
	    setDirection: function(direction){ this.stem_direction = direction; },
	
	    // Set the extension for the stem, generally for flags or beams
	    setExtension: function(ext) { this.stem_extension = ext; },
	
	    // The the y bounds for the top and bottom noteheads
	    setYBounds: function(y_top, y_bottom) {
	      this.y_top = y_top;
	      this.y_bottom = y_bottom;
	    },
	
	    // The category of the object
	    getCategory: function() { return "stem"; },
	
	    // Set the canvas context to render on
	    setContext: function(context) { this.context = context; return this;},
	
	    // Gets the entire height for the stem
	    getHeight: function() {
	      return ((this.y_bottom - this.y_top) * this.stem_direction) +
	             ((Stem.HEIGHT + this.stem_extension) * this.stem_direction);
	    },
	
	    getBoundingBox: function() {
	      throw new Vex.RERR("NotImplemented", "getBoundingBox() not implemented.");
	    },
	
	    // Get the y coordinates for the very base of the stem to the top of
	    // the extension
	    getExtents: function() {
	      var ys = [this.y_top, this.y_bottom];
	
	      var top_pixel = this.y_top;
	      var base_pixel = this.y_bottom;
	      var stem_height = Stem.HEIGHT + this.stem_extension;
	
	      for (var i = 0; i < ys.length; ++i) {
	        var stem_top = ys[i] + (stem_height * -this.stem_direction);
	
	        if (this.stem_direction == Stem.DOWN) {
	          top_pixel = Math.max(top_pixel, stem_top);
	          base_pixel = Math.min(base_pixel, ys[i]);
	        } else {
	          top_pixel = Math.min(top_pixel, stem_top);
	          base_pixel = Math.max(base_pixel, ys[i]);
	        }
	      }
	
	      return { topY: top_pixel, baseY: base_pixel };
	    },
	
	    // set the draw style of a stem:
	    setStyle: function(style) { this.style = style; return this; },
	    getStyle: function() { return this.style; },
	
	    // Apply current style to Canvas `context`
	    applyStyle: function(context) {
	      var style = this.getStyle();
	      if(style) {
	        if (style.shadowColor) context.setShadowColor(style.shadowColor);
	        if (style.shadowBlur) context.setShadowBlur(style.shadowBlur);
	        if (style.strokeStyle) context.setStrokeStyle(style.strokeStyle);
	      }
	      return this;
	    },
	
	    // Render the stem onto the canvas
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw without a canvas context.");
	
	      if (this.hide) return;
	
	      var ctx = this.context;
	      var stem_x, stem_y;
	      var stem_direction = this.stem_direction;
	
	      if (stem_direction == Stem.DOWN) {
	        // Down stems are rendered to the left of the head.
	        stem_x = this.x_begin + (Stem.WIDTH / 2);
	        stem_y = this.y_top + 2;
	      } else {
	        // Up stems are rendered to the right of the head.
	        stem_x = this.x_end + (Stem.WIDTH / 2);
	        stem_y = this.y_bottom - 2;
	      }
	
	      stem_y += this.y_extend * stem_direction;
	
	      L("Rendering stem - ", "Top Y: ", this.y_top, "Bottom Y: ", this.y_bottom);
	
	      // Draw the stem
	      ctx.save();
	      this.applyStyle(ctx);
	      ctx.beginPath();
	      ctx.setLineWidth(Stem.WIDTH);
	      ctx.moveTo(stem_x, stem_y);
	      ctx.lineTo(stem_x, stem_y - this.getHeight());
	      ctx.stroke();
	      ctx.restore();
	    }
	  };
	
	  return Stem;
	}());
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// `StemmableNote` is an abstract interface for notes with optional stems.
	// Examples of stemmable notes are `StaveNote` and `TabNote`
	Vex.Flow.StemmableNote = (function(){
	  var StemmableNote = function(note_struct) {
	    if (arguments.length > 0) this.init(note_struct);
	  };
	
	  // To enable logging for this class. Set `Vex.Flow.StemmableNote.DEBUG` to `true`.
	  function L() { if (StemmableNote.DEBUG) Vex.L("Vex.Flow.StemmableNote", arguments); }
	
	  var Stem = Vex.Flow.Stem;
	
	  Vex.Inherit(StemmableNote, Vex.Flow.Note, {
	    init: function(note_struct){
	      StemmableNote.superclass.init.call(this, note_struct);
	
	      this.stem = null;
	      this.stem_extension_override = null;
	      this.beam = null;
	
	    },
	
	    // Get and set the note's `Stem`
	    getStem: function() {return this.stem; },
	    setStem: function(stem) { this.stem = stem; return this; },
	
	    // Builds and sets a new stem
	    buildStem: function() {
	      var stem = new Stem();
	      this.setStem(stem);
	      return this;
	    },
	
	    // Get the full length of stem
	    getStemLength: function() {
	      return Stem.HEIGHT + this.getStemExtension();
	    },
	
	    // Get the number of beams for this duration
	    getBeamCount: function(){
	      var glyph = this.getGlyph();
	
	      if (glyph) {
	        return glyph.beam_count;
	      } else {
	        return 0;
	      }
	    },
	
	    // Get the minimum length of stem
	    getStemMinumumLength: function() {
	      var frac = Vex.Flow.durationToFraction(this.duration);
	      var length = (frac.value() <= 1) ? 0 : 20;
	      // if note is flagged, cannot shorten beam
	      switch (this.duration) {
	       case "8":
	         if (this.beam == null) length = 35;
	         break;
	       case "16":
	         if (this.beam == null)
	           length = 35;
	         else
	           length = 25;
	         break;
	       case "32":
	         if (this.beam == null)
	           length = 45;
	         else
	           length = 35;
	         break;
	       case "64":
	         if (this.beam == null)
	           length = 50;
	         else
	           length = 40;
	         break;
	       case "128":
	         if (this.beam == null)
	           length = 55;
	         else
	           length = 45;
	      }
	      return length;
	    },
	
	    // Get/set the direction of the stem
	    getStemDirection: function() { return this.stem_direction; },
	    setStemDirection: function(direction) {
	      if (!direction) direction = Stem.UP;
	      if (direction != Stem.UP &&
	          direction != Stem.DOWN) {
	        throw new Vex.RERR("BadArgument", "Invalid stem direction: " +
	            direction);
	      }
	
	      this.stem_direction = direction;
	      if (this.stem) {
	        this.stem.setDirection(direction);
	        this.stem.setExtension(this.getStemExtension());
	      }
	
	      this.beam = null;
	      if (this.preFormatted) {
	        this.preFormat();
	      }
	      return this;
	    },
	
	    // Get the `x` coordinate of the stem
	    getStemX: function() {
	      var x_begin = this.getAbsoluteX() + this.x_shift;
	      var x_end = this.getAbsoluteX() + this.x_shift + this.glyph.head_width;
	
	      var stem_x = this.stem_direction == Stem.DOWN ?
	        x_begin : x_end;
	
	      stem_x -= ((Stem.WIDTH / 2) * this.stem_direction);
	
	      return stem_x;
	    },
	
	    // Get the `x` coordinate for the center of the glyph.
	    // Used for `TabNote` stems and stemlets over rests
	    getCenterGlyphX: function(){
	      return this.getAbsoluteX() + this.x_shift + (this.glyph.head_width / 2);
	    },
	
	    // Get the stem extension for the current duration
	    getStemExtension: function(){
	      var glyph = this.getGlyph();
	
	      if (this.stem_extension_override != null) {
	        return this.stem_extension_override;
	      }
	
	      if (glyph) {
	        return this.getStemDirection() === 1 ? glyph.stem_up_extension :
	          glyph.stem_down_extension;
	      }
	
	      return 0;
	    },
	
	    // Set the stem length to a specific. Will override the default length.
	    setStemLength: function(height) {
	      this.stem_extension_override = (height - Stem.HEIGHT);
	      return this;
	    },
	
	    // Get the top and bottom `y` values of the stem.
	    getStemExtents: function() {
	      if (!this.ys || this.ys.length === 0) throw new Vex.RERR("NoYValues",
	          "Can't get top stem Y when note has no Y values.");
	
	      var top_pixel = this.ys[0];
	      var base_pixel = this.ys[0];
	      var stem_height = Stem.HEIGHT + this.getStemExtension();
	
	      for (var i = 0; i < this.ys.length; ++i) {
	        var stem_top = this.ys[i] + (stem_height * -this.stem_direction);
	
	        if (this.stem_direction == Stem.DOWN) {
	          top_pixel = Math.max(top_pixel, stem_top);
	          base_pixel = Math.min(base_pixel, this.ys[i]);
	        } else {
	          top_pixel = Math.min(top_pixel, stem_top);
	          base_pixel = Math.max(base_pixel, this.ys[i]);
	        }
	
	        if(this.noteType == "s" || this.noteType == 'x') {
	          top_pixel -= this.stem_direction * 7;
	          base_pixel -= this.stem_direction * 7;
	        }
	      }
	
	      L("Stem extents: ", top_pixel, base_pixel);
	      return { topY: top_pixel, baseY: base_pixel };
	    },
	
	    // Sets the current note's beam
	    setBeam: function(beam) { this.beam = beam; return this; },
	
	    // Get the `y` value for the top/bottom modifiers at a specific `text_line`
	    getYForTopText: function(text_line) {
	      var extents = this.getStemExtents();
	      if (this.hasStem()) {
	        return Vex.Min(this.stave.getYForTopText(text_line),
	            extents.topY - (this.render_options.annotation_spacing * (text_line + 1)));
	      } else {
	        return this.stave.getYForTopText(text_line);
	      }
	    },
	
	    getYForBottomText: function(text_line) {
	      var extents = this.getStemExtents();
	      if (this.hasStem()) {
	        return Vex.Max(this.stave.getYForTopText(text_line),
	          extents.baseY + (this.render_options.annotation_spacing * (text_line)));
	      } else {
	        return this.stave.getYForBottomText(text_line);
	      }
	    },
	
	    hasFlag: function() {
	      return Vex.Flow.durationToGlyph(this.duration).flag;
	    },
	
	    // Post format the note
	    postFormat: function() {
	      if (this.beam) {
	        this.beam.postFormat();
	      }
	      this.postFormatted = true;
	      return this;
	    },
	
	    // Render the stem onto the canvas
	    drawStem: function(stem_struct){
	      if (!this.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw without a canvas context.");
	
	      this.setStem(new Stem(stem_struct));
	      this.stem.setContext(this.context).draw();
	    }
	  });
	
	  return StemmableNote;
	}());
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements notes for standard notation. This consists of one or
	// more `NoteHeads`, an optional stem, and an optional flag.
	//
	// *Throughout these comments, a "note" refers to the entire `StaveNote`,
	// and a "key" refers to a specific pitch/notehead within a note.*
	//
	// See `tests/stavenote_tests.js` for usage examples.
	Vex.Flow.StaveNote = (function() {
	  var StaveNote = function(note_struct) {
	    if (arguments.length > 0) this.init(note_struct);
	  };
	  StaveNote.CATEGORY = "stavenotes";
	
	  // To enable logging for this class. Set `Vex.Flow.StaveNote.DEBUG` to `true`.
	  function L() { if (StaveNote.DEBUG) Vex.L("Vex.Flow.StaveNote", arguments); }
	
	  var Stem = Vex.Flow.Stem;
	  var NoteHead = Vex.Flow.NoteHead;
	
	  // Stem directions
	  StaveNote.STEM_UP = Stem.UP;
	  StaveNote.STEM_DOWN = Stem.DOWN;
	
	  // Helper methods for rest positioning in ModifierContext.
	  var shiftRestVertical = function(rest, note, dir) {
	    var delta = (note.isrest ? 0.0 : 1.0) * dir;
	
	    rest.line += delta;
	    rest.max_line += delta;
	    rest.min_line += delta;
	    rest.note.setKeyLine(0, rest.note.getKeyLine(0) + (delta));
	  };
	
	  // Called from formatNotes :: center a rest between two notes
	  var centerRest = function(rest, noteU, noteL) {
	    var delta = rest.line - Vex.MidLine(noteU.min_line, noteL.max_line);
	    rest.note.setKeyLine(0, rest.note.getKeyLine(0) - delta);
	    rest.line -= delta;
	    rest.max_line -= delta;
	    rest.min_line -= delta;
	  };
	
	  // ## Static Methods
	  //
	  // Format notes inside a ModifierContext.
	  StaveNote.format = function(notes, state) {
	    if (!notes || notes.length < 2) return false;
	
	    if (notes[0].getStave() != null) return StaveNote.formatByY(notes, state);
	
	    var notes_list= [];
	
	    for (var i = 0; i < notes.length; i++) {
	      var props = notes[i].getKeyProps();
	      var line = props[0].line;
	      var minL = props[props.length -1].line;
	      var stem_dir = notes[i].getStemDirection();
	      var stem_max = notes[i].getStemLength() / 10;
	      var stem_min = notes[i].getStemMinumumLength() / 10;
	
	      var maxL;
	      if (notes[i].isRest()) {
	        maxL = line + notes[i].glyph.line_above;
	        minL = line - notes[i].glyph.line_below;
	      } else {
	        maxL = stem_dir == 1 ? props[props.length -1].line + stem_max
	             : props[props.length -1].line;
	        minL = stem_dir == 1 ? props[0].line
	             : props[0].line - stem_max;
	      }
	      notes_list.push(
	        {line: props[0].line,         // note/rest base line
	         max_line: maxL,              // note/rest upper bounds line
	         min_line: minL,              // note/rest lower bounds line
	         isrest: notes[i].isRest(),
	         stem_dir: stem_dir,
	         stem_max: stem_max,          // Maximum (default) note stem length;
	         stem_min: stem_min,          // minimum note stem length
	         voice_shift: notes[i].getVoiceShiftWidth(),
	         is_displaced: notes[i].isDisplaced(),   // note manually displaced
	         note: notes[i]});
	    }
	
	    var voices = notes_list.length;
	
	    var noteU = notes_list[0];
	    var noteM = voices > 2 ? notes_list[1] : null;
	    var noteL = voices > 2 ? notes_list[2] : notes_list[1];
	
	    // for two voice backward compatibility, ensure upper voice is stems up
	    // for three voices, the voices must be in order (upper, middle, lower)
	    if (voices == 2 && noteU.stem_dir == -1 && noteL.stem_dir == 1) {
	      noteU = notes_list[1];
	      noteL = notes_list[0];
	    }
	
	    var voice_x_shift = Math.max(noteU.voice_shift, noteL.voice_shift);
	    var x_shift = 0;
	    var stem_delta;
	
	    // Test for two voice note intersection
	    if (voices == 2) {
	      var line_spacing = noteU.stem_dir == noteL.stem_dir ? 0.0 : 0.5;
	      // if top voice is a middle voice, check stem intersection with lower voice
	      if (noteU.stem_dir == noteL.stem_dir &&
	          noteU.min_line <= noteL.max_line) {
	        if (!noteU.isrest) {
	          stem_delta = Math.abs(noteU.line - (noteL.max_line + 0.5));
	          stem_delta = Math.max(stem_delta, noteU.stem_min);
	          noteU.min_line = noteU.line - stem_delta;
	          noteU.note.setStemLength(stem_delta * 10);
	        }
	      }
	      if (noteU.min_line <= noteL.max_line + line_spacing) {
	        if (noteU.isrest) {
	          // shift rest up
	          shiftRestVertical(noteU, noteL, 1);
	        } else if (noteL.isrest) {
	          // shift rest down
	          shiftRestVertical(noteL, noteU, -1);
	        } else {
	          x_shift = voice_x_shift;
	          if (noteU.stem_dir == noteL.stem_dir)
	            // upper voice is middle voice, so shift it right
	            noteU.note.setXShift(x_shift + 3);
	          else
	            // shift lower voice right
	            noteL.note.setXShift(x_shift);
	        }
	      }
	
	      // format complete
	      return true;
	    }
	
	    // Check middle voice stem intersection with lower voice
	    if (noteM != null && noteM.min_line < noteL.max_line + 0.5) {
	      if (!noteM.isrest) {
	        stem_delta = Math.abs(noteM.line - (noteL.max_line + 0.5));
	        stem_delta = Math.max(stem_delta, noteM.stem_min);
	        noteM.min_line = noteM.line - stem_delta;
	        noteM.note.setStemLength(stem_delta * 10);
	      }
	    }
	
	    // For three voices, test if rests can be repositioned
	    //
	    // Special case 1 :: middle voice rest between two notes
	    //
	    if (noteM.isrest && !noteU.isrest && !noteL.isrest) {
	      if (noteU.min_line <= noteM.max_line ||
	          noteM.min_line <= noteL.max_line) {
	         var rest_height = noteM.max_line - noteM.min_line;
	         var space = noteU.min_line - noteL.max_line;
	         if (rest_height < space)
	           // center middle voice rest between the upper and lower voices
	           centerRest(noteM, noteU, noteL);
	         else {
	           x_shift = voice_x_shift + 3;    // shift middle rest right
	           noteM.note.setXShift(x_shift);
	         }
	         // format complete
	         return true;
	      }
	    }
	
	    // Special case 2 :: all voices are rests
	    if (noteU.isrest && noteM.isrest && noteL.isrest) {
	      // Shift upper voice rest up
	      shiftRestVertical(noteU, noteM, 1);
	      // Shift lower voice rest down
	      shiftRestVertical(noteL, noteM, -1);
	      // format complete
	      return true;
	    }
	
	    // Test if any other rests can be repositioned
	    if (noteM.isrest && noteU.isrest && noteM.min_line <= noteL.max_line)
	      // Shift middle voice rest up
	      shiftRestVertical(noteM, noteL, 1);
	    if (noteM.isrest && noteL.isrest && noteU.min_line <= noteM.max_line)
	      // Shift middle voice rest down
	      shiftRestVertical(noteM, noteU, -1);
	    if (noteU.isrest && noteU.min_line <= noteM.max_line)
	      // shift upper voice rest up;
	      shiftRestVertical(noteU, noteM, 1);
	    if (noteL.isrest && noteM.min_line <= noteL.max_line)
	      // shift lower voice rest down
	      shiftRestVertical(noteL, noteM, -1);
	
	    // If middle voice intersects upper or lower voice
	    if ((!noteU.isrest && !noteM.isrest && noteU.min_line <= noteM.max_line + 0.5) ||
	        (!noteM.isrest && !noteL.isrest && noteM.min_line <= noteL.max_line)) {
	      x_shift = voice_x_shift + 3;      // shift middle note right
	      noteM.note.setXShift(x_shift);
	    }
	
	    return true;
	  };
	
	  StaveNote.formatByY = function(notes, state) {
	    // NOTE: this function does not support more than two voices per stave
	    //       use with care.
	    var hasStave = true;
	    var i;
	
	    for (i = 0; i < notes.length; i++) {
	      hasStave = hasStave && notes[i].getStave() != null;
	    }
	
	    if (!hasStave) throw new Vex.RERR("Stave Missing",
	      "All notes must have a stave - Vex.Flow.ModifierContext.formatMultiVoice!");
	
	    var x_shift = 0;
	
	    for (i = 0; i < notes.length - 1; i++) {
	      var top_note = notes[i];
	      var bottom_note = notes[i + 1];
	
	      if (top_note.getStemDirection() == Vex.Flow.StaveNote.STEM_DOWN) {
	        top_note = notes[i + 1];
	        bottom_note = notes[i];
	      }
	
	      var top_keys = top_note.getKeyProps();
	      var bottom_keys = bottom_note.getKeyProps();
	
	      var topY = top_note.getStave().getYForLine(top_keys[0].line);
	      var bottomY = bottom_note.getStave().getYForLine(bottom_keys[bottom_keys.length - 1].line);
	
	      var line_space = top_note.getStave().options.spacing_between_lines_px;
	      if (Math.abs(topY - bottomY) == line_space / 2) {
	        x_shift = top_note.getVoiceShiftWidth();
	        bottom_note.setXShift(x_shift);
	      }
	    }
	
	    state.right_shift += x_shift;
	  };
	
	  StaveNote.postFormat = function(notes) {
	    if (!notes) return false;
	
	    notes.forEach(function(note) {
	      note.postFormat();
	    });
	
	    return true;
	  };
	
	  // ## Prototype Methods
	  //
	  Vex.Inherit(StaveNote, Vex.Flow.StemmableNote, {
	    init: function(note_struct) {
	      StaveNote.superclass.init.call(this, note_struct);
	
	      this.keys = note_struct.keys;
	      this.clef = note_struct.clef;
	      this.octave_shift = note_struct.octave_shift;
	      this.beam = null;
	
	      // Pull note rendering properties
	      this.glyph = Vex.Flow.durationToGlyph(this.duration, this.noteType);
	      if (!this.glyph) {
	        throw new Vex.RuntimeError("BadArguments",
	            "Invalid note initialization data (No glyph found): " +
	            JSON.stringify(note_struct));
	      }
	
	      // if true, displace note to right
	      this.displaced = false;
	      this.dot_shiftY = 0;
	      // per-pitch properties
	      this.keyProps = [];
	      // for displaced ledger lines
	      this.use_default_head_x = false;
	
	      // Drawing
	      this.note_heads = [];
	      this.modifiers = [];
	
	      Vex.Merge(this.render_options, {
	        // font size for note heads and rests
	        glyph_font_scale: 35,
	        // number of stroke px to the left and right of head
	        stroke_px: 3
	      });
	
	      this.calculateKeyProps();
	
	      this.buildStem();
	
	      // Set the stem direction
	      if (note_struct.auto_stem) {
	        this.autoStem();
	      } else {
	        this.setStemDirection(note_struct.stem_direction);
	      }
	
	      this.buildNoteHeads();
	
	      // Calculate left/right padding
	      this.calcExtraPx();
	    },
	
	    // Builds a `Stem` for the note
	    buildStem: function() {
	      var glyph = this.getGlyph();
	
	      var y_extend = 0;
	      if (glyph.code_head == "v95" || glyph.code_head == "v3e") {
	         y_extend = -4;
	      }
	
	      var stem = new Stem({
	        y_extend: y_extend
	      });
	
	      if (this.isRest()) {
	        stem.hide = true;
	      }
	
	      this.setStem(stem);
	    },
	
	    // Builds a `NoteHead` for each key in the note
	    buildNoteHeads: function() {
	      var stem_direction = this.getStemDirection();
	
	      var keys = this.getKeys();
	
	      var last_line = null;
	      var line_diff = null;
	      var displaced = false;
	
	      // Draw notes from bottom to top.
	      var start_i = 0;
	      var end_i = keys.length;
	      var step_i = 1;
	
	      // For down-stem notes, we draw from top to bottom.
	      if (stem_direction === Stem.DOWN) {
	        start_i = keys.length - 1;
	        end_i = -1;
	        step_i = -1;
	      }
	
	      for (var i = start_i; i != end_i; i += step_i) {
	        var note_props = this.keyProps[i];
	
	        var line = note_props.line;
	
	        // Keep track of last line with a note head, so that consecutive heads
	        // are correctly displaced.
	        if (last_line === null) {
	          last_line = line;
	        } else {
	          line_diff = Math.abs(last_line - line);
	          if (line_diff === 0 || line_diff === 0.5) {
	            displaced = !displaced;
	          } else {
	            displaced = false;
	            this.use_default_head_x = true;
	          }
	        }
	        last_line = line;
	
	        var note_head = new NoteHead({
	          duration: this.duration,
	          note_type: this.noteType,
	          displaced: displaced,
	          stem_direction: stem_direction,
	          custom_glyph_code: note_props.code,
	          glyph_font_scale: this.render_options.glyph_font_scale,
	          x_shift: note_props.shift_right,
	          line: note_props.line
	        });
	
	        this.note_heads[i] = note_head;
	      }
	    },
	
	    // Automatically sets the stem direction based on the keys in the note
	    autoStem: function() {
	      var auto_stem_direction;
	
	      // Figure out optimal stem direction based on given notes
	      this.min_line = this.keyProps[0].line;
	      this.max_line = this.keyProps[this.keyProps.length - 1].line;
	      var decider = (this.min_line + this.max_line) / 2;
	
	      if (decider < 3) {
	        auto_stem_direction = 1;
	      } else {
	        auto_stem_direction = -1;
	      }
	
	      this.setStemDirection(auto_stem_direction);
	    },
	
	    // Calculates and stores the properties for each key in the note
	    calculateKeyProps: function() {
	      var last_line = null;
	      for (var i = 0; i < this.keys.length; ++i) {
	        var key = this.keys[i];
	
	        // All rests use the same position on the line.
	        // if (this.glyph.rest) key = this.glyph.position;
	        if (this.glyph.rest) this.glyph.position = key;
	        var options = { octave_shift: this.octave_shift || 0 };
	        var props = Vex.Flow.keyProperties(key, this.clef, options);
	        if (!props) {
	          throw new Vex.RuntimeError("BadArguments",
	              "Invalid key for note properties: " + key);
	        }
	
	        // Override line placement for default rests
	        if (props.key === "R") {
	          if (this.duration === "1" || this.duration === "w") {
	            props.line = 4;
	          } else {
	            props.line = 3;
	          }
	        }
	
	        // Calculate displacement of this note
	        var line = props.line;
	        if (last_line === null) {
	          last_line = line;
	        } else {
	          if (Math.abs(last_line - line) == 0.5) {
	            this.displaced = true;
	            props.displaced = true;
	
	            // Have to mark the previous note as
	            // displaced as well, for modifier placement
	            if (this.keyProps.length > 0) {
	                this.keyProps[i-1].displaced = true;
	            }
	          }
	        }
	
	        last_line = line;
	        this.keyProps.push(props);
	      }
	
	      // Sort the notes from lowest line to highest line
	      var sorted = true;
	      var lastLine = -1000;
	      var that = this;
	      this.keyProps.forEach(function(key) {
	        if (key.line < lastLine) {
	          Vex.W("Unsorted keys in note will be sorted. " +
	            "See https://github.com/0xfe/vexflow/issues/104 for details.");
	        }
	        lastLine = key.line;
	      });
	      this.keyProps.sort(function(a, b) { return a.line - b.line; });
	    },
	
	    // Get the `BoundingBox` for the entire note
	    getBoundingBox: function() {
	      if (!this.preFormatted) throw new Vex.RERR("UnformattedNote",
	          "Can't call getBoundingBox on an unformatted note.");
	
	      var metrics = this.getMetrics();
	
	      var w = metrics.width;
	      var x = this.getAbsoluteX() - metrics.modLeftPx - metrics.extraLeftPx;
	
	      var min_y = 0;
	      var max_y = 0;
	      var half_line_spacing = this.getStave().getSpacingBetweenLines() / 2;
	      var line_spacing = half_line_spacing * 2;
	
	      if (this.isRest()) {
	        var y = this.ys[0];
	        var frac = Vex.Flow.durationToFraction(this.duration);
	        if (frac.equals(1) || frac.equals(2)) {
	          min_y = y - half_line_spacing;
	          max_y = y + half_line_spacing;
	        } else {
	          min_y = y - (this.glyph.line_above * line_spacing);
	          max_y = y + (this.glyph.line_below * line_spacing);
	        }
	      } else if (this.glyph.stem) {
	        var ys = this.getStemExtents();
	        ys.baseY += half_line_spacing * this.stem_direction;
	        min_y = Vex.Min(ys.topY, ys.baseY);
	        max_y = Vex.Max(ys.topY, ys.baseY);
	      } else {
	        min_y = null;
	        max_y = null;
	
	        for (var i=0; i < this.ys.length; ++i) {
	          var yy = this.ys[i];
	          if (i === 0) {
	            min_y = yy;
	            max_y = yy;
	          } else {
	            min_y = Vex.Min(yy, min_y);
	            max_y = Vex.Max(yy, max_y);
	          }
	          min_y -= half_line_spacing;
	          max_y += half_line_spacing;
	        }
	      }
	
	      return new Vex.Flow.BoundingBox(x, min_y, w, max_y - min_y);
	    },
	
	    // Gets the line number of the top or bottom note in the chord.
	    // If `is_top_note` is `true` then get the top note
	    getLineNumber: function(is_top_note) {
	      if(!this.keyProps.length) throw new Vex.RERR("NoKeyProps",
	          "Can't get bottom note line, because note is not initialized properly.");
	      var result_line = this.keyProps[0].line;
	
	      // No precondition assumed for sortedness of keyProps array
	      for (var i=0; i<this.keyProps.length; i++) {
	        var this_line = this.keyProps[i].line;
	        if (is_top_note) {
	          if (this_line > result_line) result_line = this_line;
	        } else {
	          if (this_line < result_line) result_line = this_line;
	        }
	      }
	
	      return result_line;
	    },
	
	    // Determine if current note is a rest
	    isRest: function() { return this.glyph.rest; },
	
	    // Determine if the current note is a chord
	    isChord: function() { return !this.isRest() && this.keys.length > 1; },
	
	    // Determine if the `StaveNote` has a stem
	    hasStem: function() { return this.glyph.stem; },
	
	    // Get the `y` coordinate for text placed on the top/bottom of a
	    // note at a desired `text_line`
	    getYForTopText: function(text_line) {
	      var extents = this.getStemExtents();
	      return Vex.Min(this.stave.getYForTopText(text_line),
	          extents.topY - (this.render_options.annotation_spacing * (text_line + 1)));
	    },
	    getYForBottomText: function(text_line) {
	      var extents = this.getStemExtents();
	      return Vex.Max(this.stave.getYForTopText(text_line),
	          extents.baseY + (this.render_options.annotation_spacing * (text_line)));
	    },
	
	    // Sets the current note to the provided `stave`. This applies
	    // `y` values to the `NoteHeads`.
	    setStave: function(stave) {
	      var superclass = Vex.Flow.StaveNote.superclass;
	      superclass.setStave.call(this, stave);
	
	      var ys = this.note_heads.map(function(note_head) {
	        note_head.setStave(stave);
	        return note_head.getY();
	      });
	
	      this.setYs(ys);
	
	      var bounds = this.getNoteHeadBounds();
		    if (this.hasStem()) {
	        this.stem.setYBounds(bounds.y_top, bounds.y_bottom);
	      }
	
	      return this;
	    },
	
	    // Get the pitches in the note
	    getKeys: function() { return this.keys; },
	
	    // Get the properties for all the keys in the note
	    getKeyProps: function() {
	      return this.keyProps;
	    },
	
	    // Check if note is shifted to the right
	    isDisplaced: function() {
	      return this.displaced;
	    },
	
	    // Sets whether shift note to the right. `displaced` is a `boolean`
	    setNoteDisplaced: function(displaced) {
	      this.displaced = displaced;
	      return this;
	    },
	
	    // Get the starting `x` coordinate for a `StaveTie`
	    getTieRightX: function() {
	      var tieStartX = this.getAbsoluteX();
	      tieStartX += this.glyph.head_width + this.x_shift + this.extraRightPx;
	      if (this.modifierContext) tieStartX += this.modifierContext.getExtraRightPx();
	      return tieStartX;
	    },
	
	    // Get the ending `x` coordinate for a `StaveTie`
	    getTieLeftX: function() {
	      var tieEndX = this.getAbsoluteX();
	      tieEndX += this.x_shift - this.extraLeftPx;
	      return tieEndX;
	    },
	
	    // Get the stave line on which to place a rest
	    getLineForRest: function() {
	      var rest_line = this.keyProps[0].line;
	      if (this.keyProps.length > 1) {
	        var last_line  = this.keyProps[this.keyProps.length - 1].line;
	        var top = Vex.Max(rest_line, last_line);
	        var bot = Vex.Min(rest_line, last_line);
	        rest_line = Vex.MidLine(top, bot);
	      }
	
	      return rest_line;
	    },
	
	    // Get the default `x` and `y` coordinates for the provided `position`
	    // and key `index`
	    getModifierStartXY: function(position, index) {
	      if (!this.preFormatted) throw new Vex.RERR("UnformattedNote",
	          "Can't call GetModifierStartXY on an unformatted note");
	
	      if (this.ys.length === 0) throw new Vex.RERR("NoYValues",
	          "No Y-Values calculated for this note.");
	
	      var x = 0;
	      if (position == Vex.Flow.Modifier.Position.LEFT) {
	        // extra_left_px
	        x = -1 * 2;
	      } else if (position == Vex.Flow.Modifier.Position.RIGHT) {
	        // extra_right_px
	        x = this.glyph.head_width + this.x_shift + 2;
	      } else if (position == Vex.Flow.Modifier.Position.BELOW ||
	                 position == Vex.Flow.Modifier.Position.ABOVE) {
	        x = this.glyph.head_width / 2;
	      }
	
	      return { x: this.getAbsoluteX() + x, y: this.ys[index] };
	    },
	
	    // Sets the style of the complete StaveNote, including all keys
	    // and the stem.
	    setStyle: function(style) {
	      this.note_heads.forEach(function(notehead) {
	        notehead.setStyle(style);
	      }, this);
	      this.stem.setStyle(style);
	    },
	
	    // Sets the notehead at `index` to the provided coloring `style`.
	    //
	    // `style` is an `object` with the following properties: `shadowColor`,
	    // `shadowBlur`, `fillStyle`, `strokeStyle`
	    setKeyStyle: function(index, style) {
	      this.note_heads[index].setStyle(style);
	      return this;
	    },
	
	    setKeyLine: function(index, line) {
	      this.keyProps[index].line = line;
	      this.note_heads[index].setLine(line);
	      return this;
	    },
	
	    getKeyLine: function(index) {
	      return this.keyProps[index].line;
	    },
	
	    // Add self to modifier context. `mContext` is the `ModifierContext`
	    // to be added to.
	    addToModifierContext: function(mContext) {
	      this.setModifierContext(mContext);
	      for (var i = 0; i < this.modifiers.length; ++i) {
	        this.modifierContext.addModifier(this.modifiers[i]);
	      }
	      this.modifierContext.addModifier(this);
	      this.setPreFormatted(false);
	      return this;
	    },
	
	    // Generic function to add modifiers to a note
	    //
	    // Parameters:
	    // * `index`: The index of the key that we're modifying
	    // * `modifier`: The modifier to add
	    addModifier: function(index, modifier) {
	      modifier.setNote(this);
	      modifier.setIndex(index);
	      this.modifiers.push(modifier);
	      this.setPreFormatted(false);
	      return this;
	    },
	
	    // Helper function to add an accidental to a key
	    addAccidental: function(index, accidental) {
	      return this.addModifier(index, accidental);
	    },
	
	    // Helper function to add an articulation to a key
	    addArticulation: function(index, articulation) {
	      return this.addModifier(index, articulation);
	    },
	
	    // Helper function to add an annotation to a key
	    addAnnotation: function(index, annotation) {
	      return this.addModifier(index, annotation);
	    },
	
	    // Helper function to add a dot on a specific key
	    addDot: function(index) {
	      var dot = new Vex.Flow.Dot();
	      dot.setDotShiftY(this.glyph.dot_shiftY);
	      this.dots++;
	      return this.addModifier(index, dot);
	    },
	
	    // Convenience method to add dot to all keys in note
	    addDotToAll: function() {
	      for (var i = 0; i < this.keys.length; ++i)
	        this.addDot(i);
	      return this;
	    },
	
	    // Get all accidentals in the `ModifierContext`
	    getAccidentals: function() {
	      return this.modifierContext.getModifiers("accidentals");
	    },
	
	    // Get all dots in the `ModifierContext`
	    getDots: function() {
	      return this.modifierContext.getModifiers("dots");
	    },
	
	    // Get the width of the note if it is displaced. Used for `Voice`
	    // formatting
	    getVoiceShiftWidth: function() {
	      // TODO: may need to accomodate for dot here.
	      return this.glyph.head_width * (this.displaced ? 2 : 1);
	    },
	
	    // Calculates and sets the extra pixels to the left or right
	    // if the note is displaced.
	    calcExtraPx: function() {
	      this.setExtraLeftPx((this.displaced && this.stem_direction == -1) ?
	          this.glyph.head_width : 0);
	
	      // For upstems with flags, the extra space is unnecessary, since it's taken
	      // up by the flag.
	      this.setExtraRightPx((!this.hasFlag() && this.displaced && this.stem_direction == 1) ?
	          this.glyph.head_width : 0);
	    },
	
	    // Pre-render formatting
	    preFormat: function() {
	      if (this.preFormatted) return;
	      if (this.modifierContext) this.modifierContext.preFormat();
	
	      var width = this.glyph.head_width + this.extraLeftPx + this.extraRightPx;
	
	      // For upward flagged notes, the width of the flag needs to be added
	      if (this.glyph.flag && this.beam === null && this.stem_direction == 1) {
	        width += this.glyph.head_width;
	      }
	
	      this.setWidth(width);
	      this.setPreFormatted(true);
	    },
	
	    // Gets the staff line and y value for the highest and lowest noteheads
	    getNoteHeadBounds: function() {
	      // Top and bottom Y values for stem.
	      var y_top = null;
	      var y_bottom = null;
	
	      var highest_line = this.stave.getNumLines();
	      var lowest_line = 1;
	
	      this.note_heads.forEach(function(note_head) {
	        var line = note_head.getLine();
	        var y = note_head.getY();
	
	        if (y_top === null || y < y_top)  {
	          y_top = y;
	        }
	
	        if (y_bottom === null || y > y_bottom) {
	          y_bottom = y;
	        }
	
	        highest_line = line > highest_line ? line : highest_line;
	        lowest_line = line < lowest_line ? line : lowest_line;
	
	      }, this);
	
	      return {
	        y_top: y_top,
	        y_bottom: y_bottom,
	        highest_line: highest_line,
	        lowest_line: lowest_line
	      };
	    },
	
	    // Get the starting `x` coordinate for the noteheads
	    getNoteHeadBeginX: function(){
	      return this.getAbsoluteX() + this.x_shift;
	    },
	
	    // Get the ending `x` coordinate for the noteheads
	    getNoteHeadEndX: function(){
	      var x_begin = this.getNoteHeadBeginX();
	      return x_begin + this.glyph.head_width - (Vex.Flow.STEM_WIDTH / 2);
	    },
	
	    // Draw the ledger lines between the stave and the highest/lowest keys
	    drawLedgerLines: function(){
	      if (this.isRest()) { return; }
	      if (!this.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw without a canvas context.");
	      var ctx = this.context;
	
	      var bounds = this.getNoteHeadBounds();
	      var highest_line = bounds.highest_line;
	      var lowest_line = bounds.lowest_line;
	      var head_x = this.note_heads[0].getAbsoluteX();
	
	      var that = this;
	      function stroke(y) {
	        if (that.use_default_head_x === true)  {
	          head_x = that.getAbsoluteX() + that.x_shift;
	        }
	        var x = head_x - that.render_options.stroke_px;
	        var length = ((head_x + that.glyph.head_width) - head_x) +
	          (that.render_options.stroke_px * 2);
	
	        ctx.fillRect(x, y, length, 1);
	      }
	
	      var line; // iterator
	      for (line = 6; line <= highest_line; ++line) {
	        stroke(this.stave.getYForNote(line));
	      }
	
	      for (line = 0; line >= lowest_line; --line) {
	        stroke(this.stave.getYForNote(line));
	      }
	    },
	
	    // Draw all key modifiers
	    drawModifiers: function(){
	      if (!this.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw without a canvas context.");
	      var ctx = this.context;
	      ctx.openGroup("modifiers");
	      for (var i = 0; i < this.modifiers.length; i++) {
	        var mod = this.modifiers[i];
	        var note_head = this.note_heads[mod.getIndex()];
	        var key_style = note_head.getStyle();
	        if(key_style) {
	            ctx.save();
	            note_head.applyStyle(ctx);
	        }
	        mod.setContext(ctx);
	        mod.draw();
	        if(key_style) {
	            ctx.restore();
	        }
	      }
	      ctx.closeGroup();
	    },
	
	    // Draw the flag for the note
	    drawFlag: function(){
	      if (!this.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw without a canvas context.");
	      var ctx = this.context;
	      var glyph = this.getGlyph();
	      var render_flag = this.beam === null;
	      var bounds = this.getNoteHeadBounds();
	
	      var x_begin = this.getNoteHeadBeginX();
	      var x_end = this.getNoteHeadEndX();
	
	      if (glyph.flag && render_flag) {
	        var note_stem_height = this.stem.getHeight();
	        var flag_x, flag_y, flag_code;
	
	        if (this.getStemDirection() === Stem.DOWN) {
	          // Down stems have flags on the left.
	          flag_x = x_begin + 1;
	          flag_y = bounds.y_top - note_stem_height + 2;
	          flag_code = glyph.code_flag_downstem;
	
	        } else {
	          // Up stems have flags on the left.
	          flag_x = x_end + 1;
	          flag_y = bounds.y_bottom - note_stem_height - 2;
	          flag_code = glyph.code_flag_upstem;
	        }
	
	        // Draw the Flag
	        this.context.openGroup("flag", null, {pointerBBox: true});
	        Vex.Flow.renderGlyph(ctx, flag_x, flag_y,
	            this.render_options.glyph_font_scale, flag_code);
	        this.context.closeGroup();
	      }
	    },
	
	    // Draw the NoteHeads
	    drawNoteHeads: function(){
	      var that = this;
	      this.note_heads.forEach(function(note_head) {
	        that.context.openGroup("notehead", null, {pointerBBox: true});
	        note_head.setContext(that.context).draw();
	        that.context.closeGroup();
	      }, this);
	    },
	
	    // Render the stem onto the canvas
	    drawStem: function(stem_struct){
	      if (!this.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw without a canvas context.");
	
	      if (stem_struct) {
	        this.setStem(new Stem(stem_struct));
	      }
	
	      this.context.openGroup("stem", null, {pointerBBox: true});
	      this.stem.setContext(this.context).draw();
	      this.context.closeGroup();
	    },
	
	    // Draws all the `StaveNote` parts. This is the main drawing method.
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw without a canvas context.");
	      if (!this.stave) throw new Vex.RERR("NoStave",
	          "Can't draw without a stave.");
	      if (this.ys.length === 0) throw new Vex.RERR("NoYValues",
	          "Can't draw note without Y values.");
	
	      var x_begin = this.getNoteHeadBeginX();
	      var x_end = this.getNoteHeadEndX();
	
	      var render_stem = this.hasStem() && !this.beam;
	
	      // Format note head x positions
	      this.note_heads.forEach(function(note_head) {
	        note_head.setX(x_begin);
	      }, this);
	
	      // Format stem x positions
	      this.stem.setNoteHeadXBounds(x_begin, x_end);
	
	      L("Rendering ", this.isChord() ? "chord :" : "note :", this.keys);
	
	      // Draw each part of the note
	      this.drawLedgerLines();
	
	      this.elem = this.context.openGroup("stavenote", this.id);
	      this.context.openGroup("note", null, {pointerBBox: true});
	        if (render_stem) this.drawStem();
	        this.drawNoteHeads();
	        this.drawFlag();
	      this.context.closeGroup();
	      this.drawModifiers();
	      this.context.closeGroup();
	    }
	  });
	
	  return StaveNote;
	}());
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// The file implements notes for Tablature notation. This consists of one or
	// more fret positions, and can either be drawn with or without stems.
	//
	// See `tests/tabnote_tests.js` for usage examples
	Vex.Flow.TabNote = (function() {
	  function TabNote(tab_struct, draw_stem) {
	    if (arguments.length > 0) this.init(tab_struct, draw_stem);
	  }
	
	  var Stem = Vex.Flow.Stem;
	
	  // ## Prototype Methods
	  Vex.Inherit(TabNote, Vex.Flow.StemmableNote, {
	    // Initialize the TabNote with a `tab_struct` full of properties
	    // and whether to `draw_stem` when rendering the note
	    init: function(tab_struct, draw_stem) {
	      var superclass = Vex.Flow.TabNote.superclass;
	      superclass.init.call(this, tab_struct);
	
	      this.ghost = false; // Renders parenthesis around notes
	      // Note properties
	      //
	      // The fret positions in the note. An array of `{ str: X, fret: X }`
	      this.positions = tab_struct.positions;
	
	      // Render Options
	      Vex.Merge(this.render_options, {
	        // font size for note heads and rests
	        glyph_font_scale: 30,
	        // Flag to draw a stem
	        draw_stem: draw_stem,
	        // Flag to draw dot modifiers
	        draw_dots: draw_stem,
	        // Flag to extend the main stem through the stave and fret positions
	        draw_stem_through_stave: false
	      });
	
	      this.glyph =
	        Vex.Flow.durationToGlyph(this.duration, this.noteType);
	      if (!this.glyph) {
	        throw new Vex.RuntimeError("BadArguments",
	            "Invalid note initialization data (No glyph found): " +
	            JSON.stringify(tab_struct));
	      }
	
	      this.buildStem();
	
	      if (tab_struct.stem_direction){
	        this.setStemDirection(tab_struct.stem_direction);
	      } else {
	        this.setStemDirection(Stem.UP);
	      }
	
	      // Renders parenthesis around notes
	      this.ghost = false;
	      this.updateWidth();
	    },
	
	    // The ModifierContext category
	    getCategory: function() { return "tabnotes"; },
	
	    // Set as ghost `TabNote`, surrounds the fret positions with parenthesis.
	    // Often used for indicating frets that are being bent to
	    setGhost: function(ghost) {
	      this.ghost = ghost;
	      this.updateWidth();
	      return this;
	    },
	
	    // Determine if the note has a stem
	    hasStem: function() { return this.render_options.draw_stem; },
	
	    // Get the default stem extension for the note
	    getStemExtension: function(){
	      var glyph = this.getGlyph();
	
	      if (this.stem_extension_override != null) {
	        return this.stem_extension_override;
	      }
	
	      if (glyph) {
	        return this.getStemDirection() === 1 ? glyph.tabnote_stem_up_extension :
	          glyph.tabnote_stem_down_extension;
	      }
	
	      return 0;
	    },
	
	    // Add a dot to the note
	    addDot: function() {
	      var dot = new Vex.Flow.Dot();
	      this.dots++;
	      return this.addModifier(dot, 0);
	    },
	
	    // Calculate and store the width of the note
	    updateWidth: function() {
	      this.glyphs = [];
	      this.width = 0;
	      for (var i = 0; i < this.positions.length; ++i) {
	        var fret = this.positions[i].fret;
	        if (this.ghost) fret = "(" + fret + ")";
	        var glyph = Vex.Flow.tabToGlyph(fret);
	        this.glyphs.push(glyph);
	        this.width = (glyph.width > this.width) ? glyph.width : this.width;
	      }
	    },
	
	    // Set the `stave` to the note
	    setStave: function(stave) {
	      var superclass = Vex.Flow.TabNote.superclass;
	      superclass.setStave.call(this, stave);
	      this.context = stave.context;
	      this.width = 0;
	
	      // Calculate the fret number width based on font used
	      var i;
	      if (this.context) {
	        for (i = 0; i < this.glyphs.length; ++i) {
	          var text = "" + this.glyphs[i].text;
	          if (text.toUpperCase() != "X")
	            this.glyphs[i].width = this.context.measureText(text).width;
	          this.width = (this.glyphs[i].width > this.width) ?
	            this.glyphs[i].width : this.width;
	        }
	      }
	
	      var ys = [];
	
	      // Setup y coordinates for score.
	      for (i = 0; i < this.positions.length; ++i) {
	        var line = this.positions[i].str;
	        ys.push(this.stave.getYForLine(line - 1));
	      }
	
	      return this.setYs(ys);
	    },
	
	    // Get the fret positions for the note
	    getPositions: function() { return this.positions; },
	
	    // Add self to the provided modifier context `mc`
	    addToModifierContext: function(mc) {
	      this.setModifierContext(mc);
	      for (var i = 0; i < this.modifiers.length; ++i) {
	        this.modifierContext.addModifier(this.modifiers[i]);
	      }
	      this.modifierContext.addModifier(this);
	      this.preFormatted = false;
	      return this;
	    },
	
	    // Get the `x` coordinate to the right of the note
	    getTieRightX: function() {
	      var tieStartX = this.getAbsoluteX();
	      var note_glyph_width = this.glyph.head_width;
	      tieStartX += (note_glyph_width / 2);
	      tieStartX += ((-this.width / 2) + this.width + 2);
	
	      return tieStartX;
	    },
	
	    // Get the `x` coordinate to the left of the note
	    getTieLeftX: function() {
	      var tieEndX = this.getAbsoluteX();
	      var note_glyph_width = this.glyph.head_width;
	      tieEndX += (note_glyph_width / 2);
	      tieEndX -= ((this.width / 2) + 2);
	
	      return tieEndX;
	    },
	
	    // Get the default `x` and `y` coordinates for a modifier at a specific
	    // `position` at a fret position `index`
	    getModifierStartXY: function(position, index) {
	      if (!this.preFormatted) throw new Vex.RERR("UnformattedNote",
	          "Can't call GetModifierStartXY on an unformatted note");
	
	      if (this.ys.length === 0) throw new Vex.RERR("NoYValues",
	          "No Y-Values calculated for this note.");
	
	      var x = 0;
	      if (position == Vex.Flow.Modifier.Position.LEFT) {
	        x = -1 * 2;  // extra_left_px
	      } else if (position == Vex.Flow.Modifier.Position.RIGHT) {
	        x = this.width + 2; // extra_right_px
	      } else if (position == Vex.Flow.Modifier.Position.BELOW ||
	                 position == Vex.Flow.Modifier.Position.ABOVE) {
	          var note_glyph_width = this.glyph.head_width;
	          x = note_glyph_width / 2;
	      }
	
	      return {x: this.getAbsoluteX() + x, y: this.ys[index]};
	    },
	
	    // Get the default line for rest
	    getLineForRest: function() { return this.positions[0].str; },
	
	    // Pre-render formatting
	    preFormat: function() {
	      if (this.preFormatted) return;
	      if (this.modifierContext) this.modifierContext.preFormat();
	      // width is already set during init()
	      this.setPreFormatted(true);
	    },
	
	    // Get the x position for the stem
	    getStemX: function() { return this.getCenterGlyphX(); },
	
	    // Get the y position for the stem
	    getStemY: function(){
	      var num_lines = this.stave.getNumLines();
	
	      // The decimal staff line amounts provide optimal spacing between the
	      // fret number and the stem
	      var stemUpLine = -0.5;
	      var stemDownLine = num_lines - 0.5;
	      var stemStartLine = Stem.UP === this.stem_direction ? stemUpLine : stemDownLine;
	
	      return this.stave.getYForLine(stemStartLine);
	    },
	
	    // Get the stem extents for the tabnote
	    getStemExtents: function() {
	      var stem_base_y = this.getStemY();
	      var stem_top_y = stem_base_y + (Stem.HEIGHT * -this.stem_direction);
	
	      return { topY: stem_top_y , baseY: stem_base_y};
	    },
	
	    // Draw the fal onto the context
	    drawFlag: function() {
	      var render_stem = this.beam == null && this.render_options.draw_stem;
	      var render_flag = this.beam == null && render_stem;
	
	      // Now it's the flag's turn.
	      if (this.glyph.flag && render_flag) {
	        var flag_x = this.getStemX() + 1 ;
	        var flag_y = this.getStemY() - (this.stem.getHeight());
	        var flag_code;
	
	        if (this.stem_direction == Stem.DOWN) {
	          // Down stems have flags on the left.
	          flag_code = this.glyph.code_flag_downstem;
	        } else {
	          // Up stems have flags on the left.
	          flag_code = this.glyph.code_flag_upstem;
	        }
	
	        // Draw the Flag
	        Vex.Flow.renderGlyph(this.context, flag_x, flag_y,
	            this.render_options.glyph_font_scale, flag_code);
	      }
	    },
	
	    // Render the modifiers onto the context
	    drawModifiers: function() {
	      // Draw the modifiers
	      this.modifiers.forEach(function(modifier) {
	        // Only draw the dots if enabled
	        if (modifier.getCategory() === 'dots' && !this.render_options.draw_dots) return;
	
	        modifier.setContext(this.context);
	        modifier.draw();
	      }, this);
	    },
	
	    // Render the stem extension through the fret positions
	    drawStemThrough: function() {
	      var stem_x = this.getStemX();
	      var stem_y = this.getStemY();
	      var ctx = this.context;
	
	      var stem_through = this.render_options.draw_stem_through_stave;
	      var draw_stem = this.render_options.draw_stem;
	      if (draw_stem && stem_through) {
	        var total_lines = this.stave.getNumLines();
	        var strings_used = this.positions.map(function(position) {
	          return position.str;
	        });
	
	        var unused_strings = getUnusedStringGroups(total_lines, strings_used);
	        var stem_lines = getPartialStemLines(stem_y, unused_strings,
	                              this.getStave(), this.getStemDirection());
	
	        // Fine tune x position to match default stem
	        if (!this.beam || this.getStemDirection() === 1) {
	          stem_x += (Stem.WIDTH / 2);
	        }
	
	        ctx.save();
	        ctx.setLineWidth(Stem.WIDTH);
	        stem_lines.forEach(function(bounds) {
	          if (bounds.length === 0) return;
	
	          ctx.beginPath();
	          ctx.moveTo(stem_x, bounds[0]);
	          ctx.lineTo(stem_x, bounds[bounds.length - 1]);
	          ctx.stroke();
	          ctx.closePath();
	        });
	        ctx.restore();
	      }
	    },
	
	    // Render the fret positions onto the context
	    drawPositions: function() {
	      var ctx = this.context;
	      var x = this.getAbsoluteX();
	      var ys = this.ys;
	      var y;
	
	      for (var i = 0; i < this.positions.length; ++i) {
	        y = ys[i];
	
	        var glyph = this.glyphs[i];
	
	        // Center the fret text beneath the notation note head
	        var note_glyph_width = this.glyph.head_width;
	        var tab_x = x + (note_glyph_width / 2) - (glyph.width / 2);
	
	        ctx.clearRect(tab_x - 2, y - 3, glyph.width + 4, 6);
	
	        if (glyph.code) {
	          Vex.Flow.renderGlyph(ctx, tab_x, y + 5 + glyph.shift_y,
	              this.render_options.glyph_font_scale, glyph.code);
	        } else {
	          var text = glyph.text.toString();
	          ctx.fillText(text, tab_x, y + 5);
	        }
	      }
	    },
	
	    // The main rendering function for the entire note
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw without a canvas context.");
	      if (!this.stave) throw new Vex.RERR("NoStave", "Can't draw without a stave.");
	      if (this.ys.length === 0) throw new Vex.RERR("NoYValues",
	          "Can't draw note without Y values.");
	
	      var render_stem = this.beam == null && this.render_options.draw_stem;
	
	      this.drawPositions();
	      this.drawStemThrough();
	
	      var stem_x = this.getStemX();
	      var stem_y = this.getStemY();
	      if (render_stem) {
	        this.drawStem({
	          x_begin: stem_x,
	          x_end: stem_x,
	          y_top: stem_y,
	          y_bottom: stem_y,
	          y_extend: 0,
	          stem_extension: this.getStemExtension(),
	          stem_direction: this.stem_direction
	        });
	      }
	
	      this.drawFlag();
	      this.drawModifiers();
	    }
	  });
	
	  // ## Private Helpers
	  //
	  // Gets the unused strings grouped together if consecutive.
	  //
	  // Parameters:
	  // * num_lines - The number of lines
	  // * strings_used - An array of numbers representing which strings have fret positions
	  function getUnusedStringGroups(num_lines, strings_used) {
	    var stem_through = [];
	    var group = [];
	    for (var string = 1; string <= num_lines ; string++) {
	      var is_used = strings_used.indexOf(string) > -1;
	
	      if (!is_used) {
	        group.push(string);
	      } else {
	        stem_through.push(group);
	        group = [];
	      }
	    }
	    if (group.length > 0) stem_through.push(group);
	
	    return stem_through;
	  }
	
	  // Gets groups of points that outline the partial stem lines
	  // between fret positions
	  //
	  // Parameters:
	  // * stem_Y - The `y` coordinate the stem is located on
	  // * unused_strings - An array of groups of unused strings
	  // * stave - The stave to use for reference
	  // * stem_direction - The direction of the stem
	  function getPartialStemLines (stem_y, unused_strings, stave, stem_direction) {
	    var up_stem = stem_direction !== 1;
	    var down_stem = stem_direction !== -1;
	
	    var line_spacing = stave.getSpacingBetweenLines();
	    var total_lines = stave.getNumLines();
	
	    var stem_lines = [];
	
	    unused_strings.forEach(function(strings) {
	      var containsLastString = strings.indexOf(total_lines) > -1;
	      var containsFirstString =  strings.indexOf(1) > -1;
	
	      if ((up_stem && containsFirstString) ||
	         (down_stem && containsLastString)) {
	        return;
	      }
	
	      // If there's only one string in the group, push a duplicate value.
	      // We do this because we need 2 strings to convert into upper/lower y
	      // values.
	      if (strings.length === 1) {
	        strings.push(strings[0]);
	      }
	
	      var line_ys = [];
	      // Iterate through each group string and store it's y position
	      strings.forEach(function(string, index, strings) {
	        var isTopBound = string === 1;
	        var isBottomBound = string === total_lines;
	
	        // Get the y value for the appropriate staff line,
	        // we adjust for a 0 index array, since string numbers are index 1
	        var y = stave.getYForLine(string - 1);
	
	        // Unless the string is the first or last, add padding to each side
	        // of the line
	        if (index === 0 && !isTopBound) {
	          y -= line_spacing/2 - 1;
	        } else if (index === strings.length - 1 && !isBottomBound){
	          y += line_spacing/2 - 1;
	        }
	
	        // Store the y value
	        line_ys.push(y);
	
	        // Store a subsequent y value connecting this group to the main
	        // stem above/below the stave if it's the top/bottom string
	        if (stem_direction === 1 && isTopBound) {
	          line_ys.push(stem_y - 2);
	        } else if (stem_direction === -1 && isBottomBound) {
	          line_ys.push(stem_y + 2);
	        }
	      });
	
	      // Add the sorted y values to the
	      stem_lines.push(line_ys.sort(function(a, b) {
	        return a - b;
	      }));
	    });
	
	    return stem_lines;
	  }
	
	  return TabNote;
	}());
	
	// Vex Flow Notation
	// Mohit Muthanna <mohit@muthanna.com>
	//
	// Copyright Mohit Muthanna 2010
	//
	// Requires vex.js.
	
	/** @constructor */
	Vex.Flow.GhostNote = (function() {
	  function GhostNote(duration) {
	    if (arguments.length > 0) this.init(duration);
	  }
	
	  Vex.Inherit(GhostNote, Vex.Flow.StemmableNote, {
	    init: function(parameter) {
	      // Sanity check
	      if (!parameter) {
	        throw new Vex.RuntimeError("BadArguments",
	            "Ghost note must have valid initialization data to identify " +
	            "duration.");
	      }
	
	      var note_struct;
	
	      // Preserve backwards-compatibility
	      if (typeof(parameter) === "string") {
	        note_struct = { duration: parameter };
	      } else if (typeof(parameter) === "object") {
	        note_struct = parameter;
	      } else {
	        throw new Vex.RuntimeError("BadArguments",
	            "Ghost note must have valid initialization data to identify " +
	            "duration.");
	      }
	
	      GhostNote.superclass.init.call(this, note_struct);
	
	      // Note properties
	      this.setWidth(0);
	    },
	
	    isRest: function() { return true; },
	
	    setStave: function(stave) { GhostNote.superclass.setStave.call(this, stave); },
	
	    addToModifierContext: function()
	      { /* intentionally overridden */ return this; },
	
	    preFormat: function() {
	      this.setPreFormatted(true);
	      return this;
	    },
	
	    draw: function() {
	      if (!this.stave) throw new Vex.RERR("NoStave", "Can't draw without a stave.");
	
	      // Draw the modifiers
	      for (var i = 0; i < this.modifiers.length; ++i) {
	        var modifier = this.modifiers[i];
	        modifier.setContext(this.context);
	        modifier.draw();
	      }
	    }
	  });
	
	  return GhostNote;
	}());
	
	// Vex Flow Notation
	// Copyright Mohit Muthanna 2010
	//
	// Author Taehoon Moon 2014
	
	/** @constructor */
	Vex.Flow.ClefNote = (function() {
	  function ClefNote(clef, size, annotation) { this.init(clef, size, annotation); }
	
	  Vex.Inherit(ClefNote, Vex.Flow.Note, {
	    init: function(clef, size, annotation) {
	      ClefNote.superclass.init.call(this, {duration: "b"});
	      
	      this.setClef(clef, size, annotation);
	
	      // Note properties
	      this.ignore_ticks = true;
	    },
	
	    setClef: function(clef, size, annotation) {
	      this.clef_obj = new Vex.Flow.Clef(clef, size, annotation);
	      this.clef = this.clef_obj.clef;
	      this.glyph = new Vex.Flow.Glyph(this.clef.code, this.clef.point);
	      this.setWidth(this.glyph.getMetrics().width);
	      return this;
	    },
	
	    getClef: function() {
	      return this.clef;
	    },
	
	    setContext: function(context){
	      this.context = context;
	      this.glyph.setContext(this.context);
	      return this;
	    },
	
	    setStave: function(stave) {
	      var superclass = Vex.Flow.ClefNote.superclass;
	      superclass.setStave.call(this, stave);
	    },
	
	    getBoundingBox: function() {
	      return new Vex.Flow.BoundingBox(0, 0, 0, 0);
	    },
	
	    addToModifierContext: function() {
	      /* overridden to ignore */
	      return this;
	    },
	
	    getCategory: function() {
	      return "clefnote";
	    },
	
	    preFormat: function() {
	      this.setPreFormatted(true);
	      return this;
	    },
	
	    draw: function() {
	      if (!this.stave) throw new Vex.RERR("NoStave", "Can't draw without a stave.");
	      
	      if (!this.glyph.getContext()) {
	        this.glyph.setContext(this.context);
	      }
	      var abs_x = this.getAbsoluteX();
	
	      this.glyph.setStave(this.stave);
	      this.glyph.setYShift(
	        this.stave.getYForLine(this.clef.line) - this.stave.getYForGlyphs());
	      this.glyph.renderToStave(abs_x);
	      
	      // If the Vex.Flow.Clef has an annotation, such as 8va, draw it.
	      if (this.clef_obj.annotation !== undefined) {
	        var attachment = new Vex.Flow.Glyph(this.clef_obj.annotation.code, this.clef_obj.annotation.point);
	        if (!attachment.getContext()) {
	            attachment.setContext(this.context);
	        }
	        attachment.setStave(this.stave);
	        attachment.setYShift(
	          this.stave.getYForLine(this.clef_obj.annotation.line) - this.stave.getYForGlyphs());
	        attachment.setXShift(this.clef_obj.annotation.x_shift);
	        attachment.renderToStave(abs_x);
	      }
	      
	    }
	  });
	
	  return ClefNote;
	}());
	
	// Vex Flow Notation
	// Copyright Mohit Muthanna 2010
	//
	// Author Taehoon Moon 2014
	
	/** @constructor */
	Vex.Flow.TimeSigNote = (function() {
	  function TimeSigNote(timeSpec, customPadding) {
	    if (arguments.length > 0) this.init(timeSpec, customPadding);
	  }
	
	  Vex.Inherit(TimeSigNote, Vex.Flow.Note, {
	    init: function(timeSpec, customPadding) {
	      TimeSigNote.superclass.init.call(this, {duration: "b"});
	
	      var timeSignature = new Vex.Flow.TimeSignature(timeSpec, customPadding);
	      this.timeSig = timeSignature.getTimeSig();
	      this.setWidth(this.timeSig.glyph.getMetrics().width);
	
	      // Note properties
	      this.ignore_ticks = true;
	    },
	
	    setStave: function(stave) {
	      var superclass = Vex.Flow.TimeSigNote.superclass;
	      superclass.setStave.call(this, stave);
	    },
	
	    getBoundingBox: function() {
	      return new Vex.Flow.BoundingBox(0, 0, 0, 0);
	    },
	
	    addToModifierContext: function() {
	      /* overridden to ignore */
	      return this;
	    },
	
	    preFormat: function() {
	      this.setPreFormatted(true);
	      return this;
	    },
	
	    draw: function() {
	      if (!this.stave) throw new Vex.RERR("NoStave", "Can't draw without a stave.");
	      
	      if (!this.timeSig.glyph.getContext()) {
	        this.timeSig.glyph.setContext(this.context);
	      }
	
	      this.timeSig.glyph.setStave(this.stave);
	      this.timeSig.glyph.setYShift(
	        this.stave.getYForLine(this.timeSig.line) - this.stave.getYForGlyphs());
	      this.timeSig.glyph.renderToStave(this.getAbsoluteX());
	    }
	  });
	
	  return TimeSigNote;
	}());
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements `Beams` that span over a set of `StemmableNotes`.
	//
	// Requires: vex.js, vexmusic.js, note.js
	Vex.Flow.Beam = (function() {
	  function Beam(notes, auto_stem) {
	    if (arguments.length > 0) this.init(notes, auto_stem);
	  }
	
	  var Stem = Vex.Flow.Stem;
	
	  // ## Prototype Methods
	  Beam.prototype = {
	    init: function(notes, auto_stem) {
	      if (!notes || notes == []) {
	        throw new Vex.RuntimeError("BadArguments", "No notes provided for beam.");
	      }
	
	      if (notes.length == 1) {
	        throw new Vex.RuntimeError("BadArguments", "Too few notes for beam.");
	      }
	
	      // Validate beam line, direction and ticks.
	      this.ticks = notes[0].getIntrinsicTicks();
	
	      if (this.ticks >= Vex.Flow.durationToTicks("4")) {
	        throw new Vex.RuntimeError("BadArguments",
	            "Beams can only be applied to notes shorter than a quarter note.");
	      }
	
	      var i; // shared iterator
	      var note;
	
	      this.stem_direction = Stem.UP;
	
	      for (i = 0; i < notes.length; ++i) {
	        note = notes[i];
	        if (note.hasStem()) {
	          this.stem_direction = note.getStemDirection();
	          break;
	        }
	      }
	
	      var stem_direction = this.stem_direction;
	      // Figure out optimal stem direction based on given notes
	      if (auto_stem && notes[0].getCategory() === 'stavenotes')  {
	        stem_direction = calculateStemDirection(notes);
	      } else if (auto_stem && notes[0].getCategory() === 'tabnotes') {
	        // Auto Stem TabNotes
	        var stem_weight = notes.reduce(function(memo, note) {
	          return memo + note.stem_direction;
	        }, 0);
	
	        stem_direction = stem_weight > -1 ? Stem.UP : Stem.DOWN;
	      }
	
	      // Apply stem directions and attach beam to notes
	      for (i = 0; i < notes.length; ++i) {
	        note = notes[i];
	        if (auto_stem) {
	          note.setStemDirection(stem_direction);
	          this.stem_direction = stem_direction;
	        }
	        note.setBeam(this);
	      }
	
	      this.postFormatted = false;
	      this.notes = notes;
	      this.beam_count = this.getBeamCount();
	      this.break_on_indices = [];
	      this.render_options = {
	        beam_width: 5,
	        max_slope: 0.25,
	        min_slope: -0.25,
	        slope_iterations: 20,
	        slope_cost: 100,
	        show_stemlets: false,
	        stemlet_extension: 7,
	        partial_beam_length: 10,
	        flat_beams: false,
	        min_flat_beam_offset: 15
	      };
	    },
	
	    // The the rendering `context`
	    setContext: function(context) { this.context = context; return this; },
	
	    // Get the notes in this beam
	    getNotes: function() { return this.notes; },
	
	    // Get the max number of beams in the set of notes
	    getBeamCount: function(){
	      var beamCounts =  this.notes.map(function(note) {
	        return note.getGlyph().beam_count;
	      });
	
	      var maxBeamCount =  beamCounts.reduce(function(max, beamCount) {
	          return beamCount > max ? beamCount : max;
	      });
	
	      return maxBeamCount;
	    },
	
	    // Set which note `indices` to break the secondary beam at
	    breakSecondaryAt: function(indices) {
	      this.break_on_indices = indices;
	      return this;
	    },
	
	    // Return the y coordinate for linear function
	    getSlopeY: function(x, first_x_px, first_y_px, slope) {
	      return first_y_px + ((x - first_x_px) * slope);
	    },
	
	    // Calculate the best possible slope for the provided notes
	    calculateSlope: function() {
	      var first_note = this.notes[0];
	      var first_y_px = first_note.getStemExtents().topY;
	      var first_x_px = first_note.getStemX();
	
	      var inc = (this.render_options.max_slope - this.render_options.min_slope) /
	          this.render_options.slope_iterations;
	      var min_cost = Number.MAX_VALUE;
	      var best_slope = 0;
	      var y_shift = 0;
	
	      // iterate through slope values to find best weighted fit
	      for (var slope = this.render_options.min_slope;
	           slope <= this.render_options.max_slope;
	           slope += inc) {
	        var total_stem_extension = 0;
	        var y_shift_tmp = 0;
	
	        // iterate through notes, calculating y shift and stem extension
	        for (var i = 1; i < this.notes.length; ++i) {
	          var note = this.notes[i];
	
	          var x_px = note.getStemX();
	          var y_px = note.getStemExtents().topY;
	          var slope_y_px = this.getSlopeY(x_px, first_x_px, first_y_px, slope) + y_shift_tmp;
	
	          // beam needs to be shifted up to accommodate note
	          if (y_px * this.stem_direction < slope_y_px * this.stem_direction) {
	            var diff =  Math.abs(y_px - slope_y_px);
	            y_shift_tmp += diff * -this.stem_direction;
	            total_stem_extension += (diff * i);
	          } else { // beam overshoots note, account for the difference
	            total_stem_extension += (y_px - slope_y_px) * this.stem_direction;
	          }
	
	        }
	
	        var last_note = this.notes[this.notes.length - 1];
	        var first_last_slope = ((last_note.getStemExtents().topY - first_y_px) /
	                (last_note.getStemX() - first_x_px));
	        // most engraving books suggest aiming for a slope about half the angle of the
	        // difference between the first and last notes' stem length;
	        var ideal_slope = first_last_slope / 2;
	        var distance_from_ideal = Math.abs(ideal_slope - slope);
	
	        // This tries to align most beams to something closer to the ideal_slope, but
	        // doesn't go crazy. To disable, set this.render_options.slope_cost = 0
	        var cost = this.render_options.slope_cost * distance_from_ideal +
	            Math.abs(total_stem_extension);
	
	        // update state when a more ideal slope is found
	        if (cost < min_cost) {
	          min_cost = cost;
	          best_slope = slope;
	          y_shift = y_shift_tmp;
	        }
	      }
	
	      this.slope = best_slope;
	      this.y_shift = y_shift;
	    },
	
	    // Calculate a slope and y-shift for flat beams
	    calculateFlatSlope: function() {
	
	      // If a flat beam offset has not yet been supplied or calculated,
	      // generate one based on the notes in this particular note group
	      var total = 0;
	      var extreme_y = 0;  // Store the highest or lowest note here
	      var extreme_beam_count = 0;  // The beam count of the extreme note
	      var current_extreme = 0;
	      for (var i = 0; i < this.notes.length; i++) {
	
	        // Total up all of the offsets so we can average them out later
	        var note = this.notes[i];
	        var top_y = note.getStemExtents().topY;
	        total += top_y;
	
	        // Store the highest (stems-up) or lowest (stems-down) note so the
	        //  offset can be adjusted in case the average isn't enough
	        if (this.stem_direction === Stem.DOWN && current_extreme < top_y) {
	          current_extreme = top_y;
	          extreme_y = note.getNoteHeadBounds().y_bottom;
	          extreme_beam_count = note.getBeamCount();
	        } else if (this.stem_direction === Stem.UP && (current_extreme === 0 || current_extreme > top_y)) {
	          current_extreme = top_y;
	          extreme_y = note.getNoteHeadBounds().y_top;
	          extreme_beam_count = note.getBeamCount();
	        }
	      }
	
	      // Average the offsets to try and come up with a reasonable one that
	      //  works for all of the notes in the beam group.
	      var offset = total / this.notes.length;
	
	      // In case the average isn't long enough, add or subtract some more
	      //  based on the highest or lowest note (again, based on the stem
	      //  direction). This also takes into account the added height due to
	      //  the width of the beams.
	      var beam_width = this.render_options.beam_width * 1.5;
	      var extreme_test = this.render_options.min_flat_beam_offset + (extreme_beam_count * beam_width);
	      var new_offset = extreme_y + (extreme_test * -this.stem_direction);
	      if (this.stem_direction === Stem.DOWN && offset < new_offset) {
	        offset = extreme_y + extreme_test;
	      } else if (this.stem_direction === Stem.UP && offset > new_offset) {
	        offset = extreme_y - extreme_test;
	      }
	      if (!this.render_options.flat_beam_offset) {
	
	        // Set the offset for the group based on the calculations above.
	        this.render_options.flat_beam_offset = offset;
	      } else if (this.stem_direction === Stem.DOWN && offset > this.render_options.flat_beam_offset) {
	        this.render_options.flat_beam_offset = offset;
	      } else if (this.stem_direction === Stem.UP && offset < this.render_options.flat_beam_offset) {
	        this.render_options.flat_beam_offset = offset;
	      }
	
	      // for flat beams, the slope and y_shift are simply 0
	      this.slope = 0;
	      this.y_shift = 0;
	    },
	
	    // Create new stems for the notes in the beam, so that each stem
	    // extends into the beams.
	    applyStemExtensions: function(){
	      var first_note = this.notes[0];
	      var first_y_px = first_note.getStemExtents().topY;
	
	      // If rendering flat beams, and an offset exists, set the y-coordinate to
	      //  the offset so the stems all end at the beam offset.
	      if (this.render_options.flat_beams && this.render_options.flat_beam_offset) {
	        first_y_px = this.render_options.flat_beam_offset;
	      }
	      var first_x_px = first_note.getStemX();
	
	      for (var i = 0; i < this.notes.length; ++i) {
	        var note = this.notes[i];
	
	        var x_px = note.getStemX();
	        var y_extents = note.getStemExtents();
	        var base_y_px = y_extents.baseY;
	        var top_y_px = y_extents.topY;
	
	        // If flat beams, set the top of the stem to the offset, rather than
	        //  relying on the topY value from above.
	        if (this.render_options.flat_beams) {
	          top_y_px = first_y_px;
	        }
	
	        // For harmonic note heads, shorten stem length by 3 pixels
	        base_y_px += this.stem_direction * note.glyph.stem_offset;
	
	        // Don't go all the way to the top (for thicker stems)
	        var y_displacement = Vex.Flow.STEM_WIDTH;
	
	        if (!note.hasStem()) {
	          if (note.isRest() && this.render_options.show_stemlets) {
	            var centerGlyphX = note.getCenterGlyphX();
	
	            var width = this.render_options.beam_width;
	            var total_width = ((this.beam_count - 1)* width * 1.5) + width;
	
	            var stemlet_height = (total_width - y_displacement +
	              this.render_options.stemlet_extension);
	
	            var beam_y = this.getSlopeY(centerGlyphX, first_x_px,
	                            first_y_px, this.slope) + this.y_shift;
	            var start_y = beam_y + (Vex.Flow.Stem.HEIGHT * this.stem_direction);
	            var end_y = beam_y + (stemlet_height * this.stem_direction);
	
	            // Draw Stemlet
	            note.setStem(new Vex.Flow.Stem({
	              x_begin: centerGlyphX,
	              x_end: centerGlyphX,
	              y_bottom: this.stem_direction === Stem.UP ? end_y : start_y,
	              y_top: this.stem_direction === Stem.UP ? start_y : end_y,
	              y_extend: y_displacement,
	              stem_extension: -1, // To avoid protruding through the beam
	              stem_direction: this.stem_direction
	            }));
	          }
	
	          continue;
	        }
	
	        var slope_y = this.getSlopeY(x_px, first_x_px, first_y_px,
	                        this.slope) + this.y_shift;
	
	        note.setStem(new Vex.Flow.Stem({
	          x_begin: x_px - (Vex.Flow.STEM_WIDTH/2),
	          x_end: x_px,
	          y_top: this.stem_direction === Stem.UP ? top_y_px : base_y_px,
	          y_bottom: this.stem_direction === Stem.UP ? base_y_px :  top_y_px,
	          y_extend: y_displacement,
	          stem_extension: Math.abs(top_y_px - slope_y) - Stem.HEIGHT - 1,
	          stem_direction: this.stem_direction
	        }));
	      }
	    },
	
	    // Get the x coordinates for the beam lines of specific `duration`
	    getBeamLines: function(duration) {
	      var beam_lines = [];
	      var beam_started = false;
	      var current_beam = null;
	      var partial_beam_length = this.render_options.partial_beam_length;
	      var previous_should_break = false;
	      var tick_tally = 0;
	      for (var i = 0; i < this.notes.length; ++i) {
	        var note = this.notes[i];
	
	        // See if we need to break secondary beams on this note.
	        var ticks = note.getIntrinsicTicks();
	        tick_tally += ticks;
	        var should_break = false;
	
	        // 8th note beams are always drawn.
	        if (parseInt(duration) >= 8) {
	
	          // First, check to see if any indices were set up through breakSecondaryAt()
	          should_break = this.break_on_indices.indexOf(i) !== -1;
	
	          // If the secondary breaks were auto-configured in the render options,
	          //  handle that as well.
	          if (this.render_options.secondary_break_ticks && tick_tally >= this.render_options.secondary_break_ticks) {
	            tick_tally = 0;
	            should_break = true;
	          }
	        }
	        var note_gets_beam = ticks < Vex.Flow.durationToTicks(duration);
	        var stem_x = note.isRest() ? note.getCenterGlyphX() : note.getStemX();
	
	        // Check to see if the next note in the group will get a beam at this
	        //  level. This will help to inform the partial beam logic below.
	        var next_note = this.notes[i + 1];
	        var beam_next = next_note && next_note.getIntrinsicTicks() < Vex.Flow.durationToTicks(duration);
	        if (note_gets_beam) {
	
	          // This note gets a beam at the current level
	          if (beam_started) {
	
	            // We're currently in the middle of a beam. Just continue it on to
	            //  the stem X of the current note.
	            current_beam = beam_lines[beam_lines.length - 1];
	            current_beam.end = stem_x;
	
	            // If a secondary beam break is set up, end the beam right now.
	            if (should_break) {
	              beam_started = false;
	              if (next_note && !beam_next && current_beam.end === null) {
	
	                // This note gets a beam,.but the next one does not. This means
	                //  we need a partial pointing right.
	                current_beam.end = current_beam.start - partial_beam_length;
	              }
	            }
	          } else {
	
	            // No beam started yet. Start a new one.
	            current_beam = { start: stem_x, end: null };
	            beam_started = true;
	            if (!beam_next) {
	
	              // The next note doesn't get a beam. Draw a partial.
	              if((previous_should_break || i === 0) && next_note) {
	
	                // This is the first note (but not the last one), or it is
	                //  following a secondary break. Draw a partial to the right.
	                current_beam.end = current_beam.start + partial_beam_length;
	              } else {
	
	                // By default, draw a partial to the left.
	                current_beam.end = current_beam.start - partial_beam_length;
	              }
	            } else if (should_break) {
	
	              // This note should have a secondary break after it. Even though
	              //  we just started a beam, it needs to end immediately.
	              current_beam.end = current_beam.start - partial_beam_length;
	              beam_started = false;
	            }
	            beam_lines.push(current_beam);
	          }
	        } else {
	
	          // The current note does not get a beam.
	          beam_started = false;
	        }
	
	        // Store the secondary break flag to inform the partial beam logic in
	        //  the next iteration of the loop.
	        previous_should_break = should_break;
	      }
	
	      // Add a partial beam pointing left if this is the last note in the group
	      var last_beam = beam_lines[beam_lines.length - 1];
	      if (last_beam && last_beam.end === null) {
	        last_beam.end = last_beam.start - partial_beam_length;
	      }
	      return beam_lines;
	    },
	
	    // Render the stems for each notes
	    drawStems: function() {
	      this.notes.forEach(function(note) {
	        if (note.getStem()) {
	          note.getStem().setContext(this.context).draw();
	        }
	      }, this);
	    },
	
	    // Render the beam lines
	    drawBeamLines: function() {
	      if (!this.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw without a canvas context.");
	
	      var valid_beam_durations = ["4", "8", "16", "32", "64"];
	
	      var first_note = this.notes[0];
	      var last_note = this.notes[this.notes.length - 1];
	
	      var first_y_px = first_note.getStemExtents().topY;
	      var last_y_px = last_note.getStemExtents().topY;
	
	      // For flat beams, set the first and last Y to the offset, rather than
	      //  using the note's stem extents.
	      if (this.render_options.flat_beams && this.render_options.flat_beam_offset) {
	        first_y_px = this.render_options.flat_beam_offset;
	        last_y_px = this.render_options.flat_beam_offset;
	      }
	
	      var first_x_px = first_note.getStemX();
	
	      var beam_width = this.render_options.beam_width * this.stem_direction;
	
	      // Draw the beams.
	      for (var i = 0; i < valid_beam_durations.length; ++i) {
	        var duration = valid_beam_durations[i];
	        var beam_lines = this.getBeamLines(duration);
	
	        for (var j = 0; j < beam_lines.length; ++j) {
	          var beam_line = beam_lines[j];
	          var first_x = beam_line.start - (this.stem_direction == Stem.DOWN ? Vex.Flow.STEM_WIDTH/2:0);
	          var first_y = this.getSlopeY(first_x, first_x_px, first_y_px, this.slope);
	
	          var last_x = beam_line.end +
	            (this.stem_direction == 1 ? (Vex.Flow.STEM_WIDTH/3):(-Vex.Flow.STEM_WIDTH/3));
	          var last_y = this.getSlopeY(last_x, first_x_px, first_y_px, this.slope);
	
	          this.context.beginPath();
	          this.context.moveTo(first_x, first_y + this.y_shift);
	          this.context.lineTo(first_x, first_y + beam_width + this.y_shift);
	          this.context.lineTo(last_x + 1, last_y + beam_width + this.y_shift);
	          this.context.lineTo(last_x + 1, last_y + this.y_shift);
	          this.context.closePath();
	          this.context.fill();
	        }
	
	        first_y_px += beam_width * 1.5;
	        last_y_px += beam_width * 1.5;
	      }
	    },
	
	    // Pre-format the beam
	    preFormat: function() { return this; },
	
	    // Post-format the beam. This can only be called after
	    // the notes in the beam have both `x` and `y` values. ie: they've
	    // been formatted and have staves
	    postFormat: function() {
	      if (this.postFormatted) return;
	
	      // Calculate a smart slope if we're not forcing the beams to be flat.
	      if(this.render_options.flat_beams) {
	        this.calculateFlatSlope();
	      } else {
	        this.calculateSlope();
	      }
	      this.applyStemExtensions();
	
	      this.postFormatted = true;
	    },
	
	    // Render the beam to the canvas context
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw without a canvas context.");
	
	      if (this.unbeamable) return;
	
	      if (!this.postFormatted) {
	        this.postFormat();
	      }
	
	      this.drawStems();
	      this.drawBeamLines();
	
	      return true;
	    }
	  };
	
	  function calculateStemDirection(notes) {
	    var lineSum = 0;
	    notes.forEach(function(note) {
	      if (note.keyProps) {
	        note.keyProps.forEach(function(keyProp){
	          lineSum += (keyProp.line - 3);
	        });
	      }
	    });
	
	    if (lineSum >= 0)
	      return Stem.DOWN;
	    return Stem.UP;
	  }
	
	  // ## Static Methods
	  //
	  // Gets the default beam groups for a provided time signature.
	  // Attempts to guess if the time signature is not found in table.
	  // Currently this is fairly naive.
	  Beam.getDefaultBeamGroups = function(time_sig){
	    if (!time_sig || time_sig == "c") time_sig = "4/4";
	
	    var defaults = {
	      '1/2' :  ['1/2'],
	      '2/2' :  ['1/2'],
	      '3/2' :  ['1/2'],
	      '4/2' :  ['1/2'],
	
	      '1/4' :  ['1/4'],
	      '2/4' :  ['1/4'],
	      '3/4' :  ['1/4'],
	      '4/4' :  ['1/4'],
	
	      '1/8' :  ['1/8'],
	      '2/8' :  ['2/8'],
	      '3/8' :  ['3/8'],
	      '4/8' :  ['2/8'],
	
	      '1/16' : ['1/16'],
	      '2/16' : ['2/16'],
	      '3/16' : ['3/16'],
	      '4/16' : ['2/16']
	    };
	
	    var Fraction = Vex.Flow.Fraction;
	    var groups = defaults[time_sig];
	
	    if (!groups) {
	      // If no beam groups found, naively determine
	      // the beam groupings from the time signature
	      var beatTotal = parseInt(time_sig.split('/')[0], 10);
	      var beatValue = parseInt(time_sig.split('/')[1], 10);
	
	      var tripleMeter = beatTotal % 3 === 0;
	
	      if (tripleMeter) {
	        return [new Fraction(3, beatValue)];
	      } else if (beatValue > 4) {
	        return [new Fraction(2, beatValue)];
	      } else if (beatValue <= 4) {
	        return [new Fraction(1, beatValue)];
	      }
	    } else {
	      return groups.map(function(group) {
	        return new Fraction().parse(group);
	      });
	    }
	  };
	
	  // A helper function to automatically build basic beams for a voice. For more
	  // complex auto-beaming use `Beam.generateBeams()`.
	  //
	  // Parameters:
	  // * `voice` - The voice to generate the beams for
	  // * `stem_direction` - A stem direction to apply to the entire voice
	  // * `groups` - An array of `Fraction` representing beat groupings for the beam
	  Beam.applyAndGetBeams = function(voice, stem_direction, groups) {
	    return Beam.generateBeams(voice.getTickables(), {
	      groups: groups,
	      stem_direction: stem_direction
	    });
	  };
	
	  // A helper function to autimatically build beams for a voice with
	  // configuration options.
	  //
	  // Example configuration object:
	  //
	  // ```
	  // config = {
	  //   groups: [new Vex.Flow.Fraction(2, 8)],
	  //   stem_direction: -1,
	  //   beam_rests: true,
	  //   beam_middle_only: true,
	  //   show_stemlets: false
	  // };
	  // ```
	  //
	  // Parameters:
	  // * `notes` - An array of notes to create the beams for
	  // * `config` - The configuration object
	  //    * `groups` - Array of `Fractions` that represent the beat structure to beam the notes
	  //    * `stem_direction` - Set to apply the same direction to all notes
	  //    * `beam_rests` - Set to `true` to include rests in the beams
	  //    * `beam_middle_only` - Set to `true` to only beam rests in the middle of the beat
	  //    * `show_stemlets` - Set to `true` to draw stemlets for rests
	  //    * `maintain_stem_directions` - Set to `true` to not apply new stem directions
	  //
	  Beam.generateBeams = function(notes, config) {
	
	    if (!config) config = {};
	
	    if (!config.groups || !config.groups.length) {
	      config.groups = [new Vex.Flow.Fraction(2, 8)];
	    }
	
	    // Convert beam groups to tick amounts
	    var tickGroups = config.groups.map(function(group) {
	      if (!group.multiply) {
	        throw new Vex.RuntimeError("InvalidBeamGroups",
	          "The beam groups must be an array of Vex.Flow.Fractions");
	      }
	      return group.clone().multiply(Vex.Flow.RESOLUTION, 1);
	    });
	
	    var unprocessedNotes = notes;
	    var currentTickGroup = 0;
	    var noteGroups       = [];
	    var currentGroup     = [];
	
	    function getTotalTicks(vf_notes){
	      return vf_notes.reduce(function(memo,note){
	        return note.getTicks().clone().add(memo);
	      }, new Vex.Flow.Fraction(0, 1));
	    }
	
	    function nextTickGroup() {
	      if (tickGroups.length - 1 > currentTickGroup) {
	        currentTickGroup += 1;
	      } else {
	        currentTickGroup = 0;
	      }
	    }
	
	    function createGroups(){
	      var nextGroup = [];
	
	      unprocessedNotes.forEach(function(unprocessedNote){
	        nextGroup    = [];
	        if (unprocessedNote.shouldIgnoreTicks()) {
	          noteGroups.push(currentGroup);
	          currentGroup = nextGroup;
	          return; // Ignore untickables (like bar notes)
	        }
	
	        currentGroup.push(unprocessedNote);
	        var ticksPerGroup = tickGroups[currentTickGroup].clone();
	        var totalTicks = getTotalTicks(currentGroup);
	
	        // Double the amount of ticks in a group, if it's an unbeamable tuplet
	        var unbeamable = Vex.Flow.durationToNumber(unprocessedNote.duration) < 8;
	        if (unbeamable && unprocessedNote.tuplet) {
	          ticksPerGroup.numerator *= 2;
	        }
	
	        // If the note that was just added overflows the group tick total
	        if (totalTicks.greaterThan(ticksPerGroup)) {
	          // If the overflow note can be beamed, start the next group
	          // with it. Unbeamable notes leave the group overflowed.
	          if (!unbeamable) {
	            nextGroup.push(currentGroup.pop());
	          }
	          noteGroups.push(currentGroup);
	          currentGroup = nextGroup;
	          nextTickGroup();
	        } else if (totalTicks.equals(ticksPerGroup)) {
	          noteGroups.push(currentGroup);
	          currentGroup = nextGroup;
	          nextTickGroup();
	        }
	      });
	
	      // Adds any remainder notes
	      if (currentGroup.length > 0)
	        noteGroups.push(currentGroup);
	    }
	
	    function getBeamGroups() {
	      return noteGroups.filter(function(group){
	          if (group.length > 1) {
	            var beamable = true;
	            group.forEach(function(note) {
	              if (note.getIntrinsicTicks() >= Vex.Flow.durationToTicks("4")) {
	                beamable = false;
	              }
	            });
	            return beamable;
	          }
	          return false;
	      });
	    }
	
	    // Splits up groups by Rest
	    function sanitizeGroups() {
	      var sanitizedGroups = [];
	      noteGroups.forEach(function(group) {
	        var tempGroup = [];
	        group.forEach(function(note, index, group) {
	          var isFirstOrLast = index === 0 || index === group.length - 1;
	          var prevNote = group[index-1];
	
	          var breaksOnEachRest = !config.beam_rests && note.isRest();
	          var breaksOnFirstOrLastRest = (config.beam_rests &&
	            config.beam_middle_only && note.isRest() && isFirstOrLast);
	
	          var breakOnStemChange = false;
	          if (config.maintain_stem_directions && prevNote &&
	              !note.isRest() && !prevNote.isRest()) {
	            var prevDirection = prevNote.getStemDirection();
	            var currentDirection = note.getStemDirection();
	            breakOnStemChange = currentDirection !== prevDirection;
	          }
	
	          var isUnbeamableDuration = parseInt(note.duration, 10) < 8;
	
	          // Determine if the group should be broken at this note
	          var shouldBreak = breaksOnEachRest || breaksOnFirstOrLastRest ||
	                            breakOnStemChange || isUnbeamableDuration;
	
	          if (shouldBreak) {
	            // Add current group
	            if (tempGroup.length > 0) {
	              sanitizedGroups.push(tempGroup);
	            }
	
	            // Start a new group. Include the current note if the group
	            // was broken up by stem direction, as that note needs to start
	            // the next group of notes
	            tempGroup = breakOnStemChange ? [note] : [];
	          } else {
	            // Add note to group
	            tempGroup.push(note);
	          }
	        });
	
	        // If there is a remaining group, add it as well
	        if (tempGroup.length > 0) {
	          sanitizedGroups.push(tempGroup);
	        }
	      });
	
	      noteGroups = sanitizedGroups;
	    }
	
	    function formatStems() {
	      noteGroups.forEach(function(group){
	        var stemDirection;
	        if (config.maintain_stem_directions) {
	          var note = findFirstNote(group);
	          stemDirection = note ? note.getStemDirection() : Stem.UP;
	        } else {
	          if (config.stem_direction){
	            stemDirection = config.stem_direction;
	          } else {
	            stemDirection = calculateStemDirection(group);
	          }
	        }
	        applyStemDirection(group, stemDirection);
	      });
	    }
	
	    function findFirstNote(group) {
	      for (var i = 0; i < group.length; i++) {
	        var note = group[i];
	        if (!note.isRest()) {
	          return note;
	        }
	      }
	
	      return false;
	    }
	
	    function applyStemDirection(group, direction) {
	      group.forEach(function(note){
	        note.setStemDirection(direction);
	      });
	    }
	
	    function getTupletGroups() {
	      return noteGroups.filter(function(group){
	        if (group[0]) return group[0].tuplet;
	      });
	    }
	
	
	    // Using closures to store the variables throughout the various functions
	    // IMO Keeps it this process lot cleaner - but not super consistent with
	    // the rest of the API's style - Silverwolf90 (Cyril)
	    createGroups();
	    sanitizeGroups();
	    formatStems();
	
	    // Get the notes to be beamed
	    var beamedNoteGroups = getBeamGroups();
	
	    // Get the tuplets in order to format them accurately
	    var tupletGroups = getTupletGroups();
	
	    // Create a Vex.Flow.Beam from each group of notes to be beamed
	    var beams = [];
	    beamedNoteGroups.forEach(function(group){
	      var beam = new Vex.Flow.Beam(group);
	
	      if (config.show_stemlets) {
	        beam.render_options.show_stemlets = true;
	      }
	      if (config.secondary_breaks) {
	        beam.render_options.secondary_break_ticks = Vex.Flow.durationToTicks(config.secondary_breaks);
	      }
	      if (config.flat_beams === true) {
	        beam.render_options.flat_beams = true;
	        beam.render_options.flat_beam_offset = config.flat_beam_offset;
	      }
	      beams.push(beam);
	    });
	
	    // Reformat tuplets
	    tupletGroups.forEach(function(group){
	      var firstNote = group[0];
	      for (var i=0; i<group.length; ++i) {
	        if (group[i].hasStem()) {
	          firstNote = group[i];
	          break;
	        }
	      }
	
	      var tuplet = firstNote.tuplet;
	
	      if (firstNote.beam) tuplet.setBracketed(false);
	      if (firstNote.stem_direction == Stem.DOWN) {
	        tuplet.setTupletLocation(Vex.Flow.Tuplet.LOCATION_BOTTOM);
	      }
	    });
	
	    return beams;
	  };
	
	  return Beam;
	}());
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements the main Voice class. It's mainly a container
	// object to group `Tickables` for formatting.
	Vex.Flow.Voice = (function() {
	  function Voice(time) {
	    if (arguments.length > 0) this.init(time);
	  }
	
	  // Modes allow the addition of ticks in three different ways:
	  //
	  // STRICT: This is the default. Ticks must fill the voice.
	  // SOFT:   Ticks can be added without restrictions.
	  // FULL:   Ticks do not need to fill the voice, but can't exceed the maximum
	  //         tick length.
	  Voice.Mode = {
	    STRICT: 1,
	    SOFT:   2,
	    FULL:   3
	  };
	
	  // ## Prototype Methods
	  Voice.prototype = {
	    init: function(time) {
	      this.time = Vex.Merge({
	        num_beats: 4,
	        beat_value: 4,
	        resolution: Vex.Flow.RESOLUTION
	      }, time);
	
	      // Recalculate total ticks.
	      this.totalTicks = new Vex.Flow.Fraction(
	        this.time.num_beats * (this.time.resolution / this.time.beat_value), 1);
	
	      this.resolutionMultiplier = 1;
	
	      // Set defaults
	      this.tickables = [];
	      this.ticksUsed = new Vex.Flow.Fraction(0, 1);
	      this.smallestTickCount = this.totalTicks.clone();
	      this.largestTickWidth = 0;
	      this.stave = null;
	      this.boundingBox = null;
	      // Do we care about strictly timed notes
	      this.mode = Vex.Flow.Voice.Mode.STRICT;
	
	      // This must belong to a VoiceGroup
	      this.voiceGroup = null;
	    },
	
	    // Get the total ticks in the voice
	    getTotalTicks: function() { return this.totalTicks; },
	
	    // Get the total ticks used in the voice by all the tickables
	    getTicksUsed: function() { return this.ticksUsed; },
	
	    // Get the largest width of all the tickables
	    getLargestTickWidth: function() { return this.largestTickWidth; },
	
	    // Get the tick count for the shortest tickable
	    getSmallestTickCount: function() { return this.smallestTickCount; },
	
	    // Get the tickables in the voice
	    getTickables: function() { return this.tickables; },
	
	    // Get/set the voice mode, use a value from `Voice.Mode`
	    getMode: function() { return this.mode; },
	    setMode: function(mode) { this.mode = mode; return this; },
	
	    // Get the resolution multiplier for the voice
	    getResolutionMultiplier: function() { return this.resolutionMultiplier; },
	
	    // Get the actual tick resolution for the voice
	    getActualResolution: function() { return this.resolutionMultiplier * this.time.resolution; },
	
	    // Set the voice's stave
	    setStave: function(stave) {
	      this.stave = stave;
	      this.boundingBox = null; // Reset bounding box so we can reformat
	      return this;
	    },
	
	    // Get the bounding box for the voice
	    getBoundingBox: function() {
	      var stave, boundingBox, bb, i;
	
	      if (!this.boundingBox) {
	        if (!this.stave) throw Vex.RERR("NoStave", "Can't get bounding box without stave.");
	        stave = this.stave;
	        boundingBox = null;
	
	        for (i = 0; i < this.tickables.length; ++i) {
	          this.tickables[i].setStave(stave);
	
	          bb = this.tickables[i].getBoundingBox();
	          if (!bb) continue;
	
	          boundingBox = boundingBox ? boundingBox.mergeWith(bb) : bb;
	        }
	
	        this.boundingBox = boundingBox;
	      }
	      return this.boundingBox;
	    },
	
	    // Every tickable must be associated with a voiceGroup. This allows formatters
	    // and preformatters to associate them with the right modifierContexts.
	    getVoiceGroup: function() {
	      if (!this.voiceGroup)
	        throw new Vex.RERR("NoVoiceGroup", "No voice group for voice.");
	      return this.voiceGroup;
	    },
	
	    // Set the voice group
	    setVoiceGroup: function(g) { this.voiceGroup = g; return this; },
	
	    // Set the voice mode to strict or soft 
	    setStrict: function(strict) {
	      this.mode = strict ? Vex.Flow.Voice.Mode.STRICT : Vex.Flow.Voice.Mode.SOFT;
	      return this;
	    },
	
	    // Determine if the voice is complete according to the voice mode
	    isComplete: function() {
	      if (this.mode == Vex.Flow.Voice.Mode.STRICT ||
	          this.mode == Vex.Flow.Voice.Mode.FULL) {
	        return this.ticksUsed.equals(this.totalTicks);
	      } else {
	        return true;
	      }
	    },
	
	    // Add a tickable to the voice
	    addTickable: function(tickable) {
	      if (!tickable.shouldIgnoreTicks()) {
	        var ticks = tickable.getTicks();
	
	        // Update the total ticks for this line.
	        this.ticksUsed.add(ticks);
	
	        if ((this.mode == Vex.Flow.Voice.Mode.STRICT ||
	             this.mode == Vex.Flow.Voice.Mode.FULL) &&
	             this.ticksUsed.greaterThan(this.totalTicks)) {
	          this.totalTicks.subtract(ticks);
	          throw new Vex.RERR("BadArgument", "Too many ticks.");
	        }
	
	        // Track the smallest tickable for formatting.
	        if (ticks.lessThan(this.smallestTickCount)) {
	          this.smallestTickCount = ticks.clone();
	        }
	
	        this.resolutionMultiplier = this.ticksUsed.denominator;
	
	        // Expand total ticks using denominator from ticks used.
	        this.totalTicks.add(0, this.ticksUsed.denominator);
	      }
	
	      // Add the tickable to the line.
	      this.tickables.push(tickable);
	      tickable.setVoice(this);
	      return this;
	    },
	
	    // Add an array of tickables to the voice.
	    addTickables: function(tickables) {
	      for (var i = 0; i < tickables.length; ++i) {
	        this.addTickable(tickables[i]);
	      }
	
	      return this;
	    },
	
	    // Preformats the voice by applying the voice's stave to each note.
	    preFormat: function(){
	      if (this.preFormatted) return;
	
	      this.tickables.forEach(function(tickable) {
	        if (!tickable.getStave()) {
	          tickable.setStave(this.stave);
	        }
	      }, this);
	
	      this.preFormatted = true;
	      return this;
	    },
	
	    // Render the voice onto the canvas `context` and an optional `stave`.
	    // If `stave` is omitted, it is expected that the notes have staves
	    // already set.
	    draw: function(context, stave) {
	      var boundingBox = null;
	      for (var i = 0; i < this.tickables.length; ++i) {
	        var tickable = this.tickables[i];
	
	        // Set the stave if provided
	        if (stave) tickable.setStave(stave);
	
	        if (!tickable.getStave()) {
	          throw new Vex.RuntimeError("MissingStave",
	            "The voice cannot draw tickables without staves.");
	        }
	
	        if (i === 0) boundingBox = tickable.getBoundingBox();
	
	        if (i > 0 && boundingBox) {
	          var tickable_bb = tickable.getBoundingBox();
	          if (tickable_bb) boundingBox.mergeWith(tickable_bb);
	        }
	
	       tickable.setContext(context);
	       tickable.draw();
	      }
	
	      this.boundingBox = boundingBox;
	    }
	  };
	
	  return Voice;
	}());
	// Vex Music Notation
	// Mohit Muthanna <mohit@muthanna.com>
	//
	// Copyright Mohit Muthanna 2010
	
	/** @constructor */
	Vex.Flow.VoiceGroup = (function() {
	  function VoiceGroup() {
	    this.init();
	  }
	
	  VoiceGroup.prototype = {
	    init: function() {
	      this.voices = [];
	      this.modifierContexts = [];
	    },
	
	    // Every tickable must be associated with a voiceGroup. This allows formatters
	    // and preformatters to associate them with the right modifierContexts.
	    getVoices: function() { return this.voices; },
	    getModifierContexts: function() { return this.modifierContexts; },
	
	    addVoice: function(voice) {
	      if (!voice) throw new Vex.RERR("BadArguments", "Voice cannot be null.");
	      this.voices.push(voice);
	      voice.setVoiceGroup(this);
	    }
	  };
	
	  return VoiceGroup;
	}());
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// `Modifier` is an abstract interface for notational elements that modify
	// a `Note`. Examples of modifiers are `Accidental`, `Annotation`, `Stroke`, etc.
	//
	// For a `Modifier` instance to be positioned correctly, it must be part of
	// a `ModifierContext`. All modifiers in the same context are rendered relative to
	// one another.
	//
	// Typically, all modifiers to a note are part of the same `ModifierContext` instance. Also,
	// in multi-voice staves, all modifiers to notes on the same `tick` are part of the same
	// `ModifierContext`. This ensures that multiple voices don't trample all over each other.
	
	Vex.Flow.Modifier = (function() {
	  function Modifier() {
	    this.constructor = Modifier;
	    this.init();
	  }
	  Modifier.CATEGORY = "none";
	
	    // To enable logging for this class. Set `Vex.Flow.Modifier.DEBUG` to `true`.
	  function L() { if (Modifier.DEBUG) Vex.L("Vex.Flow.Modifier", arguments); }
	
	  // Modifiers can be positioned almost anywhere, relative to a note.
	  Modifier.Position = {
	    LEFT: 1,
	    RIGHT: 2,
	    ABOVE: 3,
	    BELOW: 4
	  };
	
	  // ## Prototype Methods
	  Modifier.prototype = {
	
	    // The constructor sets initial widths and constants.
	    init: function() {
	      this.width = 0;
	      this.context = null;
	
	      // Modifiers are attached to a note and an index. An index is a
	      // specific head in a chord.
	      this.note = null;
	      this.index = null;
	
	      // The `text_line` is reserved space above or below a stave.
	      this.text_line = 0;
	      this.position = Modifier.Position.LEFT;
	      this.modifier_context = null;
	      this.x_shift = 0;
	      this.y_shift = 0;
	      this.spacingFromNextModifier = 0;
	      L("Created new modifier");
	    },
	
	    // Every modifier has a category. The `ModifierContext` uses this to determine
	    // the type and order of the modifiers.
	    getCategory: function() { return this.constructor.CATEGORY; },
	
	    // Get and set modifier widths.
	    getWidth: function() { return this.width; },
	    setWidth: function(width) { this.width = width; return this; },
	
	    // Get and set attached note (`StaveNote`, `TabNote`, etc.)
	    getNote: function() { return this.note; },
	    setNote: function(note) { this.note = note; return this; },
	
	    // Get and set note index, which is a specific note in a chord.
	    getIndex: function() { return this.index; },
	    setIndex: function(index) { this.index = index; return this; },
	
	    // Get and set rendering context.
	    getContext: function() { return this.context; },
	    setContext: function(context) { this.context = context; return this; },
	
	    // Every modifier must be part of a `ModifierContext`.
	    getModifierContext: function() { return this.modifier_context; },
	    setModifierContext: function(c) { this.modifier_context = c; return this; },
	
	    // Get and set articulation position.
	    getPosition: function() { return this.position; },
	    setPosition: function(position) { this.position = position; return this; },
	
	    // Set the `text_line` for the modifier.
	    setTextLine: function(line) { this.text_line = line; return this; },
	
	    // Shift modifier down `y` pixels. Negative values shift up.
	    setYShift: function(y) { this.y_shift = y; return this; },
	
	    setSpacingFromNextModifier: function(x) {
	      this.spacingFromNextModifier = x;
	    },
	
	    getSpacingFromNextModifier: function() {return this.spacingFromNextModifier; },
	
	    // Shift modifier `x` pixels in the direction of the modifier. Negative values
	    // shift reverse.
	    setXShift: function(x) {
	      this.x_shift = 0;
	      if (this.position == Modifier.Position.LEFT) {
	        this.x_shift -= x;
	      } else {
	        this.x_shift += x;
	      }
	    },
	    getXShift: function() {return this.x_shift;},
	
	    // Render the modifier onto the canvas.
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw without a canvas context.");
	      throw new Vex.RERR("MethodNotImplemented",
	          "Draw() not implemented for this modifier.");
	    }
	  };
	
	  return Modifier;
	}());
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This class implements various types of modifiers to notes (e.g. bends,
	// fingering positions etc.)
	
	Vex.Flow.ModifierContext = (function() {
	  function ModifierContext() {
	    // Current modifiers
	    this.modifiers = {};
	
	    // Formatting data.
	    this.preFormatted = false;
	    this.postFormatted = false;
	    this.width = 0;
	    this.spacing = 0;
	    this.state = {
	      left_shift: 0,
	      right_shift: 0,
	      text_line: 0,
	      top_text_line: 0
	    };
	
	    // Add new modifiers to this array. The ordering is significant -- lower
	    // modifiers are formatted and rendered before higher ones.
	    this.PREFORMAT = [
	      Vex.Flow.StaveNote,
	      Vex.Flow.Dot,
	      Vex.Flow.FretHandFinger,
	      Vex.Flow.Accidental,
	      Vex.Flow.GraceNoteGroup,
	      Vex.Flow.Stroke,
	      Vex.Flow.StringNumber,
	      Vex.Flow.Articulation,
	      Vex.Flow.Ornament,
	      Vex.Flow.Annotation,
	      Vex.Flow.Bend,
	      Vex.Flow.Vibrato
	    ];
	
	    // If post-formatting is required for an element, add it to this array.
	    this.POSTFORMAT = [ Vex.Flow.StaveNote ];
	  }
	
	  // To enable logging for this class. Set `Vex.Flow.ModifierContext.DEBUG` to `true`.
	  function L() { if (ModifierContext.DEBUG) Vex.L("Vex.Flow.ModifierContext", arguments); }
	
	  ModifierContext.prototype = {
	    addModifier: function(modifier) {
	      var type = modifier.getCategory();
	      if (!this.modifiers[type]) this.modifiers[type] = [];
	      this.modifiers[type].push(modifier);
	      modifier.setModifierContext(this);
	      this.preFormatted = false;
	      return this;
	    },
	
	    getModifiers: function(type) { return this.modifiers[type]; },
	    getWidth: function() { return this.width; },
	    getExtraLeftPx: function() { return this.state.left_shift; },
	    getExtraRightPx: function() { return this.state.right_shift; },
	    getState: function() { return this.state; },
	
	    getMetrics: function() {
	      if (!this.formatted) throw new Vex.RERR("UnformattedModifier",
	          "Unformatted modifier has no metrics.");
	
	      return {
	        width: this.state.left_shift + this.state.right_shift + this.spacing,
	        spacing: this.spacing,
	        extra_left_px: this.state.left_shift,
	        extra_right_px: this.state.right_shift
	      };
	    },
	
	    preFormat: function() {
	      if (this.preFormatted) return;
	      this.PREFORMAT.forEach(function(modifier) {
	        L("Preformatting ModifierContext: ", modifier.CATEGORY);
	        modifier.format(this.getModifiers(modifier.CATEGORY), this.state, this);
	      }, this);
	
	      // Update width of this modifier context
	      this.width = this.state.left_shift + this.state.right_shift;
	      this.preFormatted = true;
	    },
	
	    postFormat: function() {
	      if (this.postFormatted) return;
	      this.POSTFORMAT.forEach(function(modifier) {
	        L("Postformatting ModifierContext: ", modifier.CATEGORY);
	        modifier.postFormat(this.getModifiers(modifier.CATEGORY), this);
	      }, this);
	    }
	  };
	
	  return ModifierContext;
	}());
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// @author Mohit Cheppudira
	// @author Greg Ristow (modifications)
	//
	// ## Description
	//
	// This file implements accidentals as modifiers that can be attached to
	// notes. Support is included for both western and microtonal accidentals.
	//
	// See `tests/accidental_tests.js` for usage examples.
	
	Vex.Flow.Accidental = (function(){
	  function Accidental(type) {
	    if (arguments.length > 0) this.init(type);
	  }
	  Accidental.CATEGORY = "accidentals";
	
	  // To enable logging for this class. Set `Vex.Flow.Accidental.DEBUG` to `true`.
	  function L() { if (Accidental.DEBUG) Vex.L("Vex.Flow.Accidental", arguments); }
	
	  var Modifier = Vex.Flow.Modifier;
	
	  // ## Static Methods
	  //
	  // Arrange accidentals inside a ModifierContext.
	  Accidental.format = function(accidentals, state) {
	    var left_shift = state.left_shift;
	    var accidental_spacing = 2;
	
	    // If there are no accidentals, we needn't format their positions
	    if (!accidentals || accidentals.length === 0) return false;
	
	    var acc_list = [];
	    var hasStave = false;
	    var prev_note = null;
	    var shiftL = 0;
	
	    // First determine the accidentals' Y positions from the note.keys
	    var i, acc, props_tmp;
	    for (i = 0; i < accidentals.length; ++i) {
	      acc = accidentals[i];
	      var note = acc.getNote();
	      var stave = note.getStave();
	      var props = note.getKeyProps()[acc.getIndex()];
	      if (note != prev_note) {
	         // Iterate through all notes to get the displaced pixels
	         for (var n = 0; n < note.keys.length; ++n) {
	            props_tmp = note.getKeyProps()[n];
	            shiftL = (props_tmp.displaced ? note.getExtraLeftPx() : shiftL);
	          }
	          prev_note = note;
	      }
	      if (stave !== null) {
	        hasStave = true;
	        var line_space = stave.options.spacing_between_lines_px;
	        var y = stave.getYForLine(props.line);
	        var acc_line = Math.round(y / line_space * 2)/2;
	        acc_list.push({ y: y, line: acc_line, shift: shiftL, acc: acc, lineSpace: line_space });
	      } else {
	        acc_list.push({ line: props.line, shift: shiftL, acc: acc });
	      }
	    }
	
	    // Sort accidentals by line number.
	    acc_list.sort(function(a, b) { return (b.line - a.line); });
	
	    // Create an array of unique line numbers (line_list) from acc_list
	    var line_list = []; // an array of unique line numbers
	    var acc_shift = 0; // amount by which all accidentals must be shifted right or left for stem flipping, notehead shifting concerns.
	    var previous_line = null;
	
	    for(i = 0; i<acc_list.length; i++) {
	      acc = acc_list[i];
	
	      // if this is the first line, or a new line, add a line_list
	      if( (previous_line === null) || (previous_line != acc.line) ) {
	        line_list.push({line : acc.line, flat_line : true, dbl_sharp_line: true, num_acc : 0, width : 0});
	      }
	      // if this accidental is not a flat, the accidental needs 3.0 lines lower
	      // clearance instead of 2.5 lines for b or bb.
	      if( (acc.acc.type != "b") && (acc.acc.type !="bb") ) {
	        line_list[line_list.length - 1].flat_line = false;
	      }
	      // if this accidental is not a double sharp, the accidental needs 3.0 lines above
	      if( acc.acc.type != "##")
	        line_list[line_list.length - 1].dbl_sharp_line = false;
	
	      // Track how many accidentals are on this line:
	      line_list[line_list.length - 1].num_acc++;
	
	      // Track the total x_offset needed for this line which will be needed
	      // for formatting lines w/ multiple accidentals:
	
	      //width = accidental width + universal spacing between accidentals
	      line_list[line_list.length - 1].width += acc.acc.getWidth() + accidental_spacing;
	
	      // if this acc_shift is larger, use it to keep first column accidentals in the same line
	      acc_shift = ( (acc.shift > acc_shift) ? acc.shift : acc_shift);
	
	      previous_line = acc.line;
	    }
	
	    // ### Place Accidentals in Columns
	    //
	    // Default to a classic triangular layout (middle accidental farthest left),
	    // but follow exceptions as outlined in G. Read's _Music Notation_ and
	    // Elaine Gould's _Behind Bars_.
	    //
	    // Additionally, this implements different vertical colission rules for
	    // flats (only need 2.5 lines clearance below) and double sharps (only
	    // need 2.5 lines of clearance above or below).
	    //
	    // Classic layouts and exception patterns are found in the 'tables.js'
	    // in 'Vex.Flow.accidentalColumnsTable'
	    //
	    // Beyond 6 vertical accidentals, default to the parallel ascending lines approach,
	    // using as few columns as possible for the verticle structure.
	    //
	    // TODO (?): Allow column to be specified for an accidental at run-time?
	
	    var total_columns = 0;
	
	    // establish the boundaries for a group of notes with clashing accidentals:
	    for(i = 0; i<line_list.length; i++) {
	      var no_further_conflicts = false;
	      var group_start = i;
	      var group_end = i;
	
	      group_check_while : while( (group_end+1 < line_list.length) && (!no_further_conflicts) ) {
	        // if this note conflicts with the next:
	        if(this.checkCollision(line_list[group_end], line_list[group_end + 1])) {
	        // include the next note in the group:
	          group_end++;
	        }
	        else no_further_conflicts = true;
	      }
	
	      // Set columns for the lines in this group:
	      var group_length = group_end - group_start + 1;
	
	      // Set the accidental column for each line of the group
	      var end_case = (this.checkCollision(line_list[group_start], line_list[group_end])) ? "a" : "b";
	
	
	        var checkCollision = this.checkCollision;
	        switch(group_length) {
	          case 3:
	            if( (end_case == "a") &&
	                (line_list[group_start+1].line - line_list[group_start+2].line == 0.5) &&
	                (line_list[group_start].line - line_list[group_start + 1].line != 0.5) )
	              end_case = "second_on_bottom";
	              break;
	          case 4:
	            if( (!checkCollision(line_list[group_start], line_list[group_start+2])) &&
	                (!checkCollision(line_list[group_start+1], line_list[group_start+3])) )
	              end_case = "spaced_out_tetrachord";
	              break;
	          case 5:
	            if( (end_case == "b") &&
	                (!checkCollision(line_list[group_start+1], line_list[group_start+3])) )
	              end_case = "spaced_out_pentachord";
	            if( (end_case == "spaced_out_pentachord") &&
	                (!checkCollision(line_list[group_start], line_list[group_start+2])) &&
	                (!checkCollision(line_list[group_start+2], line_list[group_start+4])) )
	              end_case = "very_spaced_out_pentachord";
	              break;
	          case 6:
	            if( (!checkCollision(line_list[group_start], line_list[group_start+3])) &&
	                (!checkCollision(line_list[group_start+1], line_list[group_start+4])) &&
	                (!checkCollision(line_list[group_start+2], line_list[group_start+5])) )
	              end_case = "spaced_out_hexachord";
	            if( (!checkCollision(line_list[group_start], line_list[group_start+2])) &&
	                (!checkCollision(line_list[group_start+2], line_list[group_start+4])) &&
	                (!checkCollision(line_list[group_start+1], line_list[group_start+3])) &&
	                (!checkCollision(line_list[group_start+3], line_list[group_start+5])) )
	              end_case = "very_spaced_out_hexachord";
	              break;
	        }
	
	      var group_member;
	      var column;
	      // If the group contains more than seven members, use ascending parallel lines
	      // of accidentals, using as few columns as possible while avoiding collisions.
	      if (group_length>=7) {
	        // First, determine how many columns to use:
	        var pattern_length = 2;
	        var colission_detected = true;
	        while(colission_detected === true) {
	          colission_detected = false;
	          colission_detecter : for(var line = 0; line + pattern_length < line_list.length; line++) {
	            if(this.checkCollision(line_list[line], line_list[line+pattern_length])) {
	              colission_detected = true;
	              pattern_length++;
	              break colission_detecter;
	            }
	          }
	        }
	        // Then, assign a column to each line of accidentals
	        for(group_member = i; group_member <= group_end; group_member++) {
	          column = ((group_member-i) % pattern_length) + 1;
	          line_list[group_member].column = column;
	          total_columns = (total_columns > column) ? total_columns : column;
	        }
	
	      // Otherwise, if the group contains fewer than seven members, use the layouts from
	      // the accidentalsColumnsTable housed in tables.js.
	      } else {
	        for(group_member = i; group_member <= group_end; group_member++) {
	          column = Vex.Flow.accidentalColumnsTable[group_length][end_case][group_member-i];
	          line_list[group_member].column = column;
	          total_columns = (total_columns > column) ? total_columns : column;
	        }
	      }
	
	      // Increment i to the last note that was set, so that if a lower set of notes
	      // does not conflict at all with this group, it can have its own classic shape.
	      i = group_end;
	    }
	
	    // ### Convert Columns to x_offsets
	    //
	    // This keeps columns aligned, even if they have different accidentals within them
	    // which sometimes results in a larger x_offset than is an accidental might need
	    // to preserve the symmetry of the accidental shape.
	    //
	    // Neither A.C. Vinci nor G. Read address this, and it typically only happens in
	    // music with complex chord clusters.
	    //
	    // TODO (?): Optionally allow closer compression of accidentals, instead of forcing
	    // parallel columns.
	
	    // track each column's max width, which will be used as initial shift of later columns:
	    var column_widths = [];
	    var column_x_offsets = [];
	    for(i=0; i<=total_columns; i++) {
	      column_widths[i] = 0;
	      column_x_offsets[i] = 0;
	    }
	
	    column_widths[0] = acc_shift + left_shift;
	    column_x_offsets[0] = acc_shift + left_shift;
	
	    // Fill column_widths with widest needed x-space;
	    // this is what keeps the columns parallel.
	    line_list.forEach(function(line) {
	      if(line.width > column_widths[line.column]) column_widths[line.column] = line.width;
	    });
	
	    for(i=1; i<column_widths.length; i++) {
	      // this column's offset = this column's width + previous column's offset
	      column_x_offsets[i] = column_widths[i] + column_x_offsets[i-1];
	    }
	
	    var total_shift = column_x_offsets[column_x_offsets.length-1];
	    // Set the x_shift for each accidental according to column offsets:
	    var acc_count = 0;
	    line_list.forEach(function(line) {
	      var line_width = 0;
	      var last_acc_on_line = acc_count + line.num_acc;
	      // handle all of the accidentals on a given line:
	      for(acc_count; acc_count<last_acc_on_line; acc_count++) {
	        var x_shift = (column_x_offsets[line.column-1] + line_width);
	        acc_list[acc_count].acc.setXShift(x_shift);
	        // keep track of the width of accidentals we've added so far, so that when
	        // we loop, we add space for them.
	        line_width += acc_list[acc_count].acc.getWidth() + accidental_spacing;
	        L("Line, acc_count, shift: ", line.line, acc_count, x_shift);
	      }
	    });
	
	    // update the overall layout with the full width of the accidental shapes:
	    state.left_shift += total_shift;
	  };
	
	  // Helper function to determine whether two lines of accidentals collide vertically
	  Accidental.checkCollision = function(line_1, line_2) {
	    var clearance = line_2.line - line_1.line;
	    var clearance_required = 3;
	    // But less clearance is required for certain accidentals: b, bb and ##.
	    if(clearance>0) { // then line 2 is on top
	      clearance_required = (line_2.flat_line || line_2.dbl_sharp_line) ? 2.5 : 3.0;
	      if(line_1.dbl_sharp_line) clearance -= 0.5;
	    } else { // line 1 is on top
	      clearance_required = (line_1.flat_line || line_1.dbl_sharp_line) ? 2.5 : 3.0;
	      if(line_2.dbl_sharp_line) clearance -= 0.5;
	    }
	    var colission = (Math.abs(clearance) < clearance_required);
	    L("Line_1, Line_2, Collision: ", line_1.line, line_2.line, colission);
	    return(colission);
	  };
	
	  // ## Prototype Methods
	  //
	  // An `Accidental` inherits from `Modifier`, and is formatted within a
	  // `ModifierContext`.
	  Vex.Inherit(Accidental, Modifier, {
	    // Create accidental. `type` can be a value from the
	    // `Vex.Flow.accidentalCodes.accidentals` table in `tables.js`. For
	    // example: `#`, `##`, `b`, `n`, etc.
	    init: function(type) {
	      Accidental.superclass.init.call(this);
	      L("New accidental: ", type);
	
	      this.note = null;
	      // The `index` points to a specific note in a chord.
	      this.index = null;
	      this.type = type;
	      this.position = Modifier.Position.LEFT;
	
	      this.render_options = {
	        // Font size for glyphs
	        font_scale: 38,
	
	        // Length of stroke across heads above or below the stave.
	        stroke_px: 3
	      };
	
	      this.accidental = Vex.Flow.accidentalCodes(this.type);
	      if (!this.accidental) throw new Vex.RERR("ArgumentError", "Unknown accidental type: " + type);
	
	      // Cautionary accidentals have parentheses around them
	      this.cautionary = false;
	      this.paren_left = null;
	      this.paren_right = null;
	
	      // Initial width is set from table.
	      this.setWidth(this.accidental.width);
	    },
	
	    // Attach this accidental to `note`, which must be a `StaveNote`.
	    setNote: function(note){
	      if (!note) throw new Vex.RERR("ArgumentError", "Bad note value: " + note);
	      this.note = note;
	
	      // Accidentals attached to grace notes are rendered smaller.
	      if (this.note.getCategory() === 'gracenotes') {
	        this.render_options.font_scale = 25;
	        this.setWidth(this.accidental.gracenote_width);
	      }
	    },
	
	    // If called, draws parenthesis around accidental.
	    setAsCautionary: function() {
	      this.cautionary = true;
	      this.render_options.font_scale = 28;
	      this.paren_left = Vex.Flow.accidentalCodes("{");
	      this.paren_right = Vex.Flow.accidentalCodes("}");
	      var width_adjust = (this.type == "##" || this.type == "bb") ? 6 : 4;
	
	      // Make sure `width` accomodates for parentheses.
	      this.setWidth(this.paren_left.width + this.accidental.width + this.paren_right.width - width_adjust);
	      return this;
	    },
	
	    // Render accidental onto canvas.
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoContext",
	        "Can't draw accidental without a context.");
	      if (!(this.note && (this.index != null))) throw new Vex.RERR("NoAttachedNote",
	        "Can't draw accidental without a note and index.");
	
	      // Figure out the start `x` and `y` coordinates for this note and index.
	      var start = this.note.getModifierStartXY(this.position, this.index);
	      var acc_x = ((start.x + this.x_shift) - this.width);
	      var acc_y = start.y + this.y_shift;
	      L("Rendering: ", this.type, acc_x, acc_y);
	
	      if (!this.cautionary) {
	        // Render the accidental alone.
	        Vex.Flow.renderGlyph(this.context, acc_x, acc_y,
	                             this.render_options.font_scale, this.accidental.code);
	      } else {
	        // Render the accidental in parentheses.
	        acc_x += 3;
	        Vex.Flow.renderGlyph(this.context, acc_x, acc_y,
	                             this.render_options.font_scale, this.paren_left.code);
	        acc_x += 2;
	        Vex.Flow.renderGlyph(this.context, acc_x, acc_y,
	                             this.render_options.font_scale, this.accidental.code);
	        acc_x += this.accidental.width - 2;
	        if (this.type == "##" || this.type == "bb") acc_x -= 2;
	        Vex.Flow.renderGlyph(this.context, acc_x, acc_y,
	                             this.render_options.font_scale, this.paren_right.code);
	      }
	    }
	  });
	
	  // ## Static Methods
	  //
	  // Use this method to automatically apply accidentals to a set of `voices`.
	  // The accidentals will be remembered between all the voices provided.
	  // Optionally, you can also provide an initial `keySignature`.
	  Accidental.applyAccidentals = function(voices, keySignature) {
	    var tickPositions = [];
	    var tickNoteMap = {};
	
	    // Sort the tickables in each voice by their tick position in the voice
	    voices.forEach(function(voice) {
	      var tickPosition = new Vex.Flow.Fraction(0, 1);
	      var notes = voice.getTickables();
	      notes.forEach(function(note) {
	        var notesAtPosition = tickNoteMap[tickPosition.value()];
	
	        if (!notesAtPosition) {
	          tickPositions.push(tickPosition.value());
	          tickNoteMap[tickPosition.value()] = [note];
	        } else {
	          notesAtPosition.push(note);
	        }
	
	        tickPosition.add(note.getTicks());
	      });
	    });
	
	    var music = new Vex.Flow.Music();
	
	    // Default key signature is C major
	    if (!keySignature) keySignature = "C";
	
	    // Get the scale map, which represents the current state of each pitch
	    var scaleMap = music.createScaleMap(keySignature);
	
	    tickPositions.forEach(function(tick) {
	      var notes = tickNoteMap[tick];
	
	      // Array to store all pitches that modified accidental states
	      // at this tick position
	      var modifiedPitches = [];
	
	      notes.forEach(function(note) {
	          if (note.isRest()) return;
	
	          // Go through each key and determine if an accidental should be
	          // applied
	          note.keys.forEach(function(keyString, keyIndex) {
	              var key = music.getNoteParts(keyString.split('/')[0]);
	
	              // Force a natural for every key without an accidental
	              var accidentalString = key.accidental || "n";
	              var pitch = key.root + accidentalString;
	
	              // Determine if the current pitch has the same accidental
	              // as the scale state
	              var sameAccidental = scaleMap[key.root] === pitch;
	
	              // Determine if an identical pitch in the chord already
	              // modified the accidental state
	              var previouslyModified = modifiedPitches.indexOf(pitch) > -1;
	
	              // Add the accidental to the StaveNote
	              if (!sameAccidental || (sameAccidental && previouslyModified)) {
	                  // Modify the scale map so that the root pitch has an
	                  // updated state
	                  scaleMap[key.root] = pitch;
	
	                  // Create the accidental
	                  var accidental = new Vex.Flow.Accidental(accidentalString);
	
	                  // Attach the accidental to the StaveNote
	                  note.addAccidental(keyIndex, accidental);
	
	                  // Add the pitch to list of pitches that modified accidentals
	                  modifiedPitches.push(pitch);
	              }
	          });
	      });
	    });
	  };
	
	  return Accidental;
	}());
	
	// VexFlow - Music Engraving for HTML5
	// Copyright Mohit Muthanna 2010
	//
	// This class implements dot modifiers for notes.
	
	/**
	 * @constructor
	 */
	Vex.Flow.Dot = (function() {
	  function Dot() {
	    this.init();
	  }
	
	  Dot.CATEGORY = "dots";
	
	  var Modifier = Vex.Flow.Modifier;
	
	  // Arrange dots inside a ModifierContext.
	  Dot.format = function(dots, state) {
	    var right_shift = state.right_shift;
	    var dot_spacing = 1;
	
	    if (!dots || dots.length === 0) return false;
	
	    var i, dot, note, shift;
	    var dot_list = [];
	    for (i = 0; i < dots.length; ++i) {
	      dot = dots[i];
	      note = dot.getNote();
	
	      var props;
	      // Only StaveNote has .getKeyProps()
	      if (typeof note.getKeyProps === 'function') {
	        props = note.getKeyProps()[dot.getIndex()];
	        shift = (props.displaced ? note.getExtraRightPx() : 0);
	      } else { // Else it's a TabNote
	        props = { line: 0.5 }; // Shim key props for dot placement
	        shift = 0;
	      }
	
	      dot_list.push({ line: props.line, shift: shift, note: note, dot: dot });
	    }
	
	    // Sort dots by line number.
	    dot_list.sort(function(a, b) { return (b.line - a.line); });
	
	    var dot_shift = right_shift;
	    var x_width = 0;
	    var last_line = null;
	    var last_note = null;
	    var prev_dotted_space = null;
	    var half_shiftY = 0;
	
	    for (i = 0; i < dot_list.length; ++i) {
	      dot = dot_list[i].dot;
	      note = dot_list[i].note;
	      shift = dot_list[i].shift;
	      var line = dot_list[i].line;
	
	      // Reset the position of the dot every line.
	      if (line != last_line || note != last_note) {
	        dot_shift = shift;
	      }
	
	      if (!note.isRest() && line != last_line) {
	        if (Math.abs(line % 1) == 0.5) {
	          // note is on a space, so no dot shift
	          half_shiftY = 0;
	        } else if (!note.isRest()) {
	          // note is on a line, so shift dot to space above the line
	          half_shiftY = 0.5;
	          if (last_note != null &&
	              !last_note.isRest() && last_line - line == 0.5) {
	            // previous note on a space, so shift dot to space below the line
	            half_shiftY = -0.5;
	          } else if (line + half_shiftY == prev_dotted_space) {
	            // previous space is dotted, so shift dot to space below the line
	             half_shiftY = -0.5;
	          }
	        }
	      }
	
	      // convert half_shiftY to a multiplier for dots.draw()
	      dot.dot_shiftY = (-half_shiftY);
	      prev_dotted_space = line + half_shiftY;
	
	      dot.setXShift(dot_shift);
	      dot_shift += dot.getWidth() + dot_spacing; // spacing
	      x_width = (dot_shift > x_width) ? dot_shift : x_width;
	      last_line = line;
	      last_note = note;
	    }
	
	    // Update state.
	    state.right_shift += x_width;
	  };
	
	  Vex.Inherit(Dot, Modifier, {
	    init: function() {
	      Dot.superclass.init.call(this);
	
	      this.note = null;
	      this.index = null;
	      this.position = Modifier.Position.RIGHT;
	
	      this.radius = 2;
	      this.setWidth(5);
	      this.dot_shiftY = 0;
	    },
	
	    setNote: function(note){
	      this.note = note;
	
	      if (this.note.getCategory() === 'gracenotes') {
	        this.radius *= 0.50;
	        this.setWidth(3);
	      }
	    },
	
	    setDotShiftY: function(y) { this.dot_shiftY = y; return this; },
	
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoContext",
	        "Can't draw dot without a context.");
	      if (!(this.note && (this.index != null))) throw new Vex.RERR("NoAttachedNote",
	        "Can't draw dot without a note and index.");
	
	      var line_space = this.note.stave.options.spacing_between_lines_px;
	
	      var start = this.note.getModifierStartXY(this.position, this.index);
	
	      // Set the starting y coordinate to the base of the stem for TabNotes
	      if (this.note.getCategory() === 'tabnotes') {
	        start.y = this.note.getStemExtents().baseY;
	      }
	
	      var dot_x = (start.x + this.x_shift) + this.width - this.radius;
	      var dot_y = start.y + this.y_shift + (this.dot_shiftY * line_space);
	      var ctx = this.context;
	
	      ctx.beginPath();
	      ctx.arc(dot_x, dot_y, this.radius, 0, Math.PI * 2, false);
	      ctx.fill();
	    }
	  });
	
	  return Dot;
	}());
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements the formatting and layout algorithms that are used
	// to position notes in a voice. The algorithm can align multiple voices both
	// within a stave, and across multiple staves.
	//
	// To do this, the formatter breaks up voices into a grid of rational-valued
	// `ticks`, to which each note is assigned. Then, minimum widths are assigned
	// to each tick based on the widths of the notes and modifiers in that tick. This
	// establishes the smallest amount of space required for each tick.
	//
	// Finally, the formatter distributes the left over space proportionally to
	// all the ticks, setting the `x` values of the notes in each tick.
	//
	// See `tests/formatter_tests.js` for usage examples. The helper functions included
	// here (`FormatAndDraw`, `FormatAndDrawTab`) also serve as useful usage examples.
	
	Vex.Flow.Formatter = (function() {
	  function Formatter() {
	    // Minimum width required to render all the notes in the voices.
	    this.minTotalWidth = 0;
	
	    // This is set to `true` after `minTotalWidth` is calculated.
	    this.hasMinTotalWidth = false;
	
	    // The suggested amount of space for each tick.
	    this.pixelsPerTick = 0;
	
	    // Total number of ticks in the voice.
	    this.totalTicks = new Vex.Flow.Fraction(0, 1);
	
	    // Arrays of tick and modifier contexts.
	    this.tContexts = null;
	    this.mContexts = null;
	  }
	
	  // To enable logging for this class. Set `Vex.Flow.Formatter.DEBUG` to `true`.
	  function L() { if (Formatter.DEBUG) Vex.L("Vex.Flow.Formatter", arguments); }
	
	  // ## Private Helpers
	  //
	  // Helper function to locate the next non-rest note(s).
	  function lookAhead(notes, rest_line, i, compare) {
	    // If no valid next note group, next_rest_line is same as current.
	    var next_rest_line = rest_line;
	
	    // Get the rest line for next valid non-rest note group.
	    i++;
	    while (i < notes.length) {
	      if (!notes[i].isRest() && !notes[i].shouldIgnoreTicks()) {
	        next_rest_line = notes[i].getLineForRest();
	        break;
	      }
	      i++;
	    }
	
	    // Locate the mid point between two lines.
	    if (compare && rest_line != next_rest_line) {
	      var top = Vex.Max(rest_line, next_rest_line);
	      var bot = Vex.Min(rest_line, next_rest_line);
	      next_rest_line = Vex.MidLine(top, bot);
	    }
	    return next_rest_line;
	  }
	
	  // Take an array of `voices` and place aligned tickables in the same context. Returns
	  // a mapping from `tick` to `context_type`, a list of `tick`s, and the resolution
	  // multiplier.
	  //
	  // Params:
	  // * `voices`: Array of `Voice` instances.
	  // * `context_type`: A context class (e.g., `ModifierContext`, `TickContext`)
	  // * `add_fn`: Function to add tickable to context.
	  function createContexts(voices, context_type, add_fn) {
	    if (!voices || !voices.length) throw new Vex.RERR("BadArgument",
	        "No voices to format");
	
	    // Initialize tick maps.
	    var totalTicks = voices[0].getTotalTicks();
	    var tickToContextMap = {};
	    var tickList = [];
	    var contexts = [];
	
	    var resolutionMultiplier = 1;
	
	    // Find out highest common multiple of resolution multipliers.
	    // The purpose of this is to find out a common denominator
	    // for all fractional tick values in all tickables of all voices,
	    // so that the values can be expanded and the numerator used
	    // as an integer tick value.
	    var i; // shared iterator
	    var voice;
	    for (i = 0; i < voices.length; ++i) {
	      voice = voices[i];
	      if (!(voice.getTotalTicks().equals(totalTicks))) {
	        throw new Vex.RERR("TickMismatch",
	            "Voices should have same total note duration in ticks.");
	      }
	
	      if (voice.getMode() == Vex.Flow.Voice.Mode.STRICT && !voice.isComplete())
	        throw new Vex.RERR("IncompleteVoice",
	          "Voice does not have enough notes.");
	
	      var lcm = Vex.Flow.Fraction.LCM(resolutionMultiplier,
	          voice.getResolutionMultiplier());
	      if (resolutionMultiplier < lcm) {
	        resolutionMultiplier = lcm;
	      }
	    }
	
	    // For each voice, extract notes and create a context for every
	    // new tick that hasn't been seen before.
	    for (i = 0; i < voices.length; ++i) {
	      voice = voices[i];
	
	      var tickables = voice.getTickables();
	
	      // Use resolution multiplier as denominator to expand ticks
	      // to suitable integer values, so that no additional expansion
	      // of fractional tick values is needed.
	      var ticksUsed = new Vex.Flow.Fraction(0, resolutionMultiplier);
	
	      for (var j = 0; j < tickables.length; ++j) {
	        var tickable = tickables[j];
	        var integerTicks = ticksUsed.numerator;
	
	        // If we have no tick context for this tick, create one.
	        if (!tickToContextMap[integerTicks]) {
	          var newContext = new context_type();
	          contexts.push(newContext);
	          tickToContextMap[integerTicks] = newContext;
	        }
	
	        // Add this tickable to the TickContext.
	        add_fn(tickable, tickToContextMap[integerTicks]);
	
	        // Maintain a sorted list of tick contexts.
	        tickList.push(integerTicks);
	        ticksUsed.add(tickable.getTicks());
	      }
	    }
	
	    return {
	      map: tickToContextMap,
	      array: contexts,
	      list: Vex.SortAndUnique(tickList, function(a, b) { return a - b; },
	          function(a, b) { return a === b; } ),
	      resolutionMultiplier: resolutionMultiplier
	    };
	  }
	
	
	  // ## Static Methods
	  //
	  // Helper function to format and draw a single voice. Returns a bounding
	  // box for the notation.
	  //
	  // Parameters:
	  // * `ctx` - The rendering context
	  // * `stave` - The stave to which to draw (`Stave` or `TabStave`)
	  // * `notes` - Array of `Note` instances (`StaveNote`, `TextNote`, `TabNote`, etc.)
	  // * `params` - One of below:
	  //    * Setting `autobeam` only `(context, stave, notes, true)` or `(ctx, stave, notes, {autobeam: true})`
	  //    * Setting `align_rests` a struct is needed `(context, stave, notes, {align_rests: true})`
	  //    * Setting both a struct is needed `(context, stave, notes, {autobeam: true, align_rests: true})`
	  //
	  // `autobeam` automatically generates beams for the notes.
	  // `align_rests` aligns rests with nearby notes.
	  Formatter.FormatAndDraw = function(ctx, stave, notes, params) {
	    var opts = {
	      auto_beam: false,
	      align_rests: false
	    };
	
	    if (typeof params == "object") {
	      Vex.Merge(opts, params);
	    } else if (typeof params == "boolean") {
	      opts.auto_beam = params;
	    }
	
	    // Start by creating a voice and adding all the notes to it.
	    var voice = new Vex.Flow.Voice(Vex.Flow.TIME4_4).
	      setMode(Vex.Flow.Voice.Mode.SOFT);
	    voice.addTickables(notes);
	
	    // Then create beams, if requested.
	    var beams = null;
	    if (opts.auto_beam) {
	      beams = Vex.Flow.Beam.applyAndGetBeams(voice);
	    }
	
	    // Instantiate a `Formatter` and format the notes.
	    new Formatter().
	      joinVoices([voice], {align_rests: opts.align_rests}).
	      formatToStave([voice], stave, {align_rests: opts.align_rests});
	
	    // Render the voice and beams to the stave.
	    voice.setStave(stave);
	    voice.draw(ctx, stave);
	    if (beams != null) {
	      for (var i=0; i<beams.length; ++i) {
	        beams[i].setContext(ctx).draw();
	      }
	    }
	
	    // Return the bounding box of the voice.
	    return voice.getBoundingBox();
	  };
	
	  // Helper function to format and draw aligned tab and stave notes in two
	  // separate staves.
	  //
	  // Parameters:
	  // * `ctx` - The rendering context
	  // * `tabstave` - A `TabStave` instance on which to render `TabNote`s.
	  // * `stave` - A `Stave` instance on which to render `Note`s.
	  // * `notes` - Array of `Note` instances for the stave (`StaveNote`, `BarNote`, etc.)
	  // * `tabnotes` - Array of `Note` instances for the tab stave (`TabNote`, `BarNote`, etc.)
	  // * `autobeam` - Automatically generate beams.
	  // * `params` - A configuration object:
	  //    * `autobeam` automatically generates beams for the notes.
	  //    * `align_rests` aligns rests with nearby notes.
	  Formatter.FormatAndDrawTab = function(ctx,
	      tabstave, stave, tabnotes, notes, autobeam, params) {
	    var opts = {
	      auto_beam: autobeam,
	      align_rests: false
	    };
	
	    if (typeof params == "object") {
	      Vex.Merge(opts, params);
	    } else if (typeof params == "boolean") {
	      opts.auto_beam = params;
	    }
	
	    // Create a `4/4` voice for `notes`.
	    var notevoice = new Vex.Flow.Voice(Vex.Flow.TIME4_4).
	      setMode(Vex.Flow.Voice.Mode.SOFT);
	    notevoice.addTickables(notes);
	
	    // Create a `4/4` voice for `tabnotes`.
	    var tabvoice = new Vex.Flow.Voice(Vex.Flow.TIME4_4).
	      setMode(Vex.Flow.Voice.Mode.SOFT);
	    tabvoice.addTickables(tabnotes);
	
	    // Generate beams if requested.
	    var beams = null;
	    if (opts.auto_beam) {
	      beams = Vex.Flow.Beam.applyAndGetBeams(notevoice);
	    }
	
	
	    // Instantiate a `Formatter` and align tab and stave notes.
	    new Formatter().
	      joinVoices([notevoice], {align_rests: opts.align_rests}).
	      joinVoices([tabvoice]).
	      formatToStave([notevoice,tabvoice], stave, {align_rests: opts.align_rests});
	
	    // Render voices and beams to staves.
	    notevoice.draw(ctx, stave);
	    tabvoice.draw(ctx, tabstave);
	    if (beams != null) {
	      for (var i=0; i<beams.length; ++i) {
	        beams[i].setContext(ctx).draw();
	      }
	    }
	
	    // Draw a connector between tab and note staves.
	    (new Vex.Flow.StaveConnector(stave, tabstave)).setContext(ctx).draw();
	  };
	
	  // Auto position rests based on previous/next note positions.
	  //
	  // Params:
	  // * `notes`: An array of notes.
	  // * `align_all_notes`: If set to false, only aligns non-beamed notes.
	  // * `align_tuplets`: If set to false, ignores tuplets.
	  Formatter.AlignRestsToNotes = function(notes, align_all_notes, align_tuplets) {
	    for (var i = 0; i < notes.length; ++i) {
	      if (notes[i] instanceof Vex.Flow.StaveNote && notes[i].isRest()) {
	        var note = notes[i];
	
	        if (note.tuplet && !align_tuplets) continue;
	
	        // If activated rests not on default can be rendered as specified.
	        var position = note.getGlyph().position.toUpperCase();
	        if (position != "R/4" && position != "B/4") {
	          continue;
	        }
	
	        if (align_all_notes || note.beam != null) {
	          // Align rests with previous/next notes.
	          var props = note.getKeyProps()[0];
	          if (i === 0) {
	            props.line = lookAhead(notes, props.line, i, false);
	            note.setKeyLine(0, props.line);
	          } else if (i > 0 && i < notes.length) {
	            // If previous note is a rest, use its line number.
	            var rest_line;
	            if (notes[i-1].isRest()) {
	              rest_line = notes[i-1].getKeyProps()[0].line;
	              props.line = rest_line;
	            } else {
	              rest_line = notes[i-1].getLineForRest();
	              // Get the rest line for next valid non-rest note group.
	              props.line = lookAhead(notes, rest_line, i, true);
	            }
	            note.setKeyLine(0, props.line);
	          }
	        }
	      }
	    }
	
	    return this;
	  };
	
	  // ## Prototype Methods
	  Formatter.prototype = {
	    // Find all the rests in each of the `voices` and align them
	    // to neighboring notes. If `align_all_notes` is `false`, then only
	    // align non-beamed notes.
	    alignRests: function(voices, align_all_notes) {
	      if (!voices || !voices.length) throw new Vex.RERR("BadArgument",
	          "No voices to format rests");
	      for (var i = 0; i < voices.length; i++) {
	        new Formatter.AlignRestsToNotes(voices[i].tickables, align_all_notes);
	      }
	    },
	
	    // Calculate the minimum width required to align and format `voices`.
	    preCalculateMinTotalWidth: function(voices) {
	      // Cache results.
	      if (this.hasMinTotalWidth) return;
	
	      // Create tick contexts if not already created.
	      if (!this.tContexts) {
	        if (!voices) {
	          throw new Vex.RERR("BadArgument",
	                             "'voices' required to run preCalculateMinTotalWidth");
	        }
	        this.createTickContexts(voices);
	      }
	
	      var contexts = this.tContexts;
	      var contextList = contexts.list;
	      var contextMap = contexts.map;
	
	      this.minTotalWidth = 0;
	
	      // Go through each tick context and calculate total width.
	      for (var i = 0; i < contextList.length; ++i) {
	        var context = contextMap[contextList[i]];
	
	        // `preFormat` gets them to descend down to their tickables and modifier
	        // contexts, and calculate their widths.
	        context.preFormat();
	        this.minTotalWidth += context.getWidth();
	      }
	
	      this.hasMinTotalWidth = true;
	
	      return this.minTotalWidth;
	    },
	
	    // Get minimum width required to render all voices. Either `format` or
	    // `preCalculateMinTotalWidth` must be called before this method.
	    getMinTotalWidth: function() {
	      if (!this.hasMinTotalWidth) {
	        throw new Vex.RERR("NoMinTotalWidth",
	            "Need to call 'preCalculateMinTotalWidth' or 'preFormat' before" +
	            " calling 'getMinTotalWidth'");
	      }
	
	      return this.minTotalWidth;
	    },
	
	    // Create `ModifierContext`s for each tick in `voices`.
	    createModifierContexts: function(voices) {
	      var contexts = createContexts(voices,
	          Vex.Flow.ModifierContext,
	          function(tickable, context) {
	            tickable.addToModifierContext(context);
	          });
	      this.mContexts = contexts;
	      return contexts;
	    },
	
	    // Create `TickContext`s for each tick in `voices`. Also calculate the
	    // total number of ticks in voices.
	    createTickContexts: function(voices) {
	      var contexts = createContexts(voices,
	          Vex.Flow.TickContext,
	          function(tickable, context) { context.addTickable(tickable); });
	
	      contexts.array.forEach(function(context) {
	        context.tContexts = contexts.array;
	      });
	
	      this.totalTicks = voices[0].getTicksUsed().clone();
	      this.tContexts = contexts;
	      return contexts;
	    },
	
	    // This is the core formatter logic. Format voices and justify them
	    // to `justifyWidth` pixels. `rendering_context` is required to justify elements
	    // that can't retreive widths without a canvas. This method sets the `x` positions
	    // of all the tickables/notes in the formatter.
	    preFormat: function(justifyWidth, rendering_context, voices, stave) {
	      // Initialize context maps.
	      var contexts = this.tContexts;
	      var contextList = contexts.list;
	      var contextMap = contexts.map;
	
	      // If voices and a stave were provided, set the Stave for each voice
	      // and preFormat to apply Y values to the notes;
	      if (voices && stave) {
	        voices.forEach(function(voice) {
	          voice.setStave(stave);
	          voice.preFormat();
	        });
	      }
	
	      // Figure out how many pixels to allocate per tick.
	      if (!justifyWidth) {
	        justifyWidth = 0;
	        this.pixelsPerTick = 0;
	      } else {
	        this.pixelsPerTick = justifyWidth / (this.totalTicks.value() * contexts.resolutionMultiplier);
	      }
	
	      // Now distribute the ticks to each tick context, and assign them their
	      // own X positions.
	      var x = 0;
	      var center_x = justifyWidth / 2;
	      var white_space = 0; // White space to right of previous note
	      var tick_space = 0;  // Pixels from prev note x-pos to curent note x-pos
	      var prev_tick = 0;
	      var prev_width = 0;
	      var lastMetrics = null;
	      var initial_justify_width = justifyWidth;
	      this.minTotalWidth = 0;
	
	      var i, tick, context;
	
	      // Pass 1: Give each note maximum width requested by context.
	      for (i = 0; i < contextList.length; ++i) {
	        tick = contextList[i];
	        context = contextMap[tick];
	        if (rendering_context) context.setContext(rendering_context);
	
	        // Make sure that all tickables in this context have calculated their
	        // space requirements.
	        context.preFormat();
	
	        var thisMetrics = context.getMetrics();
	        var width = context.getWidth();
	        this.minTotalWidth += width;
	        var min_x = 0;
	        var pixels_used = width;
	
	        // Calculate space between last note and next note.
	        tick_space = Math.min((tick - prev_tick) * this.pixelsPerTick, pixels_used);
	
	        // Shift next note up `tick_space` pixels.
	        var set_x = x + tick_space;
	
	        // Calculate the minimum next note position to allow for right modifiers.
	        if (lastMetrics != null) {
	          min_x = x + prev_width - lastMetrics.extraLeftPx;
	        }
	
	        // Determine the space required for the previous tick.
	        // The `shouldIgnoreTicks` bool is true for elements in the stave
	        // that don't consume ticks (bar lines, key and time signatures, etc.)
	        set_x = context.shouldIgnoreTicks() ?
	            (min_x + context.getWidth()) : Math.max(set_x, min_x);
	
	        if (context.shouldIgnoreTicks() && justifyWidth) {
	            // This note stole room... recalculate with new justification width.
	            justifyWidth -= context.getWidth();
	            this.pixelsPerTick = justifyWidth /
	              (this.totalTicks.value() * contexts.resolutionMultiplier);
	        }
	
	        // Determine pixels needed for left modifiers.
	        var left_px = thisMetrics.extraLeftPx;
	
	        // Determine white space to right of previous tick (from right modifiers.)
	        if (lastMetrics != null) {
	          white_space = (set_x - x) - (prev_width -
	                                       lastMetrics.extraLeftPx);
	        }
	
	        // Deduct pixels from white space quota.
	        if (i > 0) {
	          if (white_space > 0) {
	            if (white_space >= left_px) {
	              // Have enough white space for left modifiers - no offset needed.
	              left_px = 0;
	            } else {
	              // Decrease left modifier offset by amount of white space.
	              left_px -= white_space;
	            }
	          }
	        }
	
	        // Adjust the tick x position with the left modifier offset.
	        set_x += left_px;
	
	        // Set the `x` value for the context, which sets the `x` value for all
	        // tickables in this context.
	        context.setX(set_x);
	        context.setPixelsUsed(pixels_used);  // ??? Remove this if nothing breaks
	
	        lastMetrics = thisMetrics;
	        prev_width = width;
	        prev_tick = tick;
	        x = set_x;
	      }
	
	      this.hasMinTotalWidth = true;
	      if (justifyWidth > 0) {
	        // Pass 2: Take leftover width, and distribute it to proportionately to
	        // all notes.
	        var remaining_x = initial_justify_width - (x + prev_width);
	        var leftover_pixels_per_tick = remaining_x / (this.totalTicks.value() * contexts.resolutionMultiplier);
	        var accumulated_space = 0;
	        prev_tick = 0;
	
	        for (i = 0; i < contextList.length; ++i) {
	          tick = contextList[i];
	          context = contextMap[tick];
	          tick_space = (tick - prev_tick) * leftover_pixels_per_tick;
	          accumulated_space = accumulated_space + tick_space;
	          context.setX(context.getX() + accumulated_space);
	          prev_tick = tick;
	
	          // Move center aligned tickables to middle
	          var centeredTickables = context.getCenterAlignedTickables();
	
	          /*jshint -W083 */
	          centeredTickables.forEach(function(tickable) {
	            tickable.center_x_shift = center_x - context.getX();
	          });
	        }
	      }
	    },
	
	    // This is the top-level call for all formatting logic completed
	    // after `x` *and* `y` values have been computed for the notes
	    // in the voices.
	    postFormat: function() {
	      // Postformat modifier contexts
	      this.mContexts.list.forEach(function(mContext) {
	        this.mContexts.map[mContext].postFormat();
	      }, this);
	
	      // Postformat tick contexts
	      this.tContexts.list.forEach(function(tContext) {
	        this.tContexts.map[tContext].postFormat();
	      }, this);
	
	      return this;
	    },
	
	    // Take all `voices` and create `ModifierContext`s out of them. This tells
	    // the formatters that the voices belong on a single stave.
	    joinVoices: function(voices) {
	      this.createModifierContexts(voices);
	      this.hasMinTotalWidth = false;
	      return this;
	    },
	
	    // Align rests in voices, justify the contexts, and position the notes
	    // so voices are aligned and ready to render onto the stave. This method
	    // mutates the `x` positions of all tickables in `voices`.
	    //
	    // Voices are full justified to fit in `justifyWidth` pixels.
	    //
	    // Set `options.context` to the rendering context. Set `options.align_rests`
	    // to true to enable rest alignment.
	    format: function(voices, justifyWidth, options) {
	      var opts = {
	        align_rests: false,
	        context: null,
	        stave: null
	      };
	
	      Vex.Merge(opts, options);
	      this.alignRests(voices, opts.align_rests);
	      this.createTickContexts(voices);
	      this.preFormat(justifyWidth, opts.context, voices, opts.stave);
	
	      // Only postFormat if a stave was supplied for y value formatting
	      if (opts.stave) this.postFormat();
	
	      return this;
	    },
	
	    // This method is just like `format` except that the `justifyWidth` is inferred
	    // from the `stave`.
	    formatToStave: function(voices, stave, options) {
	      var justifyWidth = stave.getNoteEndX() - stave.getNoteStartX() - 10;
	      L("Formatting voices to width: ", justifyWidth);
	      var opts = {context: stave.getContext()};
	      Vex.Merge(opts, options);
	      return this.format(voices, justifyWidth, opts);
	    }
	  };
	
	  return Formatter;
	}());
	
	// VexFlow - Music Engraving for HTML5
	// Copyright Mohit Muthanna 2010
	//
	// This class implements varies types of ties between contiguous notes. The
	// ties include: regular ties, hammer ons, pull offs, and slides.
	
	/**
	 * Create a new tie from the specified notes. The notes must
	 * be part of the same line, and have the same duration (in ticks).
	 *
	 * @constructor
	 * @param {!Object} context The canvas context.
	 * @param {!Object} notes The notes to tie up.
	 * @param {!Object} Options
	 */
	Vex.Flow.StaveTie = (function() {
	  function StaveTie(notes, text) {
	    if (arguments.length > 0) this.init(notes, text);
	  }
	
	  StaveTie.prototype = {
	    init: function(notes, text) {
	      /**
	       * Notes is a struct that has:
	       *
	       *  {
	       *    first_note: Note,
	       *    last_note: Note,
	       *    first_indices: [n1, n2, n3],
	       *    last_indices: [n1, n2, n3]
	       *  }
	       *
	       **/
	      this.notes = notes;
	      this.context = null;
	      this.text = text;
	
	      this.render_options = {
	          cp1: 8,      // Curve control point 1
	          cp2: 12,      // Curve control point 2
	          text_shift_x: 0,
	          first_x_shift: 0,
	          last_x_shift: 0,
	          y_shift: 7,
	          tie_spacing: 0,
	          font: { family: "Arial", size: 10, style: "" }
	        };
	
	      this.font = this.render_options.font;
	      this.setNotes(notes);
	    },
	
	    setContext: function(context) { this.context = context; return this; },
	    setFont: function(font) { this.font = font; return this; },
	
	    /**
	     * Set the notes to attach this tie to.
	     *
	     * @param {!Object} notes The notes to tie up.
	     */
	    setNotes: function(notes) {
	      if (!notes.first_note && !notes.last_note)
	        throw new Vex.RuntimeError("BadArguments",
	            "Tie needs to have either first_note or last_note set.");
	
	      if (!notes.first_indices) notes.first_indices = [0];
	      if (!notes.last_indices) notes.last_indices = [0];
	
	      if (notes.first_indices.length != notes.last_indices.length)
	        throw new Vex.RuntimeError("BadArguments", "Tied notes must have similar" +
	          " index sizes");
	
	      // Success. Lets grab 'em notes.
	      this.first_note = notes.first_note;
	      this.first_indices = notes.first_indices;
	      this.last_note = notes.last_note;
	      this.last_indices = notes.last_indices;
	      return this;
	    },
	
	    /**
	     * @return {boolean} Returns true if this is a partial bar.
	     */
	    isPartial: function() {
	      return (!this.first_note || !this.last_note);
	    },
	
	    renderTie: function(params) {
	      if (params.first_ys.length === 0 || params.last_ys.length === 0)
	        throw new Vex.RERR("BadArguments", "No Y-values to render");
	
	      var ctx = this.context;
	      var cp1 = this.render_options.cp1;
	      var cp2 = this.render_options.cp2;
	
	      if (Math.abs(params.last_x_px - params.first_x_px) < 10) {
	        cp1 = 2; cp2 = 8;
	      }
	
	      var first_x_shift = this.render_options.first_x_shift;
	      var last_x_shift = this.render_options.last_x_shift;
	      var y_shift = this.render_options.y_shift * params.direction;
	
	      for (var i = 0; i < this.first_indices.length; ++i) {
	        var cp_x = ((params.last_x_px + last_x_shift) +
	                    (params.first_x_px + first_x_shift)) / 2;
	        var first_y_px = params.first_ys[this.first_indices[i]] + y_shift;
	        var last_y_px = params.last_ys[this.last_indices[i]] + y_shift;
	
	        if (isNaN(first_y_px) || isNaN(last_y_px))
	          throw new Vex.RERR("BadArguments", "Bad indices for tie rendering.");
	
	        var top_cp_y = ((first_y_px + last_y_px) / 2) + (cp1 * params.direction);
	        var bottom_cp_y = ((first_y_px + last_y_px) / 2) + (cp2 * params.direction);
	
	        ctx.beginPath();
	        ctx.moveTo(params.first_x_px + first_x_shift, first_y_px);
	        ctx.quadraticCurveTo(cp_x, top_cp_y,
	                             params.last_x_px + last_x_shift, last_y_px);
	        ctx.quadraticCurveTo(cp_x, bottom_cp_y,
	                             params.first_x_px + first_x_shift, first_y_px);
	
	        ctx.closePath();
	        ctx.fill();
	      }
	    },
	
	    renderText: function(first_x_px, last_x_px) {
	      if (!this.text) return;
	      var center_x = (first_x_px + last_x_px) / 2;
	      center_x -= this.context.measureText(this.text).width / 2;
	
	      this.context.save();
	      this.context.setFont(this.font.family, this.font.size, this.font.style);
	      this.context.fillText(
	          this.text, center_x + this.render_options.text_shift_x,
	          (this.first_note || this.last_note).getStave().getYForTopText() - 1);
	      this.context.restore();
	    },
	
	    draw: function() {
	      if (!this.context)
	        throw new Vex.RERR("NoContext", "No context to render tie.");
	      var first_note = this.first_note;
	      var last_note = this.last_note;
	      var first_x_px, last_x_px, first_ys, last_ys, stem_direction;
	
	      if (first_note) {
	        first_x_px = first_note.getTieRightX() + this.render_options.tie_spacing;
	        stem_direction = first_note.getStemDirection();
	        first_ys = first_note.getYs();
	      } else {
	        first_x_px = last_note.getStave().getTieStartX();
	        first_ys = last_note.getYs();
	        this.first_indices = this.last_indices;
	      }
	
	      if (last_note) {
	        last_x_px = last_note.getTieLeftX() + this.render_options.tie_spacing;
	        stem_direction = last_note.getStemDirection();
	        last_ys = last_note.getYs();
	      } else {
	        last_x_px = first_note.getStave().getTieEndX();
	        last_ys = first_note.getYs();
	        this.last_indices = this.first_indices;
	      }
	
	      this.renderTie({
	        first_x_px: first_x_px,
	        last_x_px: last_x_px,
	        first_ys: first_ys,
	        last_ys: last_ys,
	        direction: stem_direction
	      });
	
	      this.renderText(first_x_px, last_x_px);
	      return true;
	    }
	  };
	
	  return StaveTie;
	}());
	
	// VexFlow - Music Engraving for HTML5
	// Copyright Mohit Muthanna 2010
	//
	// This class implements varies types of ties between contiguous notes. The
	// ties include: regular ties, hammer ons, pull offs, and slides.
	
	/**
	 * Create a new tie from the specified notes. The notes must
	 * be part of the same line, and have the same duration (in ticks).
	 *
	 * @constructor
	 * @param {!Object} context The canvas context.
	 * @param {!Object} notes The notes to tie up.
	 * @param {!Object} Options
	 */
	Vex.Flow.TabTie = (function() {
	  function TabTie(notes, text) {
	    if (arguments.length > 0) this.init(notes, text);
	  }
	
	  TabTie.createHammeron = function(notes) {
	    return new TabTie(notes, "H");
	  };
	
	  TabTie.createPulloff = function(notes) {
	    return new TabTie(notes, "P");
	  };
	
	  Vex.Inherit(TabTie, Vex.Flow.StaveTie, {
	    init: function(notes, text) {
	      /**
	       * Notes is a struct that has:
	       *
	       *  {
	       *    first_note: Note,
	       *    last_note: Note,
	       *    first_indices: [n1, n2, n3],
	       *    last_indices: [n1, n2, n3]
	       *  }
	       *
	       **/
	      TabTie.superclass.init.call(this, notes, text);
	      this.render_options.cp1 = 9;
	      this.render_options.cp2 = 11;
	      this.render_options.y_shift = 3;
	
	      this.setNotes(notes);
	    },
	
	    draw: function() {
	      if (!this.context)
	        throw new Vex.RERR("NoContext", "No context to render tie.");
	      var first_note = this.first_note;
	      var last_note = this.last_note;
	      var first_x_px, last_x_px, first_ys, last_ys;
	
	      if (first_note) {
	        first_x_px = first_note.getTieRightX() + this.render_options.tie_spacing;
	        first_ys = first_note.getYs();
	      } else {
	        first_x_px = last_note.getStave().getTieStartX();
	        first_ys = last_note.getYs();
	        this.first_indices = this.last_indices;
	      }
	
	      if (last_note) {
	        last_x_px = last_note.getTieLeftX() + this.render_options.tie_spacing;
	        last_ys = last_note.getYs();
	      } else {
	        last_x_px = first_note.getStave().getTieEndX();
	        last_ys = first_note.getYs();
	        this.last_indices = this.first_indices;
	      }
	
	      this.renderTie({
	        first_x_px: first_x_px,
	        last_x_px: last_x_px,
	        first_ys: first_ys,
	        last_ys: last_ys,
	        direction: -1           // Tab tie's are always face up.
	      });
	
	      this.renderText(first_x_px, last_x_px);
	      return true;
	    }
	  });
	
	  return TabTie;
	}());
	
	// VexFlow - Music Engraving for HTML5
	// Copyright Mohit Muthanna 2010
	//
	// This class implements varies types of ties between contiguous notes. The
	// ties include: regular ties, hammer ons, pull offs, and slides.
	
	/**
	 * Create a new tie from the specified notes. The notes must
	 * be part of the same line, and have the same duration (in ticks).
	 *
	 * @constructor
	 * @param {!Object} context The canvas context.
	 * @param {!Object} notes The notes to tie up.
	 * @param {!Object} Options
	 */
	Vex.Flow.TabSlide = (function() {
	  function TabSlide(notes, direction) {
	    if (arguments.length > 0) this.init(notes, direction);
	  }
	
	  TabSlide.SLIDE_UP = 1;
	  TabSlide.SLIDE_DOWN = -1;
	
	  TabSlide.createSlideUp = function(notes) {
	    return new TabSlide(notes, TabSlide.SLIDE_UP);
	  };
	
	  TabSlide.createSlideDown = function(notes) {
	    return new TabSlide(notes, TabSlide.SLIDE_DOWN);
	  };
	
	  Vex.Inherit(TabSlide, Vex.Flow.TabTie, {
	    init: function(notes, direction) {
	      /**
	       * Notes is a struct that has:
	       *
	       *  {
	       *    first_note: Note,
	       *    last_note: Note,
	       *    first_indices: [n1, n2, n3],
	       *    last_indices: [n1, n2, n3]
	       *  }
	       *
	       **/
	      TabSlide.superclass.init.call(this, notes, "sl.");
	      if (!direction) {
	        var first_fret = notes.first_note.getPositions()[0].fret;
	        var last_fret = notes.last_note.getPositions()[0].fret;
	
	        direction = ((parseInt(first_fret, 10) > parseInt(last_fret, 10)) ?
	          TabSlide.SLIDE_DOWN : TabSlide.SLIDE_UP);
	      }
	
	      this.slide_direction = direction;
	      this.render_options.cp1 = 11;
	      this.render_options.cp2 = 14;
	      this.render_options.y_shift = 0.5;
	
	      this.setFont({font: "Times", size: 10, style: "bold italic"});
	      this.setNotes(notes);
	    },
	
	    renderTie: function(params) {
	      if (params.first_ys.length === 0 || params.last_ys.length === 0)
	        throw new Vex.RERR("BadArguments", "No Y-values to render");
	
	      var ctx = this.context;
	      var first_x_px = params.first_x_px;
	      var first_ys = params.first_ys;
	      var last_x_px = params.last_x_px;
	
	      var direction = this.slide_direction;
	      if (direction != TabSlide.SLIDE_UP &&
	          direction != TabSlide.SLIDE_DOWN) {
	        throw new Vex.RERR("BadSlide", "Invalid slide direction");
	      }
	
	      for (var i = 0; i < this.first_indices.length; ++i) {
	        var slide_y = first_ys[this.first_indices[i]] +
	          this.render_options.y_shift;
	
	        if (isNaN(slide_y))
	          throw new Vex.RERR("BadArguments", "Bad indices for slide rendering.");
	
	        ctx.beginPath();
	        ctx.moveTo(first_x_px, slide_y + (3 * direction));
	        ctx.lineTo(last_x_px, slide_y - (3 * direction));
	        ctx.closePath();
	        ctx.stroke();
	      }
	    }
	  });
	
	  return TabSlide;
	}());
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements tablature bends.
	
	/**
	   @param text Text for bend ("Full", "Half", etc.) (DEPRECATED)
	   @param release If true, render a release. (DEPRECATED)
	   @param phrase If set, ignore "text" and "release", and use the more
	                 sophisticated phrase specified.
	
	   Example of a phrase:
	
	     [{
	       type: UP,
	       text: "whole"
	       width: 8;
	     },
	     {
	       type: DOWN,
	       text: "whole"
	       width: 8;
	     },
	     {
	       type: UP,
	       text: "half"
	       width: 8;
	     },
	     {
	       type: UP,
	       text: "whole"
	       width: 8;
	     },
	     {
	       type: DOWN,
	       text: "1 1/2"
	       width: 8;
	     }]
	 */
	Vex.Flow.Bend = (function() {
	  function Bend(text, release, phrase) {
	    if (arguments.length > 0) this.init(text, release, phrase);
	  }
	  Bend.CATEGORY = "bends";
	
	  Bend.UP = 0;
	  Bend.DOWN = 1;
	
	  var Modifier = Vex.Flow.Modifier;
	
	  // ## Static Methods
	  // Arrange bends in `ModifierContext`
	  Bend.format = function(bends, state) {
	    if (!bends || bends.length === 0) return false;
	
	    var last_width = 0;
	    // Bends are always on top.
	    var text_line = state.top_text_line;
	
	    // Format Bends
	    for (var i = 0; i < bends.length; ++i) {
	      var bend = bends[i];
	      bend.setXShift(last_width);
	      last_width = bend.getWidth();
	      bend.setTextLine(text_line);
	    }
	
	    state.right_shift += last_width;
	    state.top_text_line += 1;
	    return true;
	  };
	
	  // ## Prototype Methods
	  Vex.Inherit(Bend, Modifier, {
	    init: function(text, release, phrase) {
	      var superclass = Vex.Flow.Bend.superclass;
	      superclass.init.call(this);
	
	      this.text = text;
	      this.x_shift = 0;
	      this.release = release || false;
	      this.font = "10pt Arial";
	      this.render_options = {
	        line_width: 1.5,
	        line_style: "#777777",
	        bend_width: 8,
	        release_width: 8
	      };
	
	      if (phrase) {
	        this.phrase = phrase;
	      } else {
	        // Backward compatibility
	        this.phrase = [{type: Bend.UP, text: this.text}];
	        if (this.release) this.phrase.push({type: Bend.DOWN, text: ""});
	      }
	
	      this.updateWidth();
	    },
	
	    setXShift: function(value) {
	      this.x_shift = value;
	      this.updateWidth();
	    },
	
	    setFont: function(font) { this.font = font; return this; },
	
	    getText: function() { return this.text; },
	
	    updateWidth: function() {
	      var that = this;
	
	      function measure_text(text) {
	        var text_width;
	        if (that.context) {
	          text_width = that.context.measureText(text).width;
	        } else {
	          text_width = Vex.Flow.textWidth(text);
	        }
	
	        return text_width;
	      }
	
	      var total_width = 0;
	      for (var i=0; i<this.phrase.length; ++i) {
	        var bend = this.phrase[i];
	        if ('width' in bend) {
	          total_width += bend.width;
	        } else {
	          var additional_width = (bend.type == Bend.UP) ?
	            this.render_options.bend_width : this.render_options.release_width;
	
	          bend.width = Vex.Max(additional_width, measure_text(bend.text)) + 3;
	          bend.draw_width = bend.width / 2;
	          total_width += bend.width;
	        }
	      }
	
	      this.setWidth(total_width + this.x_shift);
	      return this;
	    },
	
	    draw: function() {
	        if (!this.context) throw new Vex.RERR("NoContext",
	        "Can't draw bend without a context.");
	      if (!(this.note && (this.index != null))) throw new Vex.RERR("NoNoteForBend",
	        "Can't draw bend without a note or index.");
	
	      var start = this.note.getModifierStartXY(Modifier.Position.RIGHT,
	          this.index);
	      start.x += 3;
	      start.y += 0.5;
	      var x_shift = this.x_shift;
	
	      var ctx = this.context;
	      var bend_height = this.note.getStave().getYForTopText(this.text_line) + 3;
	      var annotation_y = this.note.getStave().getYForTopText(this.text_line) - 1;
	      var that = this;
	
	      function renderBend(x, y, width, height) {
	        var cp_x = x + width;
	        var cp_y = y;
	
	        ctx.save();
	        ctx.beginPath();
	        ctx.setLineWidth(that.render_options.line_width);
	        ctx.setStrokeStyle(that.render_options.line_style);
	        ctx.setFillStyle(that.render_options.line_style);
	        ctx.moveTo(x, y);
	        ctx.quadraticCurveTo(cp_x, cp_y, x + width, height);
	        ctx.stroke();
	        ctx.restore();
	      }
	
	      function renderRelease(x, y, width, height) {
	        ctx.save();
	        ctx.beginPath();
	        ctx.setLineWidth(that.render_options.line_width);
	        ctx.setStrokeStyle(that.render_options.line_style);
	        ctx.setFillStyle(that.render_options.line_style);
	        ctx.moveTo(x, height);
	        ctx.quadraticCurveTo(
	            x + width, height,
	            x + width, y);
	        ctx.stroke();
	        ctx.restore();
	      }
	
	      function renderArrowHead(x, y, direction) {
	        var width = 4;
	        var dir = direction || 1;
	
	        ctx.beginPath();
	        ctx.moveTo(x, y);
	        ctx.lineTo(x - width, y + width * dir);
	        ctx.lineTo(x + width, y + width * dir);
	        ctx.closePath();
	        ctx.fill();
	      }
	
	      function renderText(x, text) {
	        ctx.save();
	        ctx.setRawFont(that.font);
	        var render_x = x - (ctx.measureText(text).width / 2);
	        ctx.fillText(text, render_x, annotation_y);
	        ctx.restore();
	      }
	
	      var last_bend = null;
	      var last_drawn_width = 0;
	      for (var i=0; i<this.phrase.length; ++i) {
	        var bend = this.phrase[i];
	        if (i === 0) bend.draw_width += x_shift;
	
	        last_drawn_width = bend.draw_width + (last_bend?last_bend.draw_width:0) - (i==1?x_shift:0);
	        if (bend.type == Bend.UP) {
	          if (last_bend && last_bend.type == Bend.UP) {
	            renderArrowHead(start.x, bend_height);
	          }
	
	          renderBend(start.x, start.y, last_drawn_width, bend_height);
	        }
	
	        if (bend.type == Bend.DOWN) {
	          if (last_bend && last_bend.type == Bend.UP) {
	            renderRelease(start.x, start.y, last_drawn_width, bend_height);
	          }
	
	          if (last_bend && last_bend.type == Bend.DOWN) {
	            renderArrowHead(start.x, start.y, -1);
	            renderRelease(start.x, start.y, last_drawn_width, bend_height);
	          }
	
	          if (last_bend == null) {
	            last_drawn_width = bend.draw_width;
	            renderRelease(start.x, start.y, last_drawn_width, bend_height);
	          }
	        }
	
	        renderText(start.x + last_drawn_width, bend.text);
	        last_bend = bend;
	        last_bend.x = start.x;
	
	        start.x += last_drawn_width;
	      }
	
	      // Final arrowhead and text
	      if (last_bend.type == Bend.UP) {
	        renderArrowHead(last_bend.x + last_drawn_width, bend_height);
	      } else if (last_bend.type == Bend.DOWN) {
	        renderArrowHead(last_bend.x + last_drawn_width, start.y, -1);
	      }
	    }
	  });
	
	  return Bend;
	}());
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This class implements vibratos.
	
	Vex.Flow.Vibrato = (function() {
	  function Vibrato() { this.init(); }
	  Vibrato.CATEGORY = "vibratos";
	
	  var Modifier = Vex.Flow.Modifier;
	
	  // ## Static Methods
	  // Arrange vibratos inside a `ModifierContext`.
	  Vibrato.format = function(vibratos, state, context) {
	    if (!vibratos || vibratos.length === 0) return false;
	
	    // Vibratos are always on top.
	    var text_line = state.top_text_line;
	    var width = 0;
	    var shift = state.right_shift - 7;
	
	    // If there's a bend, drop the text line
	    var bends = context.getModifiers(Vex.Flow.Bend.CATEGORY);
	    if (bends && bends.length > 0) {
	      text_line--;
	    }
	
	    // Format Vibratos
	    for (var i = 0; i < vibratos.length; ++i) {
	      var vibrato = vibratos[i];
	      vibrato.setXShift(shift);
	      vibrato.setTextLine(text_line);
	      width += vibrato.getWidth();
	      shift += width;
	    }
	
	    state.right_shift += width;
	    state.top_text_line += 1;
	    return true;
	  };
	
	  // ## Prototype Methods
	  Vex.Inherit(Vibrato, Modifier, {
	    init: function() {
	      var superclass = Vex.Flow.Vibrato.superclass;
	      superclass.init.call(this);
	
	      this.harsh = false;
	      this.position = Vex.Flow.Modifier.Position.RIGHT;
	      this.render_options = {
	        vibrato_width: 20,
	        wave_height: 6,
	        wave_width: 4,
	        wave_girth: 2
	      };
	
	      this.setVibratoWidth(this.render_options.vibrato_width);
	    },
	
	    setHarsh: function(harsh) { this.harsh = harsh; return this; },
	    setVibratoWidth: function(width) {
	      this.vibrato_width = width;
	      this.setWidth(this.vibrato_width);
	      return this;
	    },
	
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoContext",
	        "Can't draw vibrato without a context.");
	      if (!this.note) throw new Vex.RERR("NoNoteForVibrato",
	        "Can't draw vibrato without an attached note.");
	
	      var start = this.note.getModifierStartXY(Vex.Flow.Modifier.Position.RIGHT,
	          this.index);
	
	      var ctx = this.context;
	      var that = this;
	      var vibrato_width = this.vibrato_width;
	
	      function renderVibrato(x, y) {
	        var wave_width = that.render_options.wave_width;
	        var wave_girth = that.render_options.wave_girth;
	        var wave_height = that.render_options.wave_height;
	        var num_waves = vibrato_width / wave_width;
	
	        ctx.beginPath();
	
	        var i;
	        if (that.harsh) {
	          ctx.moveTo(x, y + wave_girth + 1);
	          for (i = 0; i < num_waves / 2; ++i) {
	            ctx.lineTo(x + wave_width, y - (wave_height / 2));
	            x += wave_width;
	            ctx.lineTo(x + wave_width, y + (wave_height / 2));
	            x += wave_width;
	          }
	          for (i = 0; i < num_waves / 2; ++i) {
	            ctx.lineTo(x - wave_width, (y - (wave_height / 2)) + wave_girth + 1);
	            x -= wave_width;
	            ctx.lineTo(x - wave_width, (y + (wave_height / 2)) + wave_girth + 1);
	            x -= wave_width;
	          }
	          ctx.fill();
	        } else {
	          ctx.moveTo(x, y + wave_girth);
	          for (i = 0; i < num_waves / 2; ++i) {
	            ctx.quadraticCurveTo(x + (wave_width / 2), y - (wave_height / 2),
	              x + wave_width, y);
	            x += wave_width;
	            ctx.quadraticCurveTo(x + (wave_width / 2), y + (wave_height / 2),
	              x + wave_width, y);
	            x += wave_width;
	          }
	
	          for (i = 0; i < num_waves / 2; ++i) {
	            ctx.quadraticCurveTo(
	                x - (wave_width / 2),
	                (y + (wave_height / 2)) + wave_girth,
	                x - wave_width, y + wave_girth);
	            x -= wave_width;
	            ctx.quadraticCurveTo(
	                x - (wave_width / 2),
	                (y - (wave_height / 2)) + wave_girth,
	                x - wave_width, y + wave_girth);
	            x -= wave_width;
	          }
	          ctx.fill();
	        }
	      }
	
	      var vx = start.x + this.x_shift;
	      var vy = this.note.getYForTopText(this.text_line) + 2;
	
	      renderVibrato(vx, vy);
	    }
	  });
	
	  return Vibrato;
	}());
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements text annotations as modifiers that can be attached to
	// notes.
	//
	// See `tests/annotation_tests.js` for usage examples.
	
	Vex.Flow.Annotation = (function() {
	  function Annotation(text) {
	    if (arguments.length > 0) this.init(text);
	  }
	
	  Annotation.CATEGORY = "annotations";
	  var Modifier = Vex.Flow.Modifier;
	
	  // To enable logging for this class. Set `Vex.Flow.Annotation.DEBUG` to `true`.
	  function L() { if (Annotation.DEBUG) Vex.L("Vex.Flow.Annotation", arguments); }
	
	  // Text annotations can be positioned and justified relative to the note.
	  Annotation.Justify = {
	    LEFT: 1,
	    CENTER: 2,
	    RIGHT: 3,
	    CENTER_STEM: 4
	  };
	
	  Annotation.VerticalJustify = {
	    TOP: 1,
	    CENTER: 2,
	    BOTTOM: 3,
	    CENTER_STEM: 4
	  };
	
	  // Arrange annotations within a `ModifierContext`
	  Annotation.format = function(annotations, state) {
	    if (!annotations || annotations.length === 0) return false;
	
	    var width = 0;
	    for (var i = 0; i < annotations.length; ++i) {
	      var annotation = annotations[i];
	      width = Math.max(annotation.getWidth(), width);
	      if (annotation.getPosition() === Modifier.Position.ABOVE) {
	        annotation.setTextLine(state.top_text_line);
	        state.top_text_line++;
	      } else {
	        annotation.setTextLine(state.text_line);
	        state.text_line++;
	      }
	    }
	
	    state.left_shift += width / 2;
	    state.right_shift += width / 2;
	    return true;
	  };
	
	  // ## Prototype Methods
	  //
	  // Annotations inherit from `Modifier` and is positioned correctly when
	  // in a `ModifierContext`.
	  Vex.Inherit(Annotation, Modifier, {
	    // Create a new `Annotation` with the string `text`.
	    init: function(text) {
	      Annotation.superclass.init.call(this);
	
	      this.note = null;
	      this.index = null;
	      this.text = text;
	      this.justification = Annotation.Justify.CENTER;
	      this.vert_justification = Annotation.VerticalJustify.TOP;
	      this.font = {
	        family: "Arial",
	        size: 10,
	        weight: ""
	      };
	
	      // The default width is calculated from the text.
	      this.setWidth(Vex.Flow.textWidth(text));
	    },
	
	    // Set font family, size, and weight. E.g., `Arial`, `10pt`, `Bold`.
	    setFont: function(family, size, weight) {
	      this.font = { family: family, size: size, weight: weight };
	      return this;
	    },
	
	    // Set vertical position of text (above or below stave). `just` must be
	    // a value in `Annotation.VerticalJustify`.
	    setVerticalJustification: function(just) {
	      this.vert_justification = just;
	      return this;
	    },
	
	    // Get and set horizontal justification. `justification` is a value in
	    // `Annotation.Justify`.
	    getJustification: function() { return this.justification; },
	    setJustification: function(justification) {
	      this.justification = justification; return this; },
	
	    // Render text beside the note.
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoContext",
	        "Can't draw text annotation without a context.");
	      if (!this.note) throw new Vex.RERR("NoNoteForAnnotation",
	        "Can't draw text annotation without an attached note.");
	
	      var start = this.note.getModifierStartXY(Modifier.Position.ABOVE,
	          this.index);
	
	      // We're changing context parameters. Save current state.
	      this.context.save();
	      this.context.setFont(this.font.family, this.font.size, this.font.weight);
	      var text_width = this.context.measureText(this.text).width;
	
	      // Estimate text height to be the same as the width of an 'm'.
	      //
	      // This is a hack to work around the inability to measure text height
	      // in HTML5 Canvas (and SVG).
	      var text_height = this.context.measureText("m").width;
	      var x, y;
	
	      if (this.justification == Annotation.Justify.LEFT) {
	        x = start.x;
	      } else if (this.justification == Annotation.Justify.RIGHT) {
	        x = start.x - text_width;
	      } else if (this.justification == Annotation.Justify.CENTER) {
	        x = start.x - text_width / 2;
	      } else /* CENTER_STEM */ {
	        x = this.note.getStemX() - text_width / 2;
	      }
	
	      var stem_ext, spacing;
	      var has_stem = this.note.hasStem();
	      var stave = this.note.getStave();
	
	      // The position of the text varies based on whether or not the note
	      // has a stem.
	      if (has_stem) {
	        stem_ext = this.note.getStem().getExtents();
	        spacing = stave.getSpacingBetweenLines();
	      }
	
	      if (this.vert_justification == Annotation.VerticalJustify.BOTTOM) {
	        y = stave.getYForBottomText(this.text_line);
	        if (has_stem) {
	          var stem_base = (this.note.getStemDirection() === 1 ? stem_ext.baseY : stem_ext.topY);
	          y = Math.max(y, stem_base + (spacing * (this.text_line + 2)));
	        }
	      } else if (this.vert_justification ==
	                 Annotation.VerticalJustify.CENTER) {
	        var yt = this.note.getYForTopText(this.text_line) - 1;
	        var yb = stave.getYForBottomText(this.text_line);
	        y = yt + ( yb - yt ) / 2 + text_height / 2;
	      } else if (this.vert_justification ==
	                 Annotation.VerticalJustify.TOP) {
	        y = Math.min(stave.getYForTopText(this.text_line), this.note.getYs()[0] - 10);
	        if (has_stem) {
	          y = Math.min(y, (stem_ext.topY - 5) - (spacing * this.text_line));
	        }
	      } else /* CENTER_STEM */{
	        var extents = this.note.getStemExtents();
	        y = extents.topY + (extents.baseY - extents.topY) / 2 +
	          text_height / 2;
	      }
	
	      L("Rendering annotation: ", this.text, x, y);
	      this.context.fillText(this.text, x, y);
	      this.context.restore();
	    }
	  });
	
	  return Annotation;
	}());
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author: Larry Kuhns.
	//
	// ## Description
	//
	// This file implements articulations and accents as modifiers that can be
	// attached to notes. The complete list of articulations is available in
	// `tables.js` under `Vex.Flow.articulationCodes`.
	//
	// See `tests/articulation_tests.js` for usage examples.
	
	Vex.Flow.Articulation = (function() {
	  function Articulation(type) {
	    if (arguments.length > 0) this.init(type);
	  }
	  Articulation.CATEGORY = "articulations";
	
	  // To enable logging for this class. Set `Vex.Flow.Articulation.DEBUG` to `true`.
	  function L() { if (Articulation.DEBUG) Vex.L("Vex.Flow.Articulation", arguments); }
	
	  var Modifier = Vex.Flow.Modifier;
	
	  // ## Static Methods
	  // Arrange articulations inside `ModifierContext`
	  Articulation.format = function(articulations, state) {
	    if (!articulations || articulations.length === 0) return false;
	
	    var width = 0;
	    for (var i = 0; i < articulations.length; ++i) {
	      var increment = 1;
	      var articulation = articulations[i];
	      width = Math.max(articulation.getWidth(), width);
	
	      var type = Vex.Flow.articulationCodes(articulation.type);
	
	      if (!type.between_lines) increment += 1.5;
	
	      if (articulation.getPosition() === Modifier.Position.ABOVE) {
	        articulation.setTextLine(state.top_text_line);
	        state.top_text_line += increment;
	      } else {
	        articulation.setTextLine(state.text_line);
	        state.text_line += increment;
	      }
	    }
	
	    state.left_shift += width / 2;
	    state.right_shift += width / 2;
	    return true;
	  };
	
	  // ## Prototype Methods
	  Vex.Inherit(Articulation, Modifier, {
	    // Create a new articulation of type `type`, which is an entry in
	    // `Vex.Flow.articulationCodes` in `tables.js`.
	    init: function(type) {
	      Articulation.superclass.init.call(this);
	
	      this.note = null;
	      this.index = null;
	      this.type = type;
	      this.position = Modifier.Position.BELOW;
	
	      this.render_options = {
	        font_scale: 38
	      };
	
	      this.articulation = Vex.Flow.articulationCodes(this.type);
	      if (!this.articulation) throw new Vex.RERR("ArgumentError",
	         "Articulation not found: '" + this.type + "'");
	
	      // Default width comes from articulation table.
	      this.setWidth(this.articulation.width);
	    },
	
	    // Render articulation in position next to note.
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoContext",
	        "Can't draw Articulation without a context.");
	      if (!(this.note && (this.index !== null))) throw new Vex.RERR("NoAttachedNote",
	        "Can't draw Articulation without a note and index.");
	
	      var stem_direction = this.note.getStemDirection();
	      var stave = this.note.getStave();
	
	      var is_on_head = (this.position === Modifier.Position.ABOVE &&
	                        stem_direction === Vex.Flow.StaveNote.STEM_DOWN) ||
	                       (this.position === Modifier.Position.BELOW &&
	                        stem_direction === Vex.Flow.StaveNote.STEM_UP);
	
	      var needsLineAdjustment = function(articulation, note_line, line_spacing) {
	        var offset_direction = (articulation.position === Modifier.Position.ABOVE) ? 1 : -1;
	        var duration = articulation.getNote().getDuration();
	        if(!is_on_head && Vex.Flow.durationToNumber(duration) <= 1){
	          // Add stem length, unless it's on a whole note.
	          note_line += offset_direction * 3.5;
	        }
	
	        var articulation_line = note_line + (offset_direction * line_spacing);
	
	        if(articulation_line >= 1 &&
	           articulation_line <= 5 &&
	           articulation_line % 1 === 0){
	          return true;
	        }
	
	        return false;
	      };
	
	      // Articulations are centered over/under the note head.
	      var start = this.note.getModifierStartXY(this.position, this.index);
	      var glyph_y = start.y;
	      var shiftY = 0;
	      var line_spacing = 1;
	      var spacing = stave.getSpacingBetweenLines();
	      var is_tabnote = this.note.getCategory() === 'tabnotes';
	      var stem_ext = this.note.getStem().getExtents();
	
	      var top = stem_ext.topY;
	      var bottom = stem_ext.baseY;
	
	      if (stem_direction === Vex.Flow.StaveNote.STEM_DOWN) {
	        top = stem_ext.baseY;
	        bottom = stem_ext.topY;
	      }
	
	      // TabNotes don't have stems attached to them. Tab stems are rendered
	      // outside the stave.
	      if (is_tabnote) {
	        if (this.note.hasStem()){
	          if (stem_direction === Vex.Flow.StaveNote.STEM_UP) {
	            bottom = stave.getYForBottomText(this.text_line - 2);
	          } else if (stem_direction === Vex.Flow.StaveNote.STEM_DOWN ) {
	            top = stave.getYForTopText(this.text_line - 1.5);
	          }
	        } else { // Without a stem
	          top = stave.getYForTopText(this.text_line - 1);
	          bottom = stave.getYForBottomText(this.text_line - 2);
	        }
	      }
	
	      var is_above = (this.position === Modifier.Position.ABOVE) ? true : false;
	      var note_line = this.note.getLineNumber(is_above);
	
	      // Beamed stems are longer than quarter note stems.
	      if (!is_on_head && this.note.beam) line_spacing += 0.5;
	
	      // If articulation will overlap a line, reposition it.
	      if (needsLineAdjustment(this, note_line, line_spacing)) line_spacing += 0.5;
	
	      var glyph_y_between_lines;
	      if (this.position === Modifier.Position.ABOVE) {
	        shiftY = this.articulation.shift_up;
	        glyph_y_between_lines = (top - 7) - (spacing * (this.text_line + line_spacing));
	
	        if (this.articulation.between_lines) {
	          glyph_y = glyph_y_between_lines;
	        } else {
	          glyph_y = Math.min(stave.getYForTopText(this.text_line) - 3, glyph_y_between_lines);
	        }
	      } else {
	        shiftY = this.articulation.shift_down - 10;
	
	        glyph_y_between_lines = bottom + 10 + spacing * (this.text_line + line_spacing);
	        if (this.articulation.between_lines) {
	          glyph_y = glyph_y_between_lines;
	        } else {
	          glyph_y = Math.max(stave.getYForBottomText(this.text_line), glyph_y_between_lines);
	        }
	      }
	
	      var glyph_x = start.x + this.articulation.shift_right;
	      glyph_y += shiftY + this.y_shift;
	
	      L("Rendering articulation: ", this.articulation, glyph_x, glyph_y);
	      Vex.Flow.renderGlyph(this.context, glyph_x, glyph_y,
	                           this.render_options.font_scale, this.articulation.code);
	    }
	  });
	
	  return Articulation;
	}());
	// VexFlow - Music Engraving for HTML5
	// Copyright Mohit Muthanna 2010
	//
	// This class implements varies types of tunings for tablature.
	
	/**
	 * @constructor
	 */
	Vex.Flow.Tuning = (function() {
	  function Tuning(tuningString) {
	    this.init(tuningString);
	  }
	
	  Tuning.names = {
	    "standard": "E/5,B/4,G/4,D/4,A/3,E/3",
	    "dagdad": "D/5,A/4,G/4,D/4,A/3,D/3",
	    "dropd": "E/5,B/4,G/4,D/4,A/3,D/3",
	    "eb": "Eb/5,Bb/4,Gb/4,Db/4,Ab/3,Db/3",
	    "standardBanjo": "D/5,B/4,G/4,D/4,G/5"
	  };
	
	  Tuning.prototype = {
	    init: function(tuningString) {
	      // Default to standard tuning.
	      this.setTuning(tuningString || "E/5,B/4,G/4,D/4,A/3,E/3,B/2,E/2");
	    },
	
	    noteToInteger: function(noteString) {
	      return Vex.Flow.keyProperties(noteString).int_value;
	    },
	
	    setTuning: function(noteString) {
	      if (Vex.Flow.Tuning.names[noteString])
	        noteString = Vex.Flow.Tuning.names[noteString];
	
	      this.tuningString = noteString;
	      this.tuningValues = [];
	      this.numStrings = 0;
	
	      var keys = noteString.split(/\s*,\s*/);
	      if (keys.length === 0)
	        throw new Vex.RERR("BadArguments", "Invalid tuning string: " + noteString);
	
	      this.numStrings = keys.length;
	      for (var i = 0; i < this.numStrings; ++i) {
	        this.tuningValues[i] = this.noteToInteger(keys[i]);
	      }
	    },
	
	    getValueForString: function(stringNum) {
	      var s = parseInt(stringNum, 10);
	      if (s < 1 || s > this.numStrings)
	        throw new Vex.RERR("BadArguments", "String number must be between 1 and " +
	            this.numStrings + ": " + stringNum);
	
	      return this.tuningValues[s - 1];
	    },
	
	    getValueForFret: function(fretNum, stringNum) {
	      var stringValue = this.getValueForString(stringNum);
	      var f = parseInt(fretNum, 10);
	
	      if (f < 0) {
	        throw new Vex.RERR("BadArguments", "Fret number must be 0 or higher: " +
	            fretNum);
	      }
	
	      return stringValue + f;
	    },
	
	    getNoteForFret: function(fretNum, stringNum) {
	      var noteValue = this.getValueForFret(fretNum, stringNum);
	
	      var octave = Math.floor(noteValue / 12);
	      var value = noteValue % 12;
	
	      return Vex.Flow.integerToNote(value) + "/" + octave;
	    }
	  };
	
	  return Tuning;
	}());
	
	// VexFlow - Music Engraving for HTML5
	//
	// A base class for stave modifiers (e.g. clefs, key signatures)
	//
	
	
	/**
	 * @constructor
	 */
	Vex.Flow.StaveModifier = (function() {
	  function StaveModifier() {
	    this.init();
	  }
	
	  StaveModifier.prototype = {
	    init: function() {
	      this.padding = 10;
	    },
	
	    getCategory: function() {return "";},
	    makeSpacer: function(padding) {
	      return {
	        getContext: function() {return true;},
	        setStave: function() {},
	        renderToStave: function() {},
	        getMetrics: function() {
	          return {width: padding};
	        }
	      };
	    },
	
	    placeGlyphOnLine: function(glyph, stave, line) {
	      glyph.setYShift(stave.getYForLine(line) - stave.getYForGlyphs());
	    },
	
	    setPadding: function(padding) {
	      this.padding = padding;
	    },
	
	    addToStave: function(stave, firstGlyph) {
	      if (!firstGlyph) {
	        stave.addGlyph(this.makeSpacer(this.padding));
	      }
	
	      this.addModifier(stave);
	      return this;
	    },
	
	    addToStaveEnd: function(stave, firstGlyph) {
	      if (!firstGlyph) {
	        stave.addEndGlyph(this.makeSpacer(this.padding));
	      }
	      else {
	        stave.addEndGlyph(this.makeSpacer(2));
	      }
	
	      this.addEndModifier(stave);
	      return this;
	    },
	
	    addModifier: function() {
	      throw new Vex.RERR("MethodNotImplemented",
	          "addModifier() not implemented for this stave modifier.");
	    },
	
	    addEndModifier: function() {
	      throw new Vex.RERR("MethodNotImplemented",
	          "addEndModifier() not implemented for this stave modifier.");
	    }
	  };
	
	  return StaveModifier;
	}());
	
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author: Cyril Silverman
	//
	// ## Description
	//
	// This file implements key signatures. A key signature sits on a stave
	// and indicates the notes with implicit accidentals.
	Vex.Flow.KeySignature = (function() {
	  function KeySignature(keySpec) {
	    if (arguments.length > 0) this.init(keySpec);
	  }
	
	  // Space between natural and following accidental depending
	  // on vertical position
	  KeySignature.accidentalSpacing = {
	    '#': {
	      above: 6,
	      below: 4
	    },
	    'b': {
	      above: 4,
	      below: 7
	    },
	    'n': {
	      above: 3,
	      below: -1
	    }
	  };
	
	  // ## Prototype Methods
	  Vex.Inherit(KeySignature, Vex.Flow.StaveModifier, {
	    // Create a new Key Signature based on a `key_spec`
	    init: function(key_spec) {
	      KeySignature.superclass.init();
	
	      this.glyphFontScale = 38; // TODO(0xFE): Should this match StaveNote?
	      this.accList = Vex.Flow.keySignature(key_spec);
	    },
	
	    // Add an accidental glyph to the `stave`. `acc` is the data of the
	    // accidental to add. If the `next` accidental is also provided, extra
	    // width will be added to the initial accidental for optimal spacing.
	    addAccToStave: function(stave, acc, next) {
	      var glyph_data = Vex.Flow.accidentalCodes(acc.type);
	      var glyph = new Vex.Flow.Glyph(glyph_data.code, this.glyphFontScale);
	
	      // Determine spacing between current accidental and the next accidental
	      var extra_width = 0;
	      if (acc.type === "n" && next) {
	        var above = next.line >= acc.line;
	        var space = KeySignature.accidentalSpacing[next.type];
	        extra_width = above ? space.above : space.below;
	      }
	
	      // Set the width and place the glyph on the stave
	      glyph.setWidth(glyph_data.width + extra_width);
	      this.placeGlyphOnLine(glyph, stave, acc.line);
	      stave.addGlyph(glyph);
	    },
	
	    // Cancel out a key signature provided in the `spec` parameter. This will
	    // place appropriate natural accidentals before the key signature.
	    cancelKey: function(spec) {
	      // Get the accidental list for the cancelled key signature
	      var cancel_accList = Vex.Flow.keySignature(spec);
	
	      // If the cancelled key has a different accidental type, ie: # vs b
	      var different_types = this.accList.length > 0 &&
	                            cancel_accList[0].type !== this.accList[0].type;
	
	      // Determine how many naturals needed to add
	      var naturals = 0;
	      if (different_types) {
	        naturals = cancel_accList.length;
	      } else {
	        naturals = cancel_accList.length - this.accList.length;
	      }
	
	      // Return if no naturals needed
	      if (naturals < 1) return;
	
	      // Get the line position for each natural
	      var cancelled = [];
	      for (var i = 0; i < naturals; i++) {
	        var index = i;
	        if (!different_types) {
	          index = cancel_accList.length - naturals + i;
	        }
	
	        var acc = cancel_accList[index];
	        cancelled.push({type: "n", line: acc.line});
	      }
	
	      // Combine naturals with main accidental list for the key signature
	      this.accList = cancelled.concat(this.accList);
	
	      return this;
	    },
	
	    // Add the key signature to the `stave`. You probably want to use the 
	    // helper method `.addToStave()` instead
	    addModifier: function(stave) {
	      this.convertAccLines(stave.clef, this.accList[0].type);
	      for (var i = 0; i < this.accList.length; ++i) {
	        this.addAccToStave(stave, this.accList[i], this.accList[i+1]);
	      }
	    },
	
	    // Add the key signature to the `stave`, if it's the not the `firstGlyph`
	    // a spacer will be added as well.
	    addToStave: function(stave, firstGlyph) {
	      if (this.accList.length === 0)
	        return this;
	
	      if (!firstGlyph) {
	        stave.addGlyph(this.makeSpacer(this.padding));
	      }
	
	      this.addModifier(stave);
	      return this;
	    },
	
	    // Apply the accidental staff line placement based on the `clef` and
	    // the  accidental `type` for the key signature ('# or 'b').
	    convertAccLines: function(clef, type) {
	      var offset = 0.0; // if clef === "treble"
	      var customLines; // when clef doesn't follow treble key sig shape
	
	      switch (clef) {
	        // Treble & Subbass both have offsets of 0, so are not included.
	        case "soprano":
	          if(type === "#") customLines = [2.5,0.5,2,0,1.5,-0.5,1];
	          else offset = -1;
	          break;
	        case "mezzo-soprano":
	          if(type === "b") customLines = [0,2,0.5,2.5,1,3,1.5];
	          else offset = 1.5;
	          break;
	        case "alto":
	          offset = 0.5;
	          break;
	        case "tenor":
	          if(type === "#") customLines = [3, 1, 2.5, 0.5, 2, 0, 1.5];
	          else offset = -0.5;
	          break;
	        case "baritone-f":
	        case "baritone-c":
	          if(type === "b") customLines = [0.5,2.5,1,3,1.5,3.5,2];
	          else offset = 2;
	          break;
	        case "bass":
	        case "french":
	          offset = 1;
	          break;
	      }
	
	      // If there's a special case, assign those lines/spaces:
	      var i;
	      if (typeof customLines !== "undefined") {
	        for (i = 0; i < this.accList.length; ++i) {
	          this.accList[i].line = customLines[i];
	        }
	      } else if (offset !== 0) {
	        for (i = 0; i < this.accList.length; ++i) {
	          this.accList[i].line += offset;
	        }
	      }
	    }
	  });
	
	  return KeySignature;
	}());
	// Vex Flow Notation
	// Implements time signatures glyphs for staffs
	// See tables.js for the internal time signatures
	// representation
	//
	
	/**
	 * @param {string} timeSpec time signature, i.e. "4/4"
	 * @param {number} [customPadding] custom padding when using multi-stave/multi-instrument setting
	 * to align key/time signature (in pixels), optional
	 * @constructor
	 */
	Vex.Flow.TimeSignature = (function() {
	  function TimeSignature(timeSpec, customPadding) {
	    if (arguments.length > 0) this.init(timeSpec, customPadding);
	  }
	
	  TimeSignature.glyphs = {
	    "C": {
	      code: "v41",
	      point: 40,
	      line: 2
	    },
	    "C|": {
	      code: "vb6",
	      point: 40,
	      line: 2
	    }
	  };
	
	  Vex.Inherit(TimeSignature, Vex.Flow.StaveModifier, {
	    init: function(timeSpec, customPadding) {
	      TimeSignature.superclass.init();
	       var padding = customPadding || 15;
	
	      this.setPadding(padding);
	      this.point = 40;
	      this.topLine = 2;
	      this.bottomLine = 4;
	      this.timeSig = this.parseTimeSpec(timeSpec);
	    },
	
	    parseTimeSpec: function(timeSpec) {
	      if (timeSpec == "C" || timeSpec == "C|") {
	        var glyphInfo = TimeSignature.glyphs[timeSpec];
	        return {num: false, line: glyphInfo.line,
	          glyph: new Vex.Flow.Glyph(glyphInfo.code, glyphInfo.point)};
	      }
	
	      var topNums = [];
	      var i, c;
	      for (i = 0; i < timeSpec.length; ++i) {
	        c = timeSpec.charAt(i);
	        if (c == "/") {
	          break;
	        }
	        else if (/[0-9]/.test(c)) {
	          topNums.push(c);
	        }
	        else {
	          throw new Vex.RERR("BadTimeSignature",
	              "Invalid time spec: " + timeSpec);
	        }
	      }
	
	      if (i === 0) {
	        throw new Vex.RERR("BadTimeSignature",
	              "Invalid time spec: " + timeSpec);
	      }
	
	      // skip the "/"
	      ++i;
	
	      if (i == timeSpec.length) {
	        throw new Vex.RERR("BadTimeSignature",
	              "Invalid time spec: " + timeSpec);
	      }
	
	
	      var botNums = [];
	      for (; i < timeSpec.length; ++i) {
	        c = timeSpec.charAt(i);
	        if (/[0-9]/.test(c)) {
	          botNums.push(c);
	        }
	        else {
	          throw new Vex.RERR("BadTimeSignature",
	              "Invalid time spec: " + timeSpec);
	        }
	      }
	
	
	      return {num: true, glyph: this.makeTimeSignatureGlyph(topNums, botNums)};
	    },
	
	    makeTimeSignatureGlyph: function(topNums, botNums) {
	      var glyph = new Vex.Flow.Glyph("v0", this.point);
	      glyph["topGlyphs"] = [];
	      glyph["botGlyphs"] = [];
	
	      var topWidth = 0;
	      var i, num;
	      for (i = 0; i < topNums.length; ++i) {
	        num = topNums[i];
	        var topGlyph = new Vex.Flow.Glyph("v" + num, this.point);
	
	        glyph.topGlyphs.push(topGlyph);
	        topWidth += topGlyph.getMetrics().width;
	      }
	
	      var botWidth = 0;
	      for (i = 0; i < botNums.length; ++i) {
	        num = botNums[i];
	        var botGlyph = new Vex.Flow.Glyph("v" + num, this.point);
	
	        glyph.botGlyphs.push(botGlyph);
	        botWidth += botGlyph.getMetrics().width;
	      }
	
	      var width = (topWidth > botWidth ? topWidth : botWidth);
	      var xMin = glyph.getMetrics().x_min;
	
	      glyph.getMetrics = function() {
	        return {
	          x_min: xMin,
	          x_max: xMin + width,
	          width: width
	        };
	      };
	
	      var topStartX = (width - topWidth) / 2.0;
	      var botStartX = (width - botWidth) / 2.0;
	
	      var that = this;
	      glyph.renderToStave = function(x) {
	        var start_x = x + topStartX;
	        var i, g;
	        for (i = 0; i < this.topGlyphs.length; ++i) {
	          g = this.topGlyphs[i];
	          Vex.Flow.Glyph.renderOutline(this.context, g.metrics.outline,
	              g.scale, start_x + g.x_shift, this.stave.getYForLine(that.topLine) + 1);
	          start_x += g.getMetrics().width;
	        }
	
	        start_x = x + botStartX;
	        for (i = 0; i < this.botGlyphs.length; ++i) {
	          g = this.botGlyphs[i];
	          that.placeGlyphOnLine(g, this.stave, g.line);
	          Vex.Flow.Glyph.renderOutline(this.context, g.metrics.outline,
	              g.scale, start_x + g.x_shift, this.stave.getYForLine(that.bottomLine) + 1);
	          start_x += g.getMetrics().width;
	        }
	      };
	
	      return glyph;
	    },
	
	    getTimeSig: function() {
	      return this.timeSig;
	    },
	
	    addModifier: function(stave) {
	      if (!this.timeSig.num) {
	        this.placeGlyphOnLine(this.timeSig.glyph, stave, this.timeSig.line);
	      }
	      stave.addGlyph(this.timeSig.glyph);
	    },
	
	    addEndModifier: function(stave) {
	      if (!this.timeSig.num) {
	        this.placeGlyphOnLine(this.timeSig.glyph, stave, this.timeSig.line);
	      }
	      stave.addEndGlyph(this.timeSig.glyph);
	    }
	  });
	
	  return TimeSignature;
	}());
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna Cheppudira 2013.
	// Co-author: Benjamin W. Bohl
	//
	// ## Description
	//
	// This file implements various types of clefs that can be rendered on a stave.
	//
	// See `tests/clef_tests.js` for usage examples.
	
	Vex.Flow.Clef = (function() {
	  function Clef(clef, size, annotation) {
	    if (arguments.length > 0) this.init(clef, size, annotation);
	  }
	
	  // To enable logging for this class, set `Vex.Flow.Clef.DEBUG` to `true`.
	  function L() { if (Vex.Flow.Clef.DEBUG) Vex.L("Vex.Flow.Clef", arguments); }
	
	  // Every clef name is associated with a glyph code from the font file
	  // and a default stave line number.
	  Clef.types = {
	    "treble": {
	      code: "v83",
	      line: 3
	    },
	    "bass": {
	      code: "v79",
	      line: 1
	    },
	    "alto": {
	      code: "vad",
	      line: 2
	    },
	    "tenor": {
	      code: "vad",
	      line: 1
	    },
	    "percussion": {
	      code: "v59",
	      line: 2
	    },
	    "soprano": {
	      code: "vad",
	      line: 4
	    },
	    "mezzo-soprano": {
	      code: "vad",
	      line: 3
	    },
	    "baritone-c": {
	      code: "vad",
	      line: 0
	    },
	    "baritone-f": {
	      code: "v79",
	      line: 2
	    },
	    "subbass": {
	      code: "v79",
	      line: 0
	    },
	    "french": {
	      code: "v83",
	      line: 4
	    },
	  };
	  // Sizes affect the point-size of the clef.
	  Clef.sizes = {
	    "default": 40,
	    "small": 32
	  };
	
	  // Annotations attach to clefs -- such as "8" for octave up or down.
	  Clef.annotations = {
	    "8va": {
	      code: "v8",
	      sizes: {
	        "default": {
	          point: 20,
	          attachments: {
	            "treble": {
	              line: -1.2,
	              x_shift: 11
	            }
	          }
	        },
	        "small": {
	          point: 18,
	          attachments: {
	            "treble": {
	              line: -0.4,
	              x_shift: 8
	            }
	          }
	        }
	      }
	    },
	    "8vb": {
	      code: "v8",
	      sizes: {
	        "default": {
	          point: 20,
	          attachments: {
	            "treble": {
	              line: 6.3,
	              x_shift: 10
	            },
	            "bass": {
	              line: 4,
	              x_shift: 1
	            }
	          }
	        },
	        "small": {
	          point: 18,
	          attachments: {
	            "treble": {
	              line: 5.8,
	              x_shift: 6
	            },
	            "bass": {
	              line: 3.5,
	              x_shift: 0.5
	            }
	          }
	        }
	      }
	    },
	  };
	  // ## Prototype Methods
	  Vex.Inherit(Clef, Vex.Flow.StaveModifier, {
	    // Create a new clef. The parameter `clef` must be a key from
	    // `Clef.types`.
	    init: function(clef, size, annotation) {
	      var superclass = Vex.Flow.Clef.superclass;
	      superclass.init.call(this);
	
	      this.clef = Vex.Flow.Clef.types[clef];
	      if (size === undefined) {
	        this.size = "default";
	      } else {
	        this.size = size;
	      }
	      this.clef.point = Vex.Flow.Clef.sizes[this.size];
	
	      // If an annotation, such as 8va, is specified, add it to the Clef object.
	      if (annotation !== undefined) {
	        var anno_dict = Vex.Flow.Clef.annotations[annotation];
	        this.annotation = {
	          code: anno_dict.code,
	          point: anno_dict.sizes[this.size].point,
	          line: anno_dict.sizes[this.size].attachments[clef].line,
	          x_shift: anno_dict.sizes[this.size].attachments[clef].x_shift
	        };
	      }
	      L("Creating clef:", clef);
	    },
	
	    // Add this clef to the start of the given `stave`.
	    addModifier: function(stave) {
	      var glyph = new Vex.Flow.Glyph(this.clef.code, this.clef.point);
	      this.placeGlyphOnLine(glyph, stave, this.clef.line);
	      if (this.annotation !== undefined) {
	        var attachment = new Vex.Flow.Glyph(this.annotation.code, this.annotation.point);
	        attachment.metrics.x_max = 0;
	        attachment.setXShift(this.annotation.x_shift);
	        this.placeGlyphOnLine(attachment, stave, this.annotation.line);
	        stave.addGlyph(attachment);
	      }
	      stave.addGlyph(glyph);
	    },
	
	    // Add this clef to the end of the given `stave`.
	    addEndModifier: function(stave) {
	      var glyph = new Vex.Flow.Glyph(this.clef.code, this.clef.point);
	      this.placeGlyphOnLine(glyph, stave, this.clef.line);
	      stave.addEndGlyph(glyph);
	      if (this.annotation !== undefined) {
	        var attachment = new Vex.Flow.Glyph(this.annotation.code, this.annotation.point);
	        attachment.metrics.x_max = 0;
	        attachment.setXShift(this.annotation.x_shift);
	        this.placeGlyphOnLine(attachment, stave, this.annotation.line);
	        stave.addEndGlyph(attachment);
	      }
	    }
	  });
	
	  return Clef;
	}());
	
	// VexFlow - Music Engraving for HTML5
	// Copyright Mohit Muthanna 2010
	//
	// This class implements some standard music theory routines.
	//
	// requires: vex.js   (Vex)
	// requires: flow.js  (Vex.Flow)
	
	/**
	 * @constructor
	 */
	Vex.Flow.Music = (function() {
	  function Music() {
	    this.init();
	  }
	
	  Music.NUM_TONES = 12;
	  Music.roots = [ "c", "d", "e", "f", "g", "a", "b" ];
	  Music.root_values = [ 0, 2, 4, 5, 7, 9, 11 ];
	  Music.root_indices = {
	    "c": 0,
	    "d": 1,
	    "e": 2,
	    "f": 3,
	    "g": 4,
	    "a": 5,
	    "b": 6
	  };
	
	  Music.canonical_notes = [
	    "c", "c#", "d", "d#",
	    "e", "f", "f#", "g",
	    "g#", "a", "a#", "b"
	  ];
	
	  Music.diatonic_intervals = [
	    "unison", "m2", "M2", "m3", "M3",
	    "p4", "dim5", "p5", "m6", "M6",
	    "b7", "M7", "octave"
	  ];
	
	  Music.diatonic_accidentals = {
	    "unison": {note: 0, accidental: 0},
	    "m2":     {note: 1, accidental: -1},
	    "M2":     {note: 1, accidental: 0},
	    "m3":     {note: 2, accidental: -1},
	    "M3":     {note: 2, accidental: 0},
	    "p4":     {note: 3, accidental: 0},
	    "dim5":   {note: 4, accidental: -1},
	    "p5":     {note: 4, accidental: 0},
	    "m6":     {note: 5, accidental: -1},
	    "M6":     {note: 5, accidental: 0},
	    "b7":     {note: 6, accidental: -1},
	    "M7":     {note: 6, accidental: 0},
	    "octave": {note: 7, accidental: 0}
	  };
	
	  Music.intervals = {
	    "u":  0, "unison": 0,
	    "m2": 1, "b2": 1, "min2": 1, "S": 1, "H": 1,
	    "2": 2, "M2": 2, "maj2": 2, "T": 2, "W": 2,
	    "m3": 3, "b3": 3, "min3": 3,
	    "M3": 4, "3": 4, "maj3": 4,
	    "4":  5, "p4":  5,
	    "#4": 6, "b5": 6, "aug4": 6, "dim5": 6,
	    "5":  7, "p5":  7,
	    "#5": 8, "b6": 8, "aug5": 8,
	    "6":  9, "M6":  9, "maj6": 9,
	    "b7": 10, "m7": 10, "min7": 10, "dom7": 10,
	    "M7": 11, "maj7": 11,
	    "8": 12, "octave": 12
	  };
	
	  Music.scales = {
	    major: [2, 2, 1, 2, 2, 2, 1],
	    dorian: [2, 1, 2, 2, 2, 1, 2],
	    mixolydian: [2, 2, 1, 2, 2, 1, 2],
	    minor: [2, 1, 2, 2, 1, 2, 2]
	  };
	
	  Music.accidentals = [ "bb", "b", "n", "#", "##" ];
	
	  Music.noteValues = {
	    'c':   { root_index: 0, int_val: 0 },
	    'cn':  { root_index: 0, int_val: 0 },
	    'c#':  { root_index: 0, int_val: 1 },
	    'c##': { root_index: 0, int_val: 2 },
	    'cb':  { root_index: 0, int_val: 11 },
	    'cbb': { root_index: 0, int_val: 10 },
	    'd':   { root_index: 1, int_val: 2 },
	    'dn':  { root_index: 1, int_val: 2 },
	    'd#':  { root_index: 1, int_val: 3 },
	    'd##': { root_index: 1, int_val: 4 },
	    'db':  { root_index: 1, int_val: 1 },
	    'dbb': { root_index: 1, int_val: 0 },
	    'e':   { root_index: 2, int_val: 4 },
	    'en':  { root_index: 2, int_val: 4 },
	    'e#':  { root_index: 2, int_val: 5 },
	    'e##': { root_index: 2, int_val: 6 },
	    'eb':  { root_index: 2, int_val: 3 },
	    'ebb': { root_index: 2, int_val: 2 },
	    'f':   { root_index: 3, int_val: 5 },
	    'fn':  { root_index: 3, int_val: 5 },
	    'f#':  { root_index: 3, int_val: 6 },
	    'f##': { root_index: 3, int_val: 7 },
	    'fb':  { root_index: 3, int_val: 4 },
	    'fbb': { root_index: 3, int_val: 3 },
	    'g':   { root_index: 4, int_val: 7 },
	    'gn':  { root_index: 4, int_val: 7 },
	    'g#':  { root_index: 4, int_val: 8 },
	    'g##': { root_index: 4, int_val: 9 },
	    'gb':  { root_index: 4, int_val: 6 },
	    'gbb': { root_index: 4, int_val: 5 },
	    'a':   { root_index: 5, int_val: 9 },
	    'an':  { root_index: 5, int_val: 9 },
	    'a#':  { root_index: 5, int_val: 10 },
	    'a##': { root_index: 5, int_val: 11 },
	    'ab':  { root_index: 5, int_val: 8 },
	    'abb': { root_index: 5, int_val: 7 },
	    'b':   { root_index: 6, int_val: 11 },
	    'bn':  { root_index: 6, int_val: 11 },
	    'b#':  { root_index: 6, int_val: 0 },
	    'b##': { root_index: 6, int_val: 1 },
	    'bb':  { root_index: 6, int_val: 10 },
	    'bbb': { root_index: 6, int_val: 9 }
	  };
	
	  Music.prototype = {
	    init: function() {},
	
	    isValidNoteValue: function(note) {
	      if (note == null || note < 0 || note >= Vex.Flow.Music.NUM_TONES)
	        return false;
	      return true;
	    },
	
	    isValidIntervalValue: function(interval) {
	      return this.isValidNoteValue(interval);
	    },
	
	    getNoteParts: function(noteString) {
	      if (!noteString || noteString.length < 1)
	        throw new Vex.RERR("BadArguments", "Invalid note name: " + noteString);
	
	      if (noteString.length > 3)
	        throw new Vex.RERR("BadArguments", "Invalid note name: " + noteString);
	
	      var note = noteString.toLowerCase();
	
	      var regex = /^([cdefgab])(b|bb|n|#|##)?$/;
	      var match = regex.exec(note);
	
	      if (match != null) {
	        var root = match[1];
	        var accidental = match[2];
	
	        return {
	          'root': root,
	          'accidental': accidental
	        };
	      } else {
	        throw new Vex.RERR("BadArguments", "Invalid note name: " + noteString);
	      }
	    },
	
	    getKeyParts: function(keyString) {
	      if (!keyString || keyString.length < 1)
	        throw new Vex.RERR("BadArguments", "Invalid key: " + keyString);
	
	      var key = keyString.toLowerCase();
	
	      // Support Major, Minor, Melodic Minor, and Harmonic Minor key types.
	      var regex = /^([cdefgab])(b|#)?(mel|harm|m|M)?$/;
	      var match = regex.exec(key);
	
	      if (match != null) {
	        var root = match[1];
	        var accidental = match[2];
	        var type = match[3];
	
	        // Unspecified type implies major
	        if (!type) type = "M";
	
	        return {
	          'root': root,
	          'accidental': accidental,
	          'type': type
	        };
	      } else {
	        throw new Vex.RERR("BadArguments", "Invalid key: " + keyString);
	      }
	    },
	
	    getNoteValue: function(noteString) {
	      var value = Music.noteValues[noteString];
	      if (value == null)
	        throw new Vex.RERR("BadArguments", "Invalid note name: " + noteString);
	
	      return value.int_val;
	    },
	
	    getIntervalValue: function(intervalString) {
	      var value = Music.intervals[intervalString];
	      if (value == null)
	        throw new Vex.RERR("BadArguments",
	                           "Invalid interval name: " + intervalString);
	
	      return value;
	    },
	
	    getCanonicalNoteName: function(noteValue) {
	      if (!this.isValidNoteValue(noteValue))
	        throw new Vex.RERR("BadArguments",
	                           "Invalid note value: " + noteValue);
	
	      return Music.canonical_notes[noteValue];
	    },
	
	    getCanonicalIntervalName: function(intervalValue) {
	      if (!this.isValidIntervalValue(intervalValue))
	        throw new Vex.RERR("BadArguments",
	                           "Invalid interval value: " + intervalValue);
	
	      return Music.diatonic_intervals[intervalValue];
	    },
	
	    /* Given a note, interval, and interval direction, product the
	     * relative note.
	     */
	    getRelativeNoteValue: function(noteValue, intervalValue, direction) {
	      if (direction == null) direction = 1;
	      if (direction != 1 && direction != -1)
	        throw new Vex.RERR("BadArguments", "Invalid direction: " + direction);
	
	      var sum = (noteValue + (direction * intervalValue)) % Music.NUM_TONES;
	      if (sum < 0) sum += Music.NUM_TONES;
	
	      return sum;
	    },
	
	    getRelativeNoteName: function(root, noteValue) {
	      var parts = this.getNoteParts(root);
	      var rootValue = this.getNoteValue(parts.root);
	      var interval = noteValue - rootValue;
	
	      if (Math.abs(interval) > Music.NUM_TONES - 3) {
	        var multiplier = 1;
	        if (interval > 0 ) multiplier = -1;
	
	        // Possibly wrap around. (Add +1 for modulo operator)
	        var reverse_interval = (((noteValue + 1) + (rootValue + 1)) %
	          Music.NUM_TONES) * multiplier;
	
	        if (Math.abs(reverse_interval) > 2) {
	          throw new Vex.RERR("BadArguments", "Notes not related: " + root + ", " +
	                            noteValue);
	        } else {
	          interval = reverse_interval;
	        }
	      }
	
	      if (Math.abs(interval) > 2)
	          throw new Vex.RERR("BadArguments", "Notes not related: " + root + ", " +
	                            noteValue);
	
	      var relativeNoteName = parts.root;
	      var i;
	      if (interval > 0) {
	        for (i = 1; i <= interval; ++i)
	          relativeNoteName += "#";
	      } else if (interval < 0) {
	        for (i = -1; i >= interval; --i)
	          relativeNoteName += "b";
	      }
	
	      return relativeNoteName;
	    },
	
	    /* Return scale tones, given intervals. Each successive interval is
	     * relative to the previous one, e.g., Major Scale:
	     *
	     *   TTSTTTS = [2,2,1,2,2,2,1]
	     *
	     * When used with key = 0, returns C scale (which is isomorphic to
	     * interval list).
	     */
	    getScaleTones: function(key, intervals) {
	      var tones = [];
	      tones.push(key);
	
	      var nextNote = key;
	      for (var i = 0; i < intervals.length; ++i) {
	        nextNote = this.getRelativeNoteValue(nextNote,
	                                             intervals[i]);
	        if (nextNote != key) tones.push(nextNote);
	      }
	
	      return tones;
	    },
	
	    /* Returns the interval of a note, given a diatonic scale.
	     *
	     * E.g., Given the scale C, and the note E, returns M3
	     */
	    getIntervalBetween: function(note1, note2, direction) {
	      if (direction == null) direction = 1;
	      if (direction != 1 && direction != -1)
	        throw new Vex.RERR("BadArguments", "Invalid direction: " + direction);
	      if (!this.isValidNoteValue(note1) || !this.isValidNoteValue(note2))
	        throw new Vex.RERR("BadArguments",
	                           "Invalid notes: " + note1 + ", " + note2);
	
	      var difference;
	      if (direction == 1)
	        difference = note2 - note1;
	      else
	        difference = note1 - note2;
	
	      if (difference < 0) difference += Music.NUM_TONES;
	      return difference;
	    },
	
	    // Create a scale map that represents the pitch state for a
	    // `keySignature`. For example, passing a `G` to `keySignature` would 
	    // return a scale map with every note naturalized except for `F` which
	    // has an `F#` state.
	    createScaleMap: function(keySignature) {
	      var keySigParts = this.getKeyParts(keySignature);
	      var scaleName = Vex.Flow.KeyManager.scales[keySigParts.type];
	
	      var keySigString = keySigParts.root;
	      if (keySigParts.accidental) keySigString += keySigParts.accidental;
	
	      if (!scaleName) throw new Vex.RERR("BadArguments", "Unsupported key type: " + keySignature);
	
	      var scale = this.getScaleTones(this.getNoteValue(keySigString), scaleName);
	      var noteLocation = Vex.Flow.Music.root_indices[keySigParts.root];
	
	      var scaleMap = {};
	      for (var i = 0; i < Vex.Flow.Music.roots.length; ++i) {
	        var index = (noteLocation + i) % Vex.Flow.Music.roots.length;
	        var rootName = Vex.Flow.Music.roots[index];
	        var noteName = this.getRelativeNoteName(rootName, scale[i]);
	
	        if (noteName.length === 1) {
	          noteName += "n";
	        }
	
	        scaleMap[rootName] = noteName;
	      }
	
	      return scaleMap;
	    }
	
	  };
	
	  return Music;
	}());
	
	// VexFlow - Music Engraving for HTML5
	// Copyright Mohit Muthanna 2010
	//
	// This class implements diatonic key management.
	//
	// requires: vex.js   (Vex)
	// requires: flow.js  (Vex.Flow)
	// requires: music.js (Vex.Flow.Music)
	
	/**
	 * @constructor
	 */
	Vex.Flow.KeyManager = (function() {
	  function KeyManager(key) {
	    this.init(key);
	  }
	
	  KeyManager.scales = {
	    "M": Vex.Flow.Music.scales.major,
	    "m": Vex.Flow.Music.scales.minor
	  };
	
	  KeyManager.prototype = {
	    init: function(key) {
	      this.music = new Vex.Flow.Music();
	      this.setKey(key);
	    },
	
	    setKey: function(key) {
	      this.key = key;
	      this.reset();
	      return this;
	    },
	
	    getKey: function() { return this.key; },
	
	    reset: function() {
	      this.keyParts = this.music.getKeyParts(this.key);
	
	      this.keyString = this.keyParts.root;
	      if (this.keyParts.accidental) this.keyString += this.keyParts.accidental;
	
	      var is_supported_type = KeyManager.scales[this.keyParts.type];
	      if (!is_supported_type)
	        throw new Vex.RERR("BadArguments", "Unsupported key type: " + this.key);
	
	      this.scale = this.music.getScaleTones(
	          this.music.getNoteValue(this.keyString),
	          Vex.Flow.KeyManager.scales[this.keyParts.type]);
	
	      this.scaleMap = {};
	      this.scaleMapByValue = {};
	      this.originalScaleMapByValue = {};
	
	      var noteLocation = Vex.Flow.Music.root_indices[this.keyParts.root];
	
	      for (var i = 0; i < Vex.Flow.Music.roots.length; ++i) {
	        var index = (noteLocation + i) % Vex.Flow.Music.roots.length;
	        var rootName = Vex.Flow.Music.roots[index];
	
	        var noteName = this.music.getRelativeNoteName(rootName, this.scale[i]);
	        this.scaleMap[rootName] = noteName;
	        this.scaleMapByValue[this.scale[i]] = noteName;
	        this.originalScaleMapByValue[this.scale[i]] = noteName;
	      }
	
	      return this;
	    },
	
	    getAccidental: function(key) {
	      var root = this.music.getKeyParts(key).root;
	      var parts = this.music.getNoteParts(this.scaleMap[root]);
	
	      return {
	        note: this.scaleMap[root],
	        accidental: parts.accidental
	      };
	    },
	
	    selectNote: function(note) {
	      note = note.toLowerCase();
	      var parts = this.music.getNoteParts(note);
	
	      // First look for matching note in our altered scale
	      var scaleNote = this.scaleMap[parts.root];
	      var modparts = this.music.getNoteParts(scaleNote);
	
	      if (scaleNote == note) return {
	        "note": scaleNote,
	        "accidental": parts.accidental,
	        "change": false
	      };
	
	      // Then search for a note of equivalent value in our altered scale
	      var valueNote = this.scaleMapByValue[this.music.getNoteValue(note)];
	      if (valueNote != null) {
	        return {
	          "note": valueNote,
	          "accidental": this.music.getNoteParts(valueNote).accidental,
	          "change": false
	        };
	      }
	
	      // Then search for a note of equivalent value in the original scale
	      var originalValueNote = this.originalScaleMapByValue[
	        this.music.getNoteValue(note)];
	      if (originalValueNote != null) {
	        this.scaleMap[modparts.root] = originalValueNote;
	        delete this.scaleMapByValue[this.music.getNoteValue(scaleNote)];
	        this.scaleMapByValue[this.music.getNoteValue(note)] = originalValueNote;
	        return {
	          "note": originalValueNote,
	          "accidental": this.music.getNoteParts(originalValueNote).accidental,
	          "change": true
	        };
	      }
	
	      // Then try to unmodify a currently modified note.
	      if (modparts.root == note) {
	        delete this.scaleMapByValue[
	          this.music.getNoteValue(this.scaleMap[parts.root])];
	        this.scaleMapByValue[this.music.getNoteValue(modparts.root)] =
	          modparts.root;
	        this.scaleMap[modparts.root] = modparts.root;
	        return {
	          "note": modparts.root,
	          "accidental": null,
	          "change": true
	        };
	      }
	
	      // Last resort -- shitshoot
	      delete this.scaleMapByValue[
	        this.music.getNoteValue(this.scaleMap[parts.root])];
	      this.scaleMapByValue[this.music.getNoteValue(note)] = note;
	
	      delete this.scaleMap[modparts.root];
	      this.scaleMap[modparts.root] = note;
	
	      return {
	        "note": note,
	        "accidental": parts.accidental,
	        "change": true
	      };
	    }
	  };
	
	  return KeyManager;
	}());
	
	// Vex Flow
	// Mohit Muthanna <mohit@muthanna.com>
	//
	// Support for different rendering contexts: Canvas, Raphael
	//
	// Copyright Mohit Cheppudira 2010
	
	/* global document: false */
	
	Vex.Flow.Renderer = (function() {
	  function Renderer(sel, backend) {
	    if (arguments.length > 0) this.init(sel, backend);
	  }
	
	  Renderer.Backends = {
	    CANVAS: 1,
	    RAPHAEL: 2,
	    SVG: 3,
	    VML: 4
	  };
	
	  //End of line types
	  Renderer.LineEndType = {
	      NONE: 1,        // No leg
	      UP: 2,          // Upward leg
	      DOWN: 3         // Downward leg
	  };
	
	  // Set this to true if you're using VexFlow inside a runtime
	  // that does not allow modifiying canvas objects. There is a small
	  // performance degradation due to the extra indirection.
	  Renderer.USE_CANVAS_PROXY = false;
	  Renderer.lastContext = null;
	
	  Renderer.buildContext = function(sel,
	      backend, width, height, background) {
	
	    var renderer = new Renderer(sel, backend);
	    if (width && height) { renderer.resize(width, height); }
	
	    if (!background) background = "#FFF";
	    var ctx = renderer.getContext();
	    ctx.setBackgroundFillStyle(background);
	    Renderer.lastContext = ctx;
	    return ctx;
	  };
	
	  Renderer.getCanvasContext = function(sel, width, height, background) {
	    return Renderer.buildContext(sel, Renderer.Backends.CANVAS,
	        width, height, background);
	  };
	
	  Renderer.getRaphaelContext = function(sel, width, height, background) {
	    return Renderer.buildContext(sel, Renderer.Backends.RAPHAEL,
	        width, height, background);
	  };
	
	  Renderer.getSVGContext = function(sel, width, height, background) {
	    return Renderer.buildContext(sel, Renderer.Backends.SVG,
	        width, height, background);
	  };
	
	
	  Renderer.bolsterCanvasContext = function(ctx) {
	    if (Renderer.USE_CANVAS_PROXY) {
	      return new Vex.Flow.CanvasContext(ctx);
	    }
	
	    var methods = ["clear", "setFont", "setRawFont", "setFillStyle", "setBackgroundFillStyle",
	                   "setStrokeStyle", "setShadowColor", "setShadowBlur", "setLineWidth",
	                   "setLineCap", "setLineDash", "openGroup", "closeGroup", "getGroup"];
	    ctx.vexFlowCanvasContext = ctx;
	
	    for (var i in methods) {
	      var method = methods[i];
	      ctx[method] = Vex.Flow.CanvasContext.prototype[method];
	    }
	
	    return ctx;
	  };
	
	  //Draw a dashed line (horizontal, vertical or diagonal
	  //dashPattern = [3,3] draws a 3 pixel dash followed by a three pixel space.
	  //setting the second number to 0 draws a solid line.
	  Renderer.drawDashedLine = function(context, fromX, fromY, toX, toY, dashPattern) {
	    context.beginPath();
	
	    var dx = toX - fromX;
	    var dy = toY - fromY;
	    var angle = Math.atan2(dy, dx);
	    var x = fromX;
	    var y = fromY;
	    context.moveTo(fromX, fromY);
	    var idx = 0;
	    var draw = true;
	    while (!((dx < 0 ? x <= toX : x >= toX) && (dy < 0 ? y <= toY : y >= toY))) {
	      var dashLength = dashPattern[idx++ % dashPattern.length];
	      var nx = x + (Math.cos(angle) * dashLength);
	      x = dx < 0 ? Math.max(toX, nx) : Math.min(toX, nx);
	      var ny = y + (Math.sin(angle) * dashLength);
	      y = dy < 0 ? Math.max(toY, ny) : Math.min(toY, ny);
	      if (draw) {
	        context.lineTo(x, y);
	      } else {
	        context.moveTo(x, y);
	      }
	        draw = !draw;
	    }
	
	    context.closePath();
	    context.stroke();
	  };
	
	  Renderer.prototype = {
	    init: function(sel, backend) {
	      // Verify selector
	      this.sel = sel;
	      if (!this.sel) throw new Vex.RERR("BadArgument",
	          "Invalid selector for renderer.");
	
	      // Get element from selector
	      this.element = document.getElementById(sel);
	      if (!this.element) this.element = sel;
	
	      // Verify backend and create context
	      this.ctx = null;
	      this.paper = null;
	      this.backend = backend;
	      if (this.backend == Renderer.Backends.CANVAS) {
	        // Create context.
	        if (!this.element.getContext) throw new Vex.RERR("BadElement",
	          "Can't get canvas context from element: " + sel);
	        this.ctx = Renderer.bolsterCanvasContext(
	            this.element.getContext('2d'));
	
	      } else if (this.backend == Renderer.Backends.RAPHAEL) {
	        this.ctx = new Vex.Flow.RaphaelContext(this.element);
	
	      } else if (this.backend == Renderer.Backends.SVG) {
	        this.ctx = new Vex.Flow.SVGContext(this.element);
	
	      } else {
	        throw new Vex.RERR("InvalidBackend",
	          "No support for backend: " + this.backend);
	      }
	    },
	
	    resize: function(width, height) {
	      if (this.backend == Renderer.Backends.CANVAS) {
	        if (!this.element.getContext) throw new Vex.RERR("BadElement",
	          "Can't get canvas context from element: " + this.sel);
	        this.element.width = width;
	        this.element.height = height;
	        this.ctx = Renderer.bolsterCanvasContext(
	            this.element.getContext('2d'));
	      } else {
	        this.ctx.resize(width, height);
	      }
	
	      return this;
	    },
	
	    getContext: function() { return this.ctx; }
	  };
	
	  return Renderer;
	}());
	
	
	
	// Vex Flow
	// Mohit Muthanna <mohit@muthanna.com>
	//
	// A rendering context for the Raphael backend.
	//
	// Copyright Mohit Cheppudira 2010
	
	// ## Warning: Deprecated for SVGContext
	// Except in instances where SVG support for IE < 9.0 is
	// needed, SVGContext is recommended.
	
	/** @constructor */
	Vex.Flow.RaphaelContext = (function() {
	  function RaphaelContext(element) {
	    if (arguments.length > 0) this.init(element);
	  }
	
	  RaphaelContext.prototype = {
	    init: function(element) {
	      this.element = element;
	      this.paper = Raphael(element);
	      this.path = "";
	      this.pen = {x: 0, y: 0};
	      this.lineWidth = 1.0;
	      this.state = {
	        scale: { x: 1, y: 1 },
	        font_family: "Arial",
	        font_size: 8,
	        font_weight: 800
	      };
	
	      this.attributes = {
	        "stroke-width": 0.3,
	        "fill": "black",
	        "stroke": "black",
	        "font": "10pt Arial"
	      };
	
	      this.background_attributes = {
	        "stroke-width": 0,
	        "fill": "white",
	        "stroke": "white",
	        "font": "10pt Arial"
	      };
	
	      this.shadow_attributes = {
	        width: 0,
	        color: "black"
	      };
	
	      this.state_stack= [];
	    },
	
	    // Containers not implemented
	    openGroup: function(cls, id, attrs) {},
	    closeGroup: function() {},
	    add: function(elem) {},
	
	    setFont: function(family, size, weight) {
	      this.state.font_family = family;
	      this.state.font_size = size;
	      this.state.font_weight = weight;
	      this.attributes.font = (this.state.font_weight || "") + " " +
	        (this.state.font_size * this.state.scale.x) + "pt " +
	        this.state.font_family;
	      return this;
	    },
	
	    setRawFont: function(font) {
	      this.attributes.font = font;
	      return this;
	    },
	
	    setFillStyle: function(style) {
	      this.attributes.fill = style;
	      return this;
	    },
	
	    setBackgroundFillStyle: function(style) {
	      this.background_attributes.fill = style;
	      this.background_attributes.stroke = style;
	      return this;
	    },
	
	    setStrokeStyle: function(style) {
	      this.attributes.stroke = style;
	      return this;
	    },
	
	    setShadowColor: function(style) {
	      this.shadow_attributes.color = style;
	      return this;
	    },
	
	    setShadowBlur: function(blur) {
	      this.shadow_attributes.width = blur;
	      return this;
	    },
	
	    setLineWidth: function(width) {
	      this.attributes["stroke-width"] = width;
	      this.lineWidth = width;
	    },
	
	    // Empty because there is no equivalent in SVG
	    setLineDash: function() { return this; },
	    setLineCap: function() { return this; },
	
	    scale: function(x, y) {
	      this.state.scale = { x: x, y: y };
	      // The scale() method is deprecated as of Raphael.JS 2.0, and
	      // can no longer be used as an option in an Element.attr() call.
	      // It is preserved here for users running earlier versions of
	      // Raphael.JS, though it has no effect on the SVG output in
	      // Raphael 2 and higher.
	      this.attributes.transform = "S" + x + "," + y + ",0,0";
	      this.attributes.scale = x + "," + y + ",0,0";
	      this.attributes.font = this.state.font_size * this.state.scale.x + "pt " +
	        this.state.font_family;
	      this.background_attributes.transform = "S" + x + "," + y + ",0,0";
	      this.background_attributes.font = this.state.font_size *
	        this.state.scale.x + "pt " +
	        this.state.font_family;
	      return this;
	    },
	
	    clear: function() { this.paper.clear(); },
	
	    resize: function(width, height) {
	      this.element.style.width = width;
	      this.paper.setSize(width, height);
	      return this;
	    },
	
	    // Sets the SVG `viewBox` property, which results in auto scaling images when its container
	    // is resized.
	    //
	    // Usage: `ctx.setViewBox("0 0 600 400")`
	    setViewBox: function(viewBox) {
	      this.paper.canvas.setAttribute('viewBox', viewBox);
	    },
	
	    rect: function(x, y, width, height) {
	      if (height < 0) {
	        y += height;
	        height = -height;
	      }
	
	      this.paper.rect(x, y, width - 0.5, height - 0.5).
	        attr(this.attributes).
	        attr("fill", "none").
	        attr("stroke-width", this.lineWidth);
	      return this;
	    },
	
	    fillRect: function(x, y, width, height) {
	      if (height < 0) {
	        y += height;
	        height = -height;
	      }
	
	      this.paper.rect(x, y, width - 0.5, height - 0.5).
	        attr(this.attributes);
	      return this;
	    },
	
	    clearRect: function(x, y, width, height) {
	      if (height < 0) {
	        y += height;
	        height = -height;
	      }
	
	      this.paper.rect(x, y, width - 0.5, height - 0.5).
	        attr(this.background_attributes);
	      return this;
	    },
	
	    beginPath: function() {
	      this.path = "";
	      this.pen.x = 0;
	      this.pen.y = 0;
	      return this;
	    },
	
	    moveTo: function(x, y) {
	      this.path += "M" + x + "," + y;
	      this.pen.x = x;
	      this.pen.y = y;
	      return this;
	    },
	
	    lineTo: function(x, y) {
	      this.path += "L" + x + "," + y;
	      this.pen.x = x;
	      this.pen.y = y;
	      return this;
	    },
	
	    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	      this.path += "C" +
	        x1 + "," +
	        y1 + "," +
	        x2 + "," +
	        y2 + "," +
	        x + "," +
	        y;
	      this.pen.x = x;
	      this.pen.y = y;
	      return this;
	    },
	
	    quadraticCurveTo: function(x1, y1, x, y) {
	      this.path += "Q" +
	        x1 + "," +
	        y1 + "," +
	        x + "," +
	        y;
	      this.pen.x = x;
	      this.pen.y = y;
	      return this;
	    },
	
	    // This is an attempt (hack) to simulate the HTML5 canvas
	    // arc method.
	    arc: function(x, y, radius, startAngle, endAngle, antiClockwise) {
	      function normalizeAngle(angle) {
	        while (angle < 0) {
	          angle += Math.PI * 2;
	        }
	
	        while (angle > Math.PI * 2) {
	          angle -= Math.PI * 2;
	        }
	        return angle;
	      }
	
	      startAngle = normalizeAngle(startAngle);
	      endAngle = normalizeAngle(endAngle);
	
	      if (startAngle > endAngle) {
	          var tmp = startAngle;
	          startAngle = endAngle;
	          endAngle = tmp;
	          antiClockwise = !antiClockwise;
	      }
	
	      var delta = endAngle - startAngle;
	
	      if (delta > Math.PI) {
	          this.arcHelper(x, y, radius, startAngle, startAngle + delta / 2,
	                         antiClockwise);
	          this.arcHelper(x, y, radius, startAngle + delta / 2, endAngle,
	                         antiClockwise);
	      }
	      else {
	          this.arcHelper(x, y, radius, startAngle, endAngle, antiClockwise);
	      }
	      return this;
	    },
	
	    arcHelper: function(x, y, radius, startAngle, endAngle, antiClockwise) {
	      var x1 = x + radius * Math.cos(startAngle);
	      var y1 = y + radius * Math.sin(startAngle);
	
	      var x2 = x + radius * Math.cos(endAngle);
	      var y2 = y + radius * Math.sin(endAngle);
	
	      var largeArcFlag = 0;
	      var sweepFlag = 0;
	      if (antiClockwise) {
	        sweepFlag = 1;
	        if (endAngle - startAngle < Math.PI)
	          largeArcFlag = 1;
	      }
	      else if (endAngle - startAngle > Math.PI) {
	          largeArcFlag = 1;
	      }
	
	      this.path += "M" + x1 + "," + y1 + "," + "A" +
	        radius + "," + radius + "," + "0," + largeArcFlag + "," + sweepFlag + "," +
	        x2 + "," + y2 + "M" + this.pen.x + "," + this.pen.y;
	    },
	
	    // Adapted from the source for Raphael's Element.glow
	    glow: function() {
	      var out = this.paper.set();
	      if (this.shadow_attributes.width > 0) {
	        var sa = this.shadow_attributes;
	        var num_paths = sa.width / 2;
	        for (var i = 1; i <= num_paths; i++) {
	          out.push(this.paper.path(this.path).attr({
	            stroke: sa.color,
	            "stroke-linejoin": "round",
	            "stroke-linecap": "round",
	            "stroke-width": +(sa.width / num_paths * i).toFixed(3),
	            opacity: +((sa.opacity || 0.3) / num_paths).toFixed(3),
	            // See note in this.scale(): In Raphael the scale() method
	            // is deprecated and removed as of Raphael 2.0 and replaced
	            // by the transform() method.  It is preserved here for
	            // users with earlier versions of Raphael, but has no effect
	            // on the output SVG in Raphael 2.0+.
	            transform: this.attributes.transform,
	            scale: this.attributes.scale
	          }));
	        }
	      }
	      return out;
	    },
	
	    fill: function() {
	      var elem = this.paper.path(this.path).
	        attr(this.attributes).
	        attr("stroke-width", 0);
	      this.glow(elem);
	      return this;
	    },
	
	    stroke: function() {
	      // The first line of code below is, unfortunately, a bit of a hack:
	      // Raphael's transform() scaling does not scale the stroke-width, so
	      // in order to scale a stroke, we have to manually scale the
	      // stroke-width.
	      //
	      // This works well so long as the X & Y states for this.scale() are
	      // relatively similar.  However, if they are very different, we
	      // would expect horizontal and vertical lines to have different
	      // stroke-widths.
	      //
	      // In the future, if we want to support very divergent values for
	      // horizontal and vertical scaling, we may want to consider
	      // implementing SVG scaling with properties of the SVG viewBox &
	      // viewPort and removing it entirely from the Element.attr() calls.
	      // This would more closely parallel the approach taken in
	      // canvascontext.js as well.
	
	      var strokeWidth = this.lineWidth * (this.state.scale.x + this.state.scale.y)/2;
	      var elem = this.paper.path(this.path).
	        attr(this.attributes).
	        attr("fill", "none").
	        attr("stroke-width", strokeWidth);
	      this.glow(elem);
	      return this;
	    },
	
	    closePath: function() {
	      this.path += "Z";
	      return this;
	    },
	
	    measureText: function(text) {
	      var txt = this.paper.text(0, 0, text).
	        attr(this.attributes).
	        attr("fill", "none").
	        attr("stroke", "none");
	      var bounds = txt.getBBox();
	      txt.remove();
	
	      return {
	        width: bounds.width,
	        height: bounds.height
	      };
	    },
	
	    fillText: function(text, x, y) {
	      this.paper.text(x + (this.measureText(text).width / 2),
	          (y - (this.state.font_size / (2.25 * this.state.scale.y))), text).
	        attr(this.attributes);
	      return this;
	    },
	
	    save: function() {
	      // TODO(mmuthanna): State needs to be deep-copied.
	      this.state_stack.push({
	        state: {
	          font_family: this.state.font_family
	        },
	        attributes: {
	          font: this.attributes.font,
	          fill: this.attributes.fill,
	          stroke: this.attributes.stroke,
	          "stroke-width": this.attributes["stroke-width"]
	        },
	        shadow_attributes: {
	          width: this.shadow_attributes.width,
	          color: this.shadow_attributes.color
	        }
	      });
	      return this;
	    },
	
	    restore: function() {
	      // TODO(0xfe): State needs to be deep-restored.
	      var state = this.state_stack.pop();
	      this.state.font_family = state.state.font_family;
	      this.attributes.font = state.attributes.font;
	      this.attributes.fill = state.attributes.fill;
	      this.attributes.stroke = state.attributes.stroke;
	      this.attributes["stroke-width"] = state.attributes["stroke-width"];
	      this.shadow_attributes.width = state.shadow_attributes.width;
	      this.shadow_attributes.color = state.shadow_attributes.color;
	      return this;
	    }
	  };
	
	  return RaphaelContext;
	}());
	
	// Vex Flow
	// Mohit Muthanna <mohit@muthanna.com>
	//
	// A rendering context for SVG.
	//
	// Copyright Mohit Muthanna 2015
	// @author Gregory Ristow (2015)
	
	/** @constructor */
	Vex.Flow.SVGContext = (function() {
	  function SVGContext(element) {
	    if (arguments.length > 0) this.init(element);
	  }
	
	  // The measureTextCache is used in Javascript runtimes where
	  // there is no proper DOM support for SVG bounding boxes. This
	  // is currently only useful in the NodeJS visual regression tests.
	  SVGContext.measureTextCache = {};
	
	  // If enabled, will start collecting and indexing getBBox data by
	  // font name, size, weight, and style. This should be disabled by
	  // default (or you will find yourself slowly leaking RAM.)
	  SVGContext.collectMeasurements = false;
	
	  // If enabled, will warn if there are new getBBox requests that are
	  // not in the cache. This is enabled in the VexFlow tests, and if you
	  // see a warning on the console, you will need to enable collectMeasurements
	  // above, then update measureTextCache with the new values. See
	  // tests/measure_text_cache.js for instructions on how to do this.
	  SVGContext.validateMeasurement = false;
	
	  SVGContext.addPrefix = Vex.Prefix;
	
	  SVGContext.prototype = {
	    init: function(element) {
	      // element is the parent DOM object
	      this.element = element;
	      // Create the SVG in the SVG namespace:
	      this.svgNS = "http://www.w3.org/2000/svg";
	      var svg = this.create("svg");
	      // Add it to the canvas:
	      this.element.appendChild(svg);
	
	      // Point to it:
	      this.svg = svg;
	      this.groups = [this.svg]; // Create the group stack
	      this.parent = this.svg;
	
	      this.path = "";
	      this.pen = {x: 0, y: 0};
	      this.lineWidth = 1.0;
	      this.state = {
	        scale: { x: 1, y: 1 },
	        "font-family": "Arial",
	        "font-size": "8pt",
	        "font-weight": "normal"
	      };
	
	      this.attributes = {
	        "stroke-width": 0.3,
	        "fill": "black",
	        "stroke": "black",
	        "font-family": "Arial",
	        "font-size" : "10pt",
	        "font-weight" : "normal",
	        "font-style" : "normal"
	      };
	
	      this.background_attributes = {
	        "stroke-width": 0,
	        "fill": "white",
	        "stroke": "white",
	        "font-family": "Arial",
	        "font-size" : "10pt",
	        "font-weight": "normal",
	        "font-style": "normal"
	      };
	
	      this.shadow_attributes = {
	        width: 0,
	        color: "black"
	      };
	
	      this.state_stack= [];
	
	      // Test for Internet Explorer
	      this.iePolyfill();
	    },
	
	    create: function(svgElementType) {
	      return document.createElementNS(this.svgNS, svgElementType);
	    },
	
	    // Allow grouping elements in containers for interactivity.
	    openGroup: function(cls, id, attrs) {
	      var group = this.create("g");
	      this.groups.push(group);
	      this.parent.appendChild(group);
	      this.parent = group;
	      if (cls) group.setAttribute("class", SVGContext.addPrefix(cls));
	      if (id) group.setAttribute("id", SVGContext.addPrefix(id));
	
	      if (attrs && attrs.pointerBBox) {
	        group.setAttribute("pointer-events", "bounding-box");
	      }
	      return group;
	    },
	
	    closeGroup: function() {
	      var group = this.groups.pop();
	      this.parent = this.groups[this.groups.length - 1];
	    },
	
	    add: function(elem) {
	      this.parent.appendChild(elem);
	    },
	
	    // Tests if the browser is Internet Explorer; if it is,
	    // we do some tricks to improve text layout.  See the
	    // note at ieMeasureTextFix() for details.
	    iePolyfill: function() {
	      if (typeof(navigator) !== "undefined") {
	        this.ie = (  /MSIE 9/i.test(navigator.userAgent) ||
	                            /MSIE 10/i.test(navigator.userAgent) ||
	                            /rv:11\.0/i.test(navigator.userAgent) ||
	                            /Trident/i.test(navigator.userAgent) );
	      }
	    },
	
	    // ### Styling & State Methods:
	
	    setFont: function(family, size, weight) {
	      // Unlike canvas, in SVG italic is handled by font-style,
	      // not weight. So: we search the weight argument and
	      // apply bold and italic to weight and style respectively.
	      var bold = false;
	      var italic = false;
	      var style = "normal";
	      // Weight might also be a number (200, 400, etc...) so we
	      // test its type to be sure we have access to String methods.
	      if( typeof weight == "string" ) {
	          // look for "italic" in the weight:
	          if(weight.indexOf("italic") !== -1) {
	            weight = weight.replace(/italic/g, "");
	            italic = true;
	          }
	          // look for "bold" in weight
	          if(weight.indexOf("bold") !== -1) {
	            weight = weight.replace(/bold/g, "");
	            bold = true;
	          }
	          // remove any remaining spaces
	          weight = weight.replace(/ /g, "");
	      }
	      weight = bold ? "bold" : weight;
	      weight = (typeof weight === "undefined" || weight === "") ? "normal" : weight;
	
	      style = italic ? "italic" : style;
	
	      var fontAttributes = {
	        "font-family": family,
	        "font-size": size + "pt",
	        "font-weight": weight,
	        "font-style" : style
	      };
	
	      // Store the font size so that if the browser is Internet
	      // Explorer we can fix its calculations of text width.
	      this.fontSize = Number(size);
	
	      Vex.Merge(this.attributes, fontAttributes);
	      Vex.Merge(this.state, fontAttributes);
	
	      return this;
	    },
	
	    setRawFont: function(font) {
	      font=font.trim();
	      // Assumes size first, splits on space -- which is presently
	      // how all existing modules are calling this.
	      var fontArray = font.split(" ");
	
	      this.attributes["font-family"] = fontArray[1];
	      this.state["font-family"] = fontArray[1];
	
	      this.attributes["font-size"] = fontArray[0];
	      this.state["font-size"] = fontArray[0];
	
	      // Saves fontSize for IE polyfill
	      this.fontSize = Number(fontArray[0].match(/\d+/));
	      return this;
	    },
	
	    setFillStyle: function(style) {
	      this.attributes.fill = style;
	      return this;
	    },
	
	    setBackgroundFillStyle: function(style) {
	      this.background_attributes.fill = style;
	      this.background_attributes.stroke = style;
	      return this;
	    },
	
	    setStrokeStyle: function(style) {
	      this.attributes.stroke = style;
	      return this;
	    },
	
	    setShadowColor: function(style) {
	      this.shadow_attributes.color = style;
	      return this;
	    },
	
	    setShadowBlur: function(blur) {
	      this.shadow_attributes.width = blur;
	      return this;
	    },
	
	    setLineWidth: function(width) {
	      this.attributes["stroke-width"] = width;
	      this.lineWidth = width;
	    },
	
	    setLineDash: function(lineDash) {
	      this.attributes["stroke-linedash"] = lineDash;
	      return this;
	    },
	
	    setLineCap: function(lineCap) {
	      this.attributes["stroke-linecap"] = lineCap;
	      return this;
	    },
	
	    // ### Sizing & Scaling Methods:
	
	    // TODO (GCR): See note at scale() -- seperate our internal
	    // conception of pixel-based width/height from the style.width
	    // and style.height properties eventually to allow users to
	    // apply responsive sizing attributes to the SVG.
	    resize: function(width, height) {
	      this.width = width;
	      this.height = height;
	      this.element.style.width = width;
	      var attributes = {
	        width : width,
	        height : height
	      };
	      this.applyAttributes(this.svg, attributes);
	      return this;
	    },
	
	    scale: function(x, y) {
	      // uses viewBox to scale
	      // TODO (GCR): we may at some point want to distinguish the
	      // style.width / style.height properties that are applied to
	      // the SVG object from our internal conception of the SVG
	      // width/height.  This would allow us to create automatically
	      // scaling SVG's that filled their containers, for instance.
	      //
	      // As this isn't implemented in Canvas or Raphael contexts,
	      // I've left as is for now, but in using the viewBox to
	      // handle internal scaling, am trying to make it possible
	      // for us to eventually move in that direction.
	
	      this.state.scale = { x: x, y: y };
	      var visibleWidth = this.width / x;
	      var visibleHeight = this.height / y;
	      this.setViewBox(0,0, visibleWidth, visibleHeight);
	
	      return this;
	    },
	
	    setViewBox: function(xMin, yMin, width, height) {
	      // Override for "x y w h" style:
	      if(arguments.length == 1) this.svg.setAttribute("viewBox", viewBox);
	      else {
	        var viewBoxString = xMin + " " + yMin + " " + width + " " + height;
	        this.svg.setAttribute("viewBox", viewBoxString);
	      }
	    },
	
	    // ### Drawing helper methods:
	
	    applyAttributes: function(element, attributes) {
	      for(var propertyName in attributes) {
	        element.setAttributeNS(null, propertyName, attributes[propertyName]);
	      }
	      return element;
	    },
	
	    flipRectangle: function(args) {
	      // Avoid invalid negative height attributes by
	      // flipping a rectangle w/ negative height on its head.
	      // Since args is the actual arguments object from
	      // one of the rectangle functions, we don't need to
	      // return it.
	
	      // Add negative height to Y
	      args[1] += args[3];
	      // Make the negative height positive.
	      args[3] = -args[3];
	    },
	
	    // ### Shape & Path Methods:
	
	    clear: function() {
	      // Clear the SVG by removing all inner children.
	
	      // (This approach is usually slightly more efficient
	      // than removing the old SVG & adding a new one to
	      // the container element, since it does not cause the
	      // container to resize twice.  Also, the resize
	      // triggered by removing the entire SVG can trigger
	      // a touchcancel event when the element resizes away
	      // from a touch point.)
	
	      while (this.svg.lastChild) {
	        this.svg.removeChild(this.svg.lastChild);
	      }
	
	      // Replace the viewbox attribute we just removed:
	      this.scale(this.state.scale.x, this.state.scale.y);
	    },
	
	    // ## Rectangles:
	
	    rect: function(x, y, width, height, attributes) {
	      // Avoid invalid negative height attribs by
	      // flipping the rectangle on its head:
	      if (height < 0) this.flipRectangle(arguments);
	
	      // Create the rect & style it:
	      var rect = this.create("rect");
	      if(typeof attributes === "undefined") attributes = {
	        fill: "none",
	        "stroke-width": this.lineWidth,
	        stroke: "black"
	      };
	      Vex.Merge(attributes, {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	
	      this.applyAttributes(rect, attributes);
	
	      this.add(rect);
	      return this;
	    },
	
	    fillRect: function(x, y, width, height) {
	      if(height < 0) this.flipRectangle(arguments);
	
	      this.rect(x, y, width - 0.5, height - 0.5, this.attributes);
	      return this;
	    },
	
	    clearRect: function(x, y, width, height) {
	      // TODO(GCR): Improve implementation of this...
	      // Currently it draws a box of the background color, rather
	      // than creating alpha through lower z-levels.
	      //
	      // See the implementation of this in SVGKit:
	      // http://sourceforge.net/projects/svgkit/
	      // as a starting point.
	      //
	      // Adding a large number of transform paths (as we would
	      // have to do) could be a real performance hit.  Since
	      // tabNote seems to be the only module that makes use of this
	      // it may be worth creating a seperate tabStave that would
	      // draw lines around locations of tablature fingering.
	      //
	
	      if (height < 0) this.flipRectangle(arguments);
	
	      this.rect(x, y, width - 0.5, height - 0.5, this.background_attributes);
	      return this;
	    },
	
	    // ## Paths:
	
	    beginPath: function() {
	      this.path = "";
	      this.pen.x = 0;
	      this.pen.y = 0;
	      return this;
	    },
	
	    moveTo: function(x, y) {
	      this.path += "M" + x + " " + y;
	      this.pen.x = x;
	      this.pen.y = y;
	      return this;
	    },
	
	    lineTo: function(x, y) {
	      this.path += "L" + x + " " + y;
	      this.pen.x = x;
	      this.pen.y = y;
	      return this;
	    },
	
	    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	      this.path += "C" +
	        x1 + " " +
	        y1 + "," +
	        x2 + " " +
	        y2 + "," +
	        x + " " +
	        y;
	      this.pen.x = x;
	      this.pen.y = y;
	      return this;
	    },
	
	    quadraticCurveTo: function(x1, y1, x, y) {
	      this.path += "Q" +
	        x1 + " " +
	        y1 + "," +
	        x + " " +
	        y;
	      this.pen.x = x;
	      this.pen.y = y;
	      return this;
	    },
	
	    // This is an attempt (hack) to simulate the HTML5 canvas
	    // arc method.
	    arc: function(x, y, radius, startAngle, endAngle, antiClockwise) {
	      function normalizeAngle(angle) {
	        while (angle < 0) {
	          angle += Math.PI * 2;
	        }
	
	        while (angle > Math.PI * 2) {
	          angle -= Math.PI * 2;
	        }
	        return angle;
	      }
	
	      startAngle = normalizeAngle(startAngle);
	      endAngle = normalizeAngle(endAngle);
	
	      if (startAngle > endAngle) {
	          var tmp = startAngle;
	          startAngle = endAngle;
	          endAngle = tmp;
	          antiClockwise = !antiClockwise;
	      }
	
	      var delta = endAngle - startAngle;
	
	      if (delta > Math.PI) {
	          this.arcHelper(x, y, radius, startAngle, startAngle + delta / 2,
	                         antiClockwise);
	          this.arcHelper(x, y, radius, startAngle + delta / 2, endAngle,
	                         antiClockwise);
	      }
	      else {
	          this.arcHelper(x, y, radius, startAngle, endAngle, antiClockwise);
	      }
	      return this;
	    },
	
	    arcHelper: function(x, y, radius, startAngle, endAngle, antiClockwise) {
	      var x1 = x + radius * Math.cos(startAngle);
	      var y1 = y + radius * Math.sin(startAngle);
	
	      var x2 = x + radius * Math.cos(endAngle);
	      var y2 = y + radius * Math.sin(endAngle);
	
	      var largeArcFlag = 0;
	      var sweepFlag = 0;
	      if (antiClockwise) {
	        sweepFlag = 1;
	        if (endAngle - startAngle < Math.PI)
	          largeArcFlag = 1;
	      }
	      else if (endAngle - startAngle > Math.PI) {
	          largeArcFlag = 1;
	      }
	
	      this.path += "M" + x1 + " " + y1 + " " + "A" +
	        radius + " " + radius + " " + "0 " + largeArcFlag + " " + sweepFlag + " " +
	        x2 + " " + y2 + "M" + this.pen.x + " " + this.pen.y;
	
	    },
	
	    closePath: function() {
	      this.path += "Z";
	
	      return this;
	    },
	
	    // Adapted from the source for Raphael's Element.glow
	    glow: function() {
	      // Calculate the width & paths of the glow:
	      if (this.shadow_attributes.width > 0) {
	        var sa = this.shadow_attributes;
	        var num_paths = sa.width / 2;
	        // Stroke at varying widths to create effect of gaussian blur:
	        for (var i = 1; i <= num_paths; i++) {
	          var attributes = {
	            stroke: sa.color,
	            "stroke-linejoin": "round",
	            "stroke-linecap": "round",
	            "stroke-width": +((sa.width *0.4) / num_paths * i).toFixed(3),
	            opacity: +((sa.opacity || 0.3) / num_paths).toFixed(3),
	          };
	
	          var path = this.create("path");
	          attributes.d = this.path;
	          this.applyAttributes(path, attributes);
	          this.add(path);
	        }
	      }
	      return this;
	    },
	
	    fill: function(attributes) {
	      // If our current path is set to glow, make it glow
	      this.glow();
	
	      var path = this.create("path");
	      if(typeof attributes === "undefined") {
	        attributes = {};
	        Vex.Merge(attributes, this.attributes);
	        attributes.stroke = "none";
	      }
	
	      attributes.d = this.path;
	
	      this.applyAttributes(path, attributes);
	      this.add(path);
	      return this;
	    },
	
	    stroke: function() {
	      // If our current path is set to glow, make it glow.
	      this.glow();
	
	      var path = this.create("path");
	      var attributes = {};
	      Vex.Merge(attributes, this.attributes);
	      attributes.fill = "none";
	      attributes["stroke-width"] = this.lineWidth;
	      attributes.d = this.path;
	
	      this.applyAttributes(path, attributes);
	      this.add(path);
	      return this;
	    },
	
	    // ## Text Methods:
	    measureText: function(text) {
	      var index = text + this.attributes["font-style"] + this.attributes["font-family"] +
	                  this.attributes["font-weight"] + this.attributes["font-size"];
	
	      var txt = this.create("text");
	      if (typeof(txt.getBBox) === "function") {
	        txt.textContent = text;
	        this.applyAttributes(txt, this.attributes);
	
	        // Temporarily add it to the document for measurement.
	        this.svg.appendChild(txt);
	
	        var bbox = txt.getBBox();
	        if( this.ie &&
	            text !== "" &&
	            this.attributes["font-style"] == "italic") bbox = this.ieMeasureTextFix(bbox, text);
	        this.svg.removeChild(txt);
	
	        // For runtimes that do not have full support of bounding boxes, collect
	        // some data which can be used later to extrapolate them.
	        if (SVGContext.collectMeasurements) {
	          SVGContext.measureTextCache[index] = {
	            x: bbox.x,
	            y: bbox.y,
	            width: bbox.width,
	            height: bbox.height
	          };
	        }
	        if (SVGContext.validateMeasurements) {
	          if (!(index in SVGContext.measureTextCache)) {
	            Vex.W("measureTextCache is stale. Please update tests/measure_text_cache.js: ", index);
	          }
	        }
	        return bbox;
	      } else {
	        // Inside NodeJS or other runtimes that don't support getBBox. This
	        // is currently only useful for the NodeJS visual regression tests.
	        return SVGContext.measureTextCache[index];
	      }
	    },
	
	    ieMeasureTextFix: function(bbox, text) {
	    // Internet Explorer over-pads text in italics,
	    // resulting in giant width estimates for measureText.
	    // To fix this, we use this formula, tested against
	    // ie 11:
	    // overestimate (in pixels) = FontSize(in pt) * 1.196 + 1.96
	    // And then subtract the overestimate from calculated width.
	
	      var fontSize = Number(this.fontSize);
	      var m = 1.196;
	      var b = 1.9598;
	      var widthCorrection = (m * fontSize) + b;
	      var width = bbox.width - widthCorrection;
	      var height = bbox.height - 1.5;
	
	      // Get non-protected copy:
	      var box = {
	        x : bbox.x,
	        y : bbox.y,
	        width : width,
	        height : height
	      };
	
	      return box;
	    },
	
	    fillText: function(text, x, y) {
	      var attributes = {};
	      Vex.Merge(attributes, this.attributes);
	      attributes.stroke = "none";
	      attributes.x = x;
	      attributes.y = y;
	
	      var txt = this.create("text");
	      txt.textContent = text;
	      this.applyAttributes(txt, attributes);
	      this.add(txt);
	    },
	
	    save: function() {
	      // TODO(mmuthanna): State needs to be deep-copied.
	      this.state_stack.push({
	        state: {
	          "font-family": this.state["font-family"],
	          "font-weight": this.state["font-weight"],
	          "font-style": this.state["font-style"],
	          "font-size": this.state["font-size"]
	        },
	        attributes: {
	          "font-family": this.attributes["font-family"],
	          "font-weight": this.attributes["font-weight"],
	          "font-style": this.attributes["font-style"],
	          "font-size": this.attributes["font-size"],
	          fill: this.attributes.fill,
	          stroke: this.attributes.stroke,
	          "stroke-width": this.attributes["stroke-width"]
	        },
	        shadow_attributes: {
	          width: this.shadow_attributes.width,
	          color: this.shadow_attributes.color
	        }
	      });
	      return this;
	    },
	
	    restore: function() {
	      // TODO(0xfe): State needs to be deep-restored.
	      var state = this.state_stack.pop();
	      this.state["font-family"] = state.state["font-family"];
	      this.state["font-weight"] = state.state["font-weight"];
	      this.state["font-style"] = state.state["font-style"];
	      this.state["font-size"] = state.state["font-size"];
	
	      this.attributes["font-family"] = state.attributes["font-family"];
	      this.attributes["font-weight"] = state.attributes["font-weight"];
	      this.attributes["font-style"] = state.attributes["font-style"];
	      this.attributes["font-size"] = state.attributes["font-size"];
	
	      this.attributes.fill = state.attributes.fill;
	      this.attributes.stroke = state.attributes.stroke;
	      this.attributes["stroke-width"] = state.attributes["stroke-width"];
	      this.shadow_attributes.width = state.shadow_attributes.width;
	      this.shadow_attributes.color = state.shadow_attributes.color;
	      return this;
	    }
	  };
	
	  return SVGContext;
	}());
	
	// Vex Flow
	// Mohit Muthanna <mohit@muthanna.com>
	//
	// A rendering context for the Raphael backend.
	//
	// Copyright Mohit Cheppudira 2010
	
	/** @constructor */
	Vex.Flow.CanvasContext = (function() {
	  function CanvasContext(context) {
	    if (arguments.length > 0) this.init(context);
	  }
	
	  CanvasContext.WIDTH = 600;
	  CanvasContext.HEIGHT = 400;
	
	  CanvasContext.prototype = {
	    init: function(context) {
	      // Use a name that is unlikely to clash with a canvas context
	      // property
	      this.vexFlowCanvasContext = context;
	      if (!context.canvas) {
	        this.canvas = {
	          width: CanvasContext.WIDTH,
	          height: CanvasContext.HEIGHT
	        };
	      } else {
	        this.canvas = context.canvas;
	      }
	    },
	
	    clear: function() {
	      this.vexFlowCanvasContext.clearRect(0, 0, this.canvas.width, this.canvas.height);
	    },
	
	    // Containers not implemented
	    openGroup: function(cls, id, attrs) {},
	    closeGroup: function() {},
	    add: function(elem) {},
	
	    setFont: function(family, size, weight) {
	      this.vexFlowCanvasContext.font = (weight || "") + " " + size + "pt " + family;
	      return this;
	    },
	
	    setRawFont: function(font) {
	      this.vexFlowCanvasContext.font = font;
	      return this;
	    },
	
	    setFillStyle: function(style) {
	      this.vexFlowCanvasContext.fillStyle = style;
	      return this;
	    },
	
	    setBackgroundFillStyle: function(style) {
	      this.background_fillStyle = style;
	      return this;
	    },
	
	    setStrokeStyle: function(style) {
	      this.vexFlowCanvasContext.strokeStyle = style;
	      return this;
	    },
	
	    setShadowColor: function(style) {
	      this.vexFlowCanvasContext.shadowColor = style;
	      return this;
	    },
	
	    setShadowBlur: function(blur) {
	      this.vexFlowCanvasContext.shadowBlur = blur;
	      return this;
	    },
	
	    setLineWidth: function(width) {
	      this.vexFlowCanvasContext.lineWidth = width;
	      return this;
	    },
	
	    setLineCap: function(cap_type) {
	      this.vexFlowCanvasContext.lineCap = cap_type;
	      return this;
	    },
	
	    setLineDash: function(dash) {
	      this.vexFlowCanvasContext.lineDash = dash;
	    },
	
	    scale: function(x, y) {
	      return this.vexFlowCanvasContext.scale(parseFloat(x), parseFloat(y));
	    },
	
	    resize: function(width, height) {
	      return this.vexFlowCanvasContext.resize(
	          parseInt(width, 10), parseInt(height, 10));
	    },
	
	    rect: function(x, y, width, height) {
	      return this.vexFlowCanvasContext.rect(x, y, width, height);
	    },
	
	    fillRect: function(x, y, width, height) {
	      return this.vexFlowCanvasContext.fillRect(x, y, width, height);
	    },
	
	    clearRect: function(x, y, width, height) {
	      return this.vexFlowCanvasContext.clearRect(x, y, width, height);
	    },
	
	    beginPath: function() {
	      return this.vexFlowCanvasContext.beginPath();
	    },
	
	    moveTo: function(x, y) {
	      return this.vexFlowCanvasContext.moveTo(x, y);
	    },
	
	    lineTo: function(x, y) {
	      return this.vexFlowCanvasContext.lineTo(x, y);
	    },
	
	    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	      return this.vexFlowCanvasContext.bezierCurveTo(x1, y1, x2, y2, x, y);
	    },
	
	    quadraticCurveTo: function(x1, y1, x, y) {
	      return this.vexFlowCanvasContext.quadraticCurveTo(x1, y1, x, y);
	    },
	
	    // This is an attempt (hack) to simulate the HTML5 canvas
	    // arc method.
	    arc: function(x, y, radius, startAngle, endAngle, antiClockwise) {
	      return this.vexFlowCanvasContext.arc(x, y, radius, startAngle, endAngle, antiClockwise);
	    },
	
	    // Adapted from the source for Raphael's Element.glow
	    glow: function() {
	      return this.vexFlowCanvasContext.glow();
	    },
	
	    fill: function() {
	      return this.vexFlowCanvasContext.fill();
	    },
	
	    stroke: function() {
	      return this.vexFlowCanvasContext.stroke();
	    },
	
	    closePath: function() {
	      return this.vexFlowCanvasContext.closePath();
	    },
	
	    measureText: function(text) {
	      return this.vexFlowCanvasContext.measureText(text);
	    },
	
	    fillText: function(text, x, y) {
	      return this.vexFlowCanvasContext.fillText(text, x, y);
	    },
	
	    save: function() {
	      return this.vexFlowCanvasContext.save();
	    },
	
	    restore: function() {
	      return this.vexFlowCanvasContext.restore();
	    }
	  };
	
	  return CanvasContext;
	}());
	
	// Vex Flow Notation
	// Author Larry Kuhns 2011
	// Implements barlines (single, double, repeat, end)
	//
	// Requires vex.js.
	
	/**
	 * @constructor
	 */
	Vex.Flow.Barline = (function() {
	  function Barline(type, x) {
	    if (arguments.length > 0) this.init(type, x);
	  }
	
	  Barline.type = {
	    SINGLE: 1,
	    DOUBLE: 2,
	    END: 3,
	    REPEAT_BEGIN: 4,
	    REPEAT_END: 5,
	    REPEAT_BOTH: 6,
	    NONE: 7
	  };
	
	  Vex.Inherit(Barline, Vex.Flow.StaveModifier, {
	    init: function(type, x) {
	      Barline.superclass.init.call(this);
	      this.thickness = Vex.Flow.STAVE_LINE_THICKNESS;
	      this.barline = type;
	      this.x = x;    // Left most x for the stave
	    },
	
	    getCategory: function() { return "barlines"; },
	    setX: function(x) { this.x = x; return this; },
	
	    // Draw barlines
	    draw: function(stave, x_shift) {
	      x_shift = typeof x_shift !== 'number' ? 0 : x_shift;
	
	      switch (this.barline) {
	        case Barline.type.SINGLE:
	          this.drawVerticalBar(stave, this.x, false);
	          break;
	        case Barline.type.DOUBLE:
	          this.drawVerticalBar(stave, this.x, true);
	          break;
	        case Barline.type.END:
	          this.drawVerticalEndBar(stave, this.x);
	          break;
	        case Barline.type.REPEAT_BEGIN:
	          // If the barline is shifted over (in front of clef/time/key)
	          // Draw vertical bar at the beginning.
	          if (x_shift > 0) {
	            this.drawVerticalBar(stave, this.x);
	          }
	          this.drawRepeatBar(stave, this.x + x_shift, true);
	          break;
	        case Barline.type.REPEAT_END:
	          this.drawRepeatBar(stave, this.x, false);
	          break;
	        case Barline.type.REPEAT_BOTH:
	          this.drawRepeatBar(stave, this.x, false);
	          this.drawRepeatBar(stave, this.x, true);
	          break;
	        default:
	          // Default is NONE, so nothing to draw
	          break;
	      }
	    },
	
	    drawVerticalBar: function(stave, x, double_bar) {
	      if (!stave.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw stave without canvas context.");
	      var topY = stave.getYForLine(0);
	      var botY = stave.getYForLine(stave.getNumLines() - 1) + this.thickness;
	      if (double_bar)
	        stave.context.fillRect(x - 3, topY, 1, botY - topY);
	      stave.context.fillRect(x, topY, 1, botY - topY);
	    },
	
	    drawVerticalEndBar: function(stave, x) {
	      if (!stave.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw stave without canvas context.");
	
	      var topY = stave.getYForLine(0);
	      var botY = stave.getYForLine(stave.getNumLines() - 1) + this.thickness;
	      stave.context.fillRect(x - 5, topY, 1, botY - topY);
	      stave.context.fillRect(x - 2, topY, 3, botY - topY);
	    },
	
	    drawRepeatBar: function(stave, x, begin) {
	      if (!stave.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw stave without canvas context.");
	
	      var topY = stave.getYForLine(0);
	      var botY = stave.getYForLine(stave.getNumLines() - 1) + this.thickness;
	      var x_shift = 3;
	
	      if (!begin) {
	        x_shift = -5;
	      }
	
	      stave.context.fillRect(x + x_shift, topY, 1, botY - topY);
	      stave.context.fillRect(x - 2, topY, 3, botY - topY);
	
	      var dot_radius = 2;
	
	      // Shift dots left or right
	      if (begin) {
	        x_shift += 4;
	      } else {
	        x_shift -= 4;
	      }
	
	      var dot_x = (x + x_shift) + (dot_radius / 2);
	
	      // calculate the y offset based on number of stave lines
	      var y_offset = (stave.getNumLines() - 1) *
	        stave.getSpacingBetweenLines();
	      y_offset = (y_offset / 2) -
	                 (stave.getSpacingBetweenLines() / 2);
	      var dot_y = topY + y_offset + (dot_radius / 2);
	
	      // draw the top repeat dot
	      stave.context.beginPath();
	      stave.context.arc(dot_x, dot_y, dot_radius, 0, Math.PI * 2, false);
	      stave.context.fill();
	
	      //draw the bottom repeat dot
	      dot_y += stave.getSpacingBetweenLines();
	      stave.context.beginPath();
	      stave.context.arc(dot_x, dot_y, dot_radius, 0, Math.PI * 2, false);
	      stave.context.fill();
	    }
	  });
	
	  return Barline;
	}());
	
	// VexFlow - Music Engraving for HTML5
	// Copyright Mohit Muthanna 2010
	// This class by Raffaele Viglianti, 2012 http://itisnotsound.wordpress.com/
	//
	// This class implements hairpins between notes.
	// Hairpins can be either Crescendo or Descrescendo.
	
	/**
	 * Create a new hairpin from the specified notes.
	 *
	 * @constructor
	 * @param {!Object} notes The notes to tie up.
	 * @param {!Object} type The type of hairpin
	 */
	Vex.Flow.StaveHairpin = (function() {
	  function StaveHairpin(notes, type) {
	    if (arguments.length > 0) this.init(notes, type);
	  }
	
	  StaveHairpin.type = {
	    CRESC: 1,
	    DECRESC: 2
	  };
	
	  /* Helper function to convert ticks into pixels.
	   * Requires a Formatter with voices joined and formatted (to
	   * get pixels per tick)
	   *
	   * options is struct that has:
	   *
	   *  {
	   *   height: px,
	   *   y_shift: px, //vertical offset
	   *   left_shift_ticks: 0, //left horizontal offset expressed in ticks
	   *   right_shift_ticks: 0 // right horizontal offset expressed in ticks
	   *  }
	   *
	   **/
	  StaveHairpin.FormatByTicksAndDraw = function(ctx, formatter, notes, type, position, options) {
	    var ppt = formatter.pixelsPerTick;
	
	    if (ppt == null){
	      throw new Vex.RuntimeError("BadArguments",
	          "A valid Formatter must be provide to draw offsets by ticks.");}
	
	    var l_shift_px = ppt * options.left_shift_ticks;
	    var r_shift_px = ppt * options.right_shift_ticks;
	
	    var hairpin_options = {
	      height: options.height,
	      y_shift:options.y_shift,
	      left_shift_px:l_shift_px,
	      right_shift_px:r_shift_px};
	
	    new StaveHairpin({
	      first_note: notes.first_note,
	      last_note: notes.last_note
	    }, type)
	      .setContext(ctx)
	      .setRenderOptions(hairpin_options)
	      .setPosition(position)
	      .draw();
	  };
	
	  StaveHairpin.prototype = {
	    init: function(notes, type) {
	      /**
	       * Notes is a struct that has:
	       *
	       *  {
	       *    first_note: Note,
	       *    last_note: Note,
	       *  }
	       *
	       **/
	
	      this.notes = notes;
	      this.hairpin = type;
	      this.position = Vex.Flow.Modifier.Position.BELOW;
	
	      this.context = null;
	
	      this.render_options = {
	          height: 10,
	          y_shift: 0, //vertical offset
	          left_shift_px: 0, //left horizontal offset
	          right_shift_px: 0 // right horizontal offset
	        };
	
	      this.setNotes(notes);
	    },
	
	    setContext: function(context) { this.context = context; return this; },
	
	    setPosition: function(position) {
	      if (position == Vex.Flow.Modifier.Position.ABOVE ||
	          position == Vex.Flow.Modifier.Position.BELOW)
	        this.position = position;
	      return this;
	    },
	
	    setRenderOptions: function(options) {
	      if (options.height != null &&
	          options.y_shift != null &&
	          options.left_shift_px != null &&
	          options.right_shift_px != null){
	        this.render_options = options;
	      }
	      return this;
	    },
	
	    /**
	     * Set the notes to attach this hairpin to.
	     *
	     * @param {!Object} notes The start and end notes.
	     */
	    setNotes: function(notes) {
	      if (!notes.first_note && !notes.last_note)
	        throw new Vex.RuntimeError("BadArguments",
	            "Hairpin needs to have either first_note or last_note set.");
	
	      // Success. Lets grab 'em notes.
	      this.first_note = notes.first_note;
	      this.last_note = notes.last_note;
	      return this;
	    },
	
	    renderHairpin: function(params) {
	      var ctx = this.context;
	      var dis = this.render_options.y_shift + 20;
	      var y_shift = params.first_y;
	
	      if (this.position == Vex.Flow.Modifier.Position.ABOVE) {
	        dis = -dis +30;
	        y_shift = params.first_y - params.staff_height;
	      }
	
	      var l_shift = this.render_options.left_shift_px;
	      var r_shift = this.render_options.right_shift_px;
	
	      switch (this.hairpin) {
	        case StaveHairpin.type.CRESC:
	          ctx.moveTo(params.last_x + r_shift, y_shift + dis);
	          ctx.lineTo(params.first_x + l_shift, y_shift +(this.render_options.height/2) + dis);
	          ctx.lineTo(params.last_x + r_shift, y_shift + this.render_options.height + dis);
	          break;
	        case StaveHairpin.type.DECRESC:
	          ctx.moveTo(params.first_x + l_shift, y_shift + dis);
	          ctx.lineTo(params.last_x + r_shift, y_shift +(this.render_options.height/2) + dis);
	          ctx.lineTo(params.first_x + l_shift, y_shift + this.render_options.height + dis);
	          break;
	        default:
	          // Default is NONE, so nothing to draw
	          break;
	      }
	
	      ctx.stroke();
	    },
	
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoContext",
	        "Can't draw Hairpin without a context.");
	
	      var first_note = this.first_note;
	      var last_note = this.last_note;
	
	      var start = first_note.getModifierStartXY(this.position, 0);
	      var end = last_note.getModifierStartXY(this.position, 0);
	
	      this.renderHairpin({
	        first_x: start.x,
	        last_x: end.x,
	        first_y: first_note.getStave().y + first_note.getStave().height,
	        last_y: last_note.getStave().y + last_note.getStave().height,
	        staff_height: first_note.getStave().height
	      });
	     return true;
	    }
	  };
	  return StaveHairpin;
	}());
	
	
	// Vex Flow Notation
	// Author Larry Kuhns 2011
	// Implements voltas (repeat brackets)
	//
	// Requires vex.js.
	
	Vex.Flow.Volta = (function() {
	  function Volta(type, number, x, y_shift) {
	    if (arguments.length > 0) this.init(type, number, x, y_shift);
	  }
	
	  Volta.type = {
	    NONE: 1,
	    BEGIN: 2,
	    MID: 3,
	    END: 4,
	    BEGIN_END: 5
	  };
	
	  Vex.Inherit(Volta, Vex.Flow.StaveModifier, {
	    init: function(type, number, x, y_shift) {
	      Volta.superclass.init.call(this);
	
	      this.volta = type;
	      this.x = x;
	      this.y_shift = y_shift;
	      this.number = number;
	      this.font = {
	        family: "sans-serif",
	        size: 9,
	        weight: "bold"
	      };
	    },
	
	    getCategory: function() { return "voltas"; },
	    setShiftY: function(y) { this.y_shift = y; return this; },
	
	    draw: function(stave, x) {
	      if (!stave.context) throw new Vex.RERR("NoCanvasContext",
	        "Can't draw stave without canvas context.");
	      var ctx = stave.context;
	      var width = stave.width;
	      var top_y = stave.getYForTopText(stave.options.num_lines) + this.y_shift;
	      var vert_height = 1.5 * stave.options.spacing_between_lines_px;
	      switch(this.volta) {
	        case Vex.Flow.Volta.type.BEGIN:
	          ctx.fillRect(this.x + x, top_y, 1, vert_height);
	          break;
	        case Vex.Flow.Volta.type.END:
	          width -= 5;
	          ctx.fillRect(this.x + x + width, top_y, 1, vert_height);
	          break;
	        case Vex.Flow.Volta.type.BEGIN_END:
	          width -= 3;
	          ctx.fillRect(this.x + x, top_y, 1, vert_height);
	          ctx.fillRect(this.x + x + width, top_y, 1, vert_height);
	          break;
	      }
	        // If the beginning of a volta, draw measure number
	      if (this.volta == Volta.type.BEGIN ||
	          this.volta == Volta.type.BEGIN_END) {
	        ctx.save();
	        ctx.setFont(this.font.family, this.font.size, this.font.weight);
	        ctx.fillText(this.number, this.x + x + 5, top_y + 15);
	        ctx.restore();
	      }
	      ctx.fillRect(this.x + x, top_y, width, 1);
	      return this;
	    }
	  });
	
	  return Volta;
	}());
	// Vex Flow Notation
	// Author Larry Kuhns 2011
	// Implements Repetitions (Coda, signo, D.C., etc.)
	//
	// Requires vex.js.
	
	Vex.Flow.Repetition = (function() {
	  function Repetition(type, x, y_shift) {
	    if (arguments.length > 0) this.init(type, x, y_shift);
	  }
	
	  Repetition.type = {
	    NONE: 1,         // no coda or segno
	    CODA_LEFT: 2,    // coda at beginning of stave
	    CODA_RIGHT: 3,   // coda at end of stave
	    SEGNO_LEFT: 4,   // segno at beginning of stave
	    SEGNO_RIGHT: 5,  // segno at end of stave
	    DC: 6,           // D.C. at end of stave
	    DC_AL_CODA: 7,   // D.C. al coda at end of stave
	    DC_AL_FINE: 8,   // D.C. al Fine end of stave
	    DS: 9,           // D.S. at end of stave
	    DS_AL_CODA: 10,  // D.S. al coda at end of stave
	    DS_AL_FINE: 11,  // D.S. al Fine at end of stave
	    FINE: 12         // Fine at end of stave
	  };
	
	  Vex.Inherit(Repetition, Vex.Flow.StaveModifier, {
	    init: function(type, x, y_shift) {
	      Repetition.superclass.init.call(this);
	
	      this.symbol_type = type;
	      this.x = x;
	      this.x_shift = 0;
	      this.y_shift = y_shift;
	      this.font = {
	        family: "times",
	        size: 12,
	        weight: "bold italic"
	      };
	    },
	
	    getCategory: function() { return "repetitions"; },
	    setShiftX: function(x) { this.x_shift = x; return this; },
	    setShiftY: function(y) { this.y_shift = y; return this; },
	
	    draw: function(stave, x) {
	      switch (this.symbol_type) {
	        case Repetition.type.CODA_RIGHT:
	          this.drawCodaFixed(stave, x + stave.width);
	          break;
	        case Repetition.type.CODA_LEFT:
	          this.drawSymbolText(stave, x, "Coda", true);
	          break;
	        case Repetition.type.SEGNO_LEFT:
	          this.drawSignoFixed(stave, x);
	          break;
	        case Repetition.type.SEGNO_RIGHT:
	          this.drawSignoFixed(stave, x + stave.width);
	          break;
	        case Repetition.type.DC:
	          this.drawSymbolText(stave, x, "D.C.", false);
	          break;
	        case Repetition.type.DC_AL_CODA:
	          this.drawSymbolText(stave, x, "D.C. al", true);
	          break;
	        case Repetition.type.DC_AL_FINE:
	          this.drawSymbolText(stave, x, "D.C. al Fine", false);
	          break;
	        case Repetition.type.DS:
	          this.drawSymbolText(stave, x, "D.S.", false);
	          break;
	        case Repetition.type.DS_AL_CODA:
	          this.drawSymbolText(stave, x, "D.S. al", true);
	          break;
	        case Repetition.type.DS_AL_FINE:
	          this.drawSymbolText(stave, x, "D.S. al Fine", false);
	          break;
	        case Repetition.type.FINE:
	          this.drawSymbolText(stave, x, "Fine", false);
	          break;
	        default:
	          break;
	      }
	
	      return this;
	    },
	
	    drawCodaFixed: function(stave, x) {
	      if (!stave.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw stave without canvas context.");
	
	      var y = stave.getYForTopText(stave.options.num_lines) + this.y_shift;
	      Vex.Flow.renderGlyph(stave.context, this.x + x + this.x_shift,
	                           y + 25, 40, "v4d", true);
	      return this;
	    },
	
	    drawSignoFixed: function(stave, x) {
	      if (!stave.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw stave without canvas context.");
	      var y = stave.getYForTopText(stave.options.num_lines) + this.y_shift;
	      Vex.Flow.renderGlyph(stave.context, this.x + x + this.x_shift,
	                           y + 25, 30, "v8c", true);
	      return this;
	    },
	
	    drawSymbolText: function(stave, x, text, draw_coda) {
	      if (!stave.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw stave without canvas context.");
	
	      var ctx = stave.context;
	      ctx.save();
	      ctx.setFont(this.font.family, this.font.size, this.font.weight);
	        // Default to right symbol
	      var text_x = 0 + this.x_shift;
	      var symbol_x = x + this.x_shift;
	      if (this.symbol_type == Vex.Flow.Repetition.type.CODA_LEFT) {
	          // Offset Coda text to right of stave beginning
	        text_x = this.x + stave.options.vertical_bar_width;
	        symbol_x = text_x + ctx.measureText(text).width + 12;
	      } else {
	          // Offset Signo text to left stave end
	        symbol_x = this.x + x + stave.width - 5 + this.x_shift;
	        text_x = symbol_x - + ctx.measureText(text).width - 12;
	      }
	      var y = stave.getYForTopText(stave.options.num_lines) + this.y_shift;
	      if (draw_coda) {
	        Vex.Flow.renderGlyph(ctx, symbol_x, y, 40, "v4d", true);
	      }
	
	      ctx.fillText(text, text_x, y + 5);
	      ctx.restore();
	
	      return this;
	    }
	  });
	
	  return Repetition;
	}());
	// VexFlow - Music Engraving for HTML5
	// Copyright Mohit Muthanna 2010
	// Author Larry Kuhns 2011
	// Implements stave section names.
	
	/**
	 * @constructor
	 */
	Vex.Flow.StaveSection = (function() {
	  function StaveSection(section, x, shift_y) {
	    if (arguments.length > 0) this.init(section, x, shift_y);
	  }
	
	  var Modifier = Vex.Flow.Modifier;
	  Vex.Inherit(StaveSection, Modifier, {
	    init: function(section, x, shift_y) {
	      StaveSection.superclass.init.call(this);
	
	      this.setWidth(16);
	      this.section = section;
	      this.position = Modifier.Position.ABOVE;
	      this.x = x;
	      this.shift_x = 0;
	      this.shift_y = shift_y;
	      this.font = {
	        family: "sans-serif",
	        size: 12,
	        weight: "bold"
	      };
	    },
	
	    getCategory: function() { return "stavesection"; },
	    setStaveSection: function(section) { this.section = section; return this; },
	    setShiftX: function(x) { this.shift_x = x; return this; },
	    setShiftY: function(y) { this.shift_y = y; return this; },
	
	    draw: function(stave, shift_x) {
	      if (!stave.context) throw new Vex.RERR("NoContext",
	        "Can't draw stave section without a context.");
	
	      var ctx = stave.context;
	
	      ctx.save();
	      ctx.lineWidth = 2;
	      ctx.setFont(this.font.family, this.font.size, this.font.weight);
	      var text_width = ctx.measureText("" + this.section).width;
	      var width = text_width + 6;  // add left & right padding
	      if (width < 18) width = 18;
	      var height = 20;
	        //  Seems to be a good default y
	      var y = stave.getYForTopText(3) + this.shift_y;
	      var x = this.x + shift_x;
	      ctx.beginPath();
	      ctx.lineWidth = 2;
	      ctx.rect(x, y, width, height);
	      ctx.stroke();
	      x += (width - text_width) / 2;
	      ctx.fillText("" + this.section, x, y + 16);
	      ctx.restore();
	      return this;
	    }
	  });
	
	  return StaveSection;
	}());
	// VexFlow - Music Engraving for HTML5
	// Copyright Mohit Muthanna 2010
	// Author Radosaw Eichler 2012
	// Implements tempo marker.
	
	/**
	 * @constructor
	 * @param {Object} tempo Tempo parameters: { name, duration, dots, bpm }
	 */
	Vex.Flow.StaveTempo = (function() {
	  function StaveTempo(tempo, x, shift_y) {
	    if (arguments.length > 0) this.init(tempo, x, shift_y);
	  }
	
	  Vex.Inherit(StaveTempo, Vex.Flow.StaveModifier, {
	    init: function(tempo, x, shift_y) {
	      StaveTempo.superclass.init.call(this);
	
	      this.tempo = tempo;
	      this.position = Vex.Flow.Modifier.Position.ABOVE;
	      this.x = x;
	      this.shift_x = 10;
	      this.shift_y = shift_y;
	      this.font = {
	        family: "times",
	        size: 14,
	        weight: "bold"
	      };
	      this.render_options = {
	        glyph_font_scale: 30  // font size for note
	      };
	    },
	
	    getCategory: function() { return "stavetempo"; },
	    setTempo: function(tempo) { this.tempo = tempo; return this; },
	    setShiftX: function(x) { this.shift_x = x; return this; },
	    setShiftY: function(y) { this.shift_y = y; return this; },
	
	    draw: function(stave, shift_x) {
	      if (!stave.context) throw new Vex.RERR("NoContext",
	        "Can't draw stave tempo without a context.");
	
	      var options = this.render_options;
	      var scale = options.glyph_font_scale / 38;
	      var name = this.tempo.name;
	      var duration = this.tempo.duration;
	      var dots = this.tempo.dots;
	      var bpm = this.tempo.bpm;
	      var font = this.font;
	      var ctx = stave.context;
	      var x = this.x + this.shift_x + shift_x;
	      var y = stave.getYForTopText(1) + this.shift_y;
	
	      ctx.save();
	
	      if (name) {
	        ctx.setFont(font.family, font.size, font.weight);
	        ctx.fillText(name, x, y);
	        x += ctx.measureText(name).width;
	      }
	
	      if (duration && bpm) {
	        ctx.setFont(font.family, font.size, 'normal');
	
	        if (name) {
	          x += ctx.measureText(" ").width;
	          ctx.fillText("(", x, y);
	          x += ctx.measureText("(").width;
	        }
	
	        var code = Vex.Flow.durationToGlyph(duration);
	
	        x += 3 * scale;
	        Vex.Flow.renderGlyph(ctx, x, y, options.glyph_font_scale, code.code_head);
	        x += code.head_width * scale;
	
	        // Draw stem and flags
	        if (code.stem) {
	          var stem_height = 30;
	
	          if (code.beam_count) stem_height += 3 * (code.beam_count - 1);
	
	          stem_height *= scale;
	
	          var y_top = y - stem_height;
	          ctx.fillRect(x, y_top, scale, stem_height);
	
	          if (code.flag) {
	            Vex.Flow.renderGlyph(ctx, x + scale, y_top, options.glyph_font_scale,
	                                 code.code_flag_upstem);
	
	            if (!dots) x += 6 * scale;
	          }
	        }
	
	        // Draw dot
	        for (var i = 0; i < dots; i++) {
	          x += 6 * scale;
	          ctx.beginPath();
	          ctx.arc(x, y + 2 * scale, 2 * scale, 0, Math.PI * 2, false);
	          ctx.fill();
	        }
	
	        ctx.fillText(" = " + bpm + (name ? ")" : ""), x + 3 * scale, y);
	      }
	
	      ctx.restore();
	      return this;
	    }
	  });
	
	  return StaveTempo;
	}());
	
	// VexFlow - Music Engraving for HTML5
	// Copyright Mohit Muthanna 2010
	//
	// Author Taehoon Moon 2014
	
	/**
	 * @constructor
	 */
	Vex.Flow.StaveText = (function() {
	  function StaveText(text, position, options) {
	    if (arguments.length > 0) this.init(text, position, options);
	  }
	
	  var Modifier = Vex.Flow.Modifier;
	  Vex.Inherit(StaveText, Modifier, {
	    init: function(text, position, options) {
	      StaveText.superclass.init.call(this);
	
	      this.setWidth(16);
	      this.text = text;
	      this.position = position;
	      this.options = {
	        shift_x: 0,
	        shift_y: 0,
	        justification: Vex.Flow.TextNote.Justification.CENTER
	      };
	      Vex.Merge(this.options, options);
	
	      this.font = {
	        family: "times",
	        size: 16,
	        weight: "normal"
	      };
	    },
	
	    getCategory: function() { return "stavetext"; },
	    setStaveText: function(text) { this.text = text; return this; },
	    setShiftX: function(x) { this.shift_x = x; return this; },
	    setShiftY: function(y) { this.shift_y = y; return this; },
	
	    setFont: function(font) {
	      Vex.Merge(this.font, font);
	    },
	
	    setText: function(text) {
	      this.text = text;
	    },
	
	    draw: function(stave) {
	      if (!stave.context) throw new Vex.RERR("NoContext",
	        "Can't draw stave text without a context.");
	
	      var ctx = stave.context;
	
	      ctx.save();
	      ctx.lineWidth = 2;
	      ctx.setFont(this.font.family, this.font.size, this.font.weight);
	      var text_width = ctx.measureText("" + this.text).width;
	
	      var x, y;
	      var Modifier = Vex.Flow.Modifier;
	      switch(this.position) {
	        case Modifier.Position.LEFT:
	        case Modifier.Position.RIGHT:
	          y = (stave.getYForLine(0) + stave.getBottomLineY()) / 2 + this.options.shift_y;
	          if(this.position == Modifier.Position.LEFT) {
	            x = stave.getX() - text_width - 24 + this.options.shift_x;
	          }
	          else {
	            x = stave.getX() + stave.getWidth() + 24 + this.options.shift_x;
	          }
	          break;
	        case Modifier.Position.ABOVE:
	        case Modifier.Position.BELOW:
	          var Justification = Vex.Flow.TextNote.Justification;
	          x = stave.getX() + this.options.shift_x;
	          if(this.options.justification == Justification.CENTER) {
	            x += stave.getWidth() / 2 - text_width / 2;
	          }
	          else if(this.options.justification == Justification.RIGHT) {
	            x += stave.getWidth() - text_width;
	          }
	          
	          if(this.position == Modifier.Position.ABOVE) {
	            y = stave.getYForTopText(2) + this.options.shift_y;
	          }
	          else {
	            y = stave.getYForBottomText(2) + this.options.shift_y;
	          }
	          break;
	        default:
	          throw new Vex.RERR("InvalidPosition",
	            "Value Must be in Modifier.Position.");
	      }
	
	      ctx.fillText("" + this.text, x, y + 4);
	      ctx.restore();
	      return this;
	    }
	  });
	
	  return StaveText;
	}());
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// A `BarNote` is used to render bar lines (from `barline.js`). `BarNote`s can
	// be added to a voice and rendered in the middle of a stave. Since it has no
	// duration, it consumes no `tick`s, and is dealt with appropriately by the formatter.
	//
	// See `tests/barnote_tests.js` for usage examples.
	
	Vex.Flow.BarNote = (function() {
	  function BarNote() { this.init(); }
	
	  // To enable logging for this class. Set `Vex.Flow.BarNote.DEBUG` to `true`.
	  function L() { if (BarNote.DEBUG) Vex.L("Vex.Flow.BarNote", arguments); }
	
	  // ## Prototype Methods
	  Vex.Inherit(BarNote, Vex.Flow.Note, {
	    init: function() {
	      BarNote.superclass.init.call(this, {duration: "b"});
	
	      var TYPE = Vex.Flow.Barline.type;
	      this.metrics = {
	        widths: {}
	      };
	
	      // Defined this way to prevent lint errors.
	      this.metrics.widths[TYPE.SINGLE] = 8;
	      this.metrics.widths[TYPE.DOUBLE] = 12;
	      this.metrics.widths[TYPE.END] = 15;
	      this.metrics.widths[TYPE.REPEAT_BEGIN] = 14;
	      this.metrics.widths[TYPE.REPEAT_END] = 14;
	      this.metrics.widths[TYPE.REPEAT_BOTH] = 18;
	      this.metrics.widths[TYPE.NONE] = 0;
	
	      // Tell the formatter that bar notes have no duration.
	      this.ignore_ticks = true;
	      this.type = TYPE.SINGLE;
	
	      // Set width to width of relevant `Barline`.
	      this.setWidth(this.metrics.widths[this.type]);
	    },
	
	    // Get and set the type of Bar note. `type` must be one of `Vex.Flow.Barline.type`.
	    getType: function() { return this.type; },
	    setType: function(type) {
	      this.type = type;
	      this.setWidth(this.metrics.widths[this.type]);
	      return this;
	    },
	
	    getBoundingBox: function() {
	      return new Vex.Flow.BoundingBox(0, 0, 0, 0);
	    },
	
	    addToModifierContext: function() {
	      /* overridden to ignore */
	      return this;
	    },
	
	    preFormat: function() {
	      /* overridden to ignore */
	      this.setPreFormatted(true);
	      return this;
	    },
	
	    // Render note to stave.
	    draw: function() {
	      if (!this.stave) throw new Vex.RERR("NoStave", "Can't draw without a stave.");
	      L("Rendering bar line at: ", this.getAbsoluteX());
	      var barline = new Vex.Flow.Barline(this.type, this.getAbsoluteX());
	      barline.draw(this.stave);
	    }
	  });
	
	  return BarNote;
	}());
	
	// VexFlow - Music Engraving for HTML5
	// Author: Mike Corrigan <corrigan@gmail.com>
	//
	// This class implements tremolo notation.
	
	/**
	 * @constructor
	 */
	Vex.Flow.Tremolo = (function() {
	  function Tremolo(num) {
	    if (arguments.length > 0) this.init(num);
	  }
	
	  var Modifier = Vex.Flow.Modifier;
	  Vex.Inherit(Tremolo, Modifier, {
	    init: function(num) {
	      Tremolo.superclass.init.call(this);
	
	      this.num = num;
	      this.note = null;
	      this.index = null;
	      this.position = Modifier.Position.CENTER;
	      this.code = "v74";
	      this.shift_right = -2;
	      this.y_spacing = 4;
	
	      this.render_options = {
	        font_scale: 35,
	        stroke_px: 3,
	        stroke_spacing: 10
	      };
	
	      this.font = {
	        family: "Arial",
	        size: 16,
	        weight: ""
	      };
	    },
	
	    getCategory: function() { return "tremolo"; },
	
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoContext",
	        "Can't draw Tremolo without a context.");
	      if (!(this.note && (this.index != null))) throw new Vex.RERR("NoAttachedNote",
	        "Can't draw Tremolo without a note and index.");
	
	      var start = this.note.getModifierStartXY(this.position, this.index);
	      var x = start.x;
	      var y = start.y;
	
	      x += this.shift_right;
	      for (var i = 0; i < this.num; ++i) {
	        Vex.Flow.renderGlyph(this.context, x, y,
	                             this.render_options.font_scale, this.code);
	        y += this.y_spacing;
	      }
	    }
	  });
	
	  return Tremolo;
	}());
	
	/**
	 * Create a new tuplet from the specified notes. The notes must
	 * be part of the same line, and have the same duration (in ticks).
	 *
	 * @constructor
	 * @param {Array.<Vex.Flow.StaveNote>} A set of notes.
	 */
	Vex.Flow.Tuplet = (function() {
	  function Tuplet(notes, options) {
	    if (arguments.length > 0) this.init(notes, options);
	  }
	
	  Tuplet.LOCATION_TOP = 1;
	  Tuplet.LOCATION_BOTTOM = -1;
	
	  Tuplet.prototype = {
	    init: function(notes, options) {
	      if (!notes || notes == []) {
	        throw new Vex.RuntimeError("BadArguments", "No notes provided for tuplet.");
	      }
	
	      if (notes.length == 1) {
	        throw new Vex.RuntimeError("BadArguments", "Too few notes for tuplet.");
	      }
	
	      this.options = Vex.Merge({}, options);
	      this.notes = notes;
	      this.num_notes = 'num_notes' in this.options ?
	        this.options.num_notes : notes.length;
	      this.beats_occupied = 'beats_occupied' in this.options ?
	        this.options.beats_occupied : 2;
	      this.bracketed = (notes[0].beam == null);
	      this.ratioed = false;
	      this.point = 28;
	      this.y_pos = 16;
	      this.x_pos = 100;
	      this.width = 200;
	      this.location = Tuplet.LOCATION_TOP;
	
	      Vex.Flow.Formatter.AlignRestsToNotes(notes, true, true);
	      this.resolveGlyphs();
	      this.attach();
	    },
	
	    attach: function () {
	      for (var i = 0; i < this.notes.length; i++) {
	        var note = this.notes[i];
	        note.setTuplet(this);
	      }
	    },
	
	    detach: function () {
	      for (var i = 0; i < this.notes.length; i++) {
	        var note = this.notes[i];
	        note.setTuplet(null);
	      }
	    },
	
	    setContext: function(context) {
	      this.context = context;
	      return this;
	    },
	
	    /**
	     * Set whether or not the bracket is drawn.
	     */
	    setBracketed: function(bracketed) {
	      this.bracketed = bracketed ? true : false;
	      return this;
	    },
	
	    /**
	     * Set whether or not the ratio is shown.
	     */
	    setRatioed: function(ratioed) {
	      this.ratioed = ratioed ? true : false;
	      return this;
	    },
	
	    /**
	     * Set the tuplet to be displayed either on the top or bottom of the stave
	     */
	    setTupletLocation: function(location) {
	      if (!location) location = Tuplet.LOCATION_TOP;
	      else if (location != Tuplet.LOCATION_TOP &&
	          location != Tuplet.LOCATION_BOTTOM) {
	        throw new Vex.RERR("BadArgument", "Invalid tuplet location: " + location);
	      }
	
	      this.location = location;
	      return this;
	    },
	
	    getNotes: function() {
	      return this.notes;
	    },
	
	    getNoteCount: function() {
	      return this.num_notes;
	    },
	
	    getBeatsOccupied: function() {
	      return this.beats_occupied;
	    },
	
	    setBeatsOccupied: function(beats) {
	      this.detach();
	      this.beats_occupied = beats;
	      this.resolveGlyphs();
	      this.attach();
	    },
	
	    resolveGlyphs: function() {
	      this.num_glyphs = [];
	      var n = this.num_notes;
	      while (n >= 1) {
	        this.num_glyphs.push(new Vex.Flow.Glyph("v" + (n % 10), this.point));
	        n = parseInt(n / 10, 10);
	      }
	
	      this.denom_glyphs = [];
	      n = this.beats_occupied;
	      while (n >= 1) {
	        this.denom_glyphs.push(new Vex.Flow.Glyph("v" + (n % 10), this.point));
	        n = parseInt(n / 10, 10);
	      }
	    },
	
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw without a canvas context.");
	
	      // determine x value of left bound of tuplet
	      var first_note = this.notes[0];
	      var last_note = this.notes[this.notes.length - 1];
	
	      if (!this.bracketed) {
	        this.x_pos = first_note.getStemX();
	        this.width = last_note.getStemX() - this.x_pos;
	      }
	      else {
	        this.x_pos = first_note.getTieLeftX() - 5;
	        this.width = last_note.getTieRightX() - this.x_pos + 5;
	      }
	
	      // determine y value for tuplet
	      var i;
	      if (this.location == Tuplet.LOCATION_TOP) {
	        this.y_pos = first_note.getStave().getYForLine(0) - 15;
	        //this.y_pos = first_note.getStemExtents().topY - 10;
	
	        for (i=0; i<this.notes.length; ++i) {
	          var top_y = this.notes[i].getStemDirection() === Vex.Flow.Stem.UP ?
	              this.notes[i].getStemExtents().topY - 10
	            : this.notes[i].getStemExtents().baseY - 20;
	          if (top_y < this.y_pos)
	            this.y_pos = top_y;
	        }
	      }
	      else {
	        this.y_pos = first_note.getStave().getYForLine(4) + 20;
	
	        for (i=0; i<this.notes.length; ++i) {
	          var bottom_y = this.notes[i].getStemDirection() === Vex.Flow.Stem.UP ?
	              this.notes[i].getStemExtents().baseY + 20
	            : this.notes[i].getStemExtents().topY + 10;
	          if (bottom_y > this.y_pos)
	            this.y_pos = bottom_y;
	        }
	      }
	
	      // calculate total width of tuplet notation
	      var width = 0;
	      var glyph;
	      for (glyph in this.num_glyphs) {
	        width += this.num_glyphs[glyph].getMetrics().width;
	      }
	      if (this.ratioed) {
	        for (glyph in this.denom_glyphs) {
	          width += this.denom_glyphs[glyph].getMetrics().width;
	        }
	        width += this.point * 0.32;
	      }
	
	      var notation_center_x = this.x_pos + (this.width/2);
	      var notation_start_x = notation_center_x - (width/2);
	
	      // draw bracket if the tuplet is not beamed
	      if (this.bracketed) {
	        var line_width = this.width/2 - width/2 - 5;
	
	        // only draw the bracket if it has positive length
	        if (line_width > 0) {
	          this.context.fillRect(this.x_pos, this.y_pos,line_width, 1);
	          this.context.fillRect(this.x_pos + this.width / 2 + width / 2 + 5,
	                                this.y_pos,line_width, 1);
	          this.context.fillRect(this.x_pos,
	              this.y_pos + (this.location == Tuplet.LOCATION_BOTTOM),
	              1, this.location * 10);
	          this.context.fillRect(this.x_pos + this.width,
	              this.y_pos + (this.location == Tuplet.LOCATION_BOTTOM),
	              1, this.location * 10);
	        }
	      }
	
	      // draw numerator glyphs
	      var x_offset = 0;
	      var size = this.num_glyphs.length;
	      for (glyph in this.num_glyphs) {
	        this.num_glyphs[size-glyph-1].render(
	            this.context, notation_start_x + x_offset,
	            this.y_pos + (this.point/3) - 2);
	        x_offset += this.num_glyphs[size-glyph-1].getMetrics().width;
	      }
	
	      // display colon and denominator if the ratio is to be shown
	      if (this.ratioed) {
	        var colon_x = notation_start_x + x_offset + this.point*0.16;
	        var colon_radius = this.point * 0.06;
	        this.context.beginPath();
	        this.context.arc(colon_x, this.y_pos - this.point*0.08,
	                         colon_radius, 0, Math.PI*2, true);
	        this.context.closePath();
	        this.context.fill();
	        this.context.beginPath();
	        this.context.arc(colon_x, this.y_pos + this.point*0.12,
	                         colon_radius, 0, Math.PI*2, true);
	        this.context.closePath();
	        this.context.fill();
	        x_offset += this.point*0.32;
	        size = this.denom_glyphs.length;
	        for (glyph in this.denom_glyphs) {
	          this.denom_glyphs[size-glyph-1].render(
	              this.context, notation_start_x + x_offset,
	              this.y_pos + (this.point/3) - 2);
	          x_offset += this.denom_glyphs[size-glyph-1].getMetrics().width;
	        }
	      }
	    }
	  };
	
	  return Tuplet;
	}());
	
	// Vex Music Notation
	// Mohit Muthanna <mohit@muthanna.com>
	//
	// Copyright Mohit Muthanna 2010
	
	// Bounding boxes for interactive notation
	
	/** @constructor */
	Vex.Flow.BoundingBox = (function() {
	  function BoundingBox(x, y, w, h) { this.init(x, y, w, h); }
	  BoundingBox.copy = function(that) {
	    return new BoundingBox(that.x, that.y, that.w, that.h); };
	
	  BoundingBox.prototype = {
	    init: function(x, y, w, h) {
	      this.x = x;
	      this.y = y;
	      this.w = w;
	      this.h = h;
	    },
	
	    getX: function() { return this.x; },
	    getY: function() { return this.y; },
	    getW: function() { return this.w; },
	    getH: function() { return this.h; },
	
	    setX: function(x) { this.x = x; return this; },
	    setY: function(y) { this.y = y; return this; },
	    setW: function(w) { this.w = w; return this; },
	    setH: function(h) { this.h = h; return this; },
	
	    move: function(x, y) { this.x += x; this.y += y; },
	    clone: function() { return BoundingBox.copy(this); },
	
	    // Merge my box with given box. Creates a bigger bounding box unless
	    // the given box is contained in this one.
	    mergeWith: function(boundingBox, ctx) {
	      var that = boundingBox;
	
	      var new_x = this.x < that.x ? this.x : that.x;
	      var new_y = this.y < that.y ? this.y : that.y;
	      var new_w = (this.x + this.w) < (that.x + that.w) ? (that.x + that.w) - this.x : (this.x + this.w) - Vex.Min(this.x, that.x);
	      var new_h = (this.y + this.h) < (that.y + that.h) ? (that.y + that.h) - this.y : (this.y + this.h) - Vex.Min(this.y, that.y);
	
	      this.x = new_x;
	      this.y = new_y;
	      this.w = new_w;
	      this.h = new_h;
	
	      if (ctx) this.draw(ctx);
	      return this;
	    },
	
	    draw: function(ctx, x, y) {
	      if (!x) x = 0;
	      if (!y) y = 0;
	      ctx.rect(this.x + x, this.y + y, this.w, this.h);
	      ctx.stroke();
	    }
	  };
	
	  return BoundingBox;
	}());
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// `TextNote` is a notation element that is positioned in time. Generally 
	// meant for objects that sit above/below the staff and inline with each other.
	// Examples of this would be such as dynamics, lyrics, chord changes, etc.
	Vex.Flow.TextNote = (function() {
	  function TextNote(text_struct) {
	    if (arguments.length > 0) this.init(text_struct);
	  }
	
	  TextNote.Justification = {
	    LEFT: 1,
	    CENTER: 2,
	    RIGHT: 3
	  };
	
	  // Glyph data
	  TextNote.GLYPHS = {
	    "segno": {
	      code: "v8c",
	      point: 40,
	      x_shift: 0,
	      y_shift: -10
	      // width: 10 // optional
	    },
	    "tr": {
	      code: "v1f",
	      point: 40,
	      x_shift: 0,
	      y_shift: 0
	      // width: 10 // optional
	    },
	    "mordent_upper": {
	      code: "v1e",
	      point: 40,
	      x_shift: 0,
	      y_shift: 0
	      // width: 10 // optional
	    },
	    "mordent_lower": {
	      code: "v45",
	      point: 40,
	      x_shift: 0,
	      y_shift: 0
	      // width: 10 // optional
	    },
	    "f": {
	      code: "vba",
	      point: 40,
	      x_shift: 0,
	      y_shift: 0
	      // width: 10 // optional
	    },
	    "p": {
	      code: "vbf",
	      point: 40,
	      x_shift: 0,
	      y_shift: 0
	      // width: 10 // optional
	    },
	    "m": {
	      code: "v62",
	      point: 40,
	      x_shift: 0,
	      y_shift: 0
	      // width: 10 // optional
	    },
	    "s": {
	      code: "v4a",
	      point: 40,
	      x_shift: 0,
	      y_shift: 0
	      // width: 10 // optional
	    },
	    "z": {
	      code: "v80",
	      point: 40,
	      x_shift: 0,
	      y_shift: 0
	      // width: 10 // optional
	    },
	    "coda": {
	      code: "v4d",
	      point: 40,
	      x_shift: 0,
	      y_shift: -8
	      // width: 10 // optional
	    },
	    "pedal_open": {
	      code: "v36",
	      point:40,
	      x_shift:0,
	      y_shift:0
	    },
	    "pedal_close": {
	      code: "v5d",
	      point:40,
	      x_shift:0,
	      y_shift:3
	    },
	    "caesura_straight": {
	      code: "v34",
	      point:40,
	      x_shift:0,
	      y_shift:2
	    },
	    "caesura_curved": {
	      code: "v4b",
	      point:40,
	      x_shift:0,
	      y_shift:2
	    },
	    "breath": {
	      code: "v6c",
	      point:40,
	      x_shift:0,
	      y_shift:0
	    },
	    "tick": {
	      code: "v6f",
	      point:50,
	      x_shift:0,
	      y_shift:0
	    },
	    "turn": {
	      code: "v72",
	      point:40,
	      x_shift:0,
	      y_shift:0
	    },
	    "turn_inverted": {
	      code: "v33",
	      point:40,
	      x_shift:0,
	      y_shift:0
	    },
	
	    // DEPRECATED - please use "mordent_upper" or "mordent_lower"
	    "mordent": {
	      code: "v1e",
	      point: 40,
	      x_shift: 0,
	      y_shift: 0
	      // width: 10 // optional
	    },
	  };
	
	  // ## Prototype Methods
	  Vex.Inherit(TextNote, Vex.Flow.Note, {
	    init: function(text_struct) {
	      TextNote.superclass.init.call(this, text_struct);
	
	      // Note properties
	      this.text = text_struct.text;
	      this.superscript = text_struct.superscript;
	      this.subscript = text_struct.subscript;
	      this.glyph_type = text_struct.glyph;
	      this.glyph = null;
	      this.font = {
	        family: "Arial",
	        size: 12,
	        weight: ""
	      };
	
	      // Set font
	      if (text_struct.font) this.font = text_struct.font;
	
	      // Determine and set initial note width. Note that the text width is 
	      // an approximation and isn't very accurate. The only way to accurately
	      // measure the length of text is with `canvasContext.measureText()`
	      if (this.glyph_type) {
	        var struct = TextNote.GLYPHS[this.glyph_type];
	        if (!struct) throw new Vex.RERR("Invalid glyph type: " + this.glyph_type);
	
	        this.glyph = new Vex.Flow.Glyph(struct.code, struct.point, {cache: false});
	
	        if (struct.width)
	          this.setWidth(struct.width);
	        else
	          this.setWidth(this.glyph.getMetrics().width);
	
	        this.glyph_struct = struct;
	      } else {
	        this.setWidth(Vex.Flow.textWidth(this.text));
	      }
	      this.line = text_struct.line || 0;
	      this.smooth = text_struct.smooth || false;
	      this.ignore_ticks = text_struct.ignore_ticks || false;
	      this.justification = TextNote.Justification.LEFT;
	    },
	
	    // Set the horizontal justification of the TextNote
	    setJustification: function(just) {
	      this.justification = just;
	      return this;
	    },
	
	    // Set the Stave line on which the note should be placed
	    setLine: function(line) {
	      this.line = line;
	      return this;
	    },
	
	    // Pre-render formatting
	    preFormat: function() {
	      if (!this.context) throw new Vex.RERR("NoRenderContext",
	          "Can't measure text without rendering context.");
	      if (this.preFormatted) return;
	
	      if (this.smooth) {
	        this.setWidth(0);
	      } else {
	        if (this.glyph) {
	          // Width already set.
	        } else {
	          this.setWidth(this.context.measureText(this.text).width);
	        }
	      }
	
	      if (this.justification == TextNote.Justification.CENTER) {
	        this.extraLeftPx = this.width / 2;
	      } else if (this.justification == TextNote.Justification.RIGHT) {
	        this.extraLeftPx = this.width;
	      }
	
	      this.setPreFormatted(true);
	    },
	
	    // Renders the TextNote
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoCanvasContext",
	          "Can't draw without a canvas context.");
	      if (!this.stave) throw new Vex.RERR("NoStave", "Can't draw without a stave.");
	
	      var ctx = this.context;
	      var x = this.getAbsoluteX();
	      if (this.justification == TextNote.Justification.CENTER) {
	        x -= this.getWidth() / 2;
	      } else if (this.justification == TextNote.Justification.RIGHT) {
	        x -= this.getWidth();
	      }
	
	      var y;
	      if (this.glyph) {
	        y = this.stave.getYForLine(this.line + (-3));
	        this.glyph.render(this.context,
	                          x + this.glyph_struct.x_shift,
	                          y + this.glyph_struct.y_shift);
	      } else {
	        y = this.stave.getYForLine(this.line + (-3));
	        ctx.save();
	        ctx.setFont(this.font.family, this.font.size, this.font.weight);
	        ctx.fillText(this.text, x, y);
	
	        // Width of the letter M gives us the approximate height of the text
	        var height = ctx.measureText("M").width;
	        // Get accurate width of text
	        var width = ctx.measureText(this.text).width;
	
	        // Write superscript
	        if (this.superscript) {
	          ctx.setFont(this.font.family, this.font.size / 1.3, this.font.weight);
	          ctx.fillText(this.superscript, x + width + 2, y - (height/2.2));
	        }
	
	        // Write subscript
	        if (this.subscript) {
	          ctx.setFont(this.font.family, this.font.size / 1.3, this.font.weight);
	          ctx.fillText(this.subscript, x + width + 2, y + (height/2.2) - 1);
	        }
	
	        ctx.restore();
	      }
	    }
	  });
	
	  return TextNote;
	}());
	
	// VexFlow - Music Engraving for HTML5
	// Copyright Mohit Muthanna 2010
	// Author Larry Kuhns 2013
	// Class to draws string numbers into the notation.
	
	/**
	 * @constructor
	 */
	Vex.Flow.FretHandFinger = (function() {
	  function FretHandFinger(number) {
	    if (arguments.length > 0) this.init(number);
	  }
	  FretHandFinger.CATEGORY = "frethandfinger";
	
	  var Modifier = Vex.Flow.Modifier;
	
	  // Arrange fingerings inside a ModifierContext.
	  FretHandFinger.format = function(nums, state) {
	    var left_shift = state.left_shift;
	    var right_shift = state.right_shift;
	    var num_spacing = 1;
	
	    if (!nums || nums.length === 0) return false;
	
	    var nums_list = [];
	    var prev_note = null;
	    var shift_left = 0;
	    var shift_right = 0;
	
	    var i, num, note, pos, props_tmp;
	    for (i = 0; i < nums.length; ++i) {
	      num = nums[i];
	      note = num.getNote();
	      pos = num.getPosition();
	      var props = note.getKeyProps()[num.getIndex()];
	      if (note != prev_note) {
	        for (var n = 0; n < note.keys.length; ++n) {
	          props_tmp = note.getKeyProps()[n];
	          if (left_shift === 0)
	            shift_left = (props_tmp.displaced ? note.getExtraLeftPx() : shift_left);
	          if (right_shift === 0)
	            shift_right = (props_tmp.displaced ? note.getExtraRightPx() : shift_right);
	        }
	        prev_note = note;
	      }
	
	      nums_list.push({ line: props.line, pos: pos, shiftL: shift_left, shiftR: shift_right, note: note, num: num });
	    }
	
	    // Sort fingernumbers by line number.
	    nums_list.sort(function(a, b) { return (b.line - a.line); });
	
	    var num_shiftL = 0;
	    var num_shiftR = 0;
	    var x_widthL = 0;
	    var x_widthR = 0;
	    var last_line = null;
	    var last_note = null;
	
	    for (i = 0; i < nums_list.length; ++i) {
	      var num_shift = 0;
	      note = nums_list[i].note;
	      pos = nums_list[i].pos;
	      num = nums_list[i].num;
	      var line = nums_list[i].line;
	      var shiftL = nums_list[i].shiftL;
	      var shiftR = nums_list[i].shiftR;
	
	      // Reset the position of the string number every line.
	      if (line != last_line || note != last_note) {
	        num_shiftL = left_shift + shiftL;
	        num_shiftR = right_shift + shiftR;
	      }
	
	      var num_width = num.getWidth() + num_spacing;
	      if (pos == Vex.Flow.Modifier.Position.LEFT) {
	        num.setXShift(left_shift + num_shiftL);
	        num_shift = left_shift + num_width; // spacing
	        x_widthL = (num_shift > x_widthL) ? num_shift : x_widthL;
	      } else if (pos == Vex.Flow.Modifier.Position.RIGHT) {
	        num.setXShift(num_shiftR);
	        num_shift = shift_right + num_width; // spacing
	        x_widthR = (num_shift > x_widthR) ? num_shift : x_widthR;
	      }
	      last_line = line;
	      last_note = note;
	    }
	
	    state.left_shift += x_widthL;
	    state.right_shift += x_widthR;
	  };
	
	  Vex.Inherit(FretHandFinger, Modifier, {
	    init: function(number) {
	      var superclass = Vex.Flow.FretHandFinger.superclass;
	      superclass.init.call(this);
	
	      this.note = null;
	      this.index = null;
	      this.finger = number;
	      this.width = 7;
	      this.position = Modifier.Position.LEFT;  // Default position above stem or note head
	      this.x_shift = 0;
	      this.y_shift = 0;
	      this.x_offset = 0;       // Horizontal offset from default
	      this.y_offset = 0;       // Vertical offset from default
	      this.font = {
	        family: "sans-serif",
	        size: 9,
	        weight: "bold"
	      };
	    },
	
	    getNote: function() { return this.note; },
	    setNote: function(note) { this.note = note; return this; },
	    getIndex: function() { return this.index; },
	    setIndex: function(index) { this.index = index; return this; },
	    getPosition: function() { return this.position; },
	    setPosition: function(position) {
	      if (position >= Modifier.Position.LEFT &&
	          position <= Modifier.Position.BELOW)
	        this.position = position;
	      return this;
	    },
	    setFretHandFinger: function(number) { this.finger = number; return this; },
	    setOffsetX: function(x) { this.x_offset = x; return this; },
	    setOffsetY: function(y) { this.y_offset = y; return this; },
	
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoContext",
	        "Can't draw string number without a context.");
	      if (!(this.note && (this.index != null))) throw new Vex.RERR("NoAttachedNote",
	        "Can't draw string number without a note and index.");
	
	      var ctx = this.context;
	      var start = this.note.getModifierStartXY(this.position, this.index);
	      var dot_x = (start.x + this.x_shift + this.x_offset);
	      var dot_y = start.y + this.y_shift + this.y_offset + 5;
	
	      switch (this.position) {
	        case Modifier.Position.ABOVE:
	          dot_x -= 4;
	          dot_y -= 12;
	          break;
	        case Modifier.Position.BELOW:
	          dot_x -= 2;
	          dot_y += 10;
	          break;
	        case Modifier.Position.LEFT:
	          dot_x -= this.width;
	          break;
	        case Modifier.Position.RIGHT:
	          dot_x += 1;
	          break;
	      }
	
	      ctx.save();
	      ctx.setFont(this.font.family, this.font.size, this.font.weight);
	      ctx.fillText("" + this.finger, dot_x, dot_y);
	
	      ctx.restore();
	    }
	  });
	
	  return FretHandFinger;
	}());
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author: Larry Kuhns
	//
	// ## Description
	//
	// This file implements the `StringNumber` class which renders string
	// number annotations beside notes.
	
	Vex.Flow.StringNumber = (function() {
	  function StringNumber(number) {
	    if (arguments.length > 0) this.init(number);
	  }
	  StringNumber.CATEGORY = "stringnumber";
	
	  var Modifier = Vex.Flow.Modifier;
	
	  // ## Static Methods
	  // Arrange string numbers inside a `ModifierContext`
	  StringNumber.format = function(nums, state) {
	    var left_shift = state.left_shift;
	    var right_shift = state.right_shift;
	    var num_spacing = 1;
	
	    if (!nums || nums.length === 0) return this;
	
	    var nums_list = [];
	    var prev_note = null;
	    var shift_left = 0;
	    var shift_right = 0;
	
	    var i, num, note, pos, props_tmp;
	    for (i = 0; i < nums.length; ++i) {
	      num = nums[i];
	      note = num.getNote();
	
	      for (i = 0; i < nums.length; ++i) {
	        num = nums[i];
	        note = num.getNote();
	        pos = num.getPosition();
	        var props = note.getKeyProps()[num.getIndex()];
	
	        if (note != prev_note) {
	          for (var n = 0; n < note.keys.length; ++n) {
	            props_tmp = note.getKeyProps()[n];
	            if (left_shift === 0)
	              shift_left = (props_tmp.displaced ? note.getExtraLeftPx() : shift_left);
	            if (right_shift === 0)
	              shift_right = (props_tmp.displaced ? note.getExtraRightPx() : shift_right);
	          }
	          prev_note = note;
	        }
	
	        nums_list.push({ line: props.line, pos: pos, shiftL: shift_left, shiftR: shift_right, note: note, num: num });
	      }
	    }
	
	    // Sort string numbers by line number.
	    nums_list.sort(function(a, b) { return (b.line - a.line); });
	
	    var num_shiftL = 0;
	    var num_shiftR = 0;
	    var x_widthL = 0;
	    var x_widthR = 0;
	    var last_line = null;
	    var last_note = null;
	    for (i = 0; i < nums_list.length; ++i) {
	      var num_shift = 0;
	      note = nums_list[i].note;
	      pos = nums_list[i].pos;
	      num = nums_list[i].num;
	      var line = nums_list[i].line;
	      var shiftL = nums_list[i].shiftL;
	      var shiftR = nums_list[i].shiftR;
	
	      // Reset the position of the string number every line.
	      if (line != last_line || note != last_note) {
	        num_shiftL = left_shift + shiftL;
	        num_shiftR = right_shift + shiftR;
	      }
	
	      var num_width = num.getWidth() + num_spacing;
	      if (pos == Vex.Flow.Modifier.Position.LEFT) {
	        num.setXShift(left_shift);
	        num_shift = shift_left + num_width; // spacing
	        x_widthL = (num_shift > x_widthL) ? num_shift : x_widthL;
	      } else if (pos == Vex.Flow.Modifier.Position.RIGHT) {
	        num.setXShift(num_shiftR);
	        num_shift += num_width; // spacing
	        x_widthR = (num_shift > x_widthR) ? num_shift : x_widthR;
	      }
	      last_line = line;
	      last_note = note;
	    }
	
	    state.left_shift += x_widthL;
	    state.right_shift += x_widthR;
	    return true;
	  };
	
	  // ## Prototype Methods
	  Vex.Inherit(StringNumber, Modifier, {
	    init: function(number) {
	      StringNumber.superclass.init.call(this);
	
	      this.note = null;
	      this.last_note = null;
	      this.index = null;
	      this.string_number = number;
	      this.setWidth(20);                                 // ???
	      this.position = Modifier.Position.ABOVE;  // Default position above stem or note head
	      this.x_shift = 0;
	      this.y_shift = 0;
	      this.x_offset = 0;                               // Horizontal offset from default
	      this.y_offset = 0;                               // Vertical offset from default
	      this.dashed = true;                              // true - draw dashed extension  false - no extension
	      this.leg = Vex.Flow.Renderer.LineEndType.NONE;   // draw upward/downward leg at the of extension line
	      this.radius = 8;
	      this.font = {
	        family: "sans-serif",
	        size: 10,
	        weight: "bold"
	      };
	    },
	
	    getNote: function() { return this.note; },
	    setNote: function(note) { this.note = note; return this; },
	    getIndex: function() { return this.index; },
	    setIndex: function(index) { this.index = index; return this; },
	
	    setLineEndType: function(leg) {
	      if (leg >= Vex.Flow.Renderer.LineEndType.NONE &&
	          leg <= Vex.Flow.Renderer.LineEndType.DOWN)
	        this.leg = leg;
	      return this;
	    },
	
	    getPosition: function() { return this.position; },
	    setPosition: function(position) {
	      if (position >= Modifier.Position.LEFT &&
	          position <= Modifier.Position.BELOW)
	        this.position = position;
	      return this;
	    },
	
	    setStringNumber: function(number) { this.string_number = number; return this; },
	    setOffsetX: function(x) { this.x_offset = x; return this; },
	    setOffsetY: function(y) { this.y_offset = y; return this; },
	    setLastNote: function(note) { this.last_note = note; return this; },
	    setDashed: function(dashed) { this.dashed = dashed; return this; },
	
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoContext",
	        "Can't draw string number without a context.");
	      if (!(this.note && (this.index != null))) throw new Vex.RERR("NoAttachedNote",
	        "Can't draw string number without a note and index.");
	
	      var ctx = this.context;
	      var line_space = this.note.stave.options.spacing_between_lines_px;
	
	      var start = this.note.getModifierStartXY(this.position, this.index);
	      var dot_x = (start.x + this.x_shift + this.x_offset);
	      var dot_y = start.y + this.y_shift + this.y_offset;
	
	      switch (this.position) {
	        case Modifier.Position.ABOVE:
	        case Modifier.Position.BELOW:
	          var stem_ext = this.note.getStemExtents();
	          var top = stem_ext.topY;
	          var bottom = stem_ext.baseY + 2;
	
	          if (this.note.stem_direction == Vex.Flow.StaveNote.STEM_DOWN) {
	            top = stem_ext.baseY;
	            bottom = stem_ext.topY - 2;
	          }
	
	          if (this.position == Modifier.Position.ABOVE) {
	            dot_y = this.note.hasStem() ? top - (line_space * 1.75)
	                                        : start.y - (line_space * 1.75);
	        } else {
	            dot_y = this.note.hasStem() ? bottom + (line_space * 1.5)
	                                        : start.y + (line_space * 1.75);
	          }
	
	          dot_y += this.y_shift + this.y_offset;
	
	          break;
	        case Modifier.Position.LEFT:
	          dot_x -= (this.radius / 2) + 5;
	          break;
	        case Modifier.Position.RIGHT:
	          dot_x += (this.radius / 2) + 6;
	          break;
	      }
	
	      ctx.save();
	      ctx.beginPath();
	      ctx.arc(dot_x, dot_y, this.radius, 0, Math.PI * 2, false);
	      ctx.lineWidth = 1.5;
	      ctx.stroke();
	      ctx.setFont(this.font.family, this.font.size, this.font.weight);
	      var x = dot_x - ctx.measureText(this.string_number).width / 2;
	      ctx.fillText("" + this.string_number, x, dot_y + 4.5);
	
	      if (this.last_note != null) {
	        var end = this.last_note.getStemX() - this.note.getX() + 5;
	        ctx.strokeStyle="#000000";
	        ctx.lineCap = "round";
	        ctx.lineWidth = 0.6;
	        if (this.dashed)
	          Vex.Flow.Renderer.drawDashedLine(ctx, dot_x + 10, dot_y, dot_x + end, dot_y, [3,3]);
	        else
	          Vex.Flow.Renderer.drawDashedLine(ctx, dot_x + 10, dot_y, dot_x + end, dot_y, [3,0]);
	
	        var len, pattern;
	        switch (this.leg) {
	          case Vex.Flow.Renderer.LineEndType.UP:
	            len = -10;
	            pattern = this.dashed ? [3,3] : [3,0];
	            Vex.Flow.Renderer.drawDashedLine(ctx, dot_x + end, dot_y, dot_x + end, dot_y + len, pattern);
	            break;
	          case Vex.Flow.Renderer.LineEndType.DOWN:
	            len = 10;
	            pattern = this.dashed ? [3,3] : [3,0];
	            Vex.Flow.Renderer.drawDashedLine(ctx, dot_x + end, dot_y, dot_x + end, dot_y + len, pattern);
	            break;
	        }
	      }
	
	      ctx.restore();
	    }
	  });
	
	  return StringNumber;
	}());
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author: Larry Kuhns
	//
	// ## Description
	//
	// This file implements the `Stroke` class which renders chord strokes
	// that can be arpeggiated, brushed, rasquedo, etc.
	
	Vex.Flow.Stroke = (function() {
	  function Stroke(type, options) {
	    if (arguments.length > 0) this.init(type, options);
	  }
	  Stroke.CATEGORY = "strokes";
	
	  Stroke.Type = {
	    BRUSH_DOWN: 1,
	    BRUSH_UP: 2,
	    ROLL_DOWN: 3,        // Arpegiated chord
	    ROLL_UP: 4,          // Arpegiated chord
	    RASQUEDO_DOWN: 5,
	    RASQUEDO_UP: 6
	  };
	
	  var Modifier = Vex.Flow.Modifier;
	
	  // ## Static Methods
	
	  // Arrange strokes inside `ModifierContext`
	  Stroke.format = function(strokes, state) {
	    var left_shift = state.left_shift;
	    var stroke_spacing = 0;
	
	    if (!strokes || strokes.length === 0) return this;
	
	    var str_list = [];
	    var i, str, shift;
	    for (i = 0; i < strokes.length; ++i) {
	      str = strokes[i];
	      var note = str.getNote();
	      var props;
	      if (note instanceof Vex.Flow.StaveNote) {
	        props = note.getKeyProps()[str.getIndex()];
	        shift = (props.displaced ? note.getExtraLeftPx() : 0);
	        str_list.push({ line: props.line, shift: shift, str: str });
	      } else {
	        props = note.getPositions()[str.getIndex()];
	        str_list.push({ line: props.str, shift: 0, str: str });
	      }
	    }
	
	    var str_shift = left_shift;
	    var x_shift = 0;
	
	    // There can only be one stroke .. if more than one, they overlay each other
	    for (i = 0; i < str_list.length; ++i) {
	      str = str_list[i].str;
	      shift = str_list[i].shift;
	
	      str.setXShift(str_shift + shift);
	      x_shift = Math.max(str.getWidth() + stroke_spacing, x_shift);
	    }
	
	    state.left_shift += x_shift;
	    return true;
	  };
	
	  // ## Prototype Methods
	  Vex.Inherit(Stroke, Modifier, {
	    init: function(type, options) {
	      Stroke.superclass.init.call(this);
	
	      this.note = null;
	      this.options = Vex.Merge({}, options);
	
	      // multi voice - span stroke across all voices if true
	      this.all_voices = 'all_voices' in this.options ?
	        this.options.all_voices : true;
	
	      // multi voice - end note of stroke, set in draw()
	      this.note_end = null;
	      this.index = null;
	      this.type = type;
	      this.position = Modifier.Position.LEFT;
	
	      this.render_options = {
	        font_scale: 38,
	        stroke_px: 3,
	        stroke_spacing: 10
	      };
	
	      this.font = {
	       family: "serif",
	       size: 10,
	       weight: "bold italic"
	     };
	
	      this.setXShift(0);
	      this.setWidth(10);
	    },
	
	    getPosition: function() { return this.position; },
	    addEndNote: function(note) { this.note_end = note; return this; },
	
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoContext",
	        "Can't draw stroke without a context.");
	      if (!(this.note && (this.index != null))) throw new Vex.RERR("NoAttachedNote",
	        "Can't draw stroke without a note and index.");
	      var start = this.note.getModifierStartXY(this.position, this.index);
	      var ys = this.note.getYs();
	      var topY = start.y;
	      var botY = start.y;
	      var x = start.x - 5;
	      var line_space = this.note.stave.options.spacing_between_lines_px;
	
	      var notes = this.getModifierContext().getModifiers(this.note.getCategory());
	      var i;
	      for (i = 0; i < notes.length; i++) {
	        ys = notes[i].getYs();
	        for (var n = 0; n < ys.length; n++) {
	          if (this.note == notes[i] || this.all_voices) {
	            topY = Vex.Min(topY, ys[n]);
	            botY = Vex.Max(botY, ys[n]);
	          }
	        }
	      }
	
	      var arrow, arrow_shift_x, arrow_y, text_shift_x, text_y;
	      switch (this.type) {
	        case Stroke.Type.BRUSH_DOWN:
	          arrow = "vc3";
	          arrow_shift_x = -3;
	          arrow_y = topY - (line_space / 2) + 10;
	          botY += (line_space / 2);
	          break;
	        case Stroke.Type.BRUSH_UP:
	          arrow = "v11";
	          arrow_shift_x = 0.5;
	          arrow_y = botY + (line_space / 2);
	          topY -= (line_space / 2);
	          break;
	        case Stroke.Type.ROLL_DOWN:
	        case Stroke.Type.RASQUEDO_DOWN:
	          arrow = "vc3";
	          arrow_shift_x = -3;
	          text_shift_x = this.x_shift + arrow_shift_x - 2;
	          if (this.note instanceof Vex.Flow.StaveNote) {
	            topY += 1.5 * line_space;
	            if ((botY - topY) % 2 !== 0) {
	              botY += 0.5 * line_space;
	            } else {
	              botY += line_space;
	            }
	            arrow_y = topY - line_space;
	            text_y = botY + line_space + 2;
	          } else {
	            topY += 1.5 * line_space;
	            botY += line_space;
	            arrow_y = topY - 0.75 * line_space;
	            text_y = botY + 0.25 * line_space;
	          }
	          break;
	        case Stroke.Type.ROLL_UP:
	        case Stroke.Type.RASQUEDO_UP:
	          arrow = "v52";
	          arrow_shift_x = -4;
	          text_shift_x = this.x_shift + arrow_shift_x - 1;
	          if (this.note instanceof Vex.Flow.StaveNote) {
	            arrow_y = line_space / 2;
	            topY += 0.5 * line_space;
	            if ((botY - topY) % 2 === 0) {
	              botY += line_space / 2;
	            }
	            arrow_y = botY + 0.5 * line_space;
	            text_y = topY - 1.25 * line_space;
	          } else {
	            topY += 0.25 * line_space;
	            botY += 0.5 * line_space;
	            arrow_y = botY + 0.25 * line_space;
	            text_y = topY - line_space;
	          }
	          break;
	      }
	
	      // Draw the stroke
	      if (this.type == Stroke.Type.BRUSH_DOWN ||
	          this.type == Stroke.Type.BRUSH_UP) {
	        this.context.fillRect(x + this.x_shift, topY, 1, botY - topY);
	      } else {
	        if (this.note instanceof Vex.Flow.StaveNote) {
	          for (i = topY; i <= botY; i += line_space) {
	            Vex.Flow.renderGlyph(this.context, x + this.x_shift - 4,
	                                 i,
	                                 this.render_options.font_scale, "va3");
	          }
	        } else {
	          for (i = topY; i <= botY; i+= 10) {
	            Vex.Flow.renderGlyph(this.context, x + this.x_shift - 4,
	                                 i,
	                                 this.render_options.font_scale, "va3");
	          }
	          if (this.type == Vex.Flow.Stroke.Type.RASQUEDO_DOWN)
	            text_y = i + 0.25 * line_space;
	        }
	      }
	
	      // Draw the arrow head
	      Vex.Flow.renderGlyph(this.context, x + this.x_shift + arrow_shift_x, arrow_y,
	                           this.render_options.font_scale, arrow);
	
	      // Draw the rasquedo "R"
	      if (this.type == Stroke.Type.RASQUEDO_DOWN ||
	          this.type == Stroke.Type.RASQUEDO_UP) {
	        this.context.save();
	        this.context.setFont(this.font.family, this.font.size, this.font.weight);
	        this.context.fillText("R", x + text_shift_x, text_y);
	        this.context.restore();
	      }
	    }
	  });
	
	  return Stroke;
	}());
	// VexFlow - Music Engraving for HTML5
	// Copyright Mohit Muthanna 2010
	//
	// This class implements curves (for slurs)
	
	Vex.Flow.Curve = (function() {
	  // from: Start note
	  // to: End note
	  // options:
	  //    cps: List of control points
	  //    x_shift: pixels to shift
	  //    y_shift: pixels to shift
	  function Curve(from, to, options) {
	    if (arguments.length > 0) this.init(from, to, options);
	  }
	
	  Curve.Position = {
	    NEAR_HEAD: 1,
	    NEAR_TOP: 2
	  };
	
	  Curve.DEBUG = true;
	
	  Curve.prototype = {
	    init: function(from, to, options) {
	      this.render_options = {
	        spacing: 2,
	        thickness: 2,
	        x_shift: 0,
	        y_shift: 10,
	        position: Curve.Position.NEAR_HEAD,
	        invert: false,
	        cps: [{x: 0, y: 10}, {x: 0, y: 10}]
	      };
	
	      Vex.Merge(this.render_options, options);
	      this.setNotes(from, to);
	    },
	
	    setContext: function(context) { this.context = context; return this; },
	    setNotes: function(from, to) {
	      if (!from && !to)
	        throw new Vex.RuntimeError("BadArguments",
	            "Curve needs to have either first_note or last_note set.");
	
	      this.from = from;
	      this.to = to;
	      return this;
	    },
	
	    /**
	     * @return {boolean} Returns true if this is a partial bar.
	     */
	    isPartial: function() {
	      return (!this.from || !this.to);
	    },
	
	    renderCurve: function(params) {
	      var ctx = this.context;
	      var cps = this.render_options.cps;
	
	      var x_shift = this.render_options.x_shift;
	      var y_shift = this.render_options.y_shift * params.direction;
	
	      var first_x = params.first_x + x_shift;
	      var first_y = params.first_y + y_shift;
	      var last_x = params.last_x - x_shift;
	      var last_y = params.last_y + y_shift;
	      var thickness = this.render_options.thickness;
	
	      var cp_spacing = (last_x - first_x) / (cps.length + 2);
	
	      ctx.beginPath();
	      ctx.moveTo(first_x, first_y);
	      ctx.bezierCurveTo(first_x + cp_spacing + cps[0].x,
	                        first_y + (cps[0].y * params.direction),
	                        last_x - cp_spacing + cps[1].x,
	                        last_y + (cps[1].y * params.direction),
	                        last_x, last_y);
	      ctx.bezierCurveTo(last_x - cp_spacing + cps[1].x,
	                        last_y + ((cps[1].y + thickness) * params.direction),
	                        first_x + cp_spacing + cps[0].x,
	                        first_y + ((cps[0].y + thickness) * params.direction),
	                        first_x, first_y);
	      ctx.stroke();
	      ctx.closePath();
	      ctx.fill();
	    },
	
	    draw: function() {
	      if (!this.context)
	        throw new Vex.RERR("NoContext", "No context to render tie.");
	      var first_note = this.from;
	      var last_note = this.to;
	      var first_x, last_x, first_y, last_y, stem_direction;
	
	      var metric = "baseY";
	      var end_metric = "baseY";
	      var position = this.render_options.position;
	      var position_end = this.render_options.position_end;
	
	      if (position === Curve.Position.NEAR_TOP) {
	        metric = "topY";
	        end_metric = "topY";
	      }
	
	      if (position_end == Curve.Position.NEAR_HEAD) {
	        end_metric = "baseY";
	      } else if (position_end == Curve.Position.NEAR_TOP) {
	        end_metric = "topY";
	      }
	
	      if (first_note) {
	        first_x = first_note.getTieRightX();
	        stem_direction = first_note.getStemDirection();
	        first_y = first_note.getStemExtents()[metric];
	      } else {
	        first_x = last_note.getStave().getTieStartX();
	        first_y = last_note.getStemExtents()[metric];
	      }
	
	      if (last_note) {
	        last_x = last_note.getTieLeftX();
	        stem_direction = last_note.getStemDirection();
	        last_y = last_note.getStemExtents()[end_metric];
	      } else {
	        last_x = first_note.getStave().getTieEndX();
	        last_y = first_note.getStemExtents()[end_metric];
	      }
	
	      this.renderCurve({
	        first_x: first_x,
	        last_x: last_x,
	        first_y: first_y,
	        last_y: last_y,
	        direction: stem_direction *
	          (this.render_options.invert === true ? -1 : 1)
	      });
	      return true;
	    }
	  };
	
	  return Curve;
	}());
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements `StaveLine` which are simply lines that connect
	// two notes. This object is highly configurable, see the `render_options`.
	// A simple line is often used for notating glissando articulations, but you
	// can format a `StaveLine` with arrows or colors for more pedagogical
	// purposes, such as diagrams.
	Vex.Flow.StaveLine = (function() {
	  function StaveLine(notes) {
	    if (arguments.length > 0) this.init(notes);
	  }
	
	  // Text Positioning
	  StaveLine.TextVerticalPosition = {
	    TOP: 1,
	    BOTTOM: 2
	  };
	
	  StaveLine.TextJustification = {
	    LEFT: 1,
	    CENTER: 2,
	    RIGHT: 3
	  };
	
	  // ## Prototype Methods
	  StaveLine.prototype = {
	    // Initialize the StaveLine with the given `notes`.
	    //
	    // `notes` is a struct that has:
	    //
	    //  ```
	    //  {
	    //    first_note: Note,
	    //    last_note: Note,
	    //    first_indices: [n1, n2, n3],
	    //    last_indices: [n1, n2, n3]
	    //  }
	    //  ```
	    init: function(notes) {
	      this.notes = notes;
	      this.context = null;
	
	      this.text = "";
	
	      this.font = {
	        family: "Arial",
	        size: 10,
	        weight: ""
	      };
	
	      this.render_options = {
	        // Space to add to the left or the right
	        padding_left: 4,
	        padding_right: 3,
	
	        // The width of the line in pixels
	        line_width: 1,
	        // An array of line/space lengths. Unsupported with Raphael (SVG)
	        line_dash: null,
	        // Can draw rounded line end, instead of a square. Unsupported with Raphael (SVG)
	        rounded_end: true,
	        // The color of the line and arrowheads
	        color: null,
	
	        // Flags to draw arrows on each end of the line
	        draw_start_arrow: false,
	        draw_end_arrow: false,
	
	        // The length of the arrowhead sides
	        arrowhead_length: 10,
	        // The angle of the arrowhead
	        arrowhead_angle: Math.PI / 8,
	
	        // The position of the text
	        text_position_vertical: StaveLine.TextVerticalPosition.TOP,
	        text_justification: StaveLine.TextJustification.CENTER
	      };
	
	      this.setNotes(notes);
	    },
	
	    // Set the rendering context
	    setContext: function(context) { this.context = context; return this; },
	    // Set the font for the `StaveLine` text
	    setFont: function(font) { this.font = font; return this; },
	    // The the annotation for the `StaveLine`
	    setText: function(text) { this.text = text; return this; },
	
	    // Set the notes for the `StaveLine`
	    setNotes: function(notes) {
	      if (!notes.first_note && !notes.last_note)
	        throw new Vex.RuntimeError("BadArguments",
	            "Notes needs to have either first_note or last_note set.");
	
	      if (!notes.first_indices) notes.first_indices = [0];
	      if (!notes.last_indices) notes.last_indices = [0];
	
	      if (notes.first_indices.length != notes.last_indices.length)
	        throw new Vex.RuntimeError("BadArguments", "Connected notes must have similar" +
	          " index sizes");
	
	      // Success. Lets grab 'em notes.
	      this.first_note = notes.first_note;
	      this.first_indices = notes.first_indices;
	      this.last_note = notes.last_note;
	      this.last_indices = notes.last_indices;
	      return this;
	    },
	
	    // Apply the style of the `StaveLine` to the context
	    applyLineStyle: function() {
	      if (!this.context) {
	        throw new Vex.RERR("NoContext","No context to apply the styling to");
	      }
	
	      var render_options = this.render_options;
	      var ctx = this.context;
	
	      if (render_options.line_dash) {
	        ctx.setLineDash(render_options.line_dash);
	      }
	
	      if (render_options.line_width) {
	        ctx.setLineWidth(render_options.line_width);
	      }
	
	      if (render_options.rounded_end) {
	        ctx.setLineCap("round");
	      } else {
	        ctx.setLineCap("square");
	      }
	    },
	
	    // Apply the text styling to the context
	    applyFontStyle: function() {
	      if (!this.context) {
	        throw new Vex.RERR("NoContext","No context to apply the styling to");
	      }
	
	      var ctx = this.context;
	
	      if (this.font) {
	        ctx.setFont(this.font.family, this.font.size, this.font.weight);
	      }
	
	      if (this.render_options.color) {
	        ctx.setStrokeStyle(this.render_options.color);
	        ctx.setFillStyle(this.render_options.color);
	      }
	    },
	
	    // Renders the `StaveLine` on the context
	    draw: function() {
	      if (!this.context) {
	        throw new Vex.RERR("NoContext", "No context to render StaveLine.");
	      }
	
	      var ctx = this.context;
	      var first_note = this.first_note;
	      var last_note = this.last_note;
	      var render_options = this.render_options;
	
	      ctx.save();
	      this.applyLineStyle();
	
	      // Cycle through each set of indices and draw lines
	      var start_position;
	      var end_position;
	      this.first_indices.forEach(function(first_index, i) {
	        var last_index = this.last_indices[i];
	
	        // Get initial coordinates for the start/end of the line
	        start_position = first_note.getModifierStartXY(2, first_index);
	        end_position = last_note.getModifierStartXY(1, last_index);
	        var upwards_slope = start_position.y > end_position.y;
	
	        // Adjust `x` coordinates for modifiers
	        start_position.x += first_note.getMetrics().modRightPx +
	                            render_options.padding_left;
	        end_position.x -= last_note.getMetrics().modLeftPx +
	                          render_options.padding_right;
	
	
	        // Adjust first `x` coordinates for displacements
	        var notehead_width = first_note.getGlyph().head_width;
	        var first_displaced = first_note.getKeyProps()[first_index].displaced;
	        if (first_displaced && first_note.getStemDirection() === 1) {
	          start_position.x += notehead_width + render_options.padding_left;
	        }
	
	        // Adjust last `x` coordinates for displacements
	        var last_displaced = last_note.getKeyProps()[last_index].displaced;
	        if (last_displaced && last_note.getStemDirection() === -1) {
	          end_position.x -= notehead_width + render_options.padding_right;
	        }
	
	        // Adjust y position better if it's not coming from the center of the note
	        start_position.y += upwards_slope ? -3 : 1;
	        end_position.y += upwards_slope ? 2 : 0;
	
	        drawArrowLine(ctx, start_position, end_position, this.render_options);
	
	      }, this);
	
	      ctx.restore();
	
	      // Determine the x coordinate where to start the text
	      var text_width = ctx.measureText(this.text).width;
	      var justification = render_options.text_justification;
	      var x = 0;
	      if (justification === StaveLine.TextJustification.LEFT) {
	        x = start_position.x;
	      } else if (justification === StaveLine.TextJustification.CENTER) {
	        var delta_x = (end_position.x - start_position.x);
	        var center_x = (delta_x / 2 ) + start_position.x;
	        x = center_x - (text_width / 2);
	      } else if (justification === StaveLine.TextJustification.RIGHT) {
	        x = end_position.x  -  text_width;
	      }
	
	      // Determine the y value to start the text
	      var y;
	      var vertical_position = render_options.text_position_vertical;
	      if (vertical_position === StaveLine.TextVerticalPosition.TOP) {
	        y = first_note.getStave().getYForTopText();
	      } else if (vertical_position === StaveLine.TextVerticalPosition.BOTTOM) {
	        y = first_note.getStave().getYForBottomText();
	      }
	
	      // Draw the text
	      ctx.save();
	      this.applyFontStyle();
	      ctx.fillText(this.text, x, y);
	      ctx.restore();
	
	      return this;
	    }
	  };
	
	  // ## Private Helpers
	  // 
	  // Attribution: Arrow rendering implementations based off of
	  // Patrick Horgan's article, "Drawing lines and arcs with 
	  // arrow heads on  HTML5 Canvas"
	  // 
	  // Draw an arrow head that connects between 3 coordinates
	  function drawArrowHead(ctx, x0, y0, x1, y1, x2, y2) {
	    // all cases do this.
	    ctx.beginPath();
	    ctx.moveTo(x0,y0);
	    ctx.lineTo(x1,y1);
	    ctx.lineTo(x2,y2);
	    ctx.lineTo(x0, y0);
	    ctx.closePath();
	
	    ctx.fill();
	  }
	
	  // Helper function to draw a line with arrow heads
	  function drawArrowLine(ctx, point1, point2, config) {
	    var both_arrows = config.draw_start_arrow && config.draw_end_arrow;
	
	    var x1 = point1.x;
	    var y1 = point1.y;
	    var x2 = point2.x;
	    var y2 = point2.y;
	
	    // For ends with arrow we actually want to stop before we get to the arrow
	    // so that wide lines won't put a flat end on the arrow.
	    var distance = Math.sqrt((x2-x1)*(x2-x1)+(y2-y1)*(y2-y1));
	    var ratio = (distance - config.arrowhead_length/3) / distance;
	    var end_x, end_y, start_x, start_y;
	    if (config.draw_end_arrow || both_arrows) {
	      end_x = Math.round(x1 + (x2 - x1) * ratio);
	      end_y = Math.round(y1 + (y2 - y1) * ratio);
	    } else {
	      end_x = x2;
	      end_y = y2;
	    }
	
	    if (config.draw_start_arrow || both_arrows) {
	      start_x = x1 + (x2 - x1) * (1 - ratio);
	      start_y = y1 + (y2 - y1) * (1 - ratio);
	    } else {
	      start_x = x1;
	      start_y = y1;
	    }
	
	    if (config.color) {
	      ctx.setStrokeStyle(config.color);
	      ctx.setFillStyle(config.color);
	    }
	
	    // Draw the shaft of the arrow
	    ctx.beginPath();
	    ctx.moveTo(start_x, start_y);
	    ctx.lineTo(end_x,end_y);
	    ctx.stroke();
	    ctx.closePath();
	
	    // calculate the angle of the line
	    var line_angle = Math.atan2(y2 - y1, x2 - x1);
	    // h is the line length of a side of the arrow head
	    var h = Math.abs(config.arrowhead_length / Math.cos(config.arrowhead_angle));
	
	    var angle1, angle2;
	    var top_x, top_y;
	    var bottom_x, bottom_y;
	
	    if (config.draw_end_arrow || both_arrows) {
	      angle1 = line_angle + Math.PI + config.arrowhead_angle;
	      top_x = x2 + Math.cos(angle1) * h;
	      top_y = y2 + Math.sin(angle1) * h;
	
	      angle2 = line_angle + Math.PI - config.arrowhead_angle;
	      bottom_x = x2 + Math.cos(angle2) * h;
	      bottom_y = y2 + Math.sin(angle2) * h;
	
	      drawArrowHead(ctx, top_x, top_y, x2, y2, bottom_x, bottom_y);
	    }
	
	    if (config.draw_start_arrow || both_arrows) {
	      angle1 = line_angle + config.arrowhead_angle;
	      top_x = x1 + Math.cos(angle1) * h;
	      top_y = y1 + Math.sin(angle1) * h;
	
	      angle2 = line_angle - config.arrowhead_angle;
	      bottom_x = x1 + Math.cos(angle2) * h;
	      bottom_y = y1 + Math.sin(angle2) * h;
	
	      drawArrowHead(ctx, top_x, top_y, x1, y1, bottom_x, bottom_y);
	    }
	  }
	
	  return StaveLine;
	}());
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements the `Crescendo` object which draws crescendos and
	// decrescendo dynamics markings. A `Crescendo` is initialized with a
	// duration and formatted as part of a `Voice` like any other `Note`
	// type in VexFlow. This object would most likely be formatted in a Voice
	// with `TextNotes` - which are used to represent other dynamics markings.
	Vex.Flow.Crescendo = (function() {
	  function Crescendo(note_struct) {
	    if (arguments.length > 0) this.init(note_struct);
	  }
	
	  // To enable logging for this class. Set `Vex.Flow.Crescendo.DEBUG` to `true`.
	  function L() { if (Crescendo.DEBUG) Vex.L("Vex.Flow.Crescendo", arguments); }
	
	  // Private helper to draw the hairpin
	  function renderHairpin(ctx, params) {
	    var begin_x = params.begin_x;
	    var end_x = params.end_x;
	    var y = params.y;
	    var half_height =  params.height / 2;
	
	    ctx.beginPath();
	
	    if (params.reverse) {
	        ctx.moveTo(begin_x, y - half_height);
	        ctx.lineTo(end_x,  y);
	        ctx.lineTo(begin_x, y + half_height);
	    } else {
	        ctx.moveTo(end_x,  y - half_height);
	        ctx.lineTo(begin_x, y);
	        ctx.lineTo(end_x,  y + half_height);
	    }
	
	    ctx.stroke();
	    ctx.closePath();
	  }
	
	  // ## Prototype Methods
	  Vex.Inherit(Crescendo, Vex.Flow.Note, {
	    // Initialize the crescendo's properties
	    init: function(note_struct) {
	      Crescendo.superclass.init.call(this, note_struct);
	
	      // Whether the object is a decrescendo
	      this.decrescendo = false;
	
	      // The staff line to be placed on
	      this.line = note_struct.line || 0;
	
	      // The height at the open end of the cresc/decresc
	      this.height = 15;
	
	      Vex.Merge(this.render_options, {
	        // Extensions to the length of the crescendo on either side
	        extend_left: 0,
	        extend_right: 0,
	        // Vertical shift
	        y_shift: 0
	      });
	    },
	
	    // Set the line to center the element on
	    setLine: function(line) { this.line = line; return this; },
	
	    // Set the full height at the open end
	    setHeight: function(height) { this.height = height; return this; },
	
	    // Set whether the sign should be a descresendo by passing a bool
	    // to `decresc`
	    setDecrescendo: function(decresc) {
	      this.decrescendo = decresc;
	      return this;
	    },
	
	    // Preformat the note
	    preFormat: function() { this.preFormatted = true; return this; },
	
	    // Render the Crescendo object onto the canvas
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoContext",
	        "Can't draw Hairpin without a context.");
	
	      var tick_context = this.getTickContext();
	      var next_context = Vex.Flow.TickContext.getNextContext(tick_context);
	
	      var begin_x = this.getAbsoluteX();
	      var end_x;
	      if (next_context) {
	        end_x = next_context.getX();
	      } else {
	        end_x = this.stave.x + this.stave.width;
	      }
	
	      var y = this.stave.getYForLine(this.line + (-3)) + 1;
	
	      L("Drawing ",  this.decrescendo ? "decrescendo " : "crescendo ",
	        this.height, "x", begin_x - end_x);
	
	      renderHairpin(this.context, {
	        begin_x: begin_x - this.render_options.extend_left,
	        end_x: end_x + this.render_options.extend_right,
	        y: y + this.render_options.y_shift,
	        height: this.height,
	        reverse: this.decrescendo
	      });
	    }
	  });
	
	  return Crescendo;
	})();
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author: Cyril Silverman
	//
	// ## Description
	//
	// This file implements ornaments as modifiers that can be
	// attached to notes. The complete list of ornaments is available in
	// `tables.js` under `Vex.Flow.ornamentCodes`.
	//
	// See `tests/ornament_tests.js` for usage examples.
	
	Vex.Flow.Ornament = (function() {
	  function Ornament(type) {
	    if (arguments.length > 0) this.init(type);
	  }
	  Ornament.CATEGORY = "ornaments";
	
	  // Accidental position modifications for each glyph
	  var acc_mods = {
	    "n": {
	      shift_x: 1,
	      shift_y_upper:0,
	      shift_y_lower:0,
	      height: 17
	    },
	    "#": {
	      shift_x: 0,
	      shift_y_upper: -2,
	      shift_y_lower: -2,
	      height: 20
	    },
	    "b": {
	      shift_x: 1,
	      shift_y_upper: 0,
	      shift_y_lower: 3,
	      height: 18
	    },
	    "##": {
	      shift_x: 0,
	      shift_y_upper: 0,
	      shift_y_lower: 0,
	      height: 12,
	    },
	    "bb": {
	      shift_x: 0,
	      shift_y_upper: 0,
	      shift_y_lower: 4,
	      height: 17
	    },
	    "db": {
	      shift_x: -3,
	      shift_y_upper: 0,
	      shift_y_lower: 4,
	      height: 17
	    },
	    "bbs": {
	      shift_x: 0,
	      shift_y_upper: 0,
	      shift_y_lower: 4,
	      height: 17
	    },
	    "d": {
	      shift_x: 0,
	      shift_y_upper: 0,
	      shift_y_lower: 0,
	      height: 17
	    },
	    "++": {
	      shift_x: -2,
	      shift_y_upper: -6,
	      shift_y_lower: -3,
	      height: 22
	    },
	    "+": {
	      shift_x: 1,
	      shift_y_upper: -4,
	      shift_y_lower: -2,
	      height: 20
	    }
	  };
	
	  // To enable logging for this class. Set `Vex.Flow.Ornament.DEBUG` to `true`.
	  function L() { if (Ornament.DEBUG) Vex.L("Vex.Flow.Ornament", arguments); }
	
	  var Modifier = Vex.Flow.Modifier;
	
	  // ## Static Methods
	  // Arrange ornaments inside `ModifierContext`
	  Ornament.format = function(ornaments, state) {
	   if (!ornaments || ornaments.length === 0) return false;
	
	    var width = 0;
	    for (var i = 0; i < ornaments.length; ++i) {
	      var ornament = ornaments[i];
	      var increment = 1;
	      width = Math.max(ornament.getWidth(), width);
	
	      var type = Vex.Flow.ornamentCodes(ornament.type);
	
	      if (!type.between_lines) increment += 1.5;
	
	      if (ornament.getPosition() === Modifier.Position.ABOVE) {
	        ornament.setTextLine(state.top_text_line);
	        state.top_text_line += increment;
	      } else {
	        ornament.setTextLine(state.text_line);
	        state.text_line += increment;
	      }
	    }
	
	    state.left_shift += width / 2;
	    state.right_shift += width / 2;
	    return true;
	  };
	
	  // ## Prototype Methods
	  Vex.Inherit(Ornament, Modifier, {
	    // Create a new ornament of type `type`, which is an entry in
	    // `Vex.Flow.ornamentCodes` in `tables.js`.
	    init: function(type) {
	      Ornament.superclass.init.call(this);
	
	      this.note = null;
	      this.index = null;
	      this.type = type;
	      this.position = Modifier.Position.ABOVE;
	      this.delayed = false;
	
	      this.accidental_upper = "";
	      this.accidental_lower = "";
	
	      this.render_options = {
	        font_scale: 38
	      };
	
	      this.ornament = Vex.Flow.ornamentCodes(this.type);
	      if (!this.ornament) throw new Vex.RERR("ArgumentError",
	         "Ornament not found: '" + this.type + "'");
	
	      // Default width comes from ornament table.
	      this.setWidth(this.ornament.width);
	    },
	
	    // Set whether the ornament is to be delayed
	    setDelayed: function(delayed) { this.delayed = delayed; return this; },
	
	    // Set the upper accidental for the ornament
	    setUpperAccidental: function(acc) {
	      this.accidental_upper = acc;
	      return this;
	    },
	
	    // Set the lower accidental for the ornament
	    setLowerAccidental: function(acc) {
	      this.accidental_lower = acc;
	      return this;
	    },
	
	    // Render ornament in position next to note.
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoContext",
	        "Can't draw Ornament without a context.");
	      if (!(this.note && (this.index !== null))) throw new Vex.RERR("NoAttachedNote",
	        "Can't draw Ornament without a note and index.");
	
	      var ctx = this.context;
	      var stem_direction = this.note.getStemDirection();
	      var stave = this.note.getStave();
	
	      // Get stem extents
	      var stem_ext = this.note.getStem().getExtents();
	      var top, bottom;
	      if (stem_direction === Vex.Flow.StaveNote.STEM_DOWN) {
	        top = stem_ext.baseY;
	        bottom = stem_ext.topY;
	      } else {
	        top = stem_ext.topY;
	        bottom = stem_ext.baseY;
	      }
	
	      // TabNotes don't have stems attached to them. Tab stems are rendered
	      // outside the stave.
	      var is_tabnote = this.note.getCategory() === 'tabnotes';
	      if (is_tabnote) {
	        if (this.note.hasStem()){
	          if (stem_direction === Vex.Flow.StaveNote.STEM_UP) {
	            bottom = stave.getYForBottomText(this.text_line - 2);
	          } else if (stem_direction === Vex.Flow.StaveNote.STEM_DOWN ) {
	            top = stave.getYForTopText(this.text_line - 1.5);
	          }
	        } else { // Without a stem
	          top = stave.getYForTopText(this.text_line - 1);
	          bottom = stave.getYForBottomText(this.text_line - 2);
	        }
	      }
	
	      var is_on_head = stem_direction === Vex.Flow.StaveNote.STEM_DOWN;
	      var spacing = stave.getSpacingBetweenLines();
	      var line_spacing = 1;
	
	      // Beamed stems are longer than quarter note stems, adjust accordingly
	      if (!is_on_head && this.note.beam) {
	        line_spacing += 0.5;
	      }
	
	      var total_spacing = spacing * (this.text_line + line_spacing);
	      var glyph_y_between_lines = (top - 7) - total_spacing;
	
	      // Get initial coordinates for the modifier position
	      var start = this.note.getModifierStartXY(this.position, this.index);
	      var glyph_x = start.x + this.ornament.shift_right;
	      var glyph_y = Math.min(stave.getYForTopText(this.text_line) - 3, glyph_y_between_lines);
	      glyph_y += this.ornament.shift_up + this.y_shift;
	
	      // Ajdust x position if ornament is delayed
	      if (this.delayed) {
	        glyph_x += this.ornament.width;
	        var next_context = Vex.Flow.TickContext.getNextContext(this.note.getTickContext());
	        if (next_context) {
	          glyph_x += (next_context.getX() - glyph_x) * 0.5;
	        } else {
	          glyph_x += (stave.x + stave.width - glyph_x) * 0.5;
	        }
	      }
	
	      var ornament = this;
	      function drawAccidental(ctx, code, upper) {
	        var accidental = Vex.Flow.accidentalCodes(code);
	
	        var acc_x = glyph_x - 3;
	        var acc_y = glyph_y + 2;
	
	        // Special adjustments for trill glyph
	        if (upper) {
	          acc_y -= mods ? mods.height : 18;
	          acc_y +=  ornament.type === "tr" ? -8 : 0;
	        } else {
	          acc_y +=  ornament.type === "tr" ? -6 : 0;
	        }
	
	        // Fine tune position of accidental glyph
	        var mods = acc_mods[code];
	        if (mods) {
	          acc_x += mods.shift_x;
	          acc_y += upper ? mods.shift_y_upper : mods.shift_y_lower;
	        }
	
	        // Render the glyph
	        var scale = ornament.render_options.font_scale/1.3;
	        Vex.Flow.renderGlyph(ctx, acc_x, acc_y, scale, accidental.code);
	
	        // If rendered a bottom accidental, increase the y value by the
	        // accidental height so that the ornament's glyph is shifted up
	        if (!upper) {
	          glyph_y -= mods ? mods.height : 18;
	        }
	      }
	
	      // Draw lower accidental for ornament
	      if (this.accidental_lower) {
	        drawAccidental(ctx, this.accidental_lower, false, glyph_x, glyph_y);
	      }
	
	      L("Rendering ornament: ", this.ornament, glyph_x, glyph_y);
	      Vex.Flow.renderGlyph(ctx, glyph_x, glyph_y,
	                           this.render_options.font_scale, this.ornament.code);
	
	      // Draw upper accidental for ornament
	      if (this.accidental_upper) {
	        drawAccidental(ctx, this.accidental_upper, true, glyph_x, glyph_y);
	      }
	
	    }
	  });
	
	  return Ornament;
	}());
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements different types of pedal markings. These notation
	// elements indicate to the performer when to depress and release the a pedal.
	//
	// In order to create "Sostenuto", and "una corda" markings, you must set
	// custom text for the release/depress pedal markings.
	Vex.Flow.PedalMarking = (function() {
	  function PedalMarking(type) {
	    if (arguments.length > 0) this.init(type);
	  }
	
	  // To enable logging for this class. Set `Vex.Flow.PedalMarking.DEBUG` to `true`.
	  function L() { if (PedalMarking.DEBUG) Vex.L("Vex.Flow.PedalMarking", arguments); }
	
	  // Glyph data
	  PedalMarking.GLYPHS = {
	    "pedal_depress": {
	      code: "v36",
	      x_shift:-10,
	      y_shift:0
	    },
	    "pedal_release": {
	      code: "v5d",
	      x_shift:-2,
	      y_shift:3
	    },
	  };
	
	  PedalMarking.Styles = {
	    TEXT: 1,
	    BRACKET: 2,
	    MIXED: 3
	  };
	
	
	  // ## Public helpers
	  //
	  // Create a sustain pedal marking. Returns the defaults PedalMarking.
	  // Which uses the traditional "Ped" and "*"" markings.
	  PedalMarking.createSustain = function(notes) {
	    var pedal = new PedalMarking(notes);
	    return pedal;
	  };
	
	  // Create a sostenuto pedal marking
	  PedalMarking.createSostenuto = function(notes) {
	    var pedal = new PedalMarking(notes);
	    pedal.setStyle(PedalMarking.Styles.MIXED);
	    pedal.setCustomText("Sost. Ped.");
	    return pedal;
	  };
	
	  // Create an una corda pedal marking
	  PedalMarking.createUnaCorda = function(notes){
	    var pedal = new PedalMarking(notes);
	    pedal.setStyle(PedalMarking.Styles.TEXT);
	    pedal.setCustomText("una corda", "tre corda");
	    return pedal;
	  };
	
	  // ## Prototype Methods
	  PedalMarking.prototype =  {
	    init: function(notes) {
	      this.notes = notes;
	      this.style = Vex.Flow.PedalMarking.TEXT;
	      this.line = 0;
	
	      // Custom text for the release/depress markings
	      this.custom_depress_text = "";
	      this.custom_release_text = "";
	
	      this.font = {
	        family: "Times New Roman",
	        size: 12,
	        weight: "italic bold"
	      };
	
	      this.render_options = {
	        bracket_height: 10,
	        text_margin_right: 6,
	        bracket_line_width: 1,
	        glyph_point_size: 40,
	        color: "black"
	      };
	    },
	
	    // Set custom text for the `depress`/`release` pedal markings. No text is
	    // set if the parameter is falsy.
	    setCustomText: function(depress, release) {
	      this.custom_depress_text = depress || "";
	      this.custom_release_text = release || "";
	      return this;
	    },
	
	    // Set the pedal marking style
	    setStyle: function(style){
	      if (style < 1 && style > 3)  {
	        throw new Vex.RERR("InvalidParameter",
	          "The style must be one found in PedalMarking.Styles");
	      }
	
	      this.style = style;
	      return this;
	    },
	
	    // Set the staff line to render the markings on
	    setLine: function(line) { this.line = line; return this; },
	
	    // Set the rendering context
	    setContext: function(context) { this.context = context; return this; },
	
	    // Draw the bracket based pedal markings
	    drawBracketed: function() {
	      var ctx = this.context;
	      var is_pedal_depressed = false;
	      var prev_x;
	      var prev_y;
	      var pedal = this;
	
	      // Iterate through each note
	      this.notes.forEach(function(note, index, notes) {
	        // Each note triggers the opposite pedal action
	        is_pedal_depressed = !is_pedal_depressed;
	
	        // Get the initial coordinates for the note
	        var x = note.getAbsoluteX();
	        var y = note.getStave().getYForBottomText(pedal.line + 3);
	
	        // Throw if current note is positioned before the previous note
	        if (x < prev_x) throw new Vex.RERR('InvalidConfiguration',
	          'The notes provided must be in order of ascending x positions');
	
	        // Determine if the previous or next note are the same
	        // as the current note. We need to keep track of this for
	        // when adjustments are made for the release+depress action
	        var next_is_same = notes[index+1] === note;
	        var prev_is_same = notes[index-1] === note;
	
	        var x_shift = 0;
	        if (is_pedal_depressed) {
	          // Adjustment for release+depress
	          x_shift =  prev_is_same ? 5 : 0;
	
	          if (pedal.style === PedalMarking.Styles.MIXED && !prev_is_same) {
	            // For MIXED style, start with text instead of bracket
	            if (pedal.custom_depress_text) {
	              // If we have custom text, use instead of the default "Ped" glyph
	              var text_width = ctx.measureText(pedal.custom_depress_text).width;
	              ctx.fillText(pedal.custom_depress_text, x - (text_width/2), y);
	              x_shift = (text_width / 2) + pedal.render_options.text_margin_right;
	            } else {
	              // Render the Ped glyph in position
	              drawPedalGlyph('pedal_depress', ctx, x, y, pedal.render_options.glyph_point_size);
	              x_shift = 20 + pedal.render_options.text_margin_right;
	            }
	          } else {
	            // Draw start bracket
	            ctx.beginPath();
	            ctx.moveTo(x, y - pedal.render_options.bracket_height);
	            ctx.lineTo(x + x_shift, y);
	            ctx.stroke();
	            ctx.closePath();
	          }
	        } else {
	          // Adjustment for release+depress
	          x_shift = next_is_same ? -5 : 0;
	
	          // Draw end bracket
	          ctx.beginPath();
	          ctx.moveTo(prev_x, prev_y);
	          ctx.lineTo(x + x_shift, y);
	          ctx.lineTo(x, y - pedal.render_options.bracket_height);
	          ctx.stroke();
	          ctx.closePath();
	        }
	
	        // Store previous coordinates
	        prev_x = x + x_shift;
	        prev_y = y;
	      });
	    },
	
	    // Draw the text based pedal markings. This defaults to the traditional
	    // "Ped" and "*"" symbols if no custom text has been provided.
	    drawText: function() {
	      var ctx = this.context;
	      var is_pedal_depressed = false;
	      var pedal = this;
	
	      // The glyph point size
	      var point = pedal.render_options.glyph_point_size;
	
	      // Iterate through each note, placing glyphs or custom text accordingly
	      this.notes.forEach(function(note) {
	        is_pedal_depressed = !is_pedal_depressed;
	        var stave = note.getStave();
	        var x = note.getAbsoluteX();
	        var y = stave.getYForBottomText(pedal.line + 3);
	
	        var text_width = 0;
	        if (is_pedal_depressed) {
	          if (pedal.custom_depress_text) {
	            text_width = ctx.measureText(pedal.custom_depress_text).width;
	            ctx.fillText(pedal.custom_depress_text, x - (text_width/2), y);
	          } else {
	            drawPedalGlyph("pedal_depress", ctx, x, y, point);
	          }
	        } else {
	          if (pedal.custom_release_text) {
	            text_width = ctx.measureText(pedal.custom_release_text).width;
	            ctx.fillText(pedal.custom_release_text, x - (text_width/2), y);
	          } else {
	            drawPedalGlyph("pedal_release", ctx, x, y, point);
	          }
	        }
	      });
	    },
	
	    // Render the pedal marking in position on the rendering context 
	    draw: function() {
	      if (!this.context) throw new Vex.RERR("NoContext",
	        "Can't draw PedalMarking without a context.");
	      var ctx = this.context;
	
	      ctx.save();
	      ctx.setStrokeStyle(this.render_options.color);
	      ctx.setFillStyle(this.render_options.color);
	      ctx.setFont(this.font.family, this.font.size, this.font.weight);
	
	      L("Rendering Pedal Marking");
	
	      if (this.style === PedalMarking.Styles.BRACKET ||
	          this.style === PedalMarking.Styles.MIXED) {
	        ctx.setLineWidth(this.render_options.bracket_line_width);
	        this.drawBracketed();
	      } else if (this.style === Vex.Flow.PedalMarking.Styles.TEXT) {
	        this.drawText();
	      }
	
	      ctx.restore();
	    }
	  };
	
	  // ## Private Helper
	  // 
	  // Draws a pedal glyph with the provided `name` on a rendering `context` 
	  // at the coordinates `x` and `y. Takes into account the glyph data
	  // coordinate shifts.
	  function drawPedalGlyph(name, context, x, y, point) {
	    var glyph_data = PedalMarking.GLYPHS[name];
	    var glyph = new Vex.Flow.Glyph(glyph_data.code, point);
	    glyph.render(context, x + glyph_data.x_shift, y + glyph_data.y_shift);
	  }
	
	  return PedalMarking;
	}());
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	// Author: Cyril Silverman
	//
	// ## Description
	//
	// This file implement `TextBrackets` which extend between two notes.
	// The octave transposition markings (8va, 8vb, 15va, 15vb) can be created
	// using this class.
	//
	Vex.Flow.TextBracket = (function() {
	  function TextBracket(bracket_data) {
	    if (arguments.length > 0) this.init(bracket_data);
	  }
	
	  // To enable logging for this class. Set `Vex.Flow.TextBracket.DEBUG` to `true`.
	  function L() { if (TextBracket.DEBUG) Vex.L("Vex.Flow.TextBracket", arguments); }
	
	  TextBracket.Positions = {
	    TOP: 1,
	    BOTTOM: -1
	  };
	
	  // ## Prototype Methods
	  TextBracket.prototype =  {
	    init: function(bracket_data) {
	      this.start = bracket_data.start;
	      this.stop = bracket_data.stop;
	
	      this.text = bracket_data.text || "";
	      this.superscript = bracket_data.superscript || "";
	
	      this.position = bracket_data.position || TextBracket.Positions.TOP;
	      this.line = 1;
	
	      this.font = {
	        family: "Serif",
	        size: 15,
	        weight: "italic"
	      };
	
	      this.render_options = {
	        dashed: true,
	        dash: [5],
	        color: "black",
	        line_width: 1,
	        show_bracket: true,
	        bracket_height: 8,
	
	        // In the BOTTOM position, the bracket line can extend
	        // under the superscript.
	        underline_superscript: true
	      };
	    },
	
	    // Apply the text backet styling to the provided `context`
	    applyStyle: function(context) {
	      // Apply style for the octave bracket
	      context.setFont(this.font.family, this.font.size, this.font.weight);
	      context.setStrokeStyle(this.render_options.color);
	      context.setFillStyle(this.render_options.color);
	      context.setLineWidth(this.render_options.line_width);
	
	      return this;
	    },
	
	    // Set whether the bracket line should be `dashed`. You can also
	    // optionally set the `dash` pattern by passing in an array of numbers
	    setDashed: function(dashed, dash) {
	      this.render_options.dashed = dashed;
	      if (dash) this.render_options.dash = dash;
	      return this;
	    },
	
	    // Set the font for the text
	    setFont: function(font) { this.font = font; return this; },
	    // Set the rendering `context` for the octave bracket
	    setContext: function(context) { this.context = context; return this; },
	    // Set the staff line to render the bracket on
	    setLine: function(line) { this.line = line; return this; },
	
	    // Draw the octave bracket on the rendering context
	    draw: function() {
	      var ctx = this.context;
	
	      var y = 0;
	      switch(this.position) {
	        case TextBracket.Positions.TOP:
	          y =  this.start.getStave().getYForTopText(this.line);
	          break;
	        case TextBracket.Positions.BOTTOM:
	          y =  this.start.getStave().getYForBottomText(this.line);
	          break;
	      }
	
	      // Get the preliminary start and stop coordintates for the bracket
	      var start = { x: this.start.getAbsoluteX(), y: y};
	      var stop = { x: this.stop.getAbsoluteX(), y: y };
	
	      L("Rendering TextBracket: start:", start, "stop:", stop, "y:", y);
	
	      var bracket_height = this.render_options.bracket_height * this.position;
	
	      ctx.save();
	      this.applyStyle(ctx);
	
	      // Draw text
	      ctx.fillText(this.text, start.x, start.y);
	
	      // Get the width and height for the octave number
	      var main_width = ctx.measureText(this.text).width;
	      var main_height = ctx.measureText("M").width;
	
	      // Calculate the y position for the super script
	      var super_y = start.y - (main_height/2.5);
	
	      // Draw the superscript
	      ctx.setFont(this.font.family, this.font.size / 1.4, this.font.weight);
	      ctx.fillText(this.superscript, start.x + main_width + 1, super_y);
	
	
	      // Determine width and height of the superscript
	      var superscript_width = ctx.measureText(this.superscript).width;
	      var super_height = ctx.measureText("M").width;
	
	      // Setup initial coordinates for the bracket line
	      var start_x = start.x;
	      var line_y = super_y;
	      var end_x = stop.x + this.stop.getGlyph().head_width;
	
	      // Adjust x and y coordinates based on position
	      if (this.position === TextBracket.Positions.TOP) {
	        start_x += main_width + superscript_width + 5;
	        line_y -= super_height/2.7;
	      } else if (this.position === TextBracket.Positions.BOTTOM) {
	        line_y += super_height/2.7;
	        start_x += main_width + 2;
	
	        if (!this.render_options.underline_superscript) {
	          start_x += superscript_width;
	        }
	      }
	
	      if (this.render_options.dashed) {
	        // Main line
	        Vex.Flow.Renderer.drawDashedLine(ctx, start_x, line_y, end_x, line_y,
	          this.render_options.dash);
	        // Ending Bracket
	        if (this.render_options.show_bracket) {
	          Vex.Flow.Renderer.drawDashedLine(ctx, end_x, line_y + (1 * this.position),
	            end_x, line_y + bracket_height, this.render_options.dash);
	        }
	      } else {
	        ctx.beginPath();
	        ctx.moveTo(start_x, line_y);
	        // Main line
	        ctx.lineTo(end_x, line_y);
	        if (this.render_options.show_bracket) {
	          // Ending bracket
	          ctx.lineTo(end_x, line_y + bracket_height);
	        }
	        ctx.stroke();
	        ctx.closePath();
	      }
	
	      ctx.restore();
	    }
	  };
	
	  return TextBracket;
	})();
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements the `TextDynamics` which renders traditional
	// text dynamics markings, **ie: p, f, sfz, rfz, ppp**
	//
	// You can render any dynamics string that contains a combination of
	// the following letters:  P, M, F, Z, R, S
	Vex.Flow.TextDynamics = (function(){
	  function TextDynamics(text_struct) {
	    if (arguments.length > 0) this.init(text_struct);
	  }
	
	  // To enable logging for this class. Set `Vex.Flow.TextDynamics.DEBUG` to `true`.
	  function L() { if (TextDynamics.DEBUG) Vex.L("Vex.Flow.TextDynamics", arguments); }
	
	  // The glyph data for each dynamics letter
	  TextDynamics.GLYPHS = {
	    "f": {
	      code: "vba",
	      width: 12
	    },
	    "p": {
	      code: "vbf",
	      width: 14
	    },
	    "m": {
	      code: "v62",
	      width: 17
	    },
	    "s": {
	      code: "v4a",
	      width: 10
	    },
	    "z": {
	      code: "v80",
	      width: 12
	    },
	    "r": {
	      code: "vb1",
	      width: 12
	    }
	  };
	
	  // ## Prototype Methods
	  //
	  // A `TextDynamics` object inherits from `Note` so that it can be formatted
	  // within a `Voice`.
	  Vex.Inherit(TextDynamics, Vex.Flow.Note, {
	    // Create the dynamics marking. `text_struct` is an object
	    // that contains a `duration` property and a `sequence` of
	    // letters that represents the letters to render
	    init: function(text_struct) {
	      TextDynamics.superclass.init.call(this, text_struct);
	
	      this.sequence = text_struct.text.toLowerCase();
	      this.line = text_struct.line || 0;
	      this.glyphs = [];
	
	      Vex.Merge(this.render_options, {
	        glyph_font_size: 40
	      });
	
	      L("New Dynamics Text: ", this.sequence);
	    },
	
	    // Set the Stave line on which the note should be placed
	    setLine: function(line) { this.line = line;  return this; },
	
	    // Preformat the dynamics text
	    preFormat: function() {
	      var total_width = 0;
	      // Iterate through each letter
	      this.sequence.split('').forEach(function(letter) {
	        // Get the glyph data for the letter
	        var glyph_data = TextDynamics.GLYPHS[letter];
	        if (!glyph_data) throw new Vex.RERR("Invalid dynamics character: " + letter);
	
	        var size =  this.render_options.glyph_font_size;
	        var glyph = new Vex.Flow.Glyph(glyph_data.code, size);
	
	        // Add the glyph
	        this.glyphs.push(glyph);
	
	        total_width += glyph_data.width;
	      }, this);
	
	      // Store the width of the text
	      this.setWidth(total_width);
	      this.preFormatted = true;
	      return this;
	    },
	
	    // Draw the dynamics text on the rendering context
	    draw: function() {
	      var x = this.getAbsoluteX();
	      var y = this.stave.getYForLine(this.line + (-3));
	
	      L("Rendering Dynamics: ", this.sequence);
	
	      var letter_x = x;
	      this.glyphs.forEach(function(glyph, index) {
	        var current_letter = this.sequence[index];
	        glyph.render(this.context, letter_x, y);
	        letter_x += TextDynamics.GLYPHS[current_letter].width;
	      }, this);
	    }
	  });
	
	  return TextDynamics;
	})();
	Vex.Flow.GraceNote = (function() {
	  var GraceNote = function(note_struct) {
	    if (arguments.length > 0) this.init(note_struct);
	  };
	
	  Vex.Inherit(GraceNote, Vex.Flow.StaveNote, {
	    init: function(note_struct) {
	      GraceNote.superclass.init.call(this, note_struct);
	
	      this.render_options.glyph_font_scale = 22;
	      this.render_options.stem_height = 20;
	      this.render_options.stroke_px = 2;
	      this.glyph.head_width = 6;
	
	      this.slash = note_struct.slash;
	      this.slur = true;
	
	      this.buildNoteHeads();
	
	      this.width = 3;
	    },
	
	    getStemExtension: function(){
	      var glyph = this.getGlyph();
	
	      if (this.stem_extension_override != null) {
	        return this.stem_extension_override;
	      }
	
	      if (glyph) {
	        return this.getStemDirection() === 1 ? glyph.gracenote_stem_up_extension :
	          glyph.gracenote_stem_down_extension;
	      }
	
	      return 0;
	    },
	
	    getCategory: function() { return 'gracenotes'; },
	
	    draw: function(){
	      GraceNote.superclass.draw.call(this);
	      var ctx = this.context;
	      var stem_direction = this.getStemDirection();
	
	      if (this.slash) {
	        ctx.beginPath();
	
	        var x = this.getAbsoluteX();
	        var y = this.getYs()[0] - (this.stem.getHeight() / 2.8);
	        if (stem_direction === 1) {
	          x += 1;
	          ctx.moveTo(x, y);
	          ctx.lineTo(x + 13, y - 9);
	        } else if (stem_direction === -1) {
	          x -= 4;
	          y += 1;
	          ctx.moveTo(x, y);
	          ctx.lineTo(x + 13, y + 9);
	        }
	
	        ctx.closePath();
	        ctx.stroke();
	      }
	    }
	  });
	
	  return GraceNote;
	}());
	
	// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
	//
	// ## Description
	//
	// This file implements `GraceNoteGroup` which is used to format and
	// render grace notes.
	
	Vex.Flow.GraceNoteGroup = (function(){
	  function GraceNoteGroup(grace_notes, config) {
	    if (arguments.length > 0) this.init(grace_notes, config);
	  }
	
	  GraceNoteGroup.CATEGORY = "gracenotegroups";
	
	  // To enable logging for this class. Set `Vex.Flow.GraceNoteGroup.DEBUG` to `true`.
	  function L() { if (GraceNoteGroup.DEBUG) Vex.L("Vex.Flow.GraceNoteGroup", arguments); }
	
	  // Arrange groups inside a `ModifierContext`
	  GraceNoteGroup.format = function(gracenote_groups, state) {
	    var gracenote_spacing = 4;
	
	    if (!gracenote_groups || gracenote_groups.length === 0) return false;
	
	    var group_list = [];
	    var hasStave = false;
	    var prev_note = null;
	    var shiftL = 0;
	
	    var i, gracenote_group, props_tmp;
	    for (i = 0; i < gracenote_groups.length; ++i) {
	      gracenote_group = gracenote_groups[i];
	      var note = gracenote_group.getNote();
	      var stave = note.getStave();
	      if (note != prev_note) {
	         // Iterate through all notes to get the displaced pixels
	         for (var n = 0; n < note.keys.length; ++n) {
	            props_tmp = note.getKeyProps()[n];
	            shiftL = (props_tmp.displaced ? note.getExtraLeftPx() : shiftL);
	          }
	          prev_note = note;
	      }
	      if (stave != null) {
	        hasStave = true;
	        group_list.push({shift: shiftL, gracenote_group: gracenote_group});
	      } else {
	        group_list.push({shift: shiftL, gracenote_group: gracenote_group });
	      }
	    }
	
	    // If first note left shift in case it is displaced
	    var group_shift = group_list[0].shift;
	    var formatWidth;
	    for (i = 0; i < group_list.length; ++i) {
	      gracenote_group = group_list[i].gracenote_group;
	      gracenote_group.preFormat();
	      formatWidth = gracenote_group.getWidth() + gracenote_spacing;
	      group_shift = Math.max(formatWidth, group_shift);
	    }
	
	    for (i = 0; i < group_list.length; ++i) {
	      gracenote_group = group_list[i].gracenote_group;
	      formatWidth = gracenote_group.getWidth() + gracenote_spacing;
	      gracenote_group.setSpacingFromNextModifier(group_shift - Math.min(formatWidth, group_shift));
	    }
	
	    state.left_shift += group_shift;
	    return true;
	  };
	
	  // ## Prototype Methods
	  //
	  // `GraceNoteGroup` inherits from `Modifier` and is placed inside a
	  // `ModifierContext`.
	  Vex.Inherit(GraceNoteGroup, Vex.Flow.Modifier, {
	    init: function(grace_notes, show_slur) {
	      var superclass = GraceNoteGroup.superclass;
	      superclass.init.call(this);
	
	      this.note = null;
	      this.index = null;
	      this.position = Vex.Flow.Modifier.Position.LEFT;
	      this.grace_notes = grace_notes;
	      this.width = 0;
	
	      this.preFormatted = false;
	
	      this.show_slur = show_slur;
	      this.slur = null;
	
	      this.formatter = new Vex.Flow.Formatter();
	      this.voice = new Vex.Flow.Voice({
	        num_beats: 4,
	        beat_value: 4,
	        resolution: Vex.Flow.RESOLUTION
	      }).setStrict(false);
	
	      this.voice.addTickables(this.grace_notes);
	
	      return this;
	    },
	
	    preFormat: function(){
	      if (this.preFormatted) return;
	
	      this.formatter.joinVoices([this.voice]).format([this.voice], 0);
	      this.setWidth(this.formatter.getMinTotalWidth());
	      this.preFormatted = true;
	    },
	
	    beamNotes: function(){
	      if (this.grace_notes.length > 1) {
	        var beam = new Vex.Flow.Beam(this.grace_notes);
	
	        beam.render_options.beam_width = 3;
	        beam.render_options.partial_beam_length = 4;
	
	        this.beam = beam;
	      }
	
	      return this;
	    },
	
	    setNote: function(note) {
	      this.note = note;
	    },
	    setWidth: function(width){
	      this.width = width;
	    },
	    getWidth: function(){
	      return this.width;
	    },
	    draw: function() {
	      if (!this.context)  {
	        throw new Vex.RuntimeError("NoContext",
	          "Can't draw Grace note without a context.");
	      }
	
	      var note = this.getNote();
	
	      L("Drawing grace note group for:", note);
	
	      if (!(note && (this.index !== null))) {
	        throw new Vex.RuntimeError("NoAttachedNote",
	          "Can't draw grace note without a parent note and parent note index.");
	      }
	
	      var that = this;
	      function alignGraceNotesWithNote(grace_notes, note, groupWidth) {
	        // Shift over the tick contexts of each note
	        // So that th aligned with the note
	        var tickContext = note.getTickContext();
	        var extraPx = tickContext.getExtraPx();
	        var x = tickContext.getX() - extraPx.left - extraPx.extraLeft + that.getSpacingFromNextModifier();
	        grace_notes.forEach(function(graceNote) {
	            var tick_context = graceNote.getTickContext();
	            var x_offset = tick_context.getX();
	            graceNote.setStave(note.stave);
	            tick_context.setX(x + x_offset);
	        });
	      }
	
	      alignGraceNotesWithNote(this.grace_notes, note, this.width);
	
	      // Draw notes
	      this.grace_notes.forEach(function(graceNote) {
	        graceNote.setContext(this.context).draw();
	      }, this);
	
	      // Draw beam
	      if (this.beam) {
	        this.beam.setContext(this.context).draw();
	      }
	
	      if (this.show_slur) {
	        // Create and draw slur
	        this.slur = new Vex.Flow.StaveTie({
	          last_note: this.grace_notes[0],
	          first_note: note,
	          first_indices: [0],
	          last_indices: [0]
	        });
	
	        this.slur.render_options.cp2 = 12;
	        this.slur.setContext(this.context).draw();
	      }
	    }
	  });
	
	return GraceNoteGroup;
	}());
	//# sourceMappingURL=vexflow-debug.js.map

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};Object.defineProperty(exports, "__esModule", { value: true });exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	pitchesToStaveNote = pitchesToStaveNote;var _vexflow = __webpack_require__(241);var _vexflow2 = _interopRequireDefault(_vexflow);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var baseTable = [{ note: "C", accidental: null }, { note: "C", accidental: "#" }, { note: "D", accidental: null }, { note: "E", accidental: "b" }, { note: "E", accidental: null }, { note: "F", accidental: null }, { note: "F", accidental: "#" }, { note: "G", accidental: null }, { note: "A", accidental: "b" }, { note: "A", accidental: null }, { note: "B", accidental: "b" }, { note: "B", accidental: null }]; /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * Input: an array containing numbers of semitones above middle C
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * (e.g., [0, 4, 7] for a middle C major triad).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * Output: a Vex.Flow.StaveNote.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * Optional parameter: duration, in VexFlow notation (default = "w").
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  */function pitchesToStaveNote(pitches) {var duration = arguments.length <= 1 || arguments[1] === undefined ? "w" : arguments[1];var _Vex$Flow = _vexflow2.default.Flow;var StaveNote = _Vex$Flow.StaveNote;var Accidental = _Vex$Flow.Accidental; // Put the data in a more structured form.
	    var keysData = pitches.map(function (semitones) {var octaveOffset = Math.floor(semitones / 12);var octaveName = octaveOffset + 4;var prePhase = semitones % 12;
	        var phase = prePhase < 0 ? prePhase + 12 : prePhase;
	
	        return _extends({}, 
	        baseTable[phase], { 
	            octave: octaveName });});
	
	
	
	    // Generate the key description text that VexFlow expects.
	    var keys = keysData.map(function (keyData) {var 
	        note = keyData.note;var octave = keyData.octave;
	        var accidental = keyData.accidental || "";
	        return "" + note.toLowerCase() + accidental + "/" + octave;});
	
	    var bareNote = new StaveNote({ keys: keys, duration: duration });
	
	    // VexFlow makes us add accidentals in two places:
	    // in the 'keys', as above (e.g., "c#/4"),
	    // and additionally to the generated StaveNote.
	    var noteWithAccidentals = keysData.reduce(function (acc, keyData, index) {return (
	            keyData.accidental ? 
	            acc.addAccidental(index, new Accidental(keyData.accidental)) : 
	            acc);}, 
	    bareNote);
	
	    return noteWithAccidentals;}

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _PitchNames = __webpack_require__(238);var _PitchNames2 = _interopRequireDefault(_PitchNames);var _TextUtils = __webpack_require__(244);var 
	
	
	TextUtils = _interopRequireWildcard(_TextUtils);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var 
	
	ChordInput = (function (_Component) {_inherits(ChordInput, _Component);
	
	    function ChordInput() {_classCallCheck(this, ChordInput);var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ChordInput).call(this));
	
	        _this.state = { 
	            text: null, 
	            error: null };return _this;}_createClass(ChordInput, [{ key: '_initializeInput', value: function _initializeInput(
	
	
	
	        input) {
	            if (input !== null) {
	                input.focus();
	                input.selectionStart = input.value.length;
	                input.selectionEnd = input.value.length;}} }, { key: 'render', value: function render() 
	
	
	
	        {var _this2 = this;
	            var text = this.state.text !== null ? 
	            this.state.text : 
	            this._toString(this.props.value);
	            var formattedText = text.replace(/\s/g, ' '); // EN SPACE
	
	            return _react2.default.createElement('div', { className: 'well' }, 
	            _react2.default.createElement('label', { htmlFor: 'chord-entry' }, this.props.message), 
	            " ", 
	            _react2.default.createElement('input', { 
	                className: 'form-control', 
	                ref: this._initializeInput, 
	                id: 'chord-entry', 
	                value: formattedText, 
	                onChange: function onChange(e) {return _this2._handleChange(e.target.value);}, 
	                onBlur: function onBlur() {return _this2.setState({ text: null, error: null });}, 
	                style: { 
	                    color: this._fromString(text).status === "error" ? 
	                    "red" : 
	                    undefined, 
	                    display: "inline-block", 
	                    width: "unset" }, 
	
	                spellCheck: false }), 
	
	            _react2.default.createElement('span', { style: { 
	                    marginLeft: 10 } }, 
	            this.state.error));} }, { key: '_handleChange', value: function _handleChange(
	
	
	
	        text) {
	            this.setState({ text: text });
	
	            var value = this._fromString(text);
	            if (value.status === "success") {
	                this.props.onChange(value.result);
	                this.setState({ error: null });} else 
	            {
	                this.setState({ error: value.error });}} }, { key: '_toString', value: function _toString(
	
	
	
	        value) {
	            return value.map(function (x) {return _PitchNames2.default.pitchToName(x, true);}).join(" ");} }, { key: '_fromString', value: function _fromString(
	
	
	        str) {
	            var trimmed = str.trim().replace(/\s+/g, " ");
	
	            var parts = trimmed.length === 0 ? [] : trimmed.split(" ");
	            var maybeParsedParts = parts.map(function (text) {return { 
	                    input: text, 
	                    output: _PitchNames2.default.parseNameOrPitch(text) };});
	
	
	            var badParts = maybeParsedParts.filter(function (x) {return x.output === null;});
	            if (badParts.length !== 0) {
	                var bad = badParts.map(function (x) {return '"' + x.input + '"';});
	
	                var noun1 = TextUtils.ngettext(bad, "token", "tokens");
	                var verb = TextUtils.ngettext(bad, "doesn't", "don't");
	                var noun2 = TextUtils.ngettext(
	                bad, "a valid note", "valid notes");
	                var list = TextUtils.list(bad);
	
	                return { 
	                    status: "error", 
	                    error: 'The ' + noun1 + ' ' + list + ' ' + verb + ' look like ' + noun2 + '.' };}
	
	
	
	            var good = maybeParsedParts.map(function (x) {return x.output;}).sort(function (a, b) {return a - b;});var 
	
	            exactly = this.props.exactly;
	            if (exactly !== undefined && good.length !== exactly) {
	                var actual = good.length;
	                var nounActual = TextUtils.quantity(actual, "note", "notes");
	                var nounExactly = TextUtils.quantity(exactly, "note", "notes");
	                var error = 
	                'It looks like you entered ' + nounActual + ', ' + ('but I was expecting exactly ' + 
	                nounExactly + '.');
	                return { 
	                    status: "error", 
	                    error: error };}
	
	
	            return { 
	                status: "success", 
	                result: good };} }]);return ChordInput;})(_react.Component);exports.default = ChordInput;
	
	
	
	ChordInput.propTypes = { 
	    value: _react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired, 
	    onChange: _react.PropTypes.func.isRequired, 
	    message: _react.PropTypes.string.isRequired, 
	
	    exactly: _react.PropTypes.number };

/***/ },
/* 244 */
/***/ function(module, exports) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.numberish = numberish;exports.
	
	
	
	
	
	
	
	
	
	ngettext = ngettext;exports.
	
	
	
	
	
	
	
	
	
	
	quantity = quantity;exports.
	
	
	
	
	list = list;function numberish(numberOrArray) {if (typeof numberOrArray === "number") {return numberOrArray;} else if (Array.isArray(numberOrArray)) {return numberOrArray.length;} else {throw new Error("not very number-like: " + numberOrArray);}}function ngettext(numberOrArray, singular, plural) {var other = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];var number = numberish(numberOrArray);if (number in other) {return other[number].toString();} else if (number === 1) {return singular.toString();} else {return plural.toString();}}function quantity(numberOrArray) {var number = numberish(numberOrArray);for (var _len = arguments.length, argsToNgettext = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {argsToNgettext[_key - 1] = arguments[_key];}return number + " " + ngettext.apply(undefined, [numberOrArray].concat(argsToNgettext));}function list(entries) {
	    switch (entries.length) {
	        case 0:
	            // you probably shouldn't do that
	            return "";
	        case 1:
	            return entries[0].toString();
	        case 2:
	            return entries[0] + " and " + entries[1];
	        default:
	            var init = entries.slice(0, entries.length - 1);
	            var last = entries[entries.length - 1];
	            return init.join(", ") + ", and " + last;}}

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _HarmonicData = __webpack_require__(183);var _Rational = __webpack_require__(179);var _Rational2 = _interopRequireDefault(_Rational);var _TextUtils = __webpack_require__(244);var 
	
	
	
	TextUtils = _interopRequireWildcard(_TextUtils);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var 
	
	RationalizerSettings = (function (_Component) {_inherits(RationalizerSettings, _Component);function RationalizerSettings() {_classCallCheck(this, RationalizerSettings);return _possibleConstructorReturn(this, Object.getPrototypeOf(RationalizerSettings).apply(this, arguments));}_createClass(RationalizerSettings, [{ key: 'render', value: function render() 
	
	        {var _this2 = this;var 
	            values = this.props.values;
	            return _react2.default.createElement('div', { style: { marginBottom: 20 } }, 
	            _react2.default.createElement('h3', null, 'Configure rationalization'), 
	            _react2.default.createElement('p', null, 'How do you want to map semitone differences to acoustic ratios? You can modify the default mappings by changing the cells below.'), 
	
	
	
	            _react2.default.createElement('p', null, 'For best results, these values should be strictly decreasing, and all between 1.0 (which would be a P0) and 0.5 (which would be a P8).'), 
	
	
	
	
	            _react2.default.createElement('div', { style: { 
	                    padding: "10px 0", 
	                    display: "table-row", 
	                    verticalAlign: "top" } }, 
	
	            values.map(function (value, index) {
	                var setValueTo = function setValueTo(v) {return _this2.props.onChangeValue(index, v);};
	                return _react2.default.createElement(AcousticRatioBox, { 
	                    value: value, 
	                    key: index, 
	                    name: _HarmonicData.intervalNames[index], 
	                    isDefault: value.equals(_HarmonicData.canonicalValues[index]), 
	                    onChange: function onChange(newValue) {return setValueTo(newValue);}, 
	                    onReset: function onReset() {return setValueTo(_HarmonicData.canonicalValues[index]);} });})), 
	
	
	
	            this._renderDescendingWarning(values), 
	            this._renderZeroWarning(values));} }, { key: '_renderDescendingWarning', value: function _renderDescendingWarning(
	
	
	
	        values) {
	            var bad = values.
	            slice(0, values.length - 1).
	            map(function (x, i) {return i;}).
	            filter(function (i) {return values[i].toNumber() <= values[i + 1].toNumber();}).
	            map(function (i) {return _HarmonicData.intervalNames[i] + '–' + _HarmonicData.intervalNames[i + 1];});
	            if (!bad.length) {
	                return null;}
	
	
	            var prefix = TextUtils.ngettext(bad, 
	            "The interval", "The intervals");
	            var list = TextUtils.list(bad);
	            var verb = TextUtils.ngettext(bad, "is", "are");
	            return _react2.default.createElement('div', { className: 'alert alert-warning', style: { marginTop: 15 } }, 
	            _react2.default.createElement('strong', null, 'Warning:'), ' ', prefix, ' ', list, ' ', verb, ' not descending.');} }, { key: '_renderZeroWarning', value: function _renderZeroWarning(
	
	
	
	        values) {
	            var bad = values.
	            map(function (x, i) {return i;}).
	            filter(function (i) {return values[i].toNumber() === 0;}).
	            map(function (i) {return _HarmonicData.intervalNames[i];});
	            if (!bad.length) {
	                return null;}
	
	
	            var noun1 = TextUtils.ngettext(bad, "ratio", "ratios");
	            var list = TextUtils.list(bad);
	            var verb = TextUtils.ngettext(bad, "is", "are");
	            var noun2 = TextUtils.ngettext(bad, 
	            "this interval", 
	            "one of these intervals");
	            return _react2.default.createElement('div', { className: 'alert alert-warning', style: { marginTop: 15 } }, 
	            _react2.default.createElement('strong', null, 'Warning:'), 
	            " ", 'It looks like the ', 
	            noun1, ' for ', list, ' ', verb, ' zero. This is not good; if ', 
	            noun2, ' ever appears in a chord, the chord will be impossible to analyze. You should fix that.');} }]);return RationalizerSettings;})(_react.Component);exports.default = RationalizerSettings;
	
	
	
	
	
	RationalizerSettings.propTypes = { 
	    values: _react.PropTypes.arrayOf(
	    _react.PropTypes.instanceOf(_Rational2.default).isRequired).isRequired, 
	    onChangeValue: _react.PropTypes.func.isRequired };var 
	
	
	AcousticRatioBox = (function (_Component2) {_inherits(AcousticRatioBox, _Component2);function AcousticRatioBox() {_classCallCheck(this, AcousticRatioBox);return _possibleConstructorReturn(this, Object.getPrototypeOf(AcousticRatioBox).apply(this, arguments));}_createClass(AcousticRatioBox, [{ key: 'render', value: function render() 
	
	        {
	            var id = "ratio-entry-" + this.props.name;
	            return _react2.default.createElement('div', { style: { 
	                    display: "table-cell", 
	                    width: 60, 
	                    textAlign: "center", 
	                    padding: "0 2px" } }, 
	
	            _react2.default.createElement('label', { htmlFor: id }, this.props.name), _react2.default.createElement('br', null), 
	            _react2.default.createElement(AcousticRatioEntry, { 
	                value: this.props.value, 
	                onChange: this.props.onChange, 
	                id: id }), 
	
	            !this.props.isDefault && 
	            _react2.default.createElement('button', { onClick: this.props.onReset }, 'Reset'));} }]);return AcousticRatioBox;})(_react.Component);
	
	
	
	
	AcousticRatioBox.propTypes = { 
	    value: _react.PropTypes.instanceOf(_Rational2.default), 
	    onChange: _react.PropTypes.func.isRequired, 
	
	    onReset: _react.PropTypes.func.isRequired, 
	    name: _react.PropTypes.string.isRequired, 
	    isDefault: _react.PropTypes.bool.isRequired };
	
	
	/*
	 * State field 'text' represents the text being entered right now;
	 * it should be null when the user is not entering text
	 * (e.g., the field is blurred, or the user hasn't typed anything yet).
	 * If the 'text' state field is present,
	 * it will be used for the value of the input node.
	 *
	 * (This is so that if you type something like "2:4"
	 * it will only be corrected to "1:2" after you exit the box,
	 * so you can actually type something like "2:41.")
	 */var 
	AcousticRatioEntry = (function (_Component3) {_inherits(AcousticRatioEntry, _Component3);
	
	    function AcousticRatioEntry() {_classCallCheck(this, AcousticRatioEntry);var _this4 = _possibleConstructorReturn(this, Object.getPrototypeOf(AcousticRatioEntry).call(this));
	
	        _this4.state = { 
	            text: null };return _this4;}_createClass(AcousticRatioEntry, [{ key: 'render', value: function render() 
	
	
	
	        {var _this5 = this;
	            var text = this.state.text !== null ? 
	            this.state.text : 
	            this.props.value.a + ':' + this.props.value.b;
	            return _react2.default.createElement('input', { 
	                ref: 'input', 
	                id: this.props.id, 
	                className: 'form-control', 
	                value: text, 
	                onChange: function onChange() {return _this5._handleChange();}, 
	                onBlur: function onBlur() {return _this5.setState({ text: null });}, 
	                onClick: function onClick() {return _this5.refs.input.select();}, 
	                style: { 
	                    width: "100%", 
	                    textAlign: "center", 
	                    padding: 1 } });} }, { key: '_fromString', value: function _fromString(
	
	
	
	
	        str) {
	            var match = str.match(/^\s*(\d+)\s*:\s*(\d+)\s*$/);
	            if (!match) {
	                return { status: "error", error: "no match" };} else 
	            {var 
	                a = match[1];var b = match[2];
	                try {
	                    return { 
	                        status: "success", 
	                        result: new _Rational2.default(parseInt(a, 10), parseInt(b, 10)) };} 
	
	                catch (e) {
	                    return { status: "error", error: e.message };}}} }, { key: '_handleChange', value: function _handleChange() 
	
	
	
	
	        {
	            var text = this.refs.input.value;
	            this.setState({ text: text });
	
	            var value = this._fromString(text);
	            if (value.result) {
	                this.props.onChange(value.result);}} }]);return AcousticRatioEntry;})(_react.Component);
	
	
	
	
	AcousticRatioEntry.propTypes = { 
	    value: _react.PropTypes.instanceOf(_Rational2.default), 
	    onChange: _react.PropTypes.func.isRequired, 
	    id: _react.PropTypes.string.isRequired };

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _reactRedux = __webpack_require__(169);var _Actions = __webpack_require__(187);var 
	
	
	Actions = _interopRequireWildcard(_Actions);var _HarmonicSeries = __webpack_require__(184);var _ChordInput = __webpack_require__(243);var _ChordInput2 = _interopRequireDefault(_ChordInput);var _Page = __webpack_require__(236);var _Page2 = _interopRequireDefault(_Page);var _RationalizerSettings = __webpack_require__(245);var _RationalizerSettings2 = _interopRequireDefault(_RationalizerSettings);var _TrichordTree = __webpack_require__(247);var _TrichordTree2 = _interopRequireDefault(_TrichordTree);var _ViewOptions = __webpack_require__(255);var _ViewOptions2 = _interopRequireDefault(_ViewOptions);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var 
	
	
	
	
	
	
	
	
	
	TreeExplorer = (function (_Component) {_inherits(TreeExplorer, _Component);
	
	    function TreeExplorer() {_classCallCheck(this, TreeExplorer);var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TreeExplorer).call(this));
	
	        _this.state = { 
	            rootChord: [0, 4, 7] };return _this;}
	
	
	
	    /* eslint-disable react/prop-types */_createClass(TreeExplorer, [{ key: 'render', value: function render() 
	        {var _this2 = this;
	            return _react2.default.createElement(_Page2.default, { path: 'tree' }, 
	            _react2.default.createElement('h1', null, 'Chord tree explorer'), 
	            _react2.default.createElement('p', null, 'Explore the outfoldings of a particular trichord. Branches to the left are outfoldings down, and branches to the right are outfoldings up.'), 
	
	
	
	
	            _react2.default.createElement('p', null, 
	            _react2.default.createElement('strong', null, 'Click'), ' on any chord to set it as the root, or ', 
	            _react2.default.createElement('strong', null, 'type'), ' a root chord manually in the text box below.'), 
	
	
	            _react2.default.createElement('p', null, 
	            _react2.default.createElement('strong', null, 'Hover'), ' over a chord to see it engraved on a staff!'), 
	
	            _react2.default.createElement(_ChordInput2.default, { 
	                value: this.state.rootChord, 
	                message: 'Enter a trichord: ', 
	                onChange: function onChange(rootChord) {return _this2.setState({ rootChord: rootChord });}, 
	                exactly: 3 }), 
	
	            _react2.default.createElement(_ViewOptions2.default, { 
	                infinite: false, 
	                values: this.props.treeViewOptions, 
	                handlers: this.props.viewOptionsHandlers }), 
	
	            _react2.default.createElement(_TrichordTree2.default, { 
	                rationalizer: (0, _HarmonicSeries.extendRationalizer)(this.props.acousticRatios), 
	                rootChord: this.state.rootChord, 
	                onClickChord: function onClickChord(rootChord) {return _this2.setState({ rootChord: rootChord });}, 
	                viewOptions: this.props.treeViewOptions }), 
	
	            this.props.rootsVisible && 
	            _react2.default.createElement(_RationalizerSettings2.default, { 
	                values: this.props.acousticRatios, 
	                onChangeValue: this.props.onSetAcousticRatio }));}
	
	
	
	        /* eslint-enable */ }]);return TreeExplorer;})(_react.Component);
	
	
	
	function mapStateToProps(state) {
	    return { 
	        acousticRatios: state.acousticRatios, 
	        rootsVisible: state.treeViewOptions.showRoots, 
	        treeViewOptions: state.treeViewOptions };}
	
	
	
	function mapDispatchToProps(dispatch) {
	    return { 
	        onSetAcousticRatio: function onSetAcousticRatio(index, ratio) {return dispatch(
	            Actions.setAcousticRatio(index, ratio));}, 
	        viewOptionsHandlers: { 
	            onSetLevels: function onSetLevels(levels) {return dispatch(Actions.setTreeLevels(levels));}, 
	            onSetInfiniteLevels: function onSetInfiniteLevels(levels) {return dispatch(
	                Actions.setInfiniteTreeLevels(levels));}, 
	            onSetInfiniteHeight: function onSetInfiniteHeight(height) {return dispatch(
	                Actions.setInfiniteTreeHeight(height));}, 
	            onSetShowRoots: function onSetShowRoots(showRoots) {return dispatch(
	                Actions.setTreeShowRoots(showRoots));}, 
	            onSetShowOctaves: function onSetShowOctaves(showOctaves) {return dispatch(
	                Actions.setTreeShowOctaves(showOctaves));}, 
	            onSetWide: function onSetWide(wide) {return dispatch(Actions.setTreeWide(wide));}, 
	            onSetTreeNumber: function onSetTreeNumber(treeNumber) {return dispatch(
	                Actions.setTreeTreeNumber(treeNumber));}, 
	            onSetRootBass: function onSetRootBass(rootBass) {return dispatch(
	                Actions.setTreeRootBass(rootBass));}, 
	            onSetHighQuality: function onSetHighQuality(highQuality) {return dispatch(
	                Actions.setTreeHighQuality(highQuality));}, 
	            onSetRainbowFactor: function onSetRainbowFactor(rainbowFactor) {return dispatch(
	                Actions.setTreeRainbowFactor(rainbowFactor));}, 
	            onSetAlwaysEngrave: function onSetAlwaysEngrave(alwaysEngrave) {return dispatch(
	                Actions.setTreeAlwaysEngrave(alwaysEngrave));}, 
	            onSetLimitValue: function onSetLimitValue(limit, value) {return dispatch(
	                Actions.setTreeLimitValue(limit, value));}, 
	            onSetLimitEnabled: function onSetLimitEnabled(limit, enabled) {return dispatch(
	                Actions.setTreeLimitEnabled(limit, enabled));} } };}exports.default = 
	
	
	
	
	(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TreeExplorer);

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _Folding = __webpack_require__(248);var _Folding2 = _interopRequireDefault(_Folding);var _Utils = __webpack_require__(180);var _CustomPropTypes = __webpack_require__(249);var _CustomPropTypes2 = _interopRequireDefault(_CustomPropTypes);var _TreeView = __webpack_require__(250);var _TreeView2 = _interopRequireDefault(_TreeView);var _TrichordView = __webpack_require__(251);var _TrichordView2 = _interopRequireDefault(_TrichordView);var _InvalidRootWarnings = __webpack_require__(254);var _InvalidRootWarnings2 = _interopRequireDefault(_InvalidRootWarnings);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Given a root chord and some view parameters,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * render an interactive chord tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This involves computing the chords to be rendered
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * (the number of levels is provided as a view option)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * and rendering them all as individual TrichordViews.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */var 
	
	
	
	
	
	
	
	
	
	
	
	TrichordTree = (function (_Component) {_inherits(TrichordTree, _Component);function TrichordTree() {_classCallCheck(this, TrichordTree);return _possibleConstructorReturn(this, Object.getPrototypeOf(TrichordTree).apply(this, arguments));}_createClass(TrichordTree, [{ key: 'render', value: function render() 
	
	        {var _this2 = this;var _props = 
	            this.props;var rationalizer = _props.rationalizer;var rootChord = _props.rootChord;var onClickChord = _props.onClickChord;var 
	            levels = this.props.viewOptions.levels;var 
	
	            sizeSmall = 1;var sizeMedium = 2;var sizeLarge = 3;
	            var size = 
	            levels <= 4 ? sizeLarge : 
	            levels <= 5 ? sizeMedium : 
	            sizeSmall;
	
	            var chords = this._generateTree(rootChord, levels);
	            var nodes = chords.map(function (row, rowIndex) {return row.map(function (chord) {
	                    // The root note has some special properties:
	                    // for example, it's the only editable node,
	                    // and it should also always be at full size.
	                    // Detecting it is made easy by the fact that
	                    // it's also the only node in the first row.
	                    var isRoot = rowIndex === 0;
	                    return _react2.default.createElement(_TrichordView2.default, { 
	                        rationalizer: rationalizer, 
	                        notes: chord
	                        //
	                        , viewOptions: _this2.props.viewOptions, 
	                        size: isRoot ? sizeLarge : size
	                        //
	                        , onClick: isRoot ? null : function () {return onClickChord(chord);}, 
	                        onChange: isRoot ? function (chord) {return onClickChord(chord);} : null });});});
	
	
	
	            // We'd like to add some padding when it's wide
	            // so it's not flush against the edge.
	            // We could just use 'paddingLeft' and 'paddingRight',
	            // but doing it this way---by modifying the width and position---
	            // has the nice side-effect
	            // that it prevents a horizontal scrollbar from appearing
	            // (it can otherwise appear when there's a vertical scrollbar,
	            // because the "viewport width" includes the vertical scrollbar
	            // for some reason).
	            var widePadding = 20;
	            var wideStyle = this.props.viewOptions.wide ? { 
	                position: "relative", 
	                width: 'calc(100vw - ' + 2 * widePadding + 'px)', 
	                left: 'calc(-50vw + ' + widePadding + 'px + 50%)' } : 
	            {};
	
	            return _react2.default.createElement('div', null, 
	            this.props.viewOptions.showRoots && _react2.default.createElement(_InvalidRootWarnings2.default, { 
	                chords: (0, _Utils.flatten)(chords), 
	                rationalizer: rationalizer }), 
	
	            _react2.default.createElement('div', { style: _extends({}, wideStyle, { marginBottom: 20 }) }, 
	            _react2.default.createElement(_TreeView2.default, { 
	                elements: nodes, 
	                spacing: 2 * size })));} }, { key: '_iterateRow', value: function _iterateRow(
	
	
	
	
	
	        previousRow) {
	            var branch = function branch(c) {return [_Folding2.default.outfoldDown(c), _Folding2.default.outfoldUp(c)];};
	            var branches = previousRow.map(branch);
	            return (0, _Utils.flatten)(branches);} }, { key: '_generateTree', value: function _generateTree(
	
	
	        root, depth) {var _this3 = this;
	            return (0, _Utils.buildArray)(depth, function (i, r) {return (
	                    i === 0 ? [root] : _this3._iterateRow(r[i - 1]));});} }]);return TrichordTree;})(_react.Component);exports.default = TrichordTree;
	
	
	
	TrichordTree.propTypes = { 
	    rationalizer: _react.PropTypes.func.isRequired, 
	    rootChord: _react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired, 
	    onClickChord: _react.PropTypes.func.isRequired, 
	    viewOptions: _CustomPropTypes2.default.viewOptions.isRequired };

/***/ },
/* 248 */
/***/ function(module, exports) {

	"use strict";var _slicedToArray = (function () {function sliceIterator(arr, i) {var _arr = [];var _n = true;var _d = false;var _e = undefined;try {for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"]) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}return function (arr, i) {if (Array.isArray(arr)) {return arr;} else if (Symbol.iterator in Object(arr)) {return sliceIterator(arr, i);} else {throw new TypeError("Invalid attempt to destructure non-iterable instance");}};})();Object.defineProperty(exports, "__esModule", { value: true });exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	outfoldUp = outfoldUp;exports.
	
	
	
	
	outfoldDown = outfoldDown;exports.
	
	
	
	
	infoldCanonical = infoldCanonical;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	invert = invert; /*
	                  * Folding operations for trichords.
	                  *
	                  * "Folding" a chord is like treating one of the pitches as a pivot point
	                  * and rotating another one of the pitches around it.
	                  * For example, if you have a trichord whose bottom interval has 5 semitones
	                  * and whose top interval has 3 semitones,
	                  * then you could perform an "upward outfolding"
	                  * by rotating the middle pitch about the top pitch;
	                  * the resulting pitch would have a bottom interval of 8 semitones
	                  * and a top interval of 3 semitones:
	                  *
	                  *     o----o==o
	                  *             |
	                  *     o-------o==o
	                  *
	                  * You could also outfold this same chord downward:
	                  *
	                  *          o====o--o
	                  *          |
	                  *     o====o-------o
	                  *
	                  * Note that, in an outfolding, only the middle pitch changes.
	                  *
	                  * The inverse operation of an outfolding is an infolding.
	                  * Again, you *could* fold in either the top or the bottom pitch,
	                  * but it only really makes sense to fold in
	                  * whichever pitch forms a smaller interval with the middle pitch:
	                  * otherwise, you'll change the middle pitch,
	                  * so you won't be able to perform an outfolding to get back to the original.
	                  *
	                  * For example, to infold a chord whose bottom interval has 5 semitones
	                  * and whose top interval has 3 semitones,
	                  * we'd need to rotate the top-most pitch about the middle pitch:
	                  *
	                  *     o----o==o
	                  *          |
	                  *     o-o==o
	                  *
	                  * Note that if we were to perform an upward outfolding of the result
	                  * we'd get back to where we started.
	                  *
	                  * Finally, the operation of inverting a chord
	                  * just switches the two intervals:
	                  *
	                  *     o----o--o
	                  *     o--o----o
	                  *
	                  * A chord whose intervals are the same can't be inverted
	                  * (or, its inversion is itself).
	                  */function outfoldUp(arr) {var _arr = _slicedToArray(arr, 3);var low = _arr[0];var mid = _arr[1];var high = _arr[2];return [low, high, high + (high - mid)];}function outfoldDown(arr) {var _arr2 = _slicedToArray(arr, 3);var low = _arr2[0];var mid = _arr2[1];var high = _arr2[2];return [low - (mid - low), low, high];}function infoldCanonical(arr) {var _arr3 = _slicedToArray(arr, 3);var low = _arr3[0];var mid = _arr3[1];var high = _arr3[2];var deltaLow = mid - low;var deltaHigh = high - mid;if (deltaLow < deltaHigh) {// Infold up.
	        return [mid, mid + deltaLow, high];} else if (deltaHigh < deltaLow) {// Infold down.
	        return [low, mid - deltaHigh, mid];} else {// This is the root of the tree; there is no infolding.
	        return arr;}}function invert(arr) {var _arr4 = _slicedToArray(arr, 3);var low = _arr4[0];var mid = _arr4[1];var high = _arr4[2];return [low, low + (high - mid), high];}exports.default = { outfoldUp: outfoldUp, outfoldDown: outfoldDown, infoldCanonical: infoldCanonical, invert: invert };

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);
	
	var limits = _react.PropTypes.shape({ 
	    minCombined: _react.PropTypes.number.isRequired, 
	    maxCombined: _react.PropTypes.number.isRequired, 
	    minIndividual: _react.PropTypes.number.isRequired, 
	    maxIndividual: _react.PropTypes.number.isRequired, 
	    minCombinedEnabled: _react.PropTypes.bool.isRequired, 
	    maxCombinedEnabled: _react.PropTypes.bool.isRequired, 
	    minIndividualEnabled: _react.PropTypes.bool.isRequired, 
	    maxIndividualEnabled: _react.PropTypes.bool.isRequired });
	
	
	var limitsHandlersShape = { 
	    onSetLimitValue: _react.PropTypes.func.isRequired, 
	    onSetLimitEnabled: _react.PropTypes.func.isRequired };
	
	var limitsHandlers = _react.PropTypes.shape(limitsHandlersShape);
	
	var viewOptions = _react.PropTypes.shape({ 
	    levels: _react.PropTypes.number.isRequired, 
	    infiniteLevels: _react.PropTypes.number.isRequired, 
	    infiniteHeight: _react.PropTypes.number.isRequired, 
	    showRoots: _react.PropTypes.bool.isRequired, 
	    showOctaves: _react.PropTypes.bool.isRequired, 
	    wide: _react.PropTypes.bool.isRequired, 
	    treeNumber: _react.PropTypes.number.isRequired, 
	    rootBass: _react.PropTypes.number.isRequired, 
	    highQuality: _react.PropTypes.bool.isRequired, 
	    rainbowFactor: _react.PropTypes.number.isRequired, 
	    alwaysEngrave: _react.PropTypes.bool.isRequired, 
	    limits: limits.isRequired });
	
	
	var viewOptionsHandlers = _react.PropTypes.shape(_extends({ 
	    onSetLevels: _react.PropTypes.func.isRequired, 
	    onSetInfiniteLevels: _react.PropTypes.func.isRequired, 
	    onSetInfiniteHeight: _react.PropTypes.func.isRequired, 
	    onSetShowRoots: _react.PropTypes.func.isRequired, 
	    onSetShowOctaves: _react.PropTypes.func.isRequired, 
	    onSetWide: _react.PropTypes.func.isRequired, 
	    onSetTreeNumber: _react.PropTypes.func.isRequired, 
	    onSetRootBass: _react.PropTypes.func.isRequired, 
	    onSetHighQuality: _react.PropTypes.func.isRequired, 
	    onSetRainbowFactor: _react.PropTypes.func.isRequired, 
	    onSetAlwaysEngrave: _react.PropTypes.func.isRequired }, 
	limitsHandlersShape));exports.default = 
	
	
	{ 
	    limits: limits, 
	    limitsHandlers: limitsHandlers, 
	    viewOptions: viewOptions, 
	    viewOptionsHandlers: viewOptionsHandlers };

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}
	
	/*
	 * Lay out a bunch of components in a complete binary tree.
	 */var 
	TreeView = (function (_Component) {_inherits(TreeView, _Component);function TreeView() {_classCallCheck(this, TreeView);return _possibleConstructorReturn(this, Object.getPrototypeOf(TreeView).apply(this, arguments));}_createClass(TreeView, [{ key: "render", value: function render() 
	
	        {
	            return _react2.default.createElement("div", null, 
	            this.props.elements.map(this._renderRow.bind(this)));} }, { key: "_renderRow", value: function _renderRow(
	
	
	
	        row, rowIndex) {
	            return _react2.default.createElement("div", { key: rowIndex, style: { 
	                    display: "table", 
	                    width: "100%", 
	                    borderCollapse: "separate", 
	                    borderSpacing: this.props.spacing, 
	                    marginBottom: -this.props.spacing } }, 
	
	            _react2.default.createElement("div", { style: { 
	                    display: "table-row", 
	                    height: this.props.rowHeight } }, 
	
	            row.map(function (node, nodeIndex) {return (
	                    _react2.default.createElement("div", { key: nodeIndex, style: { 
	                            display: "table-cell", 
	                            textAlign: "center", 
	                            verticalAlign: "top", 
	                            width: 100 * Math.pow(0.5, rowIndex) + "%" } }, 
	                    node));})));} }]);return TreeView;})(_react.Component);exports.default = TreeView;
	
	
	
	
	
	TreeView.propTypes = { 
	
	    /*
	     * A ragged array like [[1], [2, 3], [4, 5, 6, 7], [8, ..., 15]]
	     * containing the rows to render, in left-to-right order.
	     */
	    elements: _react.PropTypes.arrayOf(
	    _react.PropTypes.arrayOf(_react.PropTypes.node.isRequired).isRequired).
	    isRequired, 
	
	    // Optional: fixed row height (px).
	    rowHeight: _react.PropTypes.number, 
	
	    // Optional: row and column spacing (defaults to 5px).
	    spacing: _react.PropTypes.number };
	
	
	TreeView.defaultProps = { 
	    rowHeight: undefined, 
	    spacing: 5 };

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _HarmonicSeries = __webpack_require__(184);var _Utils = __webpack_require__(180);var _DisplayUtils = __webpack_require__(239);var _CustomPropTypes = __webpack_require__(249);var _CustomPropTypes2 = _interopRequireDefault(_CustomPropTypes);var _ActionBar = __webpack_require__(252);var _ActionBar2 = _interopRequireDefault(_ActionBar);var _ChordEngraving = __webpack_require__(240);var _ChordEngraving2 = _interopRequireDefault(_ChordEngraving);var _StackedNoteInput = __webpack_require__(253);var _StackedNoteInput2 = _interopRequireDefault(_StackedNoteInput);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _toConsumableArray(arr) {if (Array.isArray(arr)) {for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {arr2[i] = arr[i];}return arr2;} else {return Array.from(arr);}}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var 
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	TrichordView = (function (_Component) {_inherits(TrichordView, _Component);
	    function TrichordView() {_classCallCheck(this, TrichordView);var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TrichordView).call(this));
	
	        _this.state = { 
	            hovered: false };return _this;}_createClass(TrichordView, [{ key: 'render', value: function render() 
	
	
	
	        {var _this2 = this;
	            // If we're not within limits,
	            // we still need to render a component of the right size
	            // so that the grid layout isn't thrown off.
	            // But we'll lower the opacity of the main content,
	            // and set the engraving's 'visibility' to 'hidden'.
	            var visible = (0, _DisplayUtils.withinLimits)(
	            this.props.notes, this.props.viewOptions.limits);var 
	
	            notes = this.props.notes;
	            var notesAscending = [].concat(_toConsumableArray(notes)).sort(function (a, b) {return a - b;});var _formatPitchesAndSemi = 
	            (0, _DisplayUtils.formatPitchesAndSemitones)(
	            notes, this.props.viewOptions);var noteNames = _formatPitchesAndSemi.noteNames;var semitoneNames = _formatPitchesAndSemi.semitoneNames;
	
	            var noteViews = this.props.onChange ? 
	            [_react2.default.createElement(_StackedNoteInput2.default, { 
	                value: notesAscending, 
	                onChange: this.props.onChange, 
	                style: { display: "inline-block", width: "100%" }, 
	                inputProps: { 
	                    style: { 
	                        textAlign: "center", 
	                        display: "block", 
	                        marginTop: -1 } }, 
	
	
	                viewOptions: this.props.viewOptions, 
	                key: 'edit-view' })] : 
	
	            noteNames.
	            map(function (name, index) {return (
	                    _react2.default.createElement('strong', { key: "note-" + index }, name));}).
	            slice().reverse();
	
	            var rootView = this._renderRootView(notesAscending);
	
	            var semitoneViews = semitoneNames.map(function (name, index) {return (
	                    _react2.default.createElement('span', { key: "semitone-" + index }, name));});
	
	            var style = { 
	                display: "inline-block", 
	                textAlign: "center", 
	                padding: 2 * this.props.size, 
	                fontSize: 8 + 2 * this.props.size, 
	                opacity: visible ? 1 : 0.2 };
	
	
	            var lines = [].concat(_toConsumableArray(
	            noteViews), [
	            this.props.viewOptions.showRoots && rootView], _toConsumableArray(
	            semitoneViews.slice().reverse())); // show descending
	
	            var flattenedContents = (0, _Utils.flatten)(lines.map(function (line, idx) {return (
	                    line && [line, _react2.default.createElement('br', { key: "br-" + idx })]);}));
	
	            var info = this.props.onClick ? 
	            _react2.default.createElement('button', { onClick: this.props.onClick, style: style }, 
	            flattenedContents) : 
	
	            _react2.default.createElement('div', { style: style, className: 'well' }, 
	            flattenedContents, 
	            this.props.onChange && _react2.default.createElement(_ActionBar2.default, { 
	                chord: notes, 
	                onSetChord: this.props.onChange }));
	
	
	
	            var hide = !visible && this.props.onClick;
	            var hoverView = this.state.hovered && !hide ? 
	            _react2.default.createElement(_ChordEngraving2.default, { notes: notes }) : null;
	
	            return _react2.default.createElement('div', { 
	                style: { 
	                    display: "inline-block", 
	                    position: "relative" }, 
	
	                onMouseEnter: function onMouseEnter() {return _this2.setState({ hovered: true });}, 
	                onMouseLeave: function onMouseLeave() {return _this2.setState({ hovered: false });} }, 
	
	            info, 
	            hoverView && 
	            _react2.default.createElement('div', { className: 'panel panel-default', style: { 
	                    position: "absolute", 
	                    bottom: "100%", 
	                    marginBottom: 5, 
	                    zIndex: 3, 
	                    //
	                    // These next two properties center horizontally:
	                    // http://stackoverflow.com/a/23384995
	                    left: "50%", 
	                    transform: "translateX(-50%)" } }, 
	
	            _react2.default.createElement('div', { className: 'panel-body' }, 
	            hoverView)));} }, { key: '_renderRootView', value: function _renderRootView(
	
	
	
	
	
	        notes) {
	            var maybeRootPitch = (0, _HarmonicSeries.findChordRootOffset)(
	            this.props.rationalizer, notes);
	            return _react2.default.createElement('strong', { key: 'root', style: { color: "blue" } }, 
	            (0, _DisplayUtils.formatMaybeRoot)(maybeRootPitch, this.props.viewOptions));} }]);return TrichordView;})(_react.Component);exports.default = TrichordView;
	
	
	
	
	TrichordView.propTypes = { 
	    rationalizer: _react.PropTypes.func.isRequired, 
	    notes: _react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired, 
	    //
	    viewOptions: _CustomPropTypes2.default.viewOptions.isRequired, 
	    size: _react.PropTypes.oneOf([1, 2, 3]), 
	    //
	    onClick: _react.PropTypes.func, 
	    onChange: _react.PropTypes.func }; // if provided, will make this node editable.
	
	TrichordView.defaultProps = { 
	    size: 3 };

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _Folding = __webpack_require__(248);var _Utils = __webpack_require__(180);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * A toolbar with actions to edit a chord.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * This can be attached to editable TrichordViews.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */var 
	
	
	
	
	
	ActionBar = (function (_Component) {_inherits(ActionBar, _Component);function ActionBar() {_classCallCheck(this, ActionBar);return _possibleConstructorReturn(this, Object.getPrototypeOf(ActionBar).apply(this, arguments));}_createClass(ActionBar, [{ key: 'render', value: function render() 
	
	        {var _props = 
	            this.props;var chord = _props.chord;var onSetChord = _props.onSetChord;
	
	            var infolded = (0, _Folding.infoldCanonical)(chord);
	            var hasInfolding = !(0, _Utils.arraysEqual)(infolded, chord);
	
	            var inversion = (0, _Folding.invert)(chord);
	            var hasInversion = !(0, _Utils.arraysEqual)(inversion, chord);
	
	            var style = { 
	                textAlign: "center", 
	                marginTop: 10 };
	
	
	            return _react2.default.createElement('div', { style: style }, 
	            _react2.default.createElement('div', { 
	                className: 'btn-group', 
	                role: 'group' }, 
	
	            _react2.default.createElement('button', { 
	                className: 'btn btn-default', 
	                disabled: !hasInfolding, 
	                onClick: function onClick() {return onSetChord(infolded);} }, 'Infold'), 
	
	            _react2.default.createElement('button', { 
	                className: 'btn btn-default', 
	                disabled: !hasInversion, 
	                onClick: function onClick() {return onSetChord(inversion);} }, 'Invert')));} }]);return ActionBar;})(_react.Component);exports.default = ActionBar;
	
	
	
	
	
	
	ActionBar.propTypes = { 
	    chord: _react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired, 
	    onSetChord: _react.PropTypes.func.isRequired };

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _CustomPropTypes = __webpack_require__(249);var _CustomPropTypes2 = _interopRequireDefault(_CustomPropTypes);var _PitchNames = __webpack_require__(238);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _toConsumableArray(arr) {if (Array.isArray(arr)) {for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {arr2[i] = arr[i];}return arr2;} else {return Array.from(arr);}}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * An input widget for a chord comprising a fixed number of notes,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * displayed in separate text boxes that the user may edit.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */var 
	
	
	
	
	
	StackedNoteInput = (function (_Component) {_inherits(StackedNoteInput, _Component);
	
	    function StackedNoteInput() {_classCallCheck(this, StackedNoteInput);var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(StackedNoteInput).call(this));
	
	        _this.state = { 
	            focusedIndex: null, 
	            focusedText: null };return _this;}_createClass(StackedNoteInput, [{ key: 'render', value: function render() 
	
	
	
	        {var _this2 = this;
	            return _react2.default.createElement('div', { style: this.props.style }, 
	            this.props.value.
	            map(function (value, index) {return _this2._renderInput(value, index);}).
	            reverse());} }, { key: 'componentDidUpdate', value: function componentDidUpdate(
	
	
	
	        oldProps, oldState) {
	            var newFocusedIndex = this.state.focusedIndex;
	            var oldFocusedIndex = oldState.focusedIndex;
	            if (newFocusedIndex !== null && newFocusedIndex !== oldFocusedIndex) {
	                this.refs['input-' + newFocusedIndex].focus();}} }, { key: '_renderInput', value: function _renderInput(
	
	
	
	        value, index) {var _this3 = this;
	            return _react2.default.createElement('input', _extends({ 
	                type: 'text', 
	                value: this._getTextForInputField(value, index), 
	                ref: 'input-' + index, 
	                onChange: function onChange(e) {return _this3._handleChange(e.target.value, index);}, 
	                onFocus: function onFocus() {return _this3.setState({ focusedIndex: index });}, 
	                onBlur: function onBlur() {
	                    // Only reset the text if
	                    // the text field was exited directly,
	                    // not if another one has already been activated
	                    // due to the 'componentDidUpdate' hook.
	                    if (_this3.state.focusedIndex === index) {
	                        _this3.setState({ 
	                            focusedIndex: null, 
	                            focusedText: null });}}, 
	
	
	
	                onKeyDown: function onKeyDown(e) {return _this3._handleKeyDown(e, index);}, 
	                key: index }, 
	            this.props.inputProps));} }, { key: '_getTextForInputField', value: function _getTextForInputField(
	
	
	
	        value, index) {
	            // When the input isn't focused,
	            // always format the prop-provided value,
	            // respecting the view options.
	            if (this.state.focusedIndex !== index) {var 
	                showOctaves = this.props.viewOptions.showOctaves;
	                return (0, _PitchNames.pitchToName)(value, true, showOctaves);}
	
	
	            // When the input's focused
	            // but the user hasn't input any text,
	            // display the prop-provided value
	            // but force octaves to be shown
	            // so that the initial value parses to the original input.
	            // (If we omitted the octaves here,
	            // then a note like "C5", when displayed as just "C",
	            // would parse in relative pitch notation to C4,
	            // which would be confusing because
	            // the value would have changed just by focusing the text field.)
	            if (this.state.focusedText === null) {
	                return (0, _PitchNames.pitchToName)(value, true, true);}
	
	
	            // Otherwise, the input is focused and the user is entering text;
	            // display that so they can keep editing.
	            return this.state.focusedText;} }, { key: '_handleChange', value: function _handleChange(
	
	
	        newText, noteIndex) {
	            var newNote = (0, _PitchNames.parseNameOrPitch)(newText);
	            if (newNote === null) {
	                // Parse failed. No problem; the user's still typing.
	                this.setState({ 
	                    focusedText: newText });
	
	                return;} else 
	            {
	                // Parse succeeded. Update the note in the chord.
	                this._updateNote(newNote, newText, noteIndex);}} }, { key: '_handleKeyDown', value: function _handleKeyDown(
	
	
	
	        e, noteIndex) {
	            var direction = ({ 
	                "ArrowUp": +1, 
	                "ArrowDown": -1 })[
	            e.key];
	
	            // Ignore other keys.
	            if (direction === undefined) {
	                return;}
	
	
	            // Don't move the cursor around
	            // (and don't select everything when holding shift).
	            e.preventDefault();
	
	            // Jump full octaves when holding shift.
	            var delta = e.shiftKey ? direction * 12 : direction;
	            var newNote = this.props.value[noteIndex] + delta;
	            this._updateNote(newNote, (0, _PitchNames.pitchToName)(newNote, true, true), noteIndex);} }, { key: '_updateNote', value: function _updateNote(
	
	
	        newNote, newText, noteIndex) {
	            // Replace the old note in the chord.
	            var notes = this.props.value;
	            var newNotes = [].concat(_toConsumableArray(
	            notes.slice(0, noteIndex)), [
	            newNote], _toConsumableArray(
	            notes.slice(noteIndex + 1)));
	
	
	            // Now here comes the tricky part.
	            // We need to sort the notes so the chord is still ascending,
	            // but if this causes the focus to switch---
	            // e.g., you edit the middle note and make it higher than the high note
	            // so that further edits to the same "thing"
	            // should actually change the (new) high note---
	            // then we need to keep track of that.
	            var oldIndex = noteIndex;
	            var taggedNotes = newNotes.map(function (note, thisIndex) {return { 
	                    note: note, 
	                    isTarget: thisIndex === oldIndex };});
	
	            var taggedNotesAscending = [].concat(_toConsumableArray(taggedNotes)).sort(function (a, b) {return (
	                    a.note - b.note);});
	            var newIndex = taggedNotesAscending.findIndex(function (note) {return note.isTarget;});
	            this.setState({ 
	                focusedIndex: newIndex, 
	                focusedText: newText });
	
	
	            // Finally, we can just discard the tagging information.
	            var notesAscending = taggedNotesAscending.map(function (x) {return x.note;});
	            this.props.onChange(notesAscending);} }]);return StackedNoteInput;})(_react.Component);exports.default = StackedNoteInput;
	
	
	
	StackedNoteInput.propTypes = { 
	    value: _react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired, 
	    onChange: _react.PropTypes.func.isRequired, 
	    viewOptions: _CustomPropTypes2.default.viewOptions.isRequired, 
	    //
	    style: _react.PropTypes.object, // optional
	    inputProps: _react.PropTypes.object };

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _HarmonicSeries = __webpack_require__(184);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Given a list of chords that will appear in a tree,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * this component tries to find all of their roots, and notes any failures.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * It generates warning messages about each failure in human-readable form.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */var 
	
	
	
	
	InvalidRootWarnings = (function (_Component) {_inherits(InvalidRootWarnings, _Component);function InvalidRootWarnings() {_classCallCheck(this, InvalidRootWarnings);return _possibleConstructorReturn(this, Object.getPrototypeOf(InvalidRootWarnings).apply(this, arguments));}_createClass(InvalidRootWarnings, [{ key: 'render', value: function render() 
	
	        {var _this2 = this;
	            var errors = this.props.chords.map(function (chord) {
	                var result = (0, _HarmonicSeries.findChordRootOffset)(_this2.props.rationalizer, chord);
	                return result.status === "error" ? result.error : null;}).
	            filter(function (x) {return x !== null;});
	
	            var finiteError = errors.some(function (x) {return x.match(/finite/);}) && 
	            _react2.default.createElement(Warning, { key: 'finite' }, 
	            _react2.default.createElement('strong', null, 'Note:'), 
	            " ", 'Some of these chords are too complicated to analyze, so we can\'t find their roots. In particular, the acoustic ratios are such complicated fractions that your browser gives up on the math. These chords are indicated with a question mark in the place where the root should be.');
	
	
	
	
	
	
	
	
	
	            var zeroRatioError = errors.some(function (x) {return x.match(/zero_ratio/);}) && 
	            _react2.default.createElement(Warning, { key: 'zero-ratio' }, 
	            _react2.default.createElement('strong', null, 'Note:'), 
	            " ", 'Some of these chords involve a semitone difference that you\'ve mapped to an acoustic ratio of zero, so we can\'t find their roots. Check your rationalization configuration to fix this. In the meantime, these chords are indicated with a question mark in the place where the root should be.');
	
	
	
	
	
	
	
	
	
	            return _react2.default.createElement('div', null, 
	            finiteError, 
	            zeroRatioError);} }]);return InvalidRootWarnings;})(_react.Component);exports.default = InvalidRootWarnings;
	
	
	
	
	InvalidRootWarnings.propTypes = { 
	    chords: _react.PropTypes.arrayOf(
	    _react.PropTypes.arrayOf(_react.PropTypes.number.isRequired).isRequired).isRequired, 
	    rationalizer: _react.PropTypes.func.isRequired };var 
	
	
	Warning = (function (_Component2) {_inherits(Warning, _Component2);function Warning() {_classCallCheck(this, Warning);return _possibleConstructorReturn(this, Object.getPrototypeOf(Warning).apply(this, arguments));}_createClass(Warning, [{ key: 'render', value: function render() 
	        {
	            return _react2.default.createElement('div', _extends({ 
	                className: 'alert alert-warning', 
	                style: { marginTop: 20 } }, 
	            this.props), 
	
	            this.props.children);} }]);return Warning;})(_react.Component);
	
	
	
	Warning.propTypes = { 
	    children: _react.PropTypes.node.isRequired };

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _CustomPropTypes = __webpack_require__(249);var _CustomPropTypes2 = _interopRequireDefault(_CustomPropTypes);var _LimitsOptions = __webpack_require__(256);var _LimitsOptions2 = _interopRequireDefault(_LimitsOptions);var _StackedNoteInput = __webpack_require__(253);var _StackedNoteInput2 = _interopRequireDefault(_StackedNoteInput);var _SettingsTable = __webpack_require__(258);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}
	
	
	
	
	
	
	/*
	 * A settings widget to configure the 'treeViewOptions' state branch.
	 * This can configure either the finite tree or the infinite tree,
	 * depending on the values of 'isInfinite'.
	 */var 
	ViewOptions = (function (_Component) {_inherits(ViewOptions, _Component);
	
	    function ViewOptions() {_classCallCheck(this, ViewOptions);var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ViewOptions).call(this));
	
	        _this.state = { 
	            showLimits: true, 
	            showTreeConfiguration: true, 
	            showDisplay: true, 
	            showAdvanced: false };return _this;}_createClass(ViewOptions, [{ key: 'render', value: function render() 
	
	
	
	        {var _this2 = this;var _props = 
	            this.props;var infinite = _props.infinite;var values = _props.values;var handlers = _props.handlers;
	
	            // Toggle one of the 'showFoo' state fields.
	            var ToggleButton = function ToggleButton(_ref) {var field = _ref.field;var label = _ref.label;
	                var value = _this2.state[field];
	                var handler = function handler() {return _this2.setState(_defineProperty({}, field, !value));};
	                var btnClass = value ? "btn-primary" : "btn-default";
	                return _react2.default.createElement('button', { 
	                    className: 'btn ' + btnClass, 
	                    onClick: handler }, 
	                label);};
	
	            ToggleButton.propTypes = { 
	                field: _react.PropTypes.oneOf(Object.keys(this.state)).isRequired, 
	                label: _react.PropTypes.node.isRequired };
	
	
	            return _react2.default.createElement('div', null, 
	            _react2.default.createElement('div', { className: 'btn-group', style: { marginBottom: 20 } }, 
	            _react2.default.createElement('span', { className: 'btn btn-default', disabled: true }, 
	            _react2.default.createElement('strong', null, 'Show:')), 
	
	            _react2.default.createElement(ToggleButton, { field: 'showLimits', label: 'Interval limits' }), 
	            infinite && _react2.default.createElement(ToggleButton, { 
	                field: 'showTreeConfiguration', 
	                label: 'Tree configuration' }), 
	
	            _react2.default.createElement(ToggleButton, { field: 'showDisplay', label: 'Display settings' }), 
	            infinite && _react2.default.createElement(ToggleButton, { 
	                field: 'showAdvanced', 
	                label: 'Advanced settings' })), 
	
	            this.state.showLimits && _react2.default.createElement(_LimitsOptions2.default, { 
	                values: values.limits, 
	                handlers: { 
	                    onSetLimitValue: handlers.onSetLimitValue, 
	                    onSetLimitEnabled: handlers.onSetLimitEnabled } }), 
	
	
	            infinite && this.state.showTreeConfiguration && _react2.default.createElement(_SettingsTable.Table, null, 
	            _react2.default.createElement(_SettingsTable.Row, null, 
	            _react2.default.createElement(_SettingsTable.LabelCell, { htmlFor: 'treeNumber' }, 'Tree number'), 
	            _react2.default.createElement(_SettingsTable.LabelCell, { htmlFor: 'rootBass' }, 'Root chord bass')), 
	
	            _react2.default.createElement(_SettingsTable.Row, null, 
	            _react2.default.createElement(_SettingsTable.Cell, null, 
	            _react2.default.createElement('input', { 
	                id: 'treeNumber', 
	                type: 'number', 
	                className: 'form-control'
	                //
	                , min: 0, 
	                max: 12, 
	                value: values.treeNumber, 
	                onChange: function onChange(e) {return handlers.onSetTreeNumber(
	                    parseInt(e.target.value, 10));} })), 
	
	
	            _react2.default.createElement(_SettingsTable.Cell, null, 
	            _react2.default.createElement(_StackedNoteInput2.default, { 
	                value: [values.rootBass], 
	                onChange: function onChange(arr) {return handlers.onSetRootBass(arr[0]);}, 
	                className: 'form-control', 
	                viewOptions: values, 
	                inputProps: { className: "form-control", size: 3 } })))), 
	
	
	
	
	            this.state.showDisplay && _react2.default.createElement(_SettingsTable.Table, null, 
	            _react2.default.createElement(_SettingsTable.Row, null, 
	            !infinite && 
	            _react2.default.createElement(_SettingsTable.LabelCell, { htmlFor: 'depth' }, 'Tree depth'), 
	            _react2.default.createElement(_SettingsTable.LabelCell, { htmlFor: 'showRoots' }, 'Show roots?'), 
	            _react2.default.createElement(_SettingsTable.LabelCell, { htmlFor: 'showOctaves' }, 'Show octaves?'), 
	            _react2.default.createElement(_SettingsTable.LabelCell, { htmlFor: 'fillWindow' }, 'Fill window?'), 
	            infinite && _react2.default.createElement(_SettingsTable.LabelCell, { 
	                htmlFor: 'alwaysEngrave' }, 'Engrave notes')), 
	
	
	            _react2.default.createElement(_SettingsTable.Row, null, 
	            !infinite && _react2.default.createElement(_SettingsTable.Cell, null, 
	            _react2.default.createElement('input', { 
	                type: 'range', 
	                id: 'depth'
	                //
	                , min: 1, 
	                max: 8, 
	                value: values.levels, 
	                onChange: function onChange(e) {return handlers.onSetLevels(
	                    e.target.valueAsNumber);} })), 
	
	
	            _react2.default.createElement(_SettingsTable.CheckboxCell, { 
	                id: 'showRoots', 
	                checked: values.showRoots, 
	                onChange: handlers.onSetShowRoots, 
	                labelYes: 'Shown', 
	                labelNo: 'Hidden' }), 
	
	            _react2.default.createElement(_SettingsTable.CheckboxCell, { 
	                id: 'showOctaves', 
	                checked: values.showOctaves, 
	                onChange: handlers.onSetShowOctaves, 
	                labelYes: 'Shown', 
	                labelNo: 'Hidden' }), 
	
	            _react2.default.createElement(_SettingsTable.CheckboxCell, { 
	                id: 'fillWindow', 
	                checked: values.wide, 
	                onChange: handlers.onSetWide, 
	                labelYes: 'Wide', 
	                labelNo: 'Inline' }), 
	
	            infinite && _react2.default.createElement(_SettingsTable.CheckboxCell, { 
	                id: 'alwaysEngrave', 
	                checked: values.alwaysEngrave, 
	                onChange: handlers.onSetAlwaysEngrave, 
	                labelYes: 'Always', 
	                labelNo: 'Hover only' }))), 
	
	
	
	            infinite && this.state.showDisplay && _react2.default.createElement(_SettingsTable.Table, null, 
	            _react2.default.createElement(_SettingsTable.Row, null, 
	            _react2.default.createElement(_SettingsTable.LabelCell, { htmlFor: 'depth' }, 'Levels shown'), 
	            _react2.default.createElement(_SettingsTable.LabelCell, { htmlFor: 'height' }, 'Height')), 
	
	            _react2.default.createElement(_SettingsTable.Row, null, 
	            _react2.default.createElement(_SettingsTable.Cell, null, 
	            _react2.default.createElement('input', { 
	                type: 'range', 
	                id: 'depth'
	                //
	                , min: 1, 
	                max: 9, 
	                step: 0.05, 
	                value: values.infiniteLevels, 
	                onChange: function onChange(e) {return handlers.onSetInfiniteLevels(
	                    e.target.valueAsNumber);} })), 
	
	
	            _react2.default.createElement(_SettingsTable.Cell, null, 
	            _react2.default.createElement('input', { 
	                type: 'range', 
	                id: 'height'
	                //
	                , min: 500, 
	                max: 1000, 
	                value: values.infiniteHeight, 
	                onChange: function onChange(e) {return handlers.onSetInfiniteHeight(
	                    e.target.valueAsNumber);} })))), 
	
	
	
	
	            infinite && this.state.showAdvanced && _react2.default.createElement(_SettingsTable.Table, null, 
	            _react2.default.createElement(_SettingsTable.Row, null, 
	            _react2.default.createElement(_SettingsTable.LabelCell, { htmlFor: 'highQuality' }, 'Display quality'), 
	
	
	            _react2.default.createElement(_SettingsTable.LabelCell, { 
	                htmlFor: 'rainbowFactor', 
	                'aria-label': 'Rainbow factor' }, 
	
	            (function () {
	                var rainbow = "Rainbow".split('');
	                return rainbow.map(function (chr, idx) {
	                    // Compute a simple rainbow gradient,
	                    // but decrease the lightness near cyan
	                    // because it's hard to see.
	                    var t = idx / rainbow.length;
	                    var hue = t * 360;
	                    var sigma = 0.1;
	                    var crit = 0.5;
	                    var base = 0.5;
	                    var drop = 0.1;
	                    var lit = Math.abs(t - crit) > sigma ? 
	                    base : 
	                    base - drop * Math.exp(1 - 1 / (
	                    1 - Math.pow((t - crit) / sigma, 2)));
	                    var hsl = 'hsl(' + hue + ', 50%, ' + lit * 100 + '%)';
	                    return _react2.default.createElement('span', { 
	                        style: { color: hsl }, 
	                        key: idx }, 
	                    chr);});})(), ' factor')), 
	
	
	
	
	            _react2.default.createElement(_SettingsTable.Row, null, 
	            _react2.default.createElement(_SettingsTable.CheckboxCell, { 
	                id: 'highQuality', 
	                checked: values.highQuality, 
	                onChange: handlers.onSetHighQuality, 
	                labelYes: 'Pretty', 
	                labelNo: 'Fast' }), 
	
	            _react2.default.createElement(_SettingsTable.Cell, null, 
	            _react2.default.createElement('input', { 
	                type: 'range', 
	                id: 'rainbowFactor'
	                //
	                , min: 0, 
	                max: 1, 
	                step: 0.05, 
	                value: values.rainbowFactor, 
	                onChange: function onChange(e) {return handlers.onSetRainbowFactor(
	                    e.target.valueAsNumber);} })))));} }]);return ViewOptions;})(_react.Component);exports.default = ViewOptions;
	
	
	
	
	
	
	
	
	ViewOptions.propTypes = { 
	    // false for finite tree, true for infinite tree
	    infinite: _react.PropTypes.bool.isRequired, 
	    values: _CustomPropTypes2.default.viewOptions.isRequired, 
	    handlers: _CustomPropTypes2.default.viewOptionsHandlers.isRequired };

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _CustomPropTypes = __webpack_require__(249);var _CustomPropTypes2 = _interopRequireDefault(_CustomPropTypes);var _LimitInput = __webpack_require__(257);var _LimitInput2 = _interopRequireDefault(_LimitInput);var _SettingsTable = __webpack_require__(258);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}
	
	
	
	
	
	/*
	 * A settings UI for the 'treeViewOptions.limits' state field.
	 */var 
	LimitsOptions = (function (_Component) {_inherits(LimitsOptions, _Component);function LimitsOptions() {_classCallCheck(this, LimitsOptions);return _possibleConstructorReturn(this, Object.getPrototypeOf(LimitsOptions).apply(this, arguments));}_createClass(LimitsOptions, [{ key: 'render', value: function render() 
	
	        {var _props = 
	            this.props;var values = _props.values;var handlers = _props.handlers;
	
	            var limitValue = function limitValue(limit) {return (
	                    function (value) {return handlers.onSetLimitValue(limit, value);});};
	            var limitEnabled = function limitEnabled(limit) {return (
	                    function (enabled) {return handlers.onSetLimitEnabled(limit, enabled);});};
	
	            return _react2.default.createElement(_SettingsTable.Table, null, 
	            _react2.default.createElement(_SettingsTable.Row, null, 
	            _react2.default.createElement(_SettingsTable.LabelCell, { htmlFor: 'minIndividual' }, 'Individual limits'), 
	
	
	            _react2.default.createElement(_SettingsTable.LabelCell, { htmlFor: 'minCombined' }, 'Combined limits')), 
	
	
	
	            _react2.default.createElement(_SettingsTable.Row, null, 
	            _react2.default.createElement(_SettingsTable.Cell, null, 
	            _react2.default.createElement(_LimitInput2.default, { 
	                min: values.minIndividual, 
	                max: values.maxIndividual, 
	                minEnabled: values.minIndividualEnabled, 
	                maxEnabled: values.maxIndividualEnabled, 
	                onSetMin: limitValue("minIndividual"), 
	                onSetMax: limitValue("maxIndividual"), 
	                onSetMinEnabled: limitEnabled("minIndividual"), 
	                onSetMaxEnabled: limitEnabled("maxIndividual"), 
	                minEnabledLabel: 'Minimum individual limit enabled', 
	                maxEnabledLabel: 'Maximum individual limit enabled', 
	                minLabel: 'Minimum individual limit', 
	                maxLabel: 'Maximum individual limit' })), 
	
	
	            _react2.default.createElement(_SettingsTable.Cell, null, 
	            _react2.default.createElement(_LimitInput2.default, { 
	                min: values.minCombined, 
	                max: values.maxCombined, 
	                minEnabled: values.minCombinedEnabled, 
	                maxEnabled: values.maxCombinedEnabled, 
	                onSetMin: limitValue("minCombined"), 
	                onSetMax: limitValue("maxCombined"), 
	                onSetMinEnabled: limitEnabled("minCombined"), 
	                onSetMaxEnabled: limitEnabled("maxCombined"), 
	                minEnabledLabel: 'Minimum combined limit enabled', 
	                maxEnabledLabel: 'Maximum combined limit enabled', 
	                minLabel: 'Minimum combined limit', 
	                maxLabel: 'Maximum combined limit' }))));} }]);return LimitsOptions;})(_react.Component);exports.default = LimitsOptions;
	
	
	
	
	
	
	LimitsOptions.propTypes = { 
	    values: _CustomPropTypes2.default.limits.isRequired, 
	    handlers: _CustomPropTypes2.default.limitsHandlers.isRequired };

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}
	
	/*
	 * A set of four connected controls:
	 * two input fields, to set minimum and maximum values for a limit,
	 * and two checkboxes, to set whether these limits are enforced.
	 */var 
	LimitInput = (function (_Component) {_inherits(LimitInput, _Component);function LimitInput() {_classCallCheck(this, LimitInput);return _possibleConstructorReturn(this, Object.getPrototypeOf(LimitInput).apply(this, arguments));}_createClass(LimitInput, [{ key: "render", value: function render() 
	
	        {var 
	            props = this.props;var 
	            min = props.min;var max = props.max;var minEnabled = props.minEnabled;var maxEnabled = props.maxEnabled;var 
	            onSetMin = props.onSetMin;var onSetMax = props.onSetMax;var onSetMinEnabled = props.onSetMinEnabled;var onSetMaxEnabled = props.onSetMaxEnabled;
	
	            var inputStyle = { 
	                display: "inline-block", 
	                width: "50%", 
	                maxWidth: "5em" };
	
	
	            return _react2.default.createElement("div", { className: "input-group" }, 
	            _react2.default.createElement("span", { className: "input-group-addon" }, 
	            _react2.default.createElement("input", { 
	                type: "checkbox", 
	                "aria-label": this.props.minEnabledLabel, 
	                checked: minEnabled, 
	                onChange: function onChange(e) {return (
	                        onSetMinEnabled(e.target.checked));} })), 
	
	
	            _react2.default.createElement("input", { 
	                style: inputStyle, 
	                disabled: !minEnabled, 
	                type: "number", 
	                min: 0, 
	                className: "form-control", 
	                value: minEnabled ? min : null, 
	                "aria-label": this.props.minLabel, 
	                onChange: function onChange(e) {return onSetMin(e.target.valueAsNumber);} }), 
	
	            _react2.default.createElement("input", { 
	                style: inputStyle, 
	                disabled: !maxEnabled, 
	                type: "number", 
	                min: 0, 
	                className: "form-control", 
	                value: maxEnabled ? max : null, 
	                "aria-label": this.props.maxLabel, 
	                onChange: function onChange(e) {return onSetMax(e.target.valueAsNumber);} }), 
	
	            _react2.default.createElement("span", { className: "input-group-addon" }, 
	            _react2.default.createElement("input", { 
	                type: "checkbox", 
	                "aria-label": this.props.maxEnabledLabel, 
	                checked: maxEnabled, 
	                onChange: function onChange(e) {return (
	                        onSetMaxEnabled(e.target.checked));} })));} }]);return LimitInput;})(_react.Component);exports.default = LimitInput;
	
	
	
	
	
	
	LimitInput.propTypes = { 
	    min: _react.PropTypes.number.isRequired, 
	    max: _react.PropTypes.number.isRequired, 
	    minEnabled: _react.PropTypes.bool.isRequired, 
	    maxEnabled: _react.PropTypes.bool.isRequired, 
	    //
	    onSetMin: _react.PropTypes.func.isRequired, 
	    onSetMax: _react.PropTypes.func.isRequired, 
	    onSetMinEnabled: _react.PropTypes.func.isRequired, 
	    onSetMaxEnabled: _react.PropTypes.func.isRequired, 
	    //
	    minLabel: _react.PropTypes.string.isRequired, 
	    maxLabel: _react.PropTypes.string.isRequired, 
	    minEnabledLabel: _react.PropTypes.string.isRequired, 
	    maxEnabledLabel: _react.PropTypes.string.isRequired };

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });exports.CheckboxCell = exports.LabelCell = exports.Cell = exports.Row = exports.Table = undefined;var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * A set of lightweight utilities to build settings layouts.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * This contains some basic structural components (Table, Row, Cell)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * and a few higher-level Cell abstractions (LabelCell, CheckboxCell).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * Sample usage:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *  import {
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *      Table,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *      Row,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *      Cell,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *      LabelCell,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *      CheckboxCell,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *  } from 'path/to/SettingsTable';
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *  function render() {
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *      return <Table>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *          <Row>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *              <LabelCell htmlFor="capacitance">Flux capacitance</LabelCell>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *              <LabelCell htmlFor="extraPower">Use extra power?</LabelCell>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *          </Row>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *          <Row>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *              <Cell>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *                  <input id="capacitance" {...moreProps} />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *              </Cell>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *              <CheckboxCell
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *                  id="extraPower"
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *                  checked={this.props.extraPower}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *                  onChange={this.props.onSetExtraPower}
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *                  labelYes="Powered up"
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *                  labelNo="Idle"
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *              />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *          </Row>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *      </Table>;
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *  }
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             */
	
	
	/*
	 * Create a component that just throws some extra style on another component.
	 */
	function makeStyledComponent(displayName, extraStyle) {var BaseComponent = arguments.length <= 2 || arguments[2] === undefined ? 'div' : arguments[2];var 
	    StyledComponent = (function (_Component) {_inherits(StyledComponent, _Component);function StyledComponent() {_classCallCheck(this, StyledComponent);return _possibleConstructorReturn(this, Object.getPrototypeOf(StyledComponent).apply(this, arguments));}_createClass(StyledComponent, [{ key: 'render', value: function render() 
	            {
	                var style = _extends({}, 
	                extraStyle, 
	                this.props.style);
	
	
	                var otherProps = _extends({}, this.props);
	                delete otherProps.style;
	                delete otherProps.children;
	
	                return _react2.default.createElement(BaseComponent, _extends({ style: style }, otherProps), 
	                this.props.children);} }]);return StyledComponent;})(_react.Component);
	
	
	
	    StyledComponent.displayName = displayName;
	    StyledComponent.propTypes = { 
	        children: _react.PropTypes.node.isRequired, 
	        style: _react.PropTypes.object };
	
	    StyledComponent.defaultProps = { 
	        style: {} };
	
	    return StyledComponent;}
	
	
	var Table = exports.Table = makeStyledComponent('Table', { 
	    display: "table", 
	    marginBottom: 10 });
	
	
	var Row = exports.Row = makeStyledComponent('Row', { 
	    display: "table-row" });
	
	
	var cellStyle = { 
	    display: "table-cell", 
	    verticalAlign: "middle", 
	    paddingBottom: 5, 
	    //
	    // marginRight doesn't work on table cells,
	    // and we only want horizontal spacing
	    // so we can't use borderSpacing on the table div.
	    // This should do.
	    paddingRight: 20 };
	
	var Cell = exports.Cell = makeStyledComponent('Cell', cellStyle);
	var LabelCell = exports.LabelCell = makeStyledComponent('LabelCell', cellStyle, 'label');
	
	/*
	 * A cell with a checkbox and a label for that checkbox.
	 * The label text can change depending on the checked state of the box.
	 */var 
	CheckboxCell = exports.CheckboxCell = (function (_Component2) {_inherits(CheckboxCell, _Component2);function CheckboxCell() {_classCallCheck(this, CheckboxCell);return _possibleConstructorReturn(this, Object.getPrototypeOf(CheckboxCell).apply(this, arguments));}_createClass(CheckboxCell, [{ key: 'render', value: function render() 
	
	        {var _props = 
	            this.props;var id = _props.id;var checked = _props.checked;var _onChange = _props.onChange;var labelYes = _props.labelYes;var labelNo = _props.labelNo;
	            return _react2.default.createElement(Cell, { className: 'checkbox' }, 
	            _react2.default.createElement('input', { 
	                type: 'checkbox', 
	                id: id, 
	                checked: checked, 
	                onChange: function onChange(e) {return _onChange(e.target.checked);}, 
	                style: { marginLeft: 0, marginRight: 20 } }), 
	
	            _react2.default.createElement('label', { 
	                htmlFor: id, 
	                style: { 
	                    userSelect: "none", 
	                    WebkitUserSelect: "none", 
	                    color: "#737373" } }, 
	
	
	            checked ? labelYes : labelNo));} }]);return CheckboxCell;})(_react.Component);
	
	
	
	
	
	CheckboxCell.propTypes = { 
	    id: _react.PropTypes.string.isRequired, // HTML id for the checkbox itself
	    checked: _react.PropTypes.bool.isRequired, 
	    onChange: _react.PropTypes.func.isRequired, // boolean => void
	    labelYes: _react.PropTypes.node.isRequired, // probably a string
	    labelNo: _react.PropTypes.node.isRequired };

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _reactRedux = __webpack_require__(169);var _Actions = __webpack_require__(187);var 
	
	
	Actions = _interopRequireWildcard(_Actions);var _HarmonicSeries = __webpack_require__(184);var _Page = __webpack_require__(236);var _Page2 = _interopRequireDefault(_Page);var _InfiniteTrichordTree = __webpack_require__(260);var _InfiniteTrichordTree2 = _interopRequireDefault(_InfiniteTrichordTree);var _RationalizerSettings = __webpack_require__(245);var _RationalizerSettings2 = _interopRequireDefault(_RationalizerSettings);var _ViewOptions = __webpack_require__(255);var _ViewOptions2 = _interopRequireDefault(_ViewOptions);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var 
	
	
	
	
	
	
	
	
	InfiniteTreeExplorer = (function (_Component) {_inherits(InfiniteTreeExplorer, _Component);
	
	    function InfiniteTreeExplorer() {_classCallCheck(this, InfiniteTreeExplorer);var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(InfiniteTreeExplorer).call(this));
	
	        _this.state = { 
	            rootChord: [0, 4, 7] };return _this;}
	
	
	
	    /* eslint-disable react/prop-types */_createClass(InfiniteTreeExplorer, [{ key: 'render', value: function render() 
	        {
	            return _react2.default.createElement(_Page2.default, { path: 'infinite-tree' }, 
	            _react2.default.createElement('h1', null, 'Infinite chord tree explorer'), 
	
	
	            _react2.default.createElement(_ViewOptions2.default, { 
	                infinite: true, 
	                values: this.props.treeViewOptions, 
	                handlers: this.props.viewOptionsHandlers }), 
	
	            _react2.default.createElement(_InfiniteTrichordTree2.default, { 
	                rationalizer: (0, _HarmonicSeries.extendRationalizer)(this.props.acousticRatios), 
	                viewOptions: this.props.treeViewOptions }), 
	
	            this.props.rootsVisible && 
	            _react2.default.createElement(_RationalizerSettings2.default, { 
	                values: this.props.acousticRatios, 
	                onChangeValue: this.props.onSetAcousticRatio }));}
	
	
	
	        /* eslint-enable */ }]);return InfiniteTreeExplorer;})(_react.Component);
	
	
	
	function mapStateToProps(state) {
	    return { 
	        acousticRatios: state.acousticRatios, 
	        rootsVisible: state.treeViewOptions.showRoots, 
	        treeViewOptions: state.treeViewOptions };}
	
	
	
	function mapDispatchToProps(dispatch) {
	    return { 
	        onSetAcousticRatio: function onSetAcousticRatio(index, ratio) {return dispatch(
	            Actions.setAcousticRatio(index, ratio));}, 
	        viewOptionsHandlers: { 
	            onSetLevels: function onSetLevels(levels) {return dispatch(Actions.setTreeLevels(levels));}, 
	            onSetInfiniteLevels: function onSetInfiniteLevels(levels) {return dispatch(
	                Actions.setInfiniteTreeLevels(levels));}, 
	            onSetInfiniteHeight: function onSetInfiniteHeight(height) {return dispatch(
	                Actions.setInfiniteTreeHeight(height));}, 
	            onSetShowRoots: function onSetShowRoots(showRoots) {return dispatch(
	                Actions.setTreeShowRoots(showRoots));}, 
	            onSetShowOctaves: function onSetShowOctaves(showOctaves) {return dispatch(
	                Actions.setTreeShowOctaves(showOctaves));}, 
	            onSetWide: function onSetWide(wide) {return dispatch(Actions.setTreeWide(wide));}, 
	            onSetTreeNumber: function onSetTreeNumber(treeNumber) {return dispatch(
	                Actions.setTreeTreeNumber(treeNumber));}, 
	            onSetRootBass: function onSetRootBass(rootBass) {return dispatch(
	                Actions.setTreeRootBass(rootBass));}, 
	            onSetHighQuality: function onSetHighQuality(highQuality) {return dispatch(
	                Actions.setTreeHighQuality(highQuality));}, 
	            onSetRainbowFactor: function onSetRainbowFactor(rainbowFactor) {return dispatch(
	                Actions.setTreeRainbowFactor(rainbowFactor));}, 
	            onSetAlwaysEngrave: function onSetAlwaysEngrave(alwaysEngrave) {return dispatch(
	                Actions.setTreeAlwaysEngrave(alwaysEngrave));}, 
	            onSetLimitValue: function onSetLimitValue(limit, value) {return dispatch(
	                Actions.setTreeLimitValue(limit, value));}, 
	            onSetLimitEnabled: function onSetLimitEnabled(limit, enabled) {return dispatch(
	                Actions.setTreeLimitEnabled(limit, enabled));} } };}
	
	
	
	
	var connector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps);exports.default = 
	connector(InfiniteTreeExplorer);

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _CustomPropTypes = __webpack_require__(249);var _CustomPropTypes2 = _interopRequireDefault(_CustomPropTypes);var _InfiniteCanvas = __webpack_require__(261);var _InfiniteCanvas2 = _interopRequireDefault(_InfiniteCanvas);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var 
	
	
	
	
	InfiniteTrichordTree = (function (_Component) {_inherits(InfiniteTrichordTree, _Component);function InfiniteTrichordTree() {_classCallCheck(this, InfiniteTrichordTree);return _possibleConstructorReturn(this, Object.getPrototypeOf(InfiniteTrichordTree).apply(this, arguments));}_createClass(InfiniteTrichordTree, [{ key: 'render', value: function render() 
	
	        {
	            var widePadding = 20;
	            var wideStyle = this.props.viewOptions.wide ? { 
	                position: "relative", 
	                width: 'calc(100vw - ' + 2 * widePadding + 'px)', 
	                left: 'calc(-50vw + ' + widePadding + 'px + 50%)' } : 
	            {};
	
	            return _react2.default.createElement('div', { style: _extends({}, wideStyle, { marginBottom: 20 }) }, 
	            _react2.default.createElement(_InfiniteCanvas2.default, { 
	                height: 800, 
	                viewOptions: this.props.viewOptions, 
	                rationalizer: this.props.rationalizer }));} }]);return InfiniteTrichordTree;})(_react.Component);exports.default = InfiniteTrichordTree;
	
	
	
	
	
	InfiniteTrichordTree.propTypes = { 
	    viewOptions: _CustomPropTypes2.default.viewOptions.isRequired, 
	    rationalizer: _react.PropTypes.func.isRequired };

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _createClass = (function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};})();Object.defineProperty(exports, "__esModule", { value: true });var _react = __webpack_require__(2);var _react2 = _interopRequireDefault(_react);var _CustomPropTypes = __webpack_require__(249);var _CustomPropTypes2 = _interopRequireDefault(_CustomPropTypes);var _vexflow = __webpack_require__(241);var _vexflow2 = _interopRequireDefault(_vexflow);var _HarmonicSeries = __webpack_require__(184);var _TreeSpace = __webpack_require__(262);var _VexFlowUtils = __webpack_require__(242);var _DisplayUtils = __webpack_require__(239);var _CanvasCore = __webpack_require__(263);var 
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	CanvasCore = _interopRequireWildcard(_CanvasCore);var _CanvasUIAdapter = __webpack_require__(264);var 
	CanvasUIAdapter = _interopRequireWildcard(_CanvasUIAdapter);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _toConsumableArray(arr) {if (Array.isArray(arr)) {for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {arr2[i] = arr[i];}return arr2;} else {return Array.from(arr);}}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * A mostly unbounded canvas for rendering trees of trichord outfoldings.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * ("Mostly" unbounded because all Numbers are double-precision floats,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * so we can't go past any rows with more than ~2^53 nodes.)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * Writing a canvas-based component is a different experience
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * than writing most React components,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * because the canvas is immediate-mode
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * so doesn't really fit well into the React declarative flow.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * To make this more declarative---and, importantly, more unit-testable---
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * the main logic is in two other modules:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *   - the 'src/core/CanvasCore' module
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *     comprises a suite of entirely pure functions
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *     that handle the core logic for controlling the canvas position
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *     and determine what should be displayed when; and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *   - the 'src/core/CanvasUIAdapter' module
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *     provides event handlers and lifecycle mixins
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *     that are modularized enough to be unit-tested separately
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *     (although they do require some mocking
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *     to interface with things like 'window.addEventListener').
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * In a nutshell, if you're looking to modify the *behavior*,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * look into one of those modules;
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * if you're looking to alter the *appearance*,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * you should find what you need in `_draw` and friends in this module.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             */var InfiniteCanvas = (function (_Component) {_inherits(InfiniteCanvas, _Component);function InfiniteCanvas() {_classCallCheck(this, InfiniteCanvas);var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(InfiniteCanvas).call(this));_this.state = { uiState: CanvasUIAdapter.initialState() };var getState = function getState() {return _this.state.uiState;};var setState = function setState(uiState) {return _this.setState({ uiState: uiState });};var getCanvas = function getCanvas() {return _this.refs.canvas;};_this._canvasEventHandlers = CanvasUIAdapter.createHandlers(getState, setState);CanvasUIAdapter.mixInLifecycles(_this, CanvasUIAdapter.createLifecycleMixins(getState, setState, getCanvas)); // These let us get properties from the UI state
	        // without having to know its internal structure.
	        _this._getCoreState = CanvasUIAdapter.getCoreAccessor(getState);_this._getLastMouse = CanvasUIAdapter.getMouseAccessor(getState); // Two functions are memoized for scrolling performance.
	        // These maps are used to cache the results,
	        // and are invalidated on every prop change for simplicity.
	        _this._fastFindChordRootOffsetMemo = new Map();_this._fastPositionToPitchesMemo = new Map();return _this;}_createClass(InfiniteCanvas, [{ key: 'render', value: function render() {
	            return _react2.default.createElement('canvas', _extends({ 
	                ref: 'canvas', 
	                width: 720, 
	                height: this.props.viewOptions.infiniteHeight, 
	                style: { 
	                    boxShadow: '0 0 2px 1px rgba(0, 0, 0, 0.2)', 
	                    borderRadius: 2, 
	                    width: "100%", 
	                    height: this.props.viewOptions.infiniteHeight } }, 
	
	            this._canvasEventHandlers, { 
	                tabIndex: 0 }), 
	
	            _react2.default.createElement('div', { className: 'alert alert-danger' }, 
	            _react2.default.createElement('strong', null, 'Uh oh!'), 
	            " ", 'Looks like your browser doesn\'t support the ', 
	
	            _react2.default.createElement('tt', null, '<canvas>'), ' element. Basically, this means we can\'t show you the infinite tree. Could you try upgrading your browser?'));} }, { key: 'componentDidMount', value: function componentDidMount() 
	
	
	
	
	
	
	        {
	            this._draw();} }, { key: 'componentWillReceiveProps', value: function componentWillReceiveProps() 
	
	
	        {
	            // Some prop changes can invalidate these caches.
	            // We just clear them always for simplicity.
	            this._fastFindChordRootOffsetMemo.clear(); // <= rationalizer
	            this._fastPositionToPitchesMemo.clear(); // <= treeNumber, rootBass
	        } }, { key: 'componentDidUpdate', value: function componentDidUpdate() 
	
	        {
	            this._draw();} }, { key: '_draw', value: function _draw() 
	
	
	        {var _this2 = this;var 
	            canvas = this.refs.canvas;
	            var coreState = this._getCoreState();
	
	            var ctx = canvas.getContext('2d', { alpha: 'false' });
	            ctx.clearRect(0, 0, canvas.width, canvas.height);
	
	            CanvasCore.getRowsInView(coreState).forEach(function (row) {return (
	                    CanvasCore.getColumnsInView(coreState, row).forEach(function (col) {var _CanvasCore$getNodeCa = 
	                        CanvasCore.getNodeCanvasCoordinates(
	                        coreState, row, col);var x = _CanvasCore$getNodeCa.x;var y = _CanvasCore$getNodeCa.y;
	                        // Avoid painting rows that are just out of bounds.
	                        if (y < canvas.height) {
	                            _this2._drawNode(ctx, row, col, x, y);}}));});} }, { key: '_drawNode', value: function _drawNode(
	
	
	
	
	        ctx, row, col, x, y) {var _this3 = this;var 
	            viewOptions = this.props.viewOptions;
	            var notes = this._fastPositionToPitches(row, col);
	            var visible = (0, _DisplayUtils.withinLimits)(notes, this.props.viewOptions.limits);var _formatPitchesAndSemi = 
	            (0, _DisplayUtils.formatPitchesAndSemitones)(
	            notes, viewOptions);var noteNames = _formatPitchesAndSemi.noteNames;var semitoneNames = _formatPitchesAndSemi.semitoneNames;
	
	            // Get smaller as we go further down the tree
	            // so we can fit more nodes in when we need to.
	            var scale = 0.5 + 0.5 * 
	            Math.sqrt(Math.max(0, 1 - y / ctx.canvas.height));
	
	            var lines = [].concat(_toConsumableArray(
	            noteNames.slice().reverse().map(function (x) {return { text: x };})), _toConsumableArray(
	            viewOptions.showRoots ? 
	            [{ 
	                text: (0, _DisplayUtils.formatMaybeRoot)(
	                this._fastFindChordRootOffset(notes), 
	                viewOptions), 
	                root: true }] : 
	
	            []), _toConsumableArray(
	            semitoneNames.slice().reverse().map(function (x) {return { text: x };})));
	
	
	            // Set up fonts now because we have some metrics to handle below.
	            var fontFamily = '"Helvetica Neue",Helvetica,Arial,sans-serif';
	
	            // Unless we're optimizing for display quality,
	            // we round the font size and line height to integers
	            // because it helps immensely with rendering speed.
	            var maybeRound = viewOptions.highQuality ? function (x) {return x;} : Math.round;
	            var fontSize = maybeRound(14 * scale);
	            var lineHeight = maybeRound(1.2 * fontSize);
	            ctx.font = fontSize + 'px ' + fontFamily;
	
	            // Profiling indicates that measureText is a bottleneck,
	            // so this is a little heuristic to avoid calls...
	            var lineWidth = function lineWidth(line) {return (
	                    line.text.length * (line.root ? 1.2 : 1));};
	            var longestLine = ctx.measureText(lines.reduce(function (best, line) {return (
	                    lineWidth(line) > lineWidth(best) ? line : best);}).text).width;
	
	            // Determine the bounds for the enclosing rectangle.
	            var padding = 5;
	            var width = longestLine + 2 * padding;
	            var height = lineHeight * lines.length + 2 * padding;
	
	            // HSV is great! But we have to use HSL :(
	            var satHSV = viewOptions.rainbowFactor * 0.2;
	            var value = 1.0;
	            var baseLight = value * 0.5 * (2 - satHSV);
	            var light = visible ? baseLight : baseLight * 0.2 + 0.8;
	            var sat = satHSV && value * satHSV / (1 - Math.abs(2 * light - 1));
	            var hslString = function hslString(h, s, l) {return 'hsl(' + 
	                h * 360 + ', ' + s * 100 + '%, ' + l * 100 + '%)';};
	            ctx.fillStyle = hslString(row / 16, sat, light);
	            ctx.strokeStyle = hslString(row / 16, sat, visible ? 0.25 : 0.8);
	
	            // Finally, draw and fill the rectangle...
	            ctx.beginPath();
	            this._roundRect(ctx, 
	            Math.round(x - width / 2), 
	            Math.round(y), 
	            Math.round(width), 
	            Math.round(height), 
	            padding);
	            ctx.stroke();
	            ctx.fill();
	
	            // ...then paint the text!
	            ctx.textAlign = "center";
	            ctx.textBaseline = "top";
	            var rootStyle = visible ? "blue" : "#DDF";
	            var nonRootStyle = visible ? "black" : "#DDD";
	            lines.forEach(function (data, index) {
	                ctx.fillStyle = data.root ? rootStyle : nonRootStyle;
	                var boldTag = data.root ? "bold " : "";
	                ctx.font = '' + boldTag + fontSize + 'px ' + fontFamily;
	                ctx.fillText(data.text + "", 
	                Math.round(x), 
	                Math.round(y) + padding + index * lineHeight);});
	
	
	            // Draw the engraving when the node is hovered.
	            var engrave = function engrave() {
	                _this3._drawEngraving(ctx, notes, x, y, width);};
	
	            if (viewOptions.alwaysEngrave) {
	                engrave();} else 
	            {
	                var lastMouse = this._getLastMouse();
	                if (lastMouse) {var 
	                    mouseX = lastMouse.x;var mouseY = lastMouse.y;
	                    var withinX = Math.abs(mouseX - x) <= width / 2;
	                    var withinY = y <= mouseY && mouseY <= y + height;
	                    if (withinX && withinY) {
	                        engrave();}}}}
	
	
	
	
	
	        /*
	         * Given the horizontal center ('cx') and vertical top ('ty') of a box
	         * whose width is 'bw',
	         * engrave the given notes near (but outside) the box
	         * using the provided 2D canvas context.
	         */ }, { key: '_drawEngraving', value: function _drawEngraving(
	        ctx, notes, cx, ty, bw) {
	            var chord = (0, _VexFlowUtils.pitchesToStaveNote)(notes);
	            var chords = [chord];
	
	            var renderer = new _vexflow2.default.Flow.Renderer(ctx.canvas, 
	            _vexflow2.default.Flow.Renderer.Backends.CANVAS);
	            var vexctx = renderer.getContext();
	            var notesWidth = 100;
	            var padding = 5;
	            var stave = new _vexflow2.default.Flow.Stave(
	            cx > ctx.canvas.width / 2 ? 
	            cx - padding - bw / 2 - notesWidth : 
	            cx + padding + bw / 2, 
	            ty - 25, // offset seems to be entirely static
	            notesWidth);
	            stave.addClef("treble").setContext(vexctx).draw();
	            _vexflow2.default.Flow.Formatter.FormatAndDraw(vexctx, stave, chords);}
	
	
	        /*
	         * Assuming a path has been started on the given context,
	         * draw a rounded rectangle with the given top-left corner and dimensions
	         * and the given border-radius.
	         * (The path is not stroked or filled.)
	         */ }, { key: '_roundRect', value: function _roundRect(
	        ctx, x, y, w, h, r) {
	            var p2 = Math.PI / 2;
	            ctx.moveTo(x + r, y);
	            ctx.lineTo(x + w - r, y);
	            ctx.arc(x + w - r, y + r, r, 3 * p2, 0);
	            ctx.lineTo(x + w, y + h - r);
	            ctx.arc(x + w - r, y + h - r, r, 0, p2);
	            ctx.lineTo(x + r, y + h);
	            ctx.arc(x + r, y + h - r, r, p2, 2 * p2);
	            ctx.lineTo(x, y + r);
	            ctx.arc(x + r, y + r, r, 2 * p2, 3 * p2);} }, { key: '_fastFindChordRootOffset', value: function _fastFindChordRootOffset(
	
	
	        notes) {
	            // Ugly, but should work for our case (all integers).
	            var key = notes.join(",");
	            var memo = this._fastFindChordRootOffsetMemo;
	            if (!memo.has(key)) {
	                memo.set(key, (0, _HarmonicSeries.findChordRootOffset)(this.props.rationalizer, notes));}
	
	            return memo.get(key);} }, { key: '_fastPositionToPitches', value: function _fastPositionToPitches(
	
	
	        row, col) {
	            var key = row + ',' + col;
	            var memo = this._fastPositionToPitchesMemo;
	            if (!memo.has(key)) {
	                var notes = (0, _TreeSpace.positionToPitches)(
	                this.props.viewOptions.treeNumber, 
	                row, col, 
	                this.props.viewOptions.rootBass);
	                memo.set(key, notes);}
	
	            return memo.get(key);} }]);return InfiniteCanvas;})(_react.Component);exports.default = InfiniteCanvas;
	
	
	
	InfiniteCanvas.propTypes = { 
	    viewOptions: _CustomPropTypes2.default.viewOptions.isRequired, 
	    rationalizer: _react.PropTypes.func.isRequired };

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });exports.
	
	positionToPath = positionToPath;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	positionToPitches = positionToPitches;var _Folding = __webpack_require__(248);function positionToPath(row, col) {var left = arguments.length <= 2 || arguments[2] === undefined ? 0 : arguments[2];var right = arguments.length <= 3 || arguments[3] === undefined ? 1 : arguments[3];if (0 > col || col >= Math.pow(2, row)) {return null;}var result = Array(row);var remaining = col;for (var index = row - 1; index >= 0; index--) {result[index] = remaining % 2 ? right : left;remaining = Math.floor(remaining / 2);}return result;} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         * Given
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         *   - the root node of the tree (the 'n' in T(n)),
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         *   - the row and column of a node within the tree,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         *   - and the pitch of the bass note in the node at (0, 0),
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         * find the pitches in the chord at the given position.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         * For example, the tree with root chord [5, 7, 9]
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         * is T(2) with a bass of 5.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         * So to find the chord at position (11, 13) within that tree,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         * you could evaluate positionToPitches(2, 11, 13, 5).
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         */function positionToPitches(root, row, col, bass) {var folds = positionToPath(row, col, _Folding.outfoldDown, _Folding.outfoldUp);var bassChord = [0, 1, 2].map(function (n) {return bass + n * root;});return folds && folds.reduce(function (chord, op) {return op(chord);}, bassChord);}exports.default = { positionToPath: positionToPath, positionToPitches: positionToPitches };

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;}; /*
	                                                                                                                                                                                                                                                                      * The purpose of this file is to provide a functional abstraction
	                                                                                                                                                                                                                                                                      * over the necessarily highly imperative implementation
	                                                                                                                                                                                                                                                                      * of the canvas for the infinite tree explorer.
	                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                      * This file handles the positioning logic,
	                                                                                                                                                                                                                                                                      * the mathematics and logic of event handling,
	                                                                                                                                                                                                                                                                      * and the logic of determining what needs to be drawn when,
	                                                                                                                                                                                                                                                                      * so that all the canvas needs to do is actually draw it.
	                                                                                                                                                                                                                                                                      * In a sense, the canvas implementation
	                                                                                                                                                                                                                                                                      * becomes an interpreter for a DSL output by this file.
	                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                      * The two primary coordinate systems used in these calculations are
	                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                      *   - absolute coordinates:
	                                                                                                                                                                                                                                                                      *     the origin is at the top-center of the entire tree,
	                                                                                                                                                                                                                                                                      *     the width of the entire tree is 1.0 unit
	                                                                                                                                                                                                                                                                      *     (so the left edge is at -0.5 and the right edge is at 0.5),
	                                                                                                                                                                                                                                                                      *     and each level is 1.0 unit tall; and
	                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                      *   - canvas coordinates:
	                                                                                                                                                                                                                                                                      *     the origin is at the top-left of the canvas,
	                                                                                                                                                                                                                                                                      *     the width is the canvas width, and the height is the canvas height.
	                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                      * Other ad hoc variations are sometimes used,
	                                                                                                                                                                                                                                                                      * like viewport-relative absolute coordinates
	                                                                                                                                                                                                                                                                      * (the scale of absolute coordinates,
	                                                                                                                                                                                                                                                                      * but the origin is at the top-center of the canvas).
	                                                                                                                                                                                                                                                                      */Object.defineProperty(exports, "__esModule", { value: true });exports.rowPadding = exports.maxSafeRow = undefined;exports.
	
	
	
	
	
	
	
	
	
	initialState = initialState;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	setViewOptions = setViewOptions;exports.
	
	
	
	
	
	
	
	
	
	setCanvasWidth = setCanvasWidth;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	getRowDimensions = getRowDimensions;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	getScalingFactorForHeight = getScalingFactorForHeight;exports.
	
	
	
	
	
	
	getScalingFactor = getScalingFactor;exports.
	
	
	
	
	
	
	
	
	
	
	
	getPanResult = getPanResult;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	performPan = performPan;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	getRowsInView = getRowsInView;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	getColumnsInView = getColumnsInView;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	getNodeCanvasCoordinates = getNodeCanvasCoordinates;var _Utils = __webpack_require__(180); /*
	                                                                                             * We use a lightweight object to keep track of the canvas state over time.
	                                                                                             * This function generates the initial state.
	                                                                                             *
	                                                                                             * You must set the view options to a non-null value
	                                                                                             * before consuming the state.
	                                                                                             */function initialState() {return { canvasWidth: 800, viewOptions: null, // must be set before you try to do anything!
	        //
	        // The 'position' field locates the viewport,
	        // which is anchored with top-center gravity
	        // and described in absolute coordinates.
	        position: { x: 0, y: 0 } };} /*
	                                      * Set the view options, and return the new state.
	                                      */function setViewOptions(state, viewOptions) {return _extends({}, state, { viewOptions: viewOptions });} /*
	                                                                                                                                                 * Set the canvas width, and return the new state.
	                                                                                                                                                 */function setCanvasWidth(state, canvasWidth) {return _extends({}, state, { canvasWidth: canvasWidth });} /*
	                                                                                                                                                                                                                                                            * Return the dimensions, in canvas coordinates, of
	                                                                                                                                                                                                                                                            * the portion of a row that would appear in the viewport.
	                                                                                                                                                                                                                                                            * The rows are evenly distributed across the viewport height.
	                                                                                                                                                                                                                                                            *
	                                                                                                                                                                                                                                                            * The return value has the shape { width: number, height: number },
	                                                                                                                                                                                                                                                            * using canvas coordinates.
	                                                                                                                                                                                                                                                            *
	                                                                                                                                                                                                                                                            * Requires 'viewOptions' to have been set.
	                                                                                                                                                                                                                                                            */function getRowDimensions(state) {var viewOptions = state.viewOptions;return { width: state.canvasWidth, height: viewOptions.infiniteHeight / viewOptions.infiniteLevels };} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                            * We use some exponential factors 2^row when rendering,
	                                                                                                                                                                                                                                                                                                                                                                                                                                            * and bizarre things start happening at really high rows.
	                                                                                                                                                                                                                                                                                                                                                                                                                                            * This function returns the index of the highest row
	                                                                                                                                                                                                                                                                                                                                                                                                                                            * that we think won't produce weird output.
	                                                                                                                                                                                                                                                                                                                                                                                                                                            */var maxSafeRow = exports.maxSafeRow = (function () {// Weirdness seems to kick in as we approach Number.MAX_SAFE_INTEGER,
	    // so we stop just a few before there,
	    // where (empirically) the effects become observable.
	    var bits = Math.floor(Math.log2(Number.MAX_SAFE_INTEGER));return bits - 2;})(); /*
	                                                                                     * As we move down in the viewport, we change the horizontal scale.
	                                                                                     * You can interpret this in two ways:
	                                                                                     * either we compress the viewport by a certain factor
	                                                                                     * or we expand the nodes themselves by a certain factor.
	                                                                                     * This method returns that scaling factor.
	                                                                                     *
	                                                                                     * To be a bit more precise, the result of this method is the number 'c'
	                                                                                     * such that the viewport width, in absolute coordinates, is 1 / c.
	                                                                                     *
	                                                                                     * The argument should be the 'y' coordinate of the current position,
	                                                                                     * in absolute coordinates.
	                                                                                     * If you have a state object, see 'getScalingFactor'.
	                                                                                     */function getScalingFactorForHeight(y) {return Math.pow(2, y);} /*
	                                                                                                                                                       * Like 'getScalingFactorForHeight', but uses the state's 'y' position.
	                                                                                                                                                       */function getScalingFactor(state) {return getScalingFactorForHeight(state.position.y);} /*
	                                                                                                                                                                                                                                                 * Given a displacement in canvas coordinates,
	                                                                                                                                                                                                                                                 * compute the new stateful position in absolute coordinates.
	                                                                                                                                                                                                                                                 *
	                                                                                                                                                                                                                                                 * The displacement argument should have shape {x: number, y: number}.
	                                                                                                                                                                                                                                                 *
	                                                                                                                                                                                                                                                 * The return value is the new value for the 'position' field.
	                                                                                                                                                                                                                                                 */function getPanResult(state, canvasDeltaXY) {var _getRowDimensions = getRowDimensions(state);var rowWidth = _getRowDimensions.width;var rowHeight = _getRowDimensions.height;var newY = state.position.y + canvasDeltaXY.y / rowHeight;var yMin = 0;var yPaddingBottom = 2; // don't chop off the bottom few rows
	    var yMax = maxSafeRow - state.viewOptions.infiniteLevels + yPaddingBottom;var finalY = Math.max(yMin, Math.min(newY, yMax)); // The value of 'perceivedWidth' represents
	    // the width of the entire row (not just what's inside the viewport)
	    // in canvas coordinates.
	    // This allows us to determine
	    // the proportion of the absolute width
	    // through which the user wants to scroll,
	    // which is the delta in absolute coordinates
	    // (which is what we want, because 'position' is in absolute coordinates).
	    var scalingFactor = getScalingFactorForHeight(finalY);var perceivedWidth = rowWidth * scalingFactor;var newX = state.position.x + canvasDeltaXY.x / perceivedWidth;var rangeX = 1 - 1 / scalingFactor;var minX = -rangeX / 2;var maxX = +rangeX / 2;var finalX = Math.max(minX, Math.min(newX, maxX));return { x: finalX, y: finalY };} /*
	                                                                                                                                                                                                                                                                                                                                             * Get the new position due to the provided pan (see 'getPanResult')
	                                                                                                                                                                                                                                                                                                                                             * and apply it to the state, returning the new state.
	                                                                                                                                                                                                                                                                                                                                             */function performPan(state, canvasDeltaXY) {return _extends({}, state, { position: getPanResult(state, canvasDeltaXY) });} /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Determine which rows should be painted in the current viewport.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * This includes all rows with any node completely within bounds,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * and up to one row direct above those rows
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * so that nodes entering the current viewport can scroll into view smoothly.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * The return value is an array of consecutive integers,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * representing the indices of the rows to paint;
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * the first row is row 0.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */function getRowsInView(state) {var firstFullyVisibleRow = Math.ceil(state.position.y);var firstPartiallyVisibleRowUnclamped = firstFullyVisibleRow - 1;var firstRow = Math.max(0, firstPartiallyVisibleRowUnclamped);var lastRowUnclamped = Math.floor(state.position.y + state.viewOptions.infiniteLevels);var lastRow = Math.min(maxSafeRow, lastRowUnclamped);return (0, _Utils.range)(firstRow, lastRow + 1); // inclusive
	} /*
	   * Determine which columns of a given row
	   * should be painted in the current viewport.
	   * This includes all columns whose nodes are completely within bounds,
	   * and up to one column directly before and after those columns
	   * so that nodes entering the current viewport can scroll into view smoothly.
	   *
	   * The return value is an array of consecutive integers,
	   * representing the indices of the columns to paint;
	   * the first column is column 0.
	   */function getColumnsInView(state, row) {var scalingFactor = getScalingFactor(state); // Determine the left and right viewport bounds in [0, 1]-coordinates.
	    var viewportXc = state.position.x + 0.5;var viewportWidth = 1 / scalingFactor;var viewportXl = viewportXc - viewportWidth / 2;var viewportXr = viewportXc + viewportWidth / 2;var nodesInRow = Math.pow(2, row);var nominalMin = Math.ceil(nodesInRow * viewportXl - 0.5);var nominalMax = Math.floor(nodesInRow * viewportXr - 0.5);var expandedMin = Math.max(0, nominalMin - 1);var expandedMax = Math.min(nodesInRow - 1, nominalMax + 1);return (0, _Utils.range)(expandedMin, expandedMax + 1); // inclusive
	} // The padding between the top of each row
	// and the top of the nodes within that row.
	var rowPadding = exports.rowPadding = 20; /*
	                                           * Get the canvas coordinates of the node in the given row and column.
	                                           */function getNodeCanvasCoordinates(state, row, column) {var _getRowDimensions2 = getRowDimensions(state);var rowWidth = _getRowDimensions2.width;var rowHeight = _getRowDimensions2.height;var absoluteY = row;var viewportRelativeY = absoluteY - state.position.y;var canvasY = viewportRelativeY * rowHeight + rowPadding; // We compute the 'x' position in terms of
	    // the offset from the centerline (OFC).
	    var nodesInRow = Math.pow(2, row);var absoluteX = (column + 0.5) / nodesInRow - 0.5;var viewportRelativeOFC = absoluteX - state.position.x;var scaledOFC = viewportRelativeOFC * getScalingFactor(state);var canvasOFC = scaledOFC * rowWidth;var canvasX = canvasOFC + rowWidth / 2;return { x: canvasX, y: canvasY };}

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};Object.defineProperty(exports, "__esModule", { value: true });exports.
	
	
	
	
	
	
	initialState = initialState;exports.
	
	
	
	
	
	
	
	
	
	
	
	getCoreAccessor = getCoreAccessor;exports.
	
	
	
	getMouseAccessor = getMouseAccessor;exports.
	
	
	
	createHandlers = createHandlers;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	createLifecycleMixins = createLifecycleMixins;exports.
	
	
	
	
	
	
	
	
	
	
	
	
	
	mixInLifecycles = mixInLifecycles;var _CanvasCore = __webpack_require__(263);var CanvasCore = _interopRequireWildcard(_CanvasCore);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _toConsumableArray(arr) {if (Array.isArray(arr)) {for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {arr2[i] = arr[i];}return arr2;} else {return Array.from(arr);}} ///////////////////////////////////////////////////////////////////////////////
	// Middleware creators
	///////////////////////////////////////////////////////////////////////////////
	function initialState() {var coreState = arguments.length <= 0 || arguments[0] === undefined ? CanvasCore.initialState() : arguments[0];return { lastMouse: null, mouseDown: false, keysDown: [], coreState: coreState, //
	        resizeListenerFunction: null, keyIntervalId: null };}function getCoreAccessor(getState) {return function () {return getState().coreState;};}function getMouseAccessor(getState) {return function () {return getState().lastMouse;};}function createHandlers(getState, setState) {var _this = this;var link = function link(fn) {return fn.bind(_this, getState, setState);};return { onMouseDown: link(handleMouseDown), onMouseMove: link(handleMouseMove), onWheel: link(handleWheel), onMouseUp: link(handleMouseUp), onMouseLeave: link(handleMouseLeave), onKeyDown: link(handleKeyDown), onKeyUp: link(handleKeyUp), onBlur: link(handleBlur) };}function createLifecycleMixins(getState, setState, getCanvas) {var link = function link(fn) {return function linkedLifecycleMixin() {for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];} // note: not bound to lexical 'this' (which is probably undefined here)
	            return fn.apply(this, [getState, setState, getCanvas].concat(args));};};return { componentWillMount: link(componentWillMount), componentDidMount: link(componentDidMount), componentWillReceiveProps: link(componentWillReceiveProps), componentDidUpdate: link(componentDidUpdate), componentWillUnmount: link(componentWillUnmount) };}function mixInLifecycles(target, mixins) {Object.keys(mixins).forEach(function (name) {var mixedInFunction = mixins[name];var existing = target[name];if (typeof existing === 'function') {target[name] = function mixedInLifecycleMethod() {for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {args[_key2] = arguments[_key2];}
	                mixedInFunction.apply(this, args);
	                return existing.apply(this, args);};} else 
	
	        {
	            target[name] = mixedInFunction;}});}
	
	
	
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Event handlers
	///////////////////////////////////////////////////////////////////////////////
	
	function handleMouseDown(getState, setState) {
	    setState(_extends({}, 
	    getState(), { 
	        mouseDown: true }));}
	
	
	
	function handleMouseMove(getState, setState, e) {
	    var state = getState();
	    var oldMouse = state.lastMouse;
	    var newMouse = getRelativeMousePosition(e);
	    setState(_extends({}, 
	    state, { 
	        lastMouse: newMouse, 
	        coreState: !state.mouseDown ? 
	        state.coreState : 
	        CanvasCore.performPan(state.coreState, { 
	            x: -(newMouse.x - oldMouse.x), 
	            y: -(newMouse.y - oldMouse.y) }) }));}
	
	
	
	
	function handleWheel(getState, setState, e) {
	    // If the user is just scrolling down the page
	    // and their mouse happens to pass over the canvas,
	    // we don't want to capture that scroll event.
	    // Only scroll when we have focus.
	    if (document.activeElement !== e.target) {
	        return;}
	
	    e.preventDefault();
	
	    var state = getState();
	    var newCoreState = CanvasCore.performPan(
	    state.coreState, { x: e.deltaX, y: e.deltaY });
	    setState(_extends({}, state, { coreState: newCoreState }));}
	
	
	function handleMouseUp(getState, setState) {
	    setState(_extends({}, 
	    getState(), { 
	        mouseDown: false }));}
	
	
	
	function handleMouseLeave(getState, setState) {
	    setState(_extends({}, 
	    getState(), { 
	        mouseDown: false }));}
	
	
	
	function handleKeyDown(getState, setState, e) {
	    var state = getState();
	    if (e.repeat) {
	        return;}
	
	    if (getMotionDirection(e.which) === null) {
	        return;}
	
	    if (state.keysDown.indexOf(e.which) !== -1) {
	        // This can happen if you press the key,
	        // then click and maybe drag a bit while still holding the key,
	        // then release the mouse while holding the key.
	        return;}
	
	    setState(_extends({}, 
	    state, { 
	        keysDown: [].concat(_toConsumableArray(state.keysDown), [e.which]) }));}
	
	
	
	function handleKeyUp(getState, setState, e) {
	    var state = getState();
	    var keysDown = state.keysDown.filter(function (x) {return x !== e.which;});
	    setState(_extends({}, state, { keysDown: keysDown }));}
	
	
	function handleBlur(getState, setState) {
	    setState(_extends({}, 
	    getState(), { 
	        keysDown: [] }));}
	
	
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Lifecycle mixins
	///////////////////////////////////////////////////////////////////////////////
	
	function componentWillMount(getState, setState) {
	    var state = getState();
	    var coreState = CanvasCore.setViewOptions(
	    state.coreState, 
	    this.props.viewOptions);
	    setState(_extends({}, state, { coreState: coreState }));}
	
	
	function componentDidMount(getState, setState, getCanvas) {
	    var resizeListenerFunction = function resizeListenerFunction() {return (
	            setState(resizeCanvas(getCanvas(), getState())));};
	    window.addEventListener('resize', resizeListenerFunction);
	
	    var keyIntervalId = window.setInterval(
	    function () {return processKeyTick(getState, setState, getCanvas);}, 
	    1000 / 60);
	
	    setState(_extends({}, 
	    resizeCanvas(getCanvas(), getState()), { 
	        resizeListenerFunction: resizeListenerFunction, 
	        keyIntervalId: keyIntervalId }));}
	
	
	
	function componentWillReceiveProps(getState, setState, getCanvas, newProps) {
	    if (newProps.viewOptions !== this.props.viewOptions) {
	        var state = getState();
	        var coreState = CanvasCore.setViewOptions(
	        state.coreState, 
	        newProps.viewOptions);
	        setState(_extends({}, state, { coreState: coreState }));}}
	
	
	
	function componentDidUpdate(getState, setState, getCanvas) {
	    var state = getState();
	    var newState = resizeCanvas(getCanvas(), state);
	    if (newState !== state) {
	        setState(newState);}}
	
	
	
	function componentWillUnmount(getState) {
	    var state = getState();
	    window.removeEventListener('resize', state.resizeListenerFunction);
	    window.clearInterval(state.keyIntervalId);}
	
	
	
	///////////////////////////////////////////////////////////////////////////////
	// Helper functions
	///////////////////////////////////////////////////////////////////////////////
	
	/*
	 * Given a MouseEvent (or SyntheticMouseEvent) object,
	 * determine the coordinates of the mouse pointer
	 * with respect to the top-left corner of its target.
	 */
	function getRelativeMousePosition(e) {var _e$target$getBounding = 
	    e.target.getBoundingClientRect();var baseX = _e$target$getBounding.left;var baseY = _e$target$getBounding.top;
	    return { 
	        x: e.clientX - baseX, 
	        y: e.clientY - baseY };}
	
	
	
	/*
	 * Given a numeric key code,
	 * determine whether the associated key represents a movement action.
	 *
	 * If it does, return an object with shape { x: number, y: number },
	 * where each number is either -1, 0, or +1
	 * and indicates the presence and direction of movement along an axis.
	 *
	 * If it doesn't, return null.
	 */
	function getMotionDirection(which) {
	    switch (which) {
	        case 0x41: // A
	        case 0x25: // Left
	            return { x: -1, y: 0 };
	        case 0x57: // W
	        case 0x26: // Up
	            return { x: 0, y: -1 };
	        case 0x44: // D
	        case 0x27: // Right
	            return { x: +1, y: 0 };
	        case 0x53: // S
	        case 0x28: // Down
	            return { x: 0, y: +1 };
	        default:
	            return null;}}
	
	
	
	/*
	 * Note: this is a confusingly semi-pure function.
	 * It's impure in that it modifies the <canvas> width in the DOM,
	 * but it's pure in that it doesn't call 'setState';
	 * this is needed to deal with React's batched events.
	 * Instead, it will return the new state (in addition to mutating the DOM).
	 */
	function resizeCanvas(canvas, state) {
	    var widthString = window.getComputedStyle(canvas).width;
	    var width = parseInt(widthString.match(/(\d+)px/)[1], 10);
	    if (width !== canvas.width) {
	        canvas.width = width;
	        var coreState = CanvasCore.setCanvasWidth(state.coreState, width);
	        return _extends({}, state, { coreState: coreState });} else 
	    {
	        return state;}}
	
	
	
	function processKeyTick(getState, setState, getCanvas) {
	    var state = getState();
	    if (state.mouseDown) {
	        return;}
	
	    var keys = state.keysDown;
	    if (keys.length === 0) {
	        // Not strictly necessary because of the 'clampedDelta' check below,
	        // but maybe a bit helpful in avoiding a few CPU cycles.
	        return;}
	
	    var deltas = keys.map(function (k) {return getMotionDirection(k);});
	    var sumDelta = deltas.reduce(
	    function (acc, d) {return { x: acc.x + d.x, y: acc.y + d.y };}, 
	    { x: 0, y: 0 });
	    var clampedDelta = { 
	        x: Math.sign(sumDelta.x), 
	        y: Math.sign(sumDelta.y) };
	
	    if (clampedDelta.x === 0 && clampedDelta.y === 0) {
	        return;}
	
	    var slowness = 90; // frames to traverse full canvas
	    var velocityX = getCanvas().width / slowness;
	    var velocityY = getCanvas().height / slowness;
	    var finalDeltas = { 
	        x: velocityX * clampedDelta.x, 
	        y: velocityY * clampedDelta.y };
	
	    setState(_extends({}, 
	    state, { 
	        coreState: CanvasCore.performPan(state.coreState, finalDeltas) }));}

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(266);
	
	__webpack_require__(453);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(267);
	__webpack_require__(300);
	__webpack_require__(306);
	__webpack_require__(308);
	__webpack_require__(310);
	__webpack_require__(312);
	__webpack_require__(314);
	__webpack_require__(316);
	__webpack_require__(317);
	__webpack_require__(318);
	__webpack_require__(319);
	__webpack_require__(320);
	__webpack_require__(321);
	__webpack_require__(322);
	__webpack_require__(323);
	__webpack_require__(324);
	__webpack_require__(325);
	__webpack_require__(326);
	__webpack_require__(327);
	__webpack_require__(330);
	__webpack_require__(331);
	__webpack_require__(332);
	__webpack_require__(334);
	__webpack_require__(335);
	__webpack_require__(336);
	__webpack_require__(337);
	__webpack_require__(338);
	__webpack_require__(339);
	__webpack_require__(340);
	__webpack_require__(342);
	__webpack_require__(343);
	__webpack_require__(344);
	__webpack_require__(346);
	__webpack_require__(347);
	__webpack_require__(348);
	__webpack_require__(350);
	__webpack_require__(351);
	__webpack_require__(352);
	__webpack_require__(353);
	__webpack_require__(354);
	__webpack_require__(355);
	__webpack_require__(356);
	__webpack_require__(357);
	__webpack_require__(358);
	__webpack_require__(359);
	__webpack_require__(360);
	__webpack_require__(361);
	__webpack_require__(362);
	__webpack_require__(363);
	__webpack_require__(368);
	__webpack_require__(369);
	__webpack_require__(373);
	__webpack_require__(374);
	__webpack_require__(376);
	__webpack_require__(377);
	__webpack_require__(382);
	__webpack_require__(383);
	__webpack_require__(386);
	__webpack_require__(388);
	__webpack_require__(390);
	__webpack_require__(392);
	__webpack_require__(393);
	__webpack_require__(394);
	__webpack_require__(396);
	__webpack_require__(397);
	__webpack_require__(399);
	__webpack_require__(400);
	__webpack_require__(401);
	__webpack_require__(402);
	__webpack_require__(409);
	__webpack_require__(412);
	__webpack_require__(413);
	__webpack_require__(415);
	__webpack_require__(416);
	__webpack_require__(417);
	__webpack_require__(418);
	__webpack_require__(419);
	__webpack_require__(420);
	__webpack_require__(421);
	__webpack_require__(422);
	__webpack_require__(423);
	__webpack_require__(424);
	__webpack_require__(425);
	__webpack_require__(426);
	__webpack_require__(428);
	__webpack_require__(429);
	__webpack_require__(430);
	__webpack_require__(431);
	__webpack_require__(432);
	__webpack_require__(433);
	__webpack_require__(435);
	__webpack_require__(436);
	__webpack_require__(437);
	__webpack_require__(438);
	__webpack_require__(440);
	__webpack_require__(441);
	__webpack_require__(443);
	__webpack_require__(444);
	__webpack_require__(446);
	__webpack_require__(447);
	__webpack_require__(448);
	__webpack_require__(451);
	__webpack_require__(452);
	module.exports = __webpack_require__(271);

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $                 = __webpack_require__(268)
	  , $export           = __webpack_require__(269)
	  , DESCRIPTORS       = __webpack_require__(274)
	  , createDesc        = __webpack_require__(273)
	  , html              = __webpack_require__(280)
	  , cel               = __webpack_require__(281)
	  , has               = __webpack_require__(283)
	  , cof               = __webpack_require__(284)
	  , invoke            = __webpack_require__(285)
	  , fails             = __webpack_require__(275)
	  , anObject          = __webpack_require__(286)
	  , aFunction         = __webpack_require__(279)
	  , isObject          = __webpack_require__(282)
	  , toObject          = __webpack_require__(287)
	  , toIObject         = __webpack_require__(289)
	  , toInteger         = __webpack_require__(291)
	  , toIndex           = __webpack_require__(292)
	  , toLength          = __webpack_require__(293)
	  , IObject           = __webpack_require__(290)
	  , IE_PROTO          = __webpack_require__(277)('__proto__')
	  , createArrayMethod = __webpack_require__(294)
	  , arrayIndexOf      = __webpack_require__(299)(false)
	  , ObjectProto       = Object.prototype
	  , ArrayProto        = Array.prototype
	  , arraySlice        = ArrayProto.slice
	  , arrayJoin         = ArrayProto.join
	  , defineProperty    = $.setDesc
	  , getOwnDescriptor  = $.getDesc
	  , defineProperties  = $.setDescs
	  , factories         = {}
	  , IE8_DOM_DEFINE;
	
	if(!DESCRIPTORS){
	  IE8_DOM_DEFINE = !fails(function(){
	    return defineProperty(cel('div'), 'a', {get: function(){ return 7; }}).a != 7;
	  });
	  $.setDesc = function(O, P, Attributes){
	    if(IE8_DOM_DEFINE)try {
	      return defineProperty(O, P, Attributes);
	    } catch(e){ /* empty */ }
	    if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	    if('value' in Attributes)anObject(O)[P] = Attributes.value;
	    return O;
	  };
	  $.getDesc = function(O, P){
	    if(IE8_DOM_DEFINE)try {
	      return getOwnDescriptor(O, P);
	    } catch(e){ /* empty */ }
	    if(has(O, P))return createDesc(!ObjectProto.propertyIsEnumerable.call(O, P), O[P]);
	  };
	  $.setDescs = defineProperties = function(O, Properties){
	    anObject(O);
	    var keys   = $.getKeys(Properties)
	      , length = keys.length
	      , i = 0
	      , P;
	    while(length > i)$.setDesc(O, P = keys[i++], Properties[P]);
	    return O;
	  };
	}
	$export($export.S + $export.F * !DESCRIPTORS, 'Object', {
	  // 19.1.2.6 / 15.2.3.3 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $.getDesc,
	  // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	  defineProperty: $.setDesc,
	  // 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	  defineProperties: defineProperties
	});
	
	  // IE 8- don't enum bug keys
	var keys1 = ('constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,' +
	            'toLocaleString,toString,valueOf').split(',')
	  // Additional keys for getOwnPropertyNames
	  , keys2 = keys1.concat('length', 'prototype')
	  , keysLen1 = keys1.length;
	
	// Create object with `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = cel('iframe')
	    , i      = keysLen1
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write('<script>document.F=Object</script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict.prototype[keys1[i]];
	  return createDict();
	};
	var createGetKeys = function(names, length){
	  return function(object){
	    var O      = toIObject(object)
	      , i      = 0
	      , result = []
	      , key;
	    for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	    // Don't enum bug & hidden keys
	    while(length > i)if(has(O, key = names[i++])){
	      ~arrayIndexOf(result, key) || result.push(key);
	    }
	    return result;
	  };
	};
	var Empty = function(){};
	$export($export.S, 'Object', {
	  // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	  getPrototypeOf: $.getProto = $.getProto || function(O){
	    O = toObject(O);
	    if(has(O, IE_PROTO))return O[IE_PROTO];
	    if(typeof O.constructor == 'function' && O instanceof O.constructor){
	      return O.constructor.prototype;
	    } return O instanceof Object ? ObjectProto : null;
	  },
	  // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $.getNames = $.getNames || createGetKeys(keys2, keys2.length, true),
	  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	  create: $.create = $.create || function(O, /*?*/Properties){
	    var result;
	    if(O !== null){
	      Empty.prototype = anObject(O);
	      result = new Empty();
	      Empty.prototype = null;
	      // add "__proto__" for Object.getPrototypeOf shim
	      result[IE_PROTO] = O;
	    } else result = createDict();
	    return Properties === undefined ? result : defineProperties(result, Properties);
	  },
	  // 19.1.2.14 / 15.2.3.14 Object.keys(O)
	  keys: $.getKeys = $.getKeys || createGetKeys(keys1, keysLen1, false)
	});
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  }
	  return factories[len](F, args);
	};
	
	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	$export($export.P, 'Function', {
	  bind: function bind(that /*, args... */){
	    var fn       = aFunction(this)
	      , partArgs = arraySlice.call(arguments, 1);
	    var bound = function(/* args... */){
	      var args = partArgs.concat(arraySlice.call(arguments));
	      return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	    };
	    if(isObject(fn.prototype))bound.prototype = fn.prototype;
	    return bound;
	  }
	});
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * fails(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});
	$export($export.P + $export.F * (IObject != Object), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(IObject(this), separator === undefined ? ',' : separator);
	  }
	});
	
	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	$export($export.S, 'Array', {isArray: __webpack_require__(296)});
	
	var createArrayReduce = function(isRight){
	  return function(callbackfn, memo){
	    aFunction(callbackfn);
	    var O      = IObject(this)
	      , length = toLength(O.length)
	      , index  = isRight ? length - 1 : 0
	      , i      = isRight ? -1 : 1;
	    if(arguments.length < 2)for(;;){
	      if(index in O){
	        memo = O[index];
	        index += i;
	        break;
	      }
	      index += i;
	      if(isRight ? index < 0 : length <= index){
	        throw TypeError('Reduce of empty array with no initial value');
	      }
	    }
	    for(;isRight ? index >= 0 : length > index; index += i)if(index in O){
	      memo = callbackfn(memo, O[index], index, this);
	    }
	    return memo;
	  };
	};
	
	var methodize = function($fn){
	  return function(arg1/*, arg2 = undefined */){
	    return $fn(this, arg1, arguments[1]);
	  };
	};
	
	$export($export.P, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: $.each = $.each || methodize(createArrayMethod(0)),
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: methodize(createArrayMethod(1)),
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: methodize(createArrayMethod(2)),
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: methodize(createArrayMethod(3)),
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: methodize(createArrayMethod(4)),
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: createArrayReduce(false),
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: createArrayReduce(true),
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: methodize(arrayIndexOf),
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function(el, fromIndex /* = @[*-1] */){
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(fromIndex));
	    if(index < 0)index = toLength(length + index);
	    for(;index >= 0; index--)if(index in O)if(O[index] === el)return index;
	    return -1;
	  }
	});
	
	// 20.3.3.1 / 15.9.4.4 Date.now()
	$export($export.S, 'Date', {now: function(){ return +new Date; }});
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(this))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ },
/* 268 */
/***/ function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(270)
	  , core      = __webpack_require__(271)
	  , hide      = __webpack_require__(272)
	  , redefine  = __webpack_require__(276)
	  , ctx       = __webpack_require__(278)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target && !own)redefine(target, key, out);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ },
/* 270 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 271 */
/***/ function(module, exports) {

	var core = module.exports = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(268)
	  , createDesc = __webpack_require__(273);
	module.exports = __webpack_require__(274) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 273 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(275)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 275 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	// add fake Function#toString
	// for correct work wrapped methods / constructors with methods like LoDash isNative
	var global    = __webpack_require__(270)
	  , hide      = __webpack_require__(272)
	  , SRC       = __webpack_require__(277)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(271).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  if(typeof val == 'function'){
	    val.hasOwnProperty(SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	    val.hasOwnProperty('name') || hide(val, 'name', key);
	  }
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe)delete O[key];
	    hide(O, key, val);
	  }
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 277 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(279);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 279 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(270).document && document.documentElement;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(282)
	  , document = __webpack_require__(270).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 282 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 283 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 284 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 285 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(282);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(288);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 288 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(290)
	  , defined = __webpack_require__(288);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(284);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 291 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(291)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(291)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(278)
	  , IObject  = __webpack_require__(290)
	  , toObject = __webpack_require__(287)
	  , toLength = __webpack_require__(293)
	  , asc      = __webpack_require__(295);
	module.exports = function(TYPE){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? asc($this, length) : IS_FILTER ? asc($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var isObject = __webpack_require__(282)
	  , isArray  = __webpack_require__(296)
	  , SPECIES  = __webpack_require__(297)('species');
	module.exports = function(original, length){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return new (C === undefined ? Array : C)(length);
	};

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(284);
	module.exports = Array.isArray || function(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	var store  = __webpack_require__(298)('wks')
	  , uid    = __webpack_require__(277)
	  , Symbol = __webpack_require__(270).Symbol;
	module.exports = function(name){
	  return store[name] || (store[name] =
	    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
	};

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(270)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(289)
	  , toLength  = __webpack_require__(293)
	  , toIndex   = __webpack_require__(292);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var $              = __webpack_require__(268)
	  , global         = __webpack_require__(270)
	  , has            = __webpack_require__(283)
	  , DESCRIPTORS    = __webpack_require__(274)
	  , $export        = __webpack_require__(269)
	  , redefine       = __webpack_require__(276)
	  , $fails         = __webpack_require__(275)
	  , shared         = __webpack_require__(298)
	  , setToStringTag = __webpack_require__(301)
	  , uid            = __webpack_require__(277)
	  , wks            = __webpack_require__(297)
	  , keyOf          = __webpack_require__(302)
	  , $names         = __webpack_require__(303)
	  , enumKeys       = __webpack_require__(304)
	  , isArray        = __webpack_require__(296)
	  , anObject       = __webpack_require__(286)
	  , toIObject      = __webpack_require__(289)
	  , createDesc     = __webpack_require__(273)
	  , getDesc        = $.getDesc
	  , setDesc        = $.setDesc
	  , _create        = $.create
	  , getNames       = $names.get
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , setter         = false
	  , HIDDEN         = wks('_hidden')
	  , isEnum         = $.isEnum
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , useNative      = typeof $Symbol == 'function'
	  , ObjectProto    = Object.prototype;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(setDesc({}, 'a', {
	    get: function(){ return setDesc(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = getDesc(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  setDesc(it, key, D);
	  if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
	} : setDesc;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol.prototype);
	  sym._k = tag;
	  DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
	    configurable: true,
	    set: function(value){
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    }
	  });
	  return sym;
	};
	
	var isSymbol = function(it){
	  return typeof it == 'symbol';
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(D && has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return setDesc(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key);
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
	    ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  var D = getDesc(it = toIObject(it), key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN)result.push(key);
	  return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
	  return result;
	};
	var $stringify = function stringify(it){
	  if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	  var args = [it]
	    , i    = 1
	    , $$   = arguments
	    , replacer, $replacer;
	  while($$.length > i)args.push($$[i++]);
	  replacer = args[1];
	  if(typeof replacer == 'function')$replacer = replacer;
	  if($replacer || !isArray(replacer))replacer = function(key, value){
	    if($replacer)value = $replacer.call(this, key, value);
	    if(!isSymbol(value))return value;
	  };
	  args[1] = replacer;
	  return _stringify.apply($JSON, args);
	};
	var buggyJSON = $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	});
	
	// 19.4.1.1 Symbol([description])
	if(!useNative){
	  $Symbol = function Symbol(){
	    if(isSymbol(this))throw TypeError('Symbol is not a constructor');
	    return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
	  };
	  redefine($Symbol.prototype, 'toString', function toString(){
	    return this._k;
	  });
	
	  isSymbol = function(it){
	    return it instanceof $Symbol;
	  };
	
	  $.create     = $create;
	  $.isEnum     = $propertyIsEnumerable;
	  $.getDesc    = $getOwnPropertyDescriptor;
	  $.setDesc    = $defineProperty;
	  $.setDescs   = $defineProperties;
	  $.getNames   = $names.get = $getOwnPropertyNames;
	  $.getSymbols = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(305)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	}
	
	var symbolStatics = {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    return keyOf(SymbolRegistry, key);
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	};
	// 19.4.2.2 Symbol.hasInstance
	// 19.4.2.3 Symbol.isConcatSpreadable
	// 19.4.2.4 Symbol.iterator
	// 19.4.2.6 Symbol.match
	// 19.4.2.8 Symbol.replace
	// 19.4.2.9 Symbol.search
	// 19.4.2.10 Symbol.species
	// 19.4.2.11 Symbol.split
	// 19.4.2.12 Symbol.toPrimitive
	// 19.4.2.13 Symbol.toStringTag
	// 19.4.2.14 Symbol.unscopables
	$.each.call((
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
	  'species,split,toPrimitive,toStringTag,unscopables'
	).split(','), function(it){
	  var sym = wks(it);
	  symbolStatics[it] = useNative ? sym : wrap(sym);
	});
	
	setter = true;
	
	$export($export.G + $export.W, {Symbol: $Symbol});
	
	$export($export.S, 'Symbol', symbolStatics);
	
	$export($export.S + $export.F * !useNative, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!useNative || buggyJSON), 'JSON', {stringify: $stringify});
	
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(268).setDesc
	  , has = __webpack_require__(283)
	  , TAG = __webpack_require__(297)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(268)
	  , toIObject = __webpack_require__(289);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = $.getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(289)
	  , getNames  = __webpack_require__(268).getNames
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return getNames(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.get = function getOwnPropertyNames(it){
	  if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
	  return getNames(toIObject(it));
	};

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var $ = __webpack_require__(268);
	module.exports = function(it){
	  var keys       = $.getKeys(it)
	    , getSymbols = $.getSymbols;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = $.isEnum
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
	  }
	  return keys;
	};

/***/ },
/* 305 */
/***/ function(module, exports) {

	module.exports = false;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(269);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(307)});

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.1 Object.assign(target, source, ...)
	var $        = __webpack_require__(268)
	  , toObject = __webpack_require__(287)
	  , IObject  = __webpack_require__(290);
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = __webpack_require__(275)(function(){
	  var a = Object.assign
	    , A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , $$    = arguments
	    , $$len = $$.length
	    , index = 1
	    , getKeys    = $.getKeys
	    , getSymbols = $.getSymbols
	    , isEnum     = $.isEnum;
	  while($$len > index){
	    var S      = IObject($$[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  }
	  return T;
	} : Object.assign;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(269);
	$export($export.S, 'Object', {is: __webpack_require__(309)});

/***/ },
/* 309 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(269);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(311).set});

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var getDesc  = __webpack_require__(268).getDesc
	  , isObject = __webpack_require__(282)
	  , anObject = __webpack_require__(286);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(278)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(313)
	  , test    = {};
	test[__webpack_require__(297)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(276)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(284)
	  , TAG = __webpack_require__(297)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(282);
	
	__webpack_require__(315)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(it) : it;
	  };
	});

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(269)
	  , core    = __webpack_require__(271)
	  , fails   = __webpack_require__(275);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(282);
	
	__webpack_require__(315)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(it) : it;
	  };
	});

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(282);
	
	__webpack_require__(315)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(it) : it;
	  };
	});

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(282);
	
	__webpack_require__(315)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(282);
	
	__webpack_require__(315)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(282);
	
	__webpack_require__(315)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(289);
	
	__webpack_require__(315)('getOwnPropertyDescriptor', function($getOwnPropertyDescriptor){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(287);
	
	__webpack_require__(315)('getPrototypeOf', function($getPrototypeOf){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(287);
	
	__webpack_require__(315)('keys', function($keys){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(315)('getOwnPropertyNames', function(){
	  return __webpack_require__(303).get;
	});

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	var setDesc    = __webpack_require__(268).setDesc
	  , createDesc = __webpack_require__(273)
	  , has        = __webpack_require__(283)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(274) && setDesc(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    var match = ('' + this).match(nameRE)
	      , name  = match ? match[1] : '';
	    has(this, NAME) || setDesc(this, NAME, createDesc(5, name));
	    return name;
	  }
	});

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $             = __webpack_require__(268)
	  , isObject      = __webpack_require__(282)
	  , HAS_INSTANCE  = __webpack_require__(297)('hasInstance')
	  , FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))$.setDesc(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = $.getProto(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $           = __webpack_require__(268)
	  , global      = __webpack_require__(270)
	  , has         = __webpack_require__(283)
	  , cof         = __webpack_require__(284)
	  , toPrimitive = __webpack_require__(328)
	  , fails       = __webpack_require__(275)
	  , $trim       = __webpack_require__(329).trim
	  , NUMBER      = 'Number'
	  , $Number     = global[NUMBER]
	  , Base        = $Number
	  , proto       = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF  = cof($.create(proto)) == NUMBER
	  , TRIM        = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? new Base(toNumber(it)) : toNumber(it);
	  };
	  $.each.call(__webpack_require__(274) ? $.getNames(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), function(key){
	    if(has(Base, key) && !has($Number, key)){
	      $.setDesc($Number, key, $.getDesc(Base, key));
	    }
	  });
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(276)(global, NUMBER, $Number);
	}

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(282);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(269)
	  , defined = __webpack_require__(288)
	  , fails   = __webpack_require__(275)
	  , spaces  = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	      '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF'
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec){
	  var exp  = {};
	  exp[KEY] = exec(trim);
	  $export($export.P + $export.F * fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  }), 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(269);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(269)
	  , _isFinite = __webpack_require__(270).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(269);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(333)});

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(282)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(269);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(269)
	  , isInteger = __webpack_require__(333)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(269);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(269);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.12 Number.parseFloat(string)
	var $export = __webpack_require__(269);
	
	$export($export.S, 'Number', {parseFloat: parseFloat});

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.13 Number.parseInt(string, radix)
	var $export = __webpack_require__(269);
	
	$export($export.S, 'Number', {parseInt: parseInt});

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(269)
	  , log1p   = __webpack_require__(341)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	// V8 bug https://code.google.com/p/v8/issues/detail?id=3509
	$export($export.S + $export.F * !($acosh && Math.floor($acosh(Number.MAX_VALUE)) == 710), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 341 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(269);
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	$export($export.S, 'Math', {asinh: asinh});

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(269);
	
	$export($export.S, 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(269)
	  , sign    = __webpack_require__(345);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 345 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(269);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(269)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(269);
	
	$export($export.S, 'Math', {expm1: __webpack_require__(349)});

/***/ },
/* 349 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	module.exports = Math.expm1 || function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	};

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(269)
	  , sign      = __webpack_require__(345)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(269)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum   = 0
	      , i     = 0
	      , $$    = arguments
	      , $$len = $$.length
	      , larg  = 0
	      , arg, div;
	    while(i < $$len){
	      arg = abs($$[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(269)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(275)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(269);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(269);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(341)});

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(269);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(269);
	
	$export($export.S, 'Math', {sign: __webpack_require__(345)});

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(269)
	  , expm1   = __webpack_require__(349)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(275)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(269)
	  , expm1   = __webpack_require__(349)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(269);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(269)
	  , toIndex        = __webpack_require__(292)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res   = []
	      , $$    = arguments
	      , $$len = $$.length
	      , i     = 0
	      , code;
	    while($$len > i){
	      code = +$$[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(269)
	  , toIObject = __webpack_require__(289)
	  , toLength  = __webpack_require__(293);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl   = toIObject(callSite.raw)
	      , len   = toLength(tpl.length)
	      , $$    = arguments
	      , $$len = $$.length
	      , res   = []
	      , i     = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < $$len)res.push(String($$[i]));
	    } return res.join('');
	  }
	});

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(329)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(364)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(365)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(291)
	  , defined   = __webpack_require__(288);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(305)
	  , $export        = __webpack_require__(269)
	  , redefine       = __webpack_require__(276)
	  , hide           = __webpack_require__(272)
	  , has            = __webpack_require__(283)
	  , Iterators      = __webpack_require__(366)
	  , $iterCreate    = __webpack_require__(367)
	  , setToStringTag = __webpack_require__(301)
	  , getProto       = __webpack_require__(268).getProto
	  , ITERATOR       = __webpack_require__(297)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , methods, key;
	  // Fix native
	  if($native){
	    var IteratorPrototype = getProto($default.call(new Base));
	    // Set @@toStringTag to native iterators
	    setToStringTag(IteratorPrototype, TAG, true);
	    // FF fix
	    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    // fix Array#{values, @@iterator}.name in V8 / FF
	    if(DEF_VALUES && $native.name !== VALUES){
	      VALUES_BUG = true;
	      $default = function values(){ return $native.call(this); };
	    }
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES  ? $default : getMethod(VALUES),
	      keys:    IS_SET      ? $default : getMethod(KEYS),
	      entries: !DEF_VALUES ? $default : getMethod('entries')
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 366 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(268)
	  , descriptor     = __webpack_require__(273)
	  , setToStringTag = __webpack_require__(301)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(272)(IteratorPrototype, __webpack_require__(297)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(269)
	  , $at     = __webpack_require__(364)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(269)
	  , toLength  = __webpack_require__(293)
	  , context   = __webpack_require__(370)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(372)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , $$   = arguments
	      , endPosition = $$.length > 1 ? $$[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(371)
	  , defined  = __webpack_require__(288);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(282)
	  , cof      = __webpack_require__(284)
	  , MATCH    = __webpack_require__(297)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(297)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(269)
	  , context  = __webpack_require__(370)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(372)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(269);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(375)
	});

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(291)
	  , defined   = __webpack_require__(288);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(269)
	  , toLength    = __webpack_require__(293)
	  , context     = __webpack_require__(370)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(372)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , $$     = arguments
	      , index  = toLength(Math.min($$.length > 1 ? $$[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx         = __webpack_require__(278)
	  , $export     = __webpack_require__(269)
	  , toObject    = __webpack_require__(287)
	  , call        = __webpack_require__(378)
	  , isArrayIter = __webpack_require__(379)
	  , toLength    = __webpack_require__(293)
	  , getIterFn   = __webpack_require__(380);
	$export($export.S + $export.F * !__webpack_require__(381)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , $$      = arguments
	      , $$len   = $$.length
	      , mapfn   = $$len > 1 ? $$[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, $$len > 2 ? $$[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        result[index] = mapping ? mapfn(O[index], index) : O[index];
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(286);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(366)
	  , ITERATOR   = __webpack_require__(297)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(313)
	  , ITERATOR  = __webpack_require__(297)('iterator')
	  , Iterators = __webpack_require__(366);
	module.exports = __webpack_require__(271).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(297)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ safe = true; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(269);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(275)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , $$     = arguments
	      , $$len  = $$.length
	      , result = new (typeof this == 'function' ? this : Array)($$len);
	    while($$len > index)result[index] = $$[index++];
	    result.length = $$len;
	    return result;
	  }
	});

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(384)
	  , step             = __webpack_require__(385)
	  , Iterators        = __webpack_require__(366)
	  , toIObject        = __webpack_require__(289);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(365)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(297)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(272)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 385 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(387)('Array');

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(270)
	  , $           = __webpack_require__(268)
	  , DESCRIPTORS = __webpack_require__(274)
	  , SPECIES     = __webpack_require__(297)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(269);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(389)});
	
	__webpack_require__(384)('copyWithin');

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(287)
	  , toIndex  = __webpack_require__(292)
	  , toLength = __webpack_require__(293);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , $$    = arguments
	    , end   = $$.length > 2 ? $$[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(269);
	
	$export($export.P, 'Array', {fill: __webpack_require__(391)});
	
	__webpack_require__(384)('fill');

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(287)
	  , toIndex  = __webpack_require__(292)
	  , toLength = __webpack_require__(293);
	module.exports = [].fill || function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , $$     = arguments
	    , $$len  = $$.length
	    , index  = toIndex($$len > 1 ? $$[1] : undefined, length)
	    , end    = $$len > 2 ? $$[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(269)
	  , $find   = __webpack_require__(294)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(384)(KEY);

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(269)
	  , $find   = __webpack_require__(294)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(384)(KEY);

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	var $        = __webpack_require__(268)
	  , global   = __webpack_require__(270)
	  , isRegExp = __webpack_require__(371)
	  , $flags   = __webpack_require__(395)
	  , $RegExp  = global.RegExp
	  , Base     = $RegExp
	  , proto    = $RegExp.prototype
	  , re1      = /a/g
	  , re2      = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(274) && (!CORRECT_NEW || __webpack_require__(275)(function(){
	  re2[__webpack_require__(297)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !(this instanceof $RegExp) && piRE && p.constructor === $RegExp && fiU ? p
	      : CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f);
	  };
	  $.each.call($.getNames(Base), function(key){
	    key in $RegExp || $.setDesc($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  });
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(276)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(387)('RegExp');

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(286);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	var $ = __webpack_require__(268);
	if(__webpack_require__(274) && /./g.flags != 'g')$.setDesc(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(395)
	});

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(398)('match', 1, function(defined, MATCH){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  };
	});

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(272)
	  , redefine = __webpack_require__(276)
	  , fails    = __webpack_require__(275)
	  , defined  = __webpack_require__(288)
	  , wks      = __webpack_require__(297);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , original = ''[KEY];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, exec(defined, SYMBOL, original));
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return original.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return original.call(string, this); }
	    );
	  }
	};

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(398)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  };
	});

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(398)('search', 1, function(defined, SEARCH){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  };
	});

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(398)('split', 2, function(defined, SPLIT, $split){
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return function split(separator, limit){
	    'use strict';
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined
	      ? fn.call(separator, O, limit)
	      : $split.call(String(O), separator, limit);
	  };
	});

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $          = __webpack_require__(268)
	  , LIBRARY    = __webpack_require__(305)
	  , global     = __webpack_require__(270)
	  , ctx        = __webpack_require__(278)
	  , classof    = __webpack_require__(313)
	  , $export    = __webpack_require__(269)
	  , isObject   = __webpack_require__(282)
	  , anObject   = __webpack_require__(286)
	  , aFunction  = __webpack_require__(279)
	  , strictNew  = __webpack_require__(403)
	  , forOf      = __webpack_require__(404)
	  , setProto   = __webpack_require__(311).set
	  , same       = __webpack_require__(309)
	  , SPECIES    = __webpack_require__(297)('species')
	  , speciesConstructor = __webpack_require__(405)
	  , asap       = __webpack_require__(406)
	  , PROMISE    = 'Promise'
	  , process    = global.process
	  , isNode     = classof(process) == 'process'
	  , P          = global[PROMISE]
	  , Wrapper;
	
	var testResolve = function(sub){
	  var test = new P(function(){});
	  if(sub)test.constructor = Object;
	  return P.resolve(test) === test;
	};
	
	var USE_NATIVE = function(){
	  var works = false;
	  function P2(x){
	    var self = new P(x);
	    setProto(self, P2.prototype);
	    return self;
	  }
	  try {
	    works = P && P.resolve && testResolve();
	    setProto(P2, P);
	    P2.prototype = $.create(P.prototype, {constructor: {value: P2}});
	    // actual Firefox has broken subclass support, test that
	    if(!(P2.resolve(5).then(function(){}) instanceof P2)){
	      works = false;
	    }
	    // actual V8 bug, https://code.google.com/p/v8/issues/detail?id=4162
	    if(works && __webpack_require__(274)){
	      var thenableThenGotten = false;
	      P.resolve($.setDesc({}, 'then', {
	        get: function(){ thenableThenGotten = true; }
	      }));
	      works = thenableThenGotten;
	    }
	  } catch(e){ works = false; }
	  return works;
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // library wrapper special case
	  if(LIBRARY && a === P && b === Wrapper)return true;
	  return same(a, b);
	};
	var getConstructor = function(C){
	  var S = anObject(C)[SPECIES];
	  return S != undefined ? S : C;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var PromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve),
	  this.reject  = aFunction(reject)
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(record, isReject){
	  if(record.n)return;
	  record.n = true;
	  var chain = record.c;
	  asap(function(){
	    var value = record.v
	      , ok    = record.s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , result, then;
	      try {
	        if(handler){
	          if(!ok)record.h = true;
	          result = handler === true ? value : handler(value);
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    chain.length = 0;
	    record.n = false;
	    if(isReject)setTimeout(function(){
	      var promise = record.p
	        , handler, console;
	      if(isUnhandled(promise)){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      } record.a = undefined;
	    }, 1);
	  });
	};
	var isUnhandled = function(promise){
	  var record = promise._d
	    , chain  = record.a || record.c
	    , i      = 0
	    , reaction;
	  if(record.h)return false;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var $reject = function(value){
	  var record = this;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  record.v = value;
	  record.s = 2;
	  record.a = record.c.slice();
	  notify(record, true);
	};
	var $resolve = function(value){
	  var record = this
	    , then;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  try {
	    if(record.p === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      asap(function(){
	        var wrapper = {r: record, d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      record.v = value;
	      record.s = 1;
	      notify(record, false);
	    }
	  } catch(e){
	    $reject.call({r: record, d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  P = function Promise(executor){
	    aFunction(executor);
	    var record = this._d = {
	      p: strictNew(this, P, PROMISE),         // <- promise
	      c: [],                                  // <- awaiting reactions
	      a: undefined,                           // <- checked in isUnhandled reactions
	      s: 0,                                   // <- state
	      d: false,                               // <- done
	      v: undefined,                           // <- value
	      h: false,                               // <- handled rejection
	      n: false                                // <- notify
	    };
	    try {
	      executor(ctx($resolve, record, 1), ctx($reject, record, 1));
	    } catch(err){
	      $reject.call(record, err);
	    }
	  };
	  __webpack_require__(408)(P.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction = new PromiseCapability(speciesConstructor(this, P))
	        , promise  = reaction.promise
	        , record   = this._d;
	      reaction.ok   = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      record.c.push(reaction);
	      if(record.a)record.a.push(reaction);
	      if(record.s)notify(record, false);
	      return promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: P});
	__webpack_require__(301)(P, PROMISE);
	__webpack_require__(387)(PROMISE);
	Wrapper = __webpack_require__(271)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = new PromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (!USE_NATIVE || testResolve(true)), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof P && sameConstructor(x.constructor, this))return x;
	    var capability = new PromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(381)(function(iter){
	  P.all(iter)['catch'](function(){});
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = getConstructor(this)
	      , capability = new PromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject
	      , values     = [];
	    var abrupt = perform(function(){
	      forOf(iterable, false, values.push, values);
	      var remaining = values.length
	        , results   = Array(remaining);
	      if(remaining)$.each.call(values, function(promise, index){
	        var alreadyCalled = false;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled = true;
	          results[index] = value;
	          --remaining || resolve(results);
	        }, reject);
	      });
	      else resolve(results);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = getConstructor(this)
	      , capability = new PromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },
/* 403 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name){
	  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
	  return it;
	};

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(278)
	  , call        = __webpack_require__(378)
	  , isArrayIter = __webpack_require__(379)
	  , anObject    = __webpack_require__(286)
	  , toLength    = __webpack_require__(293)
	  , getIterFn   = __webpack_require__(380);
	module.exports = function(iterable, entries, fn, that){
	  var iterFn = getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    call(iterator, f, step.value, entries);
	  }
	};

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(286)
	  , aFunction = __webpack_require__(279)
	  , SPECIES   = __webpack_require__(297)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(270)
	  , macrotask = __webpack_require__(407).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(284)(process) == 'process'
	  , head, last, notify;
	
	var flush = function(){
	  var parent, domain, fn;
	  if(isNode && (parent = process.domain)){
	    process.domain = null;
	    parent.exit();
	  }
	  while(head){
	    domain = head.domain;
	    fn     = head.fn;
	    if(domain)domain.enter();
	    fn(); // <- currently we use it only for Promise - try / catch not required
	    if(domain)domain.exit();
	    head = head.next;
	  } last = undefined;
	  if(parent)parent.enter();
	};
	
	// Node.js
	if(isNode){
	  notify = function(){
	    process.nextTick(flush);
	  };
	// browsers with MutationObserver
	} else if(Observer){
	  var toggle = 1
	    , node   = document.createTextNode('');
	  new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	  notify = function(){
	    node.data = toggle = -toggle;
	  };
	// environments with maybe non-completely correct, but existent Promise
	} else if(Promise && Promise.resolve){
	  notify = function(){
	    Promise.resolve().then(flush);
	  };
	// for other environments - macrotask based on:
	// - setImmediate
	// - MessageChannel
	// - window.postMessag
	// - onreadystatechange
	// - setTimeout
	} else {
	  notify = function(){
	    // strange IE + webpack dev server bug - use .call(global)
	    macrotask.call(global, flush);
	  };
	}
	
	module.exports = function asap(fn){
	  var task = {fn: fn, next: undefined, domain: isNode && process.domain};
	  if(last)last.next = task;
	  if(!head){
	    head = task;
	    notify();
	  } last = task;
	};

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(278)
	  , invoke             = __webpack_require__(285)
	  , html               = __webpack_require__(280)
	  , cel                = __webpack_require__(281)
	  , global             = __webpack_require__(270)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listner = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(284)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listner;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listner, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(276);
	module.exports = function(target, src){
	  for(var key in src)redefine(target, key, src[key]);
	  return target;
	};

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(410);
	
	// 23.1 Map Objects
	__webpack_require__(411)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $            = __webpack_require__(268)
	  , hide         = __webpack_require__(272)
	  , redefineAll  = __webpack_require__(408)
	  , ctx          = __webpack_require__(278)
	  , strictNew    = __webpack_require__(403)
	  , defined      = __webpack_require__(288)
	  , forOf        = __webpack_require__(404)
	  , $iterDefine  = __webpack_require__(365)
	  , step         = __webpack_require__(385)
	  , ID           = __webpack_require__(277)('id')
	  , $has         = __webpack_require__(283)
	  , isObject     = __webpack_require__(282)
	  , setSpecies   = __webpack_require__(387)
	  , DESCRIPTORS  = __webpack_require__(274)
	  , isExtensible = Object.isExtensible || isObject
	  , SIZE         = DESCRIPTORS ? '_s' : 'size'
	  , id           = 0;
	
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!$has(it, ID)){
	    // can't set id to frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add id
	    if(!create)return 'E';
	    // add missing object id
	    hide(it, ID, ++id);
	  // return object id with prefix
	  } return 'O' + it[ID];
	};
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      strictNew(that, C, NAME);
	      that._i = $.create(null); // index
	      that._f = undefined;      // first entry
	      that._l = undefined;      // last entry
	      that[SIZE] = 0;           // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(270)
	  , $export        = __webpack_require__(269)
	  , redefine       = __webpack_require__(276)
	  , redefineAll    = __webpack_require__(408)
	  , forOf          = __webpack_require__(404)
	  , strictNew      = __webpack_require__(403)
	  , isObject       = __webpack_require__(282)
	  , fails          = __webpack_require__(275)
	  , $iterDetect    = __webpack_require__(381)
	  , setToStringTag = __webpack_require__(301);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO;
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        strictNew(target, C, NAME);
	        var that = new Base;
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    IS_WEAK || instance.forEach(function(val, key){
	      BUGGY_ZERO = 1 / key === -Infinity;
	    });
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(410);
	
	// 23.2 Set Objects
	__webpack_require__(411)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $            = __webpack_require__(268)
	  , redefine     = __webpack_require__(276)
	  , weak         = __webpack_require__(414)
	  , isObject     = __webpack_require__(282)
	  , has          = __webpack_require__(283)
	  , frozenStore  = weak.frozenStore
	  , WEAK         = weak.WEAK
	  , isExtensible = Object.isExtensible || isObject
	  , tmp          = {};
	
	// 23.3 WeakMap Objects
	var $WeakMap = __webpack_require__(411)('WeakMap', function(get){
	  return function WeakMap(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      if(!isExtensible(key))return frozenStore(this).get(key);
	      if(has(key, WEAK))return key[WEAK][this._i];
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	}, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  $.each.call(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on leaky map
	      if(isObject(a) && !isExtensible(a)){
	        var result = frozenStore(this)[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide              = __webpack_require__(272)
	  , redefineAll       = __webpack_require__(408)
	  , anObject          = __webpack_require__(286)
	  , isObject          = __webpack_require__(282)
	  , strictNew         = __webpack_require__(403)
	  , forOf             = __webpack_require__(404)
	  , createArrayMethod = __webpack_require__(294)
	  , $has              = __webpack_require__(283)
	  , WEAK              = __webpack_require__(277)('weak')
	  , isExtensible      = Object.isExtensible || isObject
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for frozen keys
	var frozenStore = function(that){
	  return that._l || (that._l = new FrozenStore);
	};
	var FrozenStore = function(){
	  this.a = [];
	};
	var findFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	FrozenStore.prototype = {
	  get: function(key){
	    var entry = findFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      strictNew(that, C, NAME);
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        if(!isExtensible(key))return frozenStore(this)['delete'](key);
	        return $has(key, WEAK) && $has(key[WEAK], this._i) && delete key[WEAK][this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        if(!isExtensible(key))return frozenStore(this).has(key);
	        return $has(key, WEAK) && $has(key[WEAK], this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    if(!isExtensible(anObject(key))){
	      frozenStore(that).set(key, value);
	    } else {
	      $has(key, WEAK) || hide(key, WEAK, {});
	      key[WEAK][that._i] = value;
	    } return that;
	  },
	  frozenStore: frozenStore,
	  WEAK: WEAK
	};

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(414);
	
	// 23.4 WeakSet Objects
	__webpack_require__(411)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(269)
	  , _apply  = Function.apply;
	
	$export($export.S, 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    return _apply.call(target, thisArgument, argumentsList);
	  }
	});

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $         = __webpack_require__(268)
	  , $export   = __webpack_require__(269)
	  , aFunction = __webpack_require__(279)
	  , anObject  = __webpack_require__(286)
	  , isObject  = __webpack_require__(282)
	  , bind      = Function.bind || __webpack_require__(271).Function.prototype.bind;
	
	// MS Edge supports only 2 arguments
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	$export($export.S + $export.F * __webpack_require__(275)(function(){
	  function F(){}
	  return !(Reflect.construct(function(){}, [], F) instanceof F);
	}), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      if(args != undefined)switch(anObject(args).length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = $.create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var $        = __webpack_require__(268)
	  , $export  = __webpack_require__(269)
	  , anObject = __webpack_require__(286);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(275)(function(){
	  Reflect.defineProperty($.setDesc({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    try {
	      $.setDesc(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(269)
	  , getDesc  = __webpack_require__(268).getDesc
	  , anObject = __webpack_require__(286);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = getDesc(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(269)
	  , anObject = __webpack_require__(286);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(367)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var $        = __webpack_require__(268)
	  , has      = __webpack_require__(283)
	  , $export  = __webpack_require__(269)
	  , isObject = __webpack_require__(282)
	  , anObject = __webpack_require__(286);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = $.getDesc(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = $.getProto(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var $        = __webpack_require__(268)
	  , $export  = __webpack_require__(269)
	  , anObject = __webpack_require__(286);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return $.getDesc(anObject(target), propertyKey);
	  }
	});

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(269)
	  , getProto = __webpack_require__(268).getProto
	  , anObject = __webpack_require__(286);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(269);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(269)
	  , anObject      = __webpack_require__(286)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(269);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(427)});

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var $        = __webpack_require__(268)
	  , anObject = __webpack_require__(286)
	  , Reflect  = __webpack_require__(270).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = $.getNames(anObject(it))
	    , getSymbols = $.getSymbols;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(269)
	  , anObject           = __webpack_require__(286)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var $          = __webpack_require__(268)
	  , has        = __webpack_require__(283)
	  , $export    = __webpack_require__(269)
	  , createDesc = __webpack_require__(273)
	  , anObject   = __webpack_require__(286)
	  , isObject   = __webpack_require__(282);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = $.getDesc(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = $.getProto(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = $.getDesc(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    $.setDesc(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(269)
	  , setProto = __webpack_require__(311);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(269)
	  , $includes = __webpack_require__(299)(true);
	
	$export($export.P, 'Array', {
	  // https://github.com/domenic/Array.prototype.includes
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(384)('includes');

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(269)
	  , $at     = __webpack_require__(364)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(269)
	  , $pad    = __webpack_require__(434);
	
	$export($export.P, 'String', {
	  padLeft: function padLeft(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-string-pad-left-right
	var toLength = __webpack_require__(293)
	  , repeat   = __webpack_require__(375)
	  , defined  = __webpack_require__(288);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength)return S;
	  if(fillStr == '')fillStr = ' ';
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(269)
	  , $pad    = __webpack_require__(434);
	
	$export($export.P, 'String', {
	  padRight: function padRight(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(329)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	});

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(329)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	});

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(269)
	  , $re     = __webpack_require__(439)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ },
/* 439 */
/***/ function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/WebReflection/9353781
	var $          = __webpack_require__(268)
	  , $export    = __webpack_require__(269)
	  , ownKeys    = __webpack_require__(427)
	  , toIObject  = __webpack_require__(289)
	  , createDesc = __webpack_require__(273);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , setDesc = $.setDesc
	      , getDesc = $.getDesc
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key, D;
	    while(keys.length > i){
	      D = getDesc(O, key = keys[i++]);
	      if(key in result)setDesc(result, key, createDesc(0, D));
	      else result[key] = D;
	    } return result;
	  }
	});

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	// http://goo.gl/XkBrjD
	var $export = __webpack_require__(269)
	  , $values = __webpack_require__(442)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(268)
	  , toIObject = __webpack_require__(289)
	  , isEnum    = $.isEnum;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = $.getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	// http://goo.gl/XkBrjD
	var $export  = __webpack_require__(269)
	  , $entries = __webpack_require__(442)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(269);
	
	$export($export.P, 'Map', {toJSON: __webpack_require__(445)('Map')});

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var forOf   = __webpack_require__(404)
	  , classof = __webpack_require__(313);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    var arr = [];
	    forOf(this, false, arr.push, arr);
	    return arr;
	  };
	};

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(269);
	
	$export($export.P, 'Set', {toJSON: __webpack_require__(445)('Set')});

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	// JavaScript 1.6 / Strawman array statics shim
	var $       = __webpack_require__(268)
	  , $export = __webpack_require__(269)
	  , $ctx    = __webpack_require__(278)
	  , $Array  = __webpack_require__(271).Array || Array
	  , statics = {};
	var setStatics = function(keys, length){
	  $.each.call(keys.split(','), function(key){
	    if(length == undefined && key in $Array)statics[key] = $Array[key];
	    else if(key in [])statics[key] = $ctx(Function.call, [][key], length);
	  });
	};
	setStatics('pop,reverse,shift,keys,values,entries', 1);
	setStatics('indexOf,every,some,forEach,map,filter,find,findIndex,includes', 3);
	setStatics('join,slice,concat,push,splice,unshift,sort,lastIndexOf,' +
	           'reduce,reduceRight,copyWithin,fill');
	$export($export.S, 'Array', statics);

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(270)
	  , $export    = __webpack_require__(269)
	  , invoke     = __webpack_require__(285)
	  , partial    = __webpack_require__(449)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(450)
	  , invoke    = __webpack_require__(285)
	  , aFunction = __webpack_require__(279);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that  = this
	      , $$    = arguments
	      , $$len = $$.length
	      , j = 0, k = 0, args;
	    if(!holder && !$$len)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = $$[k++];
	    while($$len > k)args.push($$[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(270);

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(269)
	  , $task   = __webpack_require__(407);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(383);
	var global      = __webpack_require__(270)
	  , hide        = __webpack_require__(272)
	  , Iterators   = __webpack_require__(366)
	  , ITERATOR    = __webpack_require__(297)('iterator')
	  , NL          = global.NodeList
	  , HTC         = global.HTMLCollection
	  , NLProto     = NL && NL.prototype
	  , HTCProto    = HTC && HTC.prototype
	  , ArrayValues = Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;
	if(NLProto && !NLProto[ITERATOR])hide(NLProto, ITERATOR, ArrayValues);
	if(HTCProto && !HTCProto[ITERATOR])hide(HTCProto, ITERATOR, ArrayValues);

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var iteratorSymbol =
	    typeof Symbol === "function" && Symbol.iterator || "@@iterator";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    // This invoke function is written in a style that assumes some
	    // calling function (or Promise) will handle exceptions.
	    function invoke(method, arg) {
	      var result = generator[method](arg);
	      var value = result.value;
	      return value instanceof AwaitArgument
	        ? Promise.resolve(value.arg).then(invokeNext, invokeThrow)
	        : Promise.resolve(value).then(function(unwrapped) {
	            // When a yielded Promise is resolved, its final value becomes
	            // the .value of the Promise<{value,done}> result for the
	            // current iteration. If the Promise is rejected, however, the
	            // result for this iteration will be rejected with the same
	            // reason. Note that rejections of yielded Promises are not
	            // thrown back into the generator function, as is the case
	            // when an awaited Promise is rejected. This difference in
	            // behavior between yield and await is important, because it
	            // allows the consumer to decide what to do with the yielded
	            // rejection (swallow it and continue, manually .throw it back
	            // into the generator, abandon iteration, whatever). With
	            // await, by contrast, there is no opportunity to examine the
	            // rejection reason outside the generator function, so the
	            // only option is to throw it from the await expression, and
	            // let the generator function handle the exception.
	            result.value = unwrapped;
	            return result;
	          });
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var invokeNext = invoke.bind(generator, "next");
	    var invokeThrow = invoke.bind(generator, "throw");
	    var invokeReturn = invoke.bind(generator, "return");
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return invoke(method, arg);
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : new Promise(function (resolve) {
	          resolve(callInvokeWithMethodAndArg());
	        });
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          context._sent = arg;
	
	          if (state === GenStateSuspendedYield) {
	            context.sent = arg;
	          } else {
	            context.sent = undefined;
	          }
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      this.sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(5)))

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** bundle.js
 **/